import * as React from 'react';
import React__default, { useRef, useState, useMemo, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import FocusTrap from 'focus-trap-react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ReactQRCode from 'react-qr-code';
import Hammer from 'react-hammerjs';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CurrencyInput from 'react-currency-input-field';
import { IMaskInput as IMaskInput$1 } from 'react-imask';
import { jsx } from 'react/jsx-runtime';
import ReactCropper, { centerCrop, makeAspectCrop } from 'react-image-crop';
import { useSortBy, usePagination, useTable } from 'react-table';

var BaSeConfig = {
    docsUrl: 'https://base-react.sebrae.com.br',
    staticAssetsUrl: 'https://base-estatico.sebrae.com.br',
};

const version="1.99.2";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var palette = {
    transparent: 'transparent',
    shadowColor: 'rgba(20, 46, 82, 0.2)',
    white: '#ffffff',
    black: '#000000',
    lightGray: '#e0e5eb',
    azulSebrae10: '#0a1729',
    azulSebrae20: '#142e52',
    azulSebrae30: '#0f438a',
    azulSebrae33: '#0024a9',
    azulSebrae36: '#005eb8',
    azulSebrae43: '#0041d9',
    azulSebrae60: '#5c8fd6',
    azulSebrae62: '#3b4aff',
    azulSebrae63: '#40bbff',
    azulSebrae75: '#8fb8ef',
    azulSebrae90: '#cfe2fc',
    azulSebrae97: '#f0f6fe',
    cinzaSebrae10: '#121a21',
    cinzaSebrae20: '#243342',
    cinzaSebrae30: '#394d60',
    cinzaSebrae45: '#617385',
    cinzaSebrae60: '#8b99a7',
    cinzaSebrae75: '#b6bfc8',
    cinzaSebrae90: '#e0e5eb',
    cinzaSebrae97: '#f5f7fa',
    marrom10: '#231910',
    marrom20: '#463320',
    marrom30: '#6a4c2f',
    marrom50: '#b07f4f',
    marrom60: '#b8997a',
    marrom75: '#d2c0ac',
    marrom90: '#ede5de',
    laranja10: '#29140a',
    laranja25: '#66331a',
    laranja40: '#a35229',
    laranja63: '#ff8040',
    laranja73: '#ffa375',
    laranja75: '#ffb380',
    laranja80: '#ffbb99',
    laranja90: '#fcdecf',
    verdeOliva10: '#1c280b',
    verdeOliva20: '#385214',
    verdeOliva30: '#547a1f',
    verdeOliva47: '#83bf30',
    verdeOliva60: '#a2cf63',
    verdeOliva75: '#c5e19e',
    verdeOliva90: '#e7f3d8',
    cinza10: '#181a1b',
    cinza25: '#3c4143',
    cinza30: '#61686b',
    cinza67: '#a1adb3',
    cinza75: '#b9c1c6',
    cinza85: '#d4dadd',
    cinza90: '#e2e6e8',
    roxo10: '#231023',
    roxo20: '#462046',
    roxo30: '#6a2f6a',
    roxo44: '#994599',
    roxo60: '#b87ab8',
    roxo75: '#d2acd2',
    roxo90: '#f0dbf0',
    turquesa10: '#003325',
    turquesa15: '#004d37',
    turquesa25: '#00805c',
    turquesa40: '#00cc92',
    turquesa60: '#55ddb7',
    turquesa75: '#94ead2',
    turquesa90: '#d4f7ed',
    azulAqua10: '#05282e',
    azulAqua20: '#094f5d',
    azulAqua30: '#0e778b',
    azulAqua44: '#14adcc',
    azulAqua60: '#58c4da',
    azulAqua75: '#96dbe9',
    azulAqua90: '#d5f1f6',
    vermelho10: '#280b0d',
    vermelho20: '#52141a',
    vermelho35: '#8e242c',
    vermelho47: '#bf303c',
    vermelho65: '#e06c76',
    vermelho80: '#f0a8af',
    vermelho90: '#f3d8da',
    amarelo10: '#291f0a',
    amarelo25: '#664d1a',
    amarelo35: '#8f6b24',
    amarelo63: '#ffbf40',
    amarelo71: '#ffed69',
    amarelo73: '#ffd175',
    amarelo80: '#ffdd99',
    amarelo90: '#ffeecc',
    sucesso20: '#00662a',
    sucesso26: '#008537',
    sucesso45: '#35b068',
    sucesso70: '#85e0a3',
    sucesso75: '#99e5b2',
    sucesso85: '#c2efd1',
    sucesso95: '#ebfaf0',
    erro35: '#b22400',
    erro45: '#db340b',
    erro60: '#f5623d',
    erro70: '#ff8566',
    erro75: '#ff9980',
    erro85: '#ffc1b3',
    erro95: '#ffeae5',
    atencao35: '#ab6005',
    atencao55: '#ffb31a',
    atencao60: '#ffbc33',
    atencao70: '#ffdc66',
    atencao75: '#ffe380',
    atencao85: '#fff0b3',
    atencao95: '#fffae6',
    lilas75: '#9285f9',
    rosa61: '#f4455a',
    rosa84: '#ffabab',
    verde74: '#84f4bc',
    verde79: '#e4f998',
    violeta63: '#cd5be8',
};
var gradient = {
    cooperacao: "linear-gradient(45deg, ".concat(palette.verde74, ", ").concat(palette.laranja75, ")"),
    empreendedorismo: "linear-gradient(45deg, ".concat(palette.rosa61, ", ").concat(palette.rosa84, ")"),
    financas: "linear-gradient(45deg, ".concat(palette.verde74, ", ").concat(palette.verde79, ")"),
    inovacao: "linear-gradient(45deg, ".concat(palette.lilas75, ", ").concat(palette.azulSebrae62, ")"),
    leis: "linear-gradient(45deg, ".concat(palette.lilas75, ", ").concat(palette.violeta63, ")"),
    mercadoVendas: "linear-gradient(45deg, ".concat(palette.verde74, ", ").concat(palette.azulSebrae63, ")"),
    organizacao: "linear-gradient(45deg, ".concat(palette.azulSebrae62, ", ").concat(palette.azulSebrae63, ")"),
    pessoas: "linear-gradient(45deg, ".concat(palette.violeta63, ", ").concat(palette.rosa84, ")"),
    planejamento: "linear-gradient(45deg, ".concat(palette.laranja75, ", ").concat(palette.amarelo71, ")"),
};
var contrastPalette = {
    azulSebrae10: palette.white,
    azulSebrae20: palette.white,
    azulSebrae30: palette.white,
    azulSebrae33: palette.white,
    azulSebrae36: palette.white,
    azulSebrae43: palette.white,
    azulSebrae60: palette.cinzaSebrae10,
    azulSebrae62: palette.white,
    azulSebrae63: palette.cinzaSebrae10,
    azulSebrae75: palette.cinzaSebrae10,
    azulSebrae90: palette.cinzaSebrae20,
    azulSebrae97: palette.cinzaSebrae20,
    cinzaSebrae10: palette.white,
    cinzaSebrae20: palette.white,
    cinzaSebrae30: palette.white,
    cinzaSebrae45: palette.white,
    cinzaSebrae60: palette.cinzaSebrae10,
    cinzaSebrae75: palette.cinzaSebrae10,
    cinzaSebrae90: palette.cinzaSebrae20,
    cinzaSebrae97: palette.cinzaSebrae30,
    marrom10: palette.white,
    marrom20: palette.white,
    marrom30: palette.white,
    marrom50: palette.cinzaSebrae10,
    marrom60: palette.cinzaSebrae10,
    marrom75: palette.cinzaSebrae10,
    marrom90: palette.cinzaSebrae10,
    laranja10: palette.white,
    laranja25: palette.white,
    laranja40: palette.white,
    laranja63: palette.cinzaSebrae10,
    laranja73: palette.cinzaSebrae10,
    laranja75: palette.cinzaSebrae10,
    laranja80: palette.cinzaSebrae20,
    laranja90: palette.cinzaSebrae20,
    verdeOliva10: palette.white,
    verdeOliva20: palette.white,
    verdeOliva30: palette.white,
    verdeOliva47: palette.cinzaSebrae10,
    verdeOliva60: palette.cinzaSebrae10,
    verdeOliva75: palette.cinzaSebrae10,
    verdeOliva90: palette.cinzaSebrae20,
    cinza10: palette.white,
    cinza25: palette.white,
    cinza30: palette.white,
    cinza67: palette.cinzaSebrae10,
    cinza75: palette.cinzaSebrae10,
    cinza85: palette.cinzaSebrae20,
    cinza90: palette.cinzaSebrae20,
    roxo10: palette.white,
    roxo20: palette.white,
    roxo30: palette.white,
    roxo44: palette.white,
    roxo60: palette.cinzaSebrae10,
    roxo75: palette.cinzaSebrae10,
    roxo90: palette.cinzaSebrae20,
    turquesa10: palette.white,
    turquesa15: palette.white,
    turquesa25: palette.white,
    turquesa40: palette.cinzaSebrae10,
    turquesa60: palette.cinzaSebrae10,
    turquesa75: palette.cinzaSebrae10,
    turquesa90: palette.cinzaSebrae20,
    azulAqua10: palette.white,
    azulAqua20: palette.white,
    azulAqua30: palette.white,
    azulAqua44: palette.cinzaSebrae10,
    azulAqua60: palette.cinzaSebrae10,
    azulAqua75: palette.cinzaSebrae10,
    azulAqua90: palette.cinzaSebrae20,
    vermelho10: palette.white,
    vermelho20: palette.white,
    vermelho35: palette.white,
    vermelho47: palette.cinzaSebrae10,
    vermelho65: palette.cinzaSebrae10,
    vermelho80: palette.cinzaSebrae10,
    vermelho90: palette.cinzaSebrae10,
    amarelo10: palette.white,
    amarelo25: palette.white,
    amarelo35: palette.white,
    amarelo63: palette.cinzaSebrae10,
    amarelo71: palette.cinzaSebrae10,
    amarelo73: palette.cinzaSebrae20,
    amarelo80: palette.cinzaSebrae20,
    amarelo90: palette.cinzaSebrae20,
    sucesso20: palette.white,
    sucesso26: palette.white,
    sucesso45: palette.cinzaSebrae10,
    sucesso70: palette.cinzaSebrae10,
    sucesso75: palette.cinzaSebrae10,
    sucesso85: palette.cinzaSebrae20,
    sucesso95: palette.cinzaSebrae20,
    erro35: palette.white,
    erro45: palette.white,
    erro60: palette.cinzaSebrae10,
    erro70: palette.cinzaSebrae10,
    erro75: palette.cinzaSebrae10,
    erro85: palette.cinzaSebrae20,
    erro95: palette.cinzaSebrae20,
    atencao35: palette.white,
    atencao55: palette.cinzaSebrae10,
    atencao60: palette.cinzaSebrae10,
    atencao70: palette.cinzaSebrae20,
    atencao75: palette.cinzaSebrae20,
    atencao85: palette.cinzaSebrae20,
    atencao95: palette.cinzaSebrae20,
    lilas75: palette.cinzaSebrae10,
    rosa61: palette.cinzaSebrae10,
    rosa84: palette.cinzaSebrae10,
    verde74: palette.cinzaSebrae10,
    verde79: palette.cinzaSebrae10,
    violeta63: palette.cinzaSebrae10,
    gradientCooperacao: palette.cinzaSebrae10,
    gradientEmpreendedorismo: palette.cinzaSebrae10,
    gradientFinancas: palette.cinzaSebrae10,
    gradientInovacao: palette.white,
    gradientLeis: palette.cinzaSebrae10,
    gradientMercadoVendas: palette.cinzaSebrae10,
    gradientOrganizacao: palette.white,
    gradientPessoas: palette.cinzaSebrae10,
    gradientPlanejamento: palette.cinzaSebrae10,
};
var BaSeColors = {
    brandbook: {
        azulSebrae33: palette.azulSebrae33,
        azulSebrae43: palette.azulSebrae43,
        azulSebrae62: palette.azulSebrae62,
        azulSebrae63: palette.azulSebrae63,
        laranja75: palette.laranja75,
        amarelo71: palette.amarelo71,
        lilas75: palette.lilas75,
        rosa61: palette.rosa61,
        rosa84: palette.rosa84,
        verde74: palette.verde74,
        verde79: palette.verde79,
        violeta63: palette.violeta63,
    },
    institucionais: {
        azulSebrae: palette.azulSebrae36,
        azulSebrae10: palette.azulSebrae10,
        azulSebrae20: palette.azulSebrae20,
        azulSebrae30: palette.azulSebrae30,
        azulSebrae36: palette.azulSebrae36,
        azulSebrae60: palette.azulSebrae60,
        azulSebrae75: palette.azulSebrae75,
        azulSebrae90: palette.azulSebrae90,
        azulSebrae97: palette.azulSebrae97,
        cinzaSebrae: palette.cinzaSebrae10,
        cinzaSebrae10: palette.cinzaSebrae10,
        cinzaSebrae20: palette.cinzaSebrae20,
        cinzaSebrae30: palette.cinzaSebrae30,
        cinzaSebrae45: palette.cinzaSebrae45,
        cinzaSebrae60: palette.cinzaSebrae60,
        cinzaSebrae75: palette.cinzaSebrae75,
        cinzaSebrae90: palette.cinzaSebrae90,
        cinzaSebrae97: palette.cinzaSebrae97,
    },
    gestao: {
        cooperacao: palette.marrom50,
        marrom10: palette.marrom10,
        marrom20: palette.marrom20,
        marrom30: palette.marrom30,
        marrom50: palette.marrom50,
        marrom60: palette.marrom60,
        marrom75: palette.marrom75,
        marrom90: palette.marrom90,
        empreendedorismo: palette.laranja63,
        laranja10: palette.laranja10,
        laranja25: palette.laranja25,
        laranja40: palette.laranja40,
        laranja63: palette.laranja63,
        laranja73: palette.laranja73,
        laranja80: palette.laranja80,
        laranja90: palette.laranja90,
        financas: palette.verdeOliva47,
        verdeOliva10: palette.verdeOliva10,
        verdeOliva20: palette.verdeOliva20,
        verdeOliva30: palette.verdeOliva30,
        verdeOliva47: palette.verdeOliva47,
        verdeOliva60: palette.verdeOliva60,
        verdeOliva75: palette.verdeOliva75,
        verdeOliva90: palette.verdeOliva90,
        inovacao: palette.cinza67,
        cinza10: palette.cinza10,
        cinza25: palette.cinza25,
        cinza30: palette.cinza30,
        cinza67: palette.cinza67,
        cinza75: palette.cinza75,
        cinza85: palette.cinza85,
        cinza90: palette.cinza90,
        leis: palette.roxo44,
        roxo10: palette.roxo10,
        roxo20: palette.roxo20,
        roxo30: palette.roxo30,
        roxo44: palette.roxo44,
        roxo60: palette.roxo60,
        roxo75: palette.roxo75,
        roxo90: palette.roxo90,
        mercadoVendas: palette.turquesa40,
        turquesa10: palette.turquesa10,
        turquesa15: palette.turquesa15,
        turquesa25: palette.turquesa25,
        turquesa40: palette.turquesa40,
        turquesa60: palette.turquesa60,
        turquesa75: palette.turquesa75,
        turquesa90: palette.turquesa90,
        organizacao: palette.azulAqua44,
        azulAqua10: palette.azulAqua10,
        azulAqua20: palette.azulAqua20,
        azulAqua30: palette.azulAqua30,
        azulAqua44: palette.azulAqua44,
        azulAqua60: palette.azulAqua60,
        azulAqua75: palette.azulAqua75,
        azulAqua90: palette.azulAqua90,
        pessoas: palette.vermelho47,
        vermelho10: palette.vermelho10,
        vermelho20: palette.vermelho20,
        vermelho35: palette.vermelho35,
        vermelho47: palette.vermelho47,
        vermelho65: palette.vermelho65,
        vermelho80: palette.vermelho80,
        vermelho90: palette.vermelho90,
        planejamento: palette.amarelo63,
        amarelo10: palette.amarelo10,
        amarelo25: palette.amarelo25,
        amarelo35: palette.amarelo35,
        amarelo63: palette.amarelo63,
        amarelo73: palette.amarelo73,
        amarelo80: palette.amarelo80,
        amarelo90: palette.amarelo90,
    },
    feedbackInterface: {
        sucesso: palette.sucesso70,
        sucesso20: palette.sucesso20,
        sucesso26: palette.sucesso26,
        sucesso45: palette.sucesso45,
        sucesso70: palette.sucesso70,
        sucesso75: palette.sucesso75,
        sucesso85: palette.sucesso85,
        sucesso95: palette.sucesso95,
        erro: palette.erro70,
        erro35: palette.erro35,
        erro45: palette.erro45,
        erro60: palette.erro60,
        erro70: palette.erro70,
        erro75: palette.erro75,
        erro85: palette.erro85,
        erro95: palette.erro95,
        atencao: palette.atencao70,
        atencao35: palette.atencao35,
        atencao55: palette.atencao55,
        atencao60: palette.atencao60,
        atencao70: palette.atencao70,
        atencao75: palette.atencao75,
        atencao85: palette.atencao85,
        atencao95: palette.atencao95,
        informacao: palette.azulSebrae36,
        azulSebrae10: palette.azulSebrae10,
        azulSebrae20: palette.azulSebrae20,
        azulSebrae30: palette.azulSebrae30,
        azulSebrae36: palette.azulSebrae36,
        azulSebrae60: palette.azulSebrae60,
        azulSebrae75: palette.azulSebrae75,
        azulSebrae90: palette.azulSebrae90,
    },
    defaultColors: {
        transparent: palette.transparent,
        shadowColor: palette.shadowColor,
        lightGray: palette.lightGray,
        white: palette.white,
        black: palette.black,
    },
    contrast: {
        brandbook: {
            azulSebrae33: contrastPalette.azulSebrae33,
            azulSebrae43: contrastPalette.azulSebrae43,
            azulSebrae62: contrastPalette.azulSebrae62,
            azulSebrae63: contrastPalette.azulSebrae63,
            laranja75: contrastPalette.laranja75,
            amarelo71: contrastPalette.amarelo71,
            lilas75: contrastPalette.lilas75,
            rosa61: contrastPalette.rosa61,
            rosa84: contrastPalette.rosa84,
            verde74: contrastPalette.verde74,
            verde79: contrastPalette.verde79,
            violeta63: contrastPalette.violeta63,
        },
        institucionais: {
            azulSebrae: contrastPalette.azulSebrae36,
            azulSebrae10: contrastPalette.azulSebrae10,
            azulSebrae20: contrastPalette.azulSebrae20,
            azulSebrae30: contrastPalette.azulSebrae30,
            azulSebrae36: contrastPalette.azulSebrae36,
            azulSebrae60: contrastPalette.azulSebrae60,
            azulSebrae75: contrastPalette.azulSebrae75,
            azulSebrae90: contrastPalette.azulSebrae90,
            azulSebrae97: contrastPalette.azulSebrae97,
            cinzaSebrae: contrastPalette.cinzaSebrae10,
            cinzaSebrae10: contrastPalette.cinzaSebrae10,
            cinzaSebrae20: contrastPalette.cinzaSebrae20,
            cinzaSebrae30: contrastPalette.cinzaSebrae30,
            cinzaSebrae45: contrastPalette.cinzaSebrae45,
            cinzaSebrae60: contrastPalette.cinzaSebrae60,
            cinzaSebrae75: contrastPalette.cinzaSebrae75,
            cinzaSebrae90: contrastPalette.cinzaSebrae90,
            cinzaSebrae97: contrastPalette.cinzaSebrae97,
        },
        gestao: {
            cooperacao: contrastPalette.marrom50,
            marrom10: contrastPalette.marrom10,
            marrom20: contrastPalette.marrom20,
            marrom30: contrastPalette.marrom30,
            marrom50: contrastPalette.marrom50,
            marrom60: contrastPalette.marrom60,
            marrom75: contrastPalette.marrom75,
            marrom90: contrastPalette.marrom90,
            empreendedorismo: contrastPalette.laranja63,
            laranja10: contrastPalette.laranja10,
            laranja25: contrastPalette.laranja25,
            laranja40: contrastPalette.laranja40,
            laranja63: contrastPalette.laranja63,
            laranja73: contrastPalette.laranja73,
            laranja80: contrastPalette.laranja80,
            laranja90: contrastPalette.laranja90,
            financas: contrastPalette.verdeOliva47,
            verdeOliva10: contrastPalette.verdeOliva10,
            verdeOliva20: contrastPalette.verdeOliva20,
            verdeOliva30: contrastPalette.verdeOliva30,
            verdeOliva47: contrastPalette.verdeOliva47,
            verdeOliva60: contrastPalette.verdeOliva60,
            verdeOliva75: contrastPalette.verdeOliva75,
            verdeOliva90: contrastPalette.verdeOliva90,
            inovacao: contrastPalette.cinza67,
            cinza10: contrastPalette.cinza10,
            cinza25: contrastPalette.cinza25,
            cinza30: contrastPalette.cinza30,
            cinza67: contrastPalette.cinza67,
            cinza75: contrastPalette.cinza75,
            cinza85: contrastPalette.cinza85,
            cinza90: contrastPalette.cinza90,
            leis: contrastPalette.roxo44,
            roxo10: contrastPalette.roxo10,
            roxo20: contrastPalette.roxo20,
            roxo30: contrastPalette.roxo30,
            roxo44: contrastPalette.roxo44,
            roxo60: contrastPalette.roxo60,
            roxo75: contrastPalette.roxo75,
            roxo90: contrastPalette.roxo90,
            mercadoVendas: contrastPalette.turquesa40,
            turquesa10: contrastPalette.turquesa10,
            turquesa15: contrastPalette.turquesa15,
            turquesa25: contrastPalette.turquesa25,
            turquesa40: contrastPalette.turquesa40,
            turquesa60: contrastPalette.turquesa60,
            turquesa75: contrastPalette.turquesa75,
            turquesa90: contrastPalette.turquesa90,
            organizacao: contrastPalette.azulAqua44,
            azulAqua10: contrastPalette.azulAqua10,
            azulAqua20: contrastPalette.azulAqua20,
            azulAqua30: contrastPalette.azulAqua30,
            azulAqua44: contrastPalette.azulAqua44,
            azulAqua60: contrastPalette.azulAqua60,
            azulAqua75: contrastPalette.azulAqua75,
            azulAqua90: contrastPalette.azulAqua90,
            pessoas: contrastPalette.vermelho47,
            vermelho10: contrastPalette.vermelho10,
            vermelho20: contrastPalette.vermelho20,
            vermelho35: contrastPalette.vermelho35,
            vermelho47: contrastPalette.vermelho47,
            vermelho65: contrastPalette.vermelho65,
            vermelho80: contrastPalette.vermelho80,
            vermelho90: contrastPalette.vermelho90,
            planejamento: contrastPalette.amarelo63,
            amarelo10: contrastPalette.amarelo10,
            amarelo25: contrastPalette.amarelo25,
            amarelo35: contrastPalette.amarelo35,
            amarelo63: contrastPalette.amarelo63,
            amarelo73: contrastPalette.amarelo73,
            amarelo80: contrastPalette.amarelo80,
            amarelo90: contrastPalette.amarelo90,
        },
        feedbackInterface: {
            sucesso: contrastPalette.sucesso70,
            sucesso20: contrastPalette.sucesso20,
            sucesso26: contrastPalette.sucesso26,
            sucesso45: contrastPalette.sucesso45,
            sucesso70: contrastPalette.sucesso70,
            sucesso75: contrastPalette.sucesso75,
            sucesso85: contrastPalette.sucesso85,
            sucesso95: contrastPalette.sucesso95,
            erro: contrastPalette.erro70,
            erro35: contrastPalette.erro35,
            erro45: contrastPalette.erro45,
            erro60: contrastPalette.erro60,
            erro70: contrastPalette.erro70,
            erro75: contrastPalette.erro75,
            erro85: contrastPalette.erro85,
            erro95: contrastPalette.erro95,
            atencao: contrastPalette.atencao70,
            atencao35: contrastPalette.atencao35,
            atencao55: contrastPalette.atencao55,
            atencao60: contrastPalette.atencao60,
            atencao70: contrastPalette.atencao70,
            atencao75: contrastPalette.atencao75,
            atencao85: contrastPalette.atencao85,
            atencao95: contrastPalette.atencao95,
            informacao: contrastPalette.azulSebrae36,
            azulSebrae10: contrastPalette.azulSebrae10,
            azulSebrae20: contrastPalette.azulSebrae20,
            azulSebrae30: contrastPalette.azulSebrae30,
            azulSebrae36: contrastPalette.azulSebrae36,
            azulSebrae60: contrastPalette.azulSebrae60,
            azulSebrae75: contrastPalette.azulSebrae75,
            azulSebrae90: contrastPalette.azulSebrae90,
        },
    },
};
var BaSeGradients = {
    brandbook: {
        gestao: {
            cooperacao: gradient.cooperacao,
            empreendedorismo: gradient.empreendedorismo,
            financas: gradient.financas,
            inovacao: gradient.inovacao,
            leis: gradient.leis,
            mercadoVendas: gradient.mercadoVendas,
            organizacao: gradient.organizacao,
            pessoas: gradient.pessoas,
            planejamento: gradient.planejamento,
        },
    },
    contrast: {
        brandbook: {
            gestao: {
                cooperacao: contrastPalette.gradientCooperacao,
                empreendedorismo: contrastPalette.gradientEmpreendedorismo,
                financas: contrastPalette.gradientFinancas,
                inovacao: contrastPalette.gradientInovacao,
                leis: contrastPalette.gradientLeis,
                mercadoVendas: contrastPalette.gradientMercadoVendas,
                organizacao: contrastPalette.gradientOrganizacao,
                pessoas: contrastPalette.gradientPessoas,
                planejamento: contrastPalette.gradientPlanejamento,
            },
        },
    },
};

var BaSeShadows = {
    profundidade0: 'none',
    profundidade2: " 0  2px  4px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade4: " 0  4px  8px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade8: " 0  8px 12px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade16: "0 16px 32px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade32: "0 32px 30px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade64: "0 64px 40px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    focusPrimary: "0 0 4px ".concat(BaSeColors.institucionais.azulSebrae75),
    focusError: "0 0 4px ".concat(BaSeColors.feedbackInterface.erro70),
    focusValidated: "0 0 4px ".concat(BaSeColors.feedbackInterface.sucesso70), // TODO Ver se vai ter isso mesmo
};
var shadowLevelFactor = 2;
var minShadowLevel = 2;
var maxShadowLevel = 64;
function validateShadowLevel(level) {
    return [0, 2, 4, 8, 16, 32, 64].includes(level);
}
function getShadow(level) {
    if (level < minShadowLevel) {
        level = minShadowLevel;
    }
    if (level > maxShadowLevel) {
        level = maxShadowLevel;
    }
    if (validateShadowLevel(level)) {
        return BaSeShadows["profundidade".concat(level)];
    }
    return '';
}
var elevatedCss = function (_a) {
    var shadowLevel = _a.shadowLevel;
    return css(templateObject_1$1h || (templateObject_1$1h = __makeTemplateObject(["\n  transform: translateY(\n    -", "px\n  );\n  box-shadow: ", ";\n"], ["\n  transform: translateY(\n    -", /*  - shadowLevel */ "px\n  );\n  box-shadow: ", ";\n"])), shadowLevel * shadowLevelFactor /*  - shadowLevel */, getShadow((shadowLevel * shadowLevelFactor)));
};
var templateObject_1$1h;

var continuousTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
var elasticTimingFunction = 'cubic-bezier(0.18, 0.89, 0.67, 1.57)';
var durationNormalInMilliseconds = 255;
var durationSlowInMilliseconds = 1000;
var durationFastInMilliseconds = 120;
var durationNormal = "".concat(durationNormalInMilliseconds, "ms");
var durationSlow = "".concat(durationSlowInMilliseconds, "ms");
var durationFast$1 = "".concat(durationFastInMilliseconds, "ms");
function transition(duration, timingFunction) {
    return "all ".concat(duration, " ").concat(timingFunction);
}
var BaSeTransitions = {
    allPropertiesContinuousNormal: transition(durationNormal, continuousTimingFunction),
    allPropertiesContinuousSlow: transition(durationSlow, continuousTimingFunction),
    allPropertiesContinuousFast: transition(durationFast$1, continuousTimingFunction),
    allPropertiesElasticNormal: transition(durationNormal, elasticTimingFunction),
    allPropertiesElasticLenta: transition(durationSlow, elasticTimingFunction),
    allPropertiesElasticRapida: transition(durationFast$1, elasticTimingFunction),
    continuousTimingFunction: continuousTimingFunction,
    elasticTimingFunction: elasticTimingFunction,
    durationNormalInMilliseconds: durationNormalInMilliseconds,
    durationSlowInMilliseconds: durationSlowInMilliseconds,
    durationFastInMilliseconds: durationFastInMilliseconds,
    durationNormal: durationNormal,
    durationSlow: durationSlow,
    durationFast: durationFast$1,
};

var BaSeTypography = {
    fontFamily: 'Lato, "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSizeBase: '16px',
    lineHeightBase: '16px',
};

var mediaQueryCssFrom = function (start, mediaType) {
    if (mediaType === void 0) { mediaType = 'screen'; }
    return function (content) { return css(templateObject_1$1g || (templateObject_1$1g = __makeTemplateObject(["\n    @media ", " and (min-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media ", " and (min-width: ", "px) {\n      ", "\n    }\n  "])), mediaType, start.minWidth, content); };
};
var mediaQueryCssUpTo = function (end, mediaType) {
    if (mediaType === void 0) { mediaType = 'screen'; }
    return function (content) { return css(templateObject_2$13 || (templateObject_2$13 = __makeTemplateObject(["\n    @media ", " and (max-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media ", " and (max-width: ", "px) {\n      ", "\n    }\n  "])), mediaType, end.minWidth, content); };
};
var mediaQueryCssBetween = function (start, end, mediaType) {
    if (mediaType === void 0) { mediaType = 'screen'; }
    return function (content) { return css(templateObject_3$W || (templateObject_3$W = __makeTemplateObject(["\n    @media ", " and (min-width: ", "px) and (max-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media ", " and (min-width: ", "px) and (max-width: ", "px) {\n      ", "\n    }\n  "])), mediaType, start.minWidth, end.minWidth, content); };
};
var BaSeMediaQueries = {
    mediaQueryCssFrom: mediaQueryCssFrom,
    mediaQueryCssUpTo: mediaQueryCssUpTo,
    mediaQueryCssBetween: mediaQueryCssBetween,
};
var templateObject_1$1g, templateObject_2$13, templateObject_3$W;

var desktopLarge = {
    type: 'desktop',
    maxWidth: Number.MAX_SAFE_INTEGER,
    minWidth: 1440,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var desktop = {
    type: 'desktop',
    maxWidth: 1439,
    minWidth: 1280,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var tablet = {
    type: 'tablet',
    maxWidth: 1279,
    minWidth: 768,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var mobileLarge = {
    type: 'mobile',
    maxWidth: 767,
    minWidth: 375,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var mobile = {
    type: 'mobile',
    maxWidth: 374,
    minWidth: 360,
    gap: 32,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var mobileSmall = {
    type: 'mobile',
    maxWidth: 359,
    minWidth: 320,
    gap: 32,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
desktopLarge.mediaQuery = "(min-width: ".concat(desktopLarge.minWidth, "px)");
desktop.mediaQuery = "(min-width: ".concat(desktop.minWidth, "px) and (max-width: ").concat(desktop.maxWidth, "px)");
tablet.mediaQuery = "(min-width: ".concat(tablet.minWidth, "px) and (max-width: ").concat(tablet.maxWidth, "px)");
mobileLarge.mediaQuery = "(min-width: ".concat(mobileLarge.minWidth, "px) and (max-width: ").concat(mobileLarge.maxWidth, "px)");
mobile.mediaQuery = "(min-width: ".concat(mobile.minWidth, "px) and (max-width: ").concat(mobile.maxWidth, "px)");
mobileSmall.mediaQuery = "(max-width: ".concat(mobileSmall.maxWidth, "px)");
desktopLarge.mediaQuerySelector = "@media screen and ".concat(desktopLarge.mediaQuery);
desktop.mediaQuerySelector = "@media screen and ".concat(desktop.mediaQuery);
tablet.mediaQuerySelector = "@media screen and ".concat(tablet.mediaQuery);
mobileLarge.mediaQuerySelector = "@media screen and ".concat(mobileLarge.mediaQuery);
mobile.mediaQuerySelector = "@media screen and ".concat(mobile.mediaQuery);
mobileSmall.mediaQuerySelector = "@media screen and ".concat(mobileSmall.mediaQuery);
desktopLarge.mediaQueryCss = function (content) {
    return "".concat(desktopLarge.mediaQuerySelector, " { ").concat(content, " }");
};
desktop.mediaQueryCss = function (content) {
    return "".concat(desktop.mediaQuerySelector, " { ").concat(content, " }");
};
tablet.mediaQueryCss = function (content) {
    return "".concat(tablet.mediaQuerySelector, " { ").concat(content, " }");
};
mobileLarge.mediaQueryCss = function (content) {
    return "".concat(mobileLarge.mediaQuerySelector, " { ").concat(content, " }");
};
mobile.mediaQueryCss = function (content) {
    return "".concat(mobile.mediaQuerySelector, " { ").concat(content, " }");
};
mobileSmall.mediaQueryCss = function (content) {
    return "".concat(mobileSmall.mediaQuerySelector, " { ").concat(content, " }");
};
var BaSeBreakpoints = {
    mobileSmall: mobileSmall,
    mobile: mobile,
    mobileLarge: mobileLarge,
    tablet: tablet,
    desktop: desktop,
    desktopLarge: desktopLarge,
    mediaQueries: BaSeMediaQueries,
};

var button = {
    colors: {
        default: 'default',
        padrao: 'default',
        destructive: 'destructive',
        destrutivo: 'destructive',
        confirmation: 'confirmation',
        confirmacao: 'confirmation',
        negative: 'negative',
        negativo: 'negative',
        attention: 'attention',
        atencao: 'attention',
    },
};
var BaSeComponents = {
    button: button,
};

var BaSeStackOrder = {
    default: 0,
    normal: 1,
    aboveNormal: 10,
    belowOverlay: 100,
    overlay: 1000,
    aboveOverlay: 9999,
};

var BaSeTheme = {
    colors: BaSeColors,
    gradients: BaSeGradients,
    shadows: BaSeShadows,
    typography: BaSeTypography,
    transitions: BaSeTransitions,
    breakpoints: BaSeBreakpoints,
    components: BaSeComponents,
    stackOrder: BaSeStackOrder,
};

var queryMatchDefault = {
    onMobileSmall: false,
    onMobile: false,
    onMobileLarge: false,
    onTablet: false,
    onDesktop: false,
    onDesktopLarge: false,
    isInPortraitMode: false,
    isInLandscapeMode: false,
    inMobileSmall: false,
    inMobile: false,
    inMobileLarge: false,
    inTablet: false,
    inDesktop: false,
    inDesktopLarge: false,
    isInTouchableMode: false,
};
var BaSeBreakpointContext = React.createContext(queryMatchDefault);
var BaSeBreakpointProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState({}), queryMatch = _b[0], setQueryMatch = _b[1];
    React.useEffect(function () {
        var queries = {
            onMobileSmall: BaSeTheme.breakpoints.mobileSmall.mediaQuery,
            onMobile: BaSeTheme.breakpoints.mobile.mediaQuery,
            onMobileLarge: BaSeTheme.breakpoints.mobileLarge.mediaQuery,
            onTablet: BaSeTheme.breakpoints.tablet.mediaQuery,
            onDesktop: BaSeTheme.breakpoints.desktop.mediaQuery,
            onDesktopLarge: BaSeTheme.breakpoints.desktopLarge.mediaQuery,
            isInPortraitMode: '(orientation: portrait)',
            isInLandscapeMode: '(orientation: landscape)',
            isInTouchableMode: '(pointer:coarse)',
        };
        var mediaQueryLists = {};
        var keys = Object.keys(queries);
        var recursiveQueries = {
            inMobileSmall: BaSeTheme.breakpoints.mobileSmall.mediaQuery,
            inMobile: BaSeTheme.breakpoints.mobile.mediaQuery,
            inMobileLarge: BaSeTheme.breakpoints.mobileLarge.mediaQuery,
            inTablet: BaSeTheme.breakpoints.tablet.mediaQuery,
            inDesktop: BaSeTheme.breakpoints.desktop.mediaQuery,
            inDesktopLarge: BaSeTheme.breakpoints.desktopLarge.mediaQuery,
        };
        var recursiveKeys = Object.keys(recursiveQueries);
        var isAttached = false;
        var handleRecursiveQueries = function (options) {
            var index = 0;
            var checked = true;
            var queryReturn = {};
            var updatedMatches = recursiveKeys.reduce(function (acc, media, matchIndex) {
                acc[matchIndex] = media;
                return acc;
            }, {});
            // eslint-disable-next-line guard-for-in
            for (var query in options) {
                queryReturn[updatedMatches[index++]] = !!checked;
                if (options[query]) {
                    checked = false;
                }
            }
            return __assign(__assign({}, options), queryReturn);
        };
        var handleQueryListener = function () {
            var updatedMatches = keys.reduce(function (acc, media) {
                acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
                return acc;
            }, {});
            setQueryMatch(handleRecursiveQueries(updatedMatches));
        };
        if (window && window.matchMedia) {
            var matches_1 = {};
            keys.forEach(function (media) {
                if (typeof queries[media] === 'string') {
                    mediaQueryLists[media] = window.matchMedia(queries[media]);
                    matches_1[media] = mediaQueryLists[media].matches;
                }
                else {
                    matches_1[media] = false;
                }
            });
            setQueryMatch(handleRecursiveQueries(matches_1));
            isAttached = true;
            keys.forEach(function (media) {
                if (typeof queries[media] === 'string') {
                    mediaQueryLists[media].addListener(handleQueryListener);
                }
            });
        }
        return function () {
            if (isAttached) {
                keys.forEach(function (media) {
                    if (typeof queries[media] === 'string') {
                        mediaQueryLists[media].removeListener(handleQueryListener);
                    }
                });
            }
        };
    }, []);
    return (React.createElement(BaSeBreakpointContext.Provider, { value: queryMatch }, children));
};
var BaSeBreakpointConsumer = BaSeBreakpointContext.Consumer;

function idGenerator() {
    var counter, random;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                counter = 0;
                _a.label = 1;
            case 1:
                random = Math.random().toString(36).substring(3);
                return [4 /*yield*/, {
                        hash: "BaSe__".concat(random).concat(++counter),
                        counter: counter,
                    }];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
function getNextHash(idSequence) {
    return idSequence.next().value.hash;
}
function getNextCounter(idSequence) {
    return idSequence.next().value.counter;
}

function useNextHashId(idSequence) {
    return React.useMemo(function () { return getNextHash(idSequence); }, []);
}
function useNextCounterId(idSequence) {
    return React.useMemo(function () { return getNextCounter(idSequence); }, []);
}

const z__$1="";var en = {"a11yBar.accessibility":"Accessibility","a11yBar.language":"Language","accordion.iconDescription":"Icon to indicate if item is opened or closed","actionItem.iconDescription":"More options","avatarImage.description":"Authenticated user's image","backendNoSignalPage.errorMessage":"Please, try again later.","backendNoSignalPage.title":"No connection to the system","badge.marker":"Marker","board.columnPlaceHolder":"Drop here one item","buttonIcon.defaultDescription":"Button image","buttonIcon.hidePassword":"Hide password","buttonIcon.iconDescription.close":"Close","buttonIcon.iconDescription.menu":"Menu","buttonIcon.iconDescription.next":"Next","buttonIcon.iconDescription.options":"Options","buttonIcon.iconDescription.previous":"Previous","buttonIcon.inputIcon":"Input action","buttonIcon.showPassword":"Show password","buttonIcon.toggleDrawer":"Toggle content","changePassword.label":"Change Password","checkbox.iconDescription":"Checkbox icon","counter.char":"character","counter.chars":"characters","counter.doneMax":"Reached the maximum of {0} {1}","counter.doneMin":"Reached the minimum of {0} {1}","counter.initialMax":"Maximum of {0} {1}","counter.initialMin":"Minimum of {0} {1}","counter.line":"line","counter.lines":"lines","counter.max":"{0} {1} left","counter.maxLastOne":"{0} {1} to go","counter.min":"{0} {1} left","counter.minLastOne":"{0} {1} to go","counter.minMax":"Min: {0}/{1} | Max: {2}/{3} of {4}","counter.withoutMinMax":"{0} {1}","counter.word":"word","counter.words":"words","cropper.button.cancel":"Cancel","cropper.button.save":"Save","cropper.image.alt":"Image to crop","cropper.error.crop":"Error on image crop","cropper.error.upload":"Error on image upload","dataConfigAction.hint":"Configuration","dataDensity.high":"Compacted","dataDensity.low":"Spaced","dataDensity.normal":"Normal","dataFilter.closeFilter":"Close filter","dataFilter.customFilterActivatedTitle":"Activated filters:","dataFilter.customFilterClear":"Clear filters","dataFilter.customFilterTitle":"Filters","dataFilter.openFilter":"Open filter","dataFilter.textFilterPlaceholder":"Type text to search","dataItem.pluralItemDescription":"items","dataItem.singularItemDescription":"item","dataPagination.noItemsToDisplay":"No {0} to display","dataPagination.perPage":"Per page","dataPagination.showingAllItems.female":"Showing all {0} {1}","dataPagination.showingAllItems.male":"Showing all {0} {1}","dataPagination.showingItems":"Showing {0} of {1} {2}","dataPagination.showingMoreThanOneItem":"Showing {0} {1}","dataPagination.showingOneItems":"Showing 1 {0}","dataSelection.allItemsSelected.female":"Selected all {0} {1}","dataSelection.allItemsSelected.male":"Selected all {0} {1}","dataSelection.allPageSelected":"All page selected","dataSelection.almostAllSelected.female":"Almost all selected","dataSelection.almostAllSelected.male":"Almost all selected","dataSelection.cancelSelection":"Cancel selection","dataSelection.manyItemSelected.female":"{0} {1} selected","dataSelection.manyItemSelected.male":"{0} {1} selected","dataSelection.oneItemSelected.female":"One {0} selected","dataSelection.oneItemSelected.male":"One {0} selected","dataSelection.selectedItem":"Selected item","dataSelection.selectTheLastOne.female":"Select the last remaining {0} one too? ","dataSelection.selectTheLastOne.male":"Select the last remaining {0} one too? ","dataSelection.selectTheOtherRemaining.female":"Select the other {0} remaining {1}?","dataSelection.selectTheOtherRemaining.male":"Select the other {0} remaining {1}?","dataSelection.unselectAllItems.female":"Unselect all","dataSelection.unselectAllItems.male":"Unselect all","dataTable.sortHint.asc":"Sorted ascending","dataTable.sortHint.desc":"Sorted descending","dataTable.sortHint":"Toggle sort","errorPage.backButton":"Back","errorPage.defaultDescription":"Please, try again later or find for some help.","errorPage.defaultTitle":"Something wrong here","filePicker.buttonDeleteLabel":"Remove","filePicker.buttonPickLabel":"Choose","filePicker.buttonUpdateLabel":"Change","filePicker.dragInfo":"Or drop the file here to add it","filePicker.dragManyInfo":"Or drop the files here to add it all","filePicker.fileInvalidMessage":"File type is invalid","filePicker.image.dragInfo":"Or drop the image here to add it","filePicker.inputPickLabel":"Pick one file","filePicker.inputPickManyLabel":"Pick many files","footer.collapsedHeader":"Know all about Sebrae","footer.relationText":"Relationship Center: ","footer.system.version":"Version","forbiddenPage.errorMessage":"Please verify that your login credentials are correct.","forbiddenPage.title":"Access Denied","helperText.closeButton":"Show details","helperText.openButton":"Hide details","icon.label":"Icon: {0}","imageAccountProfile.description":"Account profile image","imagePicker.imageNotFound":"Image not found","imagePicker.imagePlaceholder":"No selected image","ImagePicker.modalTitle":"Edit photo","imagePicker.selectedImage":"Selected image","input.counter.char":"character","list.finalSeparator":" and ","list.separator":", ","loading.description":"Loading…","login.label":"Login","logo.description":"Sebrae logo","logout.label":"Logout","menuAccountProfile.ariaLabel":"Account profile menu options","message.attention":"Attention","message.confirmation":"Tip","message.default":"Important","message.destructive":"Caution","myAccount.label":"My account","myBusiness.label":"My business","myProfile.label":"My profile","myQRCode.back":"Back","myQRCode.description":"QR Code with info of {0}, CPF {1} and e-mail {2}","myQRCode.generate":"My QR Code","notFoundPage.errorMessage":"Please verify that the page address is correct.","notFoundPage.title":"Page not found","notification.iconDescription":"Notification icon","select.cleanSearch":"Clean search","select.closeOptions":"Close the options","select.emptyValue":"Select","select.hideDetail":"Hide details","select.openOptions":"Open the options","select.selectAll":"Select all","select.selectedCounter":"{0} selected","select.selectResults":"Select results","select.showDetail":"Open details","socialAccounts.label":"Social Accounts","solutions.title":"Services","stepCurrent.description":"Step {0} completed","stepCurrent.erro":"Step {0} completed with error","stepCurrent.warning":"Step {0} completed with warning","stepper.counter":"{0} of {1}","system.rights":"All rights reserved","system.sebrae":"Sebrae","tag.selected":"Selected","toggler.iconDescription":"Highlighted checkbox",z__:z__$1};

const z__="";var pt_BR$1 = {"a11yBar.accessibility":"Acessibilidade","a11yBar.language":"Idioma","accordion.iconDescription":"Ícone que indica se item está aberto ou fechado","actionItem.iconDescription":"Mais opções","avatarImage.description":"Imagem da pessoa autenticada","backendNoSignalPage.errorMessage":"Por favor, tente acessar mais tarde.","backendNoSignalPage.title":"Sem comunicação com o sistema","badge.marker":"Marcador","board.columnPlaceholder":"Arraste um item para esta coluna","buttonIcon.defaultDescription":"Imagem do botão","buttonIcon.hidePassword":"Esconder senha","buttonIcon.iconDescription.close":"Fechar","buttonIcon.iconDescription.menu":"Menu","buttonIcon.iconDescription.next":"Próximo","buttonIcon.iconDescription.options":"Opções","buttonIcon.iconDescription.previous":"Anterior","buttonIcon.inputIcon":"Ação do campo","buttonIcon.showPassword":"Exibir senha","buttonIcon.toggleDrawer":"Abre/Fecha o conteúdo","changePassword.label":"Alterar senha","checkbox.iconDescription":"Ícone do checkbox ","counter.char":"caractere","counter.chars":"caracteres","counter.doneMax":"Atingiu o máximo de {0} {1}","counter.doneMin":"Atingiu o mínimo de {0} {1}","counter.initialMax":"Máximo de {0} {1}","counter.initialMin":"Mínimo de {0} {1}","counter.line":"linha","counter.lines":"linhas","counter.max":"Faltam {0} {1}","counter.maxLastOne":"Falta {0} {1}","counter.min":"Faltam {0} {1}","counter.minLastOne":"Falta {0} {1}","counter.minMax":"Mín: {0}/{1} | Máx: {2}/{3} de {4}","counter.withoutMinMax":"{0} {1}","counter.word":"palavra","counter.words":"palavras","cropper.button.cancel":"Cancelar","cropper.button.save":"Salvar","cropper.image.alt":"Image para recortar","cropper.error.crop":"Error ao realizar o recorte da imagem","cropper.error.upload":"Erro ao carregar imagem","dataConfigAction.hint":"Configuração","dataDensity.high":"Compacto","dataDensity.low":"Espaçado","dataDensity.normal":"Normal","dataFilter.closeFilter":"Fecha o filtro","dataFilter.customFilterActivatedTitle":"Filtros ativados:","dataFilter.customFilterClear":"Limpar filtros","dataFilter.customFilterTitle":"Filtros","dataFilter.openFilter":"Abre o filtro","dataFilter.textFilterPlaceholder":"Pesquise aqui…","dataItem.pluralItemDescription":"itens","dataItem.singularItemDescription":"item","dataPagination.noItemsToDisplay":"Sem {0} para exibir","dataPagination.perPage":"Por página","dataPagination.showingAllItems.female":"Mostrando todas as {0} {1}","dataPagination.showingAllItems.male":"Mostrando todos os {0} {1}","dataPagination.showingItems":"Mostrando {0} de {1} {2}","dataPagination.showingMoreThanOneItem":"Mostrando {0} {1}","dataPagination.showingOneItems":"Mostrando 1 {0}","dataSelection.allItemsSelected.female":"Todas as {0} {1} selecionadas","dataSelection.allItemsSelected.male":"Todos os {0} {1} selecionados","dataSelection.allPageSelected":"Toda a página selecionada","dataSelection.almostAllSelected.female":"Quase todas selecionados","dataSelection.almostAllSelected.male":"Quase todos selecionados","dataSelection.cancelSelection":"Cancelar seleção","dataSelection.manyItemSelected.female":"{0} {1} selecionadas","dataSelection.manyItemSelected.male":"{0} {1} selecionados","dataSelection.oneItemSelected.female":"Uma {0} selecionada","dataSelection.oneItemSelected.male":"Um {0} selecionado","dataSelection.selectedItem":"Item selecionado","dataSelection.selectTheLastOne.female":"Selecionar a última {0} restante também?","dataSelection.selectTheLastOne.male":"Selecionar o último {0} restante também?","dataSelection.selectTheOtherRemaining.female":"Selecionar as outras {0} {1} restantes?","dataSelection.selectTheOtherRemaining.male":"Selecionar os outros {0} {1} restantes?","dataSelection.unselectAllItems.female":"Desmarcar todas","dataSelection.unselectAllItems.male":"Desmarcar todos","dataTable.sortHint.asc":"Coluna ordenada de forma ascendente","dataTable.sortHint.desc":"Coluna ordenada de forma descendente","dataTable.sortHint":"Ordenar coluna","errorPage.backButton":"Voltar","errorPage.defaultDescription":"Por favor, tente novamente mais tarde ou procure ajuda.","errorPage.defaultTitle":"Algo deu errado","filePicker.buttonDeleteLabel":"Excluir","filePicker.buttonPickLabel":"Escolher","filePicker.buttonUpdateLabel":"Trocar","filePicker.dragInfo":"Ou arraste o arquivo aqui para adicioná-lo","filePicker.dragManyInfo":"Ou arraste os arquivos aqui para adicioná-los","filePicker.fileInvalidMessage":"Tipo do arquivo é inválido","filePicker.image.dragInfo":"Ou arraste a imagem aqui para adicioná-la","filePicker.inputPickLabel":"Selecione um arquivo","filePicker.inputPickManyLabel":"Selecione os arquivos","footer.collapsedHeader":"Conheça o Sebrae","footer.relationText":"Central de relacionamento: ","footer.system.version":"Versão","forbiddenPage.errorMessage":"Por favor, verifique se você tem permissão para acessar.","forbiddenPage.title":"Acesso negado","helperText.closeButton":"Exibir detalhes","helperText.openButton":"Esconder detalhes","icon.label":"Ícone: {0}","imageAccountProfile.description":"Imagem de uma pessoa, indicando a área para fazer login","imagePicker.imageNotFound":"Imagem não encontrada","imagePicker.imagePlaceholder":"Nenhuma imagem selecionada","ImagePicker.modalTitle":"Editar foto","imagePicker.selectedImage":"Imagem selecionada","input.counter.char":"caractere","list.finalSeparator":" e ","list.separator":", ","loading.description":"Carregando…","login.label":"Entrar","logo.description":"Logotipo do Sebrae","logout.label":"Sair","menuAccountProfile.ariaLabel":"Menu com as opções do Autenticador","message.attention":"Atenção!","message.confirmation":"Dica:","message.default":"Importante:","message.destructive":"Cuidado!","myAccount.label":"Minha Conta","myBusiness.label":"Minha empresa","myProfile.label":"Meu perfil","myQRCode.back":"Voltar","myQRCode.description":"QR Code com a informação de {0}, com o CPF {1} e com o e-mail {2}","myQRCode.generate":"Meu QR Code","notFoundPage.errorMessage":"Por favor, verifique se o endereço da página está correto.","notFoundPage.title":"Página não encontrada","notification.iconDescription":"Ícone sinalizando a notificação","select.cleanSearch":"Limpar pesquisa","select.closeOptions":"Fecha as opções","select.emptyValue":"Selecione","select.hideDetail":"Fechar detalhamento do item","select.openOptions":"Abre as opções","select.selectAll":"Selecionar todos","select.selectedCounter":"{0} selecionados","select.selectResults":"Selecionar resultados","select.showDetail":"Abrir detalhamento do item","socialAccounts.label":"Vincular redes sociais","solutions.title":"Serviços","stepCurrent.description":"Etapa {0} concluída","stepCurrent.erro":"Etapa {0} concluída com erro","stepCurrent.warning":"Etapa {0} concluída com advertência","stepper.counter":"{0} de {1}","system.rights":"Todos os direitos reservados","system.sebrae":"Sebrae","tag.selected":"Selecionado","toggler.iconDescription":"Checkbox marcado",z__:z__};

// | 'es' // Spanish -- Espanhol
// | 'fr' // French -- Francês
// | 'it' // Italian -- Italiano
// | 'ja' // Japanese -- Japonês
// | 'lt' // Lithuanian -- Lituano
// | 'nl' // Dutch -- Holandês
// | 'no' // Norwegian -- Norueguês
// | 'pl' // Polish -- Polonês
// | 'ru' // Russian -- Russo
// | 'sk' // Slovak -- Eslovaco
// | 'sv' // Swedish -- Sueco
// | 'tr' // Turkish -- Turco
// | 'zh-CN' // Chinese (People's Republic of China) -- Chinês (República Popular da China)
var BaSeLocaleWithLanguages = {
    'pt-BR': 'Português (Brasil)',
    // ca: 'Català',
    // cs: 'Čeština',
    // de: 'Deutsch',
    en: 'English',
    // es: 'Español',
    // fr: 'Français',
    // it: 'Italiano',
    // ja: '日本語',
    // lt: 'Lietuvių',
    // nl: 'Nederlands',
    // no: 'Norsk',
    // pl: 'Polski',
    // ru: 'Русский',
    // sk: 'Slovenčina',
    // sv: 'Svenska',
    // tr: 'Türkçe',
    // 'zh-CN': '中文(中华人民共和国)',
};
var localizedMessages = {
    'pt-BR': pt_BR$1,
    en: en,
};
function createMessages(keys, locales) {
    var result = {};
    keys.forEach(function (key) {
        var _a;
        result[key] = (_a = result === null || result === void 0 ? void 0 : result[key]) !== null && _a !== void 0 ? _a : {};
        locales.forEach(function (locale) { var _a, _b; return (result[key][locale] = (_b = (_a = localizedMessages === null || localizedMessages === void 0 ? void 0 : localizedMessages[locale]) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : key); });
    });
    return result;
}
var messages = createMessages(Object.keys(pt_BR$1), ['en', 'pt-BR']);

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'cerca de 1 hora',
    other: 'cerca de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'cerca de 1 semana',
    other: 'cerca de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'cerca de 1 mês',
    other: 'cerca de {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'cerca de 1 ano',
    other: 'cerca de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
var formatDistance$2 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'em ' + result;
    } else {
      return 'há ' + result;
    }
  }
  return result;
};
var formatDistance$3 = formatDistance$2;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$1 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: function lastWeek(date) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};
var formatRelative$2 = function formatRelative(token, date, _baseDate, _options) {
  var format = formatRelativeLocale$1[token];
  if (typeof format === 'function') {
    return format(date);
  }
  return format;
};
var formatRelative$3 = formatRelative$2;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'depois de cristo']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$1 = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var dayValues$1 = {
  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') {
    return number + 'ª';
  }
  return number + 'º';
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$1 = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns$1 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
};
var matchDayPatterns$1 = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns$1 = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */
var locale$1 = {
  code: 'pt-BR',
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var pt_BR = locale$1;

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

var _a$6, _b, _c;
var localePtBR = 'pt-BR';
var localeEn = 'en';
var formatCurrencyPrefixPtBR = 'R$';
var formatCurrencyDecimalSeparatorPtBR = ',';
var formatCurrencyClassSeparatorPtBR = '.';
var formatCurrencyPrefixEn = 'US$';
var formatCurrencyDecimalSeparatorEn = '.';
var formatCurrencyClassSeparatorEn = ',';
var formatNumberBRL = 'BRL';
var formatNumberUSD = 'USD';
var formatNumberBRLCurrency = formatNumberBRL;
var formatNumberUSDCurrency = formatNumberUSD;
var formatNumberMinimumFractionDigits = 2;
var formatNumberMaximumFractionDigits = 2;
var BaSeI18nContext = React.createContext({
    locale: localePtBR,
    formats: {
        currency: {
            decimalSeparator: formatCurrencyDecimalSeparatorPtBR,
            classSeparator: formatCurrencyClassSeparatorPtBR,
            prefix: formatCurrencyPrefixPtBR,
        },
        numberCurrencyKey: formatNumberBRL,
        number: (_a$6 = {},
            _a$6[formatNumberBRL] = {
                style: 'decimal',
                currency: formatNumberBRLCurrency,
                minimumFractionDigits: formatNumberMinimumFractionDigits,
                maximumFractionDigits: formatNumberMaximumFractionDigits,
            },
            _a$6),
    },
    getMessage: function () { return ''; },
    changeLocale: function () { },
});
var initializedDateRegister = (_b = {},
    _b[localePtBR] = false,
    _b[localeEn] = false,
    _b);
var registerLocaleMap = (_c = {},
    _c[localePtBR] = pt_BR,
    _c[localeEn] = defaultLocale,
    _c);
var BaSeI18nProvider = function (_a) {
    var localeDefault = _a.locale, children = _a.children;
    var _b = React.useState(localeDefault), locale = _b[0], setLocale = _b[1];
    var currency = React.useMemo(function () { return ({
        decimalSeparator: locale === localePtBR
            ? formatCurrencyDecimalSeparatorPtBR
            : formatCurrencyDecimalSeparatorEn,
        classSeparator: locale === localePtBR
            ? formatCurrencyClassSeparatorPtBR
            : formatCurrencyClassSeparatorEn,
        prefix: locale === localePtBR
            ? formatCurrencyPrefixPtBR
            : formatCurrencyPrefixEn,
    }); }, [locale]);
    var numberCurrencyKey = React.useMemo(function () { return (locale === localePtBR ? formatNumberBRL : formatNumberUSD); }, [locale]);
    var number = React.useMemo(function () {
        var _a;
        return (_a = {},
            _a[numberCurrencyKey] = {
                style: 'decimal',
                currency: locale === localePtBR
                    ? formatNumberBRLCurrency
                    : formatNumberUSDCurrency,
                minimumFractionDigits: formatNumberMinimumFractionDigits,
                maximumFractionDigits: formatNumberMaximumFractionDigits,
            },
            _a);
    }, [locale, numberCurrencyKey]);
    var getMessage = React.useCallback(function (key) {
        var _a, _b;
        var replacements = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            replacements[_i - 1] = arguments[_i];
        }
        var message = (_b = (_a = messages === null || messages === void 0 ? void 0 : messages[key]) === null || _a === void 0 ? void 0 : _a[locale]) !== null && _b !== void 0 ? _b : key;
        if ((replacements === null || replacements === void 0 ? void 0 : replacements.length) > 0) {
            if (Array.isArray(replacements[0])) {
                replacements = replacements[0];
            }
            return (replacements.reduce(function (messageReplaced, term, index) {
                var regExp = new RegExp("\\{".concat(index, "\\}"), 'g');
                return (messageReplaced + '').replace(regExp, term + '');
            }, message) + '');
        }
        return message;
    }, [locale]);
    var registerDateLocale = React.useCallback(function (localeName) {
        if (!initializedDateRegister[localeName]) {
            registerLocale(localeName, registerLocaleMap[localeName]);
            initializedDateRegister[localeName] = true;
        }
    }, []);
    React.useEffect(function () { return setLocale(localeDefault); }, [localeDefault]);
    return (React.createElement(BaSeI18nContext.Provider, { value: {
            locale: locale,
            formats: { currency: currency, numberCurrencyKey: numberCurrencyKey, number: number },
            getMessage: getMessage,
            changeLocale: setLocale,
            registerDateLocale: registerDateLocale,
        } }, children));
};
var BaSeI18nConsumer = BaSeI18nContext.Consumer;

var Color = /** @class */ (function () {
    function Color(r, g, b, o) {
        if (o === void 0) { o = 1; }
        this.thresholdToLightenHover = 0.95;
        this.thresholdToLightenFocus = 0.75;
        this.thresholdToDarkenHover = 0.54;
        this.thresholdToDecreaseDarkValue = 0.12;
        this.r = 0;
        this.g = 0;
        this.b = 0;
        this.opacity = 1;
        this.set(r, g, b, o);
    }
    Color.generate = function (color) {
        color = color.replace(/\s/g, '');
        if (color.match(Color.hexColorRegExp)) {
            return Color.generateFromHex(color);
        }
        if (color.match(Color.rgbColorRegExp)) {
            return Color.generateFromCSSrgb(color);
        }
        if (color.match(Color.hslColorRegExp)) {
            return Color.generateFromHslString(color);
        }
        return null;
    };
    Color.generateFromCSSrgb = function (rgbValue) {
        rgbValue = rgbValue.replace(/\s/g, '');
        var rgb = rgbValue.split('(')[1].split(')')[0].split(',');
        if (rgb.length === 3 || rgb.length === 4) {
            var r = rgb[0], g = rgb[1], b = rgb[2], o = rgb[3];
            return new Color(parseInt(r, 10), parseInt(g, 10), parseInt(b, 10), parseFloat(o));
        }
        return null;
    };
    Color.generateFromHex = function (hexValue) {
        try {
            if (hexValue.length === 4) {
                hexValue = "#".concat(hexValue[1].repeat(2)).concat(hexValue[2].repeat(2)).concat(hexValue[3].repeat(2));
            }
            else if (hexValue.length === 5) {
                hexValue = "#".concat(hexValue[1].repeat(2)).concat(hexValue[2].repeat(2)).concat(hexValue[3].repeat(2)).concat(hexValue[4].repeat(2));
            }
            var r = parseInt(hexValue.substring(1, 3), 16);
            var g = parseInt(hexValue.substring(3, 5), 16);
            var b = parseInt(hexValue.substring(5, 7), 16);
            var o = parseInt(hexValue.substring(7, 9), 16);
            if (o) {
                return new Color(r, g, b, o / 255);
            }
            return new Color(r, g, b);
        }
        catch (_a) {
            return null;
        }
    };
    Color.generateFromHslString = function (hslValue) {
        try {
            hslValue = hslValue.split(' ').join('');
            var auxColor = new Color(0, 0, 0, 1);
            var _a = hslValue
                .split('(')[1]
                .split(')')[0]
                .split(',')
                .map(function (i) { return parseInt(i.replace('%', ''), 10); }), h = _a[0], s = _a[1], l = _a[2], opacity = _a[3];
            var _b = auxColor.HSVtoRGB(h / 360, s / 100, l / 100), r = _b.r, g = _b.g, b = _b.b;
            return new Color(r, g, b, opacity);
        }
        catch (_c) {
            return null;
        }
    };
    Color.generateMiddleColor = function (colorHex1, colorHex2) {
        var val1 = Color.generate(colorHex1);
        var val2 = Color.generate(colorHex2);
        var _a = val1 === null || val1 === void 0 ? void 0 : val1.hsl(), h1 = _a.h, s1 = _a.s, l1 = _a.l;
        var _b = val2 === null || val2 === void 0 ? void 0 : val2.hsl(), h2 = _b.h, s2 = _b.s, l2 = _b.l;
        var newH = (h1 + h2) / 200;
        var newS = (s1 + s2) / 200;
        var newL = (l1 + l2) / 200;
        var auxColor = new Color(0, 0, 0);
        var _c = auxColor.HSVtoRGB(newH, newS, newL), r = _c.r, g = _c.g, b = _c.b;
        return new Color(r, g, b);
    };
    Color.validateColor = function (color) {
        color = color.replace(/\s/g, '');
        return !!(color.match(Color.hexColorRegExp) ||
            color.match(Color.rgbColorRegExp) ||
            color.match(Color.hslColorRegExp));
    };
    Color.prototype.toString = function (type) {
        if (type === void 0) { type = 'rgb'; }
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        var p = this.opacity;
        if (type === 'rgb') {
            return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(p !== null && p !== void 0 ? p : 1, ")");
        }
        function toHex(color) {
            var hex = color.toString(16);
            if (hex.length === 1) {
                return "0".concat(hex);
            }
            return hex;
        }
        return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b)).concat(toHex(parseInt(Math.round(p * 255) + '', 10)));
    };
    Color.prototype.toStringWithOpacity = function (opacity, type) {
        if (opacity === void 0) { opacity = 1; }
        if (type === void 0) { type = 'rgb'; }
        if (opacity < 0 || opacity > 1) {
            throw Error('Informe um valor entre 0 e 1 para a opacidade. Exemplo: 0.5');
        }
        if (type === 'hex') {
            var opacityHex = parseInt((opacity * 255).toFixed(0), 10).toString(16);
            return "".concat(this.toString(type)).concat(opacityHex);
        }
        return this.toString(type).replace(')', ", ".concat(opacity, ")"));
    };
    Color.prototype.isGrayScale = function () {
        return this.r === this.b && this.b === this.g;
    };
    Color.prototype.set = function (r, g, b, o) {
        if (o === void 0) { o = 1; }
        this.r = this.clamp(r);
        this.g = this.clamp(g);
        this.b = this.clamp(b);
        this.opacity = this.clamp(o, 1);
    };
    Color.prototype.hueRotate = function (angle) {
        if (angle === void 0) { angle = 0; }
        angle = (angle / 180) * Math.PI;
        var sin = Math.sin(angle);
        var cos = Math.cos(angle);
        this.multiply([
            0.213 + cos * 0.787 - sin * 0.213,
            0.715 - cos * 0.715 - sin * 0.715,
            0.072 - cos * 0.072 + sin * 0.928,
            0.213 - cos * 0.213 + sin * 0.143,
            0.715 + cos * 0.285 + sin * 0.14,
            0.072 - cos * 0.072 - sin * 0.283,
            0.213 - cos * 0.213 - sin * 0.787,
            0.715 - cos * 0.715 + sin * 0.715,
            0.072 + cos * 0.928 + sin * 0.072,
        ]);
    };
    Color.prototype.grayscale = function (value) {
        if (value === void 0) { value = 1; }
        this.multiply([
            0.2126 + 0.7874 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 + 0.2848 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 + 0.9278 * (1 - value),
        ]);
    };
    Color.prototype.sepia = function (value) {
        if (value === void 0) { value = 1; }
        this.multiply([
            0.393 + 0.607 * (1 - value),
            0.769 - 0.769 * (1 - value),
            0.189 - 0.189 * (1 - value),
            0.349 - 0.349 * (1 - value),
            0.686 + 0.314 * (1 - value),
            0.168 - 0.168 * (1 - value),
            0.272 - 0.272 * (1 - value),
            0.534 - 0.534 * (1 - value),
            0.131 + 0.869 * (1 - value),
        ]);
    };
    Color.prototype.saturate = function (value) {
        if (value === void 0) { value = 1; }
        this.multiply([
            0.213 + 0.787 * value,
            0.715 - 0.715 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 + 0.285 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 - 0.715 * value,
            0.072 + 0.928 * value,
        ]);
    };
    Color.prototype.multiply = function (matrix) {
        var newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
        var newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
        var newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
        this.r = newR;
        this.g = newG;
        this.b = newB;
    };
    Color.prototype.brightness = function (value) {
        if (value === void 0) { value = 1; }
        this.linear(value);
    };
    Color.prototype.contrast = function (value) {
        if (value === void 0) { value = 1; }
        this.linear(value, -(0.5 * value) + 0.5);
    };
    Color.prototype.linear = function (slope, intercept) {
        if (slope === void 0) { slope = 1; }
        if (intercept === void 0) { intercept = 0; }
        this.r = this.clamp(this.r * slope + intercept * 255);
        this.g = this.clamp(this.g * slope + intercept * 255);
        this.b = this.clamp(this.b * slope + intercept * 255);
    };
    Color.prototype.invert = function (value) {
        if (value === void 0) { value = 1; }
        this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
        this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
        this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
    };
    Color.prototype.hsl = function () {
        // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
        var r = this.r / 255;
        var g = this.g / 255;
        var b = this.b / 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var h = (max + min) / 2;
        var s = (max + min) / 2;
        var l = (max + min) / 2;
        if (max === min) {
            h = s = 0;
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h * 100,
            s: s * 100,
            l: l * 100,
        };
    };
    Color.prototype.HSVtoRGB = function (h, s, l) {
        var r;
        var g;
        var b;
        if (s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var hue2rgb = function (pp, qq, t) {
                if (t < 0) {
                    t += 1;
                }
                if (t > 1) {
                    t -= 1;
                }
                if (t < 1 / 6) {
                    return pp + (qq - pp) * 6 * t;
                }
                if (t < 1 / 2) {
                    return qq;
                }
                if (t < 2 / 3) {
                    return pp + (qq - pp) * (2 / 3 - t) * 6;
                }
                return pp;
            };
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255),
        };
    };
    Color.prototype.applyLightColor = function (newValueL) {
        var _a = this.hsl(), h = _a.h, s = _a.s;
        h /= 100;
        s /= 100;
        var l = newValueL();
        var _b = this.HSVtoRGB(h, s, l), r = _b.r, g = _b.g, b = _b.b;
        return new Color(r, g, b);
    };
    Color.prototype.generateLighterColorToHover = function () {
        var _this = this;
        return this.applyLightColor(function () { return _this.thresholdToLightenHover; });
    };
    Color.prototype.generateLighterColorToFocus = function () {
        var _this = this;
        return this.applyLightColor(function () { return _this.thresholdToLightenFocus; });
    };
    Color.prototype.generateColorFromCurrentLight = function (tax) {
        var _a = this.hsl(), h = _a.h, s = _a.s, l = _a.l;
        h /= 100;
        s /= 100;
        l /= 100;
        l = l + tax;
        var _b = this.HSVtoRGB(h, s, l), r = _b.r, g = _b.g, b = _b.b;
        return new Color(r, g, b);
    };
    Color.prototype.generateDarkColor = function () {
        var _a = this.hsl(), h = _a.h, s = _a.s, l = _a.l;
        h /= 100;
        s /= 100;
        l /= 100;
        l = Math.min(this.thresholdToDarkenHover, Math.max(0, l > this.thresholdToDecreaseDarkValue
            ? l - this.thresholdToDecreaseDarkValue
            : l));
        var _b = this.HSVtoRGB(h, s, l), r = _b.r, g = _b.g, b = _b.b;
        return new Color(r, g, b);
    };
    Color.prototype.generateOpacityLightString = function () {
        return this.toStringWithOpacity(0.15);
    };
    Color.prototype.generateOpacityLightFocusString = function () {
        return this.toStringWithOpacity(0.5);
    };
    Color.prototype.clamp = function (value, limit) {
        if (limit === void 0) { limit = 255; }
        if (value > limit) {
            value = limit;
        }
        if (value < 0) {
            value = 0;
        }
        return value;
    };
    Color.hexColorRegExp = /^\#?([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$/;
    Color.rgbColorRegExp = /rgba{0,1}\(\d{1,3}\,\d{1,3}\,\d{1,3}?(\,?(\d{1}|(\d{0,1}\.\d{1,3}))){0,1}\)/g;
    Color.hslColorRegExp = /hsla{0,1}\(\d{1,3}\,\d{1,3}\%\,\d{1,3}\%()?(\,?(\d{1}|(\d{0,1}\.\d{1,3}))){0,1}\)/g;
    return Color;
}());

var lightLevelHover = 0.65;
var lightLevelFocus = 0.7;
var opacityLevelHover = 0.14;
var opacityLevelFocus = 0.83;
var getHSLValues = function (color) {
    if (!color) {
        return null;
    }
    if (typeof color === 'string') {
        var newColor = Color.generate(color);
        if (newColor) {
            return newColor.hsl();
        }
        return null;
    }
    return color === null || color === void 0 ? void 0 : color.hsl();
};
var getLValue = function (color) {
    var localColor = Color.generate(color);
    var hslColor = getHSLValues(localColor);
    return hslColor === null || hslColor === void 0 ? void 0 : hslColor.l;
};
var hueMapperHover = function (color) {
    if (!color) {
        return;
    }
    var _a = color.hsl(), h = _a.h, s = _a.s;
    h /= 100;
    s /= 100;
    var _b = color.HSVtoRGB(h, s, lightLevelHover), r = _b.r, g = _b.g, b = _b.b;
    return new Color(r, g, b).toStringWithOpacity(opacityLevelHover);
};
var hueMapperFocus = function (color) {
    if (!color) {
        return;
    }
    var _a = color.hsl(), h = _a.h, s = _a.s;
    h /= 100;
    s /= 100;
    var _b = color.HSVtoRGB(h, s, lightLevelFocus), r = _b.r, g = _b.g, b = _b.b;
    return new Color(r, g, b).toStringWithOpacity(opacityLevelFocus);
};
var createButtonHoverColor = function (color) {
    var baseColorObj = Color.generate(color);
    if (baseColorObj === null || baseColorObj === void 0 ? void 0 : baseColorObj.isGrayScale()) {
        return baseColorObj.toStringWithOpacity(0.14);
    }
    return hueMapperHover(baseColorObj);
};
var createButtonFocusColor = function (color) {
    var baseColorObj = Color.generate(color);
    if (baseColorObj === null || baseColorObj === void 0 ? void 0 : baseColorObj.isGrayScale()) {
        return baseColorObj.toStringWithOpacity(0.83);
    }
    return hueMapperFocus(baseColorObj);
};
var createButtonDarkTextColor = function (color) {
    var baseColorObj = Color.generate(color);
    if (!baseColorObj) {
        return;
    }
    var _a = baseColorObj.hsl(), h = _a.h, l = _a.l, s = _a.s;
    var newL = l / 100;
    var reduceValue = 0.1;
    newL = Math.max(0, newL - reduceValue);
    var _b = baseColorObj.HSVtoRGB(h / 100, s / 100, newL), r = _b.r, g = _b.g, b = _b.b;
    return new Color(r, g, b).toString();
};
var createColor = function (color, colorConfig) {
    if (!color) {
        return '#000';
    }
    if (!colorConfig) {
        return color;
    }
    try {
        var colorClass = Color.generate(color);
        if (!colorClass) {
            return '#000';
        }
        var _a = colorClass.hsl(), ccH = _a.h, ccS = _a.s, ccL = _a.l;
        var h = colorConfig.h, s = colorConfig.s, l = colorConfig.l, opacity = colorConfig.opacity;
        var _b = colorClass.HSVtoRGB(h !== null && h !== void 0 ? h : ccH / 100, s !== null && s !== void 0 ? s : ccS / 100, l !== null && l !== void 0 ? l : ccL / 100), r = _b.r, g = _b.g, b = _b.b;
        var newColorClass = new Color(r, g, b, opacity);
        return newColorClass.toString();
    }
    catch (e) {
        return '#000';
    }
};
var createColorSmartLightingControl = function (color, colorConfig, lightLevel) {
    var gapThreshold = 0.05;
    if (Color.validateColor(color) && colorConfig) {
        var colorClass = Color.generate(color);
        if (!colorClass) {
            return '#000';
        }
        var light = colorClass.hsl().l;
        var l = colorConfig.l;
        if (l && lightLevel) {
            if (lightLevel === 'darker' && light / 100 < l + gapThreshold) {
                return createColor(color, __assign(__assign({}, colorConfig), { l: light / 200 }));
            }
            if (lightLevel === 'lighter' && light / 100 > l - gapThreshold) {
                var newLight = light / 100;
                return createColor(color, __assign(__assign({}, colorConfig), { l: newLight + (1 - newLight) / 2 }));
            }
            return createColor(color, colorConfig);
        }
    }
    return createColor(color, colorConfig);
};

var inst$1 = BaSeTheme.colors.institucionais;
var feed$1 = BaSeTheme.colors.feedbackInterface;
var reduceLevel$1 = function (level) {
    if (level > 1 && level <= 100) {
        level /= 100;
    }
    return level;
};
var memo = {};
var ColorMapper = {
    default: {
        foreground: inst$1.azulSebrae36,
        hover: {
            defaultDark: inst$1.azulSebrae30,
            defaultLight: inst$1.azulSebrae97,
            transparentLight: createColor(inst$1.azulSebrae97, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: inst$1.azulSebrae75,
            transparentLight: createColor(inst$1.azulSebrae75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: inst$1.azulSebrae60,
        getColorByNumber: function (level) {
            return createColor(inst$1.azulSebrae36, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(inst$1.azulSebrae36, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    grayScale: {
        foreground: inst$1.cinzaSebrae45,
        hover: {
            defaultDark: inst$1.cinzaSebrae30,
            defaultLight: inst$1.cinzaSebrae97,
        },
        focus: {
            defaultLight: inst$1.cinzaSebrae75,
            transparentLight: '#A8B3BDD4',
        },
        getColorByNumber: function (level) {
            return createColor(inst$1.cinzaSebrae45, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(inst$1.cinzaSebrae45, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    confirmation: {
        foreground: feed$1.sucesso26,
        hover: {
            defaultDark: feed$1.sucesso20,
            defaultLight: feed$1.sucesso95,
            transparentLight: createColor(feed$1.sucesso95, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: feed$1.sucesso75,
            transparentLight: createColor(feed$1.sucesso75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: createColor(feed$1.sucesso26, { l: 0.6 }),
        getColorByNumber: function (level) {
            return createColor(feed$1.sucesso26, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(feed$1.sucesso26, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    destructive: {
        foreground: feed$1.erro45,
        hover: {
            defaultDark: feed$1.erro35,
            defaultLight: feed$1.erro95,
            transparentLight: createColor(feed$1.erro95, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: feed$1.erro75,
            transparentLight: createColor(feed$1.erro75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: createColor(feed$1.erro45, { l: 0.6 }),
        getColorByNumber: function (level) {
            return createColor(feed$1.erro45, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(feed$1.erro45, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    attention: {
        foreground: feed$1.atencao55,
        hover: {
            defaultDark: feed$1.atencao35,
            defaultLight: feed$1.atencao95,
            transparentLight: createColor(feed$1.atencao95, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: feed$1.atencao75,
            transparentLight: createColor(feed$1.atencao75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: createColor(feed$1.atencao55, { l: 0.6 }),
        getColorByNumber: function (level) {
            return createColor(feed$1.atencao55, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(feed$1.atencao55, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    disabled: {
        foreground: inst$1.cinzaSebrae75,
        background: inst$1.cinzaSebrae90,
        lighterBackground: inst$1.cinzaSebrae97,
        bold: inst$1.cinzaSebrae30,
        getColorByNumber: function (level) {
            return createColor(inst$1.cinzaSebrae75, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(inst$1.cinzaSebrae75, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    light: {
        focus: {
            create: function (color) {
                return createColorSmartLightingControl(color, { l: 0.75 }, 'lighter');
            },
            createTransparent: function (color) {
                return createColorSmartLightingControl(color, { l: 0.7, opacity: 0.83 }, 'lighter');
            },
        },
        hover: {
            create: function (color) {
                return createColorSmartLightingControl(color, { l: 0.95 }, 'lighter');
            },
            createTransparent: function (color) {
                return createColorSmartLightingControl(color, { l: 0.6, opacity: 0.14 }, 'lighter');
            },
        },
    },
    dark: {
        hover: {
            create: function (color) {
                return createColorSmartLightingControl(color, { l: 0.3 }, 'darker');
            },
        },
    },
    create: function (color, lightLevel) {
        if (lightLevel > 1 && lightLevel <= 100) {
            lightLevel /= 100;
        }
        return createColor(color, { l: lightLevel });
    },
    createTransparent: function (color, lightLevel, opacity) {
        if (lightLevel > 1 && lightLevel <= 100) {
            lightLevel /= 100;
        }
        if (opacity > 1 && opacity <= 100) {
            opacity /= 100;
        }
        return createColor(color, { l: lightLevel, opacity: opacity });
    },
    createMostUsedColors: function (color) {
        if (memo[color]) {
            return memo[color];
        }
        var darkHoverColor = createColorSmartLightingControl(color, { l: 0.3 }, 'darker');
        var lightHoverColor = createColorSmartLightingControl(color, { l: 0.95, opacity: 0.1 }, 'lighter');
        var lightFocusColor = createColorSmartLightingControl(color, { l: 0.75 }, 'lighter');
        var lightHoverColorTransparent = createColorSmartLightingControl(color, { l: 0.6, opacity: 0.14 }, 'lighter');
        var lightFocusColorTransparent = createColorSmartLightingControl(color, { l: 0.7, opacity: 0.83 }, 'lighter');
        memo[color] = {
            darkHoverColor: darkHoverColor,
            lightFocusColor: lightFocusColor,
            lightHoverColor: lightHoverColor,
            lightFocusColorTransparent: lightFocusColorTransparent,
            lightHoverColorTransparent: lightHoverColorTransparent,
        };
        return memo[color];
    },
    typography: {
        default: inst$1.cinzaSebrae,
        strong: inst$1.cinzaSebrae30,
        soft: inst$1.cinzaSebrae45,
        unselected: inst$1.cinzaSebrae60,
        selected: inst$1.cinzaSebrae20,
    },
    isValidType: function (color) {
        return color === 'default' ||
            color === 'confirmation' ||
            color === 'attention' ||
            color === 'destructive';
    },
    isValidColor: function (color) { return Color.validateColor(color); },
    getColor: function (color, defaultReturn) {
        var _a;
        var stringReturn = defaultReturn !== null && defaultReturn !== void 0 ? defaultReturn : '';
        if (!color) {
            return stringReturn;
        }
        if (Color.validateColor(color)) {
            return color;
        }
        if (ColorMapper.isValidType(color)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return (_a = ColorMapper[color]) === null || _a === void 0 ? void 0 : _a.foreground;
        }
        return stringReturn;
    },
};

var objectNotEmpty = function (obj) { return !!obj && !!Object.keys(obj).length; };

function useCoordinatesFromBuddyAndDirectionToAlert(buddyRef, direction, coordinates) {
    var getCoordinates = React.useCallback(function () {
        var _a, _b;
        if (!(buddyRef === null || buddyRef === void 0 ? void 0 : buddyRef.current)) {
            return coordinates !== null && coordinates !== void 0 ? coordinates : {};
        }
        var rect = (_b = (_a = buddyRef === null || buddyRef === void 0 ? void 0 : buddyRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!rect) {
            throw Error('[useCoordinatesFromBuddyAndDirectionToAlert]: Não foi possível recuperar as informações de tamanho e posição do "buddyRef"');
        }
        if (!direction || direction === 'neutral') {
            throw Error("[useCoordinatesFromBuddyAndDirectionToAlert]: Caso tenha \"buddyRef\",\n        informe uma dire\u00E7\u00E3o aqui com a prop \"direction\" entre:\n          - top;\n          - left;\n          - right; ou\n          - bottom.");
        }
        var triangleHeight = 8;
        var unset = 'unset';
        var height = rect.height + '';
        var heightPlusTriangleHeight = "".concat(rect.height + triangleHeight, "px");
        var widthPlusTriangleHeight = "".concat(rect.width + triangleHeight, "px");
        var coords = {
            top: {
                top: unset,
                bottom: heightPlusTriangleHeight,
                left: unset,
                right: unset,
            },
            bottom: {
                top: heightPlusTriangleHeight,
                bottom: unset,
                left: unset,
                right: unset,
            },
            left: {
                top: height,
                bottom: height,
                left: unset,
                right: widthPlusTriangleHeight,
            },
            right: {
                top: height,
                bottom: height,
                left: widthPlusTriangleHeight,
                right: unset,
            },
        };
        return __assign(__assign({}, coords[direction]), coordinates);
    }, [buddyRef === null || buddyRef === void 0 ? void 0 : buddyRef.current, coordinates, direction]);
    return React.useMemo(function () { return getCoordinates(); }, [getCoordinates]);
}

function useDebounce(state, delay) {
    var _a = React.useState(state), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(state);
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [state, delay]);
    return debouncedValue;
}

var cache$2 = {};
var transformLightness = function (color, lightness) {
    var cacheKey = "".concat(color, "_").concat(lightness);
    try {
        if (cache$2.hasOwnProperty(cacheKey)) {
            return cache$2[cacheKey];
        }
        var colorInstance = Color.generate(color);
        var newColor = colorInstance.applyLightColor(function () { return lightness; }).toString();
        cache$2[cacheKey] = newColor;
        return newColor;
    }
    catch (error) {
        return color;
    }
};

function _forceString(text, trimmed) {
    if (text === void 0) { text = ''; }
    if (trimmed === void 0) { trimmed = true; }
    if (typeof text !== 'string') {
        text = '';
    }
    return trimmed ? text === null || text === void 0 ? void 0 : text.trim() : text;
}
/**
 * Limpa a(s) barra(s) no final da URL informada
 *
 * @param url
 */
function urlSanitizer(url) {
    return _forceString(url).replace(/\/$/, '');
}
/**
 * Atalho para `encodeURIComponent()`
 * @param url Algo que precisa de ser codificado
 */
function urlEncode(url, simpleEncode) {
    if (simpleEncode === void 0) { simpleEncode = false; }
    var encode = function (term) {
        var _url = new URL('https://fake.url');
        _url.searchParams.set('key', term);
        return _url.search.replace('?key=', '');
    };
    return simpleEncode ? encodeURIComponent(url) : encode(url);
}
/**
 * Atalho para `decodeURIComponent()`
 * @param url Algo que precisa de ser decodificado
 */
function urlDecode(url, simpleDecode) {
    if (simpleDecode === void 0) { simpleDecode = false; }
    var decode = function (term) {
        var _a;
        return (_a = new URL("https://fake.url?key=".concat(term)).searchParams.get('key')) !== null && _a !== void 0 ? _a : decodeURIComponent(term);
    };
    return simpleDecode ? decodeURIComponent(url) : decode(url);
}
/**
 * Atalho para codificar em base64 usando UTF-8
 * @param str Texto a ser codificado
 */
function base64Encode(str) {
    return btoa(urlEncode(str).replace(/%([0-9A-F]{2})/g, function (_, char) {
        return String.fromCharCode(parseInt('0x' + char, 16));
    }));
}
/**
 * Atalho para decodificar um texto em UTF-8 na codificação base64
 * @param base64 Texto a ser decodificado
 */
function base64Decode(base64) {
    return urlDecode(atob(base64)
        .split('')
        .map(function (char) { return '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2); })
        .join(''));
}
/**
 * Atalho para decodificar um texto em UTF-8 na codificação base64
 * Retornando um TypedArray: Uint8Array
 * @param base64 Texto a ser decodificado
 */
function base64DecodeToTypedArray(base64) {
    var binaryString = base64Decode(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}
/**
 * Atalho para decodificar um texto em UTF-8 na codificação base64
 * Retornando um Blob
 * @param base64 Texto a ser decodificado
 * @param contentType Mime type do Blob
 */
function base64DecodeToBlob(base64, contentType) {
    contentType = contentType || 'application/octet-stream';
    return new Blob([base64DecodeToTypedArray(base64)], { type: contentType });
}
/**
 * Atalho para para converter uma string em objeto Blob
 * Retornando um Blob
 * @param str Texto a ser decodificado
 * @param contentType Mime type do Blob
 */
function stringToBlob(str, contentType) {
    if (contentType === void 0) { contentType = 'application/octet-stream'; }
    return new Blob([stringToTypedArray(str)], { type: contentType });
}
/**
 * Atalho para decodificar um texto em TypedArray
 * Retornando um TypedArray: Uint8Array
 * @param str Texto a ser decodificado
 */
function stringToTypedArray(str) {
    var binaryLen = str.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        bytes[i] = str.charCodeAt(i);
    }
    return bytes;
}
/**
 * Verifica se o valor passado contém um número válido
 * Retornando um boolean
 * @param value Valor a ser validado como númerico
 */
function isNumeric(value) {
    return !isNaN(Number(value));
}
/*
 * Remove todas as tags de um HTML informado
 * Retornando o texto sem as tags
 * @param html
 */
function stripHtmlTags(html) {
    if (html === void 0) { html = ''; }
    return _forceString(html, false).replace(/<[^>]*>/g, '');
}
/**
 * Normaliza o texto informado para minúsculo e sem acentuações
 * @param text
 */
function normalize(text) {
    if (text === void 0) { text = ''; }
    text = _forceString(text);
    if (!text) {
        return '';
    }
    var normalized = String(text).toLowerCase().trim();
    var map = {
        a: '[àáâãäå]',
        e: '[èéêë]',
        i: '[ìíîï]',
        o: '[òóôõö]',
        u: '[ùúûűü]',
        y: '[ýÿ]',
        c: 'ç',
        n: 'ñ',
        '-': '–',
        ' ': '\\s+',
    };
    var i;
    for (i in map) {
        if (map.hasOwnProperty(i)) {
            normalized = normalized.replace(new RegExp(map[i], 'img'), i);
        }
    }
    normalized = normalized.replace(/\s+/g, ' ');
    return normalized;
}
/**
 * Aplica a abreviação retornando a sigla do nome de acordo com o 1º e o ultimo nome
 * @param name Nome a ser abreviado
 */
function nameAbbreviation(name) {
    var _a, _b, _c, _d, _e, _f;
    if (name === void 0) { name = ''; }
    name = _forceString(name);
    var filterRegex = /^D[AEO]$/g;
    var nameSplitted = ((_b = (_a = name === null || name === void 0 ? void 0 : name.toUpperCase()) === null || _a === void 0 ? void 0 : _a.split(' ')) !== null && _b !== void 0 ? _b : [])
        .map(function (term) { return term.trim(); })
        .filter(function (term) { return !filterRegex.test(term); });
    var firstIndex = 0;
    var lastIndex = nameSplitted.length - 1;
    var firstName = nameSplitted[firstIndex];
    var lastName = firstIndex < lastIndex ? nameSplitted[lastIndex] : '';
    var first = (_d = (_c = Array.from(firstName)) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '';
    var last = (_f = (_e = Array.from(lastName)) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : '';
    return "".concat(first).concat(last);
}
/**
 * Retorna a primeira letra maiuscula do texto informado
 * @param text Texto a ser modificado
 */
function firstLetterUpperCase(text) {
    var _a;
    if (text === void 0) { text = ''; }
    text = _forceString(text);
    var firstLetter = (_a = text === null || text === void 0 ? void 0 : text.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var othersLetters = text === null || text === void 0 ? void 0 : text.substr(1);
    return firstLetter + othersLetters;
}
/**
 * Retorna o valor com a unidade
 * @param value Valor com a unidade ou só o número para concatenar com a unidade padrão. Caso passado undefined retorna "0"
 * @param unit Unidade de retono caso passado um número no value. Unidade padrão "px"
 */
function numberWithUnit(value, unit, empty) {
    if (unit === void 0) { unit = 'px'; }
    if (empty === void 0) { empty = 'initial'; }
    if (!value) {
        return empty;
    }
    return isNumeric(value) ? "".concat(value).concat(unit) : "".concat(value);
}
/**
 * Converte o input em camelCase. Exemplo passando 'um-dois-tres' vai retornar umDoisTres
 * @param input Valor de entrada
 * @param separator Separador das palavras. Padrão: "-"
 * @returns A string no padrão camelCase
 */
function camelCase(input, separator) {
    if (separator === void 0) { separator = '-'; }
    var regExp = new RegExp("\\".concat(separator.toLowerCase(), "(.)"), 'g');
    return input
        .toLowerCase()
        .replace(regExp, function (_, letter) { var _a; return (_a = letter === null || letter === void 0 ? void 0 : letter.toUpperCase) === null || _a === void 0 ? void 0 : _a.call(letter); });
}
/**
 * Converte o input em kebabCase. Exemplo passando 'Um dois tres' vai retornar um-dois-tres
 * @param input Valor de entrada
 * @returns A string no padrão kebab-case
 */
var toKebabCase = function (input) {
    return input
        .replace(/\s{1,}/, '-')
        .replace(/[A-Z]/g, function (letter, index) {
        return index === 0 ? letter.toLowerCase() : '-' + letter.toLowerCase();
    })
        .replace(/-{2,}/, '-');
};
/**
 * Inverte o texto
 * @param input Texto a ser invertido
 * @returns Texto invertido
 */
function reverse(input) {
    return input.split('').reverse().join('');
}
/**
 * Converte a lista informada no texto juntado
 * @param list Lista com os textos que vão ser juntados
 * @param separator Separador
 * @param finalSeparator Separador final (caso omitido usa o valor do `separator`)
 * @returns O texto juntado com os devidos separadores
 */
function joinWithSeparators(list, separator, finalSeparator) {
    var _a;
    var escape = function (str) { var _a; return (_a = str === null || str === void 0 ? void 0 : str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')) !== null && _a !== void 0 ? _a : ''; };
    var reverseSeparator = reverse(separator !== null && separator !== void 0 ? separator : ', ');
    var reverseFinalSeparator = reverse((_a = finalSeparator !== null && finalSeparator !== void 0 ? finalSeparator : separator) !== null && _a !== void 0 ? _a : ' e ');
    var regExp = new RegExp("".concat(escape(reverseSeparator), "(.*$)"));
    var reverseText = list
        .map(reverse)
        .reverse()
        .join(reverseSeparator)
        .replace(regExp, "".concat(reverseFinalSeparator, "$1"));
    return reverse(reverseText);
}
/**
 * Retorna o texto sem os acentos
 * @param text Texto a ter os acentos removidos
 */
function removeAccents(text) {
    if (text === void 0) { text = ''; }
    text = _forceString(text);
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Formata dataset no padrão kebab-case
 * @param dataset O dataset em camelCase
 * @returns Um mapa de data DOMString em kebab-case
 */
var getFormattedDataset = function (dataset) {
    if (dataset === null ||
        dataset === undefined ||
        Object.keys(dataset).length === 0) {
        return undefined;
    }
    return Object.entries(dataset).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc["data-".concat(toKebabCase(key))] = value;
        return acc;
    }, {});
};

var Solver = /** @class */ (function () {
    function Solver(target) {
        this.target = target;
        this.targetHSL = target.hsl();
        this.reusedColor = new Color(0, 0, 0); // Object pool
    }
    Solver.prototype.solve = function () {
        var result = this.solveNarrow(this.solveWide());
        return {
            values: result.values,
            loss: result.loss,
            filter: this.css({ values: result.values }),
        };
    };
    Solver.prototype.solveWide = function () {
        var A = 5;
        var c = 15;
        var a = [60, 180, 18000, 600, 1.2, 1.2];
        var best = { loss: Infinity };
        for (var i = 0; best.loss > 25 && i < 3; i++) {
            var initial = [50, 20, 3750, 50, 100, 100];
            var result = this.spsa(A, a, c, 1000, initial);
            if (result.loss < best.loss) {
                best = result;
            }
        }
        return best;
    };
    Solver.prototype.solveNarrow = function (wide) {
        var A = wide.loss;
        var c = 2;
        var A1 = A + 1;
        var a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
        return this.spsa(A, a, c, 500, wide.values);
    };
    Solver.prototype.spsa = function (A, a, c, iters, values) {
        if (values === void 0) { values = []; }
        var alpha = 1;
        var gamma = 0.16666666666666666;
        var best = undefined;
        var bestLoss = Infinity;
        var deltas = new Array(6);
        var highArgs = new Array(6);
        var lowArgs = new Array(6);
        for (var k = 0; k < iters; k++) {
            var ck = c / Math.pow(k + 1, gamma);
            for (var i = 0; i < 6; i++) {
                deltas[i] = Math.random() > 0.5 ? 1 : -1;
                highArgs[i] = values[i] + ck * deltas[i];
                lowArgs[i] = values[i] - ck * deltas[i];
            }
            var lossDiff = this.loss(highArgs) - this.loss(lowArgs);
            for (var i = 0; i < 6; i++) {
                var g = (lossDiff / (2 * ck)) * deltas[i];
                var ak = a[i] / Math.pow(A + k + 1, alpha);
                values[i] = fix(values[i] - ak * g, i);
            }
            var loss = this.loss(values);
            if (loss < bestLoss) {
                best = values.slice(0);
                bestLoss = loss;
            }
        }
        return { values: best, loss: bestLoss };
        function fix(value, idx) {
            var max = 100;
            if (idx === 2 /* saturate */) {
                max = 7500;
            }
            if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
                max = 200;
            }
            if (idx === 3 /* hue-rotate */) {
                if (value > max) {
                    value = value % max;
                }
                if (value < 0) {
                    value = max + (value % max);
                }
            }
            else {
                if (value < 0) {
                    value = 0;
                }
                if (value > max) {
                    value = max;
                }
            }
            return value;
        }
    };
    Solver.prototype.loss = function (filters) {
        // Argument is array of percentages.
        var color = this.reusedColor;
        color.set(0, 0, 0);
        color.invert(filters[0] / 100);
        color.sepia(filters[1] / 100);
        color.saturate(filters[2] / 100);
        color.hueRotate(filters[3] * 3.6);
        color.brightness(filters[4] / 100);
        color.contrast(filters[5] / 100);
        var colorHSL = color.hsl();
        return (Math.abs(color.r - this.target.r) +
            Math.abs(color.g - this.target.g) +
            Math.abs(color.b - this.target.b) +
            Math.abs(colorHSL.h - this.targetHSL.h) +
            Math.abs(colorHSL.s - this.targetHSL.s) +
            Math.abs(colorHSL.l - this.targetHSL.l));
    };
    Solver.prototype.css = function (_a) {
        var values = _a.values;
        function fmt(idx, multiplier) {
            if (multiplier === void 0) { multiplier = 1; }
            return values ? Math.round(values[idx] * multiplier) : 0;
        }
        return "invert(".concat(fmt(0), "%) sepia(").concat(fmt(1), "%) saturate(").concat(fmt(2), "%) hue-rotate(").concat(fmt(3, 3.6), "deg) brightness(").concat(fmt(4), "%) contrast(").concat(fmt(5), "%);");
    };
    return Solver;
}());

var cache$1 = {};
var transformToFilter = function (color) {
    try {
        if (cache$1.hasOwnProperty(color)) {
            return cache$1[color];
        }
        var colorInstance = Color.generate(color);
        var filter = new Solver(colorInstance).solve().filter;
        if (filter) {
            cache$1[color] = filter;
            return filter;
        }
    }
    catch (_a) { }
    return 'none';
};

var StaticAssetStyled = styled.img(templateObject_3$V || (templateObject_3$V = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  filter: ", ";\n  opacity: ", ";\n  transition: opacity ", ";\n\n  ", "\n\n  &::selection {\n    background: transparent;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  filter: ", ";\n  opacity: ", ";\n  transition: opacity ", ";\n\n  ", "\n\n  &::selection {\n    background: transparent;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var filter = _a.filter;
    return filter;
}, function (_a) {
    var src = _a.src;
    return (src ? 1 : 0);
}, "\n    ".concat(BaSeTheme.transitions.durationFast, "\n    ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n  "), function (_a) {
    var colorTransition = _a.colorTransition;
    return colorTransition && css(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject(["\n      transition:\n        opacity ", ",\n        filter ", ";\n    "], ["\n      transition:\n        opacity ", ",\n        filter ", ";\n    "])), "\n        ".concat(BaSeTheme.transitions["duration".concat(firstLetterUpperCase(colorTransition))], "\n        ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n      "), "\n        ".concat(BaSeTheme.transitions["duration".concat(firstLetterUpperCase(colorTransition))], "\n        ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n      "));
}, function (_a) {
    var onClick = _a.onClick;
    return onClick && css(templateObject_2$12 || (templateObject_2$12 = __makeTemplateObject(["\n      cursor: pointer;\n      // TODO ver qual vai ser o efeito de focus e hover\n      // &:focus {\n      //   ...\n      // }\n      // &:hover {\n      //   ...\n      // }\n    "], ["\n      cursor: pointer;\n      // TODO ver qual vai ser o efeito de focus e hover\n      // &:focus {\n      //   ...\n      // }\n      // &:hover {\n      //   ...\n      // }\n    "])));
});
var templateObject_1$1f, templateObject_2$12, templateObject_3$V;

function getSrc(path) {
    if (!path) {
        return '';
    }
    return "".concat(urlSanitizer(BaSeConfig.staticAssetsUrl), "/").concat(path);
}
var BaSeStaticAsset = React.memo(function (_a) {
    var path = _a.path, description = _a.description, width = _a.width, height = _a.height, color = _a.color, colorTransition = _a.colorTransition, classIdentifier = _a.classIdentifier, onClick = _a.onClick;
    if (!description) {
        throw Error('[BaSeStaticAsset] Informe a descrição da imagem. Atributo "description"');
    }
    var fallbackImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    var _b = React.useState(typeof path === 'string' ? [path] : path), paths = _b[0], setPaths = _b[1];
    var _c = React.useState(paths[0]), pathToApply = _c[0], setPathToApply = _c[1];
    var _d = React.useState(), src = _d[0], setSrc = _d[1];
    var filter = React.useMemo(function () { return (!!color ? transformToFilter(color) : 'none'); }, [color]);
    React.useEffect(function () { return setPaths(typeof path === 'string' ? [path] : path); }, [path]);
    React.useEffect(function () { return setPathToApply(paths[0]); }, [paths]);
    React.useEffect(function () { return setSrc(getSrc(pathToApply)); }, [pathToApply]);
    return (React.createElement(StaticAssetStyled, { decoding: "async", loading: "lazy", className: classIdentifier, src: src, alt: description, width: width, height: height, filter: filter, colorTransition: colorTransition, onError: function () {
            return paths.length === 0
                ? setSrc(fallbackImage)
                : setPaths(function (actualPaths) {
                    return actualPaths.filter(function (_, index) { return index > 0; });
                });
        }, onClick: onClick, onKeyDown: function (e) { return e.key === 'Enter' && (onClick === null || onClick === void 0 ? void 0 : onClick(e)); }, tabIndex: onClick ? 0 : -1, role: onClick ? 'button' : undefined }));
});
BaSeStaticAsset.displayName = 'BaSeStaticAsset';

function extractWidthHeight(size, width, height) {
    width = numberWithUnit(size !== null && size !== void 0 ? size : width);
    height = numberWithUnit(size !== null && size !== void 0 ? size : height);
    return {
        width: width,
        height: height,
    };
}

var BaSeIcon = function (_a) {
    var name = _a.name, description = _a.description, size = _a.size, color = _a.color, colorTransition = _a.colorTransition, onClick = _a.onClick;
    return (React.createElement(BaSeStaticAsset, __assign({}, extractWidthHeight(size), { classIdentifier: "BaSe--icon", description: description, path: "images/icons/".concat(name, ".svg"), color: color, colorTransition: colorTransition, onClick: onClick })));
};
BaSeIcon.displayName = 'BaSeIcon';

var spinnerMap = {
    // TODO verificar cores se estão mapeadas
    primary: {
        darkColor: '#8FB8EF',
        mediumColor: Color.generateMiddleColor('#8FB8EF', '#e0edfb').toString(),
        lightColor: '#e0edfb',
        negative: {
            darkColor: '#005eb8',
            mediumColor: Color.generateMiddleColor('#005eb8', '#f0f3f6').toString(),
            lightColor: '#f0f3f6',
        },
    },
    secondary: {
        darkColor: '#394D60',
        mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
        lightColor: '#e0e5eb',
        negative: {
            darkColor: '#394D60',
            mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
            lightColor: '#e0e5eb',
        },
    },
    tertiary: {
        darkColor: '#005eb8',
        mediumColor: Color.generateMiddleColor('#005eb8', '#f0f3f6').toString(),
        lightColor: '#f0f3f6',
        negative: {
            darkColor: '#394D60',
            mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
            lightColor: '#e0e5eb',
        },
    },
    disabled: {
        darkColor: '#394D60',
        mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
        lightColor: '#e0e5eb',
    },
};
var spinnerCustomMap = function (color, primary) {
    var _a, _b, _c;
    return ({
        darkColor: (_a = Color.generate(color !== null && color !== void 0 ? color : BaSeTheme.colors.institucionais.azulSebrae)) === null || _a === void 0 ? void 0 : _a.generateColorFromCurrentLight(primary ? 0.1 : 0).toString(),
        mediumColor: (_b = Color.generate(color !== null && color !== void 0 ? color : BaSeTheme.colors.institucionais.azulSebrae)) === null || _b === void 0 ? void 0 : _b.applyLightColor(function () { return 0.85; }).toString(),
        lightColor: (_c = Color.generate(color !== null && color !== void 0 ? color : BaSeTheme.colors.institucionais.azulSebrae)) === null || _c === void 0 ? void 0 : _c.applyLightColor(function () { return 0.99; }).toString(),
    });
};
var mappedSingleColors = {
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};

var loadingRotatation = keyframes(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n  to {\n    transform: rotate(2turn);\n  }\n"], ["\n  to {\n    transform: rotate(2turn);\n  }\n"])));
var loadingSize = keyframes(templateObject_2$11 || (templateObject_2$11 = __makeTemplateObject(["\n  from, 60% {\n    stroke-dasharray: 100% 180%;\n  }\n"], ["\n  from, 60% {\n    stroke-dasharray: 100% 180%;\n  }\n"])));
var GenericAnimated = styled.span(templateObject_3$U || (templateObject_3$U = __makeTemplateObject(["\n  stroke: ", ";\n  stroke-linecap: round;\n  stroke-dasharray: 180% 100%;\n  animation:\n    ", " 3s cubic-bezier(0.5, -0.4, 0.5, 1.4) infinite,\n    ", " 1.5s cubic-bezier(0.5, -0.8, 0.5, 1.8) infinite alternate;\n"], ["\n  stroke: ", ";\n  stroke-linecap: round;\n  stroke-dasharray: 180% 100%;\n  animation:\n    ", " 3s cubic-bezier(0.5, -0.4, 0.5, 1.4) infinite,\n    ", " 1.5s cubic-bezier(0.5, -0.8, 0.5, 1.8) infinite alternate;\n"])), BaSeTheme.colors.defaultColors.white, loadingRotatation, loadingSize);
var UseSpinnerAnimated = function (props) { return React.createElement(GenericAnimated, __assign({ as: "use" }, props)); };
var GenericGradient = styled.span(templateObject_5$D || (templateObject_5$D = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var uuid = _a.uuid, index = _a.index, rotation = _a.rotation;
    return css(templateObject_4$M || (templateObject_4$M = __makeTemplateObject(["\n    transform: rotate(", ");\n    mask: url('#base-loading-spinner-", "-mask');\n    stroke: url('#base-loading-spinner-", "-gradient-", "');\n  "], ["\n    transform: rotate(", ");\n    mask: url('#base-loading-spinner-", "-mask');\n    stroke: url('#base-loading-spinner-", "-gradient-", "');\n  "])), rotation, uuid, uuid, index);
});
var GeometrySpinnerGradient = function (_a) {
    var children = _a.children, index = _a.index, uuid = _a.uuid, rotation = _a.rotation;
    return (React.createElement(GenericGradient, { as: "g", index: index, uuid: uuid, rotation: rotation }, children));
};
var SvgSpinner = styled.svg(templateObject_7$v || (templateObject_7$v = __makeTemplateObject(["\n  ", "\n  fill: none;\n  stroke: transparent;\n  stroke-width: 12%;\n  background: transparent;\n  transform: rotate(110deg);\n"], ["\n  ", "\n  fill: none;\n  stroke: transparent;\n  stroke-width: 12%;\n  background: transparent;\n  transform: rotate(110deg);\n"])), function (_a) {
    var diameter = _a.diameter;
    return css(templateObject_6$B || (templateObject_6$B = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n  "], ["\n    width: ", "px;\n    height: ", "px;\n  "])), diameter, diameter);
});
var LoadingContainer = styled.div.attrs({
    className: 'BaSe--loading',
})(templateObject_9$q || (templateObject_9$q = __makeTemplateObject(["\n  &.BaSe--loading {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    place-items: center;\n    padding: 32px;\n    box-sizing: border-box;\n    ", "\n  }\n"], ["\n  &.BaSe--loading {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    place-items: center;\n    padding: 32px;\n    box-sizing: border-box;\n    ", "\n  }\n"])), function (_a) {
    var roundedCorner = _a.roundedCorner, shadow = _a.shadow, backgroundColor = _a.backgroundColor;
    return css(templateObject_8$t || (templateObject_8$t = __makeTemplateObject(["\n      border-radius: ", "px;\n      box-shadow: ", ";\n      background-color: ", ";\n    "], ["\n      border-radius: ", "px;\n      box-shadow: ", ";\n      background-color: ", ";\n    "])), roundedCorner ? 12 : 0, shadow !== null && shadow !== void 0 ? shadow : 'none', backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : BaSeTheme.colors.defaultColors.transparent);
});
var LoadingItems = styled.div(templateObject_10$o || (templateObject_10$o = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n"])));
var templateObject_1$1e, templateObject_2$11, templateObject_3$U, templateObject_4$M, templateObject_5$D, templateObject_6$B, templateObject_7$v, templateObject_8$t, templateObject_9$q, templateObject_10$o;

var validateType = function (type) {
    if (type === 'primary' || type === 'secondary' || type === 'tertiary') {
        return type;
    }
    return 'primary';
};
var idSequence$e = idGenerator();
var BaSeLoadingSpinner = function (_a) {
    var _b = _a.diameter, diameter = _b === void 0 ? 64 : _b, _c = _a.description, description = _c === void 0 ? 'Carregando… Aguarde.' : _c, color = _a.color, _d = _a.type, type = _d === void 0 ? 'tertiary' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var uuid = useNextHashId(idSequence$e);
    // TODO refatorar operadores ternarios para algo mais simples
    var mappedColorValues = disabled
        ? spinnerMap.disabled
        : color === 'negative'
            ? spinnerMap[validateType(type)].negative
            : !color || color === 'default'
                ? spinnerMap[validateType(type)]
                : color in mappedSingleColors
                    ? spinnerCustomMap(mappedSingleColors[color], type === 'primary')
                    : spinnerCustomMap(color, type === 'primary');
    var darkColor = mappedColorValues.darkColor, lightColor = mappedColorValues.lightColor, mediumColor = mappedColorValues.mediumColor;
    var halfDiameter = (diameter / 2).toFixed(1);
    var quarterDiameter = (diameter / 4).toFixed(1);
    return (React.createElement(SvgSpinner, { role: "img", className: "BaSe--loading-spinner", "aria-label": description || undefined, "aria-hidden": !description ? 'true' : undefined, viewBox: "-".concat(halfDiameter, " -").concat(quarterDiameter, " ").concat(diameter, " ").concat(halfDiameter), diameter: diameter },
        React.createElement("linearGradient", { id: "base-loading-spinner-".concat(uuid, "-gradient-1") },
            React.createElement("stop", { stopColor: mediumColor }),
            React.createElement("stop", { stopColor: darkColor, offset: "1" })),
        React.createElement("linearGradient", { id: "base-loading-spinner-".concat(uuid, "-gradient-2") },
            React.createElement("stop", { stopColor: lightColor }),
            React.createElement("stop", { stopColor: mediumColor, offset: "1" })),
        React.createElement("circle", { id: "base-loading-spinner-".concat(uuid, "-circle"), r: "50%" }),
        React.createElement("mask", { id: "base-loading-spinner-".concat(uuid, "-mask") },
            React.createElement("circle", null),
            React.createElement(UseSpinnerAnimated, { xlinkHref: "#base-loading-spinner-".concat(uuid, "-circle") })),
        React.createElement(GeometrySpinnerGradient, { rotation: "310deg", index: "2", uuid: uuid },
            React.createElement("use", { xlinkHref: "#base-loading-spinner-".concat(uuid, "-circle") })),
        React.createElement(GeometrySpinnerGradient, { rotation: "80deg", index: "1", uuid: uuid },
            React.createElement("use", { xlinkHref: "#base-loading-spinner-".concat(uuid, "-circle") }))));
};
BaSeLoadingSpinner.displayName = 'BaSeLoadingSpinner';

var inst = BaSeTheme.colors.institucionais;
var gest = BaSeTheme.colors.gestao;
var def = BaSeTheme.colors.defaultColors;
var feed = BaSeTheme.colors.feedbackInterface;
var TypographyLinkMapper = {
    default: {
        foreground: ColorMapper.default.foreground,
        hover: ColorMapper.default.unchecked,
        active: ColorMapper.default.hover.defaultDark,
        focus: ColorMapper.default.unchecked,
        focusShadow: ColorMapper.default.focus.defaultLight,
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    },
    destructive: {
        foreground: ColorMapper.destructive.foreground,
        hover: ColorMapper.destructive.unchecked,
        active: ColorMapper.destructive.hover.defaultDark,
        focus: ColorMapper.destructive.unchecked,
        focusShadow: ColorMapper.destructive.focus.defaultLight,
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    },
    confirmation: {
        foreground: ColorMapper.confirmation.foreground,
        hover: ColorMapper.confirmation.unchecked,
        active: ColorMapper.confirmation.hover.defaultDark,
        focus: ColorMapper.confirmation.unchecked,
        focusShadow: ColorMapper.confirmation.focus.defaultLight,
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    },
    negative: {
        foreground: inst.azulSebrae90,
        hover: def.white,
        active: ColorMapper.default.focus.defaultLight,
        focus: def.white,
        focusShadow: inst.azulSebrae90,
        visited: gest.roxo75,
        disabled: ColorMapper.grayScale.foreground,
    },
};
var TypographyCustomLinkMapper = function (color) {
    if (!Color.validateColor(color)) {
        return undefined;
    }
    return {
        foreground: color,
        hover: createColorSmartLightingControl(color, { l: 0.6 }, 'lighter'),
        active: ColorMapper.dark.hover.create(color),
        focus: createColorSmartLightingControl(color, { l: 0.6 }, 'lighter'),
        focusShadow: ColorMapper.light.focus.create(color),
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    };
};
var TypographyTypesColor = {
    default: {
        foreground: inst.cinzaSebrae45,
        strong: inst.cinzaSebrae30,
        soft: inst.cinzaSebrae45,
        unselected: inst.cinzaSebrae60,
        selected: inst.cinzaSebrae20,
    },
    confirmation: {
        foreground: feed.sucesso45,
        strong: feed.sucesso26,
        soft: feed.sucesso45,
        unselected: feed.sucesso70,
        selected: feed.sucesso20,
    },
    destructive: {
        foreground: feed.erro45,
        strong: feed.erro35,
        soft: feed.erro45,
        unselected: feed.erro60,
        selected: createColorSmartLightingControl(feed.erro45, { l: 0.2 }, 'darker'),
    },
};
var TypographyCustomTypesColor = function (color) {
    if (!color) {
        return undefined;
    }
    return {
        foreground: color,
        strong: createColorSmartLightingControl(color, { l: 0.3 }, 'darker'),
        soft: color,
        unselected: createColorSmartLightingControl(color, { l: 0.6 }, 'lighter'),
        selected: createColorSmartLightingControl(color, { l: 0.2 }, 'darker'),
    };
};
var BaSeFonts = ['Campuni'];
var GoogleFonts = [
    'Lato',
    'Alegreya Sans',
    'Open Sans',
    'Nunito',
    'Nunito Sans',
];
var DefaultFontWeight = {
    light: 300,
    regular: 400,
    bold: 700,
};
var CustomFontWeightMapper = {
    Campuni: __assign(__assign({}, DefaultFontWeight), { regular: 500 }),
};
var getFontWeight = function (font) {
    var _a;
    return ((_a = CustomFontWeightMapper[font !== null && font !== void 0 ? font : '']) !== null && _a !== void 0 ? _a : DefaultFontWeight);
};

var childrenMappedTypographyElements = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'p',
    'a',
    'li',
]
    .map(function (i) { return '> ' + i; })
    .join(', ')
    .toString();
var tagsKeepBasicTypographyStyle = css(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n  i,\n  em,\n  var {\n    font-style: italic;\n  }\n  b,\n  strong {\n    font-weight: bold;\n  }\n  blockquote {\n    padding-left: 40px;\n  }\n  abbr {\n    display: inline;\n  }\n  big {\n    font-size: larger;\n  }\n  small {\n    font-size: small;\n  }\n  code,\n  pre,\n  samp,\n  tt {\n    font-family: monospace;\n  }\n  pre {\n    white-space: pre;\n  }\n  del,\n  s,\n  strike {\n    text-decoration: line-through;\n  }\n  ins,\n  u {\n    text-decoration: underline;\n  }\n  sub,\n  sup {\n    font-size: smaller;\n  }\n  sub {\n    vertical-align: sub;\n  }\n  sup {\n    vertical-align: super;\n  }\n  center {\n    text-align: center;\n  }\n  q::before,\n  q::after {\n    content: '\u201C';\n  }\n"], ["\n  i,\n  em,\n  var {\n    font-style: italic;\n  }\n  b,\n  strong {\n    font-weight: bold;\n  }\n  blockquote {\n    padding-left: 40px;\n  }\n  abbr {\n    display: inline;\n  }\n  big {\n    font-size: larger;\n  }\n  small {\n    font-size: small;\n  }\n  code,\n  pre,\n  samp,\n  tt {\n    font-family: monospace;\n  }\n  pre {\n    white-space: pre;\n  }\n  del,\n  s,\n  strike {\n    text-decoration: line-through;\n  }\n  ins,\n  u {\n    text-decoration: underline;\n  }\n  sub,\n  sup {\n    font-size: smaller;\n  }\n  sub {\n    vertical-align: sub;\n  }\n  sup {\n    vertical-align: super;\n  }\n  center {\n    text-align: center;\n  }\n  q::before,\n  q::after {\n    content: '\u201C';\n  }\n"])));
var handleColor = function (hasHref, color) {
    var _a, _b, _c;
    if (!color) {
        return hasHref
            ? BaSeTheme.colors.institucionais.azulSebrae36
            : BaSeTheme.colors.institucionais.cinzaSebrae;
    }
    return ((_c = (_a = ColorMapper.typography[color]) !== null && _a !== void 0 ? _a : (_b = ColorMapper[color]) === null || _b === void 0 ? void 0 : _b.foreground) !== null && _c !== void 0 ? _c : color);
};
var getFontWeightType = function (isThin, isBold) {
    return isThin ? 'light' : isBold ? 'bold' : 'regular';
};
var createFontFamily = function (font) {
    var prefixFont = font ? "".concat(font, ",") : '';
    return prefixFont + BaSeTheme.typography.fontFamily;
};
var makeDefaultTypographyStyled = function (element, tagName, fontSize, lineHeight) { return styled[tagName].attrs({
    className: "BaSe--".concat(element.toLocaleLowerCase()),
})(templateObject_2$10 || (templateObject_2$10 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  vertical-align: baseline;\n  will-change: color, font-weight, font-style;\n  font-size: ", "em;\n  line-height: ", "em;\n\n  font-family: ", ";\n\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n\n  ", " {\n    font-size: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n\n  white-space: ", ";\n\n  ", "\n"], ["\n  margin: 0;\n  padding: 0;\n  vertical-align: baseline;\n  will-change: color, font-weight, font-style;\n  font-size: ", "em;\n  line-height: ", "em;\n\n  font-family: ", ";\n\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n\n  ", " {\n    font-size: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n\n  white-space: ", ";\n\n  ", "\n"])), fontSize, lineHeight, function (props) {
    return "".concat(createFontFamily(props === null || props === void 0 ? void 0 : props.fontFamily));
}, function (props) {
    return handleColor(false, props === null || props === void 0 ? void 0 : props.color);
}, function (props) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return getFontWeight(props === null || props === void 0 ? void 0 : props.fontFamily)[
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    getFontWeightType(props === null || props === void 0 ? void 0 : props.isThin, props === null || props === void 0 ? void 0 : props.isBold)];
}, function (props) {
    return (props === null || props === void 0 ? void 0 : props.isItalic) ? 'italic' : 'normal';
}, childrenMappedTypographyElements, function (props) {
    return (props === null || props === void 0 ? void 0 : props.withNewLineWrap) ? 'pre-line' : 'normal';
}, tagsKeepBasicTypographyStyle); };
var LinkWrapper = styled.a(templateObject_4$L || (templateObject_4$L = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var isDisabled = _a.isDisabled, isUnderline = _a.isUnderline, colors = _a.colors, fontSize = _a.fontSize, lineHeight = _a.lineHeight;
    return css(templateObject_3$T || (templateObject_3$T = __makeTemplateObject(["\n    cursor: pointer;\n    outline: none;\n    color: ", ";\n    text-decoration: ", ";\n    font-size: ", "em;\n    line-height: ", "em;\n    ", " {\n      display: inline;\n      font-size: inherit;\n      color: ", ";\n    }\n    ", "\n  "], ["\n    cursor: pointer;\n    outline: none;\n    color: ", ";\n    text-decoration: ", ";\n    font-size: ", "em;\n    line-height: ", "em;\n    ", " {\n      display: inline;\n      font-size: inherit;\n      color: ", ";\n    }\n    ", "\n  "])), handleColor(true, colors === null || colors === void 0 ? void 0 : colors.foreground), isUnderline ? 'underline' : 'none', fontSize, lineHeight, childrenMappedTypographyElements, handleColor(true, colors === null || colors === void 0 ? void 0 : colors.foreground), isDisabled
        ? "\n      pointer-events: none;\n      color: ".concat((_b = colors === null || colors === void 0 ? void 0 : colors.disabled) !== null && _b !== void 0 ? _b : BaSeTheme.colors.institucionais.cinzaSebrae75, ";\n      ").concat(childrenMappedTypographyElements, " {\n        color: ").concat((_c = colors === null || colors === void 0 ? void 0 : colors.disabled) !== null && _c !== void 0 ? _c : BaSeTheme.colors.institucionais.cinzaSebrae75, ";\n      }\n      ")
        : "\n        &:visited {\n          color: ".concat((_d = colors === null || colors === void 0 ? void 0 : colors.visited) !== null && _d !== void 0 ? _d : BaSeTheme.colors.gestao.roxo60, ";\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_e = colors === null || colors === void 0 ? void 0 : colors.visited) !== null && _e !== void 0 ? _e : BaSeTheme.colors.gestao.roxo60, ";\n          }\n        }\n        &:hover {\n          color: ").concat((_f = colors === null || colors === void 0 ? void 0 : colors.hover) !== null && _f !== void 0 ? _f : BaSeTheme.colors.institucionais.azulSebrae60, ";\n          text-decoration: none;\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_g = colors === null || colors === void 0 ? void 0 : colors.hover) !== null && _g !== void 0 ? _g : BaSeTheme.colors.institucionais.azulSebrae60, ";\n          }\n        }\n        &:focus {\n          color: ").concat((_h = colors === null || colors === void 0 ? void 0 : colors.focus) !== null && _h !== void 0 ? _h : BaSeTheme.colors.institucionais.azulSebrae60, ";\n          text-decoration: none;\n          border: none;\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_j = colors === null || colors === void 0 ? void 0 : colors.focus) !== null && _j !== void 0 ? _j : BaSeTheme.colors.institucionais.azulSebrae60, ";\n            border: 1px solid ").concat((_k = colors === null || colors === void 0 ? void 0 : colors.focusShadow) !== null && _k !== void 0 ? _k : BaSeTheme.colors.institucionais.azulSebrae75, ";\n            padding: 2px 7.5px;\n            border-radius: 4px;\n          }\n        }\n        &:active {\n          color: ").concat((_l = colors === null || colors === void 0 ? void 0 : colors.active) !== null && _l !== void 0 ? _l : BaSeTheme.colors.institucionais.azulSebrae30, ";\n          text-decoration: ").concat(isUnderline ? 'underline' : 'none', ";\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_m = colors === null || colors === void 0 ? void 0 : colors.active) !== null && _m !== void 0 ? _m : BaSeTheme.colors.institucionais.azulSebrae30, ";\n            border: none;\n            padding: 0;\n            border-radius: 0;\n          }\n        }\n      "));
});
var templateObject_1$1d, templateObject_2$10, templateObject_3$T, templateObject_4$L;

function Link(_a) {
    var Wrapper = _a.wrapper, availableColors = _a.availableColors, children = _a.children, fontSize = _a.fontSize, lineHeight = _a.lineHeight, isDisabled = _a.isDisabled, isUnderline = _a.isUnderline, link = _a.link, target = _a.target, other = __rest(_a, ["wrapper", "availableColors", "children", "fontSize", "lineHeight", "isDisabled", "isUnderline", "link", "target"]);
    return (React.createElement(LinkWrapper, { fontSize: fontSize, lineHeight: lineHeight, isDisabled: isDisabled, isUnderline: isUnderline, href: !!link ? link : undefined, colors: availableColors, target: target },
        React.createElement(Wrapper, __assign({ color: availableColors === null || availableColors === void 0 ? void 0 : availableColors.foreground }, other), children)));
}
var BaSeTypographyWrapper = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var fontSize = props.fontSize, lineHeight = props.lineHeight, children = props.children, color = props.color, type = props.type, link = props.link, Wrapper = props.wrapper, 
    // eslint-disable-next-line comma-dangle
    other = __rest(props, ["fontSize", "lineHeight", "children", "color", "type", "link", "wrapper"]);
    var availableColors = !!color
        ? (_a = TypographyLinkMapper[color]) !== null && _a !== void 0 ? _a : TypographyCustomLinkMapper(color)
        : undefined;
    var typeColor = !!type
        ? (_d = (_c = TypographyTypesColor[(_b = color) !== null && _b !== void 0 ? _b : 'default']) === null || _c === void 0 ? void 0 : _c[type]) !== null && _d !== void 0 ? _d : (_e = TypographyCustomTypesColor(color)) === null || _e === void 0 ? void 0 : _e[type]
        : null;
    var basicLink = React.useMemo(function () { return link; }, [link]);
    if (!!link) {
        if (typeof link === 'string') {
            return (React.createElement(Link, { availableColors: availableColors, fontSize: fontSize, lineHeight: lineHeight, color: color, type: type, wrapper: Wrapper, isUnderline: true, link: link, isDisabled: false }, children));
        }
        if (!!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.href)) {
            return (React.createElement(Link, { availableColors: availableColors, fontSize: fontSize, lineHeight: lineHeight, color: color, type: type, wrapper: Wrapper, isUnderline: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isUnderline), link: (basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled) ? '' : (_f = basicLink === null || basicLink === void 0 ? void 0 : basicLink.href) !== null && _f !== void 0 ? _f : '', isDisabled: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled), target: basicLink === null || basicLink === void 0 ? void 0 : basicLink.target }, children));
        }
        if (!!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) && React.isValidElement((_g = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _g === void 0 ? void 0 : _g.call(basicLink))) {
            return React.cloneElement((_h = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _h === void 0 ? void 0 : _h.call(basicLink), (basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled) ? { to: '' } : {}, React.createElement(Link, { availableColors: availableColors, fontSize: fontSize, lineHeight: lineHeight, color: color, type: type, wrapper: Wrapper, isUnderline: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isUnderline), link: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled)
                    ? ''
                    : (_r = (_m = (_l = (_k = (_j = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _j === void 0 ? void 0 : _j.call(basicLink)) === null || _k === void 0 ? void 0 : _k.props) === null || _l === void 0 ? void 0 : _l.to) !== null && _m !== void 0 ? _m : (_q = (_p = (_o = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _o === void 0 ? void 0 : _o.call(basicLink)) === null || _p === void 0 ? void 0 : _p.props) === null || _q === void 0 ? void 0 : _q.href) !== null && _r !== void 0 ? _r : '#', isDisabled: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled), target: basicLink === null || basicLink === void 0 ? void 0 : basicLink.target }, children));
        }
        if (React.isValidElement(link === null || link === void 0 ? void 0 : link())) {
            return React.cloneElement(link === null || link === void 0 ? void 0 : link(), {}, React.createElement(Link, { availableColors: availableColors, fontSize: fontSize, lineHeight: lineHeight, color: color, type: type, wrapper: Wrapper, isUnderline: true, link: (_x = (_u = (_t = (_s = link === null || link === void 0 ? void 0 : link()) === null || _s === void 0 ? void 0 : _s.props) === null || _t === void 0 ? void 0 : _t.to) !== null && _u !== void 0 ? _u : (_w = (_v = link === null || link === void 0 ? void 0 : link()) === null || _v === void 0 ? void 0 : _v.props) === null || _w === void 0 ? void 0 : _w.href) !== null && _x !== void 0 ? _x : '#', isDisabled: false }, children));
        }
    }
    return (React.createElement(Wrapper, __assign({ color: typeColor !== null && typeColor !== void 0 ? typeColor : availableColors === null || availableColors === void 0 ? void 0 : availableColors.foreground }, other), children));
};
BaSeTypographyWrapper.displayName = 'BaSeTypographyWrapper';

var StyledSmall2 = makeDefaultTypographyStyled('Small2', 'small', 0.69, 1.2);

var BaSeSmall2 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 0.69, lineHeight: 1.2, wrapper: StyledSmall2 }, props), props.children)); };
BaSeSmall2.displayName = 'BaSeSmall2';

var reduceLevel = function (level) {
    if (level > 1 && level <= 100) {
        level /= 100;
    }
    return level;
};
var mapButtonHeight = {
    small: 32,
    medium: 40,
    big: 48,
};
// *********************
// REGULAR BUTTONS
// *********************
var mapButtonValues = {
    primary: {
        default: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: ColorMapper.default.foreground,
                bcCHover: ColorMapper.default.hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                border: 'none',
            },
        },
        destructive: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: ColorMapper.destructive.foreground,
                bcCHover: ColorMapper.destructive.hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.destructive.focus.defaultLight),
                border: 'none',
            },
        },
        confirmation: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: ColorMapper.confirmation.foreground,
                bcCHover: ColorMapper.confirmation.hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.confirmation.focus.defaultLight),
                border: 'none',
            },
        },
        disabled: {
            color: ColorMapper.disabled.foreground,
            iconColor: ColorMapper.disabled.foreground,
            style: {
                bgC: ColorMapper.disabled.background,
                bcCHover: ColorMapper.disabled.background,
                boxShadowFocus: 'none',
                border: 'none',
            },
        },
        negative: {
            color: ColorMapper.default.foreground,
            iconColor: ColorMapper.default.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.default.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                border: 'none',
                colorHover: ColorMapper.default.hover.defaultDark,
            },
            disabled: {
                color: ColorMapper.disabled.foreground,
                iconColor: ColorMapper.disabled.foreground,
                style: {
                    bgC: ColorMapper.disabled.background,
                    bcCHover: ColorMapper.disabled.background,
                    boxShadowFocus: 'none',
                    border: 'none',
                },
            },
        },
    },
    secondary: {
        default: {
            color: ColorMapper.grayScale.foreground,
            iconColor: ColorMapper.grayScale.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.grayScale.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.grayScale.focus.defaultLight),
                border: "1px solid ".concat(ColorMapper.grayScale.hover.defaultDark),
                colorHover: ColorMapper.grayScale.hover.defaultDark,
            },
        },
        destructive: {
            color: ColorMapper.destructive.foreground,
            iconColor: ColorMapper.destructive.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.destructive.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.destructive.focus.defaultLight),
                border: "1px solid ".concat(ColorMapper.destructive.foreground),
                colorHover: ColorMapper.destructive.hover.defaultDark,
            },
        },
        confirmation: {
            color: ColorMapper.confirmation.foreground,
            iconColor: ColorMapper.confirmation.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.confirmation.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.confirmation.focus.defaultLight),
                border: "1px solid ".concat(ColorMapper.confirmation.foreground),
                colorHover: ColorMapper.confirmation.hover.defaultDark,
            },
        },
        disabled: {
            color: ColorMapper.disabled.foreground,
            iconColor: ColorMapper.disabled.foreground,
            style: {
                bgC: ColorMapper.disabled.background,
                bcCHover: '',
                boxShadowFocus: "",
                border: "1px solid ".concat(ColorMapper.disabled.foreground),
            },
        },
        negative: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                boxShadowFocus: "0px 0px 0px 4px ".concat(ColorMapper.default.focus.defaultLight),
                border: "2px solid ".concat(BaSeTheme.colors.defaultColors.white),
            },
            disabled: {
                color: ColorMapper.disabled.foreground,
                iconColor: ColorMapper.disabled.foreground,
                style: {
                    bgC: ColorMapper.disabled.background,
                    bcCHover: '',
                    boxShadowFocus: "",
                    border: "2px solid ".concat(ColorMapper.disabled.foreground),
                },
            },
        },
    },
    tertiary: {
        default: {
            color: ColorMapper.default.foreground,
            iconColor: ColorMapper.default.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: ColorMapper.default.hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.transparentLight, ";"),
                border: "none",
                colorHover: ColorMapper.default.hover.defaultDark,
            },
        },
        destructive: {
            color: ColorMapper.destructive.foreground,
            iconColor: ColorMapper.destructive.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: ColorMapper.destructive.hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.destructive.focus.transparentLight),
                border: "none",
                colorHover: ColorMapper.destructive.hover.defaultDark,
            },
        },
        confirmation: {
            color: ColorMapper.confirmation.foreground,
            iconColor: ColorMapper.confirmation.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: ColorMapper.confirmation.hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.confirmation.focus.transparentLight),
                border: "none",
                colorHover: ColorMapper.confirmation.hover.defaultDark,
            },
        },
        disabled: {
            color: ColorMapper.disabled.foreground,
            iconColor: ColorMapper.disabled.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: BaSeTheme.colors.defaultColors.transparent,
                boxShadowFocus: "none",
                border: "none",
            },
        },
        negative: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                boxShadowFocus: "0px 0px 0px 4px ".concat(ColorMapper.default.getColorByNumber(90)),
                border: "none",
            },
            disabled: {
                color: ColorMapper.disabled.getColorByNumber(60),
                iconColor: ColorMapper.disabled.getColorByNumber(60),
                style: {
                    bgC: BaSeTheme.colors.defaultColors.transparent,
                    bcCHover: BaSeTheme.colors.defaultColors.transparent,
                    boxShadowFocus: "none",
                    border: "none",
                },
            },
        },
    },
};
var styleMapSize = {
    medium: {
        padding: '8.5px 12px',
        fontSize: 1,
        lineHeight: 1.4375,
        loadingSize: 16,
    },
    small: {
        padding: '8px',
        fontSize: 0.83,
        lineHeight: 1.24,
        loadingSize: 16,
    },
    big: {
        padding: '12px 16px',
        fontSize: 1.2,
        lineHeight: 1.25,
        loadingSize: 24,
    },
};
// *********************
//  SHAPE BUTTON MAPS
// *********************
var iconButtonMapStyle = function (color) {
    var adaptColor = color === 'default' ? 'grayScale' : color;
    return {
        primary: {
            standard: {
                background: ColorMapper[color].foreground,
                iconColor: BaSeTheme.colors.defaultColors.white,
                hoverColor: ColorMapper[color].hover.defaultDark,
                backgroundOnFocus: ColorMapper[color].hover.defaultDark,
                borderHoverColor: '',
                iconHoverColor: '',
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper[color].focus.defaultLight),
                border: 'none',
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: '',
                    backgroundOnFocus: '',
                    borderHoverColor: '',
                    iconHoverColor: '',
                    boxShadowFocus: "0px 0px 0px 3px ".concat(BaSeTheme.colors.institucionais.azulSebrae75),
                    border: 'none',
                },
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.white,
                iconColor: ColorMapper.default.foreground,
                hoverColor: ColorMapper.default.hover.defaultLight,
                backgroundOnFocus: BaSeTheme.colors.defaultColors.white,
                borderHoverColor: '',
                iconHoverColor: '',
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                border: 'none',
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: '',
                    backgroundOnFocus: '',
                    borderHoverColor: '',
                    iconHoverColor: '',
                    boxShadowFocus: "0px 0px 0px 3px ".concat(BaSeTheme.colors.institucionais.azulSebrae75),
                    border: 'none',
                },
            },
        },
        secondary: {
            standard: {
                background: BaSeTheme.colors.defaultColors.white,
                iconColor: ColorMapper[adaptColor].foreground,
                hoverColor: ColorMapper[adaptColor].hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper[adaptColor].focus.defaultLight),
                border: "1px solid ".concat(ColorMapper[adaptColor].foreground),
                backgroundOnFocus: ColorMapper[adaptColor].hover.defaultLight,
                borderHoverColor: "1px solid ".concat(ColorMapper[adaptColor].hover.defaultDark),
                iconHoverColor: ColorMapper[adaptColor].hover.defaultDark,
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    boxShadowFocus: 'none',
                    backgroundOnFocus: '',
                    border: "1px solid ".concat(ColorMapper.disabled.foreground),
                    borderHoverColor: "1px solid ".concat(ColorMapper.grayScale.hover.defaultDark),
                    iconHoverColor: ColorMapper.grayScale.hover.defaultDark,
                },
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.transparent,
                iconColor: BaSeTheme.colors.defaultColors.white,
                hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                border: "2px solid ".concat(BaSeTheme.colors.defaultColors.white),
                borderColor: ColorMapper.default.foreground,
                backgroundOnFocus: BaSeTheme.colors.defaultColors.transparent,
                borderHoverColor: '',
                iconHoverColor: '',
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    boxShadowFocus: 'none',
                    backgroundOnFocus: '',
                    border: "2px solid ".concat(ColorMapper.disabled.foreground),
                    borderHoverColor: "1px solid ".concat(ColorMapper.grayScale.hover.defaultDark),
                    iconHoverColor: ColorMapper.grayScale.hover.defaultDark,
                },
            },
        },
        tertiary: {
            standard: {
                background: BaSeTheme.colors.defaultColors.transparent,
                iconColor: ColorMapper[color].foreground,
                hoverColor: ColorMapper[color].hover.transparentLight,
                backgroundOnFocus: ColorMapper[color].hover.transparentLight,
                borderHoverColor: '',
                iconHoverColor: '',
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper[color].focus.defaultLight),
                border: 'none',
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    boxShadowFocus: 'none',
                    backgroundOnFocus: '',
                    borderHoverColor: '',
                    iconHoverColor: '',
                    border: 'none',
                },
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.transparent,
                iconColor: BaSeTheme.colors.defaultColors.white,
                hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                backgroundOnFocus: BaSeTheme.colors.defaultColors.transparent,
                borderHoverColor: '',
                iconHoverColor: '',
                boxShadowFocus: "0px 0px 0px 3px ".concat(BaSeTheme.colors.defaultColors.white),
                border: 'none',
                disabled: {
                    background: BaSeTheme.colors.defaultColors.transparent,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    backgroundOnFocus: '',
                    borderHoverColor: '',
                    iconHoverColor: '',
                    boxShadowFocus: '',
                    border: 'none',
                },
            },
        },
    };
};
var iconButtonIconMapSize = {
    small: {
        iconSize: 16,
    },
    medium: {
        iconSize: 24,
    },
    big: {
        iconSize: 32,
    },
};
var iconButtonBorderRadius = {
    circle: '50%',
    square: '4px;',
};
// *********************
//  DUAL BUTTON MAPS
// *********************
var dualButtonMapStyle = {
    primary: {
        default: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.default.foreground,
            hoverColor: ColorMapper.default.hover.defaultLight,
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 1px',
            borderColor: ColorMapper.default.focus.defaultLight,
            borderRadius: '4',
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                opacity: reduceLevel(50),
            }),
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.grayScale.focus.defaultLight,
            borderRadius: '4',
        },
        error: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: ColorMapper.destructive.hover.defaultDark,
            hoverColor: '',
            boxShadowFocus: '0px 0px 0px 0px',
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.destructive.hover.defaultDark,
            borderRadius: '4',
        },
    },
    selected: {
        default: {
            background: ColorMapper.default.foreground,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: '',
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.default.foreground,
            borderRadius: '4',
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.default.foreground,
            hoverColor: '',
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '4',
        },
        error: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: ColorMapper.destructive.hover.defaultDark,
            hoverColor: '',
            boxShadowFocus: '0px 0px 0px 0px',
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.destructive.hover.defaultDark,
            borderRadius: '4',
        },
    },
};
// *********************
//  ARROW BUTTON MAPS
// *********************
var arrowButtonMapStyle = {
    primary: {
        default: {
            background: ColorMapper.default.foreground,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: ColorMapper.default.hover.defaultDark,
            boxShadowFocus: ColorMapper.default.focus.defaultLight,
            border: '0px',
            borderColor: ColorMapper.default.foreground,
            arrows: {
                top: '4.75px',
            },
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.default.foreground,
            hoverColor: ColorMapper.default.hover.transparentLight,
            boxShadowFocus: ColorMapper.default.focus.transparentLight,
            border: '0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            textHoverColor: ColorMapper.default.hover.defaultDark,
            borderHoverColor: ColorMapper.default.hover.defaultDark,
            arrows: {
                top: '4.75px',
            },
        },
        disabled: {
            background: ColorMapper.disabled.background,
            color: ColorMapper.disabled.foreground,
            hoverColor: '',
            boxShadowFocus: '',
            border: '0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            arrows: {
                top: '4.75px',
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.white,
                color: ColorMapper.default.foreground,
                hoverColor: ColorMapper.default.hover.transparentLight,
                boxShadowFocus: ColorMapper.default.focus.defaultLight,
                border: '0px',
                borderColor: BaSeTheme.colors.defaultColors.white,
                textHoverColor: ColorMapper.default.hover.defaultDark,
                borderHoverColor: ColorMapper.default.hover.defaultDark,
                arrows: {
                    top: '4.75px',
                },
            },
        },
    },
    secondary: {
        default: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.grayScale.foreground,
            hoverColor: ColorMapper.grayScale.hover.defaultLight,
            boxShadowFocus: ColorMapper.disabled.foreground,
            border: '1px',
            borderColor: ColorMapper.grayScale.foreground,
            textHoverColor: ColorMapper.grayScale.hover.defaultDark,
            borderHoverColor: ColorMapper.grayScale.hover.defaultDark,
            arrows: {
                top: '3.75px',
            },
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                opacity: reduceLevel(50),
            }),
            boxShadowFocus: "".concat(ColorMapper.default.focus.defaultLight),
            border: '2px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            arrows: {
                top: '2.75px',
            },
        },
        disabled: {
            background: ColorMapper.disabled.background,
            color: ColorMapper.disabled.foreground,
            hoverColor: '',
            boxShadowFocus: '',
            border: '1px',
            borderColor: "".concat(ColorMapper.disabled.foreground),
            negative: {
                background: ColorMapper.disabled.background,
                color: ColorMapper.disabled.foreground,
                hoverColor: '',
                boxShadowFocus: '',
                border: '2px',
                borderColor: "".concat(ColorMapper.disabled.foreground),
                arrows: {
                    top: '2.75px',
                },
            },
            arrows: {
                top: '3.5px',
            },
        },
    },
};
// *********************
//  CUSTOM COLORS BUTTON MAPS
// *********************
var mapCustomColorsButtonValues = function (customColor, ignoreTextHover, overrideColors) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (ignoreTextHover === void 0) { ignoreTextHover = false; }
    var _k = ColorMapper.createMostUsedColors(customColor), darkHoverColor = _k.darkHoverColor, lightFocusColor = _k.lightFocusColor, lightHoverColor = _k.lightHoverColor, lightFocusColorTransparent = _k.lightFocusColorTransparent, lightHoverColorTransparent = _k.lightHoverColorTransparent;
    var matchColorToReplace = function (matchColor, defaultColor) {
        return ignoreTextHover ? defaultColor : matchColor;
    };
    return {
        primary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, BaSeTheme.colors.defaultColors.white),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, BaSeTheme.colors.defaultColors.white),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor, (_a = customColor) !== null && _a !== void 0 ? _a : ColorMapper.default.foreground),
                bcCHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper.dark.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : darkHoverColor,
                boxShadowFocus: "0px 0px 0px 3px ".concat((overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : lightFocusColor),
                border: 'none',
            },
        },
        secondary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, (_b = customColor) !== null && _b !== void 0 ? _b : ColorMapper.grayScale.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, (_c = customColor) !== null && _c !== void 0 ? _c : ColorMapper.grayScale.foreground),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor, BaSeTheme.colors.defaultColors.white),
                bcCHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper.light.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : lightHoverColor,
                boxShadowFocus: "0px 0px 0px 3px ".concat((overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : lightFocusColor),
                border: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor)
                    ? "1px solid ".concat(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor))
                    : "1px solid ".concat(customColor),
                colorHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? matchColorToReplace((_d = ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.dark) === null || _d === void 0 ? void 0 : _d.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)), overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    : matchColorToReplace(darkHoverColor, ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, (_e = customColor) !== null && _e !== void 0 ? _e : ColorMapper.grayScale.foreground)),
            },
        },
        tertiary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, (_f = customColor) !== null && _f !== void 0 ? _f : ColorMapper.grayScale.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, (_g = customColor) !== null && _g !== void 0 ? _g : ColorMapper.grayScale.foreground),
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? ColorMapper.light.hover.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground))
                    : lightHoverColorTransparent,
                boxShadowFocus: "0px 0px 0px 3px ".concat((overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? ColorMapper.light.focus.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground))
                    : lightFocusColorTransparent),
                border: "none",
                colorHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? matchColorToReplace((_h = ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.dark) === null || _h === void 0 ? void 0 : _h.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)), overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    : matchColorToReplace(darkHoverColor, ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, (_j = customColor) !== null && _j !== void 0 ? _j : ColorMapper.grayScale.foreground)),
            },
        },
    };
};
// *********************
//  CUSTOM COLORS ARROW BUTTON MAPS
// *********************
var mapCustomColorsArrowButtonValues = function (customColor) {
    var _a = ColorMapper.createMostUsedColors(customColor), darkHoverColor = _a.darkHoverColor, lightFocusColor = _a.lightFocusColor, lightHoverColor = _a.lightHoverColor;
    return {
        primary: {
            background: customColor,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: darkHoverColor,
            boxShadowFocus: lightFocusColor,
            border: '0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '7.5',
        },
        secondary: {
            background: BaSeTheme.colors.defaultColors.white,
            color: customColor,
            hoverColor: lightHoverColor,
            boxShadowFocus: lightFocusColor,
            border: '1px',
            borderColor: customColor,
            borderRadius: '7.5',
        },
    };
};
// *********************
//  CUSTOM COLORS ARROW BUTTON MAPS
// *********************
var mapCustomColorsIconButtonValues = function (customColor) {
    var _a = ColorMapper.createMostUsedColors(customColor), darkHoverColor = _a.darkHoverColor, lightFocusColor = _a.lightFocusColor, lightHoverColor = _a.lightHoverColor, lightFocusColorTransparent = _a.lightFocusColorTransparent, lightHoverColorTransparent = _a.lightHoverColorTransparent;
    return {
        primary: {
            background: customColor,
            iconColor: BaSeTheme.colors.defaultColors.white,
            hoverColor: darkHoverColor,
            boxShadowFocus: "0px 0px 0px 3px ".concat(lightFocusColor),
            border: 'none',
            backgroundOnFocus: '',
            borderHoverColor: '',
            iconHoverColor: '',
        },
        secondary: {
            background: BaSeTheme.colors.defaultColors.white,
            iconColor: customColor,
            hoverColor: lightHoverColor,
            boxShadowFocus: "0px 0px 0px 3px ".concat(lightFocusColor),
            border: "1px solid ".concat(customColor),
            backgroundOnFocus: '',
            borderHoverColor: '',
            iconHoverColor: '',
        },
        tertiary: {
            background: BaSeTheme.colors.defaultColors.transparent,
            iconColor: customColor,
            hoverColor: lightHoverColorTransparent,
            boxShadowFocus: "0px 0px 0px 3px ".concat(lightFocusColorTransparent),
            border: 'none',
            backgroundOnFocus: '',
            borderHoverColor: '',
            iconHoverColor: '',
        },
    };
};
// Overrider
var buttonOverrideColor = function (overrider) {
    return {
        primary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor),
                bcCHover: (overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) &&
                    ColorMapper.dark.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor)),
                boxShadowFocus: (overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) &&
                    "0px 0px 0px 3px ".concat(ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor))),
            },
        },
        secondary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor),
                bcCHover: ((overrider === null || overrider === void 0 ? void 0 : overrider.foreground) || (overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor)) &&
                    (ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor((overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) || (overrider === null || overrider === void 0 ? void 0 : overrider.foreground)))),
                boxShadowFocus: ((overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) || (overrider === null || overrider === void 0 ? void 0 : overrider.foreground)) &&
                    "0px 0px 0px 3px ".concat(ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor((overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) || (overrider === null || overrider === void 0 ? void 0 : overrider.foreground)))),
                border: (overrider === null || overrider === void 0 ? void 0 : overrider.borderColor) &&
                    "1px solid ".concat(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.borderColor)),
                colorHover: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    ColorMapper.dark.hover.create(ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground)),
            },
        },
        tertiary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            style: {
                bcCHover: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    (ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.hover.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground))),
                boxShadowFocus: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    "0px 0px 0px 3px ".concat(ColorMapper.light.focus.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground))),
                border: 'none',
                colorHover: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    ColorMapper.dark.hover.create(ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground)),
            },
        },
    };
};

var IconButton$1 = styled.button.attrs({
    className: 'BaSe--icon-button',
})(templateObject_2$$ || (templateObject_2$$ = __makeTemplateObject(["\n  position: relative;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-radius: ", ";\n  display: flex;\n  background-color: ", ";\n  border: ", ";\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: ", ";\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  position: relative;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-radius: ", ";\n  display: flex;\n  background-color: ", ";\n  border: ", ";\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: ", ";\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (_a) {
    var borderRadius = _a.borderRadius, sideButton = _a.sideButton;
    return sideButton === 'none'
        ? borderRadius
        : sideButton === 'left'
            ? '4px 0px 0px 4px'
            : '0px 4px 4px 0px';
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var border = _a.border;
    return border;
}, BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var size = _a.width, padding = _a.padding;
    return css(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject(["\n    padding: ", ";\n    min-width: calc(", "em - (", " * 2));\n    min-height: calc(", "em - (", " * 2));\n    width: calc(", "em - (", " * 2));\n    height: calc(", "em - (", " * 2));\n    max-width: calc(", "em - (", " * 2));\n    max-height: calc(", "em - (", " * 2));\n  "], ["\n    padding: ", ";\n    min-width: calc(", "em - (", " * 2));\n    min-height: calc(", "em - (", " * 2));\n    width: calc(", "em - (", " * 2));\n    height: calc(", "em - (", " * 2));\n    max-width: calc(", "em - (", " * 2));\n    max-height: calc(", "em - (", " * 2));\n  "])), numberWithUnit(padding), size, numberWithUnit(padding), size, numberWithUnit(padding), size, numberWithUnit(padding), size, numberWithUnit(padding), size, numberWithUnit(padding), size, numberWithUnit(padding));
}, function (_a) {
    var backgroundOnHover = _a.backgroundOnHover;
    return backgroundOnHover;
}, function (_a) {
    var borderRadius = _a.borderRadius, sideButton = _a.sideButton;
    return sideButton === 'none'
        ? borderRadius
        : sideButton === 'left'
            ? '4px 0px 0px 4px'
            : '0px 4px 4px 0px';
}, function (_a) {
    var backgroundOnFocus = _a.backgroundOnFocus;
    return backgroundOnFocus;
}, function (_a) {
    var boxShadowOnFocus = _a.boxShadowOnFocus;
    return boxShadowOnFocus;
}, BaSeTheme.colors.defaultColors.transparent);
var templateObject_1$1c, templateObject_2$$;

var extraSmallIconSize = { iconSize: 12 };
var widthMap = {
    'mega-small': 1,
    'extra-small': 1.25,
    small: 2,
    medium: 2.5,
    big: 3,
};
var BaSeIconButton = React.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e;
    var id = _a.id, name = _a.name, dataset = _a.dataset, nameIcon = _a.nameIcon, descriptionIcon = _a.descriptionIcon, value = _a.value, _f = _a.type, type = _f === void 0 ? 'primary' : _f, _g = _a.color, color = _g === void 0 ? BaSeTheme.components.button.colors.default : _g, _h = _a.shape, shape = _h === void 0 ? 'circle' : _h, _j = _a.sizeIcon, sizeIcon = _j === void 0 ? 'small' : _j, _k = _a.size, size = _k === void 0 ? 'medium' : _k, _l = _a.isDisabled, isDisabled = _l === void 0 ? false : _l, _m = _a.buttonType, buttonType = _m === void 0 ? 'button' : _m, _o = _a.sideButton, sideButton = _o === void 0 ? 'none' : _o, _p = _a.autoFocus, autoFocus = _p === void 0 ? false : _p, _q = _a.isLoading, isLoading = _q === void 0 ? false : _q, children = _a.children, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    if (!nameIcon && !value) {
        throw Error('[BaSeIconButton] error: Nome do ícone ou um valor textual é obrigatório!');
    }
    var borderRadius = (_b = iconButtonBorderRadius[shape]) !== null && _b !== void 0 ? _b : iconButtonBorderRadius.circle;
    var iconSize = React.useMemo(function () {
        var _a;
        return size === 'extra-small' || size === 'mega-small'
            ? extraSmallIconSize
            : (_a = iconButtonIconMapSize[sizeIcon]) !== null && _a !== void 0 ? _a : iconButtonIconMapSize.medium;
    }, [size, sizeIcon]).iconSize;
    var padding = React.useMemo(function () {
        // TODO molhorar código
        return size === 'big'
            ? (40 - iconSize) / 2 + 4
            : size === 'medium'
                ? (40 - iconSize) / 2
                : size === 'small' || size === 'extra-small'
                    ? 4
                    : 1.5;
    }, [size, iconSize]);
    var width = React.useMemo(function () { var _a; return (_a = widthMap === null || widthMap === void 0 ? void 0 : widthMap[size !== null && size !== void 0 ? size : 'medium']) !== null && _a !== void 0 ? _a : 0; }, [size]);
    if (width <= 0) {
        throw Error("[BaSeIconButton] error: Informe o \"size\" com uma das op\u00E7\u00F5es:\n          - \"mega-small\"\n          - \"extra-small\"\n          - \"small\"\n          - \"medium\"\n          - \"big\"");
    }
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.negative ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation;
    var colorIsNegative = color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b, _c, _d;
        if (color) {
            if (!colorIsMapped) {
                if (Color.validateColor(color)) {
                    return (_a = mapCustomColorsIconButtonValues(color)) === null || _a === void 0 ? void 0 : _a[type];
                }
                return (_b = iconButtonMapStyle('default')[type]) === null || _b === void 0 ? void 0 : _b.standard;
            }
            return (_c = iconButtonMapStyle(color)[type]) === null || _c === void 0 ? void 0 : _c.standard;
        }
        return (_d = iconButtonMapStyle('default')[type]) === null || _d === void 0 ? void 0 : _d.standard;
    };
    var typeMapped = colorIsNegative
        ? isDisabled
            ? (_c = iconButtonMapStyle('default')[type]) === null || _c === void 0 ? void 0 : _c.negative.disabled
            : (_d = iconButtonMapStyle('default')[type]) === null || _d === void 0 ? void 0 : _d.negative
        : isDisabled
            ? (_e = iconButtonMapStyle('default')[type]) === null || _e === void 0 ? void 0 : _e.standard.disabled
            : getColorsAtributes();
    var background = typeMapped.background, border = typeMapped.border, backgroundOnFocus = typeMapped.backgroundOnFocus, iconColor = typeMapped.iconColor, hoverColor = typeMapped.hoverColor, boxShadowFocus = typeMapped.boxShadowFocus, borderHoverColor = typeMapped.borderHoverColor, iconHoverColor = typeMapped.iconHoverColor;
    var _r = React.useState(false), isHover = _r[0], setIsHover = _r[1];
    var formattedDataset = getFormattedDataset(dataset);
    return (React.createElement(IconButton$1, __assign({ id: id, name: name }, formattedDataset, { ref: ref, width: width, autoFocus: autoFocus, disabled: isDisabled, type: buttonType, backgroundOnFocus: backgroundOnFocus, border: isHover && !!borderHoverColor ? borderHoverColor : border, borderRadius: borderRadius, backgroundColor: background, backgroundOnHover: hoverColor, boxShadowOnFocus: size.includes('small')
            ? boxShadowFocus.replace('3', '2')
            : boxShadowFocus, padding: border === 'none' ? padding : padding - 1, sideButton: sideButton, onMouseEnter: function (e) {
            setIsHover(true);
            onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
        }, onMouseLeave: function (e) {
            setIsHover(false);
            onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
        }, onClick: onClick, onFocus: onFocus, onBlur: onBlur }),
        React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return isLoading ? (React.createElement(BaSeLoadingSpinner, { diameter: iconSize, color: isHover && !!iconHoverColor ? iconHoverColor : iconColor, description: getMessage('loading.description'), disabled: isDisabled, type: "tertiary" })) : nameIcon ? (React.createElement(BaSeIcon, { description: (descriptionIcon === null || descriptionIcon === void 0 ? void 0 : descriptionIcon.trim()) ||
                    getMessage('buttonIcon.defaultDescription'), name: nameIcon, size: iconSize, color: isHover && !!iconHoverColor ? iconHoverColor : iconColor, colorTransition: "fast" })) : (React.createElement("div", { style: {
                    width: iconSize,
                    height: iconSize,
                    display: 'grid',
                    placeItems: 'center',
                } },
                React.createElement(BaSeSmall2, { color: isHover && !!iconHoverColor ? iconHoverColor : iconColor }, value)));
        }),
        children));
});
BaSeIconButton.displayName = 'BaSeIconButton';

var StyledSmall1 = makeDefaultTypographyStyled('Small1', 'small', 0.83, 1.2);

var BaSeSmall1 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 0.83, lineHeight: 1.2, wrapper: StyledSmall1 }, props), props.children)); };
BaSeSmall1.displayName = 'BaSeSmall1';

var none$1 = 'none';
var borderSize$2 = 7;
var transparenteBorder$1 = "".concat(borderSize$2, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePosition$1 = "".concat(-1 * borderSize$2, "px");
var calcPosition$1 = "calc(50% - ".concat(borderSize$2, "px)");
var borderSizeSmaller = 6.5;
var filledBorderSmaller = function (color) {
    return color
        ? "".concat(borderSizeSmaller, "px solid ").concat(color)
        : "".concat(borderSizeSmaller, "px solid ").concat(BaSeTheme.colors.defaultColors.white);
};
var transparenteBorderSmaller$1 = "".concat(borderSizeSmaller, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePositionSmaller$1 = "".concat(-1 * borderSizeSmaller + 1, "px");
var calcPositionSmaller$1 = "calc(50% - ".concat(borderSizeSmaller, "px)");
var getTriangleMapper$1 = function (themeMode, color, direction, overrideColor) {
    var _a;
    var TriangleProps = {
        dark: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthRight: transparenteBorder$1,
                widthBottom: none$1,
                widthLeft: transparenteBorder$1,
            },
            right: {
                positionLeft: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthBottom: transparenteBorder$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: none$1,
                widthRight: transparenteBorder$1,
                widthBottom: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthLeft: transparenteBorder$1,
            },
            left: {
                positionRight: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: none$1,
                widthBottom: transparenteBorder$1,
                widthLeft: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
            },
        },
        light: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
                widthRight: transparenteBorder$1,
                widthBottom: none$1,
                widthLeft: transparenteBorder$1,
            },
            right: {
                positionLeft: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
                widthBottom: transparenteBorder$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: none$1,
                widthRight: transparenteBorder$1,
                widthBottom: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
                widthLeft: transparenteBorder$1,
            },
            left: {
                positionRight: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: none$1,
                widthBottom: transparenteBorder$1,
                widthLeft: "".concat(borderSize$2, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
            },
        },
    };
    return TriangleProps[themeMode]
        ? (_a = TriangleProps[themeMode][direction]) !== null && _a !== void 0 ? _a : TriangleProps[themeMode].neutral
        : TriangleProps.dark.neutral;
};
var getTriangleMapperSmaller$1 = function (themeMode, color, direction, overrideColor) {
    var _a;
    var TrianglePropsSmaller = {
        dark: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthRight: transparenteBorderSmaller$1,
                widthBottom: none$1,
                widthLeft: transparenteBorderSmaller$1,
            },
            right: {
                positionLeft: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: none$1,
                widthRight: transparenteBorderSmaller$1,
                widthBottom: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthLeft: transparenteBorderSmaller$1,
            },
            left: {
                positionRight: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: none$1,
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
            },
        },
        light: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: filledBorderSmaller(overrideColor),
                widthRight: transparenteBorderSmaller$1,
                widthBottom: none$1,
                widthLeft: transparenteBorderSmaller$1,
            },
            right: {
                positionLeft: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: filledBorderSmaller(overrideColor),
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: none$1,
                widthRight: transparenteBorderSmaller$1,
                widthBottom: filledBorderSmaller(overrideColor),
                widthLeft: transparenteBorderSmaller$1,
            },
            left: {
                positionRight: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: none$1,
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: filledBorderSmaller(overrideColor),
            },
        },
    };
    return TrianglePropsSmaller[themeMode]
        ? (_a = TrianglePropsSmaller[themeMode][direction]) !== null && _a !== void 0 ? _a : TrianglePropsSmaller[themeMode].neutral
        : TrianglePropsSmaller.dark.neutral;
};
var PopoverColorMapper = {
    default: BaSeTheme.colors.institucionais.azulSebrae36,
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    attention: BaSeTheme.colors.feedbackInterface.atencao55,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};

var PopoverContainer = styled.div.attrs({
    className: 'BaSe--popover',
})(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject(["\n  ", "\n  ", "\n  opacity: ", ";\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  min-width: ", "px;\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n"], ["\n  ", "\n  ", "\n  opacity: ", ";\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  min-width: ", "px;\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n"])), function (props) { return (props.open ? 'visibility: visible;' : 'visibility: hidden;'); }, function (props) { return !props.open && 'pointer-events: none;'; }, function (props) { return (props.open ? 1 : 0); }, function (props) { return props.top && 'top:' + props.top + ';'; }, function (props) { return props.right && 'right:' + props.right + ';'; }, function (props) { return props.bottom && 'bottom:' + props.bottom + ';'; }, function (props) { return props.left && 'left:' + props.left + ';'; }, function (props) { return props.width; }, BaSeTheme.stackOrder.aboveNormal, BaSeTheme.transitions.allPropertiesContinuousNormal);
var PopoverCard = styled.div.attrs({
    className: 'BaSe--popover-card',
})(templateObject_2$_ || (templateObject_2$_ = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 12px 24px 16px 16px;\n  position: relative;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  box-shadow: ", ";\n"], ["\n  border-radius: 4px;\n  padding: 12px 24px 16px 16px;\n  position: relative;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor) ||
        (themeMode === 'light'
            ? BaSeTheme.colors.defaultColors.white
            : transformLightness(color, 0.15));
}, function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor) ||
        (themeMode === 'light'
            ? transformLightness(color, 0.9)
            : transformLightness(color, 0.15));
}, BaSeTheme.shadows.profundidade4);
var PopoverCardTitleContainer = styled.div(templateObject_3$S || (templateObject_3$S = __makeTemplateObject(["\n  padding-bottom: 1px;\n  align-items: center;\n  > small {\n    font-weight: bold;\n    color: ", ";\n  }\n"], ["\n  padding-bottom: 1px;\n  align-items: center;\n  > small {\n    font-weight: bold;\n    color: ", ";\n  }\n"])), function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.titleColor) ||
        (themeMode === 'light'
            ? color
            : transformLightness(color, 0.9));
});
var PopoverCardBodyContainer = styled.div(templateObject_4$K || (templateObject_4$K = __makeTemplateObject(["\n  > small {\n    color: ", ";\n  }\n"], ["\n  > small {\n    color: ", ";\n  }\n"])), function (_a) {
    var themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground) ||
        (themeMode === 'light'
            ? BaSeTheme.colors.institucionais.cinzaSebrae45
            : BaSeTheme.colors.defaultColors.white);
});
var PopoverCardContentContainer = styled.div(templateObject_5$C || (templateObject_5$C = __makeTemplateObject(["\n  &:not(:empty) {\n    margin-top: 8px;\n  }\n"], ["\n  &:not(:empty) {\n    margin-top: 8px;\n  }\n"])));
var PopoverButtonContainer = styled.div(templateObject_6$A || (templateObject_6$A = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n\n  > button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    width: 20px;\n    height: 20px;\n    > img {\n      width: 12px;\n      height: 12px;\n    }\n  }\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n\n  > button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    width: 20px;\n    height: 20px;\n    > img {\n      width: 12px;\n      height: 12px;\n    }\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase);
var PopoverTriangle = styled.div(templateObject_7$u || (templateObject_7$u = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 1);
var PopoverTriangleSmaller = styled.div(templateObject_8$s || (templateObject_8$s = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 2);
var templateObject_1$1b, templateObject_2$_, templateObject_3$S, templateObject_4$K, templateObject_5$C, templateObject_6$A, templateObject_7$u, templateObject_8$s;

var TooltipContainer = styled.div.attrs({
    className: 'BaSe--tooltip',
})(templateObject_9$p || (templateObject_9$p = __makeTemplateObject(["\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n  position: absolute;\n\n  ", "\n  ", "\n  opacity: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n  position: absolute;\n\n  ", "\n  ", "\n  opacity: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), BaSeTheme.stackOrder.aboveNormal, BaSeTheme.transitions.allPropertiesContinuousNormal, function (props) {
    return props.open
        ? css(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject(["\n          visibility: visible;\n        "], ["\n          visibility: visible;\n        "]))) : css(templateObject_2$Z || (templateObject_2$Z = __makeTemplateObject(["\n          visibility: hidden;\n        "], ["\n          visibility: hidden;\n        "])));
}, function (props) {
    return !props.open && css(templateObject_3$R || (templateObject_3$R = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, function (props) { return (props.open ? 1 : 0); }, function (props) {
    return props.top && css(templateObject_4$J || (templateObject_4$J = __makeTemplateObject(["\n      top: ", ";\n    "], ["\n      top: ", ";\n    "])), props.top);
}, function (props) {
    return props.right && css(templateObject_5$B || (templateObject_5$B = __makeTemplateObject(["\n      right: ", ";\n    "], ["\n      right: ", ";\n    "])), props.right);
}, function (props) {
    return props.bottom && css(templateObject_6$z || (templateObject_6$z = __makeTemplateObject(["\n      bottom: ", ";\n    "], ["\n      bottom: ", ";\n    "])), props.bottom);
}, function (props) {
    return props.left && css(templateObject_7$t || (templateObject_7$t = __makeTemplateObject(["\n      left: ", ";\n    "], ["\n      left: ", ";\n    "])), props.left);
}, function (props) { return css(templateObject_8$r || (templateObject_8$r = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), props.width ? "".concat(props.width, "px") : 'auto'); });
var TooltipBody = styled.div.attrs({
    className: 'BaSe--tooltip-body',
})(templateObject_11$j || (templateObject_11$j = __makeTemplateObject(["\n  background-color: ", ";\n  ", "\n  border-radius: 4px;\n  ", "\n  position: relative;\n"], ["\n  background-color: ", ";\n  ", "\n  border-radius: 4px;\n  ", "\n  position: relative;\n"])), function (props) {
    var _a, _b;
    return props.themeMode === 'light'
        ? (ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor((_a = props === null || props === void 0 ? void 0 : props.overrideColors) === null || _a === void 0 ? void 0 : _a.backgroundColor)) ||
            BaSeTheme.colors.defaultColors.white
        : ColorMapper.getColor((_b = props === null || props === void 0 ? void 0 : props.overrideColors) === null || _b === void 0 ? void 0 : _b.backgroundColor) ||
            ColorMapper.create(ColorMapper.getColor(props === null || props === void 0 ? void 0 : props.color), 0.5);
}, function (props) {
    var _a, _b;
    return props.themeMode === 'light' &&
        "border: 1px solid ".concat((_b = (_a = props === null || props === void 0 ? void 0 : props.overrideColors) === null || _a === void 0 ? void 0 : _a.borderColor) !== null && _b !== void 0 ? _b : props.color, ";");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    return css(templateObject_10$n || (templateObject_10$n = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", // medium
        ";\n  "])), size === 'small' ? '4px' : size === 'big' ? '12px' : '8px 12px' // medium
    );
});
var MessageWrapper = styled.span(templateObject_13$g || (templateObject_13$g = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  & > small[class*=BaSe] {\n    color: ", ";\n    word-wrap: break-word;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  & > small[class*=BaSe] {\n    color: ", ";\n    word-wrap: break-word;\n  }\n"])), function (_a) {
    var messageNoBreakLine = _a.messageNoBreakLine;
    return messageNoBreakLine && css(templateObject_12$i || (templateObject_12$i = __makeTemplateObject(["\n      white-space: nowrap;\n    "], ["\n      white-space: nowrap;\n    "])));
}, function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground) ||
        (themeMode === 'light' ? color : BaSeTheme.colors.defaultColors.white);
});
var TooltipTriangle = styled.div(templateObject_14$g || (templateObject_14$g = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 1);
var TooltipTriangleSmaller = styled.div(templateObject_15$f || (templateObject_15$f = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 2);
var templateObject_1$1a, templateObject_2$Z, templateObject_3$R, templateObject_4$J, templateObject_5$B, templateObject_6$z, templateObject_7$t, templateObject_8$r, templateObject_9$p, templateObject_10$n, templateObject_11$j, templateObject_12$i, templateObject_13$g, templateObject_14$g, templateObject_15$f;

var BaSePopover = function (_a) {
    var _b;
    var width = _a.width, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.message, message = _d === void 0 ? '' : _d, _e = _a.direction, direction = _e === void 0 ? 'neutral' : _e, _f = _a.color, color = _f === void 0 ? 'default' : _f, _g = _a.themeMode, themeMode = _g === void 0 ? 'light' : _g, _h = _a.coordinates, coordinates = _h === void 0 ? {} : _h, _j = _a.delayToOpen, delayToOpen = _j === void 0 ? 0 : _j, overrideColors = _a.overrideColors, buddyRef = _a.buddyRef, _k = _a.hasCloseButton, hasCloseButton = _k === void 0 ? true : _k, _l = _a.open, externalOpen = _l === void 0 ? false : _l, _m = _a.handleClose, handleClose = _m === void 0 ? function () { } : _m, _o = _a.refOutput, refOutput = _o === void 0 ? function () { } : _o, _p = _a.renderContent, renderContent = _p === void 0 ? function () { return null; } : _p;
    var open = useDebounce(externalOpen, externalOpen ? delayToOpen : 0);
    var messages = Array.isArray(message) ? message : [message];
    var mappedColor = (_b = PopoverColorMapper[color]) !== null && _b !== void 0 ? _b : color;
    var TriangleProps = React.useCallback(function () {
        return getTriangleMapper$1(themeMode, mappedColor, direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor);
    }, [themeMode, mappedColor, direction, overrideColors]);
    var TrianglePropsSmaller = React.useCallback(function () {
        return getTriangleMapperSmaller$1(themeMode, mappedColor, direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor);
    }, [themeMode, mappedColor, direction, overrideColors]);
    var _q = useCoordinatesFromBuddyAndDirectionToAlert(buddyRef, direction, coordinates), top = _q.top, left = _q.left, bottom = _q.bottom, right = _q.right;
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            refOutput(ref === null || ref === void 0 ? void 0 : ref.current);
        }
    }, [ref, message, refOutput]);
    return (React.createElement(PopoverContainer, { "aria-hidden": !open, open: open, ref: ref, top: top, left: left, bottom: bottom, right: right, width: width },
        React.createElement(PopoverTriangle, __assign({}, TriangleProps())),
        React.createElement(PopoverTriangleSmaller, __assign({}, TrianglePropsSmaller())),
        React.createElement(PopoverCard, { color: mappedColor, themeMode: themeMode, overrideColors: overrideColors },
            React.createElement(PopoverCardTitleContainer, { color: mappedColor, themeMode: themeMode, overrideColors: overrideColors },
                React.createElement(BaSeSmall1, null, title),
                hasCloseButton && (React.createElement(PopoverButtonContainer, null,
                    React.createElement(BaSeI18nConsumer, null, function (_a) {
                        var getMessage = _a.getMessage;
                        return (React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), buttonType: "button", shape: "circle", size: "small", sizeIcon: "medium", type: "tertiary", color: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.titleColor) ||
                                (themeMode === 'light'
                                    ? color
                                    : transformLightness(mappedColor, 0.9)), onClick: handleClose }));
                    })))),
            React.createElement(PopoverCardBodyContainer, { overrideColors: overrideColors, themeMode: themeMode },
                messages.map(function (message, index) { return (React.createElement(MessageWrapper, { key: index, color: mappedColor, overrideColors: overrideColors, themeMode: themeMode },
                    React.createElement(BaSeSmall1, null, message))); }),
                React.createElement(PopoverCardContentContainer, null, renderContent())))));
};
BaSePopover.displayName = 'BaSePopover';

var none = 'none';
var borderSize$1 = 7;
var transparenteBorder = "".concat(borderSize$1, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePosition = "".concat(-1 * borderSize$1, "px");
var calcPosition = "calc(50% - ".concat(borderSize$1, "px)");
var transparenteBorderSmaller = "".concat(borderSize$1, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePositionSmaller = "".concat(-1 * borderSize$1 + 1, "px");
var calcPositionSmaller = "calc(50% - ".concat(borderSize$1, "px)");
var replaceColor = function (color) {
    return color
        ? "".concat(borderSize$1, "px solid ").concat(color)
        : "".concat(borderSize$1, "px solid ").concat(BaSeTheme.colors.defaultColors.white);
};
var getTriangleMapper = function (themeMode, color, direction, overrideColors, darkColor) {
    var _a;
    var TriangleProps = {
        dark: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePosition,
                positionRight: calcPosition,
                widthTop: "".concat(borderSize$1, "px solid ").concat(darkColor ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthRight: transparenteBorder,
                widthBottom: none,
                widthLeft: transparenteBorder,
            },
            right: {
                positionLeft: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: "".concat(borderSize$1, "px solid ").concat(darkColor ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthBottom: transparenteBorder,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePosition,
                positionRight: calcPosition,
                widthTop: none,
                widthRight: transparenteBorder,
                widthBottom: "".concat(borderSize$1, "px solid ").concat(darkColor ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthLeft: transparenteBorder,
            },
            left: {
                positionRight: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: none,
                widthBottom: transparenteBorder,
                widthLeft: "".concat(borderSize$1, "px solid ").concat(darkColor ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
            },
        },
        light: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePosition,
                positionRight: calcPosition,
                widthTop: "".concat(borderSize$1, "px solid ").concat(overrideColors || color),
                widthRight: transparenteBorder,
                widthBottom: none,
                widthLeft: transparenteBorder,
            },
            right: {
                positionLeft: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: "".concat(borderSize$1, "px solid ").concat(overrideColors || color),
                widthBottom: transparenteBorder,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePosition,
                positionRight: calcPosition,
                widthTop: none,
                widthRight: transparenteBorder,
                widthBottom: "".concat(borderSize$1, "px solid ").concat(overrideColors || color),
                widthLeft: transparenteBorder,
            },
            left: {
                positionRight: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: none,
                widthBottom: transparenteBorder,
                widthLeft: "".concat(borderSize$1, "px solid ").concat(overrideColors || color),
            },
        },
    };
    return TriangleProps[themeMode]
        ? (_a = TriangleProps[themeMode][direction]) !== null && _a !== void 0 ? _a : TriangleProps[themeMode].neutral
        : TriangleProps.dark.neutral;
};
var getTriangleMapperSmaller = function (themeMode, color, direction, overrideColors) {
    var _a;
    var TrianglePropsSmaller = {
        dark: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: "".concat(borderSize$1, "px solid ").concat(overrideColors ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthRight: transparenteBorderSmaller,
                widthBottom: none,
                widthLeft: transparenteBorderSmaller,
            },
            right: {
                positionLeft: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: "".concat(borderSize$1, "px solid ").concat(overrideColors ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthBottom: transparenteBorderSmaller,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: none,
                widthRight: transparenteBorderSmaller,
                widthBottom: "".concat(borderSize$1, "px solid ").concat(overrideColors ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthLeft: transparenteBorderSmaller,
            },
            left: {
                positionRight: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: none,
                widthBottom: transparenteBorderSmaller,
                widthLeft: "".concat(borderSize$1, "px solid ").concat(overrideColors ||
                    ColorMapper.create(ColorMapper.getColor(color), 0.5)),
            },
        },
        light: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: replaceColor(overrideColors),
                widthRight: transparenteBorderSmaller,
                widthBottom: none,
                widthLeft: transparenteBorderSmaller,
            },
            right: {
                positionLeft: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: replaceColor(overrideColors),
                widthBottom: transparenteBorderSmaller,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: none,
                widthRight: transparenteBorderSmaller,
                widthBottom: replaceColor(overrideColors),
                widthLeft: transparenteBorderSmaller,
            },
            left: {
                positionRight: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: none,
                widthBottom: transparenteBorderSmaller,
                widthLeft: replaceColor(overrideColors),
            },
        },
    };
    return TrianglePropsSmaller[themeMode]
        ? (_a = TrianglePropsSmaller[themeMode][direction]) !== null && _a !== void 0 ? _a : TrianglePropsSmaller[themeMode].neutral
        : TrianglePropsSmaller.dark.neutral;
};
var TooltipColorMapper = {
    default: BaSeTheme.colors.institucionais.azulSebrae36,
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    attention: BaSeTheme.colors.feedbackInterface.atencao55,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};

var BaSeTooltip = function (_a) {
    var width = _a.width, _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.messageNoBreakLine, messageNoBreakLine = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.direction, direction = _e === void 0 ? 'neutral' : _e, _f = _a.color, color = _f === void 0 ? 'default' : _f, _g = _a.themeMode, themeMode = _g === void 0 ? 'light' : _g, _h = _a.coordinates, coordinates = _h === void 0 ? {} : _h, _j = _a.delayToOpen, delayToOpen = _j === void 0 ? 0 : _j, _k = _a.open, externalOpen = _k === void 0 ? false : _k, buddyRef = _a.buddyRef, _l = _a.refOutput, refOutput = _l === void 0 ? function () { } : _l, overrideColors = _a.overrideColors;
    var open = useDebounce(externalOpen, externalOpen ? delayToOpen : 0);
    var messages = Array.isArray(message) ? message : [message];
    var mappedColor = React.useCallback(function () { var _a; return (_a = TooltipColorMapper[color]) !== null && _a !== void 0 ? _a : color; }, [color, TooltipColorMapper]);
    var TriangleProps = React.useCallback(function () {
        return getTriangleMapper(themeMode, mappedColor(), direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor);
    }, [getTriangleMapper, themeMode, mappedColor, direction, overrideColors]);
    var TrianglePropsSmaller = React.useCallback(function () {
        return getTriangleMapperSmaller(themeMode, mappedColor(), direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor);
    }, [direction, mappedColor, themeMode, overrideColors]);
    var _m = useCoordinatesFromBuddyAndDirectionToAlert(buddyRef, direction, coordinates), top = _m.top, left = _m.left, bottom = _m.bottom, right = _m.right;
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            refOutput(ref === null || ref === void 0 ? void 0 : ref.current);
        }
    }, [ref, message]);
    return (React.createElement(TooltipContainer, { "aria-hidden": !open, open: open, ref: ref, top: top, left: left, bottom: bottom, right: right, width: width },
        React.createElement(TooltipTriangle, __assign({}, TriangleProps())),
        React.createElement(TooltipTriangleSmaller, __assign({}, TrianglePropsSmaller())),
        React.createElement(TooltipBody, { overrideColors: overrideColors, size: size, color: mappedColor(), themeMode: themeMode }, messages.map(function (item, index) { return (React.createElement(MessageWrapper, { key: index, messageNoBreakLine: messageNoBreakLine, color: mappedColor(), overrideColors: overrideColors, themeMode: themeMode }, size === 'small' ? (React.createElement(BaSeSmall2, null, item)) : (React.createElement(BaSeSmall1, null, item)))); }))));
};
BaSeTooltip.displayName = 'BaSeTooltip';

var TextButton = styled.span(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: ", "em;\n  font-weight: ", ";\n  font-style: normal;\n  font-family: ", ";\n  color: ", ";\n  line-height: ", "em;\n  align-self: auto;\n  margin-left: ", ";\n  margin-right: ", ";\n"], ["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: ", "em;\n  font-weight: ", ";\n  font-style: normal;\n  font-family: ", ";\n  color: ", ";\n  line-height: ", "em;\n  align-self: auto;\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (props) { return props.fontSize; }, function (props) { return props.fontWeigh; }, BaSeTheme.typography.fontFamily, function (props) { return props.color; }, function (props) { return props.lineHeight; }, function (props) {
    return !!props.hasLeftIcon ? (props.fontSize > 1 ? '12px' : '8px') : '0px';
}, function (props) {
    return !!props.hasRightIcon ? (props.fontSize > 1 ? '12px' : '8px') : '0px';
});
var templateObject_1$19;

var BaSeTextButton = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#ffffff' : _b, _c = _a.fontSize, fontSize = _c === void 0 ? 1 : _c, _d = _a.lineHeight, lineHeight = _d === void 0 ? 1.2 : _d, _e = _a.hasLeftIcon, hasLeftIcon = _e === void 0 ? false : _e, _f = _a.hasRightIcon, hasRightIcon = _f === void 0 ? false : _f, _g = _a.fontWeigh, fontWeigh = _g === void 0 ? 'normal' : _g, _h = _a.children, children = _h === void 0 ? '' : _h;
    return (React.createElement(TextButton, { color: color, fontSize: fontSize, lineHeight: lineHeight, hasLeftIcon: hasLeftIcon, hasRightIcon: hasRightIcon, fontWeigh: fontWeigh }, children));
};
BaSeTextButton.displayName = 'BaSeTextButton';

var buttonWidth = function (width) { return css(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), numberWithUnit(width)); };
var getButtonRadius = function (radius) {
    if (!radius && radius !== 0) {
        return '4px';
    }
    return "".concat(radius, "px");
};
var Button = styled.button.attrs({
    className: 'BaSe--button',
})(templateObject_5$A || (templateObject_5$A = __makeTemplateObject(["\n  &.BaSe--button {\n    box-sizing: border-box;\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: relative;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    transition: ", ";\n  }\n\n  ", ";\n"], ["\n  &.BaSe--button {\n    box-sizing: border-box;\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: relative;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    transition: ", ";\n  }\n\n  ", ";\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var backgroundColor = _a.backgroundColor, width = _a.width, border = _a.border, padding = _a.padding, minWidth = _a.minWidth, justifyContent = _a.justifyContent, backgroundOnHover = _a.backgroundOnHover, boxShadowFocus = _a.boxShadowFocus, hideBorder = _a.hideBorder, boxShadow = _a.boxShadow, thickBorder = _a.thickBorder, medium = _a.medium, borderRadius = _a.borderRadius;
    return css(templateObject_4$I || (templateObject_4$I = __makeTemplateObject(["\n    background-color: ", ";\n    ", "\n    min-width: ", "px;\n    border: ", ";\n    padding: ", ";\n    justify-content: ", ";\n    border-radius: ", ";\n    ", "\n    ", "\n\n    &:hover {\n      cursor: pointer;\n      background-color: ", ";\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: ", ";\n      ", "\n    }\n\n    &:active:not(:disabled) {\n      box-shadow: none;\n      transform: translateY(2px);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  "], ["\n    background-color: ", ";\n    ", "\n    min-width: ", "px;\n    border: ", ";\n    padding: ", ";\n    justify-content: ", ";\n    border-radius: ", ";\n    ", "\n    ", "\n\n    &:hover {\n      cursor: pointer;\n      background-color: ", ";\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: ", ";\n      ", "\n    }\n\n    &:active:not(:disabled) {\n      box-shadow: none;\n      transform: translateY(2px);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  "])), backgroundColor, buttonWidth(width), minWidth, border, padding, justifyContent, getButtonRadius(borderRadius), medium && css(templateObject_2$Y || (templateObject_2$Y = __makeTemplateObject(["\n      min-height: 40px;\n    "], ["\n      min-height: 40px;\n    "]))), boxShadow && css(templateObject_3$Q || (templateObject_3$Q = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), BaSeTheme.shadows.profundidade2), backgroundOnHover, boxShadowFocus, hideBorder &&
        "border: ".concat(thickBorder ? 2 : 1, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent, ";"));
});
var SpinnerContainer = styled.div(templateObject_7$s || (templateObject_7$s = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return css(templateObject_6$y || (templateObject_6$y = __makeTemplateObject(["\n    margin-right: ", "px;\n    display: grid;\n    place-items: center;\n  "], ["\n    margin-right: ", "px;\n    display: grid;\n    place-items: center;\n  "])), size === 'big' ? 12 : 4);
});
var templateObject_1$18, templateObject_2$Y, templateObject_3$Q, templateObject_4$I, templateObject_5$A, templateObject_6$y, templateObject_7$s;

var BaSeButton = function (_a) {
    var id = _a.id, name = _a.name, dataset = _a.dataset, _b = _a.type, type = _b === void 0 ? 'primary' : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.width, width = _e === void 0 ? 'auto' : _e, _f = _a.rightIcon, rightIcon = _f === void 0 ? '' : _f, _g = _a.leftIcon, leftIcon = _g === void 0 ? '' : _g, _h = _a.isBold, isBold = _h === void 0 ? false : _h, _j = _a.spacedIcons, spacedIcons = _j === void 0 ? false : _j, _k = _a.isDisabled, isDisabled = _k === void 0 ? false : _k, _l = _a.buttonType, buttonType = _l === void 0 ? 'button' : _l, _m = _a.color, color = _m === void 0 ? 'default' : _m, _o = _a.autoFocus, autoFocus = _o === void 0 ? false : _o, _p = _a.isLoading, isLoading = _p === void 0 ? false : _p, _q = _a.loadingText, loadingText = _q === void 0 ? 'Carregando…' : _q, _r = _a.tooltip, tooltip = _r === void 0 ? {} : _r, _s = _a.popover, popover = _s === void 0 ? {} : _s, overrideColors = _a.overrideColors, _t = _a.disableTextColorHover, disableTextColorHover = _t === void 0 ? false : _t, descriptionLeftIcon = _a.descriptionLeftIcon, descriptionRightIcon = _a.descriptionRightIcon, borderRadius = _a.borderRadius, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur;
    if (objectNotEmpty(tooltip) && objectNotEmpty(popover)) {
        throw Error('[BaSeButton] error: Informe só o "tooltip" ou o "popover"!');
    }
    var _u = React.useState(undefined), innerHeight = _u[0], setInnerHeight = _u[1];
    var formattedDataset = getFormattedDataset(dataset);
    var fontWeigh = React.useCallback(function () { return (isBold ? 'bold' : 'normal'); }, [isBold]);
    var justifyContent = React.useCallback(function () {
        return spacedIcons && (!!leftIcon || !!rightIcon) ? 'space-between' : 'center';
    }, [spacedIcons, leftIcon, rightIcon]);
    var minWidth = React.useCallback(function () { return (Number(!!leftIcon) + Number(!!rightIcon)) * 30 + 50; }, [leftIcon, rightIcon]);
    var sizeValues = React.useCallback(function () { var _a; return (_a = styleMapSize[size]) !== null && _a !== void 0 ? _a : styleMapSize.medium; }, [size]);
    var replaceObjects = React.useCallback(function (originalColors) {
        var _a, _b, _c, _d;
        if (!overrideColors) {
            if (disableTextColorHover) {
                originalColors.style.colorHover = originalColors.color;
            }
            return originalColors;
        }
        var overrides = (_b = (_a = buttonOverrideColor(overrideColors)) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : (_c = buttonOverrideColor(overrideColors)) === null || _c === void 0 ? void 0 : _c.primary;
        var finalObj = {};
        for (var key in originalColors) {
            if (key === 'style') {
                finalObj.style = {};
                // eslint-disable-next-line guard-for-in
                for (var style in originalColors.style) {
                    finalObj.style[style] =
                        ((_d = overrides === null || overrides === void 0 ? void 0 : overrides.style) === null || _d === void 0 ? void 0 : _d[style]) || originalColors.style[style];
                }
            }
            else {
                finalObj[key] = overrides[key] || originalColors[key];
            }
        }
        if (disableTextColorHover) {
            finalObj.style.colorHover = finalObj.color;
        }
        return finalObj;
    }, [color, type, overrideColors, disableTextColorHover]);
    var getColorsAtributes = React.useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (color) {
            if (!ColorMapper.isValidType(color)) {
                return ((_b = (_a = mapCustomColorsButtonValues(color, disableTextColorHover, overrideColors)) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : mapCustomColorsButtonValues(color, disableTextColorHover, overrideColors).primary);
            }
            else {
                return replaceObjects((_d = (_c = mapButtonValues[type]) === null || _c === void 0 ? void 0 : _c[color]) !== null && _d !== void 0 ? _d : (_e = mapButtonValues.primary) === null || _e === void 0 ? void 0 : _e[color]);
            }
        }
        else {
            return replaceObjects((_g = (_f = mapButtonValues[type]) === null || _f === void 0 ? void 0 : _f.default) !== null && _g !== void 0 ? _g : (_h = mapButtonValues.primary) === null || _h === void 0 ? void 0 : _h.default);
        }
    }, [
        ColorMapper,
        mapButtonValues,
        type,
        color,
        overrideColors,
        disableTextColorHover,
        replaceObjects,
    ]);
    var buttonValues = React.useCallback(function () {
        var _a, _b, _c;
        return isDisabled
            ? color === 'negative'
                ? (_a = mapButtonValues[type].negative) === null || _a === void 0 ? void 0 : _a.disabled
                : (_c = (_b = mapButtonValues[type]) === null || _b === void 0 ? void 0 : _b.disabled) !== null && _c !== void 0 ? _c : mapButtonValues.primary.disabled
            : getColorsAtributes();
    }, [type, getColorsAtributes, mapButtonValues, isDisabled]);
    var _v = buttonValues(), _w = _v.style, bgC = _w.bgC, bcCHover = _w.bcCHover, boxShadowFocus = _w.boxShadowFocus, border = _w.border, colorHover = _w.colorHover, iconColor = _v.iconColor, buttonColor = _v.color;
    var _x = sizeValues(), fontSize = _x.fontSize, lineHeight = _x.lineHeight, padding = _x.padding, loadingSize = _x.loadingSize;
    var _y = React.useState(false), isTooltipOrPopoverOpen = _y[0], setIsTooltipOrPopoverOpen = _y[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _z = React.useState(false), hasHover = _z[0], setHasHover = _z[1];
    var buttonRef = React.useRef(null);
    var handleClick = React.useCallback(function (e) {
        var _a;
        if (!isLoading) {
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            onClick(e);
            setTimeout(function () { return setIsTooltipOrPopoverOpen(false); }, 1);
        }
    }, [isLoading, buttonRef, onClick]);
    var checkHover = React.useCallback(function (defaultColor) {
        return (type !== 'primary' ||
            (type === 'primary' && color === 'negative')) &&
            hasHover &&
            !!colorHover
            ? colorHover
            : defaultColor;
    }, [type, hasHover, colorHover]);
    var getBorderRadiusBasedHeight = React.useCallback(function () {
        var _a;
        var mappedHeight = (_a = mapButtonHeight[size]) !== null && _a !== void 0 ? _a : mapButtonHeight.medium;
        return (innerHeight !== null && innerHeight !== void 0 ? innerHeight : mappedHeight) / 2;
    }, [innerHeight, size]);
    var handleGetBorderRadius = React.useMemo(function () {
        return borderRadius === 'max' ? getBorderRadiusBasedHeight() : borderRadius;
    }, [borderRadius, getBorderRadiusBasedHeight]);
    React.useEffect(function () {
        var _a;
        setInnerHeight((_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
    }, [buttonRef]);
    return (React.createElement(Button, __assign({ id: id, name: name }, formattedDataset, { ref: buttonRef, autoFocus: autoFocus, disabled: isDisabled, type: buttonType, backgroundColor: bgC, backgroundOnHover: bcCHover, border: border, hideBorder: type === 'secondary' || color === 'negative', padding: padding, width: width, minWidth: minWidth(), justifyContent: justifyContent(), boxShadowFocus: boxShadowFocus, borderRadius: handleGetBorderRadius, "aria-label": isLoading ? loadingText : value, boxShadow: type !== 'tertiary' && color !== 'negative', thickBorder: color === 'negative', medium: size === 'medium', onClick: handleClick, onMouseEnter: function () {
            setHasHover(true);
            setIsTooltipOrPopoverOpen(true);
        }, onMouseLeave: function () {
            setHasHover(false);
            setIsTooltipOrPopoverOpen(false);
        }, onFocus: function (e) {
            setHasHover(true);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
            setIsTooltipOrPopoverOpen(true);
        }, onBlur: function (e) {
            setHasHover(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            setIsTooltipOrPopoverOpen(false);
        } }),
        isLoading ? (React.createElement(React.Fragment, null,
            React.createElement(SpinnerContainer, { size: size },
                React.createElement(BaSeLoadingSpinner, { description: getMessage('loading.description'), diameter: loadingSize, color: color, type: type, disabled: isDisabled })),
            React.createElement(BaSeTextButton, { fontSize: fontSize, lineHeight: lineHeight, color: checkHover(buttonColor), hasLeftIcon: !!leftIcon, hasRightIcon: !!rightIcon, fontWeigh: fontWeigh() }, loadingText))) : (React.createElement(React.Fragment, null,
            !!leftIcon && (React.createElement(BaSeIcon, { description: (descriptionLeftIcon === null || descriptionLeftIcon === void 0 ? void 0 : descriptionLeftIcon.trim()) ||
                    getMessage('buttonIcon.defaultDescription'), name: leftIcon, size: Math.floor(fontSize * 16), color: checkHover(iconColor) })),
            React.createElement(BaSeTextButton, { fontSize: fontSize, lineHeight: lineHeight, color: checkHover(buttonColor), hasLeftIcon: !!leftIcon, hasRightIcon: !!rightIcon, fontWeigh: fontWeigh() }, value),
            !!rightIcon && (React.createElement(BaSeIcon, { description: (descriptionRightIcon === null || descriptionRightIcon === void 0 ? void 0 : descriptionRightIcon.trim()) ||
                    getMessage('buttonIcon.defaultDescription'), name: rightIcon, size: Math.floor(fontSize * 16), color: checkHover(iconColor) })))),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, __assign({ buddyRef: buttonRef, open: isTooltipOrPopoverOpen }, tooltip))),
        objectNotEmpty(popover) && (React.createElement(BaSePopover, __assign({ buddyRef: buttonRef, open: isTooltipOrPopoverOpen, hasCloseButton: false }, popover)))));
};
BaSeButton.displayName = 'BaSeButton';

var BaSeShapeButton = React.forwardRef(function (_a, forwardedRef) {
    var tooltip = _a.tooltip, popover = _a.popover, onClick = _a.onClick, iconButtonProps = __rest(_a, ["tooltip", "popover", "onClick"]);
    if (objectNotEmpty(tooltip) && objectNotEmpty(popover)) {
        throw Error('[BaSeShapeButton] error: Informe só o "tooltip" ou o "popover"!');
    }
    var buttonRef = React.useRef(null);
    React.useImperativeHandle(forwardedRef, function () { return ({
        focus: function () { var _a, _b; return (_b = (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a); },
        click: function () { var _a, _b; return (_b = (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a); },
    }); }, [buttonRef]);
    var _b = React.useState(false), isTooltipOrPopoverOpen = _b[0], setIsTooltipOrPopoverOpen = _b[1];
    var handleClick = React.useCallback(function (event) {
        var _a;
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onClick(event);
        var timeout = setTimeout(function () {
            var _a;
            if ((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.isConnected) {
                setIsTooltipOrPopoverOpen(false);
            }
        }, 1);
        return function () { return clearTimeout(timeout); };
    }, [onClick, buttonRef]);
    return (React.createElement(BaSeIconButton, __assign({}, iconButtonProps, { ref: buttonRef, onClick: handleClick, onMouseEnter: function () { return setIsTooltipOrPopoverOpen(true); }, onMouseLeave: function () { return setIsTooltipOrPopoverOpen(false); } }),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, __assign({ buddyRef: buttonRef, open: isTooltipOrPopoverOpen }, tooltip))),
        objectNotEmpty(popover) && (React.createElement(BaSePopover, __assign({ buddyRef: buttonRef, open: isTooltipOrPopoverOpen, hasCloseButton: false }, popover)))));
});
BaSeShapeButton.displayName = 'BaSeShapeButton';

var StyledHeading5 = makeDefaultTypographyStyled('Heading5', 'h5', 1.2, 1.2);

var BaSeHeading5 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 1.2, lineHeight: 1.2, wrapper: StyledHeading5 }, props), props.children)); };
BaSeHeading5.displayName = 'BaSeHeading5';

var diameterBaseRadius = 24;
var checkNumber = function (num) {
    return typeof num === 'number';
};
var handleFloor = function (num) {
    num = num < 0 ? 0 : num > 100 ? 100 : num;
    return Math.floor(num);
};
var BaSeLoading = function (_a) {
    var _b = _a.text, text = _b === void 0 ? 'Carregando…' : _b, textColor = _a.textColor, spinnerColor = _a.spinnerColor, progress = _a.progress, _c = _a.lightMode, lightMode = _c === void 0 ? 'default' : _c, _d = _a.shadowLevel, shadowLevel = _d === void 0 ? 0 : _d, backgroundColor = _a.backgroundColor, spinnerSize = _a.spinnerSize, roundedCorner = _a.roundedCorner;
    var _e = React.useState({}), accessibility = _e[0], setAcessibility = _e[1];
    var handleColor = function () {
        if (textColor) {
            return textColor;
        }
        return lightMode === 'default'
            ? BaSeTheme.colors.institucionais.azulSebrae
            : BaSeTheme.colors.defaultColors.white;
    };
    var handleShadow = function () {
        if (!shadowLevel || shadowLevel < 0) {
            return 'none;';
        }
        var options = [2, 4, 8, 16, 32, 64];
        var filtered = options.find(function (opt) { return opt === shadowLevel; });
        if (filtered) {
            return BaSeTheme.shadows['profundidade' + filtered];
        }
        else {
            var index = -1;
            var space = 99;
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (var i = 0; i < options.length; i++) {
                if (space >= Math.abs(shadowLevel - options[i])) {
                    index = i;
                    space = Math.abs(shadowLevel - options[i]);
                }
            }
            return BaSeTheme.shadows['profundidade' + options[index]];
        }
    };
    React.useEffect(function () {
        if (checkNumber(progress)) {
            setAcessibility({
                'aria-valuenow': handleFloor(progress !== null && progress !== void 0 ? progress : 0),
                'aria-valuemin': 0,
                'aria-valuemax': 100,
            });
        }
    }, [progress]);
    return (React.createElement(LoadingContainer, { roundedCorner: roundedCorner, shadow: handleShadow(), backgroundColor: backgroundColor },
        React.createElement(LoadingItems, __assign({ role: checkNumber(progress) ? 'slider' : 'presentation' }, accessibility),
            React.createElement(BaSeLoadingSpinner, { color: spinnerColor, type: lightMode === 'default' ? 'tertiary' : 'primary', description: false, diameter: spinnerSize !== null && spinnerSize !== void 0 ? spinnerSize : diameterBaseRadius }),
            React.createElement(BaSeHeading5, { color: handleColor() },
                text,
                " ",
                checkNumber(progress) && "(".concat(handleFloor(progress !== null && progress !== void 0 ? progress : 0), "%)")))));
};
BaSeLoading.displayName = 'BaSeLoading';

var StyledHeading4 = makeDefaultTypographyStyled('Heading4', 'h4', 1.44, 1.2);

var BaSeHeading4 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 1.44, lineHeight: 1.2, wrapper: StyledHeading4 }, props), props.children)); };
BaSeHeading4.displayName = 'BaSeHeading4';

var zIndexOverlay = BaSeTheme.stackOrder.overlay * 2;
function widthMobile() {
    return "90%";
}
function widthTablet(size) {
    if (size === 'large') {
        return '450px';
    }
    if (size === 'medium') {
        return '450px';
    }
    return '390px';
}
function widthDesktop(size) {
    if (size === 'large') {
        return '570px';
    }
    if (size === 'medium') {
        return '450px';
    }
    return '390px';
}
function setModalWidth(isFluid, delimiter, defaultStyle) {
    if (!isFluid) {
        return defaultStyle;
    }
    return css(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n    width: 90%;\n    max-width: ", ";\n  "], ["\n    width: 90%;\n    max-width: ", ";\n  "])), numberWithUnit(BaSeTheme.breakpoints[delimiter].maxWidth));
}
var fadeIn$1 = keyframes(templateObject_2$X || (templateObject_2$X = __makeTemplateObject(["\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"])));
var ModalContainer = styled.div(templateObject_3$P || (templateObject_3$P = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  z-index: ", ";\n  box-sizing: border-box;\n\n  &,\n  &::before {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  &::before {\n    content: '';\n    background: ", ";\n    opacity: 0.5;\n  }\n"], ["\n  display: grid;\n  place-items: center;\n  z-index: ", ";\n  box-sizing: border-box;\n\n  &,\n  &::before {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  &::before {\n    content: '';\n    background: ", ";\n    opacity: 0.5;\n  }\n"])), zIndexOverlay + 0, BaSeTheme.colors.institucionais.cinzaSebrae20);
var CloseButtonContainer = styled.div(templateObject_4$H || (templateObject_4$H = __makeTemplateObject(["\n  position: relative;\n  background-color: none;\n"], ["\n  position: relative;\n  background-color: none;\n"])));
var ModalDialog = styled.div(templateObject_7$r || (templateObject_7$r = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  border: 2px solid ", ";\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n\n  will-change: opacity, transform;\n  animation: ", " ", " forwards;\n\n  ", "\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  border: 2px solid ", ";\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n\n  will-change: opacity, transform;\n  animation: ", " ", " forwards;\n\n  ", "\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.shadows.profundidade32, zIndexOverlay + 1, BaSeTheme.colors.institucionais.azulSebrae90, fadeIn$1, BaSeTheme.transitions.durationNormal, function (_a) {
    var size = _a.size, delimiter = _a.delimiter, isFluid = _a.isFluid;
    return css(templateObject_6$x || (templateObject_6$x = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), setModalWidth(isFluid, delimiter, css(templateObject_5$z || (templateObject_5$z = __makeTemplateObject(["\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      "], ["\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      "])), BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n            width: ".concat(widthMobile(), ";\n            min-width: ").concat(widthMobile(), ";\n            max-width: ").concat(widthMobile(), ";\n        ")), BaSeTheme.breakpoints.mobile.mediaQueryCss("\n            width: ".concat(widthMobile(), ";\n            min-width: ").concat(widthMobile(), ";\n            max-width: ").concat(widthMobile(), ";\n        ")), BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n            width: ".concat(widthMobile(), ";\n            min-width: ").concat(widthMobile(), ";\n            max-width: ").concat(widthMobile(), ";\n        ")), BaSeTheme.breakpoints.tablet.mediaQueryCss("\n            width: ".concat(widthTablet(size), ";\n            min-width: ").concat(widthTablet(size), ";\n            max-width: ").concat(widthTablet(size), ";\n        ")), BaSeTheme.breakpoints.desktop.mediaQueryCss("\n            width: ".concat(widthDesktop(size), ";\n            min-width: ").concat(widthDesktop(size), ";\n            max-width: ").concat(widthDesktop(size), ";\n        ")), BaSeTheme.breakpoints.desktopLarge.mediaQueryCss("\n            width: ".concat(widthDesktop(size), ";\n            min-width: ").concat(widthDesktop(size), ";\n            max-width: ").concat(widthDesktop(size), ";\n        ")))));
});
var ModalHeader = styled.div(templateObject_8$q || (templateObject_8$q = __makeTemplateObject(["\n  margin: 0;\n  padding: 1em;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  border: none;\n  border-bottom: 1px solid ", ";\n"], ["\n  margin: 0;\n  padding: 1em;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  border: none;\n  border-bottom: 1px solid ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90);
var ModalBody = styled.div(templateObject_9$o || (templateObject_9$o = __makeTemplateObject(["\n  margin: 0;\n  padding: 1.5em 1.5em 2em;\n  overflow: auto;\n  max-height: calc(100vh - 15em);\n\n  &#", " {\n    &,\n    > * {\n      box-sizing: border-box;\n    }\n  }\n"], ["\n  margin: 0;\n  padding: 1.5em 1.5em 2em;\n  overflow: auto;\n  max-height: calc(100vh - 15em);\n\n  &#", " {\n    &,\n    > * {\n      box-sizing: border-box;\n    }\n  }\n"])), function (_a) {
    var id = _a.id;
    return id;
});
var ModalFooter = styled.div(templateObject_10$m || (templateObject_10$m = __makeTemplateObject(["\n  margin: 0;\n  padding: 2em 0 0;\n  display: flex;\n  gap: 1em;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: ", ";\n  align-items: center;\n  &:empty {\n    padding-bottom: 0;\n  }\n"], ["\n  margin: 0;\n  padding: 2em 0 0;\n  display: flex;\n  gap: 1em;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: ", ";\n  align-items: center;\n  &:empty {\n    padding-bottom: 0;\n  }\n"])), function (_a) {
    var _b = _a.alignActions, alignActions = _b === void 0 ? 'start' : _b;
    return alignActions === 'center' ? 'center' : "flex-".concat(alignActions);
});
var templateObject_1$17, templateObject_2$X, templateObject_3$P, templateObject_4$H, templateObject_5$z, templateObject_6$x, templateObject_7$r, templateObject_8$q, templateObject_9$o, templateObject_10$m;

var ModalContent = React.memo(function (_a) {
    var _b;
    var content = _a.content, onClose = _a.onClose, onContentEvent = _a.onContentEvent;
    return (React.createElement(React.Fragment, null, (_b = content === null || content === void 0 ? void 0 : content({
        closeModal: onClose,
        emitEvent: onContentEvent !== null && onContentEvent !== void 0 ? onContentEvent : (function () { }),
    })) !== null && _b !== void 0 ? _b : React.createElement(BaSeLoading, null)));
});
ModalContent.displayName = 'ModalContent';
var idSequence$d = idGenerator();
function forcePromise(what) {
    if (!(what instanceof Promise)) {
        return Promise.resolve(what);
    }
    return what;
}
var BaSeModal = function (_a) {
    var size = _a.size, title = _a.title, titleColor = _a.titleColor, leftImage = _a.leftImage, rightImage = _a.rightImage, _b = _a.actions, actions = _b === void 0 ? ['Fechar'] : _b, _c = _a.alignActions, alignActions = _c === void 0 ? 'start' : _c, _d = _a.dismissible, dismissible = _d === void 0 ? true : _d, _e = _a.dismissibleIconColor, dismissibleIconColor = _e === void 0 ? 'negative' : _e, _f = _a.dismissibleIconType, dismissibleIconType = _f === void 0 ? 'primary' : _f, _g = _a.dismissibleIconName, dismissibleIconName = _g === void 0 ? 'close-big' : _g, _h = _a.isFluid, isFluid = _h === void 0 ? false : _h, _j = _a.breakpointDelimiter, breakpointDelimiter = _j === void 0 ? 'desktopLarge' : _j, beforeClose = _a.beforeClose, onClose = _a.onClose, onCancel = _a.onCancel, onContentEvent = _a.onContentEvent, content = _a.content;
    var modalId = useNextCounterId(idSequence$d);
    if (leftImage || rightImage) {
        throw Error("\n      [BaSeModal] Imagens nas laterais ainda n\u00E3o est\u00E1 liberado no \"showModal\"!\n    ");
    }
    var _k = React.useState(false), dismiss = _k[0], setDismiss = _k[1];
    var _l = React.useState(), actionSelected = _l[0], setActionSelected = _l[1];
    var _m = React.useState(actions.map(function () { return false; })), actionLoading = _m[0], setActionLoading = _m[1];
    React.useEffect(function () {
        if (dismiss) {
            return onCancel();
        }
        if (actionSelected) {
            return onClose(actionSelected);
        }
    }, [actionSelected, dismiss]);
    var dismissing = React.useCallback(function () { return setDismiss(true); }, [setDismiss]);
    var handleDismissibleAction = React.useCallback(function (event) {
        var _a;
        var path = Array.from((_a = event === null || event === void 0 ? void 0 : event.path) !== null && _a !== void 0 ? _a : []);
        return (path.filter(function (element) {
            var _a;
            var classList = Array.from((_a = element.classList) !== null && _a !== void 0 ? _a : []);
            return classList.includes('BaSe--notification-dialog');
        }).length <= 0);
    }, []);
    var handleClickAction = React.useCallback(function (actionConfig) {
        var _a;
        var mounted = true;
        var action = typeof actionConfig === 'string' ? actionConfig : actionConfig.action;
        setActionLoading(actions.map(function (actualActionConfig) { return actionConfig === actualActionConfig; }));
        forcePromise((_a = beforeClose === null || beforeClose === void 0 ? void 0 : beforeClose(action)) !== null && _a !== void 0 ? _a : true)
            .then(function (canClose) {
            return mounted && setActionSelected(canClose ? action : undefined);
        })
            .finally(function () { return mounted && setActionLoading(actions.map(function () { return false; })); });
        return function () { return (mounted = false); };
    }, [setActionSelected]);
    return (React.createElement(ModalContainer, { className: "BaSe--modal-container" },
        React.createElement(FocusTrap, { focusTrapOptions: {
                delayInitialFocus: true,
                escapeDeactivates: dismissible,
                clickOutsideDeactivates: dismissible && handleDismissibleAction,
                allowOutsideClick: true,
                onDeactivate: dismissing,
            } },
            React.createElement(ModalDialog, { className: "BaSe--modal-dialog", role: "dialog", "aria-labelledby": "BaSe--modal-title-".concat(modalId), "aria-describedby": "BaSe--modal-description-".concat(modalId), "aria-modal": "true", isFluid: !!isFluid, delimiter: breakpointDelimiter, size: size },
                title && (React.createElement(ModalHeader, { className: "BaSe--modal-header" },
                    React.createElement("span", { id: "BaSe--modal-title-".concat(modalId) }, typeof title === 'string' ? (React.createElement(BaSeHeading4, { color: titleColor !== null && titleColor !== void 0 ? titleColor : BaSeTheme.colors.institucionais.cinzaSebrae45, isBold: true }, title)) : (title())),
                    dismissible && (React.createElement(CloseButtonContainer, null,
                        React.createElement(BaSeShapeButton, { buttonType: "button", nameIcon: dismissibleIconName, shape: "circle", size: "small", sizeIcon: "small", type: dismissibleIconType, color: dismissibleIconColor, onClick: function () { return dismissing(); } }))))),
                React.createElement(ModalBody, { id: "BaSe--modal-description-".concat(modalId) },
                    React.createElement(ModalContent, { content: content, onClose: onClose, onContentEvent: onContentEvent }),
                    (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && (React.createElement(ModalFooter, { className: "BaSe--modal-footer", alignActions: alignActions }, actions.map(function (action, index) {
                        var _a, _b, _c;
                        return (React.createElement(BaSeButton, { key: typeof action === 'string' ? action : action.action, autoFocus: index === 0, buttonType: "button", size: "medium", onClick: function () { return handleClickAction(action); }, type: typeof action === 'string'
                                ? "".concat(index === 0 ? 'primary' : 'secondary')
                                : (_a = action === null || action === void 0 ? void 0 : action.type) !== null && _a !== void 0 ? _a : "".concat(index === 0 ? 'primary' : 'secondary'), color: typeof action === 'string'
                                ? 'default'
                                : (_b = action === null || action === void 0 ? void 0 : action.color) !== null && _b !== void 0 ? _b : 'default', value: typeof action === 'string' ? action : action.action, loadingText: typeof action !== 'string'
                                ? (_c = action === null || action === void 0 ? void 0 : action.loadingText) !== null && _c !== void 0 ? _c : undefined
                                : undefined, isLoading: actionLoading[index] }));
                    }))))))));
};
BaSeModal.displayName = 'BaSeModal';

var AlertColorTypes = {
    attention: {
        background: BaSeTheme.colors.feedbackInterface.atencao75,
        foreground: BaSeTheme.colors.feedbackInterface.atencao55,
    },
    confirmation: {
        background: BaSeTheme.colors.feedbackInterface.sucesso85,
        foreground: BaSeTheme.colors.feedbackInterface.sucesso45,
    },
    default: {
        background: BaSeTheme.colors.institucionais.cinzaSebrae90,
        foreground: BaSeTheme.colors.institucionais.azulSebrae60,
    },
    destructive: {
        background: BaSeTheme.colors.gestao.vermelho90,
        foreground: BaSeTheme.colors.feedbackInterface.erro35,
    },
};
var MessageColorTypes = {
    attention: {
        foreground: BaSeTheme.colors.feedbackInterface.atencao35,
        background: BaSeTheme.colors.feedbackInterface.atencao75,
    },
    confirmation: {
        foreground: BaSeTheme.colors.feedbackInterface.sucesso20,
        background: BaSeTheme.colors.feedbackInterface.sucesso85,
    },
    default: {
        foreground: BaSeTheme.colors.institucionais.azulSebrae36,
        background: BaSeTheme.colors.institucionais.azulSebrae75,
    },
    destructive: {
        foreground: BaSeTheme.colors.feedbackInterface.erro35,
        background: BaSeTheme.colors.gestao.vermelho90,
    },
};
var getAlertColorFromType = function (type) { var _a; return (_a = AlertColorTypes[type]) !== null && _a !== void 0 ? _a : AlertColorTypes.default; };
var getMessageColorFromType = function (type) { var _a; return (_a = MessageColorTypes[type]) !== null && _a !== void 0 ? _a : MessageColorTypes.default; };

var emptyingBar = keyframes(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject(["\n  from {\n    transform: scaleX(1)\n  }\n  to {\n    transform: scaleX(0)\n  }\n"], ["\n  from {\n    transform: scaleX(1)\n  }\n  to {\n    transform: scaleX(0)\n  }\n"])));
var fillingBar = keyframes(templateObject_2$W || (templateObject_2$W = __makeTemplateObject(["\n  from {\n    transform: scaleX(0)\n  }\n  to {\n    transform: scaleX(1)\n  }\n"], ["\n  from {\n    transform: scaleX(0)\n  }\n  to {\n    transform: scaleX(1)\n  }\n"])));
var ProgressBarBackground = styled.div(templateObject_3$O || (templateObject_3$O = __makeTemplateObject(["\n  background: ", ";\n  position: absolute;\n  width: 100%;\n  height: ", ";\n  bottom: 0;\n  left: 0;\n"], ["\n  background: ", ";\n  position: absolute;\n  width: 100%;\n  height: ", ";\n  bottom: 0;\n  left: 0;\n"])), function (p) {
    return p.color ? p.color : BaSeTheme.colors.institucionais.cinzaSebrae90;
}, function (_a) {
    var size = _a.size;
    return numberWithUnit(size);
});
var ProgressBarWrapped = styled.div(templateObject_4$G || (templateObject_4$G = __makeTemplateObject(["\n  animation: ", " linear\n    1 forwards;\n  animation-duration: ", ";\n  animation-play-state: ", ";\n  background: ", ";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: ", ";\n  z-index: ", ";\n  transform-origin: left;\n"], ["\n  animation: ", " linear\n    1 forwards;\n  animation-duration: ", ";\n  animation-play-state: ", ";\n  background: ", ";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: ", ";\n  z-index: ", ";\n  transform-origin: left;\n"])), function (p) { return (p.type === 'emptying' ? emptyingBar : fillingBar); }, function (p) { return "".concat(p.animationDuration, "ms"); }, function (p) { return p.animationPlayStyle; }, function (p) {
    return p.color ? p.color : BaSeTheme.colors.institucionais.cinzaSebrae60;
}, function (_a) {
    var size = _a.size;
    return numberWithUnit(size);
}, BaSeTheme.stackOrder.aboveNormal);
var templateObject_1$16, templateObject_2$W, templateObject_3$O, templateObject_4$G;

function useProgress(_a) {
    var loadingDuration = _a.loadingDuration, type = _a.type, onFinish = _a.onFinish, ref = _a.ref;
    var _b = React__default.useState(true), isRunning = _b[0], setIsRunning = _b[1];
    var _c = React__default.useState(true), loading = _c[0], setLoading = _c[1];
    var initialProgress = type === 'filling' ? 1 : 99;
    var _d = React__default.useState(initialProgress), progress = _d[0], setProgress = _d[1];
    var progressOffset = type === 'filling' ? progress + 1 : progress - 1;
    var resume = React__default.useCallback(function () {
        if (loadingDuration > 0) {
            setIsRunning(true);
        }
    }, [loadingDuration]);
    var pause = React__default.useCallback(function () {
        if (loadingDuration > 0) {
            setIsRunning(false);
        }
    }, [isRunning, loadingDuration]);
    React__default.useEffect(function () {
        var loadingTimeout = setTimeout(function () {
            if (loading && isRunning) {
                setProgress(progressOffset);
            }
        }, loadingDuration / 100);
        if (progress === 0 || progress === 100) {
            if (onFinish && loading) {
                onFinish();
                clearTimeout(loadingTimeout);
            }
            setLoading(false);
        }
        return function () {
            clearTimeout(loadingTimeout);
        };
    }, [progress, loading, progressOffset, loadingDuration, isRunning]);
    React__default.useImperativeHandle(ref, function () { return ({ pause: pause, resume: resume }); });
    return {
        progress: progress,
        loading: loading,
        isRunning: isRunning,
    };
}

var BaSeProgressBar = React.forwardRef(function (_a, ref) {
    var backgroundColor = _a.backgroundColor, foregroundColor = _a.foregroundColor, closeOnTimeout = _a.closeOnTimeout, loadingDuration = _a.loadingDuration, _b = _a.type, type = _b === void 0 ? 'emptying' : _b, _c = _a.size, size = _c === void 0 ? 6 : _c, onFinish = _a.onFinish;
    var _d = useProgress({
        loadingDuration: loadingDuration,
        closeOnTimeout: closeOnTimeout,
        type: type,
        onFinish: onFinish,
        ref: ref,
    }), loading = _d.loading, isRunning = _d.isRunning;
    if (loading || !closeOnTimeout) {
        return (React.createElement(React.Fragment, null,
            React.createElement(ProgressBarBackground, { size: size, color: backgroundColor }),
            React.createElement(ProgressBarWrapped, { size: size, "aria-label": "progress bar", role: "progressbar", color: foregroundColor, animationDuration: loadingDuration, animationPlayStyle: isRunning ? 'running' : 'paused', type: type ? type : 'emptying' })));
    }
    return null;
});
BaSeProgressBar.displayName = 'BaSeProgressBar';

var ProgressCircleWrapper = styled.div(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  .BaSe--progress-circle-progress-line {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  .BaSe--progress-circle-progress-line {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n  }\n"])));
var templateObject_1$15;

var BaSeProgressCircle = React.forwardRef(function (_a, ref) {
    var _b = _a.closeOnTimeout, closeOnTimeout = _b === void 0 ? false : _b, _c = _a.loadingDuration, loadingDuration = _c === void 0 ? 3000 : _c, _d = _a.indicatorWidth, indicatorWidth = _d === void 0 ? 3 : _d, _e = _a.indicatorColor, indicatorColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _e, _f = _a.size, size = _f === void 0 ? 100 : _f, _g = _a.trackColor, trackColor = _g === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _g, _h = _a.trackWidth, trackWidth = _h === void 0 ? 3 : _h, _j = _a.type, type = _j === void 0 ? 'emptying' : _j, children = _a.children, onFinish = _a.onFinish;
    var _k = useProgress({
        loadingDuration: loadingDuration,
        closeOnTimeout: closeOnTimeout,
        type: type,
        onFinish: onFinish,
        ref: ref,
    }), progress = _k.progress, loading = _k.loading;
    var center = size / 2;
    var radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth);
    var dashArray = 2 * Math.PI * radius;
    var dashOffset = dashArray * ((100 - progress) / 100);
    return (React.createElement(React.Fragment, null, (loading || !closeOnTimeout) && (React.createElement(ProgressCircleWrapper, null,
        React.createElement("div", null,
            React.createElement("svg", { className: "BaSe--progress-circle-progress-line", width: size, height: size },
                React.createElement("circle", { cx: center, cy: center, fill: "transparent", r: radius, stroke: trackColor, strokeWidth: trackWidth }),
                React.createElement("circle", { cx: center, cy: center, fill: "transparent", r: radius, stroke: indicatorColor, strokeDasharray: dashArray, strokeDashoffset: dashOffset, strokeLinecap: "round", strokeWidth: indicatorWidth })),
            React.createElement("div", null, children))))));
});
BaSeProgressCircle.displayName = 'BaSeProgressCircle';

var StyledHeading6 = makeDefaultTypographyStyled('Heading6', 'h6', 1, 1.2);

var BaSeHeading6 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 1, lineHeight: 1.2, wrapper: StyledHeading6 }, props), props.children)); };
BaSeHeading6.displayName = 'BaSeHeading6';

var StyledParagraph = makeDefaultTypographyStyled('Paragraph', 'p', 1, 1.46);

var BaSeParagraph = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 1, lineHeight: 1.46, wrapper: StyledParagraph }, props), props.children)); };
BaSeParagraph.displayName = 'BaSeParagraph';

var mapNotificationValues = function (color) {
    return {
        primary: {
            generalColors: {
                color: ColorMapper[color].hover.defaultDark,
                style: {
                    bgC: ColorMapper[color].hover.defaultLight,
                },
            },
        },
    };
};
var mapCustomColorsNotificationValues = function (customColor) {
    var customColorHsv = Color.generateFromHex(customColor);
    return {
        primary: {
            color: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        },
    };
};

var show = keyframes(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject(["\n  from {\n    transform: translate(-50%, -100%);\n  }\n  to {\n    transform: translate(-50%, 0);\n  }\n"], ["\n  from {\n    transform: translate(-50%, -100%);\n  }\n  to {\n    transform: translate(-50%, 0);\n  }\n"])));
var NotificationDialog = styled.div(templateObject_2$V || (templateObject_2$V = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 0.75em;\n  align-items: flex-start;\n  padding: 0.75em;\n  border-radius: 0.25em;\n  box-shadow: ", ";\n  width: 90%;\n  max-width: 390px;\n  position: fixed;\n  overflow: hidden;\n  top: 5%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  z-index: ", ";\n  transition: ", ";\n  background: ", ";\n  animation: ", " ", "\n    ", " 1;\n\n  &.exiting {\n    transform: translate(-50%, -100%);\n  }\n\n  .message {\n    flex: 1;\n    word-break: break-word;\n  }\n\n  h6 {\n    color: ", ";\n  }\n\n  p {\n    color: ", ";\n  }\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 0.75em;\n  align-items: flex-start;\n  padding: 0.75em;\n  border-radius: 0.25em;\n  box-shadow: ", ";\n  width: 90%;\n  max-width: 390px;\n  position: fixed;\n  overflow: hidden;\n  top: 5%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  z-index: ", ";\n  transition: ", ";\n  background: ", ";\n  animation: ", " ", "\n    ", " 1;\n\n  &.exiting {\n    transform: translate(-50%, -100%);\n  }\n\n  .message {\n    flex: 1;\n    word-break: break-word;\n  }\n\n  h6 {\n    color: ", ";\n  }\n\n  p {\n    color: ", ";\n  }\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"])), BaSeTheme.shadows.profundidade16, zIndexOverlay + 1, "\n    transform\n    ".concat(BaSeTheme.transitions.durationNormal, "\n    ").concat(BaSeTheme.transitions.elasticTimingFunction, "\n  "), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, show, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.elasticTimingFunction, function (_a) {
    var color = _a.color;
    return color;
}, BaSeTheme.colors.institucionais.cinzaSebrae30, BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n    top: unset;\n    bottom: 5%;\n  "), BaSeTheme.breakpoints.mobile.mediaQueryCss("\n    top: unset;\n    bottom: 5%;\n  "), BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n    top: unset;\n    bottom: 5%;\n  "));
var templateObject_1$14, templateObject_2$V;

var ExitingMode;
(function (ExitingMode) {
    ExitingMode[ExitingMode["forced"] = 0] = "forced";
    ExitingMode[ExitingMode["auto"] = 1] = "auto";
    ExitingMode[ExitingMode["action"] = 2] = "action";
})(ExitingMode || (ExitingMode = {}));
var iconColorMap = {
    attention: 'exclamation-triangle',
    default: 'info-circle',
    destructive: 'exclamation-octagon',
    confirmation: 'check-circle',
};
var idSequence$c = idGenerator();
var BaSeNotification = function (_a) {
    var color = _a.color, icon = _a.icon, message = _a.message, supportMessage = _a.supportMessage, _b = _a.showCloseButton, showCloseButton = _b === void 0 ? true : _b, _c = _a.secondsToClose, secondsToClose = _c === void 0 ? 5 : _c, progressAnimationTypeExternal = _a.progressAnimationType, action = _a.action, onClose = _a.onClose, onAction = _a.onAction;
    var counterId = useNextCounterId(idSequence$c);
    var iconName = React.useMemo(function () {
        var iconNameDefault = iconColorMap[color];
        return icon === false ? undefined : icon !== null && icon !== void 0 ? icon : iconNameDefault;
    }, [color, icon]);
    var progressAnimationType = React.useMemo(function () { return progressAnimationTypeExternal !== null && progressAnimationTypeExternal !== void 0 ? progressAnimationTypeExternal : (showCloseButton ? 'circle' : 'bar'); }, [progressAnimationTypeExternal, showCloseButton]);
    var _d = React.useState(), exiting = _d[0], setExiting = _d[1];
    var progressRef = React.useRef(null);
    var autoClose = React.useCallback(function () {
        setExiting(ExitingMode.auto);
    }, []);
    var forceClose = React.useCallback(function () {
        setExiting(ExitingMode.forced);
    }, []);
    var actionClose = React.useCallback(function () { return setExiting(ExitingMode.action); }, []);
    var pause = React.useCallback(function () {
        var _a;
        (_a = progressRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    }, []);
    var resume = React.useCallback(function () {
        var _a;
        (_a = progressRef.current) === null || _a === void 0 ? void 0 : _a.resume();
    }, []);
    React.useEffect(function () {
        if (exiting === ExitingMode.forced) {
            var timeout_1 = setTimeout(function () { return onClose(true); }, BaSeTheme.transitions.durationFastInMilliseconds);
            return function () { return clearTimeout(timeout_1); };
        }
        if (exiting === ExitingMode.auto) {
            var timeout_2 = setTimeout(function () { return onClose(false); }, BaSeTheme.transitions.durationFastInMilliseconds);
            return function () { return clearTimeout(timeout_2); };
        }
        if (exiting === ExitingMode.action) {
            var timeout_3 = setTimeout(function () { return onAction(); }, BaSeTheme.transitions.durationFastInMilliseconds);
            return function () { return clearTimeout(timeout_3); };
        }
        return;
    }, [exiting, onAction, onClose]);
    React.useEffect(function () {
        var shownTimeout = setTimeout(function () { var _a; return (_a = navigator === null || navigator === void 0 ? void 0 : navigator.vibrate) === null || _a === void 0 ? void 0 : _a.call(navigator, BaSeTheme.transitions.durationFastInMilliseconds); }, 0);
        return function () { return clearTimeout(shownTimeout); };
    }, []);
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation ||
        color === BaSeTheme.components.button.colors.attention;
    var getColorsAtributes = function () {
        var _a;
        if (color) {
            if (!colorIsMapped) {
                return mapCustomColorsNotificationValues(color).primary;
            }
            else {
                return (_a = mapNotificationValues(color).primary) === null || _a === void 0 ? void 0 : _a.generalColors;
            }
        }
        else {
            return mapNotificationValues('default').primary.generalColors;
        }
    };
    var colorValues = getColorsAtributes();
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var progressLoadingDuration = React.useMemo(function () { return secondsToClose * 1000; }, [secondsToClose]);
    var progressTrackColor = React.useMemo(function () { return transformLightness(colorValues.color, 0.8); }, [colorValues]);
    var closeButton = React.useMemo(function () { return (React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), buttonType: "button", shape: "circle", size: "small", sizeIcon: "small", type: "tertiary", color: colorValues.color, onClick: function () {
            forceClose();
        } })); }, [colorValues.color, forceClose, getMessage]);
    var progressCircle = React.useMemo(function () { return (React.createElement(BaSeProgressCircle, { ref: progressRef, loadingDuration: progressLoadingDuration, indicatorColor: colorValues.color, trackColor: progressTrackColor, size: 32, trackWidth: 3, indicatorWidth: 3, type: "emptying", closeOnTimeout: false, onFinish: function () { return autoClose(); } }, closeButton)); }, [
        progressRef,
        progressLoadingDuration,
        colorValues,
        progressTrackColor,
        autoClose,
        closeButton,
    ]);
    var progressBar = React.useMemo(function () { return (React.createElement(BaSeProgressBar, { backgroundColor: getAlertColorFromType(color).background, foregroundColor: getAlertColorFromType(color).foreground, loadingDuration: progressLoadingDuration, onFinish: autoClose, ref: progressRef })); }, [color, progressLoadingDuration, autoClose]);
    return (React.createElement(NotificationDialog, { className: "BaSe--notification-dialog ".concat(exiting !== undefined ? 'exiting' : ''), color: colorValues.color, backgroundColor: colorValues.style.bgC, role: "dialog", "aria-modal": "false", "aria-labelledby": "BaSe--notification-title-".concat(counterId), "aria-describedby": "BaSe--notification-description-".concat(counterId), onFocusCapture: function () { return pause(); }, onBlurCapture: function () { return resume(); }, onMouseEnter: function () { return pause(); }, onMouseLeave: function () { return resume(); } },
        iconName && (React.createElement("span", { className: "icon-wrapper" },
            React.createElement(BaSeIcon, { color: colorValues.color, name: iconName, size: 26, description: getMessage('notification.iconDescription') }))),
        React.createElement("div", { className: "message" },
            React.createElement("span", { id: "BaSe--notification-title-".concat(counterId) },
                React.createElement(BaSeHeading6, { isBold: true }, message)),
            supportMessage && (React.createElement("span", { id: "BaSe--notification-description-".concat(counterId) },
                React.createElement(BaSeParagraph, { withNewLineWrap: true }, supportMessage)))),
        action && (React.createElement(BaSeButton, { buttonType: "button", size: "small", type: "tertiary", color: colorValues.color, value: action, onClick: function () { return actionClose(); } })),
        (secondsToClose === 0 ||
            (secondsToClose > 0 && progressAnimationType !== 'circle')) &&
            showCloseButton &&
            closeButton,
        secondsToClose > 0 &&
            progressAnimationType === 'circle' &&
            progressCircle,
        secondsToClose > 0 && progressAnimationType === 'bar' && progressBar));
};
BaSeNotification.displayName = 'BaSeNotification';

var TutorialPopupCardWrapper = styled.div(templateObject_2$U || (templateObject_2$U = __makeTemplateObject(["\n  ", "\n  transition: ", ";\n  position: absolute;\n  will-change: top, left, opacity;\n"], ["\n  ", "\n  transition: ", ";\n  position: absolute;\n  will-change: top, left, opacity;\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return !isOpen && css(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject(["\n      opacity: 0;\n      pointer-events: none;\n    "], ["\n      opacity: 0;\n      pointer-events: none;\n    "])));
}, BaSeTheme.transitions.allPropertiesContinuousNormal);
var TutorialPopupCard = styled.div(templateObject_4$F || (templateObject_4$F = __makeTemplateObject(["\n  ", "\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid ", ";\n  border-radius: 0.75em;\n  padding: 0.75em 1em;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75em;\n  transition: ", ";\n  min-height: 115px;\n"], ["\n  ", "\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid ", ";\n  border-radius: 0.75em;\n  padding: 0.75em 1em;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75em;\n  transition: ", ";\n  min-height: 115px;\n"])), function (_a) {
    var innerWidth = _a.innerWidth, isOpen = _a.isOpen;
    return css(templateObject_3$N || (templateObject_3$N = __makeTemplateObject(["\n    width: ", "px;\n    opacity: ", ";\n  "], ["\n    width: ", "px;\n    opacity: ", ";\n  "])), innerWidth, +isOpen);
}, BaSeTheme.colors.institucionais.azulSebrae75, BaSeTheme.transitions.allPropertiesContinuousNormal);
var TutorialPopupCardTitle = styled.div(templateObject_5$y || (templateObject_5$y = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var TutorialPopupCardFooter = styled.div(templateObject_6$w || (templateObject_6$w = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  position: absolute;\n  z-index: ", ";\n  width: 100%;\n  left: 1em;\n  bottom: 1em;\n  width: calc(100% - 2em);\n  box-sizing: border-box;\n  gap: 0.5em;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  position: absolute;\n  z-index: ", ";\n  width: 100%;\n  left: 1em;\n  bottom: 1em;\n  width: calc(100% - 2em);\n  box-sizing: border-box;\n  gap: 0.5em;\n"])), BaSeTheme.stackOrder.overlay);
styled.div(templateObject_7$q || (templateObject_7$q = __makeTemplateObject(["\n  display: flex;\n  gap: 0.5em;\n  align-items: center;\n  margin-left: auto;\n  position: absolute;\n"], ["\n  display: flex;\n  gap: 0.5em;\n  align-items: center;\n  margin-left: auto;\n  position: absolute;\n"])));
var TutorialPopupTriangle = styled.div(templateObject_9$n || (templateObject_9$n = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var top = _a.top, left = _a.left, degre = _a.degre, isOpen = _a.isOpen;
    return css(templateObject_8$p || (templateObject_8$p = __makeTemplateObject(["\n    top: ", "px;\n    left: ", "px;\n    opacity: ", ";\n    transform: rotate(", "deg);\n    border-top-right-radius: 0.25em;\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0.5em 0.86em 0.5em;\n    border-color: transparent transparent #fff transparent;\n    z-index: ", ";\n  "], ["\n    top: ", "px;\n    left: ", "px;\n    opacity: ", ";\n    transform: rotate(", "deg);\n    border-top-right-radius: 0.25em;\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0.5em 0.86em 0.5em;\n    border-color: transparent transparent #fff transparent;\n    z-index: ", ";\n  "])), top, left, +isOpen, degre, BaSeTheme.stackOrder.default + 1);
});
var TutorialCardButtonWrapper = styled.div(templateObject_10$l || (templateObject_10$l = __makeTemplateObject(["\n  width: 2.5em;\n  height: 2.5em;\n  box-sizing: border-box;\n  display: grid;\n  place-items: center;\n"], ["\n  width: 2.5em;\n  height: 2.5em;\n  box-sizing: border-box;\n  display: grid;\n  place-items: center;\n"])));
var templateObject_1$13, templateObject_2$U, templateObject_3$N, templateObject_4$F, templateObject_5$y, templateObject_6$w, templateObject_7$q, templateObject_8$p, templateObject_9$n, templateObject_10$l;

var BaSePopupTutorial = function (_a) {
    var currentStep = _a.currentStep, totalSteps = _a.totalSteps, title = _a.title, open = _a.open, anchor = _a.anchor, _b = _a.width, width = _b === void 0 ? 310 : _b, _c = _a.dismissible, dismissible = _c === void 0 ? true : _c, content = _a.content, previousStep = _a.previousStep, nextStep = _a.nextStep, onClose = _a.onClose;
    var _d = React.useState({}), positions = _d[0], setPositions = _d[1];
    var _e = React.useState({}), positionsT = _e[0], setPositionsT = _e[1];
    var _f = React.useState(false), activeFocusTrap = _f[0], setActiveFocusTrap = _f[1];
    var _g = React.useState(false), activeToFocus = _g[0], setActiveToFocus = _g[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var selfRef = React.useRef(null);
    var canDismiss = React.useMemo(function () { return dismissible || currentStep === totalSteps; }, [dismissible, currentStep, totalSteps]);
    var calculateXPosition = React.useCallback(function (posi) {
        var _a, _b, _c, _d;
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var cardHeight = (_d = (_c = (_b = (_a = selfRef === null || selfRef === void 0 ? void 0 : selfRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 0;
        var idealPosition = posi.x + posi.width / 2 - width / 2;
        var difer = idealPosition + width - windowWidth;
        var isNearBottom = posi.y + cardHeight - windowHeight > 0;
        setPositionsT({
            left: Math.max(width / 2 - 8 + Math.max(difer + 20, 0), 20) + '',
            top: isNearBottom ? cardHeight - 8 + '' : -8 + '',
            degre: isNearBottom ? 60 : 239,
            isOpen: open,
        });
        return {
            x: Math.max(idealPosition - Math.max(difer + 20, 0), 20),
            y: isNearBottom ? posi.y - cardHeight - 8 : posi.y + 24,
        };
    }, [open, width]);
    var getPositionsByQuerySelector = React.useCallback(function (query) {
        var _a, _b, _c;
        var element = document.querySelector(query);
        var pos = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
        return { x: (_a = pos === null || pos === void 0 ? void 0 : pos.x) !== null && _a !== void 0 ? _a : 0, y: (_b = pos === null || pos === void 0 ? void 0 : pos.y) !== null && _b !== void 0 ? _b : 0, width: (_c = pos === null || pos === void 0 ? void 0 : pos.width) !== null && _c !== void 0 ? _c : 0 };
    }, []);
    var getPositions = React.useCallback(function () {
        if (typeof anchor === 'string') {
            return calculateXPosition(getPositionsByQuerySelector(anchor));
        }
        if (anchor === null || anchor === void 0 ? void 0 : anchor.current) {
            var pos = anchor.current.getBoundingClientRect();
            return calculateXPosition({
                x: pos.x,
                y: pos.y,
                width: pos.width,
            });
        }
        return calculateXPosition(anchor);
    }, [calculateXPosition, anchor, getPositionsByQuerySelector]);
    var handlePositions = React.useCallback(function () {
        var _a = getPositions(), x = _a.x, y = _a.y;
        setPositions({ left: x + '', top: y + '' });
    }, [getPositions]);
    var handleClose = React.useCallback(function () {
        onClose();
        return true;
    }, []);
    React.useEffect(function () {
        handlePositions();
    }, [handlePositions]);
    React.useEffect(function () {
        ['resize', 'scroll'].forEach(function (events) {
            window.addEventListener(events, handlePositions);
        });
        return function () {
            ['resize', 'scroll'].forEach(function (events) {
                window.removeEventListener(events, handlePositions);
            });
        };
    }, [handlePositions, previousStep, nextStep]);
    React.useEffect(function () {
        setTimeout(function () {
            setActiveFocusTrap(open);
        }, 200);
        if (open && positions.top && !activeToFocus) {
            var topPosition = parseInt(positions.top, 10);
            if (window.innerHeight < topPosition && topPosition > 0) {
                window.scrollTo(0, topPosition - window.innerHeight / 3);
            }
            if (topPosition < 0) {
                window.scrollBy(0, topPosition - 100);
            }
            setActiveToFocus(true);
        }
        if (!open) {
            setActiveToFocus(false);
        }
    }, [open, positions, activeToFocus]);
    return (React.createElement(TutorialPopupCardWrapper, { ref: selfRef, isOpen: open && positions.top !== undefined, style: {
            top: positions.top + 'px',
            left: positions.left + 'px',
            boxSizing: 'border-box',
        } },
        React.createElement(FocusTrap, { focusTrapOptions: {
                allowOutsideClick: true,
                escapeDeactivates: canDismiss && handleClose,
                clickOutsideDeactivates: canDismiss && handleClose,
                initialFocus: currentStep !== totalSteps
                    ? "#BaSe--tutorial-next-step-".concat(currentStep, " button")
                    : undefined,
            }, paused: !activeFocusTrap },
            React.createElement(TutorialPopupCard, { style: { boxSizing: 'border-box' }, isOpen: open, innerWidth: width },
                React.createElement(TutorialPopupCardTitle, null,
                    React.createElement("div", null,
                        React.createElement(BaSeSmall1, null, getMessage('stepper.counter', currentStep, totalSteps)),
                        React.createElement(BaSeParagraph, { isBold: true }, title)),
                    (dismissible || currentStep === totalSteps) && (React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), onClick: onClose, type: "tertiary" }))), content === null || content === void 0 ? void 0 :
                content(),
                React.createElement(TutorialPopupCardFooter, null,
                    currentStep !== 1 && (React.createElement(TutorialCardButtonWrapper, null,
                        React.createElement(BaSeIconButton, { nameIcon: "angle-left", descriptionIcon: getMessage('buttonIcon.iconDescription.previous'), type: "secondary", onClick: previousStep }))),
                    currentStep !== totalSteps && (React.createElement(TutorialCardButtonWrapper, { id: "BaSe--tutorial-next-step-".concat(currentStep) },
                        React.createElement(BaSeIconButton, { nameIcon: "angle-right", descriptionIcon: getMessage('buttonIcon.iconDescription.next'), onClick: nextStep })))))),
        React.createElement(TutorialPopupTriangle, __assign({}, positionsT))));
};

var TutorialContainer = styled.div(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n  z-index: ", ";\n  &,\n  &::before {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  &::before {\n    content: '';\n    background: ", ";\n    opacity: 0.5;\n  }\n"], ["\n  z-index: ", ";\n  &,\n  &::before {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  &::before {\n    content: '';\n    background: ", ";\n    opacity: 0.5;\n  }\n"])), BaSeTheme.stackOrder.overlay * 2, BaSeTheme.colors.institucionais.cinzaSebrae20);
var templateObject_1$12;

var idSequence$b = idGenerator();
var BaSeDialogTutorial = function (_a) {
    var onClose = _a.onClose, steps = _a.steps, _b = _a.dismissible, dismissible = _b === void 0 ? true : _b;
    var _c = React.useState(1), activeStep = _c[0], setActiveStep = _c[1];
    var totalSteps = React.useMemo(function () { return steps.length; }, [steps]);
    var handleClick = React.useCallback(function (e) {
        var _a, _b;
        if (((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.className) === null || _b === void 0 ? void 0 : _b.includes('BaSe--tutorial-container')) &&
            dismissible) {
            onClose();
        }
    }, []);
    var mapPropsToPopup = React.useCallback(function (step, index) {
        var idTip = getNextCounter(idSequence$b);
        return (React.createElement(BaSePopupTutorial, { dismissible: dismissible, onClose: onClose, open: activeStep === index + 1, anchor: step.anchor, currentStep: index + 1, totalSteps: totalSteps, title: step.title, content: step.content, previousStep: function () { return setActiveStep(function (prev) { return prev - 1; }); }, nextStep: function () { return setActiveStep(function (prev) { return prev + 1; }); }, key: idTip }));
    }, [totalSteps, activeStep]);
    var showListTips = React.useMemo(function () { return steps.map(mapPropsToPopup); }, [steps, activeStep]);
    React.useEffect(function () {
        var handleKeyDown = function (event) {
            if (event.key === 'ArrowLeft') {
                setActiveStep(function (prev) {
                    var p = prev - 1;
                    if (p <= 0) {
                        return prev;
                    }
                    return p;
                });
                return;
            }
            if (event.key === 'ArrowRight') {
                setActiveStep(function (prev) {
                    var p = prev + 1;
                    if (p > totalSteps) {
                        return prev;
                    }
                    return p;
                });
                return;
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [totalSteps]);
    if (!(steps === null || steps === void 0 ? void 0 : steps.length)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(TutorialContainer, { onClick: handleClick, className: "BaSe--tutorial-container" }, showListTips));
};

var idSequence$a = idGenerator();
function addInPool(setPoolState, itemToAdd) {
    setPoolState(function (pool) { return __spreadArray(__spreadArray([], pool, true), [itemToAdd], false); });
}
function removeFromPool(setPoolState, itemToRemove) {
    setPoolState(function (pool) { return pool.filter(function (item) { return item.id !== itemToRemove.id; }); });
}
var DialogContainer = function (_a) {
    var modalPool = _a.modalPool, notificationPool = _a.notificationPool, tutorialPool = _a.tutorialPool;
    return (React.createElement(React.Fragment, null,
        modalPool.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (React.createElement(BaSeModal, __assign({ key: id }, rest)));
        }),
        tutorialPool.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (React.createElement(BaSeDialogTutorial, __assign({ key: id }, rest)));
        }),
        notificationPool.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (React.createElement(BaSeNotification, __assign({ key: id }, rest)));
        })));
};
var BaSeDialogContext = React.createContext({
    DialogContainer: React.createElement(React.Fragment, null),
    showModal: function () { },
    showNotification: function () { },
    showTutorial: function () { },
});
var BaSeDialogProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState([]), modalPool = _b[0], setModalPool = _b[1];
    var _c = React.useState([]), notificationPool = _c[0], setNotificationPool = _c[1];
    var _d = React.useState([]), tutorialPool = _d[0], setTutorialPool = _d[1];
    var showModal = React.useCallback(function (config) {
        var _a;
        var size = config.size, title = config.title, titleColor = config.titleColor, actions = config.actions, alignActions = config.alignActions, dismissible = config.dismissible, dismissibleIconColor = config.dismissibleIconColor, dismissibleIconType = config.dismissibleIconType, dismissibleIconName = config.dismissibleIconName, isFluid = config.isFluid, breakpointDelimiter = config.breakpointDelimiter, content = config.content, onContentEvent = config.onContentEvent, beforeClose = config.beforeClose, rightImage = config.rightImage, leftImage = config.leftImage;
        var id = getNextCounter(idSequence$a);
        var modal = {
            id: id,
            size: size,
            title: title,
            titleColor: titleColor,
            actions: actions,
            alignActions: alignActions,
            dismissible: dismissible,
            dismissibleIconColor: dismissibleIconColor,
            dismissibleIconType: dismissibleIconType,
            dismissibleIconName: dismissibleIconName,
            isFluid: isFluid,
            breakpointDelimiter: breakpointDelimiter,
            content: content,
            onContentEvent: onContentEvent,
            beforeClose: beforeClose,
            onCancel: function () {
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onDismiss) === null || _a === void 0 ? void 0 : _a.call(config);
                removeFromPool(setModalPool, modal);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            },
            onClose: function (action) {
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onChooseAction) === null || _a === void 0 ? void 0 : _a.call(config, action);
                removeFromPool(setModalPool, modal);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            },
            rightImage: rightImage,
            leftImage: leftImage,
        };
        (_a = config === null || config === void 0 ? void 0 : config.onOpen) === null || _a === void 0 ? void 0 : _a.call(config);
        addInPool(setModalPool, modal);
    }, []);
    var showNotification = React.useCallback(function (config) {
        var _a;
        var color = config.color, message = config.message, supportMessage = config.supportMessage, showCloseButton = config.showCloseButton, secondsToClose = config.secondsToClose, action = config.action, icon = config.icon, progressAnimationType = config.progressAnimationType;
        var id = getNextCounter(idSequence$a);
        var notification = {
            id: id,
            icon: icon,
            color: color,
            message: message,
            supportMessage: supportMessage,
            showCloseButton: showCloseButton,
            secondsToClose: secondsToClose,
            progressAnimationType: progressAnimationType,
            action: action,
            onClose: function (forced) {
                var _a, _b, _c;
                if (forced) {
                    (_a = config === null || config === void 0 ? void 0 : config.onForceClose) === null || _a === void 0 ? void 0 : _a.call(config);
                }
                else {
                    (_b = config === null || config === void 0 ? void 0 : config.onAutoClose) === null || _b === void 0 ? void 0 : _b.call(config);
                }
                removeFromPool(setNotificationPool, notification);
                (_c = config === null || config === void 0 ? void 0 : config.afterClose) === null || _c === void 0 ? void 0 : _c.call(config);
            },
            onAction: function () {
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onActionClose) === null || _a === void 0 ? void 0 : _a.call(config);
                removeFromPool(setNotificationPool, notification);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            },
        };
        (_a = config === null || config === void 0 ? void 0 : config.onOpen) === null || _a === void 0 ? void 0 : _a.call(config);
        addInPool(setNotificationPool, notification);
    }, []);
    var showTutorial = React.useCallback(function (config) {
        var id = getNextCounter(idSequence$a);
        var tutorial = __assign(__assign({}, config), { id: id, onClose: function () {
                var _a, _b;
                var willClose = (_a = config === null || config === void 0 ? void 0 : config.beforeClose) === null || _a === void 0 ? void 0 : _a.call(config);
                if (willClose === false) {
                    return;
                }
                removeFromPool(setTutorialPool, tutorial);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            } });
        addInPool(setTutorialPool, tutorial);
    }, [tutorialPool]);
    return (React.createElement(BaSeDialogContext.Provider, { value: {
            DialogContainer: (React.createElement(DialogContainer, { modalPool: modalPool, tutorialPool: tutorialPool, notificationPool: notificationPool })),
            showModal: showModal,
            showNotification: showNotification,
            showTutorial: showTutorial,
        } }, children));
};
var BaSeDialogConsumer = BaSeDialogContext.Consumer;
var BaSeDialogContainer = function () { return (React.createElement(BaSeDialogConsumer, null, function (_a) {
    var DC = _a.DialogContainer;
    return DC;
})); };

var ELEMENT$1 = 'style';
var TYPE$2 = 'import-fonts';
var urlBaSe = BaSeConfig.staticAssetsUrl;
var urlGoogle = 'https://fonts.googleapis.com/css2?display=swap';
var configBaSeFontFamily = function (name) {
    return "fonts/".concat(urlEncode(name.toLowerCase()), "/web-font.css");
};
var configGoogleFontFamily = function (name) {
    return "&family=".concat(urlEncode(name), ":ital,wght@0,100;0,300;0,400;0,500;0,700;1,100;1,300;1,400;1,700");
};
function notInjected$2() {
    return !document.querySelector(ELEMENT$1 +
        "[data-type=\"".concat(TYPE$2, "\"]") +
        "[data-design-system=\"BaSe@".concat(version, "\"]"));
}
function inject$2(_a) {
    var BaSe = _a.BaSe, Google = _a.Google;
    var css = [];
    BaSe.forEach(function (name) {
        return css.push("@import url('".concat(urlBaSe, "/").concat(configBaSeFontFamily(name), "')"));
    });
    var fontsGoogle = Google.map(configGoogleFontFamily).join('');
    css.push("@import url('".concat(urlGoogle).concat(fontsGoogle, "');"));
    var style = document.createElement(ELEMENT$1);
    style.dataset.designSystem = "BaSe@".concat(version);
    style.dataset.type = TYPE$2;
    style.innerText = css.join(';');
    document.head.appendChild(style);
}
function addFonts(fonts) {
    if (notInjected$2()) {
        inject$2(fonts);
    }
}
function useCssFonts() {
    React.useEffect(function () { return addFonts({ BaSe: BaSeFonts, Google: GoogleFonts }); }, []);
}

var ELEMENT = 'style';
var TYPE$1 = 'reset-css';
function getElement$1() {
    return document.querySelector(ELEMENT +
        "[data-type=\"".concat(TYPE$1, "\"]") +
        "[data-design-system=\"BaSe@".concat(version, "\"]"));
}
function notInjected$1() {
    return !getElement$1();
}
function inject$1() {
    var element = document.createElement(ELEMENT);
    element.dataset.designSystem = "BaSe@".concat(version);
    element.dataset.type = TYPE$1;
    element.innerText = "@import url('".concat(BaSeConfig.staticAssetsUrl, "/css/reset.css');");
    document.head.appendChild(element);
}
function addResetCss() {
    if (notInjected$1()) {
        inject$1();
    }
}
function removeResetCss() {
    var _a;
    (_a = getElement$1()) === null || _a === void 0 ? void 0 : _a.remove();
}
function useResetCss(flag) {
    React.useEffect(function () { return (flag ? addResetCss() : removeResetCss()); }, [flag]);
}

var BaSeScrollbarCss = css(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject(["\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-track {\n    border: none;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    width: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-thumb:window-inactive {\n    background: ", ";\n  }\n"], ["\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-track {\n    border: none;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    width: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-thumb:window-inactive {\n    background: ", ";\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.colors.institucionais.cinzaSebrae10);
var templateObject_1$11;

var RootWrapper = styled.div.withConfig({
    componentId: 'BaSe--root',
})(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 1;\n\n  &,\n  * {\n    box-sizing: content-box;\n  }\n\n  &,\n  div,\n  span,\n  applet,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  a,\n  img,\n  small,\n  strong,\n  ol,\n  ul,\n  li,\n  label,\n  table,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  aside,\n  footer,\n  header,\n  nav,\n  output,\n  section {\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  footer,\n  header,\n  nav,\n  section {\n    display: block;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  &,\n  & * {\n    ", ";\n  }\n"], ["\n  font-size: 16px;\n  line-height: 1;\n\n  &,\n  * {\n    box-sizing: content-box;\n  }\n\n  &,\n  div,\n  span,\n  applet,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  a,\n  img,\n  small,\n  strong,\n  ol,\n  ul,\n  li,\n  label,\n  table,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  aside,\n  footer,\n  header,\n  nav,\n  output,\n  section {\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  footer,\n  header,\n  nav,\n  section {\n    display: block;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  &,\n  & * {\n    ", ";\n  }\n"])), BaSeScrollbarCss);
var templateObject_1$10;

var BaSeRoot = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? 'pt-BR' : _b, _c = _a.withResetCss, withResetCss = _c === void 0 ? true : _c, children = _a.children;
    useCssFonts();
    useResetCss(withResetCss);
    return (React.createElement(RootWrapper, null,
        React.createElement(BaSeI18nProvider, { locale: locale },
            React.createElement(BaSeBreakpointProvider, null,
                React.createElement(BaSeDialogProvider, null, children)))));
};

var StyledHeading1 = makeDefaultTypographyStyled('Heading1', 'h1', 2.48, 1.2);

var BaSeHeading1 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 2.48, lineHeight: 1.2, wrapper: StyledHeading1 }, props), props.children)); };
BaSeHeading1.displayName = 'BaSeHeading1';

var StyledHeading2 = makeDefaultTypographyStyled('Heading2', 'h2', 2.07, 1.2);

var BaSeHeading2 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 2.07, lineHeight: 1.2, wrapper: StyledHeading2 }, props), props.children)); };
BaSeHeading2.displayName = 'BaSeHeading2';

var StyledHeading3 = makeDefaultTypographyStyled('Heading3', 'h3', 1.72, 1.2);

var BaSeHeading3 = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 1.72, lineHeight: 1.2, wrapper: StyledHeading3 }, props), props.children)); };
BaSeHeading3.displayName = 'BaSeHeading3';

var iconAngleRight = 'images/icons/angle-down.svg';
function getFilter$1(color) {
    return transformToFilter(color);
}
function getImageUrl() {
    return "".concat(urlSanitizer(BaSeConfig.staticAssetsUrl), "/").concat(iconAngleRight);
}
var AccordionContainer = styled.div.attrs({
    className: 'BaSe--accordion',
})(templateObject_3$M || (templateObject_3$M = __makeTemplateObject(["\n  ", "\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  ", "\n  box-shadow: ", ";\n\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return css(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject(["\n    overflow: ", ";\n  "], ["\n    overflow: ", ";\n  "])), isOpen ? 'visible' : 'hidden');
}, function (_a) {
    var shadow = _a.shadow;
    return shadow;
}, function (_a) {
    var isSingle = _a.isSingle, radius = _a.radius;
    return !isSingle && css(templateObject_2$T || (templateObject_2$T = __makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), numberWithUnit(radius));
});
var AccordionContainerWrapper = styled.div(templateObject_5$x || (templateObject_5$x = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return css(templateObject_4$E || (templateObject_4$E = __makeTemplateObject(["\n    overflow: ", ";\n\n    .BaSe--accordion-title {\n      &::after {\n        transform: rotate(180deg);\n      }\n    }\n    .BaSe--accordion-content {\n      max-height: 10000vh;\n    }\n  "], ["\n    overflow: ", ";\n\n    .BaSe--accordion-title {\n      &::after {\n        transform: rotate(180deg);\n      }\n    }\n    .BaSe--accordion-content {\n      max-height: 10000vh;\n    }\n  "])), isOpen ? 'visible' : 'hidden');
});
var AccordionTitleContainer = styled.div.attrs({
    className: 'BaSe--accordion-title-container',
})(templateObject_13$f || (templateObject_13$f = __makeTemplateObject(["\n  padding: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  gap: 1em;\n  ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  padding: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  gap: 1em;\n  ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var _b = _a.noPaddingTitle, noPaddingTitle = _b === void 0 ? false : _b;
    return !noPaddingTitle && '1em';
}, function (_a) {
    var clickableTitle = _a.clickableTitle;
    return clickableTitle && css(templateObject_6$v || (templateObject_6$v = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
}, function (_a) {
    var clickableTitle = _a.clickableTitle, backgroundHeaderColor = _a.backgroundHeaderColor;
    return clickableTitle &&
        backgroundHeaderColor &&
        (function () {
            var lightness = getLValue(backgroundHeaderColor);
            var colorConfig = lightness ? { l: lightness / 100 - 0.03 } : {};
            return css(templateObject_7$p || (templateObject_7$p = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n        }\n      "])), createColorSmartLightingControl(backgroundHeaderColor, colorConfig));
        })();
}, function (_a) {
    var borderHeaderColor = _a.borderHeaderColor, _b = _a.hasBorder, hasBorder = _b === void 0 ? true : _b;
    return hasBorder && css(templateObject_8$o || (templateObject_8$o = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), borderHeaderColor);
}, function (_a) {
    var isFirst = _a.isFirst, isSingle = _a.isSingle, isLast = _a.isLast, isOpen = _a.isOpen, backgroundHeaderColor = _a.backgroundHeaderColor, radius = _a.radius;
    return css(templateObject_12$h || (templateObject_12$h = __makeTemplateObject(["\n    ", ";\n\n    ", "\n\n    ", "\n\n    background-color:", ";\n  "], ["\n    ", ";\n\n    ", "\n\n    ", "\n\n    background-color:", ";\n  "])), isFirst &&
        !isSingle && css(templateObject_9$m || (templateObject_9$m = __makeTemplateObject(["\n      border-radius: ", " ", " 0 0;\n    "], ["\n      border-radius: ", " ", " 0 0;\n    "])), numberWithUnit(radius), numberWithUnit(radius)), !isSingle &&
        !isOpen &&
        isLast && css(templateObject_10$k || (templateObject_10$k = __makeTemplateObject(["\n      border-radius: 0 0 ", " ", ";\n    "], ["\n      border-radius: 0 0 ", " ", ";\n    "])), numberWithUnit(radius), numberWithUnit(radius)), isOpen && css(templateObject_11$i || (templateObject_11$i = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "]))), backgroundHeaderColor);
});
styled.label.attrs({
    className: 'BaSe--accordion-title',
})(templateObject_16$c || (templateObject_16$c = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  padding: 1em;\n  cursor: pointer;\n  position: relative;\n\n  color: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n\n  ", "\n\n  ", "\n\n  &::after {\n    will-change: transform;\n    content: url(", ");\n    position: absolute;\n    right: 1em;\n    top: 1em;\n    width: 2em;\n    height: 2em;\n    text-align: center;\n    transition: ", ";\n    filter: ", ";\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  padding: 1em;\n  cursor: pointer;\n  position: relative;\n\n  color: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n\n  ", "\n\n  ", "\n\n  &::after {\n    will-change: transform;\n    content: url(", ");\n    position: absolute;\n    right: 1em;\n    top: 1em;\n    width: 2em;\n    height: 2em;\n    text-align: center;\n    transition: ", ";\n    filter: ", ";\n  }\n"])), function (_a) {
    var headerColor = _a.headerColor;
    return headerColor;
}, function (_a) {
    var borderHeaderColor = _a.borderHeaderColor;
    return borderHeaderColor;
}, function (_a) {
    var backgroundHeaderColor = _a.backgroundHeaderColor;
    return backgroundHeaderColor;
}, function (_a) {
    var isFirst = _a.isFirst, isSingle = _a.isSingle, radius = _a.radius;
    return isFirst &&
        !isSingle && css(templateObject_14$f || (templateObject_14$f = __makeTemplateObject(["\n      border-radius: ", " ", " 0 0;\n    "], ["\n      border-radius: ", " ", " 0 0;\n    "])), numberWithUnit(radius), numberWithUnit(radius));
}, function (_a) {
    var isLast = _a.isLast, isSingle = _a.isSingle, isOpen = _a.isOpen, radius = _a.radius;
    return !isSingle &&
        !isOpen &&
        isLast && css(templateObject_15$e || (templateObject_15$e = __makeTemplateObject(["\n      border-radius: 0 0 ", " ", ";\n    "], ["\n      border-radius: 0 0 ", " ", ";\n    "])), numberWithUnit(radius), numberWithUnit(radius));
}, getImageUrl(), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var headerColor = _a.headerColor;
    return getFilter$1(headerColor);
});
var AccordionContent = styled.div.attrs({
    className: 'BaSe--accordion-content',
})(templateObject_23$5 || (templateObject_23$5 = __makeTemplateObject(["\n  will-change: max-height, padding;\n  background: ", ";\n  box-sizing: border-box;\n  max-height: 0;\n  transition: ", ";\n  padding: 0 1em;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  will-change: max-height, padding;\n  background: ", ";\n  box-sizing: border-box;\n  max-height: 0;\n  transition: ", ";\n  padding: 0 1em;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var isOpen = _a.isOpen;
    return css(templateObject_17$b || (templateObject_17$b = __makeTemplateObject(["\n    overflow: ", ";\n  "], ["\n    overflow: ", ";\n  "])), isOpen ? 'visible' : 'hidden');
}, function (_a) {
    var isOpen = _a.isOpen, preserveContent = _a.preserveContent;
    return preserveContent && css(templateObject_18$7 || (templateObject_18$7 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), isOpen ? 'block' : 'none');
}, function (_a) {
    var noPaddingContent = _a.noPaddingContent;
    return noPaddingContent && css(templateObject_19$7 || (templateObject_19$7 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
}, function (_a) {
    var isOpen = _a.isOpen, borderHeaderColor = _a.borderHeaderColor, hasBorder = _a.hasBorder;
    return isOpen && css(templateObject_21$6 || (templateObject_21$6 = __makeTemplateObject(["\n      ", "\n      border-top: none;\n    "], ["\n      ", "\n      border-top: none;\n    "])), hasBorder && css(templateObject_20$7 || (templateObject_20$7 = __makeTemplateObject(["\n        border: 1px solid ", ";\n      "], ["\n        border: 1px solid ", ";\n      "])), borderHeaderColor));
}, function (_a) {
    var isLast = _a.isLast, radius = _a.radius;
    return isLast && css(templateObject_22$5 || (templateObject_22$5 = __makeTemplateObject(["\n      border-radius: 0 0 ", " ", ";\n    "], ["\n      border-radius: 0 0 ", " ", ";\n    "])), numberWithUnit(radius), numberWithUnit(radius));
});
var AccordionButtonWrapper = styled.div(templateObject_25$5 || (templateObject_25$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return css(templateObject_24$5 || (templateObject_24$5 = __makeTemplateObject(["\n    transform: rotateZ(", ");\n    transition: ", ";\n    width: 3em\n    height: 3em\n    display: grid;1    align-self: center;\n    place-items: center;\n  "], ["\n    transform: rotateZ(", ");\n    transition: ", ";\n    width: 3em\n    height: 3em\n    display: grid;1    align-self: center;\n    place-items: center;\n  "])), isOpen ? '180deg' : '0deg', BaSeTheme.transitions.allPropertiesContinuousNormal);
});
var templateObject_1$$, templateObject_2$T, templateObject_3$M, templateObject_4$E, templateObject_5$x, templateObject_6$v, templateObject_7$p, templateObject_8$o, templateObject_9$m, templateObject_10$k, templateObject_11$i, templateObject_12$h, templateObject_13$f, templateObject_14$f, templateObject_15$e, templateObject_16$c, templateObject_17$b, templateObject_18$7, templateObject_19$7, templateObject_20$7, templateObject_21$6, templateObject_22$5, templateObject_23$5, templateObject_24$5, templateObject_25$5;

var AccordionOptionItem = function (_a) {
    var _b;
    var data = _a.data, index = _a.index, isOpen = _a.isOpen, id = _a.id, _c = _a.backgroundTitleColor, backgroundTitleColor = _c === void 0 ? BaSeTheme.colors.defaultColors.white : _c, _d = _a.backgroundContentColor, backgroundContentColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _d, _e = _a.titleColor, titleColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _e, _f = _a.borderTitleColor, borderTitleColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _f, _g = _a.hasContentBorder, hasContentBorder = _g === void 0 ? true : _g, _h = _a.titleButtonIconSize, titleButtonIconSize = _h === void 0 ? 'big' : _h, _j = _a.titleButtonSize, titleButtonSize = _j === void 0 ? 'big' : _j, _k = _a.hasTitleBorder, hasTitleBorder = _k === void 0 ? true : _k, _l = _a.radius, radius = _l === void 0 ? 8 : _l, _m = _a.qtyOptions, qtyOptions = _m === void 0 ? 0 : _m, externalClickableTitle = _a.clickableTitle, preserveContent = _a.preserveContent, onChange = _a.onChange, onOpenIndexChange = _a.onOpenIndexChange;
    var clickableTitle = React.useMemo(function () { return externalClickableTitle !== null && externalClickableTitle !== void 0 ? externalClickableTitle : typeof data.title === 'string'; }, [data.title, externalClickableTitle]);
    var accordionTitleElementChangeOpen = React.useCallback(function (value) {
        onChange(value, index);
    }, [onChange, index]);
    var accordionTitleElementClose = React.useCallback(function () {
        onChange(false, index);
    }, [onChange, index]);
    var renderTitleElement = React.useCallback(function (renderProp) {
        return renderProp({
            open: isOpen,
            setOpen: accordionTitleElementChangeOpen,
            color: titleColor,
        });
    }, [accordionTitleElementChangeOpen, isOpen, titleColor]);
    var getAccordionTitleElement = React.useCallback(function (element) {
        if (typeof element === 'string') {
            return React.createElement(BaSeHeading5, { color: titleColor }, element);
        }
        else if (React.isValidElement(element)) {
            return element;
        }
        else {
            return renderTitleElement(element);
        }
    }, [titleColor, renderTitleElement]);
    var getAccordionContentElement = React.useCallback(function (element) {
        if (React.isValidElement(element)) {
            return element;
        }
        else {
            var newElement = element;
            return newElement === null || newElement === void 0 ? void 0 : newElement({ close: accordionTitleElementClose });
        }
    }, [accordionTitleElementClose]);
    var onChangeOpen = React.useCallback(function () {
        onOpenIndexChange === null || onOpenIndexChange === void 0 ? void 0 : onOpenIndexChange(index);
        return onChange(!isOpen, index);
    }, [onOpenIndexChange, index, onChange, isOpen]);
    return (React.createElement(AccordionContainerWrapper, { isOpen: isOpen, key: id },
        React.createElement(AccordionTitleContainer, { isFirst: index === 0, isLast: index === qtyOptions - 1, isSingle: qtyOptions === 1, isOpen: isOpen, headerColor: titleColor, borderHeaderColor: borderTitleColor, backgroundHeaderColor: (_b = data.backgroundTitleColor) !== null && _b !== void 0 ? _b : backgroundTitleColor, radius: radius, noPaddingTitle: data.noPaddingTitle, hasBorder: hasTitleBorder, clickableTitle: clickableTitle, role: clickableTitle ? 'button' : undefined, onClick: clickableTitle ? onChangeOpen : undefined },
            getAccordionTitleElement(data.title),
            typeof data.renderOpenCloseButton === 'function' ? (renderTitleElement(data.renderOpenCloseButton)) : (React.createElement(AccordionButtonWrapper, { isOpen: isOpen },
                React.createElement(BaSeShapeButton, { color: titleColor, type: "tertiary", size: titleButtonSize, nameIcon: "angle-down", sizeIcon: titleButtonIconSize, onClick: onChangeOpen })))),
        preserveContent ? (React.createElement(AccordionContent, { hasBorder: hasContentBorder, backgroundColor: backgroundContentColor, noPaddingContent: data === null || data === void 0 ? void 0 : data.noPaddingContent, isOpen: isOpen, isLast: index === qtyOptions - 1, borderHeaderColor: borderTitleColor, radius: radius, preserveContent: preserveContent }, getAccordionContentElement(data.content))) : (isOpen && (React.createElement(AccordionContent, { hasBorder: hasContentBorder, backgroundColor: backgroundContentColor, noPaddingContent: data === null || data === void 0 ? void 0 : data.noPaddingContent, isOpen: isOpen, isLast: index === qtyOptions - 1, borderHeaderColor: borderTitleColor, radius: radius }, getAccordionContentElement(data.content))))));
};
var BaSeAccordion = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.backgroundTitleColor, backgroundTitleColor = _c === void 0 ? BaSeTheme.colors.defaultColors.white : _c, _d = _a.backgroundContentColor, backgroundContentColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _d, _e = _a.titleColor, titleColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _e, _f = _a.borderTitleColor, borderTitleColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _f, _g = _a.shadow, shadow = _g === void 0 ? BaSeTheme.shadows.profundidade2 : _g, _h = _a.radius, radius = _h === void 0 ? 8 : _h, _j = _a.multipleOpen, multipleOpen = _j === void 0 ? false : _j, initialStartOpen = _a.startOpen, _k = _a.hasContentBorder, hasContentBorder = _k === void 0 ? true : _k, _l = _a.titleButtonIconSize, titleButtonIconSize = _l === void 0 ? 'big' : _l, _m = _a.titleButtonSize, titleButtonSize = _m === void 0 ? 'big' : _m, _o = _a.hasTitleBorder, hasTitleBorder = _o === void 0 ? true : _o, clickableTitle = _a.clickableTitle, _p = _a.preserveContent, preserveContent = _p === void 0 ? false : _p, onOpenIndexChange = _a.onOpenIndexChange;
    var startOpen = React.useMemo(function () {
        return Array.isArray(initialStartOpen)
            ? initialStartOpen
            : typeof initialStartOpen === 'number'
                ? [initialStartOpen]
                : undefined;
    }, [initialStartOpen]);
    var getId = React.useCallback(function (item, index) {
        var _a, _b, _c;
        var titleAsId = typeof (item === null || item === void 0 ? void 0 : item.title) === 'string'
            ? (_a = item === null || item === void 0 ? void 0 : item.title) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, '_')
            : null;
        return (_c = (_b = item === null || item === void 0 ? void 0 : item.id) !== null && _b !== void 0 ? _b : titleAsId) !== null && _c !== void 0 ? _c : index;
    }, []);
    var _q = React.useState([]), optionsStates = _q[0], setOptionStates = _q[1];
    var hasAnyOpen = React.useMemo(function () { return optionsStates.some(function (value) { return value; }); }, [optionsStates]);
    var startedOpenedObject = React.useMemo(function () {
        var _a;
        return (_a = startOpen === null || startOpen === void 0 ? void 0 : startOpen.reduce(function (currentObject, currentValue) {
            var _a;
            return (__assign(__assign({}, currentObject), (_a = {}, _a[currentValue] = true, _a)));
        }, {})) !== null && _a !== void 0 ? _a : {};
    }, [startOpen]);
    React.useEffect(function () {
        setOptionStates(options.map(function (_, index) { return startedOpenedObject[index]; }));
    }, [options, startedOpenedObject]);
    React.useEffect(function () {
        if (startOpen) {
            if (!multipleOpen && (startOpen === null || startOpen === void 0 ? void 0 : startOpen.length) > 1) {
                throw Error('[BaSeAccordion] Para passar mais de um valor para a propriedade "startOpen", é necessário definir a propriedade "multipleOpen" como true');
            }
            if ((startOpen === null || startOpen === void 0 ? void 0 : startOpen.length) > options.length) {
                throw Error('[BaSeAccordion] Não é possível passar uma quantidade no "startOpen" maior que a quantidade de itens do "Accordion"');
            }
            startOpen === null || startOpen === void 0 ? void 0 : startOpen.forEach(function (item) {
                if (item > options.length - 1) {
                    throw Error('[BaSeAccordion] Não é possível inserir um valor de índice no "startOpen" que não existe no "Accordion"');
                }
            });
        }
    }, [startOpen, multipleOpen, options]);
    var onChangeOption = React.useCallback(function (value, index) {
        setOptionStates(function (oldState) {
            if (multipleOpen) {
                var newState = __spreadArray([], oldState, true);
                newState[index] = value;
                return __spreadArray([], newState, true);
            }
            return oldState.map(function (_, oldIndex) { return oldIndex === index && value; });
        });
    }, [multipleOpen]);
    var isOpen = React.useCallback(function (index) { var _a; return (_a = optionsStates === null || optionsStates === void 0 ? void 0 : optionsStates[index]) !== null && _a !== void 0 ? _a : false; }, [optionsStates]);
    return (React.createElement(AccordionContainer, { shadow: shadow, radius: radius, isSingle: options.length === 1, isOpen: hasAnyOpen }, options.map(function (data, index) { return (React.createElement(AccordionOptionItem, { key: index, data: data, index: index, isOpen: isOpen(index), backgroundContentColor: backgroundContentColor, backgroundTitleColor: backgroundTitleColor, borderTitleColor: borderTitleColor, hasContentBorder: hasContentBorder, hasTitleBorder: hasTitleBorder, id: getId(data, index), qtyOptions: options.length, radius: radius, titleButtonIconSize: titleButtonIconSize, titleButtonSize: titleButtonSize, titleColor: titleColor, clickableTitle: clickableTitle, preserveContent: preserveContent, onChange: onChangeOption, onOpenIndexChange: onOpenIndexChange })); })));
};
BaSeAccordion.displayName = 'BaSeAccordion';

var URL_CONFIG_BY_AUTH_SERVER_URL = BaSeConfig.staticAssetsUrl + '/configs/by-auth-server-url.json';
var cache = { cached: false };
function useConfigByAuthServerUrl() {
    var _a = React.useState(cache), config = _a[0], setConfig = _a[1];
    var configIsInitialized = React.useMemo(function () { return !!config.cached; }, [config.cached]);
    React.useEffect(function () {
        if (!!cache.cached) {
            return setConfig(cache);
        }
        var controller = new AbortController();
        var signal = controller.signal;
        fetch(URL_CONFIG_BY_AUTH_SERVER_URL, { signal: signal })
            .then(function (response) { return response.json(); })
            .then(function (remoteConfig) {
            cache = __assign(__assign({}, remoteConfig), { cached: true });
            setConfig(cache);
        })
            .catch(function (err) {
            // eslint-disable-next-line no-console
            return console.error('[BaSe::configByAuthServerUrl] Error', err);
        });
        return function () { return controller.abort(); };
    }, []);
    var getConfig = React.useCallback(function (_a) {
        var authServerUrl = _a.authServerUrl, key = _a.key;
        if (!authServerUrl) {
            return undefined;
        }
        var configAuthServerUrl = config === null || config === void 0 ? void 0 : config[authServerUrl];
        if (configAuthServerUrl === undefined) {
            return undefined;
        }
        var value = configAuthServerUrl === null || configAuthServerUrl === void 0 ? void 0 : configAuthServerUrl[key];
        return value;
    }, [config]);
    return { getConfig: getConfig, configIsInitialized: configIsInitialized };
}

function useOutsideEvent(ref, calbackWhenAreOutside) {
    React.useEffect(function () {
        var handleClickOutside = function (event) {
            var _a, _b;
            return (!((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, event === null || event === void 0 ? void 0 : event.target)) &&
                (calbackWhenAreOutside === null || calbackWhenAreOutside === void 0 ? void 0 : calbackWhenAreOutside(false)));
        };
        var handleKeyEscPressed = function (event) {
            return event.key === 'Escape' && (calbackWhenAreOutside === null || calbackWhenAreOutside === void 0 ? void 0 : calbackWhenAreOutside(false));
        };
        var parent = document;
        parent.addEventListener('mousedown', handleClickOutside);
        parent.addEventListener('keyup', handleKeyEscPressed);
        return function () {
            parent.removeEventListener('mousedown', handleClickOutside);
            parent.removeEventListener('keyup', handleKeyEscPressed);
        };
    }, [ref, calbackWhenAreOutside]);
}

var emptyId = 'O.o';
function getAvatarUrl(_a) {
    var _b;
    var getConfig = _a.getConfig, avatarUrl = _a.avatarUrl, _c = _a.userId, userId = _c === void 0 ? emptyId : _c, keycloak = _a.keycloak;
    var tokenAvatarKey = getConfig({
        authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        key: 'jwtAttrAvatar',
    });
    var attrAvatar = tokenAvatarKey
        ? (_b = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _b === void 0 ? void 0 : _b[tokenAvatarKey]
        : undefined;
    if (attrAvatar) {
        return attrAvatar;
    }
    if (userId === emptyId) {
        return '';
    }
    return "".concat(urlSanitizer(avatarUrl), "/").concat(userId);
}
function extractFullName(_a) {
    var _b, _c, _d, _e;
    var getConfig = _a.getConfig, keycloak = _a.keycloak;
    var tokenNameKey = getConfig({
        authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        key: 'jwtAttrName',
    });
    var name = tokenNameKey
        ? (_b = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _b === void 0 ? void 0 : _b[tokenNameKey]
        : undefined;
    if (name) {
        return name;
    }
    var tokenGivenNameKey = getConfig({
        authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        key: 'jwtAttrGivenName',
    });
    var givenName = tokenGivenNameKey
        ? (_c = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _c === void 0 ? void 0 : _c[tokenGivenNameKey]
        : undefined;
    var tokenFamilyNameKey = getConfig({
        authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        key: 'jwtAttrFamilyName',
    });
    var familyName = tokenFamilyNameKey
        ? (_d = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _d === void 0 ? void 0 : _d[tokenFamilyNameKey]
        : undefined;
    if (givenName && familyName) {
        return "".concat(givenName, " ").concat(familyName);
    }
    var tokenUsernameKey = getConfig({
        authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        key: 'jwtAttrUsername',
    });
    return tokenUsernameKey
        ? (_e = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _e === void 0 ? void 0 : _e[tokenUsernameKey]
        : undefined;
}

var ERROR_CORRECTION_LEVELS = {
    low: 'L',
    medium: 'M',
    quartile: 'Q',
    high: 'H',
};
var fadeIn = keyframes(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["\n  from{\n    opacity: 0;\n  }\n  to{\n    opacity: 1;\n  }\n"], ["\n  from{\n    opacity: 0;\n  }\n  to{\n    opacity: 1;\n  }\n"])));
var QRCodeWrapper = styled.div(templateObject_4$D || (templateObject_4$D = __makeTemplateObject(["\n  animation: ", " ", ";\n  position: relative;\n  ", "\n  & > span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    ", "\n  }\n"], ["\n  animation: ", " ", ";\n  position: relative;\n  ", "\n  & > span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    ", "\n  }\n"])), fadeIn, BaSeTransitions.durationSlow, function (_a) {
    var size = _a.size;
    return css(templateObject_2$S || (templateObject_2$S = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), numberWithUnit(size), numberWithUnit(size));
}, function (_a) {
    var backgroundColor = _a.backgroundColor, logoPadding = _a.logoPadding;
    return css(templateObject_3$L || (templateObject_3$L = __makeTemplateObject(["\n      background: ", ";\n      padding: ", ";\n    "], ["\n      background: ", ";\n      padding: ", ";\n    "])), backgroundColor, numberWithUnit(logoPadding));
});
function useQRCode() {
    var generate = React.useCallback(function (_a) {
        var content = _a.content, id = _a.id, description = _a.description, logo = _a.logo, _b = _a.size, size = _b === void 0 ? 256 : _b, _c = _a.logoPadding, logoPadding = _c === void 0 ? 8 : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.defaultColors.black : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? BaSeTheme.colors.defaultColors.white : _e, _f = _a.errorCorrectionLevel, errorCorrectionLevel = _f === void 0 ? 'medium' : _f;
        var qrCode = (React.createElement(ReactQRCode, { id: id, value: removeAccents(content), size: size, fgColor: foregroundColor, bgColor: backgroundColor, level: ERROR_CORRECTION_LEVELS[errorCorrectionLevel], "aria-label": description }));
        return new Promise(function (resolve) {
            resolve(React.createElement(QRCodeWrapper, { size: size, backgroundColor: backgroundColor, logoPadding: logoPadding },
                qrCode,
                logo && React.createElement("span", null, logo)));
        });
    }, []);
    return { generate: generate };
}
var templateObject_1$_, templateObject_2$S, templateObject_3$L, templateObject_4$D;

function getLogoPath(easterEgg, image) {
    var paths = [];
    var extension = '.svg';
    easterEgg = false; // TODO quando a estratégia do easter egg estiver ok, remover essa linha
    if (easterEgg) {
        var easterEggPrefix = '__';
        var today = new Date();
        var month = today.getMonth() + 1;
        var day = today.getDate();
        paths.push("".concat(image).concat(easterEggPrefix).concat(month, "_").concat(day).concat(extension));
        paths.push("".concat(image).concat(easterEggPrefix).concat(month).concat(extension));
    }
    paths.push("".concat(image).concat(extension));
    return paths;
}

var BaSeLogoSebraeRestrict = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--logo-sebrae-restrict", description: getMessage('logo.description'), path: getLogoPath(easterEgg, 'images/logos/sebrae_logo-restrict'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebraeRestrict.displayName = 'BaSeLogoSebraeRestrict';

var AvatarOrIconAndNameAndEmail = React.memo(function (props) {
    var _a;
    var _b = React.useState(true), hasAvatar = _b[0], setHasAvatar = _b[1];
    React.useEffect(function () { return setHasAvatar(!!props.avatar); }, [props.avatar]);
    return (React.createElement(React.Fragment, null,
        hasAvatar ? (React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement("img", { loading: "lazy", className: "BaSe--account-profile-avatar", src: props.avatar, alt: getMessage('avatarImage.description'), onError: function () { return setHasAvatar(false); } }));
        })) : (React.createElement("span", { className: "BaSe--account-profile-name-abbr-icon", "aria-hidden": "true" }, (_a = props.icon) !== null && _a !== void 0 ? _a : '😃')),
        props.email ? (React.createElement("span", { className: "BaSe--account-profile-name-with-close" },
            React.createElement("span", { className: "BaSe--account-profile-name" },
                React.createElement("span", null, props.name),
                React.createElement("div", { className: "BaSe--account-profile-close-button" },
                    React.createElement(BaSeI18nConsumer, null, function (_a) {
                        var getMessage = _a.getMessage;
                        return (React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), buttonType: "button", shape: "circle", size: "small", sizeIcon: "small", type: "tertiary", color: BaSeTheme.colors.institucionais.cinzaSebrae75, onClick: function () { var _a; return (_a = props === null || props === void 0 ? void 0 : props.onClose) === null || _a === void 0 ? void 0 : _a.call(props); } }));
                    }))),
            React.createElement("small", { className: "BaSe--account-profile-email" }, props.email))) : (React.createElement("span", null,
            React.createElement("span", { className: "BaSe--account-profile-name" }, props.name)))));
});
AvatarOrIconAndNameAndEmail.displayName = 'AvatarOrIconAndNameAndEmail';

var TRANSITION = BaSeTheme.transitions.allPropertiesContinuousNormal;
var BUTTON_FOCUS_BOX_SHADOW_COLOR = BaSeTheme.colors.institucionais.azulSebrae75;
var BUTTON_HOVER_BACKGROUND_COLOR = BaSeTheme.colors.institucionais.azulSebrae30;
var BUTTON_BACKGROUND_COLOR = BaSeTheme.colors.defaultColors.transparent;
var BUTTON_HEIGHT = 32;
var BUTTON_ICON_SIZE = 15;
var BUTTON_TEXT_COLOR = BaSeTheme.colors.defaultColors.white;
var MENU_BACKGROUND_COLOR = BaSeTheme.colors.defaultColors.white;
var MENU_BORDER_COLOR = BaSeTheme.colors.institucionais.azulSebrae90;
var MENU_COLOR = BaSeTheme.colors.institucionais.azulSebrae;
var MENU_EMAIL_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae60;
var MENU_ICON_SHADOW = BaSeTheme.shadows.profundidade2;
var MENU_ICON_SIZE = 38;
var MENU_NAME_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae30;
var MENU_SEPARATOR_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae90;
var MENU_SHADOW = BaSeTheme.shadows.profundidade8;

var ContainerButtonStyled = styled.button(templateObject_2$R || (templateObject_2$R = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var iconSize = _a.iconSize, backgroundColor = _a.backgroundColor, textColor = _a.textColor, transition = _a.transition, focusBoxShadowColor = _a.focusBoxShadowColor, hoverBackgroundColor = _a.hoverBackgroundColor, iconColor = _a.iconColor, isAuthenticated = _a.isAuthenticated;
    return css(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n    line-height: 13px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: ", ";\n    display: grid;\n    gap: 4px;\n    grid-template-columns: ", "px 1fr;\n    place-items: center;\n    background: ", ";\n    border-radius: 4px;\n    border: none;\n    outline: none;\n    color: ", ";\n    overflow: hidden;\n    transition: ", ";\n    padding: 8px;\n    margin: 0;\n\n    &,\n    * {\n      font-family: ", ";\n    }\n\n    &:focus,\n    &:focus-within,\n    &:hover,\n    &:active {\n      cursor: pointer;\n      outline: none;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n\n    &:focus,\n    &:focus-within {\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n\n    .BaSe--account-profile-avatar,\n    .BaSe--account-profile-name-abbr-icon {\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n      overflow: hidden;\n    }\n\n    .BaSe--account-profile-avatar {\n      object-fit: contain;\n    }\n\n    .BaSe--account-profile-name-abbr-icon {\n      display: grid;\n      place-items: center;\n      color: ", ";\n      line-height: ", "px;\n      font-size: 13px;\n    }\n\n    .BaSe--account-profile-name {\n      display: inline;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      max-width: 100px;\n      font-size: 13px;\n    }\n  "], ["\n    line-height: 13px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: ", ";\n    display: grid;\n    gap: 4px;\n    grid-template-columns: ", "px 1fr;\n    place-items: center;\n    background: ", ";\n    border-radius: 4px;\n    border: none;\n    outline: none;\n    color: ", ";\n    overflow: hidden;\n    transition: ", ";\n    padding: 8px;\n    margin: 0;\n\n    &,\n    * {\n      font-family: ", ";\n    }\n\n    &:focus,\n    &:focus-within,\n    &:hover,\n    &:active {\n      cursor: pointer;\n      outline: none;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n\n    &:focus,\n    &:focus-within {\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n\n    .BaSe--account-profile-avatar,\n    .BaSe--account-profile-name-abbr-icon {\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n      overflow: hidden;\n    }\n\n    .BaSe--account-profile-avatar {\n      object-fit: contain;\n    }\n\n    .BaSe--account-profile-name-abbr-icon {\n      display: grid;\n      place-items: center;\n      color: ", ";\n      line-height: ", "px;\n      font-size: 13px;\n    }\n\n    .BaSe--account-profile-name {\n      display: inline;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      max-width: 100px;\n      font-size: 13px;\n    }\n  "])), BaSeTheme.typography.fontSizeBase, isAuthenticated ? iconSize * 2 + 2 : iconSize, backgroundColor, textColor, transition, BaSeTheme.typography.fontFamily, focusBoxShadowColor, hoverBackgroundColor, textColor, iconSize * 2 + 2, iconSize * 2 + 2, iconSize + 1, iconColor, iconSize);
});
var templateObject_1$Z, templateObject_2$R;

var getHeight = function (_a) {
    var contextLinksLength = _a.contextLinksLength, shownQRCode = _a.shownQRCode;
    return css(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n  height: calc(2em * ", ");\n"], ["\n  height: calc(2em * ", ");\n"])), shownQRCode ? 13 : 10 + contextLinksLength);
};
var ContainerMenuStyled = styled.div(templateObject_3$K || (templateObject_3$K = __makeTemplateObject(["\n  ", ";\n\n  font-size: ", ";\n  z-index: ", ";\n  min-width: 300px;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  top: ", ";\n  right: 0;\n  transition: ", ";\n  box-shadow: ", ";\n\n  &,\n  * {\n    font-family: ", ";\n  }\n\n  &,\n  &::before {\n    position: absolute;\n    opacity: 1;\n    transition-delay: 0;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    transform: rotate(45deg) scale(1) translateY(0);\n    top: -0.5em;\n    right: calc(1em - 4px);\n    height: 14px;\n    width: 14px;\n    background: ", ";\n    border: 1px solid transparent;\n    pointer-events: none;\n    ", "\n  }\n\n  .BaSe--account-profile-menu-wrapper {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n    display: grid;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    .BaSe--account-profile-qr-code-button {\n      margin: 0 2em;\n      button {\n        width: 100%;\n      }\n    }\n\n    .BaSe--account-profile-qr-code {\n      margin: 1em auto;\n    }\n\n    .BaSe--account-profile-separator,\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      margin: 0 2em 0 4em;\n    }\n\n    .BaSe--account-profile-avatar-and-name-email {\n      padding: 0;\n      display: grid;\n      grid-template-columns: 70px 1fr;\n      place-items: center;\n\n      & > span:not(.BaSe--account-profile-name-abbr-icon) {\n        justify-self: start;\n      }\n\n      .BaSe--account-profile-name-abbr-icon,\n      .BaSe--account-profile-avatar {\n        object-fit: contain;\n        width: ", "px;\n        height: ", "px;\n        border-radius: ", "px;\n        display: grid;\n        place-items: center;\n      }\n\n      .BaSe--account-profile-name-abbr-icon {\n        box-shadow: ", ";\n      }\n\n      .BaSe--account-profile-name-with-close {\n        width: calc(100% - 16px);\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n\n      .BaSe--account-profile-name {\n        color: ", ";\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n      }\n\n      .BaSe--account-profile-email {\n        color: ", ";\n      }\n    }\n\n    .BaSe--account-profile-separator {\n      border-bottom: 1px solid ", ";\n      height: 1px;\n    }\n\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      text-overflow: ellipsis;\n      display: inline;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    .BaSe--account-profile-close-button {\n      position: absolute;\n      right: 16px;\n    }\n  }\n\n  &.BaSe--account-profile-hidden {\n    pointer-events: none;\n\n    &,\n    &::before {\n      border: none;\n    }\n    &::before {\n      transform: rotate(0) scale(0) translateY(100%);\n    }\n\n    &,\n    .BaSe--account-profile-menu-wrapper {\n      height: 0;\n    }\n  }\n"], ["\n  ", ";\n\n  font-size: ", ";\n  z-index: ", ";\n  min-width: 300px;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  top: ", ";\n  right: 0;\n  transition: ", ";\n  box-shadow: ", ";\n\n  &,\n  * {\n    font-family: ", ";\n  }\n\n  &,\n  &::before {\n    position: absolute;\n    opacity: 1;\n    transition-delay: 0;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    transform: rotate(45deg) scale(1) translateY(0);\n    top: -0.5em;\n    right: calc(1em - 4px);\n    height: 14px;\n    width: 14px;\n    background: ", ";\n    border: 1px solid transparent;\n    pointer-events: none;\n    ", "\n  }\n\n  .BaSe--account-profile-menu-wrapper {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n    display: grid;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    .BaSe--account-profile-qr-code-button {\n      margin: 0 2em;\n      button {\n        width: 100%;\n      }\n    }\n\n    .BaSe--account-profile-qr-code {\n      margin: 1em auto;\n    }\n\n    .BaSe--account-profile-separator,\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      margin: 0 2em 0 4em;\n    }\n\n    .BaSe--account-profile-avatar-and-name-email {\n      padding: 0;\n      display: grid;\n      grid-template-columns: 70px 1fr;\n      place-items: center;\n\n      & > span:not(.BaSe--account-profile-name-abbr-icon) {\n        justify-self: start;\n      }\n\n      .BaSe--account-profile-name-abbr-icon,\n      .BaSe--account-profile-avatar {\n        object-fit: contain;\n        width: ", "px;\n        height: ", "px;\n        border-radius: ", "px;\n        display: grid;\n        place-items: center;\n      }\n\n      .BaSe--account-profile-name-abbr-icon {\n        box-shadow: ", ";\n      }\n\n      .BaSe--account-profile-name-with-close {\n        width: calc(100% - 16px);\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n\n      .BaSe--account-profile-name {\n        color: ", ";\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n      }\n\n      .BaSe--account-profile-email {\n        color: ", ";\n      }\n    }\n\n    .BaSe--account-profile-separator {\n      border-bottom: 1px solid ", ";\n      height: 1px;\n    }\n\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      text-overflow: ellipsis;\n      display: inline;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    .BaSe--account-profile-close-button {\n      position: absolute;\n      right: 16px;\n    }\n  }\n\n  &.BaSe--account-profile-hidden {\n    pointer-events: none;\n\n    &,\n    &::before {\n      border: none;\n    }\n    &::before {\n      transform: rotate(0) scale(0) translateY(100%);\n    }\n\n    &,\n    .BaSe--account-profile-menu-wrapper {\n      height: 0;\n    }\n  }\n"])), getHeight, BaSeTheme.typography.fontSizeBase, BaSeTheme.stackOrder.overlay, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var textColor = _a.textColor;
    return textColor;
}, function (_a) {
    var borderColor = _a.borderColor;
    return borderColor;
}, function (_a) {
    var wrapperHeight = _a.wrapperHeight;
    return numberWithUnit(wrapperHeight * 1.25);
}, function (_a) {
    var transition = _a.transition;
    return transition;
}, function (_a) {
    var menuShadow = _a.menuShadow;
    return menuShadow;
}, BaSeTheme.typography.fontFamily, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var borderColor = _a.borderColor;
    return css(templateObject_2$Q || (templateObject_2$Q = __makeTemplateObject(["\n      border-color: ", " transparent transparent ", ";\n    "], ["\n      border-color: ", " transparent transparent ", ";\n    "])), borderColor, borderColor);
}, function (props) { return props.iconSize; }, function (props) { return props.iconSize; }, function (props) { return props.iconSize / 2; }, function (props) { return props.iconShadow; }, function (props) { return props.textNameColor; }, function (props) { return props.textEmailColor; }, function (props) { return props.separatorColor; });
var templateObject_1$Y, templateObject_2$Q, templateObject_3$K;

var LinkStyled = styled.a(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  background: transparent;\n  border: 1px solid transparent;\n  text-decoration: none;\n  font-weight: normal;\n  line-height: 1.2em;\n  padding: 0;\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    outline: none;\n    text-decoration: underline;\n  }\n  &:active {\n    border-color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  background: transparent;\n  border: 1px solid transparent;\n  text-decoration: none;\n  font-weight: normal;\n  line-height: 1.2em;\n  padding: 0;\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    outline: none;\n    text-decoration: underline;\n  }\n  &:active {\n    border-color: ", ";\n    text-decoration: none;\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, function (props) { return props.textColor; }, function (props) { return props.textColor; });
var templateObject_1$X;

var WrapperStyled = styled.div.attrs({
    className: 'BaSe--account-profile',
})(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  position: relative;\n  overflow: visible;\n  height: ", ";\n  padding: 0;\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  position: relative;\n  overflow: visible;\n  height: ", ";\n  padding: 0;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, function (props) { return props.wrapperHeight; });
var templateObject_1$W;

var vCardTemplate = "BEGIN:VCARD\nVERSION:4.0\nFN:{name}\nEMAIL:{email}\nX-CPF:{cpf}\nEND:VCARD";
var focusHoverConfig = {
    opacity: 0.2,
    l: 0.7,
};
function makeAuthURL(authServerUrl, realm, path) {
    var authServerURL = new URL(authServerUrl);
    var authServerWithRealmURL = new URL("".concat(authServerURL.pathname, "/realms/").concat(realm), authServerURL);
    return new URL("".concat(authServerWithRealmURL.pathname, "/").concat(path), authServerWithRealmURL);
}
var BaSeAccountProfile = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var keycloak = _a.keycloak, clientName = _a.clientName, externalClientUri = _a.clientUri, externalClientId = _a.clientId, externalAvatarUrl = _a.avatarUrl, externalCpeUrl = _a.cpeUrl, externalAuthServerUrl = _a.authServerUrl, externalAuthRealm = _a.authRealm, _h = _a.authenticated, externalAuthenticated = _h === void 0 ? false : _h, _j = _a.userName, externalUserName = _j === void 0 ? '' : _j, _k = _a.userEmail, externalUserEmail = _k === void 0 ? '' : _k, _l = _a.userId, externalUserId = _l === void 0 ? '' : _l, _m = _a.contextLinks, externalContextLinks = _m === void 0 ? [] : _m, _o = _a.foregroundColor, foregroundColor = _o === void 0 ? BaSeTheme.colors.defaultColors.white : _o, _p = _a.backgroundColor, iconBackColor = _p === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _p, _q = _a.buttonCollapsed, buttonCollapsed = _q === void 0 ? false : _q, _r = _a.accountMenuItems, accountMenuItems = _r === void 0 ? {} : _r;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _s = useConfigByAuthServerUrl(), getConfig = _s.getConfig, configIsInitialized = _s.configIsInitialized;
    var _t = React.useState(false), menuOpened = _t[0], setMenuOpened = _t[1];
    var _u = React.useState(), elementQRCode = _u[0], setElementQRCode = _u[1];
    var generateQRCode = useQRCode().generate;
    var _v = React.useMemo(function () {
        var _a = accountMenuItems.myProfile, myProfile = _a === void 0 ? { show: true } : _a, _b = accountMenuItems.myBusiness, myBusiness = _b === void 0 ? { show: true } : _b, _c = accountMenuItems.changePassword, changePassword = _c === void 0 ? { show: true } : _c, _d = accountMenuItems.linkSocialNetworks, linkSocialNetworks = _d === void 0 ? { show: true } : _d, _e = accountMenuItems.logout, logout = _e === void 0 ? { show: true } : _e;
        return {
            myProfile: myProfile,
            myBusiness: myBusiness,
            changePassword: changePassword,
            linkSocialNetworks: linkSocialNetworks,
            logout: logout,
        };
    }, [accountMenuItems]), myProfile = _v.myProfile, myBusiness = _v.myBusiness, changePassword = _v.changePassword, linkSocialNetworks = _v.linkSocialNetworks, logout = _v.logout;
    var avatarUrl = React.useMemo(function () {
        var _a;
        var whenNotFoundConfig = externalAvatarUrl
            ? urlSanitizer(externalAvatarUrl)
            : undefined;
        if (configIsInitialized) {
            return ((_a = getConfig({
                authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
                key: 'avatarUrl',
            })) !== null && _a !== void 0 ? _a : whenNotFoundConfig);
        }
        return whenNotFoundConfig;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        externalAvatarUrl,
    ]);
    var cpeUrl = React.useMemo(function () {
        var _a;
        var whenNotFoundConfig = externalCpeUrl
            ? urlSanitizer(externalCpeUrl)
            : undefined;
        if (configIsInitialized) {
            return ((_a = getConfig({ authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl, key: 'cpeUrl' })) !== null && _a !== void 0 ? _a : whenNotFoundConfig);
        }
        return whenNotFoundConfig;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        externalCpeUrl,
    ]);
    var authenticated = React.useMemo(function () { var _a, _b; return (_b = (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.authenticated) !== null && _a !== void 0 ? _a : externalAuthenticated) !== null && _b !== void 0 ? _b : false; }, [keycloak === null || keycloak === void 0 ? void 0 : keycloak.authenticated, externalAuthenticated]);
    var authRealm = React.useMemo(function () { var _a; return (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.realm) !== null && _a !== void 0 ? _a : externalAuthRealm; }, [keycloak === null || keycloak === void 0 ? void 0 : keycloak.realm, externalAuthRealm]);
    var clientId = React.useMemo(function () { var _a; return (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.clientId) !== null && _a !== void 0 ? _a : externalClientId; }, [keycloak === null || keycloak === void 0 ? void 0 : keycloak.clientId, externalClientId]);
    var userName = React.useMemo(function () {
        var _a;
        if (configIsInitialized) {
            var tokenKey = getConfig({
                authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
                key: 'jwtAttrName',
            });
            if (tokenKey) {
                var tokenUserNameValue = String((_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a[tokenKey]);
                if (tokenUserNameValue) {
                    return tokenUserNameValue;
                }
            }
        }
        if (externalUserName !== '') {
            return externalUserName;
        }
        return undefined;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        externalUserName,
    ]);
    var getFromToken = React.useCallback(function (key) {
        var _a;
        if (configIsInitialized) {
            var config = getConfig({
                authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
                key: key,
            });
            if (config) {
                return String((_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a[config]);
            }
        }
        return undefined;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
    ]);
    var userEmail = React.useMemo(function () { var _a; return (_a = getFromToken('jwtAttrEmail')) !== null && _a !== void 0 ? _a : externalUserEmail; }, [getFromToken, externalUserEmail]);
    var userCPF = React.useMemo(function () { return getFromToken('jwtAttrCpf'); }, [getFromToken]);
    var userId = React.useMemo(function () { var _a; return (_a = getFromToken('jwtAttrId')) !== null && _a !== void 0 ? _a : externalUserId; }, [getFromToken, externalUserId]);
    var contextLinks = React.useMemo(function () { return (!Array.isArray(externalContextLinks) ? [] : externalContextLinks); }, [externalContextLinks]);
    var authServerUrl = React.useMemo(function () {
        return (keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl)
            ? urlSanitizer(keycloak.authServerUrl)
            : externalAuthServerUrl
                ? urlSanitizer(externalAuthServerUrl)
                : undefined;
    }, [keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl, externalAuthServerUrl]);
    var clientUri = React.useMemo(function () {
        return externalClientUri
            ? urlSanitizer(externalClientUri)
            : window.location.href;
    }, [externalClientUri]);
    var authLinks = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!authServerUrl || !authRealm) {
            return [];
        }
        var accountURL = makeAuthURL(authServerUrl, authRealm, 'account');
        var socialAccountsURL = makeAuthURL(authServerUrl, authRealm, 'account/identity');
        if (clientName) {
            accountURL.searchParams.set('referrer_name', clientName);
            socialAccountsURL.searchParams.set('referrer_name', clientName);
        }
        if (clientUri) {
            accountURL.searchParams.set('referrer_uri', clientUri);
            socialAccountsURL.searchParams.set('referrer_uri', clientUri);
        }
        if (clientId) {
            accountURL.searchParams.set('referrer', clientId);
            socialAccountsURL.searchParams.set('referrer', clientId);
        }
        var cpeURL;
        if (cpeUrl) {
            cpeURL = new URL(cpeUrl);
            if (clientName) {
                cpeURL.searchParams.set('sistema', clientName);
            }
            if (clientUri) {
                cpeURL.searchParams.set('voltar', clientUri);
            }
        }
        var defaultAccountMenuConfig = {
            myProfile: {
                show: (_a = myProfile.show) !== null && _a !== void 0 ? _a : true,
                label: (_b = myProfile.label) !== null && _b !== void 0 ? _b : getMessage('myProfile.label'),
                url: (_c = myProfile.link) !== null && _c !== void 0 ? _c : accountURL.toString(),
            },
            myBusiness: {
                show: (_d = myBusiness.show) !== null && _d !== void 0 ? _d : Boolean(cpeURL),
                label: (_e = myBusiness.label) !== null && _e !== void 0 ? _e : getMessage('myBusiness.label'),
                url: (_g = (_f = myBusiness.link) !== null && _f !== void 0 ? _f : cpeURL === null || cpeURL === void 0 ? void 0 : cpeURL.toString()) !== null && _g !== void 0 ? _g : '',
            },
            changePassword: {
                show: (_h = changePassword.show) !== null && _h !== void 0 ? _h : authRealm !== 'interno',
                label: (_j = changePassword.label) !== null && _j !== void 0 ? _j : getMessage('changePassword.label'),
                url: (_k = changePassword.link) !== null && _k !== void 0 ? _k : undefined,
                onClick: function () {
                    var redirectToChangePassword = function () {
                        var passwordURL = makeAuthURL(authServerUrl, authRealm, 'account/password');
                        if (clientName) {
                            passwordURL.searchParams.set('referrer_name', clientName);
                        }
                        if (clientUri) {
                            passwordURL.searchParams.set('referrer_uri', clientUri);
                        }
                        if (clientId) {
                            passwordURL.searchParams.set('referrer', clientId);
                        }
                        window.location.href = passwordURL.toString();
                    };
                    if (typeof (keycloak === null || keycloak === void 0 ? void 0 : keycloak.login) === 'function') {
                        keycloak
                            .login({ action: 'UPDATE_PASSWORD' })
                            .catch(function () { return redirectToChangePassword(); });
                        return;
                    }
                    redirectToChangePassword();
                },
            },
            linkSocialNetworks: {
                show: (_l = linkSocialNetworks.show) !== null && _l !== void 0 ? _l : true,
                label: (_m = linkSocialNetworks.label) !== null && _m !== void 0 ? _m : getMessage('socialAccounts.label'),
                url: (_o = linkSocialNetworks.link) !== null && _o !== void 0 ? _o : socialAccountsURL.toString(),
            },
        };
        var accountMenu = Object.keys(defaultAccountMenuConfig).reduce(function (acc, key) {
            var customItem = accountMenuItems[key];
            if (customItem && customItem.show === false)
                return acc;
            var defaultItem = defaultAccountMenuConfig[key];
            if (!(defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.show))
                return acc;
            var finalItem = __assign({ label: (customItem === null || customItem === void 0 ? void 0 : customItem.label) || defaultItem.label }, (defaultItem.url
                ? { url: (customItem === null || customItem === void 0 ? void 0 : customItem.link) || defaultItem.url }
                : { onClick: defaultItem.onClick }));
            acc.push(finalItem);
            return acc;
        }, []);
        return accountMenu;
    }, [
        authRealm,
        authServerUrl,
        changePassword,
        clientId,
        clientName,
        clientUri,
        cpeUrl,
        getMessage,
        keycloak,
        linkSocialNetworks,
        accountMenuItems,
        myBusiness,
        myProfile,
    ]);
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, setMenuOpened);
    var getLoggedFullName = React.useCallback(function () {
        var _a;
        var whenNotFoundConfig = userName !== null && userName !== void 0 ? userName : getMessage('myAccount.label');
        if (configIsInitialized) {
            return (_a = extractFullName({ getConfig: getConfig, keycloak: keycloak })) !== null && _a !== void 0 ? _a : whenNotFoundConfig;
        }
        return whenNotFoundConfig;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        userName,
        getMessage,
    ]);
    var getLoggedName = React.useCallback(function () { var _a, _b, _c; return (_c = (_b = (_a = getLoggedFullName()) === null || _a === void 0 ? void 0 : _a.split(' ')) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : ''; }, [getLoggedFullName]);
    var getAvatar = React.useCallback(function () {
        if (configIsInitialized) {
            return getAvatarUrl({ getConfig: getConfig, avatarUrl: avatarUrl, userId: userId, keycloak: keycloak });
        }
        return undefined;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        avatarUrl,
        userId,
    ]);
    var authLogin = React.useCallback(function () {
        var redirectToLogin = function () {
            if (!authServerUrl || !authRealm) {
                return;
            }
            var loginURL = makeAuthURL(authServerUrl, authRealm, 'protocol/openid-connect/auth');
            loginURL.searchParams.set('response_type', 'code');
            if (clientUri) {
                loginURL.searchParams.set('redirect_uri', clientUri);
            }
            if (clientId) {
                loginURL.searchParams.set('client_id', clientId);
            }
            window.location.href = loginURL.toString();
        };
        if (typeof (keycloak === null || keycloak === void 0 ? void 0 : keycloak.login) === 'function') {
            if (clientUri) {
                keycloak
                    .login({ redirectUri: clientUri })
                    .catch(function () { return redirectToLogin(); });
                return;
            }
            keycloak.login().catch(function () { return redirectToLogin(); });
            return;
        }
        redirectToLogin();
    }, [authRealm, authServerUrl, clientId, clientUri, keycloak === null || keycloak === void 0 ? void 0 : keycloak.login]);
    var authLogout = React.useCallback(function () {
        var redirectToLogout = function () {
            if (!authServerUrl || !authRealm) {
                return;
            }
            var logoutURL = makeAuthURL(authServerUrl, authRealm, 'protocol/openid-connect/logout');
            if (clientUri) {
                logoutURL.searchParams.set('post_logout_redirect_uri', clientUri);
            }
            if (clientId) {
                logoutURL.searchParams.set('client_id', clientId);
            }
            window.location.href = logoutURL.toString();
        };
        if (typeof (keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout) === 'function') {
            if (clientUri) {
                keycloak
                    .logout({ redirectUri: clientUri })
                    .catch(function () { return redirectToLogout(); });
                return;
            }
            keycloak.logout().catch(function () { return redirectToLogout(); });
            return;
        }
        redirectToLogout();
    }, [authRealm, authServerUrl, clientUri, clientId, keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout]);
    var logoutAccountMenuItem = React.useMemo(function () {
        var _a, _b, _c, _d;
        return logout.link
            ? {
                show: (_a = logout.show) !== null && _a !== void 0 ? _a : true,
                label: (_b = logout.label) !== null && _b !== void 0 ? _b : getMessage('logout.label'),
                url: logout.link,
            }
            : {
                show: (_c = logout.show) !== null && _c !== void 0 ? _c : true,
                label: (_d = logout.label) !== null && _d !== void 0 ? _d : getMessage('logout.label'),
                onClick: authLogout,
            };
    }, [authLogout, getMessage, logout]);
    var getQRCodeContent = React.useCallback(function () {
        return vCardTemplate
            .replace('{name}', getLoggedFullName())
            .replace('{email}', userEmail)
            .replace('{cpf}', userCPF !== null && userCPF !== void 0 ? userCPF : '');
    }, [getLoggedFullName, userEmail, userCPF]);
    var getQRCodeDescription = React.useCallback(function () {
        return getMessage('myQRCode.description', getLoggedFullName(), userCPF !== null && userCPF !== void 0 ? userCPF : '', userEmail);
    }, [getLoggedFullName, userEmail, userCPF]);
    if (!configIsInitialized) {
        return (React.createElement(BaSeLoadingSpinner, { diameter: BUTTON_ICON_SIZE, color: foregroundColor, description: getMessage('loading.description') }));
    }
    if (authenticated) {
        return (React.createElement(WrapperStyled, { ref: wrapperRef, wrapperHeight: BUTTON_HEIGHT },
            React.createElement(ContainerButtonStyled, { isAuthenticated: authenticated, type: "button", onClick: function () { return setMenuOpened(function (opened) { return !opened; }); }, hoverBackgroundColor: (_b = createColor(foregroundColor, focusHoverConfig)) !== null && _b !== void 0 ? _b : BUTTON_HOVER_BACKGROUND_COLOR, focusBoxShadowColor: (_c = createButtonFocusColor(foregroundColor)) !== null && _c !== void 0 ? _c : BUTTON_FOCUS_BOX_SHADOW_COLOR, backgroundColor: BUTTON_BACKGROUND_COLOR, iconSize: BUTTON_ICON_SIZE, textColor: foregroundColor, iconColor: iconBackColor, transition: TRANSITION },
                React.createElement(AvatarOrIconAndNameAndEmail, { avatar: (_d = getAvatar()) !== null && _d !== void 0 ? _d : '', icon: userName ? nameAbbreviation(getLoggedFullName()) : undefined, name: buttonCollapsed ? '' : getLoggedName() })),
            React.createElement(ContainerMenuStyled, { className: menuOpened ? '' : 'BaSe--account-profile-hidden', "aria-label": getMessage('menuAccountProfile.ariaLabel'), contextLinksLength: contextLinks.length, shownQRCode: !!elementQRCode, wrapperHeight: BUTTON_HEIGHT, backgroundColor: MENU_BACKGROUND_COLOR, borderColor: MENU_BORDER_COLOR, textColor: MENU_COLOR, textEmailColor: MENU_EMAIL_COLOR, iconShadow: MENU_ICON_SHADOW, iconSize: MENU_ICON_SIZE, textNameColor: MENU_NAME_COLOR, separatorColor: MENU_SEPARATOR_COLOR, menuShadow: MENU_SHADOW, transition: TRANSITION },
                React.createElement("ul", { className: "BaSe--account-profile-menu-wrapper", role: "menu" },
                    React.createElement("li", { className: "BaSe--account-profile-avatar-and-name-email" },
                        React.createElement(AvatarOrIconAndNameAndEmail, { avatar: (_e = getAvatar()) !== null && _e !== void 0 ? _e : '', icon: userName ? nameAbbreviation(getLoggedFullName()) : undefined, name: getLoggedFullName(), email: userEmail, onClose: function () { return setMenuOpened(false); } })),
                    elementQRCode ? (React.createElement(React.Fragment, null,
                        React.createElement("li", { className: "BaSe--account-profile-qr-code" }, elementQRCode),
                        React.createElement("li", { className: "BaSe--account-profile-qr-code-button" },
                            React.createElement(BaSeButton, { leftIcon: "angle-left-alt", value: getMessage('myQRCode.back'), type: "secondary", color: MENU_COLOR, onClick: function () { return setElementQRCode(undefined); } })))) : (React.createElement(React.Fragment, null,
                        React.createElement("li", { className: "BaSe--account-profile-qr-code-button" },
                            React.createElement(BaSeButton, { leftIcon: "device/qr-code-line", value: getMessage('myQRCode.generate'), type: "secondary", color: MENU_COLOR, isDisabled: !userName, onClick: function () {
                                    generateQRCode({
                                        content: getQRCodeContent(),
                                        description: getQRCodeDescription(),
                                        id: 'BaSe--meu-qr-code-sebrae',
                                        errorCorrectionLevel: 'high',
                                        logo: React.createElement(BaSeLogoSebraeRestrict, null),
                                    })
                                        .then(setElementQRCode)
                                        .catch(function () { return setElementQRCode(undefined); });
                                } })), contextLinks === null || contextLinks === void 0 ? void 0 :
                        contextLinks.map(function (link) { return (React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-context-link", key: link.label },
                            React.createElement(LinkStyled, { textColor: MENU_COLOR, as: "a", title: link.label, href: link.url }, link.label))); }),
                        React.createElement("li", { className: "BaSe--account-profile-separator", "aria-hidden": "true" }),
                        authLinks.map(function (link) { return (React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-auth-link", key: link.label },
                            React.createElement(LinkStyled, { textColor: MENU_COLOR, as: link.onClick ? 'button' : 'a', title: link.label, href: link.url, type: link.onClick ? 'button' : undefined, onClick: link.onClick }, link.label))); }),
                        logoutAccountMenuItem.show && (React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-auth-link" },
                            React.createElement(LinkStyled, { textColor: MENU_COLOR, as: logoutAccountMenuItem.onClick ? 'button' : 'a', title: logoutAccountMenuItem.label, href: logoutAccountMenuItem.url, type: logoutAccountMenuItem.onClick ? 'button' : undefined, onClick: logoutAccountMenuItem.onClick }, logoutAccountMenuItem.label)))))))));
    }
    return (React.createElement(ContainerButtonStyled, { isAuthenticated: authenticated, type: "button", onClick: authLogin, hoverBackgroundColor: (_f = createColor(foregroundColor, focusHoverConfig)) !== null && _f !== void 0 ? _f : BUTTON_HOVER_BACKGROUND_COLOR, focusBoxShadowColor: (_g = createButtonFocusColor(foregroundColor)) !== null && _g !== void 0 ? _g : BUTTON_FOCUS_BOX_SHADOW_COLOR, backgroundColor: BUTTON_BACKGROUND_COLOR, iconSize: BUTTON_ICON_SIZE, textColor: BUTTON_TEXT_COLOR, iconColor: MENU_COLOR, transition: TRANSITION, disabled: !authServerUrl || !authRealm },
        React.createElement(BaSeIcon, { size: BUTTON_ICON_SIZE, name: "user", color: foregroundColor, description: getMessage('imageAccountProfile.description') }),
        React.createElement(BaSeSmall1, { isBold: true, isItalic: false, isThin: false, color: foregroundColor }, buttonCollapsed ? '' : getMessage('login.label'))));
};
BaSeAccountProfile.displayName = 'BaSeAccountProfile';

var BoxContent = styled.ul.attrs({
    className: 'BaSe--box',
})(templateObject_4$C || (templateObject_4$C = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  will-change: box-shadow, transform;\n  transition: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n\n  ", "\n\n  ", "\n"], ["\n  margin: 0;\n  padding: 0;\n  will-change: box-shadow, transform;\n  transition: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n\n  ", "\n\n  ", "\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var borderColor = _a.borderColor;
    return borderColor;
}, function (_a) {
    var height = _a.height, width = _a.width, borderRadius = _a.borderRadius;
    return css(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n    height: ", ";\n    width: ", ";\n    border-radius: ", ";\n    overflow: ", ";\n  "], ["\n    height: ", ";\n    width: ", ";\n    border-radius: ", ";\n    overflow: ", ";\n  "])), numberWithUnit(height, 'px', 'auto'), numberWithUnit(width, 'px', 'auto'), numberWithUnit(borderRadius), numberWithUnit(height, 'px', 'auto') !== 'auto'
        ? 'auto'
        : 'visible');
}, function (_a) {
    var shadowLevel = _a.shadowLevel, elevationOnHoverOrFocus = _a.elevationOnHoverOrFocus, isElevated = _a.isElevated;
    return shadowLevel && css(templateObject_3$J || (templateObject_3$J = __makeTemplateObject(["\n      box-shadow: ", ";\n\n      ", "\n\n      ", "\n    "], ["\n      box-shadow: ", ";\n\n      ", "\n\n      ", "\n    "])), getShadow(shadowLevel), isElevated && elevatedCss, elevationOnHoverOrFocus && css(templateObject_2$P || (templateObject_2$P = __makeTemplateObject(["\n        &:hover,\n        &:focus-within {\n          ", "\n        }\n      "], ["\n        &:hover,\n        &:focus-within {\n          ", "\n        }\n      "])), elevatedCss));
});
var ContentItem = styled.li(templateObject_6$u || (templateObject_6$u = __makeTemplateObject(["\n  padding: 16px;\n\n  ", "\n"], ["\n  padding: 16px;\n\n  ", "\n"])), function (_a) {
    var borderColor = _a.borderColor, isLast = _a.isLast;
    return !isLast && css(templateObject_5$w || (templateObject_5$w = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n    "], ["\n      border-bottom: 1px solid ", ";\n    "])), borderColor);
});
var templateObject_1$V, templateObject_2$P, templateObject_3$J, templateObject_4$C, templateObject_5$w, templateObject_6$u;

var colors$4 = BaSeTheme.colors;
var BaSeBox = function (_a) {
    var height = _a.height, width = _a.width, _b = _a.borderRadius, borderRadius = _b === void 0 ? 8 : _b, _c = _a.elevationOnHoverOrFocus, elevationOnHoverOrFocus = _c === void 0 ? true : _c, _d = _a.isElevated, isElevated = _d === void 0 ? false : _d, _e = _a.shadowLevel, shadowLevel = _e === void 0 ? 0 : _e, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? colors$4.defaultColors.white : _f, _g = _a.borderColor, borderColor = _g === void 0 ? colors$4.institucionais.cinzaSebrae90 : _g, renderContent = _a.renderContent;
    var content = React.useMemo(function () { return renderContent(); }, [renderContent]);
    return (React.createElement(BoxContent, { height: height, width: width, borderRadius: borderRadius, backgroundColor: backgroundColor, borderColor: borderColor, shadowLevel: shadowLevel, elevationOnHoverOrFocus: elevationOnHoverOrFocus, isElevated: isElevated }, Array.isArray(content) ? (content.map(function (item, index) { return (React.createElement(ContentItem, { key: index, borderColor: borderColor, isLast: content.length === index + 1 }, item)); })) : (React.createElement(ContentItem, { borderColor: borderColor, isLast: true }, content))));
};

var initialPosition = 'initial';
var defaultBorderRadius = '50%';
var paddingWithIcon = '2px';
var paddingWithValue = '2px 6px';
var paddingWithoutAnything = '8px';
var BadgeContainer = styled.div.attrs({
    className: 'BaSe--badge-container',
})(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  &.BaSe--badge-container {\n    display: flex;\n    width: fit-content;\n  }\n"], ["\n  &.BaSe--badge-container {\n    display: flex;\n    width: fit-content;\n  }\n"])));
var BadgeContent = styled.div.attrs({
    className: 'BaSe--badge-content',
})(templateObject_2$O || (templateObject_2$O = __makeTemplateObject(["\n  &.BaSe--badge-content {\n    font-family: ", ";\n  }\n"], ["\n  &.BaSe--badge-content {\n    font-family: ", ";\n  }\n"])), BaSeTheme.typography.fontFamily);
var Badge = styled.div.attrs({
    className: 'BaSe--badge',
})(templateObject_5$v || (templateObject_5$v = __makeTemplateObject(["\n  &.BaSe--badge {\n    box-sizing: border-box;\n    position: relative;\n    top: ", ";\n    bottom: ", ";\n    left: ", ";\n    right: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    border: 2px solid ", ";\n    background-color: ", ";\n\n    ", "\n    ", "\n\n    &, ", " {\n      display: grid;\n      place-items: center;\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  &.BaSe--badge {\n    box-sizing: border-box;\n    position: relative;\n    top: ", ";\n    bottom: ", ";\n    left: ", ";\n    right: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    border: 2px solid ", ";\n    background-color: ", ";\n\n    ", "\n    ", "\n\n    &, ", " {\n      display: grid;\n      place-items: center;\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var top = _a.top;
    return numberWithUnit(top);
}, function (_a) {
    var bottom = _a.bottom;
    return numberWithUnit(bottom);
}, function (_a) {
    var left = _a.left;
    return numberWithUnit(left);
}, function (_a) {
    var right = _a.right;
    return numberWithUnit(right);
}, function (_a) {
    var padding = _a.padding;
    return padding;
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return numberWithUnit(borderRadius);
}, function (_a) {
    var border = _a.border;
    return border;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var width = _a.width;
    return css(templateObject_3$I || (templateObject_3$I = __makeTemplateObject(["\n      min-width: ", ";\n      width: ", ";\n    "], ["\n      min-width: ", ";\n      width: ", ";\n    "])), numberWithUnit(width !== null && width !== void 0 ? width : '1em'), numberWithUnit(width));
}, function (_a) {
    var height = _a.height;
    return css(templateObject_4$B || (templateObject_4$B = __makeTemplateObject(["\n      min-height: ", ";\n      height: ", ";\n      ", " {\n        font-size: calc(", " - 1em);\n        line-height: calc(", " - 1em);\n      }\n    "], ["\n      min-height: ", ";\n      height: ", ";\n      ", " {\n        font-size: calc(", " - 1em);\n        line-height: calc(", " - 1em);\n      }\n    "])), numberWithUnit(height !== null && height !== void 0 ? height : '1em'), numberWithUnit(height), BadgeContent, numberWithUnit(height !== null && height !== void 0 ? height : '2em'), numberWithUnit(height !== null && height !== void 0 ? height : '2em'));
}, BadgeContent, BadgeContent, function (_a) {
    var color = _a.color;
    return color;
});
var templateObject_1$U, templateObject_2$O, templateObject_3$I, templateObject_4$B, templateObject_5$v;

var mapBadgeValues = function (color) {
    if (color === void 0) { color = 'default'; }
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.attention ||
        color === BaSeTheme.components.button.colors.confirmation;
    // color === BaSeTheme.components.button.colors.negative;
    if (colorIsMapped) {
        return {
            primary: {
                color: BaSeTheme.colors.defaultColors.white,
                style: {
                    bgC: ColorMapper[color].foreground,
                    border: BaSeTheme.colors.defaultColors.white,
                },
            },
            secondary: {
                color: ColorMapper[color].hover.defaultDark,
                style: {
                    bgC: ColorMapper[color].hover.defaultLight,
                    border: ColorMapper[color].foreground,
                },
            },
            tertiary: {
                color: ColorMapper[color].hover.defaultDark,
                style: {
                    bgC: ColorMapper[color].hover.defaultLight,
                    border: 'none',
                },
            },
        };
    }
    var customColorHsv = Color.generateFromHex(color);
    return {
        primary: {
            color: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                border: BaSeTheme.colors.defaultColors.white,
            },
        },
        secondary: {
            color: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
            style: {
                bgC: ColorMapper.light.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                border: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        },
        tertiary: {
            color: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
            style: {
                bgC: ColorMapper.light.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                border: 'none',
            },
        },
    };
};

var valueNumberLimitDefault = 9;
var BaSeBadge = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _m = React.useMemo(function () {
        var _a, _b;
        return mapBadgeValues((_a = props.color) !== null && _a !== void 0 ? _a : 'default')[(_b = props.type) !== null && _b !== void 0 ? _b : 'primary'];
    }, [props.color, props.type]), textColor = _m.color, _o = _m.style, backgroundColor = _o.bgC, border = _o.border;
    var showBadge = React.useMemo(function () { var _a; return ((_a = props.show) !== null && _a !== void 0 ? _a : true) && props.value !== 0; }, [props.show, props.value]);
    var padding = React.useMemo(function () {
        return !props.value
            ? paddingWithoutAnything
            : typeof props.value === 'object'
                ? paddingWithIcon
                : paddingWithValue;
    }, [props.value]);
    var renderValue = React.useCallback(function () {
        var _a;
        var value = props.value;
        if (typeof value === 'string') {
            return value;
        }
        if (typeof value === 'number') {
            var limit = (_a = props.valueNumberLimit) !== null && _a !== void 0 ? _a : valueNumberLimitDefault;
            if (value > limit) {
                return "".concat(limit, "+");
            }
            if (value < -limit) {
                return "-".concat(limit);
            }
            return '' + value;
        }
        return '';
    }, [props.value, props.valueNumberLimit]);
    return (React.createElement(BadgeContainer, null,
        props.children,
        showBadge && (React.createElement(Badge, { right: (_b = (_a = props.position) === null || _a === void 0 ? void 0 : _a.right) !== null && _b !== void 0 ? _b : initialPosition, left: (_d = (_c = props.position) === null || _c === void 0 ? void 0 : _c.left) !== null && _d !== void 0 ? _d : initialPosition, bottom: (_f = (_e = props.position) === null || _e === void 0 ? void 0 : _e.bottom) !== null && _f !== void 0 ? _f : initialPosition, top: (_h = (_g = props.position) === null || _g === void 0 ? void 0 : _g.top) !== null && _h !== void 0 ? _h : initialPosition, backgroundColor: backgroundColor, border: border, color: textColor, padding: padding, borderRadius: (_j = props.borderRadius) !== null && _j !== void 0 ? _j : defaultBorderRadius, width: props.width, height: props.height },
            React.createElement(BadgeContent, null, typeof props.value === 'object' ? (React.createElement(BaSeIcon, { color: textColor, name: props.value.name, size: (_k = props.value.size) !== null && _k !== void 0 ? _k : 16, description: (_l = props.value.description) !== null && _l !== void 0 ? _l : getMessage('icon.label', getMessage('badge.marker')) })) : (renderValue()))))));
};
BaSeBadge.displayName = 'BaSeBadge';

var mapTagValues = function (color) {
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.attention ||
        color === BaSeTheme.components.button.colors.confirmation;
    if (colorIsMapped) {
        var darkColor = color === 'default'
            ? BaSeTheme.colors.defaultColors.white
            : ColorMapper[color]
                .foreground;
        return {
            primary: {
                dark: {
                    iconColor: ColorMapper[(color === 'default' ? 'grayScale' : color)].foreground,
                    style: {
                        bgC: BaSeTheme.colors.defaultColors.white,
                        bcCHover: ColorMapper[(color === 'default' ? 'grayScale' : color)].hover.defaultDark,
                        boxShadowFocus: "0px 0px 4px ".concat(BaSeTheme.colors.defaultColors.white),
                        border: BaSeTheme.colors.defaultColors.transparent,
                    },
                },
                light: {
                    iconColor: ColorMapper[color].foreground,
                    style: {
                        bgC: ColorMapper[color].hover.defaultLight,
                        bcCHover: ColorMapper[color].hover.defaultDark,
                        boxShadowFocus: "0px 0px 4px ".concat(ColorMapper[color].focus.defaultLight),
                        border: BaSeTheme.colors.defaultColors.transparent,
                    },
                },
            },
            secondary: {
                dark: {
                    iconColor: darkColor,
                    style: {
                        bgC: BaSeTheme.colors.institucionais.cinzaSebrae20,
                        bcCHover: ColorMapper[(color === 'default' ? 'grayScale' : color)].focus.defaultLight,
                        boxShadowFocus: "0px 0px 4px ".concat(darkColor),
                        border: darkColor,
                    },
                },
                light: {
                    iconColor: ColorMapper[color].foreground,
                    style: {
                        bgC: BaSeTheme.colors.defaultColors.white,
                        bcCHover: ColorMapper[color].hover.defaultDark,
                        boxShadowFocus: "0px 0px 4px ".concat(ColorMapper[color].focus.defaultLight),
                        border: ColorMapper[color].foreground,
                    },
                },
            },
        };
    }
    var customColorHsv = Color.generateFromHex(color);
    return {
        primary: {
            light: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: ColorMapper.light.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    bcCHover: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36)),
                    border: BaSeTheme.colors.defaultColors.transparent,
                },
            },
            dark: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.white,
                    bcCHover: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(BaSeTheme.colors.defaultColors.white),
                    border: BaSeTheme.colors.defaultColors.transparent,
                },
            },
        },
        secondary: {
            light: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.transparent,
                    bcCHover: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36)),
                    border: color && customColorHsv
                        ? customColorHsv.toString()
                        : BaSeTheme.colors.institucionais.azulSebrae36,
                },
            },
            dark: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: BaSeTheme.colors.institucionais.cinzaSebrae20,
                    bcCHover: ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(color && customColorHsv
                        ? customColorHsv.toString()
                        : BaSeTheme.colors.institucionais.azulSebrae36),
                    border: color && customColorHsv
                        ? customColorHsv.toString()
                        : BaSeTheme.colors.institucionais.azulSebrae36,
                },
            },
        },
    };
};

var borderSize = 1;
function getSize$1(_a) {
    var size = _a.size, bigSize = _a.bigSize, mediumSize = _a.mediumSize, smallSize = _a.smallSize;
    return size === 'big' ? bigSize : size === 'medium' ? mediumSize : smallSize;
}
function getDiffSize(_a) {
    var size = _a.size, hasClose = _a.hasClose, hasIcon = _a.hasIcon;
    var sizes = {
        small: [16, 31, 29, 42],
        medium: [16, 34, 32, 48],
        big: [24, 50, 48, 72],
    };
    var index = parseInt("".concat(+hasClose).concat(+hasIcon), 2);
    return sizes[size][index];
}
var TagContainerStyled = styled.div(templateObject_9$l || (templateObject_9$l = __makeTemplateObject(["\n  height: ", "px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  align-items: center;\n  border: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", ";\n"], ["\n  height: ", "px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  align-items: center;\n  border: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", ";\n"])), function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var type = _a.type, border = _a.border, isSelected = _a.isSelected, themeMode = _a.themeMode;
    return (type === 'primary' && !isSelected) || themeMode === 'dark'
        ? 'none'
        : "".concat(borderSize, "px solid ").concat(border);
}, function (props) { return getSize$1(props); }, function (_a) {
    var bgC = _a.bgC;
    return bgC;
}, function (_a) {
    var onClick = _a.onClick, boxShadowFocus = _a.boxShadowFocus, bcCHover = _a.bcCHover, isSelected = _a.isSelected, themeMode = _a.themeMode;
    return onClick && css(templateObject_4$A || (templateObject_4$A = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        ", "\n        ", "\n      }\n      &:focus {\n        ", "\n        outline: none;\n        box-shadow: ", ";\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        ", "\n        ", "\n      }\n      &:focus {\n        ", "\n        outline: none;\n        box-shadow: ", ";\n      }\n    "])), isSelected && css(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n          border-color: ", ";\n        "], ["\n          border-color: ", ";\n        "])), bcCHover), isSelected &&
        themeMode === 'dark' && css(templateObject_2$N || (templateObject_2$N = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), bcCHover), isSelected && css(templateObject_3$H || (templateObject_3$H = __makeTemplateObject(["\n          border-color: ", ";\n        "], ["\n          border-color: ", ";\n        "])), bcCHover), boxShadowFocus);
}, function (_a) {
    var onClick = _a.onClick, bcCHover = _a.bcCHover, type = _a.type, isSelected = _a.isSelected;
    return onClick &&
        type === 'secondary' && css(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n      &:hover {\n        border-color: ", ";\n        ", "\n      }\n      &:focus {\n        border-color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        border-color: ", ";\n        ", "\n      }\n      &:focus {\n        border-color: ", ";\n        ", "\n      }\n    "])), bcCHover, isSelected && css(templateObject_5$u || (templateObject_5$u = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), bcCHover), bcCHover, isSelected && css(templateObject_6$t || (templateObject_6$t = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), bcCHover));
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_8$n || (templateObject_8$n = __makeTemplateObject(["\n      cursor: not-allowed;\n    "], ["\n      cursor: not-allowed;\n    "])));
});
var TagIcon = styled.span(templateObject_10$j || (templateObject_10$j = __makeTemplateObject(["\n  border-radius: 50%;\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  img {\n    display: flex;\n    flex: 1;\n  }\n"], ["\n  border-radius: 50%;\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  img {\n    display: flex;\n    flex: 1;\n  }\n"])), function (_a) {
    var type = _a.type, newIconColor = _a.newIconColor;
    return type === 'primary' ? newIconColor : 'none';
}, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
});
var TagText = styled.span(templateObject_15$d || (templateObject_15$d = __makeTemplateObject(["\n  padding: ", "px\n    ", "px;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  padding: ", "px\n    ", "px;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return (size === 'big' ? 8 : 2);
}, function (_a) {
    var size = _a.size;
    return (size === 'big' ? 12 : 8);
}, function (_a) {
    var onClose = _a.onClose;
    return onClose && css(templateObject_11$h || (templateObject_11$h = __makeTemplateObject(["\n      padding-right: 4px;\n    "], ["\n      padding-right: 4px;\n    "])));
}, function (_a) {
    var icon = _a.icon;
    return icon && css(templateObject_12$g || (templateObject_12$g = __makeTemplateObject(["\n      padding-left: 4px;\n    "], ["\n      padding-left: 4px;\n    "])));
}, function (_a) {
    var icon = _a.icon, newIconColor = _a.newIconColor;
    return icon &&
        newIconColor === BaSeTheme.colors.defaultColors.transparent && css(templateObject_13$e || (templateObject_13$e = __makeTemplateObject(["\n      margin-left: 0;\n    "], ["\n      margin-left: 0;\n    "])));
}, function (_a) {
    var limitedWidth = _a.limitedWidth, size = _a.size, onClose = _a.onClose, icon = _a.icon;
    return limitedWidth && css(templateObject_14$e || (templateObject_14$e = __makeTemplateObject(["\n      & > small[class*='BaSe'] {\n        display: inline-block;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 100%;\n        vertical-align: top;\n        max-width: calc(\n          ", " -\n            ", "\n        );\n      }\n    "], ["\n      & > small[class*='BaSe'] {\n        display: inline-block;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 100%;\n        vertical-align: top;\n        max-width: calc(\n          ", " -\n            ", "\n        );\n      }\n    "])), numberWithUnit(limitedWidth), numberWithUnit(getDiffSize({ size: size, hasClose: !!onClose, hasIcon: !!icon })));
});
var TagClose = styled.span(templateObject_17$a || (templateObject_17$a = __makeTemplateObject(["\n  button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    height: ", "px;\n    width: ", "px;\n    padding: 0;\n    display: flex;\n    ", "\n    img {\n      flex: 1;\n      height: ", "px;\n      width: ", "px;\n    }\n  }\n"], ["\n  button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    height: ", "px;\n    width: ", "px;\n    padding: 0;\n    display: flex;\n    ", "\n    img {\n      flex: 1;\n      height: ", "px;\n      width: ", "px;\n    }\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var themeMode = _a.themeMode, bcCHover = _a.bcCHover;
    return themeMode === 'dark' && css(templateObject_16$b || (templateObject_16$b = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n        }\n      "])), bcCHover);
}, function (_a) {
    var size = _a.size;
    return size === 'big' ? 28 : size === 'medium' ? 14 : 12;
}, function (_a) {
    var size = _a.size;
    return size === 'big' ? 28 : size === 'medium' ? 14 : 12;
});
var templateObject_1$T, templateObject_2$N, templateObject_3$H, templateObject_4$A, templateObject_5$u, templateObject_6$t, templateObject_7$o, templateObject_8$n, templateObject_9$l, templateObject_10$j, templateObject_11$h, templateObject_12$g, templateObject_13$e, templateObject_14$e, templateObject_15$d, templateObject_16$b, templateObject_17$a;

var BaSeTag = function (_a) {
    var icon = _a.icon, label = _a.label, overrideColor = _a.overrideColor, limitedWidth = _a.limitedWidth, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.type, type = _c === void 0 ? 'primary' : _c, _d = _a.color, color = _d === void 0 ? 'default' : _d, _e = _a.themeMode, themeMode = _e === void 0 ? 'light' : _e, _f = _a.isSelected, isSelected = _f === void 0 ? false : _f, _g = _a.isDisabled, isDisabled = _g === void 0 ? false : _g, _h = _a.tooltip, tooltip = _h === void 0 ? {} : _h, clickCallback = _a.onClick, closeCallback = _a.onClose;
    if (themeMode && !['light', 'dark'].includes(themeMode)) {
        throw Error('Atributo "themeMode" deve ser do tipo: "light" ou "dark"');
    }
    if (type && !['primary', 'secondary'].includes(type)) {
        throw Error('Atributo "type" deve ser do tipo: "primary" ou "secondary"');
    }
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var iconProps = React.useMemo(function () { return ({
        name: 'check',
        description: getMessage('tag.selected'),
        size: 12,
    }); }, [getMessage]);
    var _j = React.useMemo(function () { return ({
        onClick: isDisabled ? undefined : clickCallback,
        onClose: isDisabled ? undefined : closeCallback,
    }); }, [clickCallback, closeCallback, isDisabled]), onClick = _j.onClick, onClose = _j.onClose;
    var containerProps = React.useMemo(function () {
        var props = {
            bigSize: 32,
            mediumSize: 24,
            smallSize: 16,
            className: 'BaSe--tag',
            icon: icon,
            size: size,
            type: type,
            isSelected: isSelected,
            isDisabled: isDisabled,
            themeMode: themeMode,
            tabIndex: -1,
            onClose: onClose,
        };
        if (onClick) {
            props.role = 'button';
            props.tabIndex = 0;
            props.onKeyUp = function (e) { return e.key === 'Enter' && onClick(e); };
            props.onClick = onClick;
        }
        return props;
    }, [icon, size, type, isSelected, isDisabled, themeMode, onClose, onClick]);
    var getColorsAtributes = React.useCallback(function (newColor) {
        if (newColor) {
            return mapTagValues(newColor)[type][themeMode];
        }
        return mapTagValues('default')[type][themeMode];
    }, [themeMode, type]);
    var baseColor = React.useMemo(function () {
        return themeMode === 'light'
            ? BaSeColors.defaultColors.white
            : BaSeColors.institucionais.cinzaSebrae20;
    }, [themeMode]);
    var getValues = React.useCallback(function () {
        if (isDisabled) {
            return {
                bgC: BaSeTheme.colors.institucionais.cinzaSebrae90,
                bcCHover: BaSeTheme.colors.institucionais.cinzaSebrae75,
                boxShadowFocus: BaSeTheme.colors.institucionais.cinzaSebrae75,
                border: isSelected
                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                    : BaSeTheme.colors.institucionais.cinzaSebrae90,
                newIconColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
            };
        }
        var colorValue = getColorsAtributes(color);
        if (isSelected && type === 'secondary') {
            return {
                bgC: colorValue.iconColor,
                bcCHover: colorValue.style.bcCHover,
                boxShadowFocus: colorValue.style.boxShadowFocus,
                border: colorValue.style.border,
                newIconColor: colorValue.style.bgC,
            };
        }
        if (isSelected && type === 'primary') {
            return {
                bgC: themeMode === 'dark' ? colorValue.iconColor : baseColor,
                bcCHover: colorValue.style.bcCHover,
                boxShadowFocus: colorValue.style.boxShadowFocus,
                border: colorValue.iconColor,
                newIconColor: themeMode === 'dark' ? colorValue.style.bgC : colorValue.iconColor,
            };
        }
        return {
            bgC: colorValue.style.bgC,
            bcCHover: colorValue.style.bcCHover,
            boxShadowFocus: colorValue.style.boxShadowFocus,
            border: colorValue.style.border,
            newIconColor: colorValue.iconColor,
        };
    }, [
        baseColor,
        color,
        getColorsAtributes,
        isDisabled,
        isSelected,
        themeMode,
        type,
    ]);
    var bcCHoverIcon = React.useMemo(function () { var _a; return getColorsAtributes((_a = overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor) !== null && _a !== void 0 ? _a : color); }, [color, getColorsAtributes, overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor]).style.bcCHover;
    var _k = React.useMemo(function () { return getValues(); }, [getValues]), bgC = _k.bgC, bcCHover = _k.bcCHover, boxShadowFocus = _k.boxShadowFocus, border = _k.border, newIconColor = _k.newIconColor;
    var _l = React.useState(false), isHover = _l[0], setIsHover = _l[1];
    var _m = React.useState(false), isHoverClose = _m[0], setIsHoverClose = _m[1];
    var _o = React.useState(false), isFocus = _o[0], setIsFocus = _o[1];
    var divRef = React.useRef(null);
    var _p = React.useState(false), isTooltipOpen = _p[0], setIsTooltipOpen = _p[1];
    var Text = size === 'small' ? BaSeSmall2 : BaSeSmall1;
    var buildTag = React.useCallback(function () {
        var _a, _b;
        return (React.createElement(TagContainerStyled, __assign({}, containerProps, { bgC: bgC, bcCHover: bcCHover, boxShadowFocus: boxShadowFocus, border: border, newIconColor: newIconColor, onMouseEnter: function () {
                if (onClick) {
                    setIsHover(true);
                }
                setIsTooltipOpen(true);
            }, onMouseLeave: function () {
                if (onClick) {
                    setIsHover(false);
                }
                setIsTooltipOpen(false);
            }, onFocus: function () { return onClick && setIsFocus(true); }, onBlur: function () { return onClick && setIsFocus(false); }, ref: divRef, "aria-checked": isSelected, tabIndex: isDisabled ? -1 : containerProps.tabIndex }),
            icon && (React.createElement(TagIcon, { className: "BaSe--tag-icon icon", type: type, newIconColor: (isHover || isFocus) && !isSelected
                    ? bcCHoverIcon
                    : (_a = overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor) !== null && _a !== void 0 ? _a : newIconColor, size: size },
                React.createElement(BaSeIcon, { size: size === 'big' ? 28 : size === 'medium' ? 14 : 12, name: icon, description: getMessage('icon.label', label), color: type === 'primary'
                        ? isSelected
                            ? bgC
                            : BaSeColors.defaultColors.white
                        : (isHover || isFocus) && !isSelected
                            ? bcCHoverIcon
                            : (_b = overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor) !== null && _b !== void 0 ? _b : newIconColor }))),
            label && (React.createElement(TagText, { className: "BaSe--tag-text text", newIconColor: newIconColor, size: size, icon: icon, limitedWidth: limitedWidth, onClose: onClose },
                React.createElement(Text, { isBold: true, color: isSelected || !(isHover || isFocus) ? newIconColor : bcCHover }, label))),
            onClose && (React.createElement(TagClose, { className: "BaSe--tag-close close", onClose: onClose, bcCHover: newIconColor, size: size, type: type, themeMode: themeMode, onMouseEnter: function () {
                    setIsHoverClose(true);
                }, onMouseLeave: function () {
                    setIsHoverClose(false);
                } },
                React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), buttonType: "button", shape: "circle", size: size, sizeIcon: size, type: "tertiary", color: themeMode === 'dark' && isHoverClose ? bgC : newIconColor, onClick: function (e) {
                        if (onClick) {
                            e.stopPropagation();
                        }
                        onClose(e);
                    } }))),
            objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, __assign({ buddyRef: divRef, open: isTooltipOpen, direction: "top" }, tooltip)))));
    }, [
        containerProps,
        bgC,
        bcCHover,
        boxShadowFocus,
        border,
        newIconColor,
        isHover,
        isFocus,
        bcCHoverIcon,
        Text,
        isHoverClose,
        isTooltipOpen,
        isSelected,
        isDisabled,
        icon,
        type,
        overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor,
        size,
        label,
        limitedWidth,
        themeMode,
        tooltip,
        getMessage,
        onClose,
        onClick,
    ]);
    return isSelected ? (React.createElement(BaSeBadge, { height: 20, width: 20, color: isDisabled ? BaSeColors.institucionais.cinzaSebrae60 : color, type: type, position: { right: 12, bottom: 10 }, value: iconProps }, buildTag())) : (buildTag());
};
BaSeTag.displayName = 'BaSeTag';

var colorMapper = {
    default: BaSeTheme.colors.institucionais.azulSebrae36,
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    attention: BaSeTheme.colors.feedbackInterface.atencao55,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};
function calculed(_a) {
    var size = _a.size, correction = _a.correction;
    return size ? "calc(".concat(size, " - ").concat(correction, "px)") : 'auto';
}
function gridTemplateAreaStacked(_a) {
    var _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.hideContentInfo, hideContentInfo = _c === void 0 ? false : _c, _d = _a.hideContentCategory, hideContentCategory = _d === void 0 ? false : _d, _e = _a.hideContentTag, hideContentTag = _e === void 0 ? false : _e, _f = _a.hideContentAction, hideContentAction = _f === void 0 ? false : _f;
    var he = hideHeader ? '' : ' "he" '.repeat(3);
    var cc = hideContentCategory ? '' : ' "cc" ';
    var ct = hideContentTag ? '' : ' "ct" ';
    var ci = hideContentInfo ? '' : ' "ci" '.repeat(4);
    var ca = hideContentAction ? '' : ' "ca" ';
    var lines = [he, cc, ct, ci, ca];
    return lines.join('');
}
function gridTemplateAreaSideBySide(_a) {
    var _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.hideContentInfo, hideContentInfo = _c === void 0 ? false : _c, _d = _a.hideContentCategory, hideContentCategory = _d === void 0 ? false : _d, _e = _a.hideContentTag, hideContentTag = _e === void 0 ? false : _e, _f = _a.hideContentAction, hideContentAction = _f === void 0 ? false : _f;
    var clearEmptyLine = function (line) {
        return line.replace(/^('\s+'|'\s+he\s+')$/g, '');
    };
    var he = hideHeader ? '' : ' he ';
    var ci = hideContentInfo ? '' : ' ci '.repeat(2);
    var cc = hideContentCategory ? '' : ' cc '.repeat(2);
    var ct = hideContentTag ? '' : ' ct '.repeat(2);
    var ca = hideContentAction ? '' : ' ca '.repeat(2);
    var he_cc = "'".concat(he, " ").concat(cc, "'");
    var he_ct = "'".concat(he, " ").concat(ct, "'");
    var he_ci = "'".concat(he, " ").concat(ci, "'");
    var he_ca = "'".concat(he, " ").concat(ca, "'");
    var lines = __spreadArray(__spreadArray([he_cc, he_ct], Array(3).fill(he_ci), true), [he_ca], false);
    return lines.map(clearEmptyLine).join('');
}
function gridTemplateAreaWide(_a) {
    var _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.hideContentInfo, hideContentInfo = _c === void 0 ? false : _c, _d = _a.hideContentCategory, hideContentCategory = _d === void 0 ? false : _d, _e = _a.hideContentTag, hideContentTag = _e === void 0 ? false : _e;
    var clearEmptyLine = function (line) { return line.replace(/.*×.*/g, ''); };
    var he = hideHeader ? '' : ' he '.repeat(2);
    var ci = hideContentInfo ? '×' : ' ci '.repeat(4);
    var ct = hideContentTag ? '×' : ' ct '.repeat(4);
    var lines;
    if (hideContentCategory) {
        var he_ci_ca = "'".concat(he, " ").concat(ci, " ca'");
        var he_ct_ct = "'".concat(he, " ").concat(ct, " ct'");
        lines = __spreadArray(__spreadArray([], Array(4).fill(he_ci_ca), true), [he_ct_ct], false);
    }
    else {
        var cc = ' cc '.repeat(3);
        var he_cc_ca = "'".concat(he, " ").concat(cc, " ca'");
        var he_ci = "'".concat(he, " ").concat(ci, "'");
        var he_ct = "'".concat(he, " ").concat(ct, "'");
        lines = __spreadArray(__spreadArray([he_cc_ca], Array(3).fill(he_ci), true), [he_ct], false);
    }
    return lines.map(clearEmptyLine).join('');
}

var gridAreaMapper = function (_a) {
    var _b = _a.disposition, disposition = _b === void 0 ? 'stacked' : _b, 
    // eslint-disable-next-line comma-dangle
    sliceCheck = __rest(_a, ["disposition"]);
    return ({
        stacked: css(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n      grid-template-areas: ", ";\n    "], ["\n      grid-template-areas: ", ";\n    "])), gridTemplateAreaStacked(sliceCheck)),
        'side-by-side': css(templateObject_2$M || (templateObject_2$M = __makeTemplateObject(["\n      grid-template-areas: ", ";\n    "], ["\n      grid-template-areas: ", ";\n    "])), gridTemplateAreaSideBySide(sliceCheck)),
        wide: css(templateObject_3$G || (templateObject_3$G = __makeTemplateObject(["\n      grid-template-areas: ", ";\n    "], ["\n      grid-template-areas: ", ";\n    "])), gridTemplateAreaWide(sliceCheck)),
    })[disposition];
};
var cardSlice = function (area) { return css(templateObject_4$z || (templateObject_4$z = __makeTemplateObject(["\n  grid-area: ", ";\n  place-self: stretch;\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: transparent;\n"], ["\n  grid-area: ", ";\n  place-self: stretch;\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: transparent;\n"])), area); };
var CardHeader = styled.header.attrs({
    className: 'BaSe--card-header',
})(templateObject_8$m || (templateObject_8$m = __makeTemplateObject(["\n  &.BaSe--card-header {\n    ", "\n\n    ", "\n\n    ", "\n\n    padding: 12px;\n  }\n"], ["\n  &.BaSe--card-header {\n    ", "\n\n    ", "\n\n    ", "\n\n    padding: 12px;\n  }\n"])), cardSlice('he'), function (_a) {
    var disposition = _a.disposition, withSideDestak = _a.withSideDestak;
    return disposition === 'stacked'
        ? css(templateObject_5$t || (templateObject_5$t = __makeTemplateObject(["\n            border-top-left-radius: ", ";\n            border-top-right-radius: 12px;\n          "], ["\n            border-top-left-radius: ", ";\n            border-top-right-radius: 12px;\n          "])), withSideDestak ? '6px' : '12px') : css(templateObject_6$s || (templateObject_6$s = __makeTemplateObject(["\n            border-top-left-radius: ", ";\n            border-bottom-left-radius: ", ";\n          "], ["\n            border-top-left-radius: ", ";\n            border-bottom-left-radius: ", ";\n          "])), withSideDestak ? '6px' : '12px', withSideDestak ? '6px' : '12px');
}, function (_a) {
    var onlyHeader = _a.onlyHeader, withSideDestak = _a.withSideDestak;
    return onlyHeader && css(templateObject_7$n || (templateObject_7$n = __makeTemplateObject(["\n        border-bottom-left-radius: ", ";\n        border-bottom-right-radius: 12px;\n      "], ["\n        border-bottom-left-radius: ", ";\n        border-bottom-right-radius: 12px;\n      "])), withSideDestak ? '6px' : '12px');
});
var CardContentInfo = styled.div.attrs({
    className: 'BaSe--card-content-info',
})(templateObject_9$k || (templateObject_9$k = __makeTemplateObject(["\n  ", "\n\n  padding: 24px;\n"], ["\n  ", "\n\n  padding: 24px;\n"])), cardSlice('ci'));
var CardContentCategoryItem = styled.div(templateObject_10$i || (templateObject_10$i = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  grid-template-columns: repeat(2, auto);\n  gap: 8px;\n"], ["\n  display: grid;\n  place-items: center;\n  grid-template-columns: repeat(2, auto);\n  gap: 8px;\n"])));
var CardContentCategory = styled.div.attrs({
    className: 'BaSe--card-content-category',
})(templateObject_13$d || (templateObject_13$d = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  padding: 12px;\n  gap: 12px;\n"], ["\n  ", "\n\n  ", "\n\n  padding: 12px;\n  gap: 12px;\n"])), cardSlice('cc'), function (_a) {
    var disposition = _a.disposition, hideHeader = _a.hideHeader;
    return disposition === 'stacked' && hideHeader
        ? css(templateObject_11$g || (templateObject_11$g = __makeTemplateObject(["\n          border-top-left-radius: 12px;\n          border-top-right-radius: 12px;\n        "], ["\n          border-top-left-radius: 12px;\n          border-top-right-radius: 12px;\n        "]))) : disposition === 'side-by-side' && css(templateObject_12$f || (templateObject_12$f = __makeTemplateObject(["\n          border-top-right-radius: 12px;\n        "], ["\n          border-top-right-radius: 12px;\n        "])));
});
var ContentTag = styled.li(templateObject_14$d || (templateObject_14$d = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var CardTagContainer = styled.div.attrs({
    className: 'BaSe--card-content-tag',
})(templateObject_16$a || (templateObject_16$a = __makeTemplateObject(["\n  ", "\n  display: block;\n  width: 100%;\n\n  ", "\n"], ["\n  ", "\n  display: block;\n  width: 100%;\n\n  ", "\n"])), cardSlice('ct'), function (_a) {
    var disposition = _a.disposition;
    return disposition === 'wide' && css(templateObject_15$c || (templateObject_15$c = __makeTemplateObject(["\n      border-bottom-left-radius: 0.75em;\n      border-bottom-right-radius: 0.75em;\n    "], ["\n      border-bottom-left-radius: 0.75em;\n      border-bottom-right-radius: 0.75em;\n    "])));
});
var CardTagWrapper = styled.ul(templateObject_20$6 || (templateObject_20$6 = __makeTemplateObject(["\n  position: relative;\n  padding: 1.5em 3.75em 1.5em 1.5em;\n  max-height: 100%;\n  flex-wrap: wrap;\n  gap: 1.5em;\n  display: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  padding: 1.5em 3.75em 1.5em 1.5em;\n  max-height: 100%;\n  flex-wrap: wrap;\n  gap: 1.5em;\n  display: ", ";\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var isCollapsed = _a.isCollapsed, contentTagExpandable = _a.contentTagExpandable;
    return isCollapsed || contentTagExpandable ? 'flex' : 'grid';
}, function (_a) {
    var contentTagGrouped = _a.contentTagGrouped, isCollapsed = _a.isCollapsed;
    return contentTagGrouped &&
        (isCollapsed
            ? css(templateObject_17$9 || (templateObject_17$9 = __makeTemplateObject(["\n          ", ":not(:nth-last-of-type(2))::after {\n            margin-left: 0.5em;\n            content: '|';\n            color: ", ";\n          }\n        "], ["\n          ", ":not(:nth-last-of-type(2))::after {\n            margin-left: 0.5em;\n            content: '|';\n            color: ", ";\n          }\n        "])), ContentTag, BaSeTheme.colors.institucionais.cinzaSebrae75) : css(templateObject_18$6 || (templateObject_18$6 = __makeTemplateObject(["\n          ", " {\n            flex: 1 100%;\n          }\n        "], ["\n          ", " {\n            flex: 1 100%;\n          }\n        "])), ContentTag));
}, function (_a) {
    var contentTagExpandable = _a.contentTagExpandable, contentTagHeight = _a.contentTagHeight, isCollapsed = _a.isCollapsed;
    return isCollapsed &&
        contentTagHeight &&
        contentTagExpandable && css(templateObject_19$6 || (templateObject_19$6 = __makeTemplateObject(["\n      max-height: calc(", " - 0.5em);\n      overflow-y: hidden;\n    "], ["\n      max-height: calc(", " - 0.5em);\n      overflow-y: hidden;\n    "])), contentTagHeight);
});
var TagButtonWrapper = styled.li(templateObject_21$5 || (templateObject_21$5 = __makeTemplateObject(["\n  position: absolute;\n  top: 18px;\n  right: 24px;\n"], ["\n  position: absolute;\n  top: 18px;\n  right: 24px;\n"])));
var ContentTagSeparator = styled.hr(templateObject_22$4 || (templateObject_22$4 = __makeTemplateObject(["\n  margin: 0;\n  border: none;\n  width: 100%;\n  height: 0.5px;\n  margin-top: 8px;\n  background: ", ";\n"], ["\n  margin: 0;\n  border: none;\n  width: 100%;\n  height: 0.5px;\n  margin-top: 8px;\n  background: ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90);
var CardContentAction = styled.footer.attrs({
    className: 'BaSe--card-content-action',
})(templateObject_23$4 || (templateObject_23$4 = __makeTemplateObject(["\n  &.BaSe--card-content-action {\n    ", "\n\n    padding: 12px;\n    gap: 12px;\n  }\n"], ["\n  &.BaSe--card-content-action {\n    ", "\n\n    padding: 12px;\n    gap: 12px;\n  }\n"])), cardSlice('ca'));
var CardWrapper = styled.section.attrs({
    className: 'BaSe--card',
})(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  &.BaSe--card {\n    will-change: box-shadow, transform, border-left-width;\n    display: grid;\n    box-sizing: content-box;\n    border-radius: 12px;\n    position: relative;\n\n    transition: ", ";\n\n    ", "\n\n    ", "\n\n  ", "\n\n  ", ";\n  }\n"], ["\n  &.BaSe--card {\n    will-change: box-shadow, transform, border-left-width;\n    display: grid;\n    box-sizing: content-box;\n    border-radius: 12px;\n    position: relative;\n\n    transition: ", ";\n\n    ", "\n\n    ", "\n\n  ", "\n\n  ", ";\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, gridAreaMapper, function (_a) {
    var withSideDestak = _a.withSideDestak, height = _a.height, width = _a.width;
    return css(templateObject_24$4 || (templateObject_24$4 = __makeTemplateObject(["\n      height: ", ";\n      width: ", ";\n    "], ["\n      height: ", ";\n      width: ", ";\n    "])), calculed({ size: height, correction: 2 }), calculed({ size: width, correction: withSideDestak ? 5 : 2 }));
}, function (_a) {
    var withSideDestak = _a.withSideDestak, destakColor = _a.destakColor, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, disposition = _a.disposition, backgroundImage = _a.backgroundImage, hideHeader = _a.hideHeader, hideContentAction = _a.hideContentAction, hideContentTag = _a.hideContentTag, hideContentCategory = _a.hideContentCategory;
    return css(templateObject_33$1 || (templateObject_33$1 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      ", "\n\n      ", "\n\n    ", "\n\n    ", "\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      ", "\n\n      ", "\n\n    ", "\n\n    ", "\n    "])), backgroundColor, borderColor, hideHeader &&
        backgroundImage && css(templateObject_25$4 || (templateObject_25$4 = __makeTemplateObject(["\n        background-image: url('", "');\n        background-repeat: no-repeat;\n        background-size: cover;\n      "], ["\n        background-image: url('", "');\n        background-repeat: no-repeat;\n        background-size: cover;\n      "])), backgroundImage), withSideDestak && css(templateObject_26$4 || (templateObject_26$4 = __makeTemplateObject(["\n        border-left: 4px solid ", ";\n      "], ["\n        border-left: 4px solid ", ";\n      "])), destakColor), !hideHeader && css(templateObject_27$4 || (templateObject_27$4 = __makeTemplateObject(["\n        & > ", " {\n          background-color: ", ";\n          background-image: url('", "');\n          background-repeat: no-repeat;\n          background-size: cover;\n        }\n      "], ["\n        & > ", " {\n          background-color: ", ";\n          background-image: url('", "');\n          background-repeat: no-repeat;\n          background-size: cover;\n        }\n      "])), CardHeader, destakColor, backgroundImage), disposition === 'wide'
        ? css(templateObject_30$4 || (templateObject_30$4 = __makeTemplateObject(["\n            ", "\n\n            ", "\n          "], ["\n            ", "\n\n            ", "\n          "])), !hideContentAction && css(templateObject_28$4 || (templateObject_28$4 = __makeTemplateObject(["\n              & > ", " {\n                align-self: flex-start;\n                justify-self: flex-end;\n              }\n            "], ["\n              & > ", " {\n                align-self: flex-start;\n                justify-self: flex-end;\n              }\n            "])), CardContentAction), !hideContentTag && css(templateObject_29$4 || (templateObject_29$4 = __makeTemplateObject(["\n              & > ", " {\n                box-shadow:\n                  8px 0 0 0 ", " inset,\n                  -8px 0 0 0 ", " inset,\n                  0 2px 0 0 ", " inset;\n              }\n            "], ["\n              & > ", " {\n                box-shadow:\n                  8px 0 0 0 ", " inset,\n                  -8px 0 0 0 ", " inset,\n                  0 2px 0 0 ", " inset;\n              }\n            "])), CardTagContainer, backgroundColor, backgroundColor, borderColor)) : css(templateObject_32$2 || (templateObject_32$2 = __makeTemplateObject(["\n            ", "\n          "], ["\n            ", "\n          "])), !hideContentCategory && css(templateObject_31$3 || (templateObject_31$3 = __makeTemplateObject(["\n              & > ", " {\n                background-color: ", ";\n              }\n            "], ["\n              & > ", " {\n                background-color: ", ";\n              }\n            "])), CardContentCategory, transformLightness(backgroundColor, 0.96))));
}, function (_a) {
    var shadowLevel = _a.shadowLevel, elevationOnHoverOrFocus = _a.elevationOnHoverOrFocus, isElevated = _a.isElevated;
    return shadowLevel && css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n        box-shadow: ", ";\n\n        ", "\n\n        ", "\n      "], ["\n        box-shadow: ", ";\n\n        ", "\n\n        ", "\n      "])), getShadow(shadowLevel), isElevated && elevatedCss, elevationOnHoverOrFocus && css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n          &:hover,\n          &:focus-within {\n            ", "\n          }\n        "], ["\n          &:hover,\n          &:focus-within {\n            ", "\n          }\n        "])), elevatedCss));
});
var templateObject_1$S, templateObject_2$M, templateObject_3$G, templateObject_4$z, templateObject_5$t, templateObject_6$s, templateObject_7$n, templateObject_8$m, templateObject_9$k, templateObject_10$i, templateObject_11$g, templateObject_12$f, templateObject_13$d, templateObject_14$d, templateObject_15$c, templateObject_16$a, templateObject_17$9, templateObject_18$6, templateObject_19$6, templateObject_20$6, templateObject_21$5, templateObject_22$4, templateObject_23$4, templateObject_24$4, templateObject_25$4, templateObject_26$4, templateObject_27$4, templateObject_28$4, templateObject_29$4, templateObject_30$4, templateObject_31$3, templateObject_32$2, templateObject_33$1, templateObject_34, templateObject_35, templateObject_36;

var BaSeCardContentTag = function (_a) {
    var destakColor = _a.destakColor, foregroundColor = _a.foregroundColor, disposition = _a.disposition, renderContentTag = _a.renderContentTag;
    var ct = renderContentTag === null || renderContentTag === void 0 ? void 0 : renderContentTag();
    var containerTagRef = React.useRef(null);
    var _b = React.useState(), contentTagHeight = _b[0], setContentTagHeight = _b[1];
    var _c = React.useState(false), contentTagExpandable = _c[0], setContentTagExpandable = _c[1];
    var _d = React.useState(true), isCollapsed = _d[0], setIsCollapsed = _d[1];
    var _e = React.useState(false), contentTagGrouped = _e[0], setContentTagGrouped = _e[1];
    var _f = React.useState(false), showExpandableButton = _f[0], setShowExpandableButton = _f[1];
    var renderTag = React.useCallback(function (tag) { return React.createElement(BaSeTag, __assign({ color: foregroundColor }, tag)); }, [foregroundColor]);
    var renderOthers = React.useCallback(function (others, collapsedItem) {
        if (!others.length) {
            return React.createElement(React.Fragment, { key: "+".concat(others.length) });
        }
        return isCollapsed
            ? renderTag(__assign(__assign({ key: "+".concat(others.length) }, collapsedItem), { label: "+".concat(others.length), onClick: undefined, onClose: undefined, tooltip: undefined }))
            : others.map(function (tag, index) { return renderTag(__assign({ key: index }, tag)); });
    }, [renderTag, isCollapsed]);
    var renderCollpasibleTag = React.useCallback(function (group) {
        var _a, _b, _c, _d, _e;
        return Array.isArray(group.alwaysVisible)
            ? group.alwaysVisible
                .map(function (tag, index) { return renderTag(__assign({ key: index }, tag)); })
                .concat(renderOthers(group.collapsibleItems, group.collapsedItem))
            : Array.of(renderTag(__assign({ key: (_e = (_c = (_a = group === null || group === void 0 ? void 0 : group.key) !== null && _a !== void 0 ? _a : (_b = group.alwaysVisible) === null || _b === void 0 ? void 0 : _b.key) !== null && _c !== void 0 ? _c : (_d = group.alwaysVisible) === null || _d === void 0 ? void 0 : _d.label) !== null && _e !== void 0 ? _e : '😭' }, group.alwaysVisible))).concat(renderOthers(group.collapsibleItems, group.collapsedItem));
    }, [renderTag, renderOthers]);
    var renderContent = React.useCallback(function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (value) {
            var tagProps = value;
            var collapsedTag = value;
            var expandableTag = value;
            if (Array.isArray(value)) {
                return value.map(function (item, index) {
                    var _a;
                    return (React.createElement(ContentTag, { key: (_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : index }, item && 'alwaysVisible' in item ? (React.createElement(React.Fragment, null,
                        renderCollpasibleTag(item),
                        !isCollapsed && value.length - 1 !== index && (React.createElement(ContentTagSeparator, null)))) : (renderTag(__assign({ key: index }, item)))));
                });
            }
            if (tagProps === null || tagProps === void 0 ? void 0 : tagProps.label) {
                return (React.createElement(ContentTag, { key: (_a = tagProps === null || tagProps === void 0 ? void 0 : tagProps.key) !== null && _a !== void 0 ? _a : tagProps === null || tagProps === void 0 ? void 0 : tagProps.label }, renderTag(__assign({ key: (_b = tagProps.key) !== null && _b !== void 0 ? _b : tagProps.label }, tagProps))));
            }
            if (collapsedTag === null || collapsedTag === void 0 ? void 0 : collapsedTag.alwaysVisible) {
                return (React.createElement(ContentTag, { key: (_j = (_g = (_e = (_c = collapsedTag === null || collapsedTag === void 0 ? void 0 : collapsedTag.key) !== null && _c !== void 0 ? _c : (_d = collapsedTag.alwaysVisible) === null || _d === void 0 ? void 0 : _d.key) !== null && _e !== void 0 ? _e : (_f = collapsedTag.alwaysVisible) === null || _f === void 0 ? void 0 : _f.label) !== null && _g !== void 0 ? _g : (_h = collapsedTag.alwaysVisible) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : '🤔' }, renderCollpasibleTag(collapsedTag)));
            }
            if (expandableTag === null || expandableTag === void 0 ? void 0 : expandableTag.items) {
                return expandableTag.items.map(function (tag, index) {
                    var _a;
                    return (React.createElement(ContentTag, { key: (_a = tag === null || tag === void 0 ? void 0 : tag.key) !== null && _a !== void 0 ? _a : index }, renderTag(__assign({ key: index }, tag))));
                });
            }
        }
        return value;
    }, [isCollapsed, renderCollpasibleTag, renderTag]);
    React.useEffect(function () {
        var _a;
        var tagContainer = containerTagRef.current;
        var isGroupedTag = (ct && 'alwaysVisible' in ct) ||
            (Array.isArray(ct) && 'alwaysVisible' in ct[0]);
        setShowExpandableButton(isGroupedTag);
        setContentTagGrouped(isGroupedTag);
        var isExpandableTag = ((_a = ct === null || ct === void 0 ? void 0 : ct.items) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (isExpandableTag) {
            var calculateToShowButton_1 = function () {
                var _a;
                setContentTagExpandable(isExpandableTag);
                var firstLine = [];
                var list = Array.from((_a = tagContainer === null || tagContainer === void 0 ? void 0 : tagContainer.children) !== null && _a !== void 0 ? _a : []);
                for (var _i = 0, _b = list; _i < _b.length; _i++) {
                    var current = _b[_i];
                    var index = list.indexOf(current);
                    var currentRect = current.getBoundingClientRect();
                    if (index === 0) {
                        firstLine.push(current);
                        continue;
                    }
                    var prev = list[index - 1];
                    var prevRect = prev.getBoundingClientRect();
                    if (Math.abs(prevRect.y - currentRect.y) > 8) {
                        break;
                    }
                    firstLine.push(current);
                }
                var greaterHeight = firstLine.reduce(function (height, current) {
                    var currentRect = current.getBoundingClientRect();
                    return Math.max(height, currentRect.height);
                }, 0);
                setContentTagHeight("".concat(greaterHeight, "px"));
                setShowExpandableButton(list.length > firstLine.length);
            };
            if (tagContainer) {
                var calculate = function () { return calculateToShowButton_1(); };
                var resizeObserver_1 = new ResizeObserver(calculate);
                resizeObserver_1.observe(tagContainer);
                var timeout_1 = setTimeout(calculate, 1000);
                return function () {
                    resizeObserver_1.unobserve(tagContainer);
                    clearTimeout(timeout_1);
                };
            }
        }
        return;
    }, [containerTagRef.current]);
    return (React.createElement(CardTagContainer, { disposition: disposition },
        React.createElement(CardTagWrapper, { isCollapsed: isCollapsed, contentTagGrouped: contentTagGrouped, contentTagExpandable: contentTagExpandable, contentTagHeight: contentTagHeight, ref: containerTagRef, as: React.isValidElement(ct) ? 'div' : 'ul' },
            renderContent(ct),
            showExpandableButton && (React.createElement(TagButtonWrapper, null,
                React.createElement(BaSeShapeButton, { color: destakColor, type: "tertiary", size: "small", sizeIcon: "medium", nameIcon: isCollapsed ? 'angle-down' : 'angle-up', onClick: function () { return setIsCollapsed(function (actual) { return !actual; }); } }))))));
};
BaSeCardContentTag.displayName = 'BaSeCardContentTag';

var colors$3 = BaSeTheme.colors;
var BaSeCard = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 'auto' : _b, _c = _a.width, width = _c === void 0 ? 'auto' : _c, _d = _a.disposition, disposition = _d === void 0 ? 'stacked' : _d, _e = _a.shadowLevel, shadowLevel = _e === void 0 ? 2 : _e, _f = _a.elevationOnHoverOrFocus, elevationOnHoverOrFocus = _f === void 0 ? true : _f, _g = _a.isElevated, isElevated = _g === void 0 ? false : _g, _h = _a.withSideDestak, withSideDestak = _h === void 0 ? true : _h, _j = _a.destakColor, externalDestakColor = _j === void 0 ? 'default' : _j, _k = _a.backgroundColor, backgroundColor = _k === void 0 ? colors$3.defaultColors.white : _k, _l = _a.foregroundColor, foregroundColor = _l === void 0 ? colors$3.institucionais.cinzaSebrae45 : _l, _m = _a.headerColor, headerColor = _m === void 0 ? colors$3.defaultColors.white : _m, _o = _a.borderColor, borderColor = _o === void 0 ? colors$3.institucionais.cinzaSebrae90 : _o, backgroundImage = _a.backgroundImage, renderHeader = _a.renderHeader, renderContentInfo = _a.renderContentInfo, renderContentCategory = _a.renderContentCategory, renderContentTag = _a.renderContentTag, renderContentAction = _a.renderContentAction;
    var hideHeader = React.useMemo(function () { return typeof renderHeader !== 'function'; }, [renderHeader]);
    var hideContentInfo = React.useMemo(function () { return typeof renderContentInfo !== 'function'; }, [renderContentInfo]);
    var hideContentCategory = React.useMemo(function () { return typeof renderContentCategory !== 'function'; }, [renderContentCategory]);
    var hideContentTag = React.useMemo(function () { return typeof renderContentTag !== 'function'; }, [renderContentTag]);
    var hideContentAction = React.useMemo(function () { return typeof renderContentAction !== 'function'; }, [renderContentAction]);
    var onlyHeader = React.useMemo(function () {
        return !!(hideContentAction &&
            hideContentCategory &&
            hideContentInfo &&
            hideContentTag);
    }, []);
    var destakColor = React.useMemo(function () {
        var _a;
        return (_a = colorMapper[externalDestakColor]) !== null && _a !== void 0 ? _a : externalDestakColor;
    }, [externalDestakColor]);
    if (!validateShadowLevel(shadowLevel)) {
        throw Error("[BaSeCard] \"shadowLevel\" ".concat(shadowLevel, " n\u00E3o existe"));
    }
    if (elevationOnHoverOrFocus && shadowLevel === maxShadowLevel) {
        throw Error("[BaSeCard] \"shadowLevel\" ".concat(shadowLevel, " n\u00E3o pode ter\n      eleva\u00E7\u00E3o com \"elevationOnHoverOrFocus\".\n      J\u00E1 est\u00E1 no \u00FAltimo nivel"));
    }
    if (disposition === 'side-by-side') {
        if (hideHeader) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"side-by-side\",\n        n\u00E3o pode ocutar o header.\n        Use o \"disposition\" igual a \"stacked\" sem o header");
        }
        else if (hideContentInfo &&
            hideContentCategory &&
            hideContentTag &&
            hideContentAction) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"side-by-side\",\n        n\u00E3o pode ocutar os outros sem se o header.\n        Use o \"disposition\" igual a \"stacked\" s\u00F3 com o header");
        }
    }
    if (disposition === 'wide') {
        if (hideHeader && hideContentAction) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"wide\",\n        n\u00E3o pode ocutar o header e o content action.\n        Use o \"disposition\" igual a \"stacked\" sem o header e sem o content action");
        }
        if (hideContentInfo && hideContentCategory && hideContentTag) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"wide\",\n        n\u00E3o pode ocutar o content info, content category e content tag.\n        Use o \"disposition\" igual a \"stacked\" s\u00F3 com o header e o content action");
        }
        if (hideContentAction) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"wide\",\n        n\u00E3o pode ocutar o content action.\n        Use o \"disposition\" igual a \"stacked\" ou \"side-by-side\" sem o content action");
        }
    }
    var header = React.useCallback(function () {
        if (hideHeader) {
            return;
        }
        var he = renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader();
        if (typeof he === 'string') {
            return (React.createElement(CardHeader, { disposition: disposition, withSideDestak: withSideDestak, onlyHeader: onlyHeader },
                React.createElement(BaSeHeading4, { color: headerColor }, he)));
        }
        return (React.createElement(CardHeader, { disposition: disposition, withSideDestak: withSideDestak, onlyHeader: onlyHeader }, he));
    }, [hideHeader, renderHeader, headerColor]);
    var contentInfo = React.useCallback(function () {
        if (hideContentInfo) {
            return;
        }
        var ci = renderContentInfo === null || renderContentInfo === void 0 ? void 0 : renderContentInfo();
        if (typeof ci === 'string') {
            return (React.createElement(CardContentInfo, null,
                React.createElement(BaSeHeading5, { color: foregroundColor }, ci)));
        }
        return React.createElement(CardContentInfo, null, ci);
    }, [hideContentInfo, renderContentInfo, foregroundColor]);
    var contentCategory = React.useCallback(function () {
        if (hideContentCategory) {
            return;
        }
        var cc = renderContentCategory === null || renderContentCategory === void 0 ? void 0 : renderContentCategory();
        if (React.isValidElement(cc)) {
            return (React.createElement(CardContentCategory, { disposition: disposition, hideHeader: hideHeader }, cc));
        }
        return (React.createElement(CardContentCategory, { disposition: disposition, hideHeader: hideHeader }, cc === null || cc === void 0 ? void 0 : cc.map(function (category) { return (React.createElement(BaSeI18nConsumer, { key: "".concat(category.label, "-").concat(category.icon) }, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(CardContentCategoryItem, null,
                category.icon && (React.createElement(BaSeIcon, { description: getMessage('icon.label', category.label), name: category.icon, color: destakColor, size: 13 })),
                React.createElement(BaSeSmall1, { color: foregroundColor }, category.label)));
        })); })));
    }, [
        hideContentCategory,
        renderContentCategory,
        foregroundColor,
        destakColor,
    ]);
    var contentAction = React.useCallback(function () {
        var _a, _b;
        if (hideContentAction) {
            return;
        }
        var ct = renderContentAction === null || renderContentAction === void 0 ? void 0 : renderContentAction();
        if (React.isValidElement(ct)) {
            return React.createElement(CardContentAction, null, ct);
        }
        return (React.createElement(CardContentAction, null, (_a = ct === null || ct === void 0 ? void 0 : ct.shapeButtons) === null || _a === void 0 ? void 0 :
            _a.map(function (shapeButton) { return (React.createElement(BaSeShapeButton, __assign({ key: "".concat(shapeButton.nameIcon, "-").concat(shapeButton.value), color: foregroundColor, type: "secondary" }, shapeButton))); }), (_b = ct === null || ct === void 0 ? void 0 : ct.buttons) === null || _b === void 0 ? void 0 :
            _b.map(function (button) { return (React.createElement(BaSeButton, __assign({ key: "".concat(button.leftIcon, "-").concat(button.value, "-").concat(button.rightIcon), color: foregroundColor, type: "secondary" }, button))); })));
    }, [hideContentAction, renderContentAction, foregroundColor]);
    return (React.createElement(CardWrapper, { height: height, width: width, disposition: disposition, shadowLevel: shadowLevel, withSideDestak: withSideDestak, elevationOnHoverOrFocus: elevationOnHoverOrFocus, isElevated: isElevated, backgroundColor: backgroundColor, borderColor: borderColor, backgroundImage: backgroundImage !== null && backgroundImage !== void 0 ? backgroundImage : (hideHeader
            ? ''
            : "".concat(BaSeConfig.staticAssetsUrl, "/images/others/card/background.png")), destakColor: destakColor, hideHeader: hideHeader, hideContentInfo: hideContentInfo, hideContentCategory: hideContentCategory, hideContentTag: hideContentTag, hideContentAction: hideContentAction },
        header(),
        contentInfo(),
        !hideContentTag && (React.createElement(BaSeCardContentTag, { disposition: disposition, destakColor: destakColor, foregroundColor: foregroundColor, renderContentTag: renderContentTag })),
        contentCategory(),
        contentAction()));
};
BaSeCard.displayName = 'BaSeCard';

var ContainerStyled = styled.div.attrs({
    className: 'BaSe--container',
})(templateObject_3$F || (templateObject_3$F = __makeTemplateObject(["\n  &.BaSe--container {\n    width: 100%;\n    margin: 0 auto;\n\n    max-width: ", ";\n\n    ", "\n\n    ", "\n  }\n"], ["\n  &.BaSe--container {\n    width: 100%;\n    margin: 0 auto;\n\n    max-width: ", ";\n\n    ", "\n\n    ", "\n  }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return numberWithUnit(maxWidth, 'px', '100%');
}, function (_a) {
    var fullViewport = _a.fullViewport;
    return fullViewport && css(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n        height: 100vh;\n        width: 100vw;\n      "], ["\n        height: 100vh;\n        width: 100vw;\n      "])));
}, function (_a) {
    var autoScroll = _a.autoScroll;
    return autoScroll && css(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n        overflow: auto;\n      "], ["\n        overflow: auto;\n      "])));
});
var templateObject_1$R, templateObject_2$L, templateObject_3$F;

var BaSeContainer = function (_a) {
    var delimitedOnBreakpoint = _a.delimitedOnBreakpoint, _b = _a.fullViewport, fullViewport = _b === void 0 ? false : _b, _c = _a.withAutoScroll, withAutoScroll = _c === void 0 ? false : _c, children = _a.children, 
    // eslint-disable-next-line comma-dangle
    divProps = __rest(_a, ["delimitedOnBreakpoint", "fullViewport", "withAutoScroll", "children"]);
    var maxWidth = React.useMemo(function () {
        if (delimitedOnBreakpoint &&
            delimitedOnBreakpoint in BaSeTheme.breakpoints) {
            return BaSeTheme.breakpoints[delimitedOnBreakpoint].minWidth;
        }
        return;
    }, [delimitedOnBreakpoint]);
    return (React.createElement(ContainerStyled, __assign({ maxWidth: maxWidth, fullViewport: fullViewport, autoScroll: withAutoScroll }, divProps), children));
};
BaSeContainer.displayName = 'BaSeContainer';

var mapSizeCheckbox = {
    small: 13,
    medium: 16,
};
var mapCheckBoxValues = function (color) {
    var isDisabled = color === 'disabled';
    return {
        primary: {
            generalColors: {
                iconColor: BaSeTheme.colors.defaultColors.white,
                style: {
                    bgC: ColorMapper[color].foreground,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : ColorMapper[color].hover.defaultDark,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : ColorMapper[color].focus.defaultLight,
                    border: 'none',
                },
            },
            negative: {
                iconColor: ColorMapper[color].foreground,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.white,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : BaSeTheme.colors.institucionais.cinzaSebrae97,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : BaSeTheme.colors.institucionais.azulSebrae90,
                    border: 'none',
                },
            },
        },
    };
};
var mapCustomColorsCheckboxValues = function (customColor) {
    var customColorHsv = Color.generateFromHex(customColor);
    return {
        primary: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                bcCHover: ColorMapper.dark.hover.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                boxShadowFocus: ColorMapper.light.focus.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: 'none',
            },
        },
    };
};

var checkboxWrapperHeight = 24;
var checkboxContainerSize = 18;
var checkboxBorderSize = 2;
var checkboxIconSize = 16 - checkboxBorderSize;
var CheckboxContainer = styled.div(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  display: grid;\n  place-items: center;\n  align-self: ", ";\n  cursor: ", ";\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  display: grid;\n  place-items: center;\n  align-self: ", ";\n  cursor: ", ";\n"])), checkboxContainerSize, checkboxWrapperHeight, function (_a) {
    var verticalAlign = _a.verticalAlign;
    return verticalAlign;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  cursor: ", ";\n"], ["\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  cursor: ", ";\n"])), BaSeTheme.stackOrder.normal + 1, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var hoverCheckedStyles = function (backgroundColor) { return css(templateObject_3$E || (templateObject_3$E = __makeTemplateObject(["\n  background: ", ";\n  border-color: ", ";\n  transition: none;\n"], ["\n  background: ", ";\n  border-color: ", ";\n  transition: none;\n"])), backgroundColor, backgroundColor); };
var hoverUncheckedStyles = css(templateObject_4$y || (templateObject_4$y = __makeTemplateObject(["\n  border: ", "px solid\n    ", ";\n"], ["\n  border: ", "px solid\n    ", ";\n"])), checkboxBorderSize, BaSeTheme.colors.institucionais.azulSebrae30);
var checkedStyles = function (backgroundColor, shape) { return css(templateObject_5$s || (templateObject_5$s = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border: ", "px solid ", ";\n  background: ", ";\n  border-radius: ", ";\n  position: relative;\n  transition: ", ";\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border: ", "px solid ", ";\n  background: ", ";\n  border-radius: ", ";\n  position: relative;\n  transition: ", ";\n"])), checkboxIconSize, checkboxIconSize, checkboxBorderSize, backgroundColor, backgroundColor, shape === 'square' ? '0.25em' : '50%', "background ".concat(BaSeTheme.transitions.durationNormal)); };
var uncheckedStyles = function (disabled, shape) { return css(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", ";\n  background: ", ";\n  border: ", "px solid\n    ", ";\n  transition: ", ";\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", ";\n  background: ", ";\n  border: ", "px solid\n    ", ";\n  transition: ", ";\n"])), checkboxIconSize, checkboxIconSize, shape === 'square' ? '0.25em' : '50%', disabled
    ? BaSeTheme.colors.institucionais.cinzaSebrae97
    : BaSeTheme.colors.defaultColors.white, checkboxBorderSize, disabled
    ? BaSeTheme.colors.defaultColors.lightGray
    : BaSeTheme.colors.institucionais.cinzaSebrae75, "background ".concat(BaSeTheme.transitions.durationNormal)); };
var StyledCheckbox = styled.div(templateObject_9$j || (templateObject_9$j = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
    return props.checked
        ? checkedStyles(props.backgroundColor, props.shape)
        : uncheckedStyles(props.disabled, props.shape);
}, function (props) {
    return props.focus && css(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    "], ["\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    "])), props.boxShadowFocus);
}, function (props) {
    return !props.disabled &&
        props.hover &&
        (props.checked
            ? hoverCheckedStyles(props.backgroundOnHover)
            : hoverUncheckedStyles);
}, function (_a) {
    var isHoverable = _a.isHoverable, disabled = _a.disabled, checked = _a.checked, backgroundOnHover = _a.backgroundOnHover;
    return isHoverable && css(templateObject_8$l || (templateObject_8$l = __makeTemplateObject(["\n      &:hover {\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n      }\n    "])), !disabled &&
        (checked
            ? hoverCheckedStyles(backgroundOnHover)
            : hoverUncheckedStyles));
});
var StyledLabel$3 = styled.label(templateObject_11$f || (templateObject_11$f = __makeTemplateObject(["\n  font-family: ", ";\n  line-height: ", "px;\n  margin: 0 5px;\n  font-size: ", "px;\n  ", "\n"], ["\n  font-family: ", ";\n  line-height: ", "px;\n  margin: 0 5px;\n  font-size: ", "px;\n  ", "\n"])), BaSeTheme.typography.fontFamily, checkboxWrapperHeight, function (_a) {
    var _b;
    var size = _a.size;
    return (_b = mapSizeCheckbox[size]) !== null && _b !== void 0 ? _b : mapSizeCheckbox.medium;
}, function (_a) {
    var disabled = _a.disabled;
    return css(templateObject_10$h || (templateObject_10$h = __makeTemplateObject(["\n    color: ", ";\n    cursor: ", ";\n  "], ["\n    color: ", ";\n    cursor: ", ";\n  "])), disabled
        ? BaSeTheme.colors.institucionais.cinzaSebrae75
        : BaSeTheme.colors.institucionais.cinzaSebrae30, disabled ? 'not-allowed' : 'pointer');
});
var WrapperCheckbox = styled.div.attrs({
    className: 'BaSe--checkbox',
})(templateObject_12$e || (templateObject_12$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  min-height: ", "px;\n  align-items: center;\n  text-align: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  min-height: ", "px;\n  align-items: center;\n  text-align: ", ";\n"])), function (_a) {
    var horizontalAlign = _a.horizontalAlign;
    return horizontalAlign;
}, checkboxWrapperHeight, function (_a) {
    var horizontalAlign = _a.horizontalAlign;
    return horizontalAlign === 'row' ? 'left' : 'right';
});
var templateObject_1$Q, templateObject_2$K, templateObject_3$E, templateObject_4$y, templateObject_5$s, templateObject_6$r, templateObject_7$m, templateObject_8$l, templateObject_9$j, templateObject_10$h, templateObject_11$f, templateObject_12$e;

var idSequence$9 = idGenerator();
var BaSeCheckbox = function (_a) {
    var _b;
    var id = _a.id, name = _a.name, dataset = _a.dataset, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.isInteractive, isInteractive = _f === void 0 ? true : _f, _g = _a.checked, checked = _g === void 0 ? false : _g, _h = _a.indeterminate, indeterminate = _h === void 0 ? false : _h, _j = _a.align, align = _j === void 0 ? 'top-left' : _j, _k = _a.size, size = _k === void 0 ? 'medium' : _k, _l = _a.color, color = _l === void 0 ? 'default' : _l, _m = _a.shape, shape = _m === void 0 ? 'square' : _m, _o = _a.onChange, onChange = _o === void 0 ? function () { } : _o;
    var idCheckbox = id !== null && id !== void 0 ? id : useNextHashId(idSequence$9);
    var _p = React.useState(false), focus = _p[0], setFocus = _p[1];
    var _q = React.useState(false), hover = _q[0], setHover = _q[1];
    var formattedDataset = getFormattedDataset(dataset);
    var onCheckOrUncheck = function (event) {
        if (!disabled) {
            onChange(!checked, value, event);
        }
    };
    value = value !== null && value !== void 0 ? value : label;
    var re = new RegExp('(.*)-(.*)');
    var verticalAlign = function () {
        var verticalValue = (align.match(re) || [])[1];
        if (verticalValue === 'top') {
            return 'start';
        }
        if (verticalValue === 'bottom') {
            return 'flex-end';
        }
        if (verticalValue === 'center') {
            return 'center';
        }
        throw Error("BaSeCheckbox: Valor de \"align\" referente ao valor vertical \"".concat(verticalValue, "\" \u00E9 invalido! Informe \"top\", \"bottom\" ou \"center\""));
    };
    var horizontalAlign = function () {
        var horizontalValue = (align.match(re) || [])[2];
        if (horizontalValue === 'right') {
            return 'row-reverse';
        }
        if (horizontalValue === 'left') {
            return 'row';
        }
        throw Error("BaSeCheckbox: Valor de \"align\" referente ao valor horizontal \"".concat(horizontalValue, "\" \u00E9 invalido! Informe \"right\" ou \"left\""));
    };
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation ||
        color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b;
        if (color) {
            if (!colorIsMapped) {
                return mapCustomColorsCheckboxValues(color).primary;
            }
            else {
                if (color === BaSeTheme.components.button.colors.negative) {
                    return (_a = mapCheckBoxValues('default').primary) === null || _a === void 0 ? void 0 : _a.negative;
                }
                return (_b = mapCheckBoxValues(color).primary) === null || _b === void 0 ? void 0 : _b.generalColors;
            }
        }
        else {
            return mapCheckBoxValues('default').primary.generalColors;
        }
    };
    var buttonValues = disabled
        ? color === 'negative'
            ? (_b = mapCheckBoxValues('disabled').primary) === null || _b === void 0 ? void 0 : _b.negative
            : mapCheckBoxValues('disabled').primary.generalColors
        : getColorsAtributes();
    var _r = buttonValues.style, bgC = _r.bgC, bcCHover = _r.bcCHover, boxShadowFocus = _r.boxShadowFocus, border = _r.border, iconColor = buttonValues.iconColor;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(WrapperCheckbox, { horizontalAlign: horizontalAlign() },
        React.createElement(CheckboxContainer, { verticalAlign: verticalAlign(), disabled: disabled },
            React.createElement(HiddenCheckbox, __assign({ defaultValue: value, tabIndex: isInteractive ? 0 : -1, id: idCheckbox, name: name }, formattedDataset, { checked: checked, disabled: disabled, onChange: onCheckOrUncheck, onPointerEnter: function () { return setHover(isInteractive && true); }, onFocus: function () { return setFocus(isInteractive && true); }, onPointerLeave: function () { return setHover(false); }, onBlur: function () { return setFocus(false); }, onKeyPress: function (event) {
                    return event.key === 'Enter' && isInteractive && onCheckOrUncheck(event);
                } })),
            React.createElement(StyledCheckbox, { shape: shape, hover: hover, focus: focus, disabled: disabled, checked: checked, backgroundColor: bgC, backgroundOnHover: bcCHover, isHoverable: isInteractive, border: border, boxShadowFocus: boxShadowFocus }, checked && (React.createElement(BaSeIcon, { description: getMessage('checkbox.iconDescription'), name: indeterminate ? 'minus' : 'check', color: iconColor, size: checkboxIconSize })))),
        React.createElement(StyledLabel$3, { htmlFor: idCheckbox, size: size, disabled: disabled }, label)));
};
BaSeCheckbox.displayName = 'BaSeCheckbox';

var _a$5 = BaSeTheme.colors.institucionais, azulSebrae36 = _a$5.azulSebrae36, azulSebrae75 = _a$5.azulSebrae75, cinzaSebrae90$1 = _a$5.cinzaSebrae90, cinzaSebrae97$1 = _a$5.cinzaSebrae97;
var SelectableContainer = styled.button.attrs({
    className: 'BaSe--selectable-container',
})(templateObject_5$r || (templateObject_5$r = __makeTemplateObject(["\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  appearance: none;\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n\n  ", ";\n\n  ", ";\n\n  :hover {\n    ", "\n  }\n"], ["\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  appearance: none;\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n\n  ", ";\n\n  ", ";\n\n  :hover {\n    ", "\n  }\n"])), BaSeTheme.colors.defaultColors.transparent, function (_a) {
    var borderRadius = _a.borderRadius;
    return numberWithUnit(borderRadius);
}, BaSeTheme.shadows.profundidade4, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected
        ? css(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n          outline: 3px solid ", ";\n          :focus {\n            outline: 3px solid ", ";\n          }\n        "], ["\n          outline: 3px solid ", ";\n          :focus {\n            outline: 3px solid ", ";\n          }\n        "])), azulSebrae36, azulSebrae75) : css(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n          outline: 1px solid ", ";\n          :focus {\n            outline: 3px solid ", ";\n          }\n        "], ["\n          outline: 1px solid ", ";\n          :focus {\n            outline: 3px solid ", ";\n          }\n        "])), cinzaSebrae90$1, azulSebrae75);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_3$D || (templateObject_3$D = __makeTemplateObject(["\n      background-color: ", ";\n      outline: 3px solid ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      outline: 3px solid ", ";\n      cursor: not-allowed;\n    "])), cinzaSebrae97$1, cinzaSebrae90$1);
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled && css(templateObject_4$x || (templateObject_4$x = __makeTemplateObject(["\n        outline: 3px solid ", ";\n        box-shadow: ", ";\n        transition: box-shadow 0.3s ease-in-out;\n      "], ["\n        outline: 3px solid ", ";\n        box-shadow: ", ";\n        transition: box-shadow 0.3s ease-in-out;\n      "])), azulSebrae36, BaSeTheme.shadows.profundidade8);
});
var CheckboxContent = styled.div(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n  position: absolute;\n  top: 0.6em;\n  right: 0.5em;\n\n  .BaSe--checkbox div > div,\n  img {\n    width: 1.125em;\n    height: 1.125em;\n  }\n"], ["\n  position: absolute;\n  top: 0.6em;\n  right: 0.5em;\n\n  .BaSe--checkbox div > div,\n  img {\n    width: 1.125em;\n    height: 1.125em;\n  }\n"])));
var templateObject_1$P, templateObject_2$J, templateObject_3$D, templateObject_4$x, templateObject_5$r, templateObject_6$q;

var BaSeSelectableContainer = function (_a) {
    var inputProps = _a.inputProps, _b = _a.borderRadius, borderRadius = _b === void 0 ? 12 : _b, renderContent = _a.renderContent;
    var _c = React.useMemo(function () { return inputProps; }, [inputProps]), checked = _c.checked, disabled = _c.disabled, shape = _c.shape, onChange = _c.onChange;
    return (React.createElement(SelectableContainer, { isSelected: !!checked, disabled: disabled, borderRadius: borderRadius, type: "button", onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(!checked); } },
        renderContent(!!checked),
        React.createElement(CheckboxContent, null,
            React.createElement(BaSeCheckbox, { checked: checked, shape: shape, disabled: disabled }))));
};
BaSeSelectableContainer.displayName = 'BaSeSelectableContainer';

var shadowColor = BaSeTheme.colors.defaultColors.shadowColor, _a$4 = BaSeTheme.transitions, durationFast = _a$4.durationFast, allPropertiesContinuousSlow = _a$4.allPropertiesContinuousSlow, zIndexNormal = BaSeTheme.stackOrder.normal;
function isInPosition(anchor, pos) {
    return pos.includes(anchor);
}
function isHorizontalPosition(anchor) {
    return isInPosition(anchor, ['left', 'right']);
}
var DrawerWrapper = styled.div.attrs({
    className: 'BaSe--drawer',
})(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n  overflow: hidden;\n  display: flex;\n\n  flex-direction: ", ";\n  ", ";\n"], ["\n  overflow: hidden;\n  display: flex;\n\n  flex-direction: ", ";\n  ", ";\n"])), function (_a) {
    var anchor = _a.anchor;
    return "".concat(isHorizontalPosition(anchor) ? 'row' : 'column').concat(isInPosition(anchor, ['right', 'bottom']) ? '-reverse' : '');
}, function (_a) {
    var pullerPosition = _a.pullerPosition, anchor = _a.anchor, height = _a.height, width = _a.width;
    return css(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n    flex-direction: ", "", ";\n    ", ";\n    align-items: ", ";\n  "], ["\n    flex-direction: ", "", ";\n    ", ";\n    align-items: ", ";\n  "])), isHorizontalPosition(anchor) ? 'row' : 'column', isInPosition(anchor, ['right', 'bottom']) ? '-reverse' : '', isHorizontalPosition(anchor)
        ? "height: ".concat(numberWithUnit(height))
        : "width: ".concat(numberWithUnit(width)), pullerPosition === 'start'
        ? 'flex-start'
        : pullerPosition === 'end'
            ? 'flex-end'
            : 'center');
});
var DrawerContent = styled.div.attrs({
    className: 'BaSe--drawer-content',
})(templateObject_4$w || (templateObject_4$w = __makeTemplateObject(["\n  will-change: margin-left, margin-right, margin-bottom;\n  overflow: hidden;\n  transition: ", ";\n  z-index: ", ";\n  background-color: ", ";\n  height: ", ";\n  width: ", ";\n  ", "\n"], ["\n  will-change: margin-left, margin-right, margin-bottom;\n  overflow: hidden;\n  transition: ", ";\n  z-index: ", ";\n  background-color: ", ";\n  height: ", ";\n  width: ", ";\n  ", "\n"])), allPropertiesContinuousSlow, zIndexNormal, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var height = _a.height;
    return numberWithUnit(height);
}, function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (_a) {
    var open = _a.open, width = _a.width, height = _a.height, anchor = _a.anchor;
    return css(templateObject_3$C || (templateObject_3$C = __makeTemplateObject(["\n    box-shadow: ", " 12px ", ";\n\n    margin-", ": -", ""], ["\n    box-shadow: ", " 12px ", ";\n\n    margin-", ": -", ""])), isHorizontalPosition(anchor) ? '0 8px' : '8px 0', shadowColor, anchor, open ? '0' : numberWithUnit(isHorizontalPosition(anchor) ? width : height));
});
var DrawerPuller = styled.button.attrs({
    className: 'BaSe--drawer-puller',
})(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n  will-change: background-color, box-shadow;\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n\n  display: grid;\n  place-items: center;\n\n  z-index: ", ";\n\n  box-shadow: ", "\n    4px ", ";\n\n  margin: ", ";\n\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px\n      ", ";\n  }\n\n  .BaSe--icon {\n    transition: transform ", ";\n  }\n\n  height: ", ";\n\n  width: ", ";\n\n  border-radius: ", ";\n\n  ", "\n"], ["\n  will-change: background-color, box-shadow;\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n\n  display: grid;\n  place-items: center;\n\n  z-index: ", ";\n\n  box-shadow: ", "\n    4px ", ";\n\n  margin: ", ";\n\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px\n      ", ";\n  }\n\n  .BaSe--icon {\n    transition: transform ", ";\n  }\n\n  height: ", ";\n\n  width: ", ";\n\n  border-radius: ", ";\n\n  ", "\n"])), zIndexNormal + 1, function (_a) {
    var anchor = _a.anchor;
    return "\n    ".concat(isInPosition(anchor, ['top', 'bottom'])
        ? '0'
        : "".concat(isInPosition(anchor, ['left']) ? '2px' : '-2px'), "\n    ").concat(isInPosition(anchor, ['right', 'left'])
        ? '0'
        : "".concat(isInPosition(anchor, ['top']) ? '2px' : '-2px'));
}, shadowColor, function (_a) {
    var anchor = _a.anchor;
    return "\n    ".concat(isInPosition(anchor, ['right', 'left'])
        ? '30px'
        : "".concat(isInPosition(anchor, ['bottom']) ? '4px' : '0'), "\n    ").concat(isInPosition(anchor, ['top', 'bottom'])
        ? '30px'
        : "".concat(isInPosition(anchor, ['left']) ? '4px' : '0'), "\n    ").concat(isInPosition(anchor, ['right', 'left'])
        ? '30px'
        : "".concat(isInPosition(anchor, ['top']) ? '4px' : '0'), "\n    ").concat(isInPosition(anchor, ['top', 'bottom'])
        ? '30px'
        : "".concat(isInPosition(anchor, ['right']) ? '4px' : '0'), "\n  ");
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var foregroundColor = _a.foregroundColor;
    return transformLightness(foregroundColor, 0.94);
}, function (_a) {
    var foregroundColor = _a.foregroundColor;
    return transformLightness(foregroundColor, 0.93);
}, durationFast, function (_a) {
    var anchor = _a.anchor;
    return isHorizontalPosition(anchor) ? '48px' : '24px';
}, function (_a) {
    var anchor = _a.anchor;
    return isHorizontalPosition(anchor) ? '24px' : '48px';
}, function (_a) {
    var anchor = _a.anchor;
    return "\n    ".concat(isInPosition(anchor, ['top', 'left']) ? '0' : '16px', "\n    ").concat(isInPosition(anchor, ['top', 'right']) ? '0' : '16px', "\n    ").concat(isInPosition(anchor, ['bottom', 'right']) ? '0' : '16px', "\n    ").concat(isInPosition(anchor, ['bottom', 'left']) ? '0' : '16px', "\n  ");
}, function (_a) {
    var open = _a.open;
    return !open && css(templateObject_5$q || (templateObject_5$q = __makeTemplateObject(["\n      .BaSe--icon {\n        transform: rotate(180deg);\n      }\n    "], ["\n      .BaSe--icon {\n        transform: rotate(180deg);\n      }\n    "])));
});
var templateObject_1$O, templateObject_2$I, templateObject_3$C, templateObject_4$w, templateObject_5$q, templateObject_6$p;

var _a$3 = BaSeTheme.colors, white$3 = _a$3.defaultColors.white, cinzaSebrae45$2 = _a$3.institucionais.cinzaSebrae45;
function isVerticalPosition(anchor) {
    return ['top', 'bottom'].includes(anchor);
}
var BaSeDrawer = function (_a) {
    var children = _a.children, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? white$3 : _b, _c = _a.foregroundColor, foregroundColor = _c === void 0 ? cinzaSebrae45$2 : _c, _d = _a.anchor, anchor = _d === void 0 ? 'left' : _d, _e = _a.pullerPosition, pullerPosition = _e === void 0 ? 'middle' : _e, height = _a.height, width = _a.width, _f = _a.open, externalOpen = _f === void 0 ? true : _f, onToggle = _a.onToggle;
    if (isVerticalPosition(anchor) && !height) {
        throw Error('[BaSeDrawer] Ao informar a posição "bottom" é necessário definir a prop "height".');
    }
    if (!isVerticalPosition(anchor) && !width) {
        throw Error('[BaSeDrawer] Ao informar a posição "left" ou "right" é necessário definir a prop "width".');
    }
    var internalHeight = React.useMemo(function () { return height !== null && height !== void 0 ? height : '100%'; }, [height]);
    var internalWidth = React.useMemo(function () { return width !== null && width !== void 0 ? width : '100%'; }, [width]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _g = React.useState(externalOpen), open = _g[0], setOpen = _g[1];
    React.useEffect(function () { return onToggle === null || onToggle === void 0 ? void 0 : onToggle(open); }, [open]);
    React.useEffect(function () { return setOpen(externalOpen); }, [externalOpen]);
    return (React.createElement(DrawerWrapper, { anchor: anchor, pullerPosition: pullerPosition, height: internalHeight, width: internalWidth },
        React.createElement(DrawerContent, { backgroundColor: backgroundColor, open: open, anchor: anchor, height: internalHeight, width: internalWidth }, children),
        React.createElement(DrawerPuller, { backgroundColor: backgroundColor, foregroundColor: foregroundColor, open: open, anchor: anchor, onClick: function () { return setOpen(function (oldState) { return !oldState; }); } },
            React.createElement(BaSeIcon, { name: "angle-".concat(anchor === 'bottom' ? 'down' : anchor === 'top' ? 'up' : anchor), description: getMessage('buttonIcon.toggleDrawer'), color: foregroundColor, size: 24 }))));
};
BaSeDrawer.displayName = 'BaSeDrawer';

function getValue(unit) {
    if (unit === undefined) {
        return undefined;
    }
    return numberWithUnit(unit);
}
var GridWrapper = styled.div(templateObject_3$B || (templateObject_3$B = __makeTemplateObject(["\n  margin: 0 auto;\n  position: relative;\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(12, 1fr);\n  width: auto;\n  ", "\n  ", "\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n  /*tablet*/\n  ", "\n  /*desktop*/\n  ", "\n  /*desktopLarge*/\n  ", "\n"], ["\n  margin: 0 auto;\n  position: relative;\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(12, 1fr);\n  width: auto;\n  ", "\n  ", "\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n  /*tablet*/\n  ", "\n  /*desktop*/\n  ", "\n  /*desktopLarge*/\n  ", "\n"])), function (_a) {
    var delimitedOnBreakpoint = _a.delimitedOnBreakpoint;
    return delimitedOnBreakpoint && css(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), BaSeTheme.breakpoints[delimitedOnBreakpoint].minWidth);
}, function (_a) {
    var padding = _a.padding;
    return padding && css(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), getValue(padding));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.mobileSmall.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.mobile.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.mobile.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.mobileLarge.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.tablet.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.tablet.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.desktop.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.desktop.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.desktopLarge.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.desktopLarge.gap, "px"), ";\n  "));
});
var templateObject_1$N, templateObject_2$H, templateObject_3$B;

var BaSeGrid = function (_a) {
    var gap = _a.gap, padding = _a.padding, delimitedOnBreakpoint = _a.delimitedOnBreakpoint, children = _a.children;
    return (React.createElement(GridWrapper, { className: "BaSe--grid", padding: padding, gap: gap, delimitedOnBreakpoint: delimitedOnBreakpoint }, children));
};
BaSeGrid.displayName = 'BaSeGrid';

function gridColumn(size, startAt) {
    return startAt !== undefined
        ? "".concat(startAt + 1, " / span ").concat(size)
        : "span ".concat(size);
}
function get(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
    var what = _a.what, props = _a.props, breakpoint = _a.breakpoint;
    var fallback = {
        mobileSmall: (_b = props.all) === null || _b === void 0 ? void 0 : _b[what],
        mobile: (_d = (_c = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _c === void 0 ? void 0 : _c[what]) !== null && _d !== void 0 ? _d : (_e = props.all) === null || _e === void 0 ? void 0 : _e[what],
        mobileLarge: (_j = (_g = (_f = props === null || props === void 0 ? void 0 : props.mobile) === null || _f === void 0 ? void 0 : _f[what]) !== null && _g !== void 0 ? _g : (_h = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _h === void 0 ? void 0 : _h[what]) !== null && _j !== void 0 ? _j : (_k = props.all) === null || _k === void 0 ? void 0 : _k[what],
        tablet: (_r = (_p = (_m = (_l = props === null || props === void 0 ? void 0 : props.mobileLarge) === null || _l === void 0 ? void 0 : _l[what]) !== null && _m !== void 0 ? _m : (_o = props === null || props === void 0 ? void 0 : props.mobile) === null || _o === void 0 ? void 0 : _o[what]) !== null && _p !== void 0 ? _p : (_q = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _q === void 0 ? void 0 : _q[what]) !== null && _r !== void 0 ? _r : (_s = props.all) === null || _s === void 0 ? void 0 : _s[what],
        desktop: (_0 = (_y = (_w = (_u = (_t = props === null || props === void 0 ? void 0 : props.tablet) === null || _t === void 0 ? void 0 : _t[what]) !== null && _u !== void 0 ? _u : (_v = props === null || props === void 0 ? void 0 : props.mobileLarge) === null || _v === void 0 ? void 0 : _v[what]) !== null && _w !== void 0 ? _w : (_x = props === null || props === void 0 ? void 0 : props.mobile) === null || _x === void 0 ? void 0 : _x[what]) !== null && _y !== void 0 ? _y : (_z = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _z === void 0 ? void 0 : _z[what]) !== null && _0 !== void 0 ? _0 : (_1 = props.all) === null || _1 === void 0 ? void 0 : _1[what],
        desktopLarge: (_11 = (_9 = (_7 = (_5 = (_3 = (_2 = props === null || props === void 0 ? void 0 : props.desktop) === null || _2 === void 0 ? void 0 : _2[what]) !== null && _3 !== void 0 ? _3 : (_4 = props === null || props === void 0 ? void 0 : props.tablet) === null || _4 === void 0 ? void 0 : _4[what]) !== null && _5 !== void 0 ? _5 : (_6 = props === null || props === void 0 ? void 0 : props.mobileLarge) === null || _6 === void 0 ? void 0 : _6[what]) !== null && _7 !== void 0 ? _7 : (_8 = props === null || props === void 0 ? void 0 : props.mobile) === null || _8 === void 0 ? void 0 : _8[what]) !== null && _9 !== void 0 ? _9 : (_10 = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _10 === void 0 ? void 0 : _10[what]) !== null && _11 !== void 0 ? _11 : (_12 = props.all) === null || _12 === void 0 ? void 0 : _12[what],
    };
    return (_14 = (_13 = props === null || props === void 0 ? void 0 : props[breakpoint]) === null || _13 === void 0 ? void 0 : _13[what]) !== null && _14 !== void 0 ? _14 : fallback[breakpoint];
}
function getSize(_a) {
    var props = _a.from, breakpoint = _a.atBreakpoint;
    return get({ props: props, breakpoint: breakpoint, what: 'size' });
}
function getStartAt(_a) {
    var props = _a.from, breakpoint = _a.atBreakpoint;
    return get({ props: props, breakpoint: breakpoint, what: 'startAt' });
}
function gridColumnBreakpoint(props, breakpoint) {
    return gridColumn(getSize({ from: props, atBreakpoint: breakpoint }), getStartAt({ from: props, atBreakpoint: breakpoint }));
}
var GridItemWrapper = styled.div(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  grid-column: ", ";\n\n  /* mobileSmall */\n  ", "\n  /* mobile */\n  ", "\n  /* mobileLarge */\n  ", "\n  /* tablet */\n  ", "\n  /* desktop */\n  ", "\n  /* desktopLarge */\n  ", "\n"], ["\n  grid-column: ", ";\n\n  /* mobileSmall */\n  ", "\n  /* mobile */\n  ", "\n  /* mobileLarge */\n  ", "\n  /* tablet */\n  ", "\n  /* desktop */\n  ", "\n  /* desktopLarge */\n  ", "\n"])), function (props) { var _a; return gridColumn(props.all.size, (_a = props.all) === null || _a === void 0 ? void 0 : _a.startAt); }, function (props) {
    return BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'mobileSmall'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.mobile.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'mobile'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'mobileLarge'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.tablet.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'tablet'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.desktop.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'desktop'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.desktopLarge.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'desktopLarge'), ";\n  "));
});
var templateObject_1$M;

var BaSeGridItem = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 12 : _b, startAt = _a.startAt, mobileSmall = _a.mobileSmall, mobile = _a.mobile, mobileLarge = _a.mobileLarge, tablet = _a.tablet, desktop = _a.desktop, desktopLarge = _a.desktopLarge, children = _a.children;
    return (React.createElement(GridItemWrapper, { className: "BaSe--grid-item", all: { size: size, startAt: startAt }, mobileSmall: mobileSmall, mobile: mobile, mobileLarge: mobileLarge, tablet: tablet, desktop: desktop, desktopLarge: desktopLarge }, children));
};
BaSeGridItem.displayName = 'BaSeGridItem';

var validateColor = function (color) {
    var customColorHsv = Color.generateFromHex(color);
    return color && customColorHsv;
};
var defaultColor = {
    background: BaSeTheme.colors.institucionais.cinzaSebrae97,
    link: BaSeTheme.colors.institucionais.azulSebrae36,
    text: BaSeTheme.colors.institucionais.cinzaSebrae60,
    version: BaSeTheme.colors.institucionais.cinzaSebrae75,
    mobileHeader: BaSeTheme.colors.institucionais.azulSebrae36,
    separator: BaSeTheme.colors.gestao.cinza85,
};
var FooterWrapper = styled.footer.attrs({
    className: 'BaSe--footer',
})(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  &.BaSe--footer {\n    font-family: ", ";\n    width: 100%;\n    background-color: ", ";\n    display: grid;\n    place-items: center;\n  }\n"], ["\n  &.BaSe--footer {\n    font-family: ", ";\n    width: 100%;\n    background-color: ", ";\n    display: grid;\n    place-items: center;\n  }\n"])), BaSeTheme.typography.fontFamily, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor && validateColor(backgroundColor)
        ? backgroundColor
        : defaultColor.background;
});
var CollapsedSubFooter = styled.div(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n  justify-self: start;\n  padding: 1em;\n  a,\n  p {\n    padding: 0.5em 0;\n    justify-content: start;\n  }\n"], ["\n  justify-self: start;\n  padding: 1em;\n  a,\n  p {\n    padding: 0.5em 0;\n    justify-content: start;\n  }\n"])));
var CollapsedUpperFooter = styled.div(templateObject_4$v || (templateObject_4$v = __makeTemplateObject(["\n  width: 100%;\n  p,\n  a {\n    padding-left: 0;\n  }\n\n  ", "\n"], ["\n  width: 100%;\n  p,\n  a {\n    padding-left: 0;\n  }\n\n  ", "\n"])), function (_a) {
    var hideLinks = _a.hideLinks;
    return hideLinks && css(templateObject_3$A || (templateObject_3$A = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var TextFooter = styled.div(templateObject_5$p || (templateObject_5$p = __makeTemplateObject(["\n  width: 100%;\n  display: ", ";\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: ", ";\n"], ["\n  width: 100%;\n  display: ", ";\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: ", ";\n"])), function (_a) {
    var hideLinks = _a.hideLinks;
    return (hideLinks ? 'none' : 'flex');
}, function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? '13px 0px' : '0px');
});
styled.div(templateObject_6$o || (templateObject_6$o = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 18px 16px;\n  color: #ffffff;\n  font-size: 13px;\n"], ["\n  background-color: ", ";\n  padding: 18px 16px;\n  color: #ffffff;\n  font-size: 13px;\n"])), function (_a) {
    var mobileHeaderColor = _a.mobileHeaderColor;
    return mobileHeaderColor && validateColor(mobileHeaderColor)
        ? mobileHeaderColor
        : defaultColor.mobileHeader;
});
var YearText = styled.p(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  a {\n    padding: 0;\n  }\n"], ["\n  color: ", ";\n  font-size: 13px;\n  a {\n    padding: 0;\n  }\n"])), function (_a) {
    var textColor = _a.textColor;
    return textColor && validateColor(textColor) ? textColor : defaultColor.text;
});
var SystemFooter = styled.p(templateObject_8$k || (templateObject_8$k = __makeTemplateObject(["\n  color: ", ";\n  font-size: 11px;\n"], ["\n  color: ", ";\n  font-size: 11px;\n"])), function (_a) {
    var versionColor = _a.versionColor;
    return versionColor && validateColor(versionColor)
        ? versionColor
        : defaultColor.version;
});
var RelationFooter = styled.div(templateObject_9$i || (templateObject_9$i = __makeTemplateObject(["\n  font-size: 13px;\n  align-content: center;\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  justify-content: ", ";\n  text-align: ", ";\n"], ["\n  font-size: 13px;\n  align-content: center;\n  display: ", ";\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  justify-content: ", ";\n  text-align: ", ";\n"])), function (_a) {
    var hideLinks = _a.hideLinks;
    return (hideLinks ? 'none' : 'flex');
}, function (_a) {
    var direction = _a.direction;
    return direction === 'row' ? 'flex-end' : 'flex-start';
}, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? 'end' : 'start');
});
var Line = styled.hr(templateObject_10$g || (templateObject_10$g = __makeTemplateObject(["\n  border: none;\n  border-bottom: 1px solid\n    ", ";\n  width: 100%;\n  margin: 0px;\n"], ["\n  border: none;\n  border-bottom: 1px solid\n    ", ";\n  width: 100%;\n  margin: 0px;\n"])), function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor && validateColor(separatorColor)
        ? separatorColor
        : defaultColor.separator;
});
var Separator = styled(Line)(templateObject_11$e || (templateObject_11$e = __makeTemplateObject(["\n  transform: translateY(16px);\n"], ["\n  transform: translateY(16px);\n"])));
var FooterLinks = styled.div(templateObject_13$c || (templateObject_13$c = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-self: start;\n  text-align: center;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-self: start;\n  text-align: center;\n\n  ", "\n"])), function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? 'center' : 'start');
}, function (_a) {
    var direction = _a.direction;
    return direction === 'column' && css(templateObject_12$d || (templateObject_12$d = __makeTemplateObject(["\n      padding: 0;\n      p:not(:last-child),\n      a:not(:last-child) {\n        border: none;\n      }\n    "], ["\n      padding: 0;\n      p:not(:last-child),\n      a:not(:last-child) {\n        border: none;\n      }\n    "])));
});
var FooterLink = styled.p(templateObject_14$c || (templateObject_14$c = __makeTemplateObject(["\n  font-size: 13px;\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n  padding: 4px 16px;\n  :not(:last-child) {\n    border-right: 1px solid\n      ", ";\n  }\n  :first-child {\n    padding-left: 0;\n  }\n"], ["\n  font-size: 13px;\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n  padding: 4px 16px;\n  :not(:last-child) {\n    border-right: 1px solid\n      ", ";\n  }\n  :first-child {\n    padding-left: 0;\n  }\n"])), function (_a) {
    var linkColor = _a.linkColor;
    return linkColor && validateColor(linkColor) ? linkColor : defaultColor.link;
}, function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor && validateColor(separatorColor)
        ? separatorColor
        : defaultColor.separator;
});
var FooterContent = styled.div(templateObject_15$b || (templateObject_15$b = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1$L, templateObject_2$G, templateObject_3$A, templateObject_4$v, templateObject_5$p, templateObject_6$o, templateObject_7$l, templateObject_8$k, templateObject_9$i, templateObject_10$g, templateObject_11$e, templateObject_12$d, templateObject_13$c, templateObject_14$c, templateObject_15$b;

function useMenuItemsShrink(setMenuItemsShrink, collapsedBreakpoint) {
    var queryContext = React.useContext(BaSeBreakpointContext);
    var handleMenuItemsShrink = React.useCallback(function () {
        if (!collapsedBreakpoint || !(collapsedBreakpoint in queryContext)) {
            setMenuItemsShrink(true);
        }
        else {
            var queryMarked = false;
            // eslint-disable-next-line guard-for-in
            for (var query in queryContext) {
                queryMarked += queryContext[query];
                if (query === collapsedBreakpoint) {
                    break;
                }
            }
            setMenuItemsShrink(!!queryMarked);
        }
    }, [queryContext]);
    React.useEffect(function () {
        handleMenuItemsShrink();
    }, [handleMenuItemsShrink]);
}

var SEBRAE_URL = 'https://www.sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_quemsomos';
var SEBRAE_TEL = '0800 570 0800';
var SEBRAE_TEL_URL = 'tel:08005700800';
var CURRENT_YEAR = new Date().getFullYear();
var BaSeLinkFooter = function (_a) {
    var linkColor = _a.linkColor, modal = _a.modal, link = _a.link, label = _a.label;
    var showModal = React.useContext(BaSeDialogContext).showModal;
    return (React.createElement(FooterLink, { as: modal ? undefined : 'a', linkColor: linkColor, onClick: function () { return (modal ? showModal(modal) : undefined); }, href: link !== null && link !== void 0 ? link : undefined }, ' ' + label));
};
var BaSeRelationFooter = function (_a) {
    var _b, _c;
    var menuDisplay = _a.menuDisplay, textColor = _a.textColor, relationText = _a.relationText, linkColor = _a.linkColor, relationLink = _a.relationLink, hideLinks = _a.hideLinks;
    return (React.createElement(RelationFooter, { direction: menuDisplay ? 'column' : 'row', hideLinks: hideLinks },
        React.createElement(YearText, { textColor: textColor },
            relationText,
            React.createElement(BaSeLinkFooter, { linkColor: linkColor, label: (_b = relationLink === null || relationLink === void 0 ? void 0 : relationLink.label) !== null && _b !== void 0 ? _b : SEBRAE_TEL, modal: relationLink === null || relationLink === void 0 ? void 0 : relationLink.modal, link: (_c = relationLink === null || relationLink === void 0 ? void 0 : relationLink.link) !== null && _c !== void 0 ? _c : SEBRAE_TEL_URL }))));
};
var BaSeItemsFooter = function (_a) {
    var menuDisplay = _a.menuDisplay, links = _a.links, linkColor = _a.linkColor;
    return (React.createElement(FooterLinks, { direction: menuDisplay ? 'column' : 'row' }, links.map(function (item) {
        if (!item.modal && !item.link) {
            throw Error("item '".concat(item.label, "' deve ter link ou modal"));
        }
        return (React.createElement(BaSeLinkFooter, { linkColor: linkColor, key: item.label, label: item.label, link: item.link, modal: item.modal }));
    })));
};
var BaSeTextFooter = function (_a) {
    var menuDisplay = _a.menuDisplay, textColor = _a.textColor, versionColor = _a.versionColor, systemName = _a.systemName, systemVersion = _a.systemVersion;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _b = React.useMemo(function () { return ({
        sebrae: getMessage('system.sebrae'),
        rights: getMessage('system.rights'),
        version: getMessage('footer.system.version'),
    }); }, [getMessage]), sebrae = _b.sebrae, rights = _b.rights, version = _b.version;
    return (React.createElement(TextFooter, { direction: menuDisplay ? 'column' : 'row' },
        React.createElement(YearText, { textColor: textColor },
            sebrae,
            " ",
            CURRENT_YEAR,
            " - ",
            rights),
        React.createElement(SystemFooter, { versionColor: versionColor },
            systemName,
            " ",
            version,
            " ",
            systemVersion)));
};
var BaSeFooter = function (_a) {
    var relationLink = _a.relationLink, relationTextExternal = _a.relationText, _b = _a.links, linksExternal = _b === void 0 ? [] : _b, collapsedHeaderExternal = _a.collapsedHeader, _c = _a.systemName, systemName = _c === void 0 ? '' : _c, _d = _a.systemVersion, systemVersion = _d === void 0 ? '' : _d, _e = _a.collapsedHeaderColor, collapsedHeaderColor = _e === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _e, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _f, _g = _a.linkColor, linkColor = _g === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _g, _h = _a.textColor, textColor = _h === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _h, _j = _a.versionColor, versionColor = _j === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae75 : _j, _k = _a.separatorColor, separatorColor = _k === void 0 ? BaSeTheme.colors.gestao.cinza85 : _k, _l = _a.collapsedBreakpoint, collapsedBreakpoint = _l === void 0 ? 'onTablet' : _l, _m = _a.delimitedOnBreakpoint, delimitedOnBreakpoint = _m === void 0 ? 'desktop' : _m, hideLinks = _a.hideLinks;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var relationText = React.useMemo(function () { return relationTextExternal !== null && relationTextExternal !== void 0 ? relationTextExternal : getMessage('footer.relationText'); }, [relationTextExternal]);
    var links = React.useMemo(function () {
        return linksExternal.length === 0
            ? [
                {
                    label: getMessage('footer.collapsedHeader'),
                    link: SEBRAE_URL,
                },
            ]
            : linksExternal;
    }, [linksExternal]);
    var collapsedHeader = React.useMemo(function () { var _a; return (_a = collapsedHeaderExternal !== null && collapsedHeaderExternal !== void 0 ? collapsedHeaderExternal : links[0].label) !== null && _a !== void 0 ? _a : ''; }, [collapsedHeaderExternal, links]);
    var _o = React.useState(false), menuDisplay = _o[0], setMenuDisplay = _o[1];
    useMenuItemsShrink(setMenuDisplay, collapsedBreakpoint);
    return (React.createElement(FooterWrapper, { backgroundColor: backgroundColor }, !menuDisplay ? (React.createElement(FooterContent, null,
        React.createElement(BaSeGrid, { delimitedOnBreakpoint: delimitedOnBreakpoint },
            React.createElement(BaSeGridItem, { size: 12 },
                React.createElement(TextFooter, { direction: menuDisplay ? 'column' : 'row', hideLinks: hideLinks },
                    React.createElement(BaSeItemsFooter, { menuDisplay: menuDisplay, links: links, linkColor: linkColor }),
                    React.createElement(BaSeRelationFooter, { linkColor: linkColor, menuDisplay: menuDisplay, textColor: textColor, relationText: relationText, relationLink: relationLink })))),
        React.createElement(Line, { separatorColor: separatorColor }),
        React.createElement(BaSeGrid, { delimitedOnBreakpoint: delimitedOnBreakpoint },
            React.createElement(BaSeGridItem, { size: 12 },
                React.createElement(BaSeTextFooter, { menuDisplay: menuDisplay, systemName: systemName, systemVersion: systemVersion, textColor: textColor, versionColor: versionColor }))))) : (React.createElement(React.Fragment, null,
        React.createElement(CollapsedUpperFooter, { hideLinks: hideLinks },
            React.createElement(BaSeAccordion, { options: [
                    {
                        content: (React.createElement(React.Fragment, null,
                            React.createElement(BaSeItemsFooter, { menuDisplay: menuDisplay, links: links, linkColor: linkColor }),
                            React.createElement(Separator, { separatorColor: separatorColor }))),
                        title: collapsedHeader,
                    },
                ], backgroundTitleColor: collapsedHeaderColor, hasContentBorder: false, titleColor: BaSeTheme.colors.defaultColors.white, 
                // borderTitleColor={collapsedHeaderColor}
                backgroundContentColor: backgroundColor, shadow: "none" })),
        React.createElement(CollapsedSubFooter, null,
            React.createElement(BaSeRelationFooter, { hideLinks: hideLinks, linkColor: linkColor, menuDisplay: menuDisplay, textColor: textColor, relationText: relationText, relationLink: relationLink }),
            React.createElement(BaSeTextFooter, { menuDisplay: menuDisplay, systemName: systemName, systemVersion: systemVersion, textColor: textColor, versionColor: versionColor }))))));
};
BaSeFooter.displayName = 'BaSeFooter';

var VLIBRAS_URL = 'https://vlibras.gov.br/app';
var TYPE = 'libras';
var OPEN_TIMEOUT_DELAY = 1000;
var timeoutToOpen;
function isVLibras(obj) {
    return !!obj && typeof obj === 'object' && 'Widget' in obj;
}
function inject() {
    var div_vw = document.createElement('div');
    var div_vw_access_button = document.createElement('div');
    var div_vw_plugin_wrapper = document.createElement('div');
    var div_vw_plugin_top_wrapper = document.createElement('div');
    var script = document.createElement('script');
    div_vw.dataset.designSystem = "BaSe@".concat(version);
    div_vw.dataset.type = TYPE;
    div_vw.setAttribute('vw', '');
    div_vw.classList.add('enabled');
    div_vw_access_button.setAttribute('vw-access-button', '');
    div_vw_access_button.classList.add('active');
    div_vw_plugin_wrapper.setAttribute('vw-plugin-wrapper', '');
    div_vw_plugin_top_wrapper.classList.add('vw-plugin-top-wrapper');
    script.src = "".concat(VLIBRAS_URL, "/vlibras-plugin.js");
    script.onload = function () {
        var VLibras = window['VLibras'];
        if (isVLibras(VLibras)) {
            new VLibras.Widget({ rootPath: VLIBRAS_URL });
        }
        var windowOnLoad = window === null || window === void 0 ? void 0 : window['onload'];
        windowOnLoad === null || windowOnLoad === void 0 ? void 0 : windowOnLoad();
        clearTimeout(timeoutToOpen);
        timeoutToOpen = setTimeout(function () { return div_vw_access_button.click(); }, OPEN_TIMEOUT_DELAY);
    };
    div_vw_plugin_wrapper.append(div_vw_plugin_top_wrapper);
    div_vw.append(div_vw_access_button, div_vw_plugin_wrapper);
    document.body.append(div_vw, script);
}
function getElement() {
    return document.querySelector("div[data-type=\"".concat(TYPE, "\"][data-design-system=\"BaSe@").concat(version, "\"]"));
}
function notInjected() {
    return !getElement();
}
function elementEnabled() {
    var _a, _b;
    return (_b = (_a = getElement()) === null || _a === void 0 ? void 0 : _a.classList.contains('enabled')) !== null && _b !== void 0 ? _b : false;
}
function showElement() {
    clearTimeout(timeoutToOpen);
    var wrapper = getElement();
    if (wrapper) {
        wrapper.classList.toggle('enabled');
        var accessButton_1 = wrapper.querySelector('[vw-access-button]');
        timeoutToOpen = setTimeout(function () {
            accessButton_1 === null || accessButton_1 === void 0 ? void 0 : accessButton_1.click();
        }, OPEN_TIMEOUT_DELAY);
    }
}
function hideElement() {
    clearTimeout(timeoutToOpen);
    var wrapper = getElement();
    if (wrapper) {
        var accessButton = wrapper.querySelector('[vw-access-button]');
        var accessButtonActive = accessButton === null || accessButton === void 0 ? void 0 : accessButton.classList.contains('active');
        if (!accessButtonActive) {
            var closeButton = wrapper.querySelector('.vpw-settings-btn-close');
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.click();
        }
        wrapper.classList.toggle('enabled');
    }
}
function addVLibras() {
    if (notInjected()) {
        return inject();
    }
    showElement();
}
function removeVLibras() {
    hideElement();
}
function useVLibras() {
    var toggleVLibras = React.useCallback(function () { return (elementEnabled() ? removeVLibras() : addVLibras()); }, []);
    return {
        toggleVLibras: toggleVLibras,
    };
}

var nonCssZoomPropertyKeys = [
    'transform',
    'webkit-transform',
    'moz-transform',
    'ms-transform',
    'o-transform',
];
var nonCssZoomPropertyValue = function (value) { return function (property) {
    return (document.body.style[property] = "scale(".concat(value, ")"));
}; };
function supportsCssZoom() {
    var _a, _b;
    return (_b = (_a = CSS === null || CSS === void 0 ? void 0 : CSS.supports) === null || _a === void 0 ? void 0 : _a.call(CSS, 'zoom: 1')) !== null && _b !== void 0 ? _b : false;
}
function rawNonCssZoomValue(rawValue) {
    if (!rawValue) {
        return undefined;
    }
    return parseFloat(rawValue.replace(/[scale()]/g, ''));
}
function getZoom() {
    var _a;
    var zoom = supportsCssZoom()
        ? +((_a = document.body.style) === null || _a === void 0 ? void 0 : _a['zoom'])
        : nonCssZoomPropertyKeys.reduce(function (value, property) {
            var _a;
            return value && !isNaN(value)
                ? value
                : rawNonCssZoomValue((_a = document.body.style) === null || _a === void 0 ? void 0 : _a[property]);
        }, undefined);
    return zoom || 1;
}
function setZoom(value) {
    if (supportsCssZoom()) {
        document.body.style['zoom'] = value;
        return;
    }
    nonCssZoomPropertyKeys.forEach(nonCssZoomPropertyValue(value));
}
function maxZoom(zoom, max) {
    var diff = supportsCssZoom() ? 0.5 : 0.25;
    return zoom >= max ? max : zoom + diff;
}
function minZoom(zoom, min) {
    var diff = supportsCssZoom() ? 0.5 : 0.25;
    return zoom <= min ? min : zoom - diff;
}
function bodyZoomIn(max) {
    setZoom(maxZoom(getZoom(), max));
}
function bodyZoomOut(min) {
    setZoom(minZoom(getZoom(), min));
}
var selectedContrastModeIndicator = 'x';
var unselectedContrastModeIndicator = '-';
function useA11yCtrl(_a) {
    var 
    // TODO Colocar as opções padrões depois que tiver resolvido o uso com o provedor de tema
    // contrastModeOptions =  ['off', 'on', 'high'],
    _b = _a.contrastModeOptions, 
    // TODO Colocar as opções padrões depois que tiver resolvido o uso com o provedor de tema
    // contrastModeOptions =  ['off', 'on', 'high'],
    contrastModeOptions = _b === void 0 ? [] : _b, _c = _a.zoomOptions, zoomOptions = _c === void 0 ? { min: 1, max: 2 } : _c, _d = _a.useDefaultToggleLibras, useDefaultToggleLibras = _d === void 0 ? true : _d, _e = _a.useDefaultToggleContrastMode, useDefaultToggleContrastMode = _e === void 0 ? true : _e, _f = _a.useDefaultZoomIn, useDefaultZoomIn = _f === void 0 ? true : _f, _g = _a.useDefaultZoomOut, useDefaultZoomOut = _g === void 0 ? true : _g, onToggleContrastMode = _a.onToggleContrastMode, onToggleLibras = _a.onToggleLibras, onZoomIn = _a.onZoomIn, onZoomOut = _a.onZoomOut;
    var toggleVLibras = useVLibras().toggleVLibras;
    var _h = React.useState(false), shownLibras = _h[0], setShownLibras = _h[1];
    var _j = React.useState(0), contrastMode = _j[0], setContrastMode = _j[1];
    var contrastModeIndicator = React.useMemo(function () {
        return contrastModeOptions.map(function (_, mode) {
            return mode === contrastMode
                ? selectedContrastModeIndicator
                : unselectedContrastModeIndicator;
        });
    }, [contrastMode, contrastModeOptions]);
    var toggleLibras = React.useCallback(function () {
        if (useDefaultToggleLibras) {
            toggleVLibras();
        }
        setShownLibras(function (i) { return !i; });
    }, [useDefaultToggleLibras, toggleVLibras]);
    var toggleContrastMode = React.useCallback(function () {
        setContrastMode(function (actual) {
            var next = actual + 1;
            return next >= contrastModeOptions.length ? 0 : next;
        });
    }, [contrastModeOptions]);
    var zoomIn = React.useCallback(function () {
        if (useDefaultZoomIn) {
            bodyZoomIn(zoomOptions.max);
        }
        onZoomIn === null || onZoomIn === void 0 ? void 0 : onZoomIn();
    }, [useDefaultZoomIn, zoomOptions.max]);
    var zoomOut = React.useCallback(function () {
        if (useDefaultZoomOut) {
            bodyZoomOut(zoomOptions.min);
        }
        onZoomOut === null || onZoomOut === void 0 ? void 0 : onZoomOut();
    }, [useDefaultZoomOut, zoomOptions.min]);
    React.useEffect(function () {
        if (!contrastModeOptions.length) {
            return;
        }
        document.body.style['-moz-transform-origin'] = 'left center';
        document.body.style['transform-origin'] = 'left center';
        onToggleContrastMode === null || onToggleContrastMode === void 0 ? void 0 : onToggleContrastMode(contrastModeOptions[contrastMode]);
    }, [
        contrastMode,
        useDefaultToggleContrastMode,
        contrastModeOptions,
        onToggleContrastMode,
    ]);
    React.useEffect(function () {
        onToggleLibras === null || onToggleLibras === void 0 ? void 0 : onToggleLibras(shownLibras);
    }, [shownLibras, onToggleLibras]);
    return {
        contrastModeIndicator: contrastModeIndicator,
        toggleContrastMode: toggleContrastMode,
        toggleLibras: toggleLibras,
        zoomIn: zoomIn,
        zoomOut: zoomOut,
    };
}

var BaSeLogoSebraeRestrictInverse = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--logo-sebrae-restrict-inverse", description: "Logotipo do Sebrae", path: getLogoPath(easterEgg, 'images/logos/sebrae_logo-restrict-inverse'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebraeRestrictInverse.displayName = 'BaSeLogoSebraeRestrictInverse';

var BarWrapper = styled.section.attrs({
    className: 'BaSe--a11y-bar',
})(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n  padding: 0 0.5em;\n  width: calc(100% - 1em);\n  background-color: ", ";\n"], ["\n  padding: 0 0.5em;\n  width: calc(100% - 1em);\n  background-color: ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
});
var ItemWrapper = styled.div.attrs({
    className: 'BaSe--a11y-bar-item',
})(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.25em;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.25em;\n"])));
var ItemSeparator = styled.hr(templateObject_3$z || (templateObject_3$z = __makeTemplateObject(["\n  height: 1.23em;\n  width: 1px;\n  border: none;\n  background-color: ", ";\n"], ["\n  height: 1.23em;\n  width: 1px;\n  border: none;\n  background-color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var InvisibleButton = styled.button.attrs({
    type: 'button',
})(templateObject_5$o || (templateObject_5$o = __makeTemplateObject(["\n  &,\n  &:hover,\n  &:focus,\n  &:active {\n    appearance: none;\n    outline: none;\n    border: none;\n    background: transparent;\n    padding: 0;\n    margin: 0;\n    line-height: 1.23em;\n\n    ", "\n  }\n"], ["\n  &,\n  &:hover,\n  &:focus,\n  &:active {\n    appearance: none;\n    outline: none;\n    border: none;\n    background: transparent;\n    padding: 0;\n    margin: 0;\n    line-height: 1.23em;\n\n    ", "\n  }\n"])), function (_a) {
    var onClick = _a.onClick;
    return onClick && css(templateObject_4$u || (templateObject_4$u = __makeTemplateObject(["\n        cursor: pointer;\n      "], ["\n        cursor: pointer;\n      "])));
});
var OptionsWrapper = styled.div.attrs({
    className: 'BaSe--a11y-bar-options',
})(templateObject_8$j || (templateObject_8$j = __makeTemplateObject(["\n  position: absolute;\n  top: 2em;\n  left: 0;\n  width: 17.5em;\n  border-radius: 0.25em;\n  box-sizing: border-box;\n  background: ", ";\n  z-index: ", ";\n  transition: ", ";\n  /* padding: 1.25em 1em; */\n  border: 1px solid ", ";\n  ", ";\n"], ["\n  position: absolute;\n  top: 2em;\n  left: 0;\n  width: 17.5em;\n  border-radius: 0.25em;\n  box-sizing: border-box;\n  background: ", ";\n  z-index: ", ";\n  transition: ", ";\n  /* padding: 1.25em 1em; */\n  border: 1px solid ", ";\n  ", ";\n"])), function (_a) {
    var background = _a.background;
    return background;
}, BaSeTheme.stackOrder.aboveOverlay, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var border = _a.border;
    return border;
}, function (_a) {
    var isVisible = _a.isVisible;
    return isVisible
        ? css(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n          height: auto;\n          /* overflow: auto; */\n          box-shadow: ", ";\n          opacity: 1;\n        "], ["\n          height: auto;\n          /* overflow: auto; */\n          box-shadow: ", ";\n          opacity: 1;\n        "])), BaSeTheme.shadows.profundidade8) : css(templateObject_7$k || (templateObject_7$k = __makeTemplateObject(["\n          height: 0;\n          padding: 0;\n          overflow: hidden;\n          border: none;\n          opacity: 0;\n        "], ["\n          height: 0;\n          padding: 0;\n          overflow: hidden;\n          border: none;\n          opacity: 0;\n        "])));
});
var OptionsTriangle = styled.div(templateObject_10$f || (templateObject_10$f = __makeTemplateObject(["\n  z-index: ", ";\n  position: absolute;\n  transform: rotate(45deg);\n  width: 0.5em;\n  height: 0.5em;\n  top: -5.5px;\n  ", "\n"], ["\n  z-index: ", ";\n  position: absolute;\n  transform: rotate(45deg);\n  width: 0.5em;\n  height: 0.5em;\n  top: -5.5px;\n  ", "\n"])), BaSeTheme.stackOrder.normal + 1, function (_a) {
    var background = _a.background, border = _a.border, left = _a.left;
    return css(templateObject_9$h || (templateObject_9$h = __makeTemplateObject(["\n    background-color: ", ";\n    border-top: 1px solid ", ";\n    border-left: 1px solid ", ";\n    border-top-left-radius: 0.125em;\n    left: ", ";\n  "], ["\n    background-color: ", ";\n    border-top: 1px solid ", ";\n    border-left: 1px solid ", ";\n    border-top-left-radius: 0.125em;\n    left: ", ";\n  "])), background, border, border, left !== null && left !== void 0 ? left : 'calc(50% - 1.2em)');
});
var AccessButton = styled.button.attrs({
    type: 'button',
    className: 'BaSe--a11y-bar-button',
})(templateObject_13$b || (templateObject_13$b = __makeTemplateObject(["\n  font-size: 16px;\n  border-radius: 0.25em;\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n  place-items: center;\n  width: 7.25em;\n  height: 7.25em;\n  gap: 1.5em;\n  padding: 0.75em 1em;\n  box-sizing: border-box;\n  cursor: pointer;\n  ", "\n  ", "\n"], ["\n  font-size: 16px;\n  border-radius: 0.25em;\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n  place-items: center;\n  width: 7.25em;\n  height: 7.25em;\n  gap: 1.5em;\n  padding: 0.75em 1em;\n  box-sizing: border-box;\n  cursor: pointer;\n  ", "\n  ", "\n"])), function (_a) {
    var background = _a.background, primaryColor = _a.primaryColor, activeColor = _a.activeColor, isDisabled = _a.isDisabled;
    return !isDisabled && css(templateObject_11$d || (templateObject_11$d = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n    "])), background, primaryColor, activeColor);
}, function (_a) {
    var isDisabled = _a.isDisabled, disabledBackgroundColor = _a.disabledBackgroundColor, disabledPrimaryColor = _a.disabledPrimaryColor;
    return isDisabled && css(templateObject_12$c || (templateObject_12$c = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n      cursor: not-allowed;\n    "])), disabledBackgroundColor, disabledPrimaryColor);
});
var OptionFlex = styled.div(templateObject_14$b || (templateObject_14$b = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25em 1em 0;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25em 1em 0;\n"])));
var GridAcessButton = styled.div(templateObject_15$a || (templateObject_15$a = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 1em;\n  padding: 1.25em 1em;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 1em;\n  padding: 1.25em 1em;\n"])));
var AcessButtonPrefix = styled.span(templateObject_17$8 || (templateObject_17$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isVisible = _a.isVisible;
    return !isVisible && css(templateObject_16$9 || (templateObject_16$9 = __makeTemplateObject(["\n      visibility: hidden;\n    "], ["\n      visibility: hidden;\n    "])));
});
var ContrastControl = styled.span(templateObject_18$5 || (templateObject_18$5 = __makeTemplateObject(["\n  display: flex;\n  gap: 0.25em;\n  align-items: center;\n"], ["\n  display: flex;\n  gap: 0.25em;\n  align-items: center;\n"])));
var ContrastLevel = styled.span(templateObject_20$5 || (templateObject_20$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var background = _a.background, border = _a.border;
    return css(templateObject_19$5 || (templateObject_19$5 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    background-color: ", ";\n    width: 6px;\n    height: 6px;\n    border-radius: 12px;\n    transition: ", ";\n  "], ["\n    border: 1px solid ", ";\n    background-color: ", ";\n    width: 6px;\n    height: 6px;\n    border-radius: 12px;\n    transition: ", ";\n  "])), border, background, BaSeTheme.transitions.allPropertiesContinuousFast);
});
var LanguageList = styled.div(templateObject_21$4 || (templateObject_21$4 = __makeTemplateObject(["\n  max-height: 17.5em;\n  padding: 0.675em 1em 1.25em;\n  margin: 0.675em 0 0 0;\n  overflow: auto;\n"], ["\n  max-height: 17.5em;\n  padding: 0.675em 1em 1.25em;\n  margin: 0.675em 0 0 0;\n  overflow: auto;\n"])));
var templateObject_1$K, templateObject_2$F, templateObject_3$z, templateObject_4$u, templateObject_5$o, templateObject_6$n, templateObject_7$k, templateObject_8$j, templateObject_9$h, templateObject_10$f, templateObject_11$d, templateObject_12$c, templateObject_13$b, templateObject_14$b, templateObject_15$a, templateObject_16$9, templateObject_17$8, templateObject_18$5, templateObject_19$5, templateObject_20$5, templateObject_21$4;

var _a$2 = BaSeTheme.colors.institucionais, azulSebrae$1 = _a$2.azulSebrae, cinzaSebrae97 = _a$2.cinzaSebrae97, cinzaSebrae90 = _a$2.cinzaSebrae90, cinzaSebrae75 = _a$2.cinzaSebrae75, cinzaSebrae30 = _a$2.cinzaSebrae30, azulSebrae90 = _a$2.azulSebrae90;
var white$2 = BaSeTheme.colors.defaultColors.white;
var locales = Object.keys(BaSeLocaleWithLanguages);
var localeWithLanguages = Object.entries(BaSeLocaleWithLanguages);
var BaSeA11yBar = function (_a) {
    var delimitedOnBreakpoint = _a.delimitedOnBreakpoint, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? cinzaSebrae90 : _b, _c = _a.titleColor, titleColor = _c === void 0 ? azulSebrae$1 : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? cinzaSebrae30 : _d, _e = _a.optionsBackgroundColor, optionsBackgroundColor = _e === void 0 ? white$2 : _e, _f = _a.optionsForegroundColor, optionsForegroundColor = _f === void 0 ? azulSebrae$1 : _f, _g = _a.disabledOptionBackgroundColor, disabledOptionBackgroundColor = _g === void 0 ? cinzaSebrae97 : _g, _h = _a.disabledOptionPrimaryColor, disabledOptionPrimaryColor = _h === void 0 ? cinzaSebrae75 : _h, _j = _a.iconColor, iconColor = _j === void 0 ? cinzaSebrae75 : _j, _k = _a.logoInverseColor, logoInverseColor = _k === void 0 ? false : _k, _l = _a.localeLanguageOptions, localeLanguageOptions = _l === void 0 ? localeWithLanguages : _l, _m = _a.borderColor, borderColor = _m === void 0 ? azulSebrae90 : _m, _o = _a.closeMenuColor, closeMenuColor = _o === void 0 ? azulSebrae$1 : _o, 
    // localeLanguageOptions = [],
    _p = _a.useDefaultChangeLocaleLanguage, 
    // localeLanguageOptions = [],
    useDefaultChangeLocaleLanguage = _p === void 0 ? true : _p, localeLanguageColorOption = _a.localeLanguageColorOption, onChangeLocaleLanguage = _a.onChangeLocaleLanguage, logoOnClick = _a.logoOnClick, renderLogo = _a.renderLogo, a11yCtrl = __rest(_a, ["delimitedOnBreakpoint", "backgroundColor", "titleColor", "foregroundColor", "optionsBackgroundColor", "optionsForegroundColor", "disabledOptionBackgroundColor", "disabledOptionPrimaryColor", "iconColor", "logoInverseColor", "localeLanguageOptions", "borderColor", "closeMenuColor", "useDefaultChangeLocaleLanguage", "localeLanguageColorOption", "onChangeLocaleLanguage", "logoOnClick", "renderLogo"]);
    var _q = React.useContext(BaSeI18nContext), getMessage = _q.getMessage, changeLocale = _q.changeLocale;
    var a11yOptionsRef = React.createRef();
    var localeLanguageOptionsRef = React.createRef();
    var _r = React.useState(), selectedLocaleLanguage = _r[0], setSelectedLocaleLanguage = _r[1];
    var _s = React.useState(false), shownA11yOptions = _s[0], setShownA11yOptions = _s[1];
    var _t = React.useState(false), shownLocaleLanguageOptions = _t[0], setShownLocaleLanguageOptions = _t[1];
    var _u = React.useMemo(function () { return selectedLocaleLanguage !== null && selectedLocaleLanguage !== void 0 ? selectedLocaleLanguage : [undefined, undefined]; }, [selectedLocaleLanguage]), selectedLocale = _u[0], selectedLanguage = _u[1];
    var _v = useA11yCtrl(a11yCtrl), contrastModeIndicator = _v.contrastModeIndicator, toggleContrastMode = _v.toggleContrastMode, toggleLibras = _v.toggleLibras, zoomIn = _v.zoomIn, zoomOut = _v.zoomOut;
    var focusColors = React.useMemo(function () { return ColorMapper.createTransparent(optionsForegroundColor, 0.6, 0.14); }, [optionsForegroundColor]);
    var displayContrastLevel = React.useCallback(function () {
        return (React.createElement(React.Fragment, null, contrastModeIndicator.map(function (cont, key) { return (React.createElement(ContrastLevel, { key: key, background: cont === 'x' ? optionsForegroundColor : 'transparent', border: cont === 'x' ? optionsForegroundColor : iconColor })); })));
    }, [contrastModeIndicator, iconColor, optionsForegroundColor]);
    var getColor = React.useCallback(function (isDisabled, defaultColor, disabledColor) { return (isDisabled ? disabledColor : defaultColor); }, []);
    useOutsideEvent(a11yOptionsRef, setShownA11yOptions);
    useOutsideEvent(localeLanguageOptionsRef, setShownLocaleLanguageOptions);
    React.useEffect(function () {
        if (!localeLanguageOptions.length) {
            return;
        }
        if (!useDefaultChangeLocaleLanguage || !selectedLocale) {
            return;
        }
        if (locales.includes(selectedLocale)) {
            changeLocale(selectedLocale);
        }
    }, [
        localeLanguageOptions,
        selectedLocale,
        changeLocale,
        useDefaultChangeLocaleLanguage,
    ]);
    React.useEffect(function () {
        if (!selectedLocaleLanguage) {
            return;
        }
        onChangeLocaleLanguage === null || onChangeLocaleLanguage === void 0 ? void 0 : onChangeLocaleLanguage(selectedLocaleLanguage);
    }, [selectedLocaleLanguage, onChangeLocaleLanguage]);
    React.useEffect(function () {
        if (!localeLanguageOptions.length) {
            return;
        }
        setSelectedLocaleLanguage(localeLanguageOptions[0]);
    }, [localeLanguageOptions]);
    return (React.createElement(BarWrapper, { backgroundColor: backgroundColor },
        React.createElement(BaSeContainer, { delimitedOnBreakpoint: delimitedOnBreakpoint, style: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(ItemWrapper, null,
                React.createElement(ItemWrapper, { ref: a11yOptionsRef },
                    React.createElement(BaSeIcon, { name: "accessibility", size: "1.25em", color: iconColor, description: getMessage('icon.label', getMessage('a11yBar.accessibility')) }),
                    React.createElement(BaSeSmall1, { isBold: true, color: foregroundColor }, getMessage('a11yBar.accessibility')),
                    React.createElement(BaSeIconButton, { nameIcon: "angle-down", descriptionIcon: getMessage('buttonIcon.iconDescription.options'), color: iconColor, type: shownA11yOptions ? 'primary' : 'tertiary', size: "small", onClick: function () { return setShownA11yOptions(function (i) { return !i; }); } }),
                    React.createElement(OptionsWrapper, { isVisible: shownA11yOptions, border: borderColor, background: optionsBackgroundColor },
                        React.createElement(OptionsTriangle, { isVisible: shownA11yOptions, border: borderColor, background: optionsBackgroundColor }),
                        React.createElement(OptionFlex, null,
                            React.createElement(BaSeParagraph, { isBold: true, color: titleColor }, getMessage('a11yBar.accessibility')),
                            React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), type: "tertiary", size: "small", color: closeMenuColor, onClick: function () { return setShownA11yOptions(false); } })),
                        React.createElement(GridAcessButton, null,
                            React.createElement(AccessButton, { disabledBackgroundColor: disabledOptionBackgroundColor, disabledPrimaryColor: disabledOptionPrimaryColor, type: "button", background: optionsBackgroundColor, primaryColor: optionsForegroundColor, activeColor: focusColors, isDisabled: !onChangeLocaleLanguage, onClick: function () { return toggleContrastMode(); } },
                                React.createElement(AcessButtonPrefix, { isVisible: true },
                                    React.createElement(ContrastControl, null, displayContrastLevel())),
                                React.createElement(BaSeIcon, { description: "contraste", name: "constrast", color: getColor(!onChangeLocaleLanguage, optionsForegroundColor, disabledOptionPrimaryColor), size: 16 }),
                                React.createElement(BaSeSmall2, { color: getColor(!onChangeLocaleLanguage, optionsForegroundColor, disabledOptionPrimaryColor) }, "Alto contraste")),
                            React.createElement(AccessButton, { disabledBackgroundColor: disabledOptionBackgroundColor, disabledPrimaryColor: disabledOptionPrimaryColor, type: "button", background: optionsBackgroundColor, primaryColor: optionsForegroundColor, activeColor: focusColors, isDisabled: false, onClick: function () { return toggleLibras(); } },
                                React.createElement(AcessButtonPrefix, { isVisible: false }),
                                React.createElement(BaSeIcon, { description: "contraste", name: "libras-1", color: optionsForegroundColor, size: 16 }),
                                React.createElement(BaSeSmall2, { color: optionsForegroundColor }, "Libras")),
                            React.createElement(AccessButton, { disabledBackgroundColor: disabledOptionBackgroundColor, disabledPrimaryColor: disabledOptionPrimaryColor, type: "button", background: optionsBackgroundColor, primaryColor: optionsForegroundColor, activeColor: focusColors, isDisabled: false, onClick: function () { return zoomIn(); } },
                                React.createElement(AcessButtonPrefix, { isVisible: false }),
                                React.createElement(BaSeIcon, { description: "contraste", name: "search-plus", color: optionsForegroundColor, size: 16 }),
                                React.createElement(BaSeSmall2, { color: optionsForegroundColor }, "zoom +")),
                            React.createElement(AccessButton, { disabledBackgroundColor: disabledOptionBackgroundColor, disabledPrimaryColor: disabledOptionPrimaryColor, type: "button", background: optionsBackgroundColor, primaryColor: optionsForegroundColor, activeColor: focusColors, isDisabled: false, onClick: function () { return zoomOut(); } },
                                React.createElement(AcessButtonPrefix, { isVisible: false }),
                                React.createElement(BaSeIcon, { description: "contraste", name: "search-minus", color: optionsForegroundColor, size: 16 }),
                                React.createElement(BaSeSmall2, { color: optionsForegroundColor }, "zoom -"))))),
                selectedLanguage && (React.createElement(React.Fragment, null,
                    React.createElement(ItemSeparator, { color: iconColor }),
                    React.createElement(ItemWrapper, { ref: localeLanguageOptionsRef },
                        React.createElement(BaSeIcon, { name: "globe", size: "1.25em", color: iconColor, description: getMessage('icon.label', selectedLanguage) }),
                        React.createElement(BaSeSmall1, { isBold: true, color: foregroundColor }, selectedLanguage),
                        React.createElement(BaSeIconButton, { nameIcon: "angle-down", descriptionIcon: getMessage('buttonIcon.iconDescription.options'), color: iconColor, type: shownLocaleLanguageOptions ? 'primary' : 'tertiary', size: "small", onClick: function () { return setShownLocaleLanguageOptions(function (i) { return !i; }); } }),
                        React.createElement(OptionsWrapper, { hasScroll: true, border: borderColor, isVisible: shownLocaleLanguageOptions, background: optionsBackgroundColor },
                            React.createElement(OptionsTriangle, { left: "25%", isVisible: shownA11yOptions, border: borderColor, background: optionsBackgroundColor }),
                            React.createElement(OptionFlex, null,
                                React.createElement(BaSeParagraph, { isBold: true, color: titleColor }, getMessage('a11yBar.language')),
                                React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), color: closeMenuColor, type: "tertiary", size: "small", onClick: function () { return setShownLocaleLanguageOptions(false); } })),
                            React.createElement(LanguageList, null, localeLanguageOptions.map(function (_a) {
                                var locale = _a[0], language = _a[1];
                                return (
                                // <button
                                //   key={locale}
                                //   type="button"
                                //   onClick={() =>
                                //     setSelectedLocaleLanguage([locale, language])
                                //   }
                                // >
                                //   {language}
                                // </button>
                                React.createElement(React.Fragment, { key: language },
                                    React.createElement(BaSeButton, { color: localeLanguageColorOption, type: "tertiary", value: language, onClick: function () {
                                            return setSelectedLocaleLanguage([locale, language]);
                                        } })));
                            }))))))),
            React.createElement(ItemWrapper, null, renderLogo ? (renderLogo()) : (React.createElement(React.Fragment, null,
                logoInverseColor ? (React.createElement(BaSeLogoSebraeRestrictInverse, { width: "0.75em", onClick: logoOnClick })) : (React.createElement(BaSeLogoSebraeRestrict, { width: "0.75em", onClick: logoOnClick })),
                React.createElement(InvisibleButton, { onClick: logoOnClick },
                    React.createElement(BaSeSmall1, { isBold: true, color: logoInverseColor ? white$2 : azulSebrae$1 }, "Sebrae"))))))));
};
BaSeA11yBar.displayName = 'BaSeA11yBar';

var BaSeLogoSebrae = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--logo-sebrae", description: getMessage('logo.description'), path: getLogoPath(easterEgg, 'images/logos/sebrae_logo'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebrae.displayName = 'BaSeLogoSebrae';

var BaSeLogoSebraeInverse = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--logo-sebrae-inverse", description: getMessage('logo.description'), path: getLogoPath(easterEgg, 'images/logos/sebrae_logo-inverse'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebraeInverse.displayName = 'BaSeLogoSebraeInverse';

var SingleSolutionGrid = styled.div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  display: grid;\n  gap: 0.75em;\n  grid-template-columns: 40px 1fr;\n"], ["\n  display: grid;\n  gap: 0.75em;\n  grid-template-columns: 40px 1fr;\n"])));
var SystemLogo = styled.img(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n  width: 2.5em;\n  height: 2.5em;\n  min-width: 2.5em;\n  min-height: 2.5em;\n  border-radius: 1.25em;\n  box-shadow: ", ";\n"], ["\n  width: 2.5em;\n  height: 2.5em;\n  min-width: 2.5em;\n  min-height: 2.5em;\n  border-radius: 1.25em;\n  box-shadow: ", ";\n"])), BaSeTheme.shadows.profundidade2);
var SystemLogoWrapper = styled.div(templateObject_3$y || (templateObject_3$y = __makeTemplateObject(["\n  width: 2.5em;\n  height: 2.5em;\n  min-width: 2.5em;\n  min-height: 2.5em;\n  border-radius: 1.25em;\n  box-shadow: ", ";\n  display: grid;\n  place-items: center;\n\n  img {\n    width: 20px;\n    height: 10px;\n  }\n"], ["\n  width: 2.5em;\n  height: 2.5em;\n  min-width: 2.5em;\n  min-height: 2.5em;\n  border-radius: 1.25em;\n  box-shadow: ", ";\n  display: grid;\n  place-items: center;\n\n  img {\n    width: 20px;\n    height: 10px;\n  }\n"])), BaSeTheme.shadows.profundidade2);
var SingleInfoWrapper = styled.div(templateObject_4$t || (templateObject_4$t = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var templateObject_1$J, templateObject_2$E, templateObject_3$y, templateObject_4$t;

var SINGLE_LINE_HEIGHT = 17;
var CHARACTER_INFO_COUNT = 50;
var CHARACTER_TITLE_COUNT = 30;
var MAX_LINE_COUNT_DESCRIPTION = 3;
var MAX_LINE_COUNT_TITLE = 2;
var cinzaSebrae45$1 = BaSeTheme.colors.institucionais.cinzaSebrae45;
var BaSeSingleSolution = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.description, description = _c === void 0 ? '' : _c, _d = _a.image, image = _d === void 0 ? '' : _d, isVisible = _a.isVisible, _e = _a.textColor, textColor = _e === void 0 ? cinzaSebrae45$1 : _e;
    var _f = React.useState(false), isContentReduced = _f[0], setIsContentReduced = _f[1];
    var _g = React.useState(false), isTitleReduced = _g[0], setIsTitleReduced = _g[1];
    var titleRef = React.useRef(null);
    var descriptionRef = React.useRef(null);
    var renderSystemLogo = React.useCallback(function () {
        if (image) {
            return (React.createElement(SystemLogoWrapper, null,
                React.createElement(SystemLogo, { src: image, alt: title }),
                ";"));
        }
        return (React.createElement(SystemLogoWrapper, null,
            React.createElement(BaSeLogoSebraeRestrict, null)));
    }, [image, title]);
    var handleReduceString = React.useCallback(function (text, amount) {
        return text.substring(0, amount) + '...';
    }, []);
    var reduceDescription = React.useCallback(function () {
        if (isContentReduced) {
            return handleReduceString(description, CHARACTER_INFO_COUNT);
        }
        return description;
    }, [handleReduceString, isContentReduced, description]);
    var reduceTitle = React.useCallback(function () {
        if (isTitleReduced) {
            return handleReduceString(title, CHARACTER_TITLE_COUNT);
        }
        return title;
    }, [handleReduceString, isTitleReduced, title]);
    React.useEffect(function () {
        var _a, _b;
        if (((_b = (_a = descriptionRef === null || descriptionRef === void 0 ? void 0 : descriptionRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) >
            SINGLE_LINE_HEIGHT * MAX_LINE_COUNT_DESCRIPTION &&
            !isContentReduced &&
            isVisible) {
            setIsContentReduced(true);
        }
        if (!isVisible) {
            setIsContentReduced(false);
        }
    }, [isContentReduced, descriptionRef, isVisible]);
    React.useEffect(function () {
        var _a, _b;
        if (((_b = (_a = titleRef === null || titleRef === void 0 ? void 0 : titleRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) >
            SINGLE_LINE_HEIGHT * MAX_LINE_COUNT_TITLE &&
            !isTitleReduced &&
            isVisible) {
            setIsTitleReduced(true);
        }
        if (!isVisible) {
            setIsTitleReduced(false);
        }
    }, [isVisible, titleRef, isTitleReduced]);
    return (React.createElement(SingleSolutionGrid, null,
        renderSystemLogo(),
        React.createElement(SingleInfoWrapper, null,
            React.createElement("div", { ref: titleRef },
                React.createElement(BaSeSmall1, { isBold: true, color: textColor }, reduceTitle())),
            React.createElement("div", { ref: descriptionRef },
                React.createElement(BaSeSmall1, { color: textColor }, reduceDescription())))));
};
BaSeSingleSolution.displayName = 'BaSeSingleSolution';

var SolutionsWrapper = styled.div.attrs({
    className: 'BaSe--User-Apps',
})(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var SolutionsMenu = styled.div.attrs({
    className: 'BaSe--User-Apps-menu',
})(templateObject_4$s || (templateObject_4$s = __makeTemplateObject(["\n  position: absolute;\n  top: 2em;\n  right: -2em;\n  width: 26em;\n  border-radius: 0.25em;\n  box-sizing: border-box;\n  background: ", ";\n  z-index: ", ";\n  transition: ", ";\n  border: 1px solid ", ";\n  ", ";\n"], ["\n  position: absolute;\n  top: 2em;\n  right: -2em;\n  width: 26em;\n  border-radius: 0.25em;\n  box-sizing: border-box;\n  background: ", ";\n  z-index: ", ";\n  transition: ", ";\n  border: 1px solid ", ";\n  ", ";\n"])), function (_a) {
    var background = _a.background;
    return background;
}, BaSeTheme.stackOrder.aboveOverlay, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var border = _a.border;
    return border;
}, function (_a) {
    var isVisible = _a.isVisible;
    return isVisible
        ? css(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n          height: auto;\n          box-shadow: ", ";\n          opacity: 1;\n        "], ["\n          height: auto;\n          box-shadow: ", ";\n          opacity: 1;\n        "])), BaSeTheme.shadows.profundidade8) : css(templateObject_3$x || (templateObject_3$x = __makeTemplateObject(["\n          height: 0;\n          padding: 0;\n          overflow: hidden;\n          border: none;\n          opacity: 0;\n        "], ["\n          height: 0;\n          padding: 0;\n          overflow: hidden;\n          border: none;\n          opacity: 0;\n        "])));
});
styled.div(templateObject_5$n || (templateObject_5$n = __makeTemplateObject(["\n  padding: 24px 22px 12px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding: 24px 22px 12px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var SolutionHeader = styled.div(templateObject_6$m || (templateObject_6$m = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.25em;\n  padding: 1.25em 1em 0;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.25em;\n  padding: 1.25em 1em 0;\n"])));
var SolutionsGrid = styled.div(templateObject_7$j || (templateObject_7$j = __makeTemplateObject(["\n  padding: 1.25em 1em;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 1.5em;\n  row-gap: 1em;\n"], ["\n  padding: 1.25em 1em;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 1.5em;\n  row-gap: 1em;\n"])));
var InformationWrapper = styled.div(templateObject_8$i || (templateObject_8$i = __makeTemplateObject(["\n  padding: 0.75em 1em 0;\n"], ["\n  padding: 0.75em 1em 0;\n"])));
var templateObject_1$I, templateObject_2$D, templateObject_3$x, templateObject_4$s, templateObject_5$n, templateObject_6$m, templateObject_7$j, templateObject_8$i;

var SOLUTIONS_SIZE = 'small';
var SOLUTIONS_TRIANGLE_POSITION = 'calc(100% - 3.5em)';
var white$1 = BaSeTheme.colors.defaultColors.white;
var _a$1 = BaSeTheme.colors.institucionais, azulSebrae97 = _a$1.azulSebrae97, azulSebrae = _a$1.azulSebrae, cinzaSebrae45 = _a$1.cinzaSebrae45;
var BaSeUserApps = function (_a) {
    var _b = _a.iconColor, iconColor = _b === void 0 ? white$1 : _b, _c = _a.iconName, iconName = _c === void 0 ? 'apps' : _c, _d = _a.menuBackgroundColor, menuBackgroundColor = _d === void 0 ? white$1 : _d, _e = _a.menuBorderColor, menuBorderColor = _e === void 0 ? azulSebrae97 : _e, _f = _a.textColor, textColor = _f === void 0 ? cinzaSebrae45 : _f, _g = _a.titleColor, titleColor = _g === void 0 ? azulSebrae : _g, _h = _a.closeMenuColor, closeMenuColor = _h === void 0 ? 'default' : _h, _j = _a.solutions, solutions = _j === void 0 ? [] : _j, title = _a.title, description = _a.description;
    var SolutionsRef = React.useRef(null);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _k = React.useState(false), menuOpen = _k[0], setMenuOpen = _k[1];
    var handleClick = React.useCallback(function () {
        setMenuOpen(true);
    }, []);
    useOutsideEvent(SolutionsRef, setMenuOpen);
    return (React.createElement(SolutionsWrapper, { ref: SolutionsRef },
        React.createElement(BaSeIconButton, { descriptionIcon: getMessage('solutions.title'), type: "tertiary", nameIcon: iconName, color: iconColor, sizeIcon: SOLUTIONS_SIZE, onClick: handleClick }),
        React.createElement(SolutionsMenu, { isVisible: menuOpen, background: menuBackgroundColor, border: menuBorderColor },
            React.createElement(OptionsTriangle, { isVisible: menuOpen, background: menuBackgroundColor, border: menuBorderColor, left: SOLUTIONS_TRIANGLE_POSITION }),
            React.createElement(SolutionHeader, null,
                React.createElement(BaSeHeading5, { color: titleColor }, title !== null && title !== void 0 ? title : getMessage('solutions.title')),
                React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), type: "tertiary", size: "small", color: closeMenuColor, onClick: function () { return setMenuOpen(false); } })),
            !!description && (React.createElement(InformationWrapper, null,
                React.createElement(BaSeSmall1, { color: textColor }, description))),
            React.createElement(SolutionsGrid, null, solutions.map(function (solu) { return (React.createElement(React.Fragment, { key: solu.title },
                React.createElement(BaSeSingleSolution, __assign({}, solu, { isVisible: menuOpen, textColor: textColor })))); })))));
};
BaSeUserApps.displayName = 'BaSeUserApps';

var StyledText = makeDefaultTypographyStyled('Text', 'span', 1, 1.46);

var BaSeText = function (props) { return (React.createElement(BaSeTypographyWrapper, __assign({ fontSize: 1, lineHeight: 1.46, wrapper: StyledText }, props), props.children)); };
BaSeText.displayName = 'BaSeText';

var slideIn$2 = keyframes(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  from {\n    transform: translateX(-100vw);\n  };\n  to {\n    transform: translateX(0);\n  };\n"], ["\n  from {\n    transform: translateX(-100vw);\n  };\n  to {\n    transform: translateX(0);\n  };\n"])));
var slideOut = keyframes(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  from {\n    transform: translateX(0);\n  };\n  to {\n    transform: translateX(-100vw);\n  }\n"], ["\n  from {\n    transform: translateX(0);\n  };\n  to {\n    transform: translateX(-100vw);\n  }\n"])));
var HeaderOutsideContainer = styled.div(templateObject_4$r || (templateObject_4$r = __makeTemplateObject(["\n  min-height: 60px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  ", "\n"], ["\n  min-height: 60px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  ", "\n"])), function (props) { return props.color; }, function (props) {
    return props.hasBoxShadow && css(templateObject_3$w || (templateObject_3$w = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), BaSeTheme.shadows.profundidade4);
});
var HeaderContainer = styled.div(templateObject_9$g || (templateObject_9$g = __makeTemplateObject(["\n  max-width: ", ";\n  width: 100%;\n  display: grid;\n  ", "\n  color: ", ";\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n"], ["\n  max-width: ", ";\n  width: 100%;\n  display: grid;\n  ", "\n  color: ", ";\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n"])), function (props) { return (props.maxWidth ? "".concat(props.maxWidth, "px") : '100%'); }, function (props) {
    return props.mobile && props.hasItems
        ? css(templateObject_5$m || (templateObject_5$m = __makeTemplateObject(["\n          grid-template-columns: 1fr 1fr 1fr;\n        "], ["\n          grid-template-columns: 1fr 1fr 1fr;\n        "]))) : css(templateObject_6$l || (templateObject_6$l = __makeTemplateObject(["\n          grid-template-columns: 1fr auto;\n        "], ["\n          grid-template-columns: 1fr auto;\n        "])));
}, function (props) { return props.textColor; }, function (props) {
    return props.mobile
        ? css(templateObject_7$i || (templateObject_7$i = __makeTemplateObject(["\n          padding: 0 18px 0 10px;\n        "], ["\n          padding: 0 18px 0 10px;\n        "]))) : css(templateObject_8$h || (templateObject_8$h = __makeTemplateObject(["\n          padding: 0 24px;\n        "], ["\n          padding: 0 24px;\n        "])));
});
var HeaderExpandedMenuItemsContainer = styled.ul(templateObject_11$c || (templateObject_11$c = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  height: 21px;\n  align-items: center;\n  padding-right: 25px;\n  height: 100%;\n\n  &:empty {\n    padding-right: 0px;\n    margin-right: 0px;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  height: 21px;\n  align-items: center;\n  padding-right: 25px;\n  height: 100%;\n\n  &:empty {\n    padding-right: 0px;\n    margin-right: 0px;\n  }\n\n  ", "\n"])), function (props) {
    return props.showBorder && css(templateObject_10$e || (templateObject_10$e = __makeTemplateObject(["\n      margin-right: 8px;\n\n      ::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        height: 21px;\n        top: calc(50% - 10.5px);\n        width: 1px;\n        background-color: ", ";\n      }\n    "], ["\n      margin-right: 8px;\n\n      ::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        height: 21px;\n        top: calc(50% - 10.5px);\n        width: 1px;\n        background-color: ", ";\n      }\n    "])), props.color);
});
var HeaderFlex = styled.div(templateObject_15$9 || (templateObject_15$9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  ", "\n  ", "\n  ", ";\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  ", "\n  ", "\n  ", ";\n  ", "\n"])), function (props) {
    return props.alignEnd ? 'flex-end' : props.alignStart ? 'start' : 'center';
}, function (props) {
    return props.alignEnd && css(templateObject_12$b || (templateObject_12$b = __makeTemplateObject(["\n      button {\n        gap: 0;\n      }\n    "], ["\n      button {\n        gap: 0;\n      }\n    "])));
}, function (props) {
    return props.fullWidth && css(templateObject_13$a || (templateObject_13$a = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
}, function (props) { var _a; return "gap: ".concat((_a = props.gap) !== null && _a !== void 0 ? _a : 0, "px"); }, function (props) {
    return props.fullHeight && css(templateObject_14$a || (templateObject_14$a = __makeTemplateObject(["\n      height: 100%;\n    "], ["\n      height: 100%;\n    "])));
});
var HeaderSideMenu = styled.aside.attrs({
    className: 'BaSe--header-side-menu',
})(templateObject_16$8 || (templateObject_16$8 = __makeTemplateObject(["\n  &.BaSe--header-side-menu {\n    background-color: ", ";\n    height: 100%;\n    display: flex;\n    flex-flow: column;\n    gap: 16px;\n    padding: 16px;\n    h5 {\n      margin-bottom: 16px;\n    }\n  }\n"], ["\n  &.BaSe--header-side-menu {\n    background-color: ", ";\n    height: 100%;\n    display: flex;\n    flex-flow: column;\n    gap: 16px;\n    padding: 16px;\n    h5 {\n      margin-bottom: 16px;\n    }\n  }\n"])), function (props) { return props.sidebarBackgroundColor; });
var HeaderCollapsedContainer = styled.div(templateObject_17$7 || (templateObject_17$7 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100vw;\n  min-height: 100vh;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100vw;\n  min-height: 100vh;\n"])), BaSeTheme.stackOrder.overlay + 2);
var HeaderCollapsedTransparentContainer = styled.div(templateObject_18$4 || (templateObject_18$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.5;\n  width: 100vw;\n  height: 100vh;\n  z-index: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.5;\n  width: 100vw;\n  height: 100vh;\n  z-index: ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae20, BaSeTheme.stackOrder.overlay + 3);
var HeaderCollapsedContent = styled.div(templateObject_21$3 || (templateObject_21$3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100vw - 56px);\n  height: 100vh;\n  z-index: ", ";\n  ", ";\n\n  &.closed {\n    ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100vw - 56px);\n  height: 100vh;\n  z-index: ", ";\n  ", ";\n\n  &.closed {\n    ", ";\n  }\n"])), BaSeTheme.stackOrder.overlay + 4, css(templateObject_19$4 || (templateObject_19$4 = __makeTemplateObject(["\n    animation: ", " ", "\n      ", ";\n  "], ["\n    animation: ", " ", "\n      ", ";\n  "])), slideIn$2, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction), css(templateObject_20$4 || (templateObject_20$4 = __makeTemplateObject(["\n      animation: ", " ", "\n        ", ";\n    "], ["\n      animation: ", " ", "\n        ", ";\n    "])), slideOut, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction));
var HeaderCollapsedMenuItemNonNav = styled.div(templateObject_22$3 || (templateObject_22$3 = __makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
var HeaderCollapsedMenuItemContainer = styled.li(templateObject_25$3 || (templateObject_25$3 = __makeTemplateObject(["\n  ", ";\n  position: relative;\n  animation-delay: ", "ms;\n  animation-fill-mode: both;\n  margin: 0.5em 0;\n\n  ", "\n"], ["\n  ", ";\n  position: relative;\n  animation-delay: ", "ms;\n  animation-fill-mode: both;\n  margin: 0.5em 0;\n\n  ", "\n"])), css(templateObject_23$3 || (templateObject_23$3 = __makeTemplateObject(["\n    animation: ", " ", "\n      ", ";\n  "], ["\n    animation: ", " ", "\n      ", ";\n  "])), slideIn$2, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction), function (props) { return props.delay; }, function (_a) {
    var hasClick = _a.hasClick, color = _a.color;
    return hasClick && css(templateObject_24$3 || (templateObject_24$3 = __makeTemplateObject(["\n      cursor: pointer;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        height: 0;\n      }\n\n      &::after {\n        top: 0;\n        width: 1px;\n        left: -16px;\n      }\n\n      &::before {\n        bottom: 0;\n        left: -16px;\n        width: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          height: 100%;\n        }\n      }\n\n      &:hover::before {\n        height: 100%;\n      }\n    "], ["\n      cursor: pointer;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        height: 0;\n      }\n\n      &::after {\n        top: 0;\n        width: 1px;\n        left: -16px;\n      }\n\n      &::before {\n        bottom: 0;\n        left: -16px;\n        width: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          height: 100%;\n        }\n      }\n\n      &:hover::before {\n        height: 100%;\n      }\n    "])), BaSeTheme.transitions.durationNormal, color);
});
var HeaderMenuIconContainer = styled.div(templateObject_26$3 || (templateObject_26$3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"])));
var HeaderCloseIconContent = styled.div(templateObject_27$3 || (templateObject_27$3 = __makeTemplateObject(["\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: ", ";\n\n  button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: ", ";\n\n  button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: ", ";\n  }\n"])), BaSeTheme.stackOrder.normal + 1, BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (_a) {
    var buttonBackgroundColor = _a.buttonBackgroundColor;
    return buttonBackgroundColor;
});
var HeaderExpandedMenuItemContainer = styled.li(templateObject_29$3 || (templateObject_29$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var onClick = _a.onClick, color = _a.color;
    return onClick && css(templateObject_28$3 || (templateObject_28$3 = __makeTemplateObject(["\n      cursor: pointer;\n      position: relative;\n      height: 100%;\n      display: flex;\n      flex-flow: column;\n      justify-content: center;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        width: 0;\n      }\n\n      &::after {\n        left: 0;\n        bottom: 0px;\n        height: 1px;\n      }\n\n      &::before {\n        right: 0;\n        bottom: 0;\n        height: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          width: 100%;\n        }\n      }\n\n      &:hover::before {\n        width: 100%;\n      }\n    "], ["\n      cursor: pointer;\n      position: relative;\n      height: 100%;\n      display: flex;\n      flex-flow: column;\n      justify-content: center;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        width: 0;\n      }\n\n      &::after {\n        left: 0;\n        bottom: 0px;\n        height: 1px;\n      }\n\n      &::before {\n        right: 0;\n        bottom: 0;\n        height: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          width: 100%;\n        }\n      }\n\n      &:hover::before {\n        width: 100%;\n      }\n    "])), BaSeTheme.transitions.durationNormal, color);
});
var HeaderGhostContainer = styled.div(templateObject_30$3 || (templateObject_30$3 = __makeTemplateObject(["\n  width: 24px;\n  height: 100vh;\n  background-color: ", ";\n  position: fixed;\n"], ["\n  width: 24px;\n  height: 100vh;\n  background-color: ", ";\n  position: fixed;\n"])), BaSeTheme.colors.defaultColors.transparent);
var HeaderExpandedComponentsContainer = styled.div(templateObject_31$2 || (templateObject_31$2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"])));
var SubHeaderContainer = styled.div.attrs({
    className: 'BaSe--header-submenu',
})(templateObject_32$1 || (templateObject_32$1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  box-shadow: ", ";\n  align-items: center;\n  max-height: ", ";\n  transition: ", ";\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  box-shadow: ", ";\n  align-items: center;\n  max-height: ", ";\n  transition: ", ";\n  overflow: hidden;\n"])), function (props) { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : BaSeTheme.colors.defaultColors.white; }, BaSeTheme.shadows.profundidade4, function (props) { return (props.open ? '100vh' : '0px'); }, BaSeTheme.transitions.allPropertiesContinuousNormal);
var templateObject_1$H, templateObject_2$C, templateObject_3$w, templateObject_4$r, templateObject_5$m, templateObject_6$l, templateObject_7$i, templateObject_8$h, templateObject_9$g, templateObject_10$e, templateObject_11$c, templateObject_12$b, templateObject_13$a, templateObject_14$a, templateObject_15$9, templateObject_16$8, templateObject_17$7, templateObject_18$4, templateObject_19$4, templateObject_20$4, templateObject_21$3, templateObject_22$3, templateObject_23$3, templateObject_24$3, templateObject_25$3, templateObject_26$3, templateObject_27$3, templateObject_28$3, templateObject_29$3, templateObject_30$3, templateObject_31$2, templateObject_32$1;

var animationTime = 250;
var LEFT_TO_RIGHT = 4;
var RIGHT_TO_LEFT = 2;
var BaSeHeader = function (_a) {
    var _b = _a.menuItens, menuItens = _b === void 0 ? [] : _b, _c = _a.textColor, textColor = _c === void 0 ? BaSeTheme.colors.contrast.institucionais.azulSebrae36 : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _d, _e = _a.sidebarBackgroundColor, sidebarBackgroundColor = _e === void 0 ? BaSeTheme.colors.contrast.institucionais
        .azulSebrae36 : _e, _f = _a.sidebarTextColor, sidebarTextColor = _f === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _f, _g = _a.systemName, systemName = _g === void 0 ? '' : _g, accountProfileProps = _a.accountProfileProps, _h = _a.customComponents, customComponents = _h === void 0 ? [] : _h, _j = _a.collapsedBreakpoint, collapsedBreakpoint = _j === void 0 ? 'onTablet' : _j, logoOnClick = _a.logoOnClick, systemLogo = _a.systemLogo, _k = _a.logoInverseColor, logoInverseColor = _k === void 0 ? true : _k, _l = _a.submenuProps, submenuProps = _l === void 0 ? {} : _l, delimitedOnBreakpoint = _a.delimitedOnBreakpoint, _m = _a.withA11yBar, withA11yBar = _m === void 0 ? false : _m, a11yBarProps = _a.a11yBarProps, _o = _a.hasBoxShadow, hasBoxShadow = _o === void 0 ? true : _o, solutionsProps = _a.solutionsProps;
    var _p = submenuProps.open, submenuOpen = _p === void 0 ? false : _p, submenuBackgroundColor = submenuProps.backgroundColor, submenuCollapsedBreakpoint = submenuProps.collapsedBreakpoint;
    var _q = React.useState(false), menuDisplay = _q[0], setMenuDisplay = _q[1];
    var _r = React.useState(false), menuOpen = _r[0], setMenuOpen = _r[1];
    var _s = React.useState(false), submenuOpenQuery = _s[0], setSubmenuOpenQuery = _s[1];
    var _t = React.useState(''), classClosed = _t[0], setClassClosed = _t[1];
    var handleMenuAnimations = React.useCallback(function (force) {
        if (force === void 0) { force = false; }
        if (force || menuOpen) {
            setClassClosed('closed');
            setTimeout(function () {
                setMenuOpen(false);
                setClassClosed('');
            }, animationTime);
        }
        else {
            setMenuOpen(true);
        }
    }, [menuOpen]);
    var handleDelimiterBreakpoint = React.useCallback(function () {
        if (delimitedOnBreakpoint &&
            delimitedOnBreakpoint in BaSeTheme.breakpoints) {
            return BaSeTheme.breakpoints[delimitedOnBreakpoint].minWidth;
        }
        return;
    }, [delimitedOnBreakpoint]);
    var handleDeactivateFocusTrap = React.useCallback(function () {
        handleMenuAnimations(true);
    }, []);
    var handleClickMenuItem = React.useCallback(function (item, e) {
        if (item.onClick) {
            item.onClick(e);
            handleMenuAnimations(true);
        }
    }, []);
    useMenuItemsShrink(setMenuDisplay, collapsedBreakpoint);
    useMenuItemsShrink(setSubmenuOpenQuery, submenuCollapsedBreakpoint);
    var delayTime = React.useCallback(function (index) { return 100 + index * 50; }, []);
    var handleSwipe = React.useCallback(function (swipe, direction) {
        if (swipe.direction === direction) {
            handleMenuAnimations();
        }
    }, [handleMenuAnimations]);
    var SystemLogoMemo = React.useMemo(function () {
        var _a;
        return ((_a = systemLogo === null || systemLogo === void 0 ? void 0 : systemLogo()) !== null && _a !== void 0 ? _a : (logoInverseColor ? (React.createElement(BaSeLogoSebraeInverse, { easterEgg: true, onClick: logoOnClick, width: 68 })) : (React.createElement(BaSeLogoSebrae, { easterEgg: true, onClick: logoOnClick, width: 68 }))));
    }, [systemLogo, logoInverseColor]); // TODO add estaerEgg props no array do memo
    React.useEffect(function () {
        var _a;
        if (accountProfileProps) {
            (_a = accountProfileProps.clientName) !== null && _a !== void 0 ? _a : (accountProfileProps.clientName = systemName);
        }
    }, [accountProfileProps, systemName]);
    return (React.createElement(React.Fragment, null,
        withA11yBar && (React.createElement(BaSeA11yBar, __assign({ delimitedOnBreakpoint: delimitedOnBreakpoint }, a11yBarProps))),
        React.createElement(HeaderOutsideContainer, { hasBoxShadow: hasBoxShadow, className: "BaSe--header", color: backgroundColor },
            React.createElement(HeaderContainer, { textColor: textColor, hasItems: menuItens.length > 0, mobile: menuDisplay, maxWidth: handleDelimiterBreakpoint() },
                menuDisplay && menuItens.length > 0 && (React.createElement(HeaderFlex, { alignStart: true },
                    React.createElement(HeaderMenuIconContainer, null,
                        React.createElement(BaSeI18nConsumer, null, function (_a) {
                            var getMessage = _a.getMessage;
                            return (React.createElement(BaSeIconButton, { nameIcon: "bars", descriptionIcon: getMessage('buttonIcon.iconDescription.menu'), type: "tertiary", buttonType: "button", size: "medium", sizeIcon: "medium", color: textColor, onClick: function () { return handleMenuAnimations(); } }));
                        })),
                    customComponents
                        .filter(function (widget) { return widget.showOnCollapsed; })
                        .map(function (item, key) { return (React.createElement(HeaderFlex, { alignStart: true, fullWidth: true, key: key }, item.component(function () { }))); }))),
                React.createElement(HeaderFlex, { alignStart: menuItens.length === 0, gap: 16 },
                    SystemLogoMemo,
                    !menuDisplay && (React.createElement(HeaderExpandedComponentsContainer, null, customComponents
                        .filter(function (widget) { return widget.showOnExpanded; })
                        .map(function (item, key) { return (React.createElement(HeaderFlex, { fullWidth: true, key: key }, item.component(function () { }))); }))),
                    menuDisplay &&
                        menuItens.length === 0 &&
                        customComponents
                            .filter(function (widget) { return widget.showOnCollapsed; })
                            .map(function (item, key) { return (React.createElement(HeaderFlex, { alignStart: true, fullWidth: true, key: key }, item.component(function () { }))); })),
                React.createElement(HeaderFlex, { fullHeight: true, alignEnd: menuDisplay },
                    !menuDisplay && (React.createElement(HeaderExpandedMenuItemsContainer, { showBorder: menuItens.length > 0 && !!accountProfileProps, color: textColor, role: "menu" }, menuItens.map(function (item, index) {
                        var _a, _b;
                        return (React.createElement(HeaderExpandedMenuItemContainer, { key: index, role: "menuitem", tabIndex: !!item.onClick ? 0 : undefined, onKeyDown: function (e) { var _a; return e.key === 'Enter' && ((_a = item === null || item === void 0 ? void 0 : item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, e)); }, onClick: item.onClick, color: textColor }, (_b = (_a = item === null || item === void 0 ? void 0 : item.component) === null || _a === void 0 ? void 0 : _a.call(item, function () { })) !== null && _b !== void 0 ? _b : (React.createElement(BaSeParagraph, { color: textColor }, item.label))));
                    }))),
                    objectNotEmpty(solutionsProps) && (React.createElement(BaSeUserApps, __assign({}, solutionsProps))),
                    accountProfileProps && (React.createElement(BaSeAccountProfile, __assign({ foregroundColor: textColor, backgroundColor: backgroundColor }, accountProfileProps, { buttonCollapsed: menuDisplay })))))),
        React.createElement(SubHeaderContainer, { open: submenuOpen && submenuOpenQuery, color: submenuBackgroundColor }, customComponents
            .filter(function (widget) { return widget.showOnSubmenu; })
            .map(function (item, key) { return (React.createElement(HeaderFlex, { key: key }, item.component(function () { }))); })),
        menuDisplay && (React.createElement(Hammer, { onSwipe: function (e) { return handleSwipe(e, LEFT_TO_RIGHT); } },
            React.createElement(HeaderGhostContainer, null))),
        menuOpen && menuDisplay && (React.createElement(Hammer, { onSwipe: function (e) { return handleSwipe(e, RIGHT_TO_LEFT); } },
            React.createElement(HeaderCollapsedContainer, null,
                React.createElement(HeaderCollapsedTransparentContainer, null),
                React.createElement(FocusTrap, { focusTrapOptions: {
                        delayInitialFocus: true,
                        escapeDeactivates: true,
                        clickOutsideDeactivates: true,
                        onDeactivate: handleDeactivateFocusTrap,
                    } },
                    React.createElement(HeaderCollapsedContent, { className: "BaSe--header-collapsed-content ".concat(classClosed) },
                        React.createElement(HeaderSideMenu, { sidebarBackgroundColor: sidebarBackgroundColor ||
                                BaSeTheme.colors.defaultColors.white },
                            React.createElement(BaSeHeading5, { isBold: true, color: sidebarTextColor }, systemName),
                            React.createElement(HeaderCollapsedMenuItemNonNav, null, customComponents
                                .filter(function (widget) { return widget.showOnSidebar; })
                                .map(function (item, key) { return (React.createElement(HeaderCollapsedMenuItemContainer, { as: "div", delay: 100, key: key, hasClick: false }, item.component(function () { return handleMenuAnimations(); }))); })),
                            React.createElement("nav", null,
                                React.createElement("ul", { role: "menu" }, menuItens
                                    .filter(function (i) { return !i.hideOnSidebar; })
                                    .map(function (item, index) {
                                    var _a, _b;
                                    return (React.createElement(HeaderCollapsedMenuItemContainer, { color: sidebarTextColor, tabIndex: !!item.onClick ? 0 : undefined, key: index, role: "menuitem", onKeyDown: function (e) {
                                            return e.key === 'Enter' && handleClickMenuItem(item, e);
                                        }, onClick: function (e) {
                                            return handleClickMenuItem(item, e);
                                        }, hasClick: !!item.onClick, delay: delayTime(index) }, (_b = (_a = item === null || item === void 0 ? void 0 : item.component) === null || _a === void 0 ? void 0 : _a.call(item, function () {
                                        return handleMenuAnimations();
                                    })) !== null && _b !== void 0 ? _b : (React.createElement(BaSeText, { color: sidebarTextColor }, item.label))));
                                })))),
                        React.createElement(HeaderCloseIconContent, { buttonBackgroundColor: sidebarBackgroundColor },
                            React.createElement(BaSeI18nConsumer, null, function (_a) {
                                var getMessage = _a.getMessage;
                                return (React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), onClick: function () { return handleMenuAnimations(); }, buttonType: "button", shape: "circle", size: "medium", sizeIcon: "medium", type: "tertiary", color: sidebarTextColor }));
                            })))))))));
};
BaSeHeader.displayName = 'BaSeHeader';

var PanelWrapper = styled.section.attrs({
    className: 'BaSe--panel',
})(templateObject_4$q || (templateObject_4$q = __makeTemplateObject(["\n  &.BaSe--panel {\n    display: flex;\n    flex-direction: column;\n\n    will-change: box-shadow, transform, border-left-width;\n    box-sizing: content-box;\n    overflow: hidden;\n\n    transition: ", ";\n\n    ", "\n\n    ", ";\n  }\n"], ["\n  &.BaSe--panel {\n    display: flex;\n    flex-direction: column;\n\n    will-change: box-shadow, transform, border-left-width;\n    box-sizing: content-box;\n    overflow: hidden;\n\n    transition: ", ";\n\n    ", "\n\n    ", ";\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var height = _a.height, width = _a.width, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderRadius = _a.borderRadius;
    return css(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n      border-radius: ", ";\n      height: ", ";\n      width: ", ";\n      background-color: ", ";\n      border: ", ";\n    "], ["\n      border-radius: ", ";\n      height: ", ";\n      width: ", ";\n      background-color: ", ";\n      border: ", ";\n    "])), numberWithUnit(borderRadius), numberWithUnit(height), numberWithUnit(width), backgroundColor, "1px solid ".concat(borderColor));
}, function (_a) {
    var shadowLevel = _a.shadowLevel, elevationOnHoverOrFocus = _a.elevationOnHoverOrFocus, isElevated = _a.isElevated;
    return shadowLevel && css(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n        box-shadow: ", ";\n\n        ", "\n\n        ", "\n      "], ["\n        box-shadow: ", ";\n\n        ", "\n\n        ", "\n      "])), getShadow(shadowLevel), isElevated && elevatedCss, elevationOnHoverOrFocus && css(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n          &:hover,\n          &:focus-within {\n            ", "\n          }\n        "], ["\n          &:hover,\n          &:focus-within {\n            ", "\n          }\n        "])), elevatedCss));
});
var PanelHeader = styled.header(templateObject_6$k || (templateObject_6$k = __makeTemplateObject(["\n  min-height: 72px;\n  display: grid !important;\n  align-items: center;\n\n  ", "\n"], ["\n  min-height: 72px;\n  display: grid !important;\n  align-items: center;\n\n  ", "\n"])), function (_a) {
    var borderColor = _a.borderColor, headerColor = _a.headerColor, hasShadow = _a.hasShadow;
    return css(templateObject_5$l || (templateObject_5$l = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n    background-color: ", ";\n    ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n    background-color: ", ";\n    ", ";\n  "])), borderColor, headerColor, hasShadow && "box-shadow: ".concat(getShadow(2)));
});
var PanelContent = styled.div(templateObject_7$h || (templateObject_7$h = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  overflow: auto;\n  height: 100%;\n\n  ", "\n"], ["\n  padding: 0;\n  margin: 0;\n  overflow: auto;\n  height: 100%;\n\n  ", "\n"])), BaSeScrollbarCss);
var PanelHeaderWrapper = styled.div(templateObject_8$g || (templateObject_8$g = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 16px;\n"])));
var PanelHeaderImage = styled.div(templateObject_9$f || (templateObject_9$f = __makeTemplateObject(["\n  padding-right: 12px;\n"], ["\n  padding-right: 12px;\n"])));
var PanelHeaderContent = styled.div(templateObject_10$d || (templateObject_10$d = __makeTemplateObject(["\n  flex: 1;\n  flex-direction: column;\n"], ["\n  flex: 1;\n  flex-direction: column;\n"])));
var PanelHeaderActions = styled.div(templateObject_11$b || (templateObject_11$b = __makeTemplateObject(["\n  display: flex;\n  gap: 12px;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  gap: 12px;\n  align-items: flex-end;\n"])));
var templateObject_1$G, templateObject_2$B, templateObject_3$v, templateObject_4$q, templateObject_5$l, templateObject_6$k, templateObject_7$h, templateObject_8$g, templateObject_9$f, templateObject_10$d, templateObject_11$b;

var colors$2 = BaSeTheme.colors;
var BaSePanel = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, height = _a.height, width = _a.width, borderRadius = _a.borderRadius, _b = _a.shadowLevel, shadowLevel = _b === void 0 ? 0 : _b, _c = _a.isElevated, isElevated = _c === void 0 ? false : _c, _d = _a.elevationOnHoverOrFocus, elevationOnHoverOrFocus = _d === void 0 ? false : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? colors$2.defaultColors.transparent : _e, _f = _a.foregroundTitleColor, foregroundTitleColor = _f === void 0 ? colors$2.institucionais.cinzaSebrae45 : _f, _g = _a.foregroundSubtitleColor, foregroundSubtitleColor = _g === void 0 ? colors$2.institucionais.cinzaSebrae45 : _g, _h = _a.headerColor, headerColor = _h === void 0 ? colors$2.defaultColors.white : _h, _j = _a.borderColor, borderColor = _j === void 0 ? colors$2.institucionais.cinzaSebrae90 : _j, renderHeaderImage = _a.renderHeaderImage, renderHeaderActions = _a.renderHeaderActions, renderContent = _a.renderContent;
    var showHeaderImage = React__default.useMemo(function () { return typeof renderHeaderImage === 'function'; }, [renderHeaderImage]);
    var showHeaderActions = React__default.useMemo(function () { return typeof renderHeaderActions === 'function'; }, [renderHeaderActions]);
    var contentHeaderActions = React__default.useCallback(function () {
        var _a, _b;
        if (!showHeaderActions) {
            return;
        }
        var rhc = renderHeaderActions === null || renderHeaderActions === void 0 ? void 0 : renderHeaderActions();
        if (React__default.isValidElement(rhc)) {
            return React__default.createElement(PanelHeaderActions, null, rhc);
        }
        return (React__default.createElement(PanelHeaderActions, null, (_a = rhc === null || rhc === void 0 ? void 0 : rhc.shapeButtons) === null || _a === void 0 ? void 0 :
            _a.map(function (shapeButton) { return (React__default.createElement(BaSeShapeButton, __assign({ key: "".concat(shapeButton.nameIcon, "-").concat(shapeButton.value), color: foregroundTitleColor, type: "secondary" }, shapeButton))); }), (_b = rhc === null || rhc === void 0 ? void 0 : rhc.buttons) === null || _b === void 0 ? void 0 :
            _b.map(function (button) { return (React__default.createElement(BaSeButton, __assign({ key: "".concat(button.leftIcon, "-").concat(button.value, "-").concat(button.rightIcon), color: foregroundTitleColor, type: "secondary" }, button))); })));
    }, [showHeaderActions, renderHeaderActions, foregroundTitleColor]);
    return (React__default.createElement(PanelWrapper, { height: height, width: width, borderRadius: borderRadius, backgroundColor: backgroundColor, borderColor: borderColor, shadowLevel: shadowLevel, isElevated: isElevated, elevationOnHoverOrFocus: elevationOnHoverOrFocus },
        React__default.createElement(PanelHeader, { headerColor: headerColor, borderColor: borderColor, hasShadow: shadowLevel > 0 },
            React__default.createElement(PanelHeaderWrapper, null,
                showHeaderImage && (React__default.createElement(PanelHeaderImage, null, renderHeaderImage === null || renderHeaderImage === void 0 ? void 0 : renderHeaderImage())),
                React__default.createElement(PanelHeaderContent, null,
                    React__default.createElement(BaSeHeading6, { color: foregroundTitleColor, isBold: true }, title),
                    subTitle && (React__default.createElement(BaSeParagraph, { color: foregroundSubtitleColor, isItalic: true }, subTitle))),
                contentHeaderActions())),
        React__default.createElement(PanelContent, null, renderContent())));
};

var SideMenuMainItem = styled.li(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  position: relative;\n  padding: 16px;\n  cursor: pointer;\n\n  ", ";\n\n  img {\n    margin-right: 8px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  position: relative;\n  padding: 16px;\n  cursor: pointer;\n\n  ", ";\n\n  img {\n    margin-right: 8px;\n  }\n"])), function (_a) {
    var hoverTextColor = _a.hoverTextColor, selectedTextColor = _a.selectedTextColor, bottomLineColor = _a.bottomLineColor, active = _a.active, backgroundColor = _a.backgroundColor, backgroundHoverColor = _a.backgroundHoverColor;
    return css(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      width: 0;\n      background-color: ", ";\n      top: 0;\n      bottom: 0;\n      will-change: widht;\n      transition: ", ";\n    }\n\n    ", "\n\n    &:hover , &:focus {\n      color: ", ";\n      background-color: ", ";\n      outline: none;\n    }\n  "], ["\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      width: 0;\n      background-color: ", ";\n      top: 0;\n      bottom: 0;\n      will-change: widht;\n      transition: ", ";\n    }\n\n    ", "\n\n    &:hover , &:focus {\n      color: ", ";\n      background-color: ", ";\n      outline: none;\n    }\n  "])), backgroundColor, bottomLineColor, selectedTextColor, BaSeTheme.transitions.allPropertiesContinuousNormal, active && css(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n      &::before {\n        width: 4px;\n      }\n    "], ["\n      &::before {\n        width: 4px;\n      }\n    "]))), hoverTextColor, backgroundHoverColor);
});
var SideMenuChildItem = styled(SideMenuMainItem)(templateObject_4$p || (templateObject_4$p = __makeTemplateObject(["\n  font-weight: normal;\n  font-size: 13px;\n  padding: 8px 16px;\n  border-bottom: none;\n\n  &::before {\n    display: none;\n  }\n"], ["\n  font-weight: normal;\n  font-size: 13px;\n  padding: 8px 16px;\n  border-bottom: none;\n\n  &::before {\n    display: none;\n  }\n"])));
var templateObject_1$F, templateObject_2$A, templateObject_3$u, templateObject_4$p;

var SideMenuColors = {
    light: {
        textColor: ColorMapper.grayScale.foreground,
        hoverTextColor: ColorMapper.grayScale.hover.defaultDark,
        selectedTextColor: ColorMapper.default.foreground,
        childrenActiveTextColor: ColorMapper.default.hover.defaultDark,
        bottomLineColor: ColorMapper.grayScale.getColorByNumber(90),
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        backgroundHoverColor: ColorMapper.grayScale.hover.defaultLight,
    },
    dark: {
        textColor: ColorMapper.grayScale.focus.defaultLight,
        hoverTextColor: BaSeTheme.colors.defaultColors.white,
        selectedTextColor: BaSeTheme.colors.defaultColors.white,
        childrenActiveTextColor: BaSeTheme.colors.defaultColors.white,
        bottomLineColor: ColorMapper.grayScale.getColorByNumber(90),
        backgroundColor: BaSeTheme.colors.defaultColors.transparent,
        backgroundHoverColor: ColorMapper.createTransparent(ColorMapper.default.hover.defaultLight, 97, 0.5),
    },
};
// const colorMappedLight = {
//   // light
//   // relative: { s: 100, l: 36 }, // selected
//   normalText: { s: 16, l: 45 }, // s => s * .16 , l => (1 - l) / (64 / 9)
//   backhover: { s: 33, l: 97 }, // s => s * .33 , l => (1 - l) / (64 / 61)
//   lineColor: { s: 22, l: 90 }, // s => s * .22 , l => (1 - l) / (64 / 54)
//   selectedChildText: { s: 80, l: 30 }, // s => s * .8 , l => l * .83
//   hoverText: { s: 25, l: 30 }, // s => s * .8 , l => l * .83
// };
// const colorMappedDark = {
//   // dark
//   // relative: { s: 1, l: 1, o: 1 }, // selected
//   normalText: { s: 14, l: 75 }, // s => s * .14 , l => l + (1 - l) / (25 / 20)
//   backhover: { s: 33, l: 97, o: 0.5 }, // s => s * .33 , l => l * .97
//   lineColor: { s: 22, l: 90 }, // s => s * .22 , l => l * .9
//   selectedChildText: { s: 100, l: 100 }, // s  , l
//   hoverText: { s: 100, l: 100 }, // s  , l
// };
var colorMappedCustom$1 = function (color) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!color) {
        return SideMenuColors;
    }
    var mappedTypes = {
        destructive: ColorMapper.destructive.foreground,
        confirmation: ColorMapper.confirmation.foreground,
        attention: ColorMapper.attention.foreground,
    };
    var originalValues = getHSLValues((_a = mappedTypes[color]) !== null && _a !== void 0 ? _a : color);
    if (!originalValues) {
        return SideMenuColors;
    }
    var h = originalValues.h, s = originalValues.s, l = originalValues.l;
    h /= 100;
    s /= 100;
    l /= 100;
    return {
        light: {
            textColor: createColorSmartLightingControl((_b = mappedTypes[color]) !== null && _b !== void 0 ? _b : color, { h: h, s: s * 0.16, l: l + (1 - l) / (64 / 9) }, 'lighter'),
            hoverTextColor: createColorSmartLightingControl((_c = mappedTypes[color]) !== null && _c !== void 0 ? _c : color, { h: h, s: s * 0.25, l: l * 0.83 }, 'darker'),
            selectedTextColor: (_d = mappedTypes[color]) !== null && _d !== void 0 ? _d : color,
            childrenActiveTextColor: createColorSmartLightingControl((_e = mappedTypes[color]) !== null && _e !== void 0 ? _e : color, { h: h, s: s * 0.8, l: l * 0.83 }, 'darker'),
            bottomLineColor: createColorSmartLightingControl((_f = mappedTypes[color]) !== null && _f !== void 0 ? _f : color, { h: h, s: s * 0.22, l: l + (1 - l) / (64 / 54) }, 'lighter'),
            backgroundColor: BaSeTheme.colors.defaultColors.white,
            backgroundHoverColor: createColorSmartLightingControl((_g = mappedTypes[color]) !== null && _g !== void 0 ? _g : color, { h: h, s: s * 0.33, l: l + (1 - l) / (64 / 61) }, 'lighter'),
        },
        dark: {
            textColor: createColorSmartLightingControl((_h = mappedTypes[color]) !== null && _h !== void 0 ? _h : color, { h: h, s: s * 0.14, l: l + (1 - l) / (25 / 6) }, 'lighter'),
            hoverTextColor: (_j = mappedTypes[color]) !== null && _j !== void 0 ? _j : color,
            selectedTextColor: (_k = mappedTypes[color]) !== null && _k !== void 0 ? _k : color,
            childrenActiveTextColor: (_l = mappedTypes[color]) !== null && _l !== void 0 ? _l : color,
            bottomLineColor: createColorSmartLightingControl((_m = mappedTypes[color]) !== null && _m !== void 0 ? _m : color, { h: h, s: s * 0.22, l: l * 0.9 }, 'darker'),
            backgroundColor: BaSeTheme.colors.defaultColors.transparent,
            backgroundHoverColor: createColorSmartLightingControl((_o = mappedTypes[color]) !== null && _o !== void 0 ? _o : color, { h: h, s: s * 0.33, l: l * 0.97, opacity: 0.5 }, 'lighter'),
        },
    };
};

var BaSeSideMenuItem = function (_a) {
    var _b, _c;
    var label = _a.label, callback = _a.callback, subItens = _a.subItens, active = _a.active, icon = _a.icon, theme = _a.theme, activeCallback = _a.activeCallback, activeIndex = _a.activeIndex, insideIndex = _a.insideIndex, color = _a.color;
    var menuColors = !!color
        ? (_b = colorMappedCustom$1(color)[theme !== null && theme !== void 0 ? theme : 'light']) !== null && _b !== void 0 ? _b : colorMappedCustom$1(color).dark
        : (_c = SideMenuColors[theme !== null && theme !== void 0 ? theme : 'light']) !== null && _c !== void 0 ? _c : SideMenuColors.dark;
    var _d = React.useState(-1), activeIndexChild = _d[0], setActiveIndexChild = _d[1];
    var _e = React.useState(false), hasHover = _e[0], setHasHover = _e[1];
    var _f = React.useState(false), hasFocus = _f[0], setHasFocus = _f[1];
    var handleStateColor = React.useCallback(function () {
        if (hasHover || hasFocus) {
            return menuColors === null || menuColors === void 0 ? void 0 : menuColors.hoverTextColor;
        }
        if (insideIndex === activeIndex) {
            return menuColors === null || menuColors === void 0 ? void 0 : menuColors.selectedTextColor;
        }
        return menuColors === null || menuColors === void 0 ? void 0 : menuColors.textColor;
    }, [hasHover, hasFocus, menuColors, insideIndex, activeIndex]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleCallback = function () {
        callback === null || callback === void 0 ? void 0 : callback();
        activeCallback === null || activeCallback === void 0 ? void 0 : activeCallback(insideIndex);
    };
    var handleChildrenCallback = function (index, fun) {
        fun === null || fun === void 0 ? void 0 : fun();
        setActiveIndexChild === null || setActiveIndexChild === void 0 ? void 0 : setActiveIndexChild(index);
    };
    React.useEffect(function () {
        if (active) {
            activeCallback === null || activeCallback === void 0 ? void 0 : activeCallback(insideIndex);
        }
    }, [active]);
    React.useEffect(function () {
        if (activeIndex !== insideIndex) {
            setActiveIndexChild(-1);
        }
    }, [activeIndex, insideIndex]);
    React.useEffect(function () {
        subItens === null || subItens === void 0 ? void 0 : subItens.forEach(function (item, key) {
            if (item === null || item === void 0 ? void 0 : item.active) {
                setActiveIndexChild(key);
                activeCallback === null || activeCallback === void 0 ? void 0 : activeCallback(insideIndex);
                return;
            }
        });
    }, [subItens]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SideMenuMainItem, __assign({ tabIndex: 0, onClick: handleCallback }, menuColors, { onMouseEnter: function () { return setHasHover(true); }, onMouseLeave: function () { return setHasHover(false); }, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setHasFocus(false); }, active: insideIndex === activeIndex }),
            !!icon && (React.createElement(BaSeIcon, { size: 13, name: icon, description: getMessage('icon.label', label), color: handleStateColor() })),
            React.createElement(BaSeParagraph, { color: menuColors.textColor, isBold: true }, label)),
        insideIndex === activeIndex && !!subItens && subItens.length && (React.createElement("ul", { style: { paddingLeft: 20 } }, subItens.map(function (_a, key) {
            var childLabel = _a.label, childCallback = _a.callback;
            var isActive = activeIndexChild === key;
            return (React.createElement(SideMenuChildItem, __assign({ tabIndex: 0, active: isActive }, menuColors, { onClick: function () { return handleChildrenCallback(key, childCallback); }, key: key }),
                React.createElement(BaSeSmall1, { isBold: isActive, color: isActive
                        ? menuColors.childrenActiveTextColor
                        : menuColors.textColor }, childLabel)));
        })))));
};

var SideMenuContainer = styled.nav.attrs({
    className: 'BaSe--side-menu',
})(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  &.BaSe--side-menu {\n    display: flex;\n    flex-flow: column;\n\n    ul {\n      margin: 0;\n      padding: 0;\n    }\n\n    ", ";\n  }\n"], ["\n  &.BaSe--side-menu {\n    display: flex;\n    flex-flow: column;\n\n    ul {\n      margin: 0;\n      padding: 0;\n    }\n\n    ", ";\n  }\n"])), BaSeScrollbarCss);
var templateObject_1$E;

var BaSeSideMenu = function (_a) {
    var _b = _a.itens, itens = _b === void 0 ? [] : _b, _c = _a.themeMode, themeMode = _c === void 0 ? 'light' : _c, color = _a.color;
    var _d = React.useState(-1), activeIndex = _d[0], setActiveIndex = _d[1];
    if (!itens || !itens.length) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(SideMenuContainer, null,
        React.createElement("ul", null, itens.map(function (props, index) { return (React.createElement(BaSeSideMenuItem, __assign({}, props, { key: index, theme: themeMode, activeIndex: activeIndex, activeCallback: setActiveIndex, insideIndex: index, color: color }))); }))));
};
BaSeSideMenu.displayName = 'BaSeSideMenu';

function lighting$1(color, lightness) {
    return transformLightness(color, lightness);
}
function darking$1(color) {
    return transformLightness(color, 0.3);
}
function getFilter(color) {
    return transformToFilter(color);
}
var slideIn$1 = function (origin) { return keyframes(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  from {\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    opacity: 1;\n  }\n"])), origin); };
var fade = function (from) {
    if (from === void 0) { from = 0; }
    return keyframes(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  from {\n    opacity: ", ";\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"], ["\n  from {\n    opacity: ", ";\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"])), from);
};
var StepperContainer = styled.div.attrs({
    className: 'BaSe--stepper',
})(templateObject_5$k || (templateObject_5$k = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal'
        ? css(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n          display: flex;\n          gap: 30px;\n          flex-direction: column;\n        "], ["\n          display: flex;\n          gap: 30px;\n          flex-direction: column;\n        "]))) : css(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n          display: block;\n        "], ["\n          display: block;\n        "])));
});
var StepsContainer = styled.ul.attrs({
    className: 'BaSe--stepper-container',
})(templateObject_8$f || (templateObject_8$f = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n\n  ", "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal'
        ? css(templateObject_6$j || (templateObject_6$j = __makeTemplateObject(["\n          flex-direction: row;\n          align-items: flex-start;\n        "], ["\n          flex-direction: row;\n          align-items: flex-start;\n        "]))) : css(templateObject_7$g || (templateObject_7$g = __makeTemplateObject(["\n          flex-direction: column;\n          align-items: stretch;\n        "], ["\n          flex-direction: column;\n          align-items: stretch;\n        "])));
});
var StepContainer = styled.li.attrs({
    className: 'BaSe--stepper-header',
})(templateObject_15$8 || (templateObject_15$8 = __makeTemplateObject(["\n  flex: 1;\n  display: grid;\n  place-items: ", ";\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    z-index: ", ";\n  }\n\n  &::before {\n    background-color: ", ";\n\n    ", "\n  }\n\n  &::after {\n    transition: ", ";\n    background-color: ", ";\n\n    ", "\n    will-change: width;\n  }\n  &:last-child::before,\n  &:last-child::after {\n    content: none;\n  }\n"], ["\n  flex: 1;\n  display: grid;\n  place-items: ", ";\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    z-index: ", ";\n  }\n\n  &::before {\n    background-color: ", ";\n\n    ", "\n  }\n\n  &::after {\n    transition: ", ";\n    background-color: ", ";\n\n    ", "\n    will-change: width;\n  }\n  &:last-child::before,\n  &:last-child::after {\n    content: none;\n  }\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' ? 'center' : 'start';
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal'
        ? css(templateObject_9$e || (templateObject_9$e = __makeTemplateObject(["\n            transform: translateX(20px);\n            width: calc(100% - 30px);\n            height: 1.5px;\n            top: 19px;\n            left: 50%;\n          "], ["\n            transform: translateX(20px);\n            width: calc(100% - 30px);\n            height: 1.5px;\n            top: 19px;\n            left: 50%;\n          "]))) : css(templateObject_10$c || (templateObject_10$c = __makeTemplateObject(["\n            width: 1.5px;\n            height: calc(100% - 31px);\n            transform: translateY(24px);\n            top: 15px;\n            left: 24px;\n          "], ["\n            width: 1.5px;\n            height: calc(100% - 31px);\n            transform: translateY(24px);\n            top: 15px;\n            left: 24px;\n          "])));
}, BaSeTheme.stackOrder.normal + 1, function (_a) {
    var withError = _a.withError, isActive = _a.isActive, isCompleted = _a.isCompleted, completedColor = _a.completedColor, completedWithErrorColor = _a.completedWithErrorColor, uncompletedColor = _a.uncompletedColor, uncompletedWithErrorColor = _a.uncompletedWithErrorColor, activeColor = _a.activeColor, activeWithErrorColor = _a.activeWithErrorColor;
    return isActive
        ? withError
            ? activeWithErrorColor
            : activeColor
        : lighting$1((isCompleted
            ? withError
                ? completedWithErrorColor
                : completedColor
            : withError
                ? uncompletedWithErrorColor
                : uncompletedColor), 0.75);
}, function (_a) {
    var orientation = _a.orientation, isActive = _a.isActive, isCompleted = _a.isCompleted;
    return orientation === 'horizontal'
        ? css(templateObject_11$a || (templateObject_11$a = __makeTemplateObject(["\n            width: ", ";\n          "], ["\n            width: ", ";\n          "])), !isCompleted || isActive ? 'calc(100% - 30px)' : '0') : css(templateObject_12$a || (templateObject_12$a = __makeTemplateObject(["\n            height: ", ";\n          "], ["\n            height: ", ";\n          "])), !isCompleted || isActive ? 'calc(100% - 31px)' : '0');
}, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var withError = _a.withError, isCompleted = _a.isCompleted, completedColor = _a.completedColor, completedWithErrorColor = _a.completedWithErrorColor, uncompletedColor = _a.uncompletedColor, uncompletedWithErrorColor = _a.uncompletedWithErrorColor;
    return lighting$1((isCompleted
        ? withError
            ? completedWithErrorColor
            : completedColor
        : withError
            ? uncompletedWithErrorColor
            : uncompletedColor), 0.75);
}, function (_a) {
    var orientation = _a.orientation, isCompleted = _a.isCompleted;
    return orientation === 'horizontal'
        ? css(templateObject_13$9 || (templateObject_13$9 = __makeTemplateObject(["\n            width: ", ";\n          "], ["\n            width: ", ";\n          "])), isCompleted ? 'calc(100% - 30px)' : '0') : css(templateObject_14$9 || (templateObject_14$9 = __makeTemplateObject(["\n            height: ", ";\n          "], ["\n            height: ", ";\n          "])), isCompleted ? 'calc(100% - 31px)' : '0');
});
var StepItem = styled.button(templateObject_20$3 || (templateObject_20$3 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  appearance: none;\n  background: ", ";\n  border: none;\n  cursor: ", ";\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", ";\n\n  &:disabled {\n    div {\n      border-color: ", ";\n      background: ", ";\n    }\n  }\n  span {\n    small {\n      color: ", ";\n    }\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  appearance: none;\n  background: ", ";\n  border: none;\n  cursor: ", ";\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", ";\n\n  &:disabled {\n    div {\n      border-color: ", ";\n      background: ", ";\n    }\n  }\n  span {\n    small {\n      color: ", ";\n    }\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, BaSeTheme.colors.defaultColors.transparent, function (_a) {
    var disabled = _a.disabled, isClickable = _a.isClickable;
    return disabled ? 'not-allowed' : isClickable ? 'pointer' : 'default';
}, function (_a) {
    var isClickable = _a.isClickable;
    return !isClickable && css(templateObject_16$7 || (templateObject_16$7 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal'
        ? css(templateObject_17$6 || (templateObject_17$6 = __makeTemplateObject(["\n          flex-direction: column;\n          justify-content: center;\n        "], ["\n          flex-direction: column;\n          justify-content: center;\n        "]))) : css(templateObject_18$3 || (templateObject_18$3 = __makeTemplateObject(["\n          flex-direction: row;\n          justify-content: flex-start;\n        "], ["\n          flex-direction: row;\n          justify-content: flex-start;\n        "])));
}, function (_a) {
    var disabled = _a.disabled, isClickable = _a.isClickable, withError = _a.withError, isActive = _a.isActive, activeColor = _a.activeColor, activeWithErrorColor = _a.activeWithErrorColor;
    return !disabled &&
        !isActive &&
        isClickable && css(templateObject_19$3 || (templateObject_19$3 = __makeTemplateObject(["\n      &:focus:not(:hover) {\n        div {\n          background-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n\n      &:hover {\n        div {\n          background: ", ";\n          border-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n    "], ["\n      &:focus:not(:hover) {\n        div {\n          background-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n\n      &:hover {\n        div {\n          background: ", ";\n          border-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n    "])), lighting$1((withError ? activeWithErrorColor : activeColor), 0.98), withError ? activeWithErrorColor : activeColor, fade(0.9), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.durationFast, getFilter((withError ? activeWithErrorColor : activeColor)), lighting$1((withError ? activeWithErrorColor : activeColor), 0.97), darking$1((withError ? activeWithErrorColor : activeColor)), darking$1((withError ? activeWithErrorColor : activeColor)), fade(0.9), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.durationFast, getFilter(darking$1((withError ? activeWithErrorColor : activeColor))));
}, BaSeTheme.colors.institucionais.cinzaSebrae90, BaSeTheme.colors.institucionais.cinzaSebrae90, BaSeTheme.colors.institucionais.cinzaSebrae75);
var StepCircleHeader = styled.div(templateObject_21$2 || (templateObject_21$2 = __makeTemplateObject(["\n  height: 32px;\n  width: 32px;\n  max-height: 32px;\n  max-width: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background-color: ", ";\n  flex-basis: 50px;\n  transition: ", ";\n  z-index: ", ";\n  border-color: ", ";\n"], ["\n  height: 32px;\n  width: 32px;\n  max-height: 32px;\n  max-width: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background-color: ", ";\n  flex-basis: 50px;\n  transition: ", ";\n  z-index: ", ";\n  border-color: ", ";\n"])), BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, "\n    ".concat(BaSeTheme.transitions.allPropertiesContinuousFast, "\n    ").concat(BaSeTheme.transitions.durationFast, "\n  "), BaSeTheme.stackOrder.normal + 1, function (_a) {
    var withError = _a.withError, isActive = _a.isActive, isCompleted = _a.isCompleted, completedColor = _a.completedColor, completedWithErrorColor = _a.completedWithErrorColor, uncompletedColor = _a.uncompletedColor, uncompletedWithErrorColor = _a.uncompletedWithErrorColor, activeColor = _a.activeColor, activeWithErrorColor = _a.activeWithErrorColor;
    return isActive
        ? withError
            ? activeWithErrorColor
            : activeColor
        : lighting$1((isCompleted
            ? withError
                ? completedWithErrorColor
                : completedColor
            : withError
                ? uncompletedWithErrorColor
                : uncompletedColor), 0.75);
});
var FadableItem = styled.span(templateObject_22$2 || (templateObject_22$2 = __makeTemplateObject(["\n  opacity: 0;\n  animation: ", " ", "\n    ", " 1 forwards;\n"], ["\n  opacity: 0;\n  animation: ", " ", "\n    ", " 1 forwards;\n"])), fade(), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.durationFast);
var CustomTooltip = styled.div(templateObject_23$2 || (templateObject_23$2 = __makeTemplateObject(["\n  width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  padding: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  transition: opacity 0.5s ease;\n"], ["\n  width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  padding: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  transition: opacity 0.5s ease;\n"])));
var StepText = styled(FadableItem)(templateObject_24$2 || (templateObject_24$2 = __makeTemplateObject(["\n  text-align: ", ";\n\n  & > div > [class*='BaSe'] {\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    transition: ", ";\n\n    color: ", ";\n  }\n\n  &:hover + ", " {\n    visibility: visible;\n    transition: opacity 0.5s ease;\n    opacity: 1;\n  }\n"], ["\n  text-align: ", ";\n\n  & > div > [class*='BaSe'] {\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    transition: ", ";\n\n    color: ", ";\n  }\n\n  &:hover + ", " {\n    visibility: visible;\n    transition: opacity 0.5s ease;\n    opacity: 1;\n  }\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' ? 'center' : 'start';
}, "".concat(BaSeTheme.transitions.allPropertiesContinuousFast, " ").concat(BaSeTheme.transitions.durationFast), function (_a) {
    var withError = _a.withError, isActive = _a.isActive, isCompleted = _a.isCompleted, activeColor = _a.activeColor, completedWithErrorColor = _a.completedWithErrorColor, incompletedColor = _a.uncompletedColor, incompletedWithErrorColor = _a.uncompletedWithErrorColor, activeWithErrorColor = _a.activeWithErrorColor, completedColor = _a.completedColor;
    return isActive
        ? withError
            ? activeWithErrorColor
            : activeColor
        : isCompleted
            ? withError
                ? completedWithErrorColor
                : completedColor
            : withError
                ? incompletedWithErrorColor
                : incompletedColor;
}, CustomTooltip);
var StepperContent = styled(FadableItem)(templateObject_27$2 || (templateObject_27$2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var transition = _a.transition, orientation = _a.orientation;
    return transition === 'inert' &&
        orientation === 'vertical' && css(templateObject_25$2 || (templateObject_25$2 = __makeTemplateObject(["\n      opacity: 1;\n      animation: none;\n    "], ["\n      opacity: 1;\n      animation: none;\n    "])));
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical' && css(templateObject_26$2 || (templateObject_26$2 = __makeTemplateObject(["\n      width: calc(100% - 4em);\n      padding-left: 4em;\n    "], ["\n      width: calc(100% - 4em);\n      padding-left: 4em;\n    "])));
});
var StepContentTransitionHorizontal = styled.div(templateObject_29$2 || (templateObject_29$2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var transition = _a.transition;
    return transition !== 'inert' && css(templateObject_28$2 || (templateObject_28$2 = __makeTemplateObject(["\n      animation: ", "\n        ", "\n        ", ";\n    "], ["\n      animation: ", "\n        ", "\n        ", ";\n    "])), slideIn$1(transition === 'leftToRight' ? -100 : 100), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.continuousTimingFunction);
});
var StepperContentBody = styled.div(templateObject_30$2 || (templateObject_30$2 = __makeTemplateObject(["\n  &[hidden] {\n    display: none;\n  }\n"], ["\n  &[hidden] {\n    display: none;\n  }\n"])));
var templateObject_1$D, templateObject_2$z, templateObject_3$t, templateObject_4$o, templateObject_5$k, templateObject_6$j, templateObject_7$g, templateObject_8$f, templateObject_9$e, templateObject_10$c, templateObject_11$a, templateObject_12$a, templateObject_13$9, templateObject_14$9, templateObject_15$8, templateObject_16$7, templateObject_17$6, templateObject_18$3, templateObject_19$3, templateObject_20$3, templateObject_21$2, templateObject_22$2, templateObject_23$2, templateObject_24$2, templateObject_25$2, templateObject_26$2, templateObject_27$2, templateObject_28$2, templateObject_29$2, templateObject_30$2;

var BaSeStepContent = function (_a) {
    var canGotoNext = _a.canGotoNext, canGotoPrev = _a.canGotoPrev, content = _a.content, onNext = _a.onNext, onPrev = _a.onPrev, gotoStep = _a.gotoStep, steps = _a.steps, _b = _a.preserveContent, preserveContent = _b === void 0 ? false : _b, currentStep = _a.currentStep;
    return preserveContent ? (React.createElement(React.Fragment, null, steps &&
        steps.map(function (step, index) {
            return (React.createElement(StepperContentBody, { key: index, hidden: index + 1 !== currentStep }, step &&
                step.content &&
                (step === null || step === void 0 ? void 0 : step.content({
                    gotoPrev: onPrev,
                    gotoNext: onNext,
                    canGotoPrev: canGotoPrev,
                    canGotoNext: canGotoNext,
                    gotoStep: gotoStep,
                }))));
        }))) : (React.createElement(React.Fragment, null, content({
        gotoPrev: onPrev,
        gotoNext: onNext,
        canGotoPrev: canGotoPrev,
        canGotoNext: canGotoNext,
        gotoStep: gotoStep,
    })));
};
BaSeStepContent.displayName = 'BaSeStepContent';

var StepperContentToRender = function (_a) {
    var _b, _c;
    var orientation = _a.orientation, transition = _a.transition, steps = _a.steps, currentStep = _a.currentStep, onStepChange = _a.onStepChange, _d = _a.preserveContent, preserveContent = _d === void 0 ? false : _d;
    var content = React.useMemo(function () { return steps[currentStep - 1].content; }, [steps, currentStep]);
    return (React.createElement(React.Fragment, null, typeof content === 'function' && (React.createElement(StepperContent, { as: "section", className: "BaSe--stepper-content", orientation: orientation, transition: transition },
        React.createElement(StepContentTransitionHorizontal, { transition: transition },
            React.createElement(BaSeStepContent, { steps: steps, content: content, canGotoNext: currentStep < steps.length && !((_b = steps === null || steps === void 0 ? void 0 : steps[currentStep]) === null || _b === void 0 ? void 0 : _b.isDisabled), canGotoPrev: currentStep > 1 && !((_c = steps === null || steps === void 0 ? void 0 : steps[currentStep - 2]) === null || _c === void 0 ? void 0 : _c.isDisabled), gotoStep: onStepChange, onNext: function () { return onStepChange(currentStep + 1); }, onPrev: function () { return onStepChange(currentStep - 1); }, currentStep: currentStep, preserveContent: preserveContent }))))));
};
var BaSeStepHeader = function (_a) {
    var _b;
    var steps = _a.steps, transition = _a.transition, title = _a.title, iconName = _a.iconName, _c = _a.tooltip, tooltip = _c === void 0 ? 'none' : _c, currentStep = _a.currentStep, isActive = _a.isActive, isCompleted = _a.isCompleted, _d = _a.activeColor, activeColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _d, _e = _a.completedColor, completedColor = _e === void 0 ? BaSeTheme.colors.feedbackInterface.sucesso45 : _e, _f = _a.uncompletedColor, uncompletedColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _f, orientation = _a.orientation, _g = _a.isDisabled, isDisabled = _g === void 0 ? false : _g, _h = _a.isClickable, isClickable = _h === void 0 ? true : _h, onActivated = _a.onActivated, onStepChange = _a.onStepChange, _j = _a.activeWithErrorColor, activeWithErrorColor = _j === void 0 ? BaSeTheme.colors.feedbackInterface.atencao35 : _j, _k = _a.completedWithErrorColor, completedWithErrorColor = _k === void 0 ? BaSeTheme.colors.feedbackInterface.erro45 : _k, _l = _a.uncompletedWithErrorColor, uncompletedWithErrorColor = _l === void 0 ? BaSeTheme.colors.feedbackInterface.atencao55 : _l, _m = _a.withError, withError = _m === void 0 ? false : _m;
    var _o = React.useState(false), isTooltipOpen = _o[0], setIsTooltipOpen = _o[1];
    var itemRef = React.useRef(null);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var renderIcon = React.useCallback(function (name, color) {
        var description = getMessage(withError ? 'stepCurrent.erro' : 'stepCurrent.description', currentStep.toString());
        return (React.createElement(FadableItem, null,
            React.createElement(BaSeIcon, { name: name, description: description, color: color ? color : isActive ? activeColor : uncompletedColor, colorTransition: "fast", size: 24 })));
    }, [
        withError,
        currentStep,
        isActive,
        activeColor,
        uncompletedColor,
        getMessage,
    ]);
    var renderText = React.useCallback(function (stringOrList) {
        var texts = !Array.isArray(stringOrList)
            ? [stringOrList]
            : stringOrList;
        return (React.createElement(StepText, { isActive: isActive, isCompleted: isCompleted, activeColor: activeColor, completedColor: completedColor, uncompletedColor: uncompletedColor, orientation: orientation, activeWithErrorColor: activeWithErrorColor, completedWithErrorColor: completedWithErrorColor, uncompletedWithErrorColor: uncompletedWithErrorColor, withError: withError },
            React.createElement("div", null, texts.map(function (text, index) {
                return text && React.createElement(BaSeSmall1, { key: index }, text);
            }))));
    }, [
        isActive,
        isCompleted,
        activeColor,
        completedColor,
        uncompletedColor,
        orientation,
        activeWithErrorColor,
        completedWithErrorColor,
        uncompletedWithErrorColor,
        withError,
    ]);
    return (React.createElement(StepContainer, { isActive: isActive, isCompleted: isCompleted, activeColor: activeColor, completedColor: completedColor, uncompletedColor: uncompletedColor, orientation: orientation, activeWithErrorColor: activeWithErrorColor, completedWithErrorColor: completedWithErrorColor, uncompletedWithErrorColor: uncompletedWithErrorColor, withError: withError },
        React.createElement(StepItem, { ref: itemRef, isActive: isActive, isCompleted: isCompleted, activeColor: activeColor, completedColor: completedColor, uncompletedColor: uncompletedColor, activeWithErrorColor: activeWithErrorColor, completedWithErrorColor: completedWithErrorColor, uncompletedWithErrorColor: uncompletedWithErrorColor, withError: withError, onMouseEnter: function () { return setIsTooltipOpen(true); }, onMouseLeave: function () { return setIsTooltipOpen(false); }, disabled: isDisabled, isClickable: isClickable, onClick: function () { return onActivated(); }, role: isClickable ? 'button' : 'heading', tabIndex: isClickable ? 0 : -1, orientation: orientation },
            React.createElement(StepCircleHeader, { activeColor: activeColor, completedColor: completedColor, uncompletedColor: uncompletedColor, isActive: isActive, isCompleted: isCompleted, activeWithErrorColor: activeWithErrorColor, completedWithErrorColor: completedWithErrorColor, uncompletedWithErrorColor: uncompletedWithErrorColor, withError: withError }, isCompleted
                ? renderIcon(withError ? 'close' : 'check', withError ? completedWithErrorColor : completedColor)
                : withError
                    ? renderIcon('exclamation', uncompletedWithErrorColor)
                    : !!iconName
                        ? renderIcon(iconName)
                        : renderText((_b = currentStep === null || currentStep === void 0 ? void 0 : currentStep.toString) === null || _b === void 0 ? void 0 : _b.call(currentStep))),
            renderText(title)),
        tooltip !== 'none' && title && (React.createElement(BaSeTooltip, { buddyRef: itemRef, color: "outlined", direction: tooltip, message: title, open: isTooltipOpen })),
        isActive && orientation === 'vertical' && (React.createElement(StepperContentToRender, { orientation: orientation, transition: transition, steps: steps, currentStep: currentStep, onStepChange: onStepChange }))));
};
BaSeStepHeader.displayName = 'BaSeStepHeader';

var BaSeStepper = function (_a) {
    var initialStepper = _a.steps, activeColor = _a.activeColor, completedColor = _a.completedColor, uncompletedColor = _a.uncompletedColor, _b = _a.currentStep, currentStep = _b === void 0 ? 1 : _b, _c = _a.orientation, orientation = _c === void 0 ? 'horizontal' : _c, _d = _a.withTransition, withTransition = _d === void 0 ? false : _d, onStepChange = _a.onStepChange, activeWithErrorColor = _a.activeWithErrorColor, completedWithErrorColor = _a.completedWithErrorColor, uncompletedWithErrorColor = _a.uncompletedWithErrorColor, _e = _a.preserveContent, preserveContent = _e === void 0 ? false : _e;
    var _f = React.useState(currentStep), lastActivatedTabIndex = _f[0], setLastActivatedTabIndex = _f[1];
    var _g = React.useState('inert'), transition = _g[0], setTransition = _g[1];
    var steps = React.useMemo(function () {
        if (typeof initialStepper === 'number') {
            return Array(initialStepper).fill({});
        }
        return initialStepper;
    }, [initialStepper]);
    if (!Array.isArray(steps) || (steps === null || steps === void 0 ? void 0 : steps.length) === 0) {
        throw Error('Prop "steps" é obrigatória');
    }
    if (!onStepChange) {
        throw Error('Prop "onStepChange" é obrigatória');
    }
    React.useEffect(function () {
        onStepChange(currentStep);
        return function () { return setLastActivatedTabIndex(currentStep); };
    }, [currentStep, onStepChange]);
    React.useEffect(function () {
        if (withTransition) {
            setTransition(function () {
                return lastActivatedTabIndex < currentStep ? 'leftToRight' : 'rightToLeft';
            });
            setTimeout(function () {
                setTransition(function () { return 'inert'; });
            }, BaSeTheme.transitions.durationNormalInMilliseconds);
        }
    }, [currentStep, lastActivatedTabIndex, withTransition]);
    return (React.createElement(StepperContainer, { orientation: orientation },
        React.createElement("nav", null,
            React.createElement(StepsContainer, { orientation: orientation }, steps.map(function (_a, index) {
                var title = _a.title, iconName = _a.iconName, isDisabled = _a.isDisabled, isClickable = _a.isClickable, isCompleted = _a.isCompleted, tooltip = _a.tooltip, withError = _a.withError;
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(BaSeStepHeader, { activeWithErrorColor: activeWithErrorColor, completedWithErrorColor: completedWithErrorColor, uncompletedWithErrorColor: uncompletedWithErrorColor, steps: steps, withError: withError, isDisabled: isDisabled, isClickable: isClickable, tooltip: tooltip, title: title, iconName: iconName, currentStep: index + 1, activeColor: activeColor, completedColor: completedColor, uncompletedColor: uncompletedColor, isActive: currentStep === index + 1, isCompleted: isCompleted !== null && isCompleted !== void 0 ? isCompleted : currentStep > index + 1, orientation: orientation, onActivated: function () { return onStepChange(index + 1); }, onStepChange: onStepChange, transition: transition })));
            }))),
        orientation === 'horizontal' && (React.createElement(StepperContentToRender, { preserveContent: preserveContent, orientation: orientation, transition: transition, steps: steps, currentStep: currentStep, onStepChange: onStepChange }))));
};
BaSeStepper.displayName = 'BaSeStepper';

function lighting(color, lightness) {
    if (lightness === void 0) { lightness = 0.97; }
    return transformLightness(color, lightness);
}
function darking(color, lightness) {
    if (lightness === void 0) { lightness = 0.25; }
    return transformLightness(color, lightness);
}
var sidePadding = 8;
var slideIn = function (origin) { return keyframes(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  from {\n    display: block;\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    display: block;\n    opacity: 1;\n  }\n"], ["\n  from {\n    display: block;\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    display: block;\n    opacity: 1;\n  }\n"])), origin); };
var TabsContainer = styled.div(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var TabSeparator = styled.hr(templateObject_5$j || (templateObject_5$j = __makeTemplateObject(["\n  margin: 0;\n  width: 100%;\n  height: 1px;\n  border: none;\n  overflow: visible;\n  position: relative;\n  background-color: ", ";\n\n  &::before,\n  &::after {\n    content: '';\n    top: 0;\n    left: 0;\n    height: 4px;\n    position: absolute;\n    background: ", ";\n    z-index: ", ";\n  }\n\n  &::before {\n    transition: ", ";\n    will-change: transform, width;\n    ", "\n  }\n\n  &::after {\n    ", ";\n  }\n"], ["\n  margin: 0;\n  width: 100%;\n  height: 1px;\n  border: none;\n  overflow: visible;\n  position: relative;\n  background-color: ", ";\n\n  &::before,\n  &::after {\n    content: '';\n    top: 0;\n    left: 0;\n    height: 4px;\n    position: absolute;\n    background: ", ";\n    z-index: ", ";\n  }\n\n  &::before {\n    transition: ", ";\n    will-change: transform, width;\n    ", "\n  }\n\n  &::after {\n    ", ";\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90, function (_a) {
    var activeColor = _a.activeColor;
    return activeColor;
}, BaSeTheme.stackOrder.normal, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var activeLeft = _a.activeLeft, activeWidth = _a.activeWidth;
    return css(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n      transform: translateX(", "px);\n      width: ", "px;\n    "], ["\n      transform: translateX(", "px);\n      width: ", "px;\n    "])), activeLeft, activeWidth);
}, function (_a) {
    var destakLeft = _a.destakLeft, destakWidth = _a.destakWidth;
    return css(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n      transform: translateX(", "px);\n      width: ", "px;\n    "], ["\n      transform: translateX(", "px);\n      width: ", "px;\n    "])), destakLeft, destakWidth);
});
var TabHeader = styled.ul(templateObject_6$i || (templateObject_6$i = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  gap: ", ";\n  align-items: flex-end;\n  position: relative;\n\n  overflow-y: hidden;\n  overscroll-behavior-x: contain;\n  scroll-snap-type: x mandatory;\n  flex-shrink: 0;\n  min-block-size: fit-content;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  gap: ", ";\n  align-items: flex-end;\n  position: relative;\n\n  overflow-y: hidden;\n  overscroll-behavior-x: contain;\n  scroll-snap-type: x mandatory;\n  flex-shrink: 0;\n  min-block-size: fit-content;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"])), function (_a) {
    var tabGap = _a.tabGap;
    return numberWithUnit(tabGap);
});
var TabContent = styled.div(templateObject_8$e || (templateObject_8$e = __makeTemplateObject(["\n  position: relative;\n  &[hidden] {\n    display: none;\n  }\n  ", ";\n"], ["\n  position: relative;\n  &[hidden] {\n    display: none;\n  }\n  ", ";\n"])), function (_a) {
    var transition = _a.transition;
    return transition !== 'inert' && css(templateObject_7$f || (templateObject_7$f = __makeTemplateObject(["\n      animation: ", "\n        ", "\n        ", ";\n    "], ["\n      animation: ", "\n        ", "\n        ", ";\n    "])), slideIn(transition === 'leftToRight' ? -100 : 100), BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction);
});
var TabContainer = styled.li(templateObject_9$d || (templateObject_9$d = __makeTemplateObject([""], [""])));
var TabItem = styled.button(templateObject_14$8 || (templateObject_14$8 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  appearance: none;\n  outline: none;\n  border: none;\n  margin: 3px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: ", "px;\n  white-space: nowrap;\n  scroll-snap-align: start;\n  cursor: ", ";\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n\n    ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px\n      ", ";\n\n    ", "\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  appearance: none;\n  outline: none;\n  border: none;\n  margin: 3px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: ", "px;\n  white-space: nowrap;\n  scroll-snap-align: start;\n  cursor: ", ";\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n\n    ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px\n      ", ";\n\n    ", "\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, sidePadding, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var isActive = _a.isActive, inactiveColor = _a.inactiveColor;
    return isActive
        ? css(templateObject_10$b || (templateObject_10$b = __makeTemplateObject(["\n          box-shadow: 0 0 0 3px ", ";\n          background-color: ", ";\n        "], ["\n          box-shadow: 0 0 0 3px ", ";\n          background-color: ", ";\n        "])), lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : ''), lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : '')) : css(templateObject_11$9 || (templateObject_11$9 = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), BaSeTheme.colors.defaultColors.transparent);
}, function (_a) {
    var inactiveColor = _a.inactiveColor, disabled = _a.disabled;
    return !disabled && lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : '');
}, function (_a) {
    var isActive = _a.isActive, disabled = _a.disabled, inactiveColor = _a.inactiveColor, activeColor = _a.activeColor;
    return !isActive &&
        !disabled && css(templateObject_12$9 || (templateObject_12$9 = __makeTemplateObject(["\n        h5 {\n          color: ", ";\n        }\n        .BaSe--icon {\n          filter: ", ";\n        }\n        box-shadow: 0 0 0 3px ", ";\n      "], ["\n        h5 {\n          color: ", ";\n        }\n        .BaSe--icon {\n          filter: ", ";\n        }\n        box-shadow: 0 0 0 3px ", ";\n      "])), darking(activeColor !== null && activeColor !== void 0 ? activeColor : ''), transformToFilter(darking(activeColor !== null && activeColor !== void 0 ? activeColor : '')), lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : ''));
}, function (_a) {
    var inactiveColor = _a.inactiveColor;
    return lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : '', 0.9);
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_13$8 || (templateObject_13$8 = __makeTemplateObject(["\n        &:not(:hover) {\n          background-color: ", ";\n        }\n      "], ["\n        &:not(:hover) {\n          background-color: ", ";\n        }\n      "])), BaSeTheme.colors.defaultColors.transparent);
});
var CustomTabItem = styled.button(templateObject_17$5 || (templateObject_17$5 = __makeTemplateObject(["\n  appearance: none;\n  outline: none;\n  border: none;\n  position: relative;\n  display: flex;\n  align-items: center;\n  scroll-snap-align: start;\n  padding: 0;\n  margin: 3px;\n  cursor: ", ";\n\n  box-shadow: 0 0 0 3px\n    ", ";\n\n  &:hover {\n    ", "\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px\n      ", ";\n  }\n"], ["\n  appearance: none;\n  outline: none;\n  border: none;\n  position: relative;\n  display: flex;\n  align-items: center;\n  scroll-snap-align: start;\n  padding: 0;\n  margin: 3px;\n  cursor: ", ";\n\n  box-shadow: 0 0 0 3px\n    ", ";\n\n  &:hover {\n    ", "\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px\n      ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var isActive = _a.isActive, activeColor = _a.activeColor;
    return isActive ? activeColor : BaSeTheme.colors.defaultColors.transparent;
}, function (_a) {
    var isActive = _a.isActive, disabled = _a.disabled, inactiveColor = _a.inactiveColor;
    return isActive
        ? css(templateObject_15$7 || (templateObject_15$7 = __makeTemplateObject(["\n            opacity: 0.8;\n          "], ["\n            opacity: 0.8;\n          "]))) : !disabled && css(templateObject_16$6 || (templateObject_16$6 = __makeTemplateObject(["\n            box-shadow: 0 0 0 3px ", ";\n          "], ["\n            box-shadow: 0 0 0 3px ", ";\n          "])), lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : '', 0.9));
}, function (_a) {
    var isActive = _a.isActive, activeColor = _a.activeColor, inactiveColor = _a.inactiveColor;
    return isActive ? activeColor : lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : '', 0.9);
});
var templateObject_1$C, templateObject_2$y, templateObject_3$s, templateObject_4$n, templateObject_5$j, templateObject_6$i, templateObject_7$f, templateObject_8$e, templateObject_9$d, templateObject_10$b, templateObject_11$9, templateObject_12$9, templateObject_13$8, templateObject_14$8, templateObject_15$7, templateObject_16$6, templateObject_17$5;

var outlineSize = 3;
var BaSeTab = function (_a) {
    var title = _a.title, index = _a.index, isActive = _a.isActive, _b = _a.activeColor, activeColor = _b === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _b, _c = _a.inactiveColor, inactiveColor = _c === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, onActivatedTabIndex = _a.onActivatedTabIndex, onActiveItem = _a.onActiveItem, onDestakItem = _a.onDestakItem;
    var itemRef = React__default.createRef();
    var label = React__default.useMemo(function () {
        return typeof title === 'string'
            ? title
            : typeof title === 'object' && 'label' in title
                ? title.label
                : undefined;
    }, [title]);
    var icon = React__default.useMemo(function () {
        return typeof title === 'object' && 'iconName' in title
            ? {
                name: title.iconName,
                description: title.iconDescription,
                size: title.iconSize,
            }
            : undefined;
    }, [title]);
    var renderCustomTab = React__default.useMemo(function () { return (typeof title === 'function' ? title : undefined); }, [title]);
    var onSelectedItem = React__default.useCallback(function () {
        var _a, _b;
        var rect = (_a = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var offsetLeft = (_b = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _b === void 0 ? void 0 : _b.offsetLeft;
        var tabLeft = offsetLeft ? offsetLeft - outlineSize : 0;
        var tabWidth = (rect === null || rect === void 0 ? void 0 : rect.width) ? (rect === null || rect === void 0 ? void 0 : rect.width) + outlineSize * 2 : 0;
        onDestakItem(0, 0);
        onActiveItem(tabLeft, tabWidth);
        onActivatedTabIndex(index);
    }, [itemRef, onDestakItem, onActiveItem, onActivatedTabIndex, index]);
    React__default.useEffect(function () {
        if (isActive) {
            onSelectedItem();
        }
    }, [isActive, onSelectedItem]);
    return (React__default.createElement(TabContainer, { className: "BaSe--tab", isActive: isActive }, renderCustomTab ? (React__default.createElement(CustomTabItem, { ref: itemRef, isActive: isActive, activeColor: activeColor, disabled: isDisabled, inactiveColor: inactiveColor, onClick: onSelectedItem }, renderCustomTab(isActive, isDisabled))) : (React__default.createElement(TabItem, { ref: itemRef, isActive: isActive, disabled: isDisabled, activeColor: activeColor, inactiveColor: inactiveColor, onClick: onSelectedItem },
        React__default.createElement(BaSeHeading5, { isBold: isActive, color: isActive ? activeColor : inactiveColor }, label),
        icon && (React__default.createElement(BaSeIcon, { name: icon.name, size: numberWithUnit(icon.size), color: isActive ? activeColor : inactiveColor, description: icon.description }))))));
};
BaSeTab.displayName = 'BaSeTab';

var BaSeTabContent = React.memo(function (_a) {
    var canGotoTab = _a.canGotoTab, gotoTab = _a.gotoTab, content = _a.content;
    return content === null || content === void 0 ? void 0 : content({ canGotoTab: canGotoTab, gotoTab: gotoTab });
});
BaSeTabContent.displayName = 'BaSeTabContent';

var BaSeTabs = function (_a) {
    var _b;
    var tabs = _a.tabs, _c = _a.activatedTabIndex, activatedTabIndex = _c === void 0 ? 0 : _c, _d = _a.tabGap, tabGap = _d === void 0 ? '1.5em' : _d, _e = _a.withTransition, withTransition = _e === void 0 ? false : _e, _f = _a.preserveContent, preserveContent = _f === void 0 ? false : _f, _g = _a.activeColor, activeColor = _g === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _g, _h = _a.inactiveColor, inactiveColor = _h === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _h, onActivatedTabIndex = _a.onActivatedTabIndex;
    var tabsRef = React.createRef();
    var _j = React.useState(activatedTabIndex), lastActivatedTabIndex = _j[0], setLastActivatedTabIndex = _j[1];
    var _k = React.useState(0), activatedTabLeft = _k[0], setActivatedTabLeft = _k[1];
    var _l = React.useState(0), activatedTabWidth = _l[0], setActivatedTabWidth = _l[1];
    var _m = React.useState(0), destakTabLeft = _m[0], setDestakTabLeft = _m[1];
    var _o = React.useState(0), destakTabWidth = _o[0], setDestakTabWidth = _o[1];
    var _p = React.useState('inert'), transition = _p[0], setTransition = _p[1];
    if (!Array.isArray(tabs) || (tabs === null || tabs === void 0 ? void 0 : tabs.length) === 0) {
        throw Error('Prop "tabs" é obrigatória');
    }
    if (!onActivatedTabIndex) {
        throw Error('Prop "onActivatedTabIndex" é obrigatório');
    }
    React.useEffect(function () {
        onActivatedTabIndex(activatedTabIndex);
        return function () { return setLastActivatedTabIndex(activatedTabIndex); };
    }, [activatedTabIndex, onActivatedTabIndex]);
    React.useEffect(function () {
        if (withTransition) {
            setTransition(function () {
                return lastActivatedTabIndex < activatedTabIndex
                    ? 'leftToRight'
                    : 'rightToLeft';
            });
            setTimeout(function () { return setTransition('inert'); }, BaSeTheme.transitions.durationNormalInMilliseconds);
        }
    }, [activatedTabIndex, lastActivatedTabIndex, withTransition]);
    var findIndex = React.useCallback(function (query) {
        var _a;
        return ((_a = query === null || query === void 0 ? void 0 : query.withIndex) !== null && _a !== void 0 ? _a : tabs.findIndex(function (tab) { return tab.title === (query === null || query === void 0 ? void 0 : query.withTitle); }));
    }, [tabs]);
    return (React.createElement(TabsContainer, { className: "BaSe--tabs" },
        React.createElement(TabHeader, { ref: tabsRef, tabGap: tabGap, onScroll: function () {
                setActivatedTabLeft(function (actual) { var _a, _b; return actual - ((_b = (_a = tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) !== null && _b !== void 0 ? _b : 0); });
            } }, tabs.map(function (_a, index) {
            var title = _a.title, isDisabled = _a.isDisabled;
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(BaSeTab, { title: title, index: index, activeColor: activeColor, inactiveColor: inactiveColor, isActive: activatedTabIndex === index, isDisabled: isDisabled, onActivatedTabIndex: function (tabIndex) {
                        onActivatedTabIndex(tabIndex);
                    }, onActiveItem: function (tabLeft, tabWidth) {
                        setActivatedTabLeft(tabLeft);
                        setActivatedTabWidth(tabWidth);
                    }, onDestakItem: function (tabLeft, tabWidth) {
                        setDestakTabLeft(tabLeft);
                        setDestakTabWidth(tabWidth);
                    } })));
        })),
        React.createElement(TabSeparator, { activeLeft: activatedTabLeft, activeWidth: activatedTabWidth, activeColor: activeColor, destakLeft: destakTabLeft, destakWidth: destakTabWidth }),
        preserveContent ? (tabs.map(function (_a, index) {
            var content = _a.content;
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(TabContent, { as: "section", className: "BaSe--tab-content", transition: transition, hidden: index !== activatedTabIndex },
                    React.createElement(BaSeTabContent, { canGotoTab: function (query) { var _a, _b; return (_b = !((_a = tabs === null || tabs === void 0 ? void 0 : tabs[findIndex(query)]) === null || _a === void 0 ? void 0 : _a.isDisabled)) !== null && _b !== void 0 ? _b : false; }, gotoTab: function (query) { return onActivatedTabIndex(findIndex(query)); }, content: content }))));
        })) : (React.createElement(TabContent, { as: "section", className: "BaSe--tab-content", transition: transition },
            React.createElement(BaSeTabContent, { canGotoTab: function (query) { var _a, _b; return (_b = !((_a = tabs === null || tabs === void 0 ? void 0 : tabs[findIndex(query)]) === null || _a === void 0 ? void 0 : _a.isDisabled)) !== null && _b !== void 0 ? _b : false; }, gotoTab: function (query) { return onActivatedTabIndex(findIndex(query)); }, content: (_b = tabs[activatedTabIndex]) === null || _b === void 0 ? void 0 : _b.content })))));
};
BaSeTabs.displayName = 'BaSeTabs';

var BaSeBoardContext = React.createContext({
    columns: [],
    setColumns: function () { },
});
var BaSeBoardProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState([]), columns = _b[0], setColumns = _b[1];
    return (React.createElement(BaSeBoardContext.Provider, { value: {
            columns: columns,
            setColumns: setColumns,
        } }, children));
};
BaSeBoardContext.Consumer;

var BoardListsWrapper = styled.section.attrs({
    className: 'BaSe--board',
})(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  &.BaSe--board {\n    gap: 0.5em;\n    padding: 1em;\n\n    min-height: 0;\n    height: 100%;\n    margin: auto;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.4);\n      pointer-events: none;\n      z-index: 1;\n      display: ", ";\n    }\n  }\n"], ["\n  &.BaSe--board {\n    gap: 0.5em;\n    padding: 1em;\n\n    min-height: 0;\n    height: 100%;\n    margin: auto;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.4);\n      pointer-events: none;\n      z-index: 1;\n      display: ", ";\n    }\n  }\n"])), function (_a) {
    var loadingValidDrop = _a.loadingValidDrop;
    return loadingValidDrop ? 'block' : 'none';
});
var BoardColumnContainer = styled.section.attrs({
    className: 'BaSe--board-column-container',
})(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  &.BaSe--board-column-container {\n    height: 100%;\n    padding: 0.5em;\n    gap: 1em;\n    display: flex;\n    justify-content: flex-start;\n    overflow-x: auto;\n  }\n"], ["\n  &.BaSe--board-column-container {\n    height: 100%;\n    padding: 0.5em;\n    gap: 1em;\n    display: flex;\n    justify-content: flex-start;\n    overflow-x: auto;\n  }\n"])));
var ContainerLoading = styled.div.attrs({
    className: 'BaSe--container-loading',
})(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  &.BaSe--container-loading {\n    flex: 1;\n  }\n"], ["\n  &.BaSe--container-loading {\n    flex: 1;\n  }\n"])));
var BoardItemsWrapper = styled.div.attrs({
    className: 'BaSe--board-items',
})(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n  &.BaSe--board-items {\n  }\n"], ["\n  &.BaSe--board-items {\n  }\n"])));
var BoardItem = styled.div.attrs({
    className: 'BaSe--board-item',
})(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n  &.BaSe--board-item {\n    margin: 10px 0;\n  }\n"], ["\n  &.BaSe--board-item {\n    margin: 10px 0;\n  }\n"])));
var BoardWithoutItems = styled.section.attrs({
    className: 'BaSe--board-without-items',
})(templateObject_7$e || (templateObject_7$e = __makeTemplateObject(["\n  &.BaSe--board-without-items {\n    ", "\n\n    padding: 1em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    white-space: initial;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n  }\n"], ["\n  &.BaSe--board-without-items {\n    ", "\n\n    padding: 1em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    white-space: initial;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n  }\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return css(templateObject_6$h || (templateObject_6$h = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), bgColor !== null && bgColor !== void 0 ? bgColor : BaSeTheme.colors.defaultColors.lightGray);
});
var BoardItemListWrapper = styled.div.attrs({
    className: 'BaSe--board--list--item--wrapper',
})(templateObject_8$d || (templateObject_8$d = __makeTemplateObject(["\n  &.BaSe--board--list--item--wrapper {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    user-select: none;\n  }\n"], ["\n  &.BaSe--board--list--item--wrapper {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    user-select: none;\n  }\n"])));
var BoardColumnHeader = styled.section.attrs({
    className: 'BaSe--board-column-header',
})(templateObject_10$a || (templateObject_10$a = __makeTemplateObject(["\n  &.BaSe--board-column-header {\n    ", "\n\n    height: 47px;\n    padding: 5px 10px;\n    border-radius: 12px 12px 0px 0px;\n    display: flex;\n    justify-content: space-between;\n\n    position: relative;\n  }\n"], ["\n  &.BaSe--board-column-header {\n    ", "\n\n    height: 47px;\n    padding: 5px 10px;\n    border-radius: 12px 12px 0px 0px;\n    display: flex;\n    justify-content: space-between;\n\n    position: relative;\n  }\n"])), function (_a) {
    var bgColorHeader = _a.bgColorHeader;
    return css(templateObject_9$c || (templateObject_9$c = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), bgColorHeader !== null && bgColorHeader !== void 0 ? bgColorHeader : BaSeTheme.colors.institucionais.azulSebrae36);
});
var BoardColumnCompressed = styled.section.attrs({
    className: 'BaSe--board-column-compressed',
})(templateObject_12$8 || (templateObject_12$8 = __makeTemplateObject(["\n  &.BaSe--board-column-compressed {\n    ", "\n\n    width: 3.75em;\n    padding: 5px 10px;\n    border-radius: 12px 12px 0px 0px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1em;\n  }\n"], ["\n  &.BaSe--board-column-compressed {\n    ", "\n\n    width: 3.75em;\n    padding: 5px 10px;\n    border-radius: 12px 12px 0px 0px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1em;\n  }\n"])), function (_a) {
    var bgColorHeader = _a.bgColorHeader;
    return css(templateObject_11$8 || (templateObject_11$8 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), bgColorHeader !== null && bgColorHeader !== void 0 ? bgColorHeader : BaSeTheme.colors.institucionais.azulSebrae36);
});
var AlignHeaderTitle = styled.section.attrs({
    className: 'BaSe--board-align-title-header',
})(templateObject_13$7 || (templateObject_13$7 = __makeTemplateObject(["\n  &.BaSe--board-align-title-header {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n    text-align: center;\n    padding: 5px 0;\n  }\n"], ["\n  &.BaSe--board-align-title-header {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n    text-align: center;\n    padding: 5px 0;\n  }\n"])));
var AlignTitleCollumnCompressed = styled.section.attrs({
    className: 'BaSe--board-align-title-collumn-compressed',
})(templateObject_14$7 || (templateObject_14$7 = __makeTemplateObject(["\n  &.BaSe--board-align-title-collumn-compressed {\n    writing-mode: vertical-lr;\n  }\n"], ["\n  &.BaSe--board-align-title-collumn-compressed {\n    writing-mode: vertical-lr;\n  }\n"])));
styled.section.attrs({
    className: 'BaSe--board-align-header-right',
})(templateObject_15$6 || (templateObject_15$6 = __makeTemplateObject(["\n  &.BaSe--board-align-header-right {\n    position: absolute;\n    right: 0;\n    top: 48%;\n    transform: translateY(-48%);\n  }\n"], ["\n  &.BaSe--board-align-header-right {\n    position: absolute;\n    right: 0;\n    top: 48%;\n    transform: translateY(-48%);\n  }\n"])));
var BoardColumnContent = styled.div.attrs({
    className: 'BaSe--board-column-content',
})(templateObject_17$4 || (templateObject_17$4 = __makeTemplateObject(["\n  padding: 10px;\n  ", "\n\n  height: 80vh;\n  -ms-overflow-style: none;\n  overflow-y: scroll;\n"], ["\n  padding: 10px;\n  ", "\n\n  height: 80vh;\n  -ms-overflow-style: none;\n  overflow-y: scroll;\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return css(templateObject_16$5 || (templateObject_16$5 = __makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), bgColor !== null && bgColor !== void 0 ? bgColor : BaSeTheme.colors.defaultColors.lightGray);
});
var templateObject_1$B, templateObject_2$x, templateObject_3$r, templateObject_4$m, templateObject_5$i, templateObject_6$h, templateObject_7$e, templateObject_8$d, templateObject_9$c, templateObject_10$a, templateObject_11$8, templateObject_12$8, templateObject_13$7, templateObject_14$7, templateObject_15$6, templateObject_16$5, templateObject_17$4;

var ListWithoutItems = function (_a) {
    var column = _a.column, provided = _a.provided;
    return (React__default.createElement(BoardWithoutItems, __assign({ bgColor: column.backgroundColor }, provided.droppableProps, { ref: provided.innerRef }),
        React__default.createElement(BaSeSmall1, { color: BaSeTheme.colors.institucionais.azulSebrae36 },
            React__default.createElement(BaSeI18nConsumer, null, function (_a) {
                var _b;
                var getMessage = _a.getMessage;
                return (_b = column.textWithoutItems) !== null && _b !== void 0 ? _b : getMessage('board.columnPlaceholder');
            }),
            provided.placeholder)));
};

var ColumnCompressed = function (_a) {
    var _b, _c, _d;
    var header = _a.header, destakBackgroundColor = _a.destakBackgroundColor, destakForegroundColor = _a.destakForegroundColor, columnCompressed = _a.columnCompressed, handleCompress = _a.handleCompress, provided = _a.provided;
    var nameIcon = columnCompressed ? 'angle-right' : 'angle-left';
    return (React.createElement(BoardColumnCompressed, __assign({ bgColorHeader: (_b = header.backgroundColor) !== null && _b !== void 0 ? _b : destakBackgroundColor }, provided.droppableProps, { ref: provided.innerRef }),
        React.createElement(React.Fragment, null,
            React.createElement(BaSeShapeButton, { buttonType: "button", color: BaSeTheme.colors.defaultColors.white, name: nameIcon, onClick: function () { return handleCompress && handleCompress(); }, shape: "square", size: "medium", sizeIcon: "medium", type: "tertiary", nameIcon: nameIcon })),
        React.createElement(AlignTitleCollumnCompressed, null,
            React.createElement(BaSeParagraph, { isBold: true, color: (_c = destakForegroundColor !== null && destakForegroundColor !== void 0 ? destakForegroundColor : header.foregroundColor) !== null && _c !== void 0 ? _c : BaSeTheme.colors.defaultColors.white }, header.title),
            header.subTitle && (React.createElement(BaSeParagraph, { color: (_d = destakForegroundColor !== null && destakForegroundColor !== void 0 ? destakForegroundColor : header.foregroundColor) !== null && _d !== void 0 ? _d : BaSeTheme.colors.defaultColors.white }, header.subTitle)))));
};
var HeaderColumn = function (_a) {
    var _b, _c, _d;
    var header = _a.header, items = _a.items, destakBackgroundColor = _a.destakBackgroundColor, destakForegroundColor = _a.destakForegroundColor, columnCompressed = _a.columnCompressed, handleCompress = _a.handleCompress;
    var nameIcon = columnCompressed ? 'angle-right' : 'angle-left';
    return (React.createElement(BoardColumnHeader, { bgColorHeader: (_b = header.backgroundColor) !== null && _b !== void 0 ? _b : destakBackgroundColor },
        React.createElement("div", { style: { zIndex: 9999999 } }, header.hasCompression && header.hasCompression && (React.createElement(BaSeShapeButton, { buttonType: "button", color: BaSeTheme.colors.defaultColors.white, name: nameIcon, onClick: function () { return handleCompress && handleCompress(); }, shape: "square", size: "medium", sizeIcon: "medium", type: "tertiary", nameIcon: nameIcon }))),
        React.createElement(AlignHeaderTitle, null,
            React.createElement(BaSeParagraph, { isBold: true, color: (_c = destakForegroundColor !== null && destakForegroundColor !== void 0 ? destakForegroundColor : header.foregroundColor) !== null && _c !== void 0 ? _c : BaSeTheme.colors.defaultColors.white }, header.title),
            header.subTitle && (React.createElement(BaSeParagraph, { color: (_d = destakForegroundColor !== null && destakForegroundColor !== void 0 ? destakForegroundColor : header.foregroundColor) !== null && _d !== void 0 ? _d : BaSeTheme.colors.defaultColors.white }, header.subTitle))),
        !columnCompressed && header.render && header.render(items)));
};
var ColumnItems = function (_a) {
    var items = _a.items, loading = _a.loading;
    return (React.createElement(BoardItemsWrapper, null,
        items.map(function (item, index) { return (React.createElement("div", { key: item.id },
            React.createElement(Draggable, { draggableId: item.id.toString(), index: index, isDragDisabled: item.isDragDisabled }, function (provided) {
                return (React.createElement(BoardItem, __assign({ key: item.id, ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps), item.render(item)));
            }))); }),
        loading && (React.createElement("div", null,
            React.createElement(BaSeLoading, { lightMode: "default", shadowLevel: 0, spinnerColor: "", spinnerSize: 24, text: "Carregando\u2026" // TODO i18n aqui :/
                , textColor: "" })))));
};
var ContentColumnItem = function (_a) {
    // const items = React.useMemo(() => column.items ?? [], [column.items]);
    var provided = _a.provided, destakBackgroundColor = _a.destakBackgroundColor, destakForegroundColor = _a.destakForegroundColor, onFetchColumnItem = _a.onFetchColumnItem, column = _a.column, setColumns = _a.setColumns, itemMaxWidth = _a.itemMaxWidth, itemMinWidth = _a.itemMinWidth;
    var setItems = React.useCallback(function (list, event) {
        if (event === 'SCROLL') {
            setColumns(function (prevColumns) {
                var newPrev = prevColumns.map(function (pc) {
                    return pc.id === column.id
                        ? __assign(__assign({}, pc), { items: __spreadArray(__spreadArray([], pc.items, true), (list !== null && list !== void 0 ? list : []), true) }) : pc;
                });
                return newPrev;
            });
            return;
        }
        setColumns(function (prevColumns) {
            return prevColumns.map(function (pc) {
                return pc.id === column.id ? __assign(__assign({}, pc), { items: list !== null && list !== void 0 ? list : [] }) : pc;
            });
        });
    }, [column]);
    var KEY = "cacheKeyCompress-".concat(column.id);
    // const [items, setItems] = React.useState<BoardItem[]>([]);
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(false), loadingMore = _c[0], setLoadingMore = _c[1];
    var _d = React.useState(true), hassMoreItems = _d[0], setHasMoreItems = _d[1];
    var _e = React.useState(false), setLoadingInitial = _e[1];
    var _f = React.useState(''), typeLoading = _f[0], setTypeLoading = _f[1];
    var _g = React.useState(false), columnCompressed = _g[0], setColumnCompressed = _g[1];
    var listRef = React.useRef(null);
    var loadingRef = React.useRef(false);
    var handleCompress = React.useCallback(function () {
        setColumnCompressed(function (prev) {
            localStorage.setItem(KEY, JSON.stringify(!prev));
            return !prev;
        });
    }, [KEY]);
    React.useEffect(function () {
        var value = localStorage.getItem(KEY);
        if (value) {
            setColumnCompressed(JSON.parse(value));
        }
    }, [KEY]);
    var handleFetchColumnItem = React.useCallback(function (event) {
        var _a;
        if (loadingRef.current)
            return;
        loadingRef.current = true;
        setLoadingMore(true);
        var result = (_a = onFetchColumnItem === null || onFetchColumnItem === void 0 ? void 0 : onFetchColumnItem(event)) !== null && _a !== void 0 ? _a : [];
        if (Array.isArray(result)) {
            setItems(result, event.type);
            loadingRef.current = false;
            setLoadingInitial(false);
            setTypeLoading(event.type);
            setHasMoreItems(false);
            return;
        }
        result
            .then(function (response) {
            if (response === undefined || response.length === 0) {
                setHasMoreItems(false);
            }
            else {
                setHasMoreItems(true);
                setLoadingMore(true);
                setItems(response, event.type);
                setTypeLoading(event.type);
            }
        })
            .catch(function () {
            setLoading(false);
            setLoadingMore(false);
        })
            .finally(function () {
            loadingRef.current = false;
            setLoadingMore(false);
            setTypeLoading('FINALLY');
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onFetchColumnItem]);
    var handleReload = React.useCallback(function () {
        handleFetchColumnItem({ column: column, type: 'RELOAD' });
        setTypeLoading('RELOAD');
    }, [handleFetchColumnItem, column]);
    var handleScroll = React.useCallback(function () {
        if (!hassMoreItems)
            return;
        var list = listRef.current;
        if (list) {
            var some = Number(list.scrollTop + list.clientHeight + 10).toFixed(2);
            var end = Number(some) >= list.scrollHeight;
            if (end) {
                // onFetchColumnItem?.({ column } as BoardItemEvent, onFetchItem);
                handleFetchColumnItem({ column: column, type: 'SCROLL' });
            }
        }
    }, [handleFetchColumnItem, hassMoreItems, column]);
    React.useEffect(function () {
        var list = listRef.current;
        if (list) {
            list.addEventListener('scroll', handleScroll);
            return function () {
                list.removeEventListener('scroll', handleScroll);
            };
        }
        return undefined;
    });
    React.useEffect(function () {
        if (column.items.length === 0) {
            handleFetchColumnItem({ column: column, type: 'INITIAL' });
            setTypeLoading('INITIAL');
        }
    }, [handleFetchColumnItem, column.items.length]);
    if (columnCompressed) {
        return (React.createElement(ColumnCompressed, { header: column.header, items: column.items, destakBackgroundColor: destakBackgroundColor, destakForegroundColor: destakForegroundColor, onReload: handleReload, columnCompressed: columnCompressed, handleCompress: handleCompress, provided: provided }));
    }
    if (typeLoading === 'INITIAL') {
        return (React.createElement("div", __assign({ style: {
                maxWidth: "".concat(itemMaxWidth, "px"),
                minWidth: "".concat(itemMinWidth, "px"),
            }, ref: provided.innerRef }, provided.droppableProps),
            React.createElement(HeaderColumn, { header: column.header, items: column.items, destakBackgroundColor: destakBackgroundColor, destakForegroundColor: destakForegroundColor, onReload: handleReload, columnCompressed: columnCompressed, handleCompress: handleCompress, provided: provided }),
            React.createElement(ContainerLoading, null,
                React.createElement(BaSeLoading, { lightMode: "default", shadowLevel: 0, spinnerColor: "", spinnerSize: 24, text: "Carregando\u2026", textColor: "" }))));
    }
    return (React.createElement("div", { style: {
            maxWidth: "".concat(itemMaxWidth, "px"),
            minWidth: "".concat(itemMinWidth, "px"),
        } },
        React.createElement(HeaderColumn, { header: column.header, items: column.items, destakBackgroundColor: destakBackgroundColor, destakForegroundColor: destakForegroundColor, onReload: handleReload, columnCompressed: columnCompressed, handleCompress: handleCompress, provided: provided }),
        React.createElement(BoardItemListWrapper, { loading: loading }, column.items.length > 0 ? (React.createElement("div", __assign({}, provided.droppableProps, { ref: provided.innerRef }),
            React.createElement(BoardColumnContent, { id: "colunascrool", ref: listRef, bgColor: column.backgroundColor },
                React.createElement(ColumnItems, { items: column.items, loading: loadingMore }),
                provided.placeholder))) : (React.createElement(ListWithoutItems, { column: column, provided: provided })))));
};
var BoardWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement(BaSeBoardProvider, null, children));
};
var BaSeBoard = function (_a) {
    var columnsExternal = _a.columns, itemListMinWidth = _a.itemListMinWidth, itemListMaxWidth = _a.itemListMaxWidth, onFetchColumnItem = _a.onFetchColumnItem, validateDrop = _a.validateDrop, onDrop = _a.onDrop, handleCompressColumn = _a.handleCompressColumn;
    var _b = React.useState(columnsExternal), columns = _b[0], setColumns = _b[1];
    var _c = React.useState(false), loadingValidDrop = _c[0], setLoadingValidDrop = _c[1];
    React.useEffect(function () {
        setColumns(columnsExternal);
    }, [columnsExternal]);
    var commitDrop = React.useCallback(function (result, boardItemEvent) {
        setColumns(function (prevColumns) {
            var _a;
            var updatedColumns = __spreadArray([], prevColumns, true);
            var sourceColumn = updatedColumns.filter(function (column) {
                return column.items.some(function (item) { return item.id === Number(result.draggableId); });
            })[0];
            var targetColumn = updatedColumns.filter(function (column) { var _a; return column.id === Number((_a = result.destination) === null || _a === void 0 ? void 0 : _a.droppableId); })[0];
            var itemToMove = sourceColumn === null || sourceColumn === void 0 ? void 0 : sourceColumn.items.filter(function (item) { return item.id === Number(result.draggableId); })[0];
            sourceColumn.items = sourceColumn.items.filter(function (item) { return item.id !== Number(result.draggableId); });
            var destinationIndex = ((_a = result.destination) === null || _a === void 0 ? void 0 : _a.index) || 0;
            targetColumn.items = __spreadArray(__spreadArray(__spreadArray([], targetColumn.items.slice(0, destinationIndex), true), [
                itemToMove
            ], false), targetColumn.items.slice(destinationIndex), true);
            return updatedColumns;
        });
        onDrop === null || onDrop === void 0 ? void 0 : onDrop(boardItemEvent);
    }, [onDrop]);
    var handleDragEnd = React.useCallback(function (result) {
        var _a, _b;
        if (!result.destination) {
            return;
        }
        if (((_a = result.destination) === null || _a === void 0 ? void 0 : _a.droppableId) === undefined) {
            return;
        }
        if (result.source.droppableId === result.destination.droppableId) {
            return;
        }
        var boardItemEvent = {
            item: { id: result.draggableId },
            columnOrigin: { id: result.source.droppableId },
            columnTarget: { id: result.destination.droppableId },
        };
        var resultValidateDrop = (_b = validateDrop === null || validateDrop === void 0 ? void 0 : validateDrop(boardItemEvent)) !== null && _b !== void 0 ? _b : true;
        if (typeof resultValidateDrop === 'boolean') {
            if (resultValidateDrop) {
                commitDrop(result, boardItemEvent);
            }
            return;
        }
        setLoadingValidDrop(true);
        resultValidateDrop
            .then(function (bool) {
            if (bool) {
                commitDrop(result, boardItemEvent);
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () { return setLoadingValidDrop(false); });
    }, [commitDrop, validateDrop]);
    return (React.createElement(BoardWrapper, null,
        React.createElement(DragDropContext, { onDragEnd: handleDragEnd },
            React.createElement(BoardListsWrapper, { length: columns.length, itemMinWidth: itemListMinWidth, itemMaxWidth: itemListMaxWidth, loadingValidDrop: loadingValidDrop },
                React.createElement(BoardColumnContainer, null, columns.map(function (column) { return (React.createElement(Droppable, { key: column.id, type: "COLUMN", direction: "vertical", droppableId: String(column.id) }, function (provided) { return (React.createElement(ContentColumnItem, { onFetchColumnItem: onFetchColumnItem, provided: provided, column: column, setColumns: setColumns, itemMinWidth: itemListMinWidth, itemMaxWidth: itemListMaxWidth, handleCompressColumn: handleCompressColumn })); })); }))))));
};

var BaSeDataRowInfoContext = React.createContext({
    rowInfo: undefined,
    setRowInfo: function () { },
});
var BaSeDataRowInfoProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), rowInfo = _b[0], setRowInfo = _b[1];
    return (React.createElement(BaSeDataRowInfoContext.Provider, { value: {
            rowInfo: rowInfo,
            setRowInfo: setRowInfo,
        } }, children));
};
var BaSeDataRowInfoConsumer = BaSeDataRowInfoContext.Consumer;

var BaSeDataInfoContext = React.createContext({
    info: undefined,
    setInfo: function () { },
});
var BaSeDataInfoProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), info = _b[0], setInfo = _b[1];
    return (React.createElement(BaSeDataInfoContext.Provider, { value: {
            info: info,
            setInfo: setInfo,
        } }, children));
};
var BaSeDataInfoConsumer = BaSeDataInfoContext.Consumer;

var ArrowButton = styled.button(templateObject_15$5 || (templateObject_15$5 = __makeTemplateObject(["\n  ", "\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n\n    .arrow-shape {\n      box-shadow: none;\n    }\n  }\n"], ["\n  ", "\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n\n    .arrow-shape {\n      box-shadow: none;\n    }\n  }\n"])), function (_a) {
    var borderRadius = _a.borderRadius, background = _a.background, border = _a.border, borderColor = _a.borderColor, isLeft = _a.isLeft, hasBoxShadow = _a.hasBoxShadow, hoverColor = _a.hoverColor, isSecondaryNegative = _a.isSecondaryNegative, boxShadowFocus = _a.boxShadowFocus, textHoverColor = _a.textHoverColor, borderHoverColor = _a.borderHoverColor, isDisabled = _a.isDisabled;
    return css(templateObject_14$6 || (templateObject_14$6 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: flex;\n    height: 40px;\n    padding: 7px;\n    box-sizing: border-box;\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: ", ";\n    border-top: ", " solid ", ";\n    border-right: ", ";\n    border-left: ", ";\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: pointer;\n    border-bottom: ", " solid ", ";\n    transition: ", ";\n\n    ", ";\n    ", "\n\n    span {\n      z-index: ", ";\n    }\n\n    .arrow-shape {\n      border: ", " solid ", ";\n      ", "\n    }\n\n    .arrow-body {\n      background-color: ", ";\n    }\n\n    &:hover {\n      ", "\n      ", "\n    .arrow-shape {\n        ", "\n        ", "\n      }\n      .arrow-body {\n        background-color: ", ";\n      }\n\n      span {\n        ", "\n      }\n    }\n\n    ", "\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: flex;\n    height: 40px;\n    padding: 7px;\n    box-sizing: border-box;\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: ", ";\n    border-top: ", " solid ", ";\n    border-right: ", ";\n    border-left: ", ";\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: pointer;\n    border-bottom: ", " solid ", ";\n    transition: ", ";\n\n    ", ";\n    ", "\n\n    span {\n      z-index: ", ";\n    }\n\n    .arrow-shape {\n      border: ", " solid ", ";\n      ", "\n    }\n\n    .arrow-body {\n      background-color: ", ";\n    }\n\n    &:hover {\n      ", "\n      ", "\n    .arrow-shape {\n        ", "\n        ", "\n      }\n      .arrow-body {\n        background-color: ", ";\n      }\n\n      span {\n        ", "\n      }\n    }\n\n    ", "\n  "])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, numberWithUnit(borderRadius), background, BaSeTheme.stackOrder.normal + 2, border, borderColor, isLeft ? "".concat(border, " solid ").concat(borderColor) : '0px', !isLeft ? "".concat(border, " solid ").concat(borderColor) : '0px', border, borderColor, BaSeTheme.transitions.allPropertiesContinuousFast, isLeft
        ? css(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n          margin-left: 20px;\n          padding-left: 36px;\n          padding-right: 12px;\n        "], ["\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n          margin-left: 20px;\n          padding-left: 36px;\n          padding-right: 12px;\n        "])), isSecondaryNegative ? 0 : 1, isSecondaryNegative ? 0 : 1) : css(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n          margin-right: 20px;\n          padding-right: 36px;\n          padding-left: 12px;\n        "], ["\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n          margin-right: 20px;\n          padding-right: 36px;\n          padding-left: 12px;\n        "])), isSecondaryNegative ? 0 : 1, isSecondaryNegative ? 0 : 1), hasBoxShadow && css(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n      box-shadow: 0px 2px 4px ", ";\n    "], ["\n      box-shadow: 0px 2px 4px ", ";\n    "])), BaSeTheme.colors.defaultColors.shadowColor), BaSeTheme.stackOrder.aboveNormal, border, borderColor, (!isSecondaryNegative || isDisabled) && css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), background), background, css(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), hoverColor), borderHoverColor && "border-color: ".concat(borderHoverColor, ";"), css(templateObject_6$g || (templateObject_6$g = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), hoverColor), borderHoverColor && css(templateObject_7$d || (templateObject_7$d = __makeTemplateObject(["\n          border-color: ", ";\n        "], ["\n          border-color: ", ";\n        "])), borderHoverColor), hoverColor, textHoverColor && "color: ".concat(textHoverColor, ";"), isSecondaryNegative
        ? css(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n        &:focus {\n          outline: none;\n          border: 2px solid ", ";\n          border-", ":none;\n          .arrow-shape {\n            border: 2px solid ", ";\n          }\n          .arrow-shape {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n          .arrow-body {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n\n          ", "\n        }\n      "], ["\n        &:focus {\n          outline: none;\n          border: 2px solid ", ";\n          border-", ":none;\n          .arrow-shape {\n            border: 2px solid ", ";\n          }\n          .arrow-shape {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n          .arrow-body {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n\n          ", "\n        }\n      "])), BaSeTheme.colors.defaultColors.transparent, isLeft ? 'left' : 'right', BaSeTheme.colors.defaultColors.transparent, boxShadowFocus, boxShadowFocus, isLeft
            ? css(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n                  box-shadow:\n                    3px 3px 0px 0px ", ",\n                    3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "], ["\n                  box-shadow:\n                    3px 3px 0px 0px ", ",\n                    3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus, boxShadowFocus) : css(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n                  box-shadow:\n                    -3px 3px 0px 0px ", ",\n                    -3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "], ["\n                  box-shadow:\n                    -3px 3px 0px 0px ", ",\n                    -3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus, boxShadowFocus)) : css(templateObject_13$6 || (templateObject_13$6 = __makeTemplateObject(["\n          &:focus {\n            outline: none;\n            ", ";\n\n            .arrow-shape {\n              box-shadow: 0px 0px 0px 3px ", ";\n              border-color: ", ";\n            }\n            border-color: ", ";\n          }\n        "], ["\n          &:focus {\n            outline: none;\n            ", ";\n\n            .arrow-shape {\n              box-shadow: 0px 0px 0px 3px ", ";\n              border-color: ", ";\n            }\n            border-color: ", ";\n          }\n        "])), isLeft
        ? css(templateObject_11$7 || (templateObject_11$7 = __makeTemplateObject(["\n                  box-shadow:\n                    1px 3px 0px 0px ", ",\n                    1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "], ["\n                  box-shadow:\n                    1px 3px 0px 0px ", ",\n                    1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus) : css(templateObject_12$7 || (templateObject_12$7 = __makeTemplateObject(["\n                  box-shadow:\n                    -1px 3px 0px 0px ", ",\n                    -1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "], ["\n                  box-shadow:\n                    -1px 3px 0px 0px ", ",\n                    -1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus), boxShadowFocus, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent));
});
var ArrowStyledContainer = styled.div.attrs({
    className: 'arrow-shape',
})(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isLeft = _a.isLeft, clip = _a.clip, isSecondaryNegative = _a.isSecondaryNegative, boxShadow = _a.boxShadow;
    return css(templateObject_20$2 || (templateObject_20$2 = __makeTemplateObject(["\n    position: absolute;\n    box-sizing: border-box;\n    ", "\n    width: 30.5px;\n    height: 30.5px;\n    border-radius: 4px;\n    clip-path: ", ";\n    transform: rotate(", ");\n    ", ";\n  "], ["\n    position: absolute;\n    box-sizing: border-box;\n    ", "\n    width: 30.5px;\n    height: 30.5px;\n    border-radius: 4px;\n    clip-path: ", ";\n    transform: rotate(", ");\n    ", ";\n  "])), isSecondaryNegative
        ? isLeft
            ? css(templateObject_16$4 || (templateObject_16$4 = __makeTemplateObject(["\n            right: calc(100% - calc(30.5px / 2));\n          "], ["\n            right: calc(100% - calc(30.5px / 2));\n          "]))) : css(templateObject_17$3 || (templateObject_17$3 = __makeTemplateObject(["\n            left: calc(100% - calc(30.5px / 2));\n          "], ["\n            left: calc(100% - calc(30.5px / 2));\n          "])))
        : isLeft
            ? css(templateObject_18$2 || (templateObject_18$2 = __makeTemplateObject(["\n            right: calc(100% - 16px);\n          "], ["\n            right: calc(100% - 16px);\n          "]))) : css(templateObject_19$2 || (templateObject_19$2 = __makeTemplateObject(["\n            left: calc(100% - 16px);\n          "], ["\n            left: calc(100% - 16px);\n          "]))), clip !== null && clip !== void 0 ? clip : "polygon(300% -300%, -300% -300%, 300% 300%)", isLeft ? "225deg" : "45deg", boxShadow &&
        (isLeft
            ? "box-shadow: 0px -4px 4px -2px ".concat(BaSeTheme.colors.defaultColors.shadowColor)
            : "box-shadow: 4px 0px 4px -2px ".concat(BaSeTheme.colors.defaultColors.shadowColor)));
});
styled.div.attrs({
    className: 'arrow-body',
})(templateObject_27$1 || (templateObject_27$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isLeft = _a.isLeft, _b = _a.svgWidth, svgWidth = _b === void 0 ? '141.55' : _b;
    return css(templateObject_26$1 || (templateObject_26$1 = __makeTemplateObject(["\n    position: absolute;\n    ", "\n    top:-0.5px;\n    bottom: -0.5px;\n    border-radius: 5px;\n    ", "\n  "], ["\n    position: absolute;\n    ", "\n    top:-0.5px;\n    bottom: -0.5px;\n    border-radius: 5px;\n    ", "\n  "])), isLeft
        ? css(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject(["\n          left: -19.5px;\n          right: -0.5px;\n        "], ["\n          left: -19.5px;\n          right: -0.5px;\n        "]))) : css(templateObject_23$1 || (templateObject_23$1 = __makeTemplateObject(["\n          right: -19.5px;\n          left: -0.5px;\n        "], ["\n          right: -19.5px;\n          left: -0.5px;\n        "]))), isLeft
        ? css(templateObject_24$1 || (templateObject_24$1 = __makeTemplateObject(["\n          clip-path: polygon(22% 0, 100% 0, 100% 100%, 22% 100%, 2% 50%);\n        "], ["\n          clip-path: polygon(22% 0, 100% 0, 100% 100%, 22% 100%, 2% 50%);\n        "]))) : css(templateObject_25$1 || (templateObject_25$1 = __makeTemplateObject(["\n          clip-path: path(\n            'M4,40 a4,4,0,0,1-4-4V4 A4,4,0,0,1,4,0 H", " a4,4,0,0,1,3.15,1.54l12.46,16 a4,4,0,0,1,0,4.92 l-12.46,16 A4,4,0,0,1,", ",40 Z'\n          );\n        "], ["\n          clip-path: path(\n            'M4,40 a4,4,0,0,1-4-4V4 A4,4,0,0,1,4,0 H", " a4,4,0,0,1,3.15,1.54l12.46,16 a4,4,0,0,1,0,4.92 l-12.46,16 A4,4,0,0,1,", ",40 Z'\n          );\n        "])), svgWidth, svgWidth));
});
styled.button(templateObject_31$1 || (templateObject_31$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, isLeft = _a.isLeft;
    return css(templateObject_30$1 || (templateObject_30$1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    border: none;\n    background-color: ", ";\n    width: ", ";\n    cursor: pointer;\n    &:focus {\n      outline: none;\n      ", ";\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    border: none;\n    background-color: ", ";\n    width: ", ";\n    cursor: pointer;\n    &:focus {\n      outline: none;\n      ", ";\n  "])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, BaSeTheme.colors.defaultColors.transparent, numberWithUnit(width), isLeft
        ? css(templateObject_28$1 || (templateObject_28$1 = __makeTemplateObject(["\n              box-shadow:\n                3px 3px 0px 0px ", ",\n                3px -3px 0px 0px ", ",\n                0px 0px 0px 3px ", ";\n            "], ["\n              box-shadow:\n                3px 3px 0px 0px ", ",\n                3px -3px 0px 0px ", ",\n                0px 0px 0px 3px ", ";\n            "])), BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60) : css(templateObject_29$1 || (templateObject_29$1 = __makeTemplateObject(["\n              box-shadow:\n                -3px 3px 0px 0px ", ",\n                -3px -3px 0px 0px\n                  ", ",\n                0px 0px 0px 3px ", ";\n            "], ["\n              box-shadow:\n                -3px 3px 0px 0px ", ",\n                -3px -3px 0px 0px\n                  ", ",\n                0px 0px 0px 3px ", ";\n            "])), BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60));
});
var templateObject_1$A, templateObject_2$w, templateObject_3$q, templateObject_4$l, templateObject_5$h, templateObject_6$g, templateObject_7$d, templateObject_8$c, templateObject_9$b, templateObject_10$9, templateObject_11$7, templateObject_12$7, templateObject_13$6, templateObject_14$6, templateObject_15$5, templateObject_16$4, templateObject_17$3, templateObject_18$2, templateObject_19$2, templateObject_20$2, templateObject_21$1, templateObject_22$1, templateObject_23$1, templateObject_24$1, templateObject_25$1, templateObject_26$1, templateObject_27$1, templateObject_28$1, templateObject_29$1, templateObject_30$1, templateObject_31$1;

var DEFAULT_BORDER_RADIUS = '7.5px';
var AVALIABLE_BORDER_RADIUS_VALUES = [16, 8, 4, 2, 0];
var BaSeArrowButton = function (_a) {
    var _b;
    var id = _a.id, name = _a.name, dataset = _a.dataset, _c = _a.type, type = _c === void 0 ? 'primary' : _c, _d = _a.value, value = _d === void 0 ? 'Valor' : _d, _e = _a.color, color = _e === void 0 ? 'default' : _e, _f = _a.isDisabled, isDisabled = _f === void 0 ? false : _f, _g = _a.direction, direction = _g === void 0 ? 'right' : _g, _h = _a.buttonType, buttonType = _h === void 0 ? 'button' : _h, _j = _a.autoFocus, autoFocus = _j === void 0 ? false : _j, _k = _a.tooltip, tooltip = _k === void 0 ? {} : _k, borderRadius = _a.borderRadius, _l = _a.onClick, onClick = _l === void 0 ? function () { } : _l, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var formattedDataset = getFormattedDataset(dataset);
    var colorIsMapped = React.useMemo(function () {
        return color === BaSeTheme.components.button.colors.default ||
            color === BaSeTheme.components.button.colors.negative;
    }, [color]);
    var getDefaultStyleMap = React.useMemo(function () {
        var _a, _b;
        var types = (_a = arrowButtonMapStyle[type]) !== null && _a !== void 0 ? _a : arrowButtonMapStyle.primary;
        return (_b = types === null || types === void 0 ? void 0 : types[color]) !== null && _b !== void 0 ? _b : types === null || types === void 0 ? void 0 : types.default;
    }, [type, color]);
    var getColorsAtributes = React.useMemo(function () {
        var _a, _b;
        if (!colorIsMapped && color) {
            return ((_b = (_a = mapCustomColorsArrowButtonValues(color)) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : mapCustomColorsArrowButtonValues(color).primary);
        }
        return getDefaultStyleMap;
    }, [color, colorIsMapped, type, getDefaultStyleMap]);
    var typeMapped = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        return isDisabled
            ? color === 'negative'
                ? (_c = (_b = (_a = arrowButtonMapStyle[type]) === null || _a === void 0 ? void 0 : _a.disabled) === null || _b === void 0 ? void 0 : _b.negative) !== null && _c !== void 0 ? _c : (_d = arrowButtonMapStyle[type]) === null || _d === void 0 ? void 0 : _d.disabled
                : (_f = (_e = arrowButtonMapStyle[type]) === null || _e === void 0 ? void 0 : _e.disabled) !== null && _f !== void 0 ? _f : arrowButtonMapStyle.primary.default
            : getColorsAtributes;
    }, [isDisabled, color, getColorsAtributes]);
    var iconColor = typeMapped.color, arrows = typeMapped.arrows, typeStyle = __rest(typeMapped, ["color", "arrows"]);
    var isLeft = direction === 'left';
    var _m = React.useState(false), isTooltipOpen = _m[0], setIsTooltipOpen = _m[1];
    var buttonRef = React.useRef(null);
    var borderRadiusPx = React.useMemo(function () {
        return (borderRadius !== null && borderRadius !== void 0 ? borderRadius : '') in AVALIABLE_BORDER_RADIUS_VALUES
            ? "".concat(borderRadius, "px")
            : DEFAULT_BORDER_RADIUS;
    }, [borderRadius]);
    return (React.createElement(ArrowButton, __assign({ id: id, name: name }, formattedDataset, { ref: buttonRef, "aria-disabled": isDisabled ? true : undefined, className: "BaSe--button-arrow", autoFocus: autoFocus, disabled: isDisabled, isDisabled: isDisabled, type: buttonType, isLeft: isLeft, isSecondaryNegative: color === 'negative' && type === 'secondary', hasBoxShadow: color !== 'negative' || !isDisabled, onMouseEnter: function () { return setIsTooltipOpen(true); }, onMouseLeave: function () { return setIsTooltipOpen(false); }, onClick: onClick, onFocus: onFocus, onBlur: onBlur, borderRadius: borderRadiusPx }, typeStyle),
        React.createElement(ArrowStyledContainer, __assign({ isSecondaryNegative: color === 'negative' && type === 'secondary', boxShadow: color !== 'negative' || !isDisabled, isLeft: isLeft }, arrows)),
        React.createElement(BaSeTextButton, { fontSize: 1, lineHeight: 1.4, hasLeftIcon: false, hasRightIcon: false, fontWeigh: "normal", color: iconColor }, value),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, { buddyRef: buttonRef, color: tooltip === null || tooltip === void 0 ? void 0 : tooltip.color, direction: tooltip === null || tooltip === void 0 ? void 0 : tooltip.direction, message: (_b = tooltip === null || tooltip === void 0 ? void 0 : tooltip.message) !== null && _b !== void 0 ? _b : '', open: isTooltipOpen, width: tooltip === null || tooltip === void 0 ? void 0 : tooltip.width, coordinates: tooltip === null || tooltip === void 0 ? void 0 : tooltip.coordinates }))));
};
BaSeArrowButton.displayName = 'BaSeArrowButton';

function addSeparatorToNumber(_a) {
    var integer = _a.integer, _b = _a.classSeparator, classSeparator = _b === void 0 ? '.' : _b;
    var fin = '';
    var count = 0;
    for (var i = integer.length - 1; i >= 0; i--) {
        if (count === 3) {
            fin = classSeparator + fin;
            count = 0;
        }
        fin = integer[i] + fin;
        count++;
    }
    return fin;
}
function decimalMask(_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.decimalSeparator, decimalSeparator = _c === void 0 ? ',' : _c, _d = _a.classSeparator, classSeparator = _d === void 0 ? '.' : _d;
    var val = value + '';
    if (val) {
        var negative = '';
        if (val[0] === '-') {
            negative = val[0];
        }
        val = val.replace(/\D/g, '');
        if (!val) {
            return '';
        }
        if (val.length < 5) {
            try {
                val = parseFloat(parseInt(val, 10) / 100 + '').toFixed(2) + '';
                var _e = val.split('.'), integer = _e[0], float = _e[1];
                var newInteger = addSeparatorToNumber({
                    integer: integer,
                    classSeparator: classSeparator,
                });
                val = "".concat(newInteger !== null && newInteger !== void 0 ? newInteger : '').concat(decimalSeparator).concat(float !== null && float !== void 0 ? float : '');
            }
            catch (_f) {
                val = '';
            }
        }
        else {
            var splitter = val.length - 2;
            var integer = val.slice(0, splitter);
            var float = val.slice(splitter, splitter + 2);
            var newInteger = addSeparatorToNumber({
                integer: integer,
                classSeparator: classSeparator,
            });
            val = "".concat(newInteger !== null && newInteger !== void 0 ? newInteger : '').concat(decimalSeparator).concat(float !== null && float !== void 0 ? float : '');
        }
        return negative ? negative + val : val;
    }
    else {
        return '';
    }
}
function removeNonDigit(val) {
    var _a;
    return !!val ? (_a = String(val)) === null || _a === void 0 ? void 0 : _a.replace(/[\D\s]+/g, '') : '';
}
function isNegative(val) {
    var negativeRegExp = /^-/;
    return negativeRegExp.test(val);
}
function substringContainMask(target, value) {
    var _a;
    if (!target || !value) {
        return false;
    }
    var mappedTable = (_a = target === null || target === void 0 ? void 0 : target.split('')) === null || _a === void 0 ? void 0 : _a.map(function () { return false; });
    for (var index = 0, targetIndex = 0; index <= value.length - 1 && targetIndex <= target.length - 1; index++) {
        if (value[index] === target[targetIndex]) {
            mappedTable[targetIndex] = true;
            targetIndex++;
        }
    }
    return mappedTable.findIndex(function (bol) { return bol === false; }) !== -1;
}
function forceCurrencyValue(_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.value, value = _d === void 0 ? '' : _d, _e = _c.decimalSeparator, decimalSeparator = _e === void 0 ? ',' : _e;
    var valueSplitted = String(value).split(decimalSeparator);
    var integer = removeNonDigit(valueSplitted[0]);
    var decimal = valueSplitted[1]
        ? ((_b = valueSplitted[1]) === null || _b === void 0 ? void 0 : _b.length) === 2
            ? valueSplitted[1]
            : valueSplitted[1] + '0'
        : '00';
    var hasNegativeSign = isNegative(valueSplitted[0]);
    return parseFloat("".concat(hasNegativeSign ? '-' : '').concat(integer, ".").concat(decimal)).toFixed(2);
}
function clearCnpjMask(_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b;
    return value.replace(/[^A-Z\d]/gi, '').toUpperCase();
}

var HelperStyled = styled.span.attrs({
    className: 'BaSe--helper-text',
})(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: normal;\n  font-size: ", ";\n  line-height: 13px;\n  ", "\n  display: flex;\n  align-items: center;\n  img {\n    margin-right: 4px;\n    ", "\n    transition: ", ";\n  }\n  ::selection {\n    color: inherit;\n    background: inherit;\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: normal;\n  font-size: ", ";\n  line-height: 13px;\n  ", "\n  display: flex;\n  align-items: center;\n  img {\n    margin-right: 4px;\n    ", "\n    transition: ", ";\n  }\n  ::selection {\n    color: inherit;\n    background: inherit;\n  }\n"])), function (props) {
    return props.color ? props.color : BaSeTheme.colors.institucionais.azulSebrae36;
}, BaSeTheme.typography.fontFamily, function (props) { return (props.isItalic ? 'italic' : 'normal'); }, function (props) { return (props.size === 'small' ? '11px' : '13px'); }, function (props) { return props.hasComplement && 'cursor: pointer;'; }, function (props) { return props.open && 'transform: rotate(180deg);'; }, BaSeTheme.transitions.allPropertiesContinuousNormal);
var HelperContainer = styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject([""], [""])));
var HelperDetailsContainer = styled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  padding-left: 16px;\n  max-height: ", ";\n  opacity: ", ";\n  transition: ", ";\n  overflow: hidden;\n"], ["\n  padding-left: 16px;\n  max-height: ", ";\n  opacity: ", ";\n  transition: ", ";\n  overflow: hidden;\n"])), function (props) { return (props.open ? '100vh' : '0px'); }, function (props) { return (props.open ? 1 : 0); }, BaSeTheme.transitions.allPropertiesContinuousNormal);
var templateObject_1$z, templateObject_2$v, templateObject_3$p;

// relative: { s: 100, l: 36 },
// normalText: { s: 16, l: 45 },
var defaultDetailsColor = BaSeTheme.colors.institucionais.cinzaSebrae45;
var colorMappedCustom = function (color) {
    var _a;
    if (!color) {
        return defaultDetailsColor;
    }
    var mappedTypes = {
        destructive: ColorMapper.destructive.foreground,
        confirmation: ColorMapper.confirmation.foreground,
        attention: ColorMapper.attention.foreground,
        default: ColorMapper.default.foreground,
    };
    var toTransformColor = (_a = mappedTypes[color]) !== null && _a !== void 0 ? _a : color;
    var originalValues = getHSLValues(toTransformColor);
    if (!originalValues) {
        return defaultDetailsColor;
    }
    var h = originalValues.h, s = originalValues.s, l = originalValues.l;
    h /= 100;
    s /= 100;
    l /= 100;
    return createColorSmartLightingControl(toTransformColor, { h: h, s: s * 0.16, l: l + (1 - l) / (64 / 9) }, 'lighter');
};

var BaSeHelperText = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.details, details = _c === void 0 ? '' : _c, color = _a.color, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.isItalic, isItalic = _e === void 0 ? false : _e;
    var _f = React.useState(false), open = _f[0], setOpen = _f[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleDetailsColor = React.useCallback(function () { return colorMappedCustom(color); }, [color]);
    return (React.createElement(HelperContainer, null,
        React.createElement(HelperStyled, { isItalic: isItalic, size: size, open: open, color: ColorMapper.getColor(color, BaSeTheme.colors.institucionais.azulSebrae36), hasComplement: !!details, onClick: function () { return setOpen(function (prev) { return !prev && !!details; }); } },
            !!details && (React.createElement(BaSeIcon, { size: 12, name: "angle-down", description: open
                    ? getMessage('helperText.openButton')
                    : getMessage('helperText.closeButton'), color: ColorMapper.getColor(color, BaSeTheme.colors.institucionais.azulSebrae36) })),
            label),
        React.createElement(HelperDetailsContainer, { open: !!details && open },
            React.createElement(BaSeSmall2, { color: handleDetailsColor() }, details))));
};
BaSeHelperText.displayName = 'BaSeHelperText';

styled.span(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return css(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n    font-size: 0.83em;\n    color: ", ";\n    margin-top: 3px;\n    line-height: 1.2em;\n    font-family: ", ";\n    font-style: italic;\n    font-weight: normal;\n  "], ["\n    font-size: 0.83em;\n    color: ", ";\n    margin-top: 3px;\n    line-height: 1.2em;\n    font-family: ", ";\n    font-style: italic;\n    font-weight: normal;\n  "])), color, BaSeTheme.typography.fontFamily);
});
var ContainerInput = styled.div.attrs({
    className: 'BaSe--input',
})(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return css(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: ", ";\n  "])), numberWithUnit(width));
});
var WrapperInput = styled.div.attrs({
    className: 'BaSe--input-wrapper',
})(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n\n  .BaSe--loading-spinner {\n    margin-right: 0.65em;\n  }\n\n  & > input.BaSe--input-input {\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n\n  .BaSe--loading-spinner {\n    margin-right: 0.65em;\n  }\n\n  & > input.BaSe--input-input {\n    ", "\n  }\n"])), function (_a) {
    var _b = _a.paddingRight, paddingRight = _b === void 0 ? 12 : _b, size = _a.size, customColors = _a.customColors, align = _a.align;
    return css(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      padding-left: 12px;\n      padding-right: ", "px;\n      width: calc(100% - ", "px);\n      color: ", ";\n      background: ", ";\n      border: 1px solid ", ";\n      border-radius: 4px;\n      height: ", "px;\n      text-align: ", ";\n      &:focus {\n        outline: none !important;\n        box-shadow: 0 0 4px ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      }\n    "], ["\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      padding-left: 12px;\n      padding-right: ", "px;\n      width: calc(100% - ", "px);\n      color: ", ";\n      background: ", ";\n      border: 1px solid ", ";\n      border-radius: 4px;\n      height: ", "px;\n      text-align: ", ";\n      &:focus {\n        outline: none !important;\n        box-shadow: 0 0 4px ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      }\n    "])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, paddingRight, paddingRight, customColors === null || customColors === void 0 ? void 0 : customColors.color, customColors === null || customColors === void 0 ? void 0 : customColors.backgroundColor, customColors === null || customColors === void 0 ? void 0 : customColors.borderColor, size, align, customColors === null || customColors === void 0 ? void 0 : customColors.boxShadowFocus, customColors === null || customColors === void 0 ? void 0 : customColors.focusBorderColor, customColors === null || customColors === void 0 ? void 0 : customColors.focusTextColor);
});
var ContainerIcon = styled.div(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var rotation = _a.rotation;
    return css(templateObject_8$b || (templateObject_8$b = __makeTemplateObject(["\n    right: 0;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n\n    button {\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      border-radius: 0 4px 4px 0;\n\n      &:focus {\n        border-radius: 0 4px 4px 0;\n      }\n    }\n    & > img {\n      transition: ", ";\n      margin-right: 1em;\n    }\n    ", "}\n  "], ["\n    right: 0;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n\n    button {\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      border-radius: 0 4px 4px 0;\n\n      &:focus {\n        border-radius: 0 4px 4px 0;\n      }\n    }\n    & > img {\n      transition: ", ";\n      margin-right: 1em;\n    }\n    ", "}\n  "])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, BaSeTheme.transitions.allPropertiesContinuousFast, rotation && css(templateObject_7$c || (templateObject_7$c = __makeTemplateObject(["\n        & > img {\n          transform: rotateX(180deg);\n        }\n      "], ["\n        & > img {\n          transform: rotateX(180deg);\n        }\n      "]))));
});
var MoreInfoContainer$3 = styled.div(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var WrapperHelper$2 = styled.div(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject(["\n  padding-top: 2px;\n"], ["\n  padding-top: 2px;\n"])));
var CheckIconWrapper = styled.div(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var top = _a.top;
    return css(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject(["\n    position: relative;\n    right: 12px;\n    top: ", "px;\n  "], ["\n    position: relative;\n    right: 12px;\n    top: ", "px;\n  "])), top);
});
var StyledTextFooterWrapper = styled.div(templateObject_14$5 || (templateObject_14$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledInputCounter = styled.div(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  text-align: end;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  text-align: end;\n  width: 100%;\n"])), BaSeTheme.typography.fontFamily, function (_a) {
    var color = _a.color;
    return color;
});
var CurrencyInputWrapper = styled.div(templateObject_17$2 || (templateObject_17$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n  width: 100%;\n\n  .BaSe--loading-spinner {\n    margin-right: 0.65em;\n  }\n\n  & > input {\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n  width: 100%;\n\n  .BaSe--loading-spinner {\n    margin-right: 0.65em;\n  }\n\n  & > input {\n    ", "\n  }\n"])), function (_a) {
    var _b = _a.paddingRight, paddingRight = _b === void 0 ? 12 : _b, size = _a.size, customColors = _a.customColors, align = _a.align;
    return css(templateObject_16$3 || (templateObject_16$3 = __makeTemplateObject(["\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      padding-left: 12px;\n      padding-right: ", "px;\n      width: calc(100% - ", "px);\n      color: ", ";\n      background: ", ";\n      border: 1px solid ", ";\n      border-radius: 4px;\n      height: ", "px;\n      text-align: ", ";\n      &:focus {\n        outline: none !important;\n        box-shadow: 0 0 4px ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      }\n    "], ["\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      padding-left: 12px;\n      padding-right: ", "px;\n      width: calc(100% - ", "px);\n      color: ", ";\n      background: ", ";\n      border: 1px solid ", ";\n      border-radius: 4px;\n      height: ", "px;\n      text-align: ", ";\n      &:focus {\n        outline: none !important;\n        box-shadow: 0 0 4px ", ";\n        border: 1px solid ", ";\n        color: ", ";\n      }\n    "])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, paddingRight, paddingRight, customColors === null || customColors === void 0 ? void 0 : customColors.color, customColors === null || customColors === void 0 ? void 0 : customColors.backgroundColor, customColors === null || customColors === void 0 ? void 0 : customColors.borderColor, size, align, customColors === null || customColors === void 0 ? void 0 : customColors.boxShadowFocus, customColors === null || customColors === void 0 ? void 0 : customColors.focusBorderColor, customColors === null || customColors === void 0 ? void 0 : customColors.focusTextColor);
});
var templateObject_1$y, templateObject_2$u, templateObject_3$o, templateObject_4$k, templateObject_5$g, templateObject_6$f, templateObject_7$c, templateObject_8$b, templateObject_9$a, templateObject_10$8, templateObject_11$6, templateObject_12$6, templateObject_13$5, templateObject_14$5, templateObject_15$4, templateObject_16$3, templateObject_17$2;

var translationValueToName = {
    0: 'invalid',
    1: 'valid',
    2: 'normal',
    3: 'disabled',
};
var mapBaSeInputSize = {
    small: 28,
    medium: 36,
    big: 44,
};
var mapBaSeInputColor = {
    normal: {
        color: BaSeTheme.colors.institucionais.cinzaSebrae60,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        focusTextColor: BaSeTheme.colors.institucionais.azulSebrae36,
        focusBorderColor: BaSeTheme.colors.institucionais.azulSebrae36,
        boxShadowFocus: BaSeTheme.colors.institucionais.azulSebrae75,
    },
    valid: {
        color: BaSeTheme.colors.feedbackInterface.sucesso20,
        borderColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        focusTextColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        focusBorderColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        boxShadowFocus: BaSeTheme.colors.feedbackInterface.sucesso70,
    },
    invalid: {
        color: BaSeTheme.colors.feedbackInterface.erro35,
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        focusTextColor: BaSeTheme.colors.feedbackInterface.erro35,
        focusBorderColor: BaSeTheme.colors.feedbackInterface.erro35,
        boxShadowFocus: BaSeTheme.colors.feedbackInterface.erro70,
    },
    disabled: {
        color: BaSeTheme.colors.institucionais.cinzaSebrae75,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        backgroundColor: BaSeTheme.colors.institucionais.cinzaSebrae97,
    },
};
var removeAtributes = function (overrider) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var storageObj = {};
    if (overrider === null || overrider === void 0 ? void 0 : overrider.valid) {
        storageObj.valid = {
            borderColor: (_a = overrider.valid.foreground) !== null && _a !== void 0 ? _a : mapBaSeInputColor.valid.borderColor,
            backgroundColor: (_b = overrider.valid.background) !== null && _b !== void 0 ? _b : mapBaSeInputColor.valid.backgroundColor,
            focusTextColor: (_c = overrider.valid.foreground) !== null && _c !== void 0 ? _c : mapBaSeInputColor.valid.focusTextColor,
            focusBorderColor: (_d = overrider.valid.foreground) !== null && _d !== void 0 ? _d : mapBaSeInputColor.valid.focusBorderColor,
            boxShadowFocus: Color.validateColor(overrider === null || overrider === void 0 ? void 0 : overrider.valid.foreground)
                ? ColorMapper.light.focus.create(overrider.valid.foreground)
                : mapBaSeInputColor.valid.boxShadowFocus,
        };
    }
    if (overrider === null || overrider === void 0 ? void 0 : overrider.invalid) {
        storageObj.invalid = {
            color: (_e = overrider.invalid.foreground) !== null && _e !== void 0 ? _e : mapBaSeInputColor.invalid.color,
            borderColor: (_f = overrider.invalid.foreground) !== null && _f !== void 0 ? _f : mapBaSeInputColor.invalid.borderColor,
            backgroundColor: (_g = overrider.invalid.background) !== null && _g !== void 0 ? _g : mapBaSeInputColor.invalid.backgroundColor,
            focusTextColor: (_h = overrider.invalid.foreground) !== null && _h !== void 0 ? _h : mapBaSeInputColor.invalid.focusTextColor,
            focusBorderColor: (_j = overrider.invalid.foreground) !== null && _j !== void 0 ? _j : mapBaSeInputColor.invalid.focusBorderColor,
            boxShadowFocus: Color.validateColor(overrider === null || overrider === void 0 ? void 0 : overrider.invalid.foreground)
                ? ColorMapper.light.focus.create(overrider.invalid.foreground)
                : mapBaSeInputColor.invalid.boxShadowFocus,
        };
    }
    return __assign({}, storageObj);
};
var inputColorManager = function (color, overrideColor) {
    if (!color) {
        return __assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor));
    }
    if (color in ColorMapper) {
        return __assign(__assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor)), { normal: __assign(__assign({}, mapBaSeInputColor === null || mapBaSeInputColor === void 0 ? void 0 : mapBaSeInputColor.normal), { focusTextColor: ColorMapper[color].foreground, focusBorderColor: ColorMapper[color].foreground, boxShadowFocus: ColorMapper[color].focus.defaultLight }) });
    }
    if (!Color.validateColor(color)) {
        return __assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor));
    }
    return __assign(__assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor)), { normal: __assign(__assign({}, mapBaSeInputColor === null || mapBaSeInputColor === void 0 ? void 0 : mapBaSeInputColor.normal), { focusTextColor: color, focusBorderColor: color, boxShadowFocus: ColorMapper.light.focus.create(color) }) });
};
var labelColorsMapper = {
    color: BaSeTheme.colors.institucionais.cinzaSebrae45,
};
var subLabelColorMapper = {
    color: BaSeTheme.colors.institucionais.cinzaSebrae60,
};
var overrideExtraColorsMapper = {
    label: labelColorsMapper.color,
    subLabel: subLabelColorMapper.color,
    border: undefined,
};
var overrideExtraColors = function (overrideColors) {
    if (!overrideColors) {
        return __assign({}, overrideExtraColorsMapper);
    }
    var overrideObj = __assign({}, overrideExtraColorsMapper);
    var createValidObj = Object.keys(overrideColors);
    createValidObj.forEach(function (obj) {
        if (overrideColors[obj] && obj in overrideExtraColorsMapper) {
            overrideObj[obj] = overrideColors[obj];
        }
    });
    return overrideObj;
};

var lineSeparatorRegEx = /\n/;
var wordSeparatorRegEx = /(!([^\s0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+|\s|[-–@.,][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+/gim;
function clearValueToFilterWord(value) {
    if (value === void 0) { value = ''; }
    return value
        .trim()
        .replace(/^[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+/gim, '')
        .replace(/[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+$/gim, '');
}
function charCounter(value) {
    var _a;
    return (_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0;
}
function lineCounter(value) {
    return value.split(lineSeparatorRegEx).length;
}
function wordCounter(value) {
    var cleanValue = clearValueToFilterWord(value);
    if (!cleanValue) {
        return 0;
    }
    var splittedValue = cleanValue.split(wordSeparatorRegEx);
    var filteredVaue = splittedValue.filter(function (val) { return !!clearValueToFilterWord(val); });
    var length = filteredVaue.length;
    return length;
}
function useCounter(_a) {
    var value = _a.value, hasCounter = _a.hasCounter, _b = _a.counterMinLength, counterMinLength = _b === void 0 ? 0 : _b, _c = _a.counterMaxLength, counterMaxLength = _c === void 0 ? 0 : _c, onChange = _a.onChange;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var length = React.useMemo(function () {
        return hasCounter === 'chars'
            ? charCounter(value)
            : hasCounter === 'lines'
                ? lineCounter(value)
                : hasCounter === 'words'
                    ? wordCounter(value)
                    : 0;
    }, [value, hasCounter]);
    var getDescription = React.useCallback(function (singularWord, pluralWord) {
        return counterMinLength && counterMaxLength
            ? getMessage('counter.minMax', length <= counterMinLength ? length : counterMinLength, counterMinLength, length, counterMaxLength, counterMaxLength > 1 ? pluralWord : singularWord)
            : counterMinLength && length === 0
                ? getMessage('counter.initialMin', counterMinLength, counterMinLength > 1 ? pluralWord : singularWord)
                : counterMinLength && length < counterMinLength
                    ? getMessage(counterMinLength - length === 1
                        ? 'counter.minLastOne'
                        : 'counter.min', counterMinLength - length, counterMinLength - length > 1 ? pluralWord : singularWord)
                    : counterMinLength && length >= counterMinLength
                        ? getMessage('counter.doneMin', counterMinLength, counterMinLength > 1 ? pluralWord : singularWord)
                        : counterMaxLength && length === 0
                            ? getMessage('counter.initialMax', counterMaxLength, counterMaxLength > 1 ? pluralWord : singularWord)
                            : counterMaxLength && length < counterMaxLength
                                ? getMessage(counterMaxLength - length === 1
                                    ? 'counter.maxLastOne'
                                    : 'counter.max', counterMaxLength - length, counterMaxLength - length > 1 ? pluralWord : singularWord)
                                : counterMaxLength && length === counterMaxLength
                                    ? getMessage('counter.doneMax', counterMaxLength, counterMaxLength > 1 ? pluralWord : singularWord)
                                    : getMessage('counter.withoutMinMax', length, length > 1 ? pluralWord : singularWord);
    }, [getMessage, counterMinLength, counterMaxLength, length]);
    var cropWord = React.useCallback(function (newValue) {
        var _a;
        var separatorList = (_a = newValue.match(wordSeparatorRegEx)) !== null && _a !== void 0 ? _a : [];
        var cleanValue = clearValueToFilterWord(newValue);
        var splittedValue = cleanValue.split(wordSeparatorRegEx);
        var filteredVaue = splittedValue.filter(function (val) { return !!clearValueToFilterWord(val); });
        var valueListCropped = filteredVaue.splice(0, counterMaxLength);
        var valueToChange = valueListCropped.reduce(function (acc, item, index, list) {
            return acc + item + (index + 1 < list.length ? separatorList[index] : '');
        }, '');
        onChange(valueToChange);
    }, [counterMaxLength, onChange]);
    var cropLine = React.useCallback(function (newValue) {
        return onChange(newValue
            .split(lineSeparatorRegEx)
            .splice(0, counterMaxLength)
            .join('\n'));
    }, [counterMaxLength, onChange]);
    var cropText = React.useCallback(function (newValue) {
        if (hasCounter === 'chars' || hasCounter === false) {
            return;
        }
        length <= counterMaxLength
            ? onChange(newValue)
            : hasCounter === 'words'
                ? cropWord(newValue)
                : cropLine(newValue);
    }, [counterMaxLength, hasCounter, onChange, length]);
    var counterDescription = React.useMemo(function () {
        return hasCounter === 'words'
            ? getDescription(getMessage('counter.word'), getMessage('counter.words'))
            : hasCounter === 'chars'
                ? getDescription(getMessage('counter.char'), getMessage('counter.chars'))
                : hasCounter === 'lines'
                    ? getDescription(getMessage('counter.line'), getMessage('counter.lines'))
                    : '';
    }, [getDescription, getMessage, hasCounter]);
    return { counterDescription: counterDescription, cropText: cropText };
}

var Coordinates = function (width, height, size) {
    if (height === void 0) { height = null; }
    if (size === void 0) { size = 13; }
    var half = size / 2 + 4; // Add de 4 pixels pelo padding do ShapeButton
    var spaceToIcon = 5;
    var boundaries = 7;
    return {
        top: {
            bottom: "calc(100% + ".concat(spaceToIcon, "px)"),
            left: "calc(-".concat(width / 2, "px + ").concat(half, "px)"),
        },
        right: {
            top: height ? "calc(-".concat(height / 2, "px + ").concat(half, "px)") : '',
            left: "calc(100% + ".concat(boundaries, "px)"),
        },
        left: {
            top: height ? "calc(-".concat(height / 2, "px + ").concat(half, "px)") : '',
            right: "calc(100% + ".concat(boundaries, "px)"),
        },
        bottom: {
            top: "calc(100% + ".concat(spaceToIcon, "px)"),
            left: "calc(-".concat(width / 2, "px + ").concat(half, "px)"),
        },
        neutral: {
            bottom: "calc(100% + ".concat(spaceToIcon, "px)"),
            left: "calc(-".concat(width / 2, "px + ").concat(half, "px)"),
        },
    };
};

var handleProps = function (size) {
    if (!size) {
        return undefined;
    }
    return numberWithUnit(size);
};
var HelperButtonContainer = styled.div.attrs({
    className: 'BaSe--helper-button-container',
})(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var HelperButtonIconContainer = styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  cursor: pointer;\n  button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding: 4px;\n  }\n\n  img {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  cursor: pointer;\n  button {\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding: 4px;\n  }\n\n  img {\n    width: ", ";\n    height: ", ";\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (props) { var _a; return (_a = handleProps(props.size)) !== null && _a !== void 0 ? _a : '13px'; }, function (props) { var _a; return (_a = handleProps(props.size)) !== null && _a !== void 0 ? _a : '13px'; });
var templateObject_1$x, templateObject_2$t;

var defaultIconName = 'question-circle';
var defaultIconSize = 13;
var defaultIconColor = 'default';
var BaSePopupButton = function (_a) {
    var _b, _c;
    var _d = _a.direction, direction = _d === void 0 ? 'top' : _d, _e = _a.type, type = _e === void 0 ? 'tooltip' : _e, _f = _a.tooltipColor, tooltipColor = _f === void 0 ? 'default' : _f, _g = _a.alertSize, alertSize = _g === void 0 ? type === 'tooltip' ? 106 : 180 : _g, _h = _a.message, message = _h === void 0 ? '' : _h, _j = _a.title, title = _j === void 0 ? '' : _j, _k = _a.iconProps, iconProps = _k === void 0 ? {
        name: defaultIconName,
        color: defaultIconColor,
        size: defaultIconSize,
        onClick: function () { },
    } : _k, overrideColors = _a.overrideColors, renderContent = _a.renderContent;
    var initialCoordinates = React.useMemo(function () {
        var _a;
        return Coordinates(alertSize, null, (_a = iconProps === null || iconProps === void 0 ? void 0 : iconProps.size) !== null && _a !== void 0 ? _a : defaultIconSize)[direction];
    }, [alertSize, iconProps === null || iconProps === void 0 ? void 0 : iconProps.size, defaultIconSize, direction]);
    var _l = React.useState(initialCoordinates), coordinates = _l[0], setCoordinates = _l[1];
    var _m = React.useState(false), open = _m[0], setOpen = _m[1];
    var helperButtonRef = React.useRef(null);
    var handleRef = React.useCallback(function (e) {
        var _a;
        return setCoordinates(Coordinates(alertSize, e === null || e === void 0 ? void 0 : e.offsetHeight, (_a = iconProps === null || iconProps === void 0 ? void 0 : iconProps.size) !== null && _a !== void 0 ? _a : defaultIconSize)[direction]);
    }, [alertSize, iconProps === null || iconProps === void 0 ? void 0 : iconProps.size, defaultIconSize, direction]);
    useOutsideEvent(helperButtonRef, function (e) { return setOpen(e); });
    return (React.createElement(HelperButtonContainer, { ref: helperButtonRef },
        React.createElement(HelperButtonIconContainer, { size: (_b = iconProps.size) !== null && _b !== void 0 ? _b : defaultIconSize, onClick: function () { return setOpen(function (prev) { return !prev; }); } },
            React.createElement(BaSeShapeButton, { buttonType: "button", type: "tertiary", size: "medium", nameIcon: (_c = iconProps.name) !== null && _c !== void 0 ? _c : defaultIconName, color: ColorMapper.getColor(iconProps === null || iconProps === void 0 ? void 0 : iconProps.color, defaultIconColor), onClick: function (e) { var _a; return (_a = iconProps === null || iconProps === void 0 ? void 0 : iconProps.onClick) === null || _a === void 0 ? void 0 : _a.call(iconProps, e); } })),
        type === 'tooltip' ? (React.createElement(BaSeTooltip, { width: alertSize, open: open, direction: direction, message: message, color: tooltipColor, coordinates: coordinates, refOutput: handleRef, overrideColors: overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.alert })) : (React.createElement(BaSePopover, { width: alertSize, open: open, direction: direction, message: message, coordinates: coordinates, refOutput: handleRef, title: title, overrideColors: overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.alert, renderContent: renderContent, handleClose: function () { return setOpen(false); } }))));
};
BaSePopupButton.displayName = 'BaSePopupButton';

var WrapperInputlabel = styled.div.attrs({
    className: 'BaSe--input-wrapper-label',
})(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n  ", "\n"])), BaSeTheme.stackOrder.normal, BaSeTheme.colors.defaultColors.transparent, function (_a) {
    var isEmpty = _a.isEmpty;
    return isEmpty && css(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n      margin-bottom: 0px;\n    "], ["\n      margin-bottom: 0px;\n    "])));
});
var StyledLabel$2 = styled.label.attrs({
    className: 'BaSe--input-label',
})(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var fontSize = _a.fontSize, lineHeight = _a.lineHeight, color = _a.color;
    return css(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-style: normal;\n    font-weight: normal;\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-style: normal;\n    font-weight: normal;\n  "])), fontSize, lineHeight, color, BaSeTheme.typography.fontFamily);
});
var StyledSubLabel$2 = styled.label.attrs({
    className: 'BaSe--input-sub-label',
})(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var fontSize = _a.fontSize, lineHeight = _a.lineHeight, color = _a.color;
    return css(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-weight: normal;\n    color: ", ";\n    font-style: italic;\n    margin-left: 4px;\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-weight: normal;\n    color: ", ";\n    font-style: italic;\n    margin-left: 4px;\n  "])), fontSize, lineHeight, BaSeTheme.typography.fontFamily, color);
});
var ButtonInfoContainer$2 = styled.div(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1$w, templateObject_2$s, templateObject_3$n, templateObject_4$j, templateObject_5$f, templateObject_6$e, templateObject_7$b;

var BaSeFormLabel = function (_a) {
    var _b, _c;
    var id = _a.id, size = _a.size, label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, colors = _a.colors, getContainerHeight = _a.getContainerHeight;
    var containerRef = React.useRef(null);
    var isEmpty = React.useCallback(function () { return !label && !subLabel && !showHelpButton; }, [label, subLabel, showHelpButton]);
    var handleResize = React.useCallback(function () {
        var _a, _b;
        if (((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) &&
            getContainerHeight &&
            !isEmpty()) {
            getContainerHeight(((_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) + 2); // 2px da margin-bottom
        }
    }, [containerRef, isEmpty, getContainerHeight]);
    React.useLayoutEffect(function () {
        handleResize();
    }, [handleResize]);
    React.useEffect(function () {
        window.addEventListener('resize', function () { return handleResize(); });
        return window.removeEventListener('resize', function () { return handleResize(); });
    }, []);
    return (React.createElement(WrapperInputlabel, { ref: containerRef, isEmpty: isEmpty() },
        React.createElement(StyledLabel$2, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id, color: (_b = colors === null || colors === void 0 ? void 0 : colors.label) !== null && _b !== void 0 ? _b : BaSeTheme.colors.institucionais.cinzaSebrae45 }, label),
        React.createElement(StyledSubLabel$2, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id, color: (_c = colors === null || colors === void 0 ? void 0 : colors.subLabel) !== null && _c !== void 0 ? _c : BaSeTheme.colors.institucionais.cinzaSebrae60 }, subLabel),
        showHelpButton && (React.createElement(ButtonInfoContainer$2, null,
            React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))));
};

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    var b = "function" === typeof Symbol && Symbol.for;
    var c = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r = b ? Symbol.for("react.memo") : 60115;
    var t = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x = b ? Symbol.for("react.responder") : 60118;
    var y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a) {
      return z(a) === k;
    };
    exports.isContextProvider = function(a) {
      return z(a) === h;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function(a) {
      return z(a) === n;
    };
    exports.isFragment = function(a) {
      return z(a) === e;
    };
    exports.isLazy = function(a) {
      return z(a) === t;
    };
    exports.isMemo = function(a) {
      return z(a) === r;
    };
    exports.isPortal = function(a) {
      return z(a) === d;
    };
    exports.isProfiler = function(a) {
      return z(a) === g;
    };
    exports.isStrictMode = function(a) {
      return z(a) === f;
    };
    exports.isSuspense = function(a) {
      return z(a) === p;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});

// node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/react-is/cjs/react-is.development.js"(exports) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/react-is/index.js"(exports, module) {
    if (process.env.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "node_modules/object-assign/index.js"(exports, module) {
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "node_modules/prop-types/checkPropTypes.js"(exports, module) {
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "node_modules/prop-types/index.js"(exports, module) {
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// lib/IntlCurrencyInput.tsx
var import_prop_types = __toESM(require_prop_types(), 1);

// node_modules/big.js/big.mjs
var DP = 20;
var RM = 1;
var MAX_DP = 1e6;
var MAX_POWER = 1e6;
var NE = -7;
var PE = 21;
var STRICT = false;
var NAME = "[big.js] ";
var INVALID = NAME + "Invalid ";
var INVALID_DP = INVALID + "decimal places";
var INVALID_RM = INVALID + "rounding mode";
var DIV_BY_ZERO = NAME + "Division by zero";
var P = {};
var UNDEFINED = void 0;
var NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function _Big_() {
  function Big2(n) {
    var x = this;
    if (!(x instanceof Big2))
      return n === UNDEFINED ? _Big_() : new Big2(n);
    if (n instanceof Big2) {
      x.s = n.s;
      x.e = n.e;
      x.c = n.c.slice();
    } else {
      if (typeof n !== "string") {
        if (Big2.strict === true && typeof n !== "bigint") {
          throw TypeError(INVALID + "value");
        }
        n = n === 0 && 1 / n < 0 ? "-0" : String(n);
      }
      parse(x, n);
    }
    x.constructor = Big2;
  }
  Big2.prototype = P;
  Big2.DP = DP;
  Big2.RM = RM;
  Big2.NE = NE;
  Big2.PE = PE;
  Big2.strict = STRICT;
  Big2.roundDown = 0;
  Big2.roundHalfUp = 1;
  Big2.roundHalfEven = 2;
  Big2.roundUp = 3;
  return Big2;
}
function parse(x, n) {
  var e, i, nl;
  if (!NUMERIC.test(n)) {
    throw Error(INVALID + "number");
  }
  x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
  if ((e = n.indexOf(".")) > -1)
    n = n.replace(".", "");
  if ((i = n.search(/e/i)) > 0) {
    if (e < 0)
      e = i;
    e += +n.slice(i + 1);
    n = n.substring(0, i);
  } else if (e < 0) {
    e = n.length;
  }
  nl = n.length;
  for (i = 0; i < nl && n.charAt(i) == "0"; )
    ++i;
  if (i == nl) {
    x.c = [x.e = 0];
  } else {
    for (; nl > 0 && n.charAt(--nl) == "0"; )
      ;
    x.e = e - i - 1;
    x.c = [];
    for (e = 0; i <= nl; )
      x.c[e++] = +n.charAt(i++);
  }
  return x;
}
function round(x, sd, rm, more) {
  var xc = x.c;
  if (rm === UNDEFINED)
    rm = x.constructor.RM;
  if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
    throw Error(INVALID_RM);
  }
  if (sd < 1) {
    more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED)));
    xc.length = 1;
    if (more) {
      x.e = x.e - sd + 1;
      xc[0] = 1;
    } else {
      xc[0] = x.e = 0;
    }
  } else if (sd < xc.length) {
    more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
    xc.length = sd;
    if (more) {
      for (; ++xc[--sd] > 9; ) {
        xc[sd] = 0;
        if (sd === 0) {
          ++x.e;
          xc.unshift(1);
          break;
        }
      }
    }
    for (sd = xc.length; !xc[--sd]; )
      xc.pop();
  }
  return x;
}
function stringify(x, doExponential, isNonzero) {
  var e = x.e, s = x.c.join(""), n = s.length;
  if (doExponential) {
    s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
  } else if (e < 0) {
    for (; ++e; )
      s = "0" + s;
    s = "0." + s;
  } else if (e > 0) {
    if (++e > n) {
      for (e -= n; e--; )
        s += "0";
    } else if (e < n) {
      s = s.slice(0, e) + "." + s.slice(e);
    }
  } else if (n > 1) {
    s = s.charAt(0) + "." + s.slice(1);
  }
  return x.s < 0 && isNonzero ? "-" + s : s;
}
P.abs = function() {
  var x = new this.constructor(this);
  x.s = 1;
  return x;
};
P.cmp = function(y) {
  var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
  if (!xc[0] || !yc[0])
    return !xc[0] ? !yc[0] ? 0 : -j : i;
  if (i != j)
    return i;
  isneg = i < 0;
  if (k != l)
    return k > l ^ isneg ? 1 : -1;
  j = (k = xc.length) < (l = yc.length) ? k : l;
  for (i = -1; ++i < j; ) {
    if (xc[i] != yc[i])
      return xc[i] > yc[i] ^ isneg ? 1 : -1;
  }
  return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};
P.div = function(y) {
  var x = this, Big2 = x.constructor, a = x.c, b = (y = new Big2(y)).c, k = x.s == y.s ? 1 : -1, dp = Big2.DP;
  if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }
  if (!b[0]) {
    throw Error(DIV_BY_ZERO);
  }
  if (!a[0]) {
    y.s = k;
    y.c = [y.e = 0];
    return y;
  }
  var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1;
  q.s = k;
  k = p < 0 ? 0 : p;
  bz.unshift(0);
  for (; rl++ < bl; )
    r.push(0);
  do {
    for (n = 0; n < 10; n++) {
      if (bl != (rl = r.length)) {
        cmp = bl > rl ? 1 : -1;
      } else {
        for (ri = -1, cmp = 0; ++ri < bl; ) {
          if (b[ri] != r[ri]) {
            cmp = b[ri] > r[ri] ? 1 : -1;
            break;
          }
        }
      }
      if (cmp < 0) {
        for (bt = rl == bl ? b : bz; rl; ) {
          if (r[--rl] < bt[rl]) {
            ri = rl;
            for (; ri && !r[--ri]; )
              r[ri] = 9;
            --r[ri];
            r[rl] += 10;
          }
          r[rl] -= bt[rl];
        }
        for (; !r[0]; )
          r.shift();
      } else {
        break;
      }
    }
    qc[qi++] = cmp ? n : ++n;
    if (r[0] && cmp)
      r[rl] = a[ai] || 0;
    else
      r = [a[ai]];
  } while ((ai++ < al || r[0] !== UNDEFINED) && k--);
  if (!qc[0] && qi != 1) {
    qc.shift();
    q.e--;
    p--;
  }
  if (qi > p)
    round(q, p, Big2.RM, r[0] !== UNDEFINED);
  return q;
};
P.eq = function(y) {
  return this.cmp(y) === 0;
};
P.gt = function(y) {
  return this.cmp(y) > 0;
};
P.gte = function(y) {
  return this.cmp(y) > -1;
};
P.lt = function(y) {
  return this.cmp(y) < 0;
};
P.lte = function(y) {
  return this.cmp(y) < 1;
};
P.minus = P.sub = function(y) {
  var i, j, t, xlty, x = this, Big2 = x.constructor, a = x.s, b = (y = new Big2(y)).s;
  if (a != b) {
    y.s = -b;
    return x.plus(y);
  }
  var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
  if (!xc[0] || !yc[0]) {
    if (yc[0]) {
      y.s = -b;
    } else if (xc[0]) {
      y = new Big2(x);
    } else {
      y.s = 1;
    }
    return y;
  }
  if (a = xe - ye) {
    if (xlty = a < 0) {
      a = -a;
      t = xc;
    } else {
      ye = xe;
      t = yc;
    }
    t.reverse();
    for (b = a; b--; )
      t.push(0);
    t.reverse();
  } else {
    j = ((xlty = xc.length < yc.length) ? xc : yc).length;
    for (a = b = 0; b < j; b++) {
      if (xc[b] != yc[b]) {
        xlty = xc[b] < yc[b];
        break;
      }
    }
  }
  if (xlty) {
    t = xc;
    xc = yc;
    yc = t;
    y.s = -y.s;
  }
  if ((b = (j = yc.length) - (i = xc.length)) > 0)
    for (; b--; )
      xc[i++] = 0;
  for (b = i; j > a; ) {
    if (xc[--j] < yc[j]) {
      for (i = j; i && !xc[--i]; )
        xc[i] = 9;
      --xc[i];
      xc[j] += 10;
    }
    xc[j] -= yc[j];
  }
  for (; xc[--b] === 0; )
    xc.pop();
  for (; xc[0] === 0; ) {
    xc.shift();
    --ye;
  }
  if (!xc[0]) {
    y.s = 1;
    xc = [ye = 0];
  }
  y.c = xc;
  y.e = ye;
  return y;
};
P.mod = function(y) {
  var ygtx, x = this, Big2 = x.constructor, a = x.s, b = (y = new Big2(y)).s;
  if (!y.c[0]) {
    throw Error(DIV_BY_ZERO);
  }
  x.s = y.s = 1;
  ygtx = y.cmp(x) == 1;
  x.s = a;
  y.s = b;
  if (ygtx)
    return new Big2(x);
  a = Big2.DP;
  b = Big2.RM;
  Big2.DP = Big2.RM = 0;
  x = x.div(y);
  Big2.DP = a;
  Big2.RM = b;
  return this.minus(x.times(y));
};
P.neg = function() {
  var x = new this.constructor(this);
  x.s = -x.s;
  return x;
};
P.plus = P.add = function(y) {
  var e, k, t, x = this, Big2 = x.constructor;
  y = new Big2(y);
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }
  var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
  if (!xc[0] || !yc[0]) {
    if (!yc[0]) {
      if (xc[0]) {
        y = new Big2(x);
      } else {
        y.s = x.s;
      }
    }
    return y;
  }
  xc = xc.slice();
  if (e = xe - ye) {
    if (e > 0) {
      ye = xe;
      t = yc;
    } else {
      e = -e;
      t = xc;
    }
    t.reverse();
    for (; e--; )
      t.push(0);
    t.reverse();
  }
  if (xc.length - yc.length < 0) {
    t = yc;
    yc = xc;
    xc = t;
  }
  e = yc.length;
  for (k = 0; e; xc[e] %= 10)
    k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
  if (k) {
    xc.unshift(k);
    ++ye;
  }
  for (e = xc.length; xc[--e] === 0; )
    xc.pop();
  y.c = xc;
  y.e = ye;
  return y;
};
P.pow = function(n) {
  var x = this, one = new x.constructor("1"), y = one, isneg = n < 0;
  if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
    throw Error(INVALID + "exponent");
  }
  if (isneg)
    n = -n;
  for (; ; ) {
    if (n & 1)
      y = y.times(x);
    n >>= 1;
    if (!n)
      break;
    x = x.times(x);
  }
  return isneg ? one.div(y) : y;
};
P.prec = function(sd, rm) {
  if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
    throw Error(INVALID + "precision");
  }
  return round(new this.constructor(this), sd, rm);
};
P.round = function(dp, rm) {
  if (dp === UNDEFINED)
    dp = 0;
  else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }
  return round(new this.constructor(this), dp + this.e + 1, rm);
};
P.sqrt = function() {
  var r, c, t, x = this, Big2 = x.constructor, s = x.s, e = x.e, half = new Big2("0.5");
  if (!x.c[0])
    return new Big2(x);
  if (s < 0) {
    throw Error(NAME + "No square root");
  }
  s = Math.sqrt(x + "");
  if (s === 0 || s === 1 / 0) {
    c = x.c.join("");
    if (!(c.length + e & 1))
      c += "0";
    s = Math.sqrt(c);
    e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    r = new Big2((s == 1 / 0 ? "5e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
  } else {
    r = new Big2(s + "");
  }
  e = r.e + (Big2.DP += 4);
  do {
    t = r;
    r = half.times(t.plus(x.div(t)));
  } while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
  return round(r, (Big2.DP -= 4) + r.e + 1, Big2.RM);
};
P.times = P.mul = function(y) {
  var c, x = this, Big2 = x.constructor, xc = x.c, yc = (y = new Big2(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
  y.s = x.s == y.s ? 1 : -1;
  if (!xc[0] || !yc[0]) {
    y.c = [y.e = 0];
    return y;
  }
  y.e = i + j;
  if (a < b) {
    c = xc;
    xc = yc;
    yc = c;
    j = a;
    a = b;
    b = j;
  }
  for (c = new Array(j = a + b); j--; )
    c[j] = 0;
  for (i = b; i--; ) {
    b = 0;
    for (j = a + i; j > i; ) {
      b = c[j] + yc[i] * xc[j - i - 1] + b;
      c[j--] = b % 10;
      b = b / 10 | 0;
    }
    c[j] = b;
  }
  if (b)
    ++y.e;
  else
    c.shift();
  for (i = c.length; !c[--i]; )
    c.pop();
  y.c = c;
  return y;
};
P.toExponential = function(dp, rm) {
  var x = this, n = x.c[0];
  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round(new x.constructor(x), ++dp, rm);
    for (; x.c.length < dp; )
      x.c.push(0);
  }
  return stringify(x, true, !!n);
};
P.toFixed = function(dp, rm) {
  var x = this, n = x.c[0];
  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round(new x.constructor(x), dp + x.e + 1, rm);
    for (dp = dp + x.e + 1; x.c.length < dp; )
      x.c.push(0);
  }
  return stringify(x, false, !!n);
};
P[Symbol.for("nodejs.util.inspect.custom")] = P.toJSON = P.toString = function() {
  var x = this, Big2 = x.constructor;
  return stringify(x, x.e <= Big2.NE || x.e >= Big2.PE, !!x.c[0]);
};
P.toNumber = function() {
  var n = Number(stringify(this, true, true));
  if (this.constructor.strict === true && !this.eq(n.toString())) {
    throw Error(NAME + "Imprecise conversion");
  }
  return n;
};
P.toPrecision = function(sd, rm) {
  var x = this, Big2 = x.constructor, n = x.c[0];
  if (sd !== UNDEFINED) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
      throw Error(INVALID + "precision");
    }
    x = round(new Big2(x), sd, rm);
    for (; x.c.length < sd; )
      x.c.push(0);
  }
  return stringify(x, sd <= x.e || x.e <= Big2.NE || x.e >= Big2.PE, !!n);
};
P.valueOf = function() {
  var x = this, Big2 = x.constructor;
  if (Big2.strict === true) {
    throw Error(NAME + "valueOf disallowed");
  }
  return stringify(x, x.e <= Big2.NE || x.e >= Big2.PE, true);
};
var Big = _Big_();
var big_default = Big;

// lib/format-currency.ts
function formatCurrency(value, localeConfig, currencyName) {
  const numberConfig = localeConfig.formats.number[currencyName];
  const formatter = new globalThis.Intl.NumberFormat(localeConfig.locale, numberConfig);
  return formatter.format(big_default(value).toNumber());
}
var MINIMUM_FRACTION_DIGITS = 2;
var MAXIMUM_FRACTION_DIGITS = 2;
var defaultConfig = {
  locale: "en-US",
  formats: {
    number: {
      USD: {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: MINIMUM_FRACTION_DIGITS,
        maximumFractionDigits: MAXIMUM_FRACTION_DIGITS
      }
    }
  }
};
var IntlCurrencyInput = ({
  component: InputComponent,
  value,
  defaultValue,
  config,
  currency,
  max,
  autoFocus,
  autoSelect,
  autoReset,
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  inputRef,
  ...otherProps
}) => {
  const localInputRef = useRef(null);
  const [maskedValue, setMaskedValue] = useState("0");
  const safeConfig = useMemo(() => () => {
    const { formats: { number: { [currency]: { maximumFractionDigits = MAXIMUM_FRACTION_DIGITS } } } } = config;
    const finalConfig = {
      ...defaultConfig,
      ...config
    };
    finalConfig.formats.number[currency].minimumFractionDigits = maximumFractionDigits;
    return finalConfig;
  }, [defaultConfig, config]);
  const clean = (entry) => {
    if (typeof entry === "number") {
      return entry;
    }
    return Number(entry.replace(/[^0-9-]/g, "")) || 0;
  };
  const normalizeValue = (entry) => {
    const { formats: { number: { [currency]: { maximumFractionDigits = MAXIMUM_FRACTION_DIGITS } } } } = safeConfig();
    let safeValue = entry;
    if (typeof entry === "string") {
      safeValue = clean(entry);
      if (safeValue % 1 !== 0) {
        safeValue = safeValue.toFixed(maximumFractionDigits);
      }
    } else {
      safeValue = Number.isInteger(safeValue) ? Number(safeValue) * 10 ** maximumFractionDigits : Number(safeValue).toFixed(maximumFractionDigits);
    }
    return clean(safeValue) / 10 ** maximumFractionDigits;
  };
  const calculateValues = (inputFieldValue) => {
    const localValue = normalizeValue(inputFieldValue);
    const localMaskedValue = formatCurrency(localValue, safeConfig(), currency);
    return [localValue, localMaskedValue];
  };
  const updateValues = (entry) => {
    const [calculatedValue, calculatedMaskedValue] = calculateValues(entry);
    if (!max || calculatedValue <= max) {
      setMaskedValue(calculatedMaskedValue);
      return [calculatedValue, calculatedMaskedValue];
    } else {
      return [normalizeValue(maskedValue), maskedValue];
    }
  };
  const handleChange = (event) => {
    event.preventDefault();
    const [localValue, localMaskedValue] = updateValues(event.target.value);
    if (localMaskedValue) {
      onChange(event, localValue, localMaskedValue);
    }
  };
  const handleBlur = (event) => {
    const [localValue, localMaskedValue] = updateValues(event.target.value);
    if (autoReset) {
      calculateValues(0);
    }
    if (localMaskedValue) {
      onBlur(event, localValue, localMaskedValue);
    }
  };
  const handleFocus = (event) => {
    if (autoSelect) {
      localInputRef.current.select();
    }
    const [localValue, localMaskedValue] = updateValues(event.target.value);
    if (localMaskedValue) {
      onFocus(event, localValue, localMaskedValue);
    }
  };
  const handleKeyUp = (event) => onKeyPress(event, event.key, event.keyCode);
  useEffect(() => {
    const currentValue = value || defaultValue || 0;
    const [, localMaskedValue] = calculateValues(currentValue);
    setMaskedValue(localMaskedValue);
    if (autoFocus && localInputRef.current) {
      localInputRef.current.focus();
    }
  }, [autoFocus, autoSelect, currency, value, defaultValue, config]);
  return /* @__PURE__ */ jsx(
    InputComponent,
    {
      ...otherProps,
      ref: inputRef ? inputRef : localInputRef,
      value: maskedValue,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onKeyUp: handleKeyUp
    }
  );
};
var checkCurrentPropType = () => Element ? (0, import_prop_types.instanceOf)(Element) : import_prop_types.any;
IntlCurrencyInput.propTypes = {
  defaultValue: import_prop_types.number,
  value: import_prop_types.number,
  max: import_prop_types.number,
  component: import_prop_types.node.isRequired,
  currency: import_prop_types.string.isRequired,
  config: (0, import_prop_types.shape)({}).isRequired,
  autoFocus: import_prop_types.bool.isRequired,
  autoSelect: import_prop_types.bool.isRequired,
  autoReset: import_prop_types.bool.isRequired,
  onChange: import_prop_types.func.isRequired,
  onBlur: import_prop_types.func.isRequired,
  onFocus: import_prop_types.func.isRequired,
  onKeyPress: import_prop_types.func.isRequired,
  inputRef: (0, import_prop_types.oneOfType)([
    import_prop_types.func,
    (0, import_prop_types.shape)({ current: checkCurrentPropType() })
  ])
};
IntlCurrencyInput.defaultProps = {
  component: "input",
  currency: "USD",
  value: 0,
  config: defaultConfig,
  autoFocus: false,
  autoSelect: false,
  autoReset: false,
  onChange: () => {
  },
  onBlur: () => {
  },
  onFocus: () => {
  },
  onKeyPress: () => {
  },
  inputRef: null
};
var IntlCurrencyInput_default = IntlCurrencyInput;
/*! Bundled license information:

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/

var _a;
var idSequence$8 = idGenerator();
function numberBySize(_a) {
    var size = _a.size, 
    // eslint-disable-next-line comma-dangle
    sizes = __rest(_a, ["size"]);
    return sizes[size];
}
var DECIMAL_LIMIT = 2;
var CNPJ_MASK = 'cnpj';
var CPF_MASK = 'cpf';
var CEP_MASK = 'cep';
var PHONE_MASK = 'phone';
var PHONE_DDD_MASK = 'phoneDDD';
var OLD_PHONE_MASK = 'oldPhone';
var OLD_PHONE_DDD_MASK = 'oldPhoneDDD';
var DATE_MASK = 'date';
var DECIMAL_MASK = 'decimal';
var CURRENCY_MASK = 'currency';
var PASSWORD_TYPE = 'password';
var TEXT_TYPE = 'text';
var statusManager = {
    invalid: 0,
    valid: 1,
    normal: 2,
    disabled: 3,
};
var mappedInputMask = (_a = {},
    _a[CNPJ_MASK] = '**.***.***/****-00',
    _a[CPF_MASK] = '000.000.000-00',
    _a[CEP_MASK] = '00.000-000',
    _a[PHONE_MASK] = '00000-0000',
    _a[PHONE_DDD_MASK] = '(00) 00000-0000',
    _a[OLD_PHONE_MASK] = '0000-0000',
    _a[OLD_PHONE_DDD_MASK] = '(00) 0000-0000',
    _a[DATE_MASK] = '00/00/0000',
    _a);
var InputWrapper = function (_a) {
    var _b;
    var children = _a.children, mask = _a.mask, id = _a.id, value = _a.value, inputRef = _a.inputRef, typeInput = _a.typeInput, inputMode = _a.inputMode, formattedDataset = _a.formattedDataset, disabled = _a.disabled, readOnly = _a.readOnly, placeholder = _a.placeholder, prefix = _a.prefix, suffix = _a.suffix, maxLength = _a.maxLength, currencyTyping = _a.currencyTyping, size = _a.size, customColors = _a.customColors, paddingRight = _a.paddingRight, align = _a.align, applyValue = _a.applyValue, onChange = _a.onChange, onPaste = _a.onPaste, onFocus = _a.onFocus, onBlur = _a.onBlur, onDoubleClick = _a.onDoubleClick, onKeyDown = _a.onKeyDown;
    var childrenPassThru = React.useMemo(function () { return !mask || mask === DECIMAL_MASK; }, [mask]);
    var usingCurrencyInput = React.useMemo(function () { return mask === CURRENCY_MASK; }, [mask]);
    if (childrenPassThru) {
        return React.createElement(React.Fragment, null, children);
    }
    if (usingCurrencyInput) {
        var _c = React.useContext(BaSeI18nContext), locale_1 = _c.locale, formats_1 = _c.formats;
        var _d = React.useState(), currency_1 = _d[0], setCurrency_1 = _d[1];
        var currencyInputConfig = React.useMemo(function () {
            var _a;
            return ({
                locale: locale_1,
                formats: {
                    number: (_a = {},
                        _a[formats_1.numberCurrencyKey] = __assign(__assign({}, formats_1.number[formats_1.numberCurrencyKey]), { style: !prefix ? DECIMAL_MASK : mask }),
                        _a),
                },
            });
        }, [formats_1.number, formats_1.numberCurrencyKey, locale_1, mask, prefix]);
        var handleChange = React.useCallback(function () {
            var _a, _b, _c, _d;
            var cursorPosition = (_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) !== null && _b !== void 0 ? _b : 0;
            var previousValue = (_d = (_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '';
            setTimeout(function () {
                var _a, _b, _c;
                var newValue = (_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                var lengthDifference = newValue.length - previousValue.length;
                var newCursorPosition = cursorPosition + lengthDifference !== -1
                    ? cursorPosition + lengthDifference
                    : 0;
                (_c = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _c === void 0 ? void 0 : _c.setSelectionRange(newCursorPosition, newCursorPosition);
                applyValue(newValue);
            }, 0);
        }, [applyValue, inputRef]);
        var setSelectionOnDecimal = React.useCallback(function (e) {
            var _a, _b, _c, _d, _e;
            if ('key' in e && e.key === 'ArrowLeft') {
                return;
            }
            var target = e.currentTarget;
            var targetValue = (_a = target.value) !== null && _a !== void 0 ? _a : '';
            var decimalValue = (_c = (_b = targetValue.split(formats_1.currency.decimalSeparator)) === null || _b === void 0 ? void 0 : _b[1]) !== null && _c !== void 0 ? _c : '';
            var valueLength = targetValue.length;
            var selectionStart = (_d = target.selectionStart) !== null && _d !== void 0 ? _d : 0;
            var selectionEnd = (_e = target.selectionEnd) !== null && _e !== void 0 ? _e : 0;
            var decimalLimit = valueLength - DECIMAL_LIMIT;
            var hasValidDecimals = decimalValue.length === DECIMAL_LIMIT;
            if (hasValidDecimals &&
                selectionStart === selectionEnd &&
                selectionEnd >= decimalLimit) {
                target.setSelectionRange(decimalLimit, valueLength);
            }
        }, [formats_1.currency.decimalSeparator]);
        React.useEffect(function () {
            if (usingCurrencyInput &&
                !(currency_1 === null || currency_1 === void 0 ? void 0 : currency_1.toString()) &&
                (typeof value === 'string' || typeof value === 'number')) {
                setCurrency_1(value.toString().replaceAll(/[^0-9.-]/g, ''));
            }
        }, [usingCurrencyInput, currency_1, value]);
        return currencyTyping === 'locked' ? (React.createElement(CurrencyInput, __assign({}, formattedDataset, { className: "BaSe--input-input", 
            // defaultValue={0.0}
            decimalsLimit: DECIMAL_LIMIT, decimalScale: DECIMAL_LIMIT, value: currency_1, maxLength: maxLength, id: id, type: typeInput, inputMode: inputMode, ref: inputRef, placeholder: placeholder, disabled: disabled, readOnly: readOnly, prefix: prefix, suffix: suffix, decimalSeparator: formats_1.currency.decimalSeparator, groupSeparator: formats_1.currency.classSeparator, onValueChange: setCurrency_1, onChange: onChange, onPaste: onPaste, onFocus: onFocus, onBlur: onBlur, onDoubleClick: onDoubleClick, onKeyDown: onKeyDown, onClick: setSelectionOnDecimal, onKeyUp: setSelectionOnDecimal }))) : (React.createElement(CurrencyInputWrapper, { size: size, customColors: customColors, paddingRight: paddingRight, align: align },
            React.createElement(IntlCurrencyInput_default, { defaultValue: currency_1, currency: formats_1.numberCurrencyKey, config: currencyInputConfig, inputRef: inputRef, onChange: handleChange, onBlur: onBlur, onFocus: onFocus })));
    }
    return (React.createElement(IMaskInput$1, __assign({}, formattedDataset, { className: "BaSe--input-input", mask: (_b = mappedInputMask === null || mappedInputMask === void 0 ? void 0 : mappedInputMask[mask]) !== null && _b !== void 0 ? _b : mask, value: value, type: typeInput, inputMode: inputMode, disabled: disabled, readOnly: readOnly, placeholder: placeholder, onAccept: function (val) { return applyValue(val); }, onPaste: onPaste, onFocus: onFocus, onBlur: onBlur, onDoubleClick: onDoubleClick, onKeyDown: onKeyDown })));
};
var BaSeInput = React.forwardRef(function (_a, forwardedRef) {
    var _b, _c, _d, _e, _f, _g;
    var externalId = _a.id, name = _a.name, dataset = _a.dataset, _h = _a.isLoading, isLoading = _h === void 0 ? false : _h, _j = _a.isDisabled, isDisabled = _j === void 0 ? false : _j, _k = _a.isReadOnly, isReadOnly = _k === void 0 ? false : _k, _l = _a.showHelpButton, showHelpButton = _l === void 0 ? false : _l, _m = _a.placeholder, placeholder = _m === void 0 ? '' : _m, _o = _a.label, label = _o === void 0 ? '' : _o, _p = _a.complement, complement = _p === void 0 ? '' : _p, _q = _a.moreInfoLabel, moreInfoLabel = _q === void 0 ? '' : _q, _r = _a.moreInfoDetails, moreInfoDetails = _r === void 0 ? '' : _r, _s = _a.size, size = _s === void 0 ? 'medium' : _s, _t = _a.typeInput, typeInput = _t === void 0 ? 'text' : _t, _u = _a.inputMode, inputMode = _u === void 0 ? 'text' : _u, _v = _a.value, value = _v === void 0 ? '' : _v, _w = _a.width, width = _w === void 0 ? '100%' : _w, _x = _a.subLabel, subLabel = _x === void 0 ? '' : _x, _y = _a.align, align = _y === void 0 ? 'start' : _y, _z = _a.helpButtonProps, helpButtonProps = _z === void 0 ? {} : _z, _0 = _a.onSpecificKeyDown, onSpecificKeyDown = _0 === void 0 ? [] : _0, externalPrefix = _a.prefix, suffix = _a.suffix, mask = _a.mask, _1 = _a.color, color = _1 === void 0 ? 'default' : _1, _2 = _a.overrideColors, overrideColors = _2 === void 0 ? {} : _2, _3 = _a.iconButton, iconButton = _3 === void 0 ? {
        typeButton: '',
        name: '',
        action: function () { },
        type: 'primary',
        value: '',
        tooltip: {},
    } : _3, _4 = _a.inputStatus, inputStatus = _4 === void 0 ? 'normal' : _4, _5 = _a.onChange, onChange = _5 === void 0 ? function () { } : _5, onBlur = _a.onBlur, onFocus = _a.onFocus, onInput = _a.onInput, onDoubleClick = _a.onDoubleClick, onPaste = _a.onPaste, onDirty = _a.onDirty, onMutated = _a.onModified, _6 = _a.hasCounter, hasCounter = _6 === void 0 ? false : _6, maxLength = _a.maxLength, counterMinLength = _a.counterMinLength, counterMaxLength = _a.counterMaxLength, _7 = _a.currencyTyping, currencyTyping = _7 === void 0 ? 'locked' : _7;
    if (![false, 'chars', 'words'].includes(hasCounter)) {
        throw Error('[BaSeInput] Atributo "hasCounter" deve ser do tipo: "chars", "words" ou false');
    }
    if (!['text', 'password', 'email', 'tel', 'url'].includes(typeInput)) {
        throw Error('[BaSeInput] Atributo "typeInput" deve ser do tipo: "text", "password", "email", "tel" ou "url"');
    }
    if (!['text', 'decimal', 'email', 'tel', 'url', 'search'].includes(inputMode)) {
        throw Error('[BaSeInput] Atributo "inputMode" deve ser do tipo: "text", "decimal", "email", "tel" ou "url"');
    }
    if (align === 'end' && iconButton.typeButton === 'base-button') {
        throw Error('[BaSeInput] Atributo "align" não deve ser "end", quando passamos um "iconButton.typeButton" igual à "base-button"');
    }
    if (mask === 'currency' &&
        externalPrefix &&
        externalPrefix !== '' &&
        currencyTyping === 'unlocked') {
        throw Error('[BaSeInput] Atributo "prefix" deve ser usado apenas para remover o valor padrão passando "" quando passamos um "mask" igual à "currency" e "currencyTyping" igual a "unlocked"');
    }
    var inputRef = React.useRef(null);
    React.useImperativeHandle(forwardedRef, function () { return ({ focus: function () { var _a, _b; return (_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a); } }); }, [inputRef]);
    var _8 = useCounter({
        value: value,
        hasCounter: hasCounter,
        counterMinLength: counterMinLength,
        counterMaxLength: counterMaxLength,
        onChange: onChange,
    }), counterDescription = _8.counterDescription, cropText = _8.cropText;
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence$8);
    var _9 = React.useState(false), mutated = _9[0], setMutated = _9[1];
    var _10 = React.useState(false), dirty = _10[0], setDirty = _10[1];
    var copyValue = React.useState(value)[0];
    var _11 = React.useContext(BaSeI18nContext), getMessage = _11.getMessage, currencyFormat = _11.formats.currency;
    var prefix = React.useMemo(function () {
        return externalPrefix !== null && externalPrefix !== void 0 ? externalPrefix : (mask === CURRENCY_MASK ? currencyFormat.prefix : externalPrefix);
    }, [currencyFormat, mask, externalPrefix]);
    var _12 = React.useState(false), hasFocus = _12[0], setHasFocus = _12[1];
    var formattedDataset = getFormattedDataset(dataset);
    var handlePasteEvent = React.useCallback(function (event) {
        onPaste === null || onPaste === void 0 ? void 0 : onPaste(event);
    }, [onPaste]);
    var handleDoubleClickEvent = React.useCallback(function (event) {
        onDoubleClick === null || onDoubleClick === void 0 ? void 0 : onDoubleClick(event);
    }, [onDoubleClick]);
    var handleInputEvent = React.useCallback(function (event) {
        setMutated(true);
        onInput === null || onInput === void 0 ? void 0 : onInput(event);
        counterMaxLength
            ? cropText(event.currentTarget.value)
            : onChange(event.currentTarget.value);
    }, [onInput, setMutated, cropText, onChange, counterMaxLength]);
    var handleFocusEvent = React.useCallback(function (event) {
        setHasFocus(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    }, [onFocus, setHasFocus]);
    var handleBlurEvent = React.useCallback(function (event) {
        setHasFocus(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }, [onBlur, setHasFocus]);
    var handleInputStatus = React.useCallback(function () {
        var _a;
        if (isDisabled) {
            return statusManager.disabled;
        }
        if (!dirty && !mutated) {
            return statusManager.normal;
        }
        return (_a = statusManager[inputStatus !== null && inputStatus !== void 0 ? inputStatus : 'normal']) !== null && _a !== void 0 ? _a : statusManager.normal;
    }, [inputStatus, isDisabled, dirty, mutated]);
    var getColorsFromState = React.useCallback(function () {
        var _a;
        var colors = __assign({}, inputColorManager(color, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.status)[isDisabled
            ? 'disabled'
            : !dirty && !mutated
                ? 'normal'
                : inputStatus !== null && inputStatus !== void 0 ? inputStatus : 'normal']);
        var overrideBorder = (_a = getOverridedColorsExtra === null || getOverridedColorsExtra === void 0 ? void 0 : getOverridedColorsExtra()) === null || _a === void 0 ? void 0 : _a.border;
        if (overrideBorder) {
            colors.borderColor = overrideBorder;
        }
        if (overrideColors.value) {
            colors.color = overrideColors.value;
        }
        if (overrideColors.background) {
            colors.backgroundColor = overrideColors.background;
        }
        return colors;
    }, [isDisabled, color, inputStatus, overrideColors, dirty, mutated]);
    var getOverridedColorsExtra = React.useCallback(function () {
        return overrideExtraColors(overrideColors);
    }, [overrideColors]);
    var handleIconColorBaseIcon = React.useCallback(function (ignoreFocus) {
        var _a, _b, _c, _d;
        if (ignoreFocus) {
            return (_a = iconButton.color) !== null && _a !== void 0 ? _a : (_b = getColorsFromState()) === null || _b === void 0 ? void 0 : _b.focusTextColor;
        }
        return ((_c = iconButton.color) !== null && _c !== void 0 ? _c : (_d = getColorsFromState()) === null || _d === void 0 ? void 0 : _d[hasFocus ? 'focusTextColor' : 'color']);
    }, [iconButton.color, getColorsFromState, hasFocus]);
    var getValidTopIconPositions = React.useCallback(function () {
        var _a;
        var topPositionMap = {
            small: 8,
            medium: 12,
            big: 16,
        };
        return (iconButton === null || iconButton === void 0 ? void 0 : iconButton.typeButton) || inputStatus === 'valid'
            ? (iconButton === null || iconButton === void 0 ? void 0 : iconButton.typeButton) !== 'base-icon' && inputStatus !== 'valid'
                ? 2
                : 0
            : (_a = topPositionMap[size !== null && size !== void 0 ? size : 'medium']) !== null && _a !== void 0 ? _a : topPositionMap === null || topPositionMap === void 0 ? void 0 : topPositionMap.medium;
    }, [size, iconButton === null || iconButton === void 0 ? void 0 : iconButton.typeButton, inputStatus]);
    var _13 = React.useState(false), showPassword = _13[0], setShowPassword = _13[1];
    var getValue = React.useCallback(function (dirtyValue) {
        var _a;
        var _b, _c;
        var escapeRegExp = function (str) { var _a; return (_a = str === null || str === void 0 ? void 0 : str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')) !== null && _a !== void 0 ? _a : ''; };
        var prefixRegExp = new RegExp("^".concat(escapeRegExp(prefix)));
        var suffixRegExp = new RegExp("".concat(escapeRegExp(suffix), "$"));
        var filterValue = function (regExp, val, what) {
            return what ? (val !== null && val !== void 0 ? val : '').toString().replace(regExp, '') : val;
        };
        var valueWithoutPrefix = filterValue(prefixRegExp, dirtyValue, prefix);
        var valueWithoutPrefixAndSuffix = filterValue(suffixRegExp, valueWithoutPrefix, suffix);
        var masks = (_a = {},
            _a[CNPJ_MASK] = function () {
                return clearCnpjMask({ value: valueWithoutPrefixAndSuffix });
            },
            _a[CURRENCY_MASK] = function () {
                return forceCurrencyValue({
                    value: valueWithoutPrefixAndSuffix,
                    decimalSeparator: currencyFormat.decimalSeparator,
                });
            },
            _a[DECIMAL_MASK] = function () {
                return decimalMask({
                    value: valueWithoutPrefixAndSuffix,
                    decimalSeparator: currencyFormat.decimalSeparator,
                    classSeparator: currencyFormat.classSeparator,
                });
            },
            _a);
        var clearValue = (_c = (_b = masks === null || masks === void 0 ? void 0 : masks[mask]) === null || _b === void 0 ? void 0 : _b.call(masks)) !== null && _c !== void 0 ? _c : valueWithoutPrefixAndSuffix;
        if (clearValue) {
            return clearValue;
        }
        return '';
    }, [mask, prefix, suffix, currencyFormat]);
    var inputValue = React.useMemo(function () {
        var clearValue = getValue(value);
        if (clearValue) {
            return (prefix !== null && prefix !== void 0 ? prefix : '') + clearValue + (suffix !== null && suffix !== void 0 ? suffix : '');
        }
        return '';
    }, [prefix, suffix, value, getValue]);
    var applyValue = React.useCallback(function (valueToApply) { return onChange(getValue(valueToApply)); }, [onChange, getValue]);
    var onChangeEvent = React.useCallback(function (event) {
        var _a;
        applyValue((_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.value);
    }, [applyValue]);
    var hasComplement = React.useMemo(function () { return complement !== ''; }, [complement]);
    var paddingRight = React.useMemo(function () {
        return typeInput === PASSWORD_TYPE ||
            iconButton.typeButton === 'base-icon' ||
            isLoading
            ? numberBySize({ size: size, small: 24, medium: 32, big: 40 })
            : iconButton.typeButton === 'base-shape-button'
                ? numberBySize({ size: size, small: 40, medium: 48, big: 56 })
                : 12;
    }, [typeInput, iconButton.typeButton, size, isLoading]);
    var calcSize = React.useMemo(function () {
        var _a, _b;
        return iconButton.type === 'secondary'
            ? ((_a = mapBaSeInputSize[size]) !== null && _a !== void 0 ? _a : mapBaSeInputSize.medium) + 2
            : (_b = mapBaSeInputSize[size]) !== null && _b !== void 0 ? _b : mapBaSeInputSize.medium;
    }, [iconButton.type, size]);
    var inputType = React.useMemo(function () {
        return typeInput === 'password'
            ? !showPassword
                ? PASSWORD_TYPE
                : TEXT_TYPE
            : typeInput;
    }, [showPassword, typeInput]);
    var onClickIconButton = React.useCallback(function () {
        var _a, _b, _c;
        if (typeInput === PASSWORD_TYPE) {
            return setShowPassword(function (actualShowPassword) { return !actualShowPassword; });
        }
        (_a = iconButton === null || iconButton === void 0 ? void 0 : iconButton.action) === null || _a === void 0 ? void 0 : _a.call(iconButton);
        (_c = (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
    }, [typeInput, iconButton, inputRef]);
    var handleKeyDownEvent = React.useCallback(function (event) {
        var _a, _b;
        for (var _i = 0, onSpecificKeyDown_1 = onSpecificKeyDown; _i < onSpecificKeyDown_1.length; _i++) {
            var keyListener = onSpecificKeyDown_1[_i];
            if ((keyListener === null || keyListener === void 0 ? void 0 : keyListener.listenerKey) === event.key) {
                (_a = keyListener === null || keyListener === void 0 ? void 0 : keyListener.callback) === null || _a === void 0 ? void 0 : _a.call(keyListener, event);
            }
        }
        if (suffix && mask !== CURRENCY_MASK) {
            var pos = ((prefix !== null && prefix !== void 0 ? prefix : '') + value).length;
            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.setSelectionRange(pos, pos);
        }
    }, [onSpecificKeyDown, prefix, suffix, value, mask]);
    var handleHelperColor = function () {
        var _a, _b;
        var type = translationValueToName[handleInputStatus()];
        return (_b = (_a = mapBaSeInputColor[type]) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : mapBaSeInputColor.normal.color;
    };
    var getOriginalValueFromMaskedInput = React.useCallback(function () {
        if (!!mask) {
            return mask
                ? removeNonDigit(value + '') !== removeNonDigit(copyValue + '')
                : substringContainMask(copyValue, value);
        }
        return value !== copyValue;
    }, [mask, value, copyValue]);
    React.useEffect(function () { return setDirty(getOriginalValueFromMaskedInput()); }, [value, copyValue, getOriginalValueFromMaskedInput]);
    React.useEffect(function () { return onDirty === null || onDirty === void 0 ? void 0 : onDirty(dirty); }, [dirty, onDirty]);
    React.useEffect(function () { return onMutated === null || onMutated === void 0 ? void 0 : onMutated(mutated); }, [mutated, onMutated]);
    return (React.createElement(ContainerInput, { width: width },
        React.createElement(BaSeFormLabel, { id: id, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, colors: {
                label: (_b = getOverridedColorsExtra()) === null || _b === void 0 ? void 0 : _b.label,
                subLabel: (_c = getOverridedColorsExtra()) === null || _c === void 0 ? void 0 : _c.subLabel,
            } }),
        React.createElement(WrapperInput, { size: calcSize, customColors: getColorsFromState(), paddingRight: paddingRight, align: align },
            React.createElement(InputWrapper, { mask: mask, maxLength: maxLength, inputRef: inputRef, id: id, value: inputValue, typeInput: inputType, inputMode: inputMode, formattedDataset: formattedDataset, disabled: isDisabled, readOnly: isReadOnly, placeholder: placeholder, currencyTyping: currencyTyping, size: calcSize, customColors: getColorsFromState(), paddingRight: paddingRight, align: align, prefix: prefix, suffix: suffix, applyValue: applyValue, onChange: onChangeEvent, onPaste: handlePasteEvent, onFocus: handleFocusEvent, onBlur: handleBlurEvent, onDoubleClick: handleDoubleClickEvent, onKeyDown: handleKeyDownEvent },
                React.createElement("input", __assign({ className: "BaSe--input-input", id: id, name: name }, formattedDataset, { ref: inputRef, value: inputValue, type: inputType, inputMode: inputMode, disabled: isDisabled, readOnly: isReadOnly, placeholder: placeholder, onChange: onChangeEvent, maxLength: maxLength, onInput: handleInputEvent, onPaste: handlePasteEvent, onFocus: handleFocusEvent, onBlur: handleBlurEvent, onDoubleClick: handleDoubleClickEvent, onKeyDown: handleKeyDownEvent }))),
            React.createElement(ContainerIcon, { rotation: typeInput === PASSWORD_TYPE && showPassword }, isLoading ? (React.createElement(BaSeLoadingSpinner, { description: getMessage('loading.description'), diameter: size === 'big' ? 24 : 16, color: handleIconColorBaseIcon() })) : (React.createElement(React.Fragment, null,
                inputStatus === 'valid' && (dirty || mutated) && (React.createElement(CheckIconWrapper, { top: getValidTopIconPositions() },
                    React.createElement(BaSeIcon, { description: "Campo validado", name: "check", color: handleIconColorBaseIcon(true), size: 18 }))),
                (typeInput === PASSWORD_TYPE ||
                    iconButton.typeButton === 'base-icon') && (React.createElement("div", null,
                    React.createElement(BaSeShapeButton, { name: name ? "input-shape-button-".concat(name) : undefined, nameIcon: typeInput === PASSWORD_TYPE
                            ? !showPassword
                                ? 'eye-slash'
                                : 'eye'
                            : (_d = iconButton.name) !== null && _d !== void 0 ? _d : '', descriptionIcon: iconButton.value !== '' &&
                            iconButton.value !== undefined
                            ? iconButton.value
                            : typeInput === PASSWORD_TYPE
                                ? !showPassword
                                    ? getMessage('buttonIcon.showPassword')
                                    : getMessage('buttonIcon.hidePassword')
                                : getMessage('buttonIcon.inputIcon'), size: size, type: "tertiary", color: handleIconColorBaseIcon(true), tooltip: iconButton.tooltip, isDisabled: isDisabled, onClick: onClickIconButton }))),
                iconButton.typeButton === 'base-button' && (React.createElement("div", null,
                    React.createElement(BaSeButton, { value: iconButton.value, onClick: onClickIconButton, type: iconButton.type, leftIcon: iconButton.name, size: size, buttonType: "button", isDisabled: isDisabled, color: handleIconColorBaseIcon(true), tooltip: iconButton.tooltip }))),
                iconButton.typeButton === 'base-shape-button' && (React.createElement("div", null,
                    React.createElement(BaSeShapeButton, { onClick: onClickIconButton, buttonType: "button", nameIcon: (_e = iconButton.name) !== null && _e !== void 0 ? _e : '', shape: "square", size: size, type: iconButton.type, isDisabled: isDisabled, color: handleIconColorBaseIcon(true), tooltip: iconButton.tooltip }))))))),
        React.createElement(StyledTextFooterWrapper, null,
            hasComplement && (React.createElement(WrapperHelper$2, null,
                React.createElement(BaSeHelperText, { isItalic: true, color: (_f = overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.complement) !== null && _f !== void 0 ? _f : handleHelperColor(), label: complement }))),
            hasCounter && (React.createElement(StyledInputCounter, { color: (_g = overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.complement) !== null && _g !== void 0 ? _g : handleHelperColor() }, counterDescription))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$3, null,
            React.createElement(BaSeHelperText, { color: overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.moreInfo, size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
});
BaSeInput.displayName = 'BaSeInput';

var AutocompleteWrapper = styled.div.attrs({
    className: 'BaSe--autocomplete',
})(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen, mode = _a.mode;
    return mode === 'list' &&
        isOpen && css(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n      & .BaSe--input-input:not(:focus) {\n        border: 1px solid ", ";\n        color: ", ";\n        box-shadow: ", ";\n      }\n    "], ["\n      & .BaSe--input-input:not(:focus) {\n        border: 1px solid ", ";\n        color: ", ";\n        box-shadow: ", ";\n      }\n    "])), BaSeTheme.colors.institucionais.azulSebrae36, BaSeTheme.colors.institucionais.azulSebrae36, BaSeTheme.shadows.focusPrimary);
});
var AutocompleteResultInline = styled.output.attrs({
    className: 'BaSe--autocomplete-result-inline',
})(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  bottom: ", "px;\n  left: 0.8em;\n  color: ", ";\n  pointer-events: none;\n\n  & > span {\n    color: ", ";\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  bottom: ", "px;\n  left: 0.8em;\n  color: ", ";\n  pointer-events: none;\n\n  & > span {\n    color: ", ";\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (_a) {
    var size = _a.size;
    return size === 'small' ? 7 : size === 'medium' ? 11 : 15;
}, BaSeTheme.colors.institucionais.cinzaSebrae75, BaSeTheme.colors.defaultColors.transparent);
var HideTopOfAutocompleteResultList = styled.div(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"], ["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.stackOrder.overlay + 1);
var AutocompleteResultList = styled.ul.attrs({
    className: 'BaSe--autocomplete-result-list',
})(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  ", ";\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  ", ";\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, BaSeTheme.stackOrder.overlay, BaSeTheme.colors.defaultColors.white, function (_a) {
    var hasError = _a.hasError;
    return hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.azulSebrae36;
}, function (_a) {
    var attached = _a.attached;
    return attached && css(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n      border-top: none;\n      border-radius: 0px 0px 4px 4px;\n    "], ["\n      border-top: none;\n      border-radius: 0px 0px 4px 4px;\n    "])));
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'auto' : '0px');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, attached = _a.attached;
    return isOpen && attached ? '-3px' : '4px';
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError;
    return isOpen
        ? hasError
            ? BaSeTheme.shadows.focusError
            : BaSeTheme.shadows.focusPrimary
        : 'none';
}, BaSeScrollbarCss);
var AutocompleteResultListItem = styled.li(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  transition: ", ";\n  will-change: background-color;\n  padding: 8px 4px;\n  gap: 16px;\n  cursor: ", ";\n  justify-content: ", ";\n  background-color: ", ";\n\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &.active {\n    background-color: ", ";\n  }\n"], ["\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  transition: ", ";\n  will-change: background-color;\n  padding: 8px 4px;\n  gap: 16px;\n  cursor: ", ";\n  justify-content: ", ";\n  background-color: ", ";\n\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &.active {\n    background-color: ", ";\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var _b = _a.cursor, cursor = _b === void 0 ? 'pointer' : _b;
    return cursor;
}, function (_a) {
    var hasStatus = _a.hasStatus;
    return hasStatus ? 'space-between' : 'normal';
}, BaSeTheme.colors.contrast.institucionais.azulSebrae, BaSeTheme.colors.institucionais.azulSebrae97, BaSeTheme.colors.institucionais.azulSebrae);
var AutocompleteResultItemImage = styled.img(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject(["\n  border: 2px solid ", ";\n  object-fit: contain;\n  ", "\n"], ["\n  border: 2px solid ", ";\n  object-fit: contain;\n  ", "\n"])), BaSeTheme.colors.institucionais.cinzaSebrae75, function (_a) {
    var size = _a.size;
    return css(templateObject_8$a || (templateObject_8$a = __makeTemplateObject(["\n    border-radius: ", "px;\n    height: ", "px;\n    width: ", "px;\n    max-width: ", "px;\n    max-height: ", "px;\n    flex: 0 0 ", "px;\n  "], ["\n    border-radius: ", "px;\n    height: ", "px;\n    width: ", "px;\n    max-width: ", "px;\n    max-height: ", "px;\n    flex: 0 0 ", "px;\n  "])), size, size, size, size, size, size);
});
var templateObject_1$v, templateObject_2$r, templateObject_3$m, templateObject_4$i, templateObject_5$e, templateObject_6$d, templateObject_7$a, templateObject_8$a, templateObject_9$9;

var ExtraItem = function (_a) {
    var _b = _a.extraItem, text = _b.text, iconName = _b.iconName, showOnlyResultIsEmpty = _b.showOnlyResultIsEmpty, _c = _b.color, color = _c === void 0 ? BaSeTheme.colors.defaultColors.black : _c, _d = _b.isBold, isBold = _d === void 0 ? true : _d, isEmpty = _a.isEmpty;
    return !showOnlyResultIsEmpty || (showOnlyResultIsEmpty && isEmpty) ? (React.createElement(AutocompleteResultListItem, { className: "BaSe--autocomplete-result-list-item ", cursor: "auto" },
        iconName && (React.createElement(BaSeIcon, { name: iconName, size: 20, description: "\u00CDcone do texto final: ".concat(text), color: color })),
        React.createElement(BaSeParagraph, { isBold: isBold, color: color }, text))) : null;
};
var ExtraAction$1 = function (_a) {
    var _b = _a.extraAction, label = _b.label, onClick = _b.onClick, iconName = _b.iconName, showOnlyResultIsEmpty = _b.showOnlyResultIsEmpty, isEmpty = _a.isEmpty, term = _a.term, setIsOpen = _a.setIsOpen;
    var _c = React.useState(false), isActive = _c[0], setIsActive = _c[1];
    var textColor = React.useMemo(function () {
        return isActive
            ? BaSeTheme.colors.defaultColors.white
            : BaSeTheme.colors.defaultColors.black;
    }, [isActive]);
    var closeCallback = React.useCallback(function () { return setIsOpen(false); }, []);
    return !showOnlyResultIsEmpty || (showOnlyResultIsEmpty && isEmpty) ? (React.createElement(AutocompleteResultListItem, { role: "button", tabIndex: 0, className: "BaSe--autocomplete-result-list-item ".concat(isActive ? 'active' : ''), onFocus: function () { return setIsActive(true); }, onBlur: function () { return setIsActive(false); }, onClick: function () { return onClick(term, closeCallback); }, onKeyDown: function (e) { return e.key === 'Enter' && onClick(term, closeCallback); } },
        iconName && (React.createElement(BaSeIcon, { name: iconName, size: 20, description: "\u00CDcone da a\u00E7\u00E3o: ".concat(label), color: textColor })),
        React.createElement(BaSeParagraph, { color: textColor }, label))) : null;
};
var BaSeAutocomplete = function (_a) {
    var id = _a.id, name = _a.name, dataset = _a.dataset, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.mode, mode = _c === void 0 ? 'list' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.width, width = _e === void 0 ? '100%' : _e, _f = _a.inputMode, inputMode = _f === void 0 ? 'search' : _f, _g = _a.isDisabled, isDisabled = _g === void 0 ? false : _g, _h = _a.minLengthToSearch, minLengthToSearch = _h === void 0 ? 3 : _h, _j = _a.showHelpButton, showHelpButton = _j === void 0 ? false : _j, _k = _a.complement, complement = _k === void 0 ? '' : _k, _l = _a.moreInfoLabel, moreInfoLabel = _l === void 0 ? '' : _l, _m = _a.moreInfoDetails, moreInfoDetails = _m === void 0 ? '' : _m, _o = _a.size, size = _o === void 0 ? 'medium' : _o, _p = _a.subLabel, subLabel = _p === void 0 ? '' : _p, _q = _a.helpButtonProps, helpButtonProps = _q === void 0 ? {} : _q, _r = _a.imageAndIconSize, imageAndIconSize = _r === void 0 ? 48 : _r, onSearchTerm = _a.onSearchTerm, onSelectedItem = _a.onSelectedItem, onClearSelection = _a.onClearSelection, _s = _a.extraActions, extraActions = _s === void 0 ? [] : _s, _t = _a.extraItems, extraItems = _t === void 0 ? [] : _t;
    var _u = React.useState(0), selectedIndex = _u[0], setSelectedIndex = _u[1];
    var _v = React.useState(false), isOpen = _v[0], setIsOpen = _v[1];
    var _w = React.useState(false), isLoading = _w[0], setIsLoading = _w[1];
    var _x = React.useState(false), isInputFocused = _x[0], setIsInputFocused = _x[1];
    var _y = React.useState(false), hasError = _y[0], setHasError = _y[1];
    var _z = React.useState(''), value = _z[0], setValue = _z[1];
    var _0 = React.useState([]), resultList = _0[0], setResultList = _0[1];
    var wrapperRef = React.useRef(null);
    var listRef = React.useRef(null);
    var term = useDebounce(value, 350);
    useOutsideEvent(wrapperRef, setIsOpen);
    var hasAlwaysOpenedExtraItem = React.useMemo(function () {
        return extraItems.some(function (_a) {
            var showOnlyResultIsEmpty = _a.showOnlyResultIsEmpty;
            return !showOnlyResultIsEmpty;
        });
    }, [extraItems]);
    var foundResult = React.useMemo(function () {
        return !hasError &&
            (term === null || term === void 0 ? void 0 : term.length) >= minLengthToSearch &&
            (hasAlwaysOpenedExtraItem ||
                (resultList === null || resultList === void 0 ? void 0 : resultList.length) > 0 ||
                extraActions.length > 0);
    }, [
        hasError,
        resultList,
        extraActions,
        term,
        minLengthToSearch,
        hasAlwaysOpenedExtraItem,
    ]);
    var getResult = React.useCallback(function () { var _a; return (_a = resultList === null || resultList === void 0 ? void 0 : resultList[selectedIndex]) === null || _a === void 0 ? void 0 : _a.label; }, [resultList, selectedIndex]);
    var resultInline = React.useCallback(function () {
        var _a, _b;
        var regExp = new RegExp("(^.{".concat(term.length, "})(.*$)"));
        return (_b = (_a = getResult()) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, regExp, "<span>".concat(term, "</span>$2"));
    }, [resultList, term]);
    var isActive = React.useCallback(function (item) {
        var itemIndex = resultList.findIndex(function (resultItem) { return resultItem.id === item.id; });
        return itemIndex === selectedIndex;
    }, [selectedIndex, resultList]);
    var attached = React.useCallback(function () { return !complement && !moreInfoLabel; }, [complement, moreInfoLabel]);
    var clear = React.useCallback(function () {
        setSelectedIndex(0);
        setValue('');
        onClearSelection === null || onClearSelection === void 0 ? void 0 : onClearSelection();
    }, [setValue, setSelectedIndex]);
    var selectItem = React.useCallback(function (item) {
        var resultItem = item !== null && item !== void 0 ? item : resultList === null || resultList === void 0 ? void 0 : resultList[selectedIndex];
        onSelectedItem === null || onSelectedItem === void 0 ? void 0 : onSelectedItem(resultItem, clear);
    }, [resultList, selectedIndex, clear]);
    var eventPreparation = React.useCallback(function (event) {
        if (mode !== 'inline') {
            event.preventDefault();
            event.stopPropagation();
            return true;
        }
        return false;
    }, [mode]);
    var getCurrentItemHeightActive = React.useCallback(function () {
        var _a, _b, _c, _d, _e;
        return (_e = (_d = (_c = (_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.active')) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 ? void 0 : _d.height) !== null && _e !== void 0 ? _e : 0;
    }, [listRef]);
    var onEnter = React.useCallback(function () {
        setValue(getResult());
        selectItem();
        setSelectedIndex(0);
    }, [setValue, getResult, selectItem]);
    var onEscape = React.useCallback(function () { return clear(); }, [clear]);
    var onArrowUp = React.useCallback(function (event) {
        var _a;
        if (eventPreparation(event)) {
            var min_1 = 0;
            setSelectedIndex(function (actualSelectedIndex) {
                return --actualSelectedIndex < min_1 ? min_1 : actualSelectedIndex;
            });
            (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({
                behavior: 'smooth',
                top: getCurrentItemHeightActive() * -1,
            });
        }
    }, [setSelectedIndex]);
    var onArrowDown = React.useCallback(function (event) {
        var _a;
        if (eventPreparation(event)) {
            var max_1 = resultList.length - 1;
            setSelectedIndex(function (actualSelectedIndex) {
                return ++actualSelectedIndex >= max_1 ? max_1 : actualSelectedIndex;
            });
            (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({
                behavior: 'smooth',
                top: getCurrentItemHeightActive(),
            });
        }
    }, [setSelectedIndex, resultList]);
    var onFocus = React.useCallback(function () {
        setIsInputFocused(true);
        setIsOpen(true);
    }, []);
    React.useEffect(function () {
        if (value !== term) {
            setHasError(false);
            setResultList([]);
        }
        if (value === '') {
            onClearSelection === null || onClearSelection === void 0 ? void 0 : onClearSelection();
        }
    }, [term, value]);
    React.useEffect(function () {
        setHasError(false);
        setResultList([]);
        if (!term || minLengthToSearch > (term === null || term === void 0 ? void 0 : term.length)) {
            return;
        }
        setIsLoading(true);
        var afterSearchTerm = onSearchTerm(term);
        if (Array.isArray(afterSearchTerm)) {
            setResultList(afterSearchTerm);
            return setIsLoading(false);
        }
        afterSearchTerm
            .then(setResultList)
            .catch(function () { return setHasError(true); })
            .finally(function () { return setIsLoading(false); });
    }, [term]);
    React.useEffect(function () { return setHasError(resultList.some(function (item) { return !(item === null || item === void 0 ? void 0 : item.id) || !(item === null || item === void 0 ? void 0 : item.label); })); }, [resultList]);
    React.useEffect(function () { return setIsOpen(foundResult && isInputFocused); }, [resultList, foundResult]);
    return (React.createElement(AutocompleteWrapper, { ref: wrapperRef, isOpen: isOpen, mode: mode },
        React.createElement(BaSeInput, { id: id, name: name, dataset: dataset, width: width, showHelpButton: showHelpButton, complement: complement, moreInfoLabel: moreInfoLabel, moreInfoDetails: moreInfoDetails, size: size, subLabel: subLabel, helpButtonProps: helpButtonProps, label: label, inputMode: inputMode, placeholder: placeholder, value: value, isDisabled: isDisabled, isLoading: isLoading, iconButton: {
                action: !!(value === null || value === void 0 ? void 0 : value.length) ? clear : undefined,
                color: BaSeTheme.colors.institucionais.azulSebrae,
                name: !!(value === null || value === void 0 ? void 0 : value.length) ? 'close' : 'search',
                typeButton: 'base-icon',
            }, onSpecificKeyDown: [
                { listenerKey: 'Enter', callback: onEnter },
                { listenerKey: 'Escape', callback: onEscape },
                { listenerKey: 'ArrowUp', callback: onArrowUp },
                { listenerKey: 'ArrowDown', callback: onArrowDown },
            ], inputStatus: hasError ? 'invalid' : 'normal', onChange: function (newValue) { return setValue(newValue); }, onFocus: onFocus }),
        foundResult &&
            (mode === 'list' ? (React.createElement(React.Fragment, null,
                isOpen && attached() && React.createElement(HideTopOfAutocompleteResultList, null),
                React.createElement(AutocompleteResultList, { ref: listRef, attached: attached(), hasError: hasError, isOpen: isOpen },
                    resultList.map(function (item) { return (React.createElement(AutocompleteResultListItem, { hasStatus: !!item.status, className: "BaSe--autocomplete-result-list-item ".concat(isActive(item) ? 'active' : ''), key: item.id, onClick: function () {
                            setValue(item.label);
                            selectItem(item);
                            setIsInputFocused(false);
                            setIsOpen(false);
                        } },
                        (item === null || item === void 0 ? void 0 : item.imageSource) && (React.createElement(AutocompleteResultItemImage, { size: imageAndIconSize, src: item.imageSource, alt: "Imagem de ".concat(item === null || item === void 0 ? void 0 : item.label) })),
                        (item === null || item === void 0 ? void 0 : item.iconName) && (React.createElement(BaSeIcon, { name: item.iconName, size: imageAndIconSize, description: "\u00CDcone do item: ".concat(item === null || item === void 0 ? void 0 : item.label), color: isActive(item)
                                ? BaSeTheme.colors.defaultColors.white
                                : BaSeTheme.colors.defaultColors.black })),
                        React.createElement(React.Fragment, null,
                            React.createElement(BaSeParagraph, { color: isActive(item)
                                    ? BaSeTheme.colors.defaultColors.white
                                    : BaSeTheme.colors.defaultColors.black }, item === null || item === void 0 ? void 0 : item.label),
                            (item === null || item === void 0 ? void 0 : item.description) && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement(BaSeSmall1, { color: isActive(item)
                                        ? BaSeTheme.colors.institucionais.cinzaSebrae75
                                        : BaSeTheme.colors.institucionais.cinzaSebrae45 }, item === null || item === void 0 ? void 0 : item.description))),
                            (item === null || item === void 0 ? void 0 : item.status) && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement(BaSeSmall1, { isBold: true, color: isActive(item)
                                        ? BaSeTheme.colors.defaultColors.white
                                        : (item === null || item === void 0 ? void 0 : item.statusColor)
                                            ? item === null || item === void 0 ? void 0 : item.statusColor
                                            : BaSeTheme.colors.institucionais.cinzaSebrae45 }, item === null || item === void 0 ? void 0 : item.status)))))); }),
                    extraActions.map(function (action, index) { return (React.createElement(ExtraAction$1, { extraAction: action, key: index, isEmpty: !(resultList === null || resultList === void 0 ? void 0 : resultList.length), term: term, setIsOpen: setIsOpen })); }),
                    extraItems.map(function (action, index) { return (React.createElement(ExtraItem, { extraItem: action, key: index, isEmpty: !(resultList === null || resultList === void 0 ? void 0 : resultList.length) })); })))) : (React.createElement(AutocompleteResultInline, { size: size, dangerouslySetInnerHTML: { __html: resultInline() } })))));
};
BaSeAutocomplete.displayName = 'BaSeAutocomplete';

var WrapperCounterLabel = styled.div.attrs({
    className: 'BaSe--counter-wrapper-label',
})(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"])), BaSeTheme.colors.defaultColors.transparent);
var StyledLabel$1 = styled.label(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"])), function (props) { return props.fontSize; }, function (props) { return props.lineHeight; }, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.typography.fontFamily);
var StyledSubLabel$1 = styled.label.attrs({
    className: 'BaSe--counter-sub-label',
})(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight;
}, BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae60);
var ButtonInfoContainer$1 = styled.div(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var StyledApoio = styled.span(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"], ["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"])), function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae45;
}, BaSeTheme.typography.fontFamily);
var StyledCounterInput = styled.input.attrs({
    inputMode: 'numeric',
})(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  padding-left: 12px;\n  background: ", ";\n  border-top: 1px solid\n    ", ";\n  border-bottom: 1px solid\n    ", ";\n  border-left: 0px;\n  border-right: 0px;\n  border-radius: 0px;\n  height: ", "px;\n  padding-right: 26px;\n  padding: 0;\n  margin-left: -2px;\n  margin-right: -2px;\n  width: ", ";\n  min-width: 60px;\n  color: ", ";\n  text-align: center;\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  padding-left: 12px;\n  background: ", ";\n  border-top: 1px solid\n    ", ";\n  border-bottom: 1px solid\n    ", ";\n  border-left: 0px;\n  border-right: 0px;\n  border-radius: 0px;\n  height: ", "px;\n  padding-right: 26px;\n  padding: 0;\n  margin-left: -2px;\n  margin-right: -2px;\n  width: ", ";\n  min-width: 60px;\n  color: ", ";\n  text-align: center;\n  &:focus {\n    outline: 0;\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, BaSeTheme.colors.defaultColors.transparent, function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae75;
}, function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae75;
}, function (props) { return props.height; }, function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae30;
});
var CounterContainer = styled.div(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var MoreInfoContainer$2 = styled.div(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var CounterInnerContainer = styled.div(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1$u, templateObject_2$q, templateObject_3$l, templateObject_4$h, templateObject_5$d, templateObject_6$c, templateObject_7$9, templateObject_8$9, templateObject_9$8;

var mapCounterSize = {
    small: {
        padding: 30,
    },
    big: {
        padding: 46,
    },
    medium: {
        padding: 38,
    },
};

var idSequence$7 = idGenerator();
var BaSeCounter = function (_a) {
    var _b, _c;
    var _d = _a.value, value = _d === void 0 ? 0 : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.subLabel, subLabel = _g === void 0 ? '' : _g, _h = _a.complement, complement = _h === void 0 ? '' : _h, _j = _a.moreInfoLabel, moreInfoLabel = _j === void 0 ? '' : _j, _k = _a.moreInfoDetails, moreInfoDetails = _k === void 0 ? '' : _k, _l = _a.showHelpButton, showHelpButton = _l === void 0 ? false : _l, _m = _a.type, type = _m === void 0 ? 'primary' : _m, _o = _a.color, color = _o === void 0 ? 'default' : _o, _p = _a.minValue, minValue = _p === void 0 ? Number.MIN_SAFE_INTEGER : _p, _q = _a.maxValue, maxValue = _q === void 0 ? Number.MAX_SAFE_INTEGER : _q, _r = _a.stepValue, stepValue = _r === void 0 ? 1 : _r, _s = _a.isDisabled, isDisabled = _s === void 0 ? false : _s, _t = _a.width, width = _t === void 0 ? 0 : _t, _u = _a.helpButtonProps, helpButtonProps = _u === void 0 ? {} : _u, _v = _a.onChange, onChange = _v === void 0 ? function () { } : _v;
    var id = useNextHashId(idSequence$7);
    var onChangeInput = function (newValue) {
        var cleanedValue = newValue.target.value;
        if (isNumeric(cleanedValue)) {
            var castedValue = Number(cleanedValue);
            onChange(castedValue <= maxValue
                ? castedValue >= minValue
                    ? castedValue
                    : minValue
                : maxValue);
        }
    };
    var increaseValue = function () { return onChange(Number(value) + stepValue); };
    var decreaseValue = function () { return onChange(Number(value) - stepValue); };
    var isLeftButtonDisabled = Number(value) <= Number(minValue) || isDisabled;
    var isRightButtonDisabled = Number(value) >= Number(maxValue) || isDisabled;
    var height = (_c = (_b = mapCounterSize[size]) === null || _b === void 0 ? void 0 : _b.padding) !== null && _c !== void 0 ? _c : mapCounterSize.medium.padding;
    var hasError = color === 'destructive';
    return (React.createElement(CounterContainer, null,
        React.createElement(WrapperCounterLabel, null,
            React.createElement(StyledLabel$1, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, label),
            React.createElement(StyledSubLabel$1, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, subLabel),
            showHelpButton && (React.createElement(ButtonInfoContainer$1, null,
                React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
        React.createElement(CounterInnerContainer, null,
            React.createElement(BaSeShapeButton, { shape: "square", nameIcon: "minus", sideButton: "left", isDisabled: !hasError && isLeftButtonDisabled, type: type, color: color, onClick: function () { return !isLeftButtonDisabled && decreaseValue(); }, size: size, buttonType: "button" }),
            React.createElement(StyledCounterInput, { id: id, value: value, disabled: isDisabled, hasError: hasError, width: width, height: height, onChange: onChangeInput }),
            React.createElement(BaSeShapeButton, { shape: "square", nameIcon: "plus", sideButton: "right", isDisabled: !hasError && isRightButtonDisabled, type: type, color: color, onClick: function () { return !isRightButtonDisabled && increaseValue(); }, size: size, buttonType: "button" })),
        React.createElement(StyledApoio, { hasError: hasError }, complement),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$2, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
};
BaSeCounter.displayName = 'BaSeCounter';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

var handleDateFalsy = function (date) { return !!date; };
var addLeftZero = function (num) {
    if (!num) {
        return '';
    }
    var stringNum = num + '';
    return (stringNum === null || stringNum === void 0 ? void 0 : stringNum.length) === 1 ? '0' + stringNum : stringNum;
};
var yearMode = function (year, isFullYear) {
    if (isFullYear === void 0) { isFullYear = true; }
    return !year
        ? ''
        : isFullYear
            ? year.getUTCFullYear()
            : year.getFullYear().toString().substring(2, 4);
};
var localDateFormate = {
    en: function (date, props) {
        var _a;
        return handleDateFalsy(date)
            ? "".concat(addLeftZero(((_a = date === null || date === void 0 ? void 0 : date.getUTCMonth()) !== null && _a !== void 0 ? _a : -1) + 1), "/").concat(addLeftZero(date === null || date === void 0 ? void 0 : date.getUTCDate()), "/").concat(yearMode(date, props === null || props === void 0 ? void 0 : props.fullYear))
            : '';
    },
    'pt-BR': function (date, props) {
        var _a;
        return handleDateFalsy(date)
            ? "".concat(addLeftZero(date === null || date === void 0 ? void 0 : date.getUTCDate()), "/").concat(addLeftZero(((_a = date === null || date === void 0 ? void 0 : date.getUTCMonth()) !== null && _a !== void 0 ? _a : -1) + 1), "/").concat(yearMode(date, props === null || props === void 0 ? void 0 : props.fullYear))
            : '';
    },
};
var localeMapFormat = {
    en: {
        days: 'MM/dd/yyyy',
        months: 'MM/yyyy',
        years: 'yyyy',
    },
    'pt-BR': {
        days: 'dd/MM/yyyy',
        months: 'MM/yyyy',
        years: 'yyyy',
    },
};

var DatePickerColorMapper = {
    titleProps: {
        color: ColorMapper.grayScale.hover.defaultDark,
    },
    headerProps: {
        color: BaSeTheme.colors.defaultColors.white, // Adaptar para themeMode dark
    },
    arrowProps: {
        color: ColorMapper.default.foreground,
        hoverColor: ColorMapper.default.hover.defaultDark,
    },
    containerCardProps: {
        color: BaSeTheme.colors.defaultColors.white,
        borderColor: ColorMapper.default.focus.defaultLight,
    },
    daysText: {
        color: ColorMapper.default.getColorByNumber(20),
        hoverColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.default.hover.defaultLight,
        focusColor: ColorMapper.default.foreground,
        shadowColor: ColorMapper.default.focus.defaultLight,
    },
};
var DatePickerColorManager = function (color, inputStatus) {
    var statusMapper = {
        normal: 'default',
        invalid: 'destructive',
        valid: 'confirmation',
    };
    var statusColor;
    if (inputStatus && inputStatus in statusMapper && inputStatus !== 'normal') {
        statusColor = statusMapper[inputStatus];
    }
    if (statusColor) {
        return __assign(__assign({}, DatePickerColorMapper), { arrowProps: __assign(__assign({}, DatePickerColorMapper === null || DatePickerColorMapper === void 0 ? void 0 : DatePickerColorMapper.arrowProps), { color: ColorMapper[statusColor].foreground, hoverColor: ColorMapper[statusColor].hover.defaultDark }), containerCardProps: __assign(__assign({}, DatePickerColorMapper.containerCardProps), { borderColor: ColorMapper[statusColor].focus.defaultLight }), daysText: __assign(__assign({}, DatePickerColorMapper.daysText), { color: ColorMapper[statusColor].getColorByNumber(20), hoverColor: ColorMapper[statusColor].hover.defaultLight, focusColor: ColorMapper[statusColor].foreground, shadowColor: ColorMapper[statusColor].focus.defaultLight }), statusColor: ColorMapper[statusColor].foreground });
    }
    if (!color) {
        return __assign({}, DatePickerColorMapper);
    }
    if (ColorMapper.isValidType(color)) {
        return __assign(__assign({}, DatePickerColorMapper), { arrowProps: __assign(__assign({}, DatePickerColorMapper === null || DatePickerColorMapper === void 0 ? void 0 : DatePickerColorMapper.arrowProps), { color: ColorMapper[color].foreground, hoverColor: ColorMapper[color].hover.defaultDark }), containerCardProps: __assign(__assign({}, DatePickerColorMapper.containerCardProps), { borderColor: ColorMapper[color].focus.defaultLight }), daysText: __assign(__assign({}, DatePickerColorMapper.daysText), { color: ColorMapper[color].getColorByNumber(20), hoverColor: ColorMapper[color].hover.defaultLight, focusColor: ColorMapper[color].foreground, shadowColor: ColorMapper[color].focus.defaultLight }) });
    }
    if (!Color.validateColor(color)) {
        return __assign({}, DatePickerColorMapper);
    }
    return __assign(__assign({}, DatePickerColorMapper), { arrowProps: __assign(__assign({}, DatePickerColorMapper === null || DatePickerColorMapper === void 0 ? void 0 : DatePickerColorMapper.arrowProps), { color: color, hoverColor: ColorMapper.dark.hover.create(color) }), containerCardProps: __assign(__assign({}, DatePickerColorMapper.containerCardProps), { borderColor: ColorMapper.light.focus.create(color) }), daysText: __assign(__assign({}, DatePickerColorMapper.daysText), { color: ColorMapper.create(color, 0.2), hoverColor: ColorMapper.light.hover.create(color), focusColor: color, shadowColor: ColorMapper.light.focus.create(color) }) });
};
var maskSizeMap = {
    small: 32,
    medium: 40,
    big: 48,
};
var MaskDatePickerSize = function (optionalSize) {
    return maskSizeMap[!optionalSize || !(optionalSize in maskSizeMap) ? 'medium' : optionalSize];
};

var DatePickerOriginal = styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  .react-datepicker__navigation-icon::before,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    border-color: #ccc;\n    border-style: solid;\n    border-width: 3px 3px 0 0;\n    content: '';\n    display: block;\n    height: 9px;\n    position: absolute;\n    top: 6px;\n    width: 9px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    margin-left: -4px;\n    position: absolute;\n    width: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n    content: '';\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    border-top: none;\n    border-bottom-color: #f0f0f0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    top: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    bottom: 0;\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    border-bottom: none;\n    border-top-color: #fff;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    bottom: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    bottom: -1px;\n    border-top-color: #aeaeae;\n  }\n\n  .react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n  }\n\n  .react-datepicker {\n    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;\n    font-size: 0.8rem;\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n  }\n\n  .react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time,\n  .react-datepicker--time-only .react-datepicker__time-box {\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n  }\n\n  .react-datepicker-popper {\n    z-index: 1;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] {\n    padding-top: 10px;\n  }\n\n  .react-datepicker-popper[data-placement='bottom-end']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement='top-end']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] {\n    padding-bottom: 10px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] {\n    padding-left: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='right']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] {\n    padding-right: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    background-color: #f0f0f0;\n    border-bottom: 1px solid #aeaeae;\n    border-top-left-radius: 0.3rem;\n    padding: 8px 0;\n    position: relative;\n  }\n\n  .react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n    border-top-left-radius: 0;\n  }\n\n  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-dropdown-container--select,\n  .react-datepicker__month-dropdown-container--select,\n  .react-datepicker__month-year-dropdown-container--select,\n  .react-datepicker__year-dropdown-container--scroll,\n  .react-datepicker__month-dropdown-container--scroll,\n  .react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    margin-top: 0;\n    color: #000;\n    font-weight: bold;\n    font-size: 0.944rem;\n  }\n\n  .react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation {\n    align-items: center;\n    background: none;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 2px;\n    padding: 0;\n    border: none;\n    z-index: 1;\n    height: 32px;\n    width: 32px;\n    text-indent: -999em;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 2px;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 2px;\n  }\n\n  .react-datepicker__navigation--next--with-time:not(\n      .react-datepicker__navigation--next--with-today-button\n    ) {\n    right: 85px;\n  }\n\n  .react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    top: 4px;\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    top: -4px;\n  }\n\n  .react-datepicker__navigation:hover *::before {\n    border-color: #a6a6a6;\n  }\n\n  .react-datepicker__navigation-icon {\n    position: relative;\n    top: -1px;\n    font-size: 20px;\n  }\n\n  .react-datepicker__navigation-icon--next {\n    left: -2px;\n  }\n\n  .react-datepicker__navigation-icon--next::before {\n    transform: rotate(45deg);\n    left: -7px;\n  }\n\n  .react-datepicker__navigation-icon--previous {\n    right: -2px;\n  }\n\n  .react-datepicker__navigation-icon--previous::before {\n    transform: rotate(225deg);\n    right: -7px;\n  }\n\n  .react-datepicker__month-container {\n    float: left;\n  }\n\n  .react-datepicker__year {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__year-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 180px;\n  }\n\n  .react-datepicker__year .react-datepicker__year-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__month .react-datepicker__month-text,\n  .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input {\n    width: auto;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-inner-spin-button,\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time'] {\n    -moz-appearance: textfield;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n  }\n\n  .react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid #aeaeae;\n    width: 85px;\n  }\n\n  .react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0;\n    padding-left: 0;\n    width: 100%;\n    box-sizing: content-box;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__week-number {\n    color: #ccc;\n\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__week {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 2px;\n    width: 100%;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day-names,\n  .react-datepicker__week {\n  }\n\n  .react-datepicker__day-names {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 2px;\n  }\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    color: #000;\n\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__month--disabled,\n  .react-datepicker__quarter--disabled {\n    color: #ccc;\n    pointer-events: none;\n  }\n\n  .react-datepicker__month--disabled:hover,\n  .react-datepicker__quarter--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text,\n  .react-datepicker__year-text {\n    cursor: pointer;\n  }\n\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover,\n  .react-datepicker__year-text:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today,\n  .react-datepicker__year-text--today {\n    font-weight: bold;\n  }\n\n  .react-datepicker__day--highlighted,\n  .react-datepicker__month-text--highlighted,\n  .react-datepicker__quarter-text--highlighted,\n  .react-datepicker__year-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: #3dcc4a;\n    color: #fff;\n  }\n\n  .react-datepicker__day--highlighted:hover,\n  .react-datepicker__month-text--highlighted:hover,\n  .react-datepicker__quarter-text--highlighted:hover,\n  .react-datepicker__year-text--highlighted:hover {\n    background-color: #32be3f;\n  }\n\n  .react-datepicker__day--highlighted-custom-1,\n  .react-datepicker__month-text--highlighted-custom-1,\n  .react-datepicker__quarter-text--highlighted-custom-1,\n  .react-datepicker__year-text--highlighted-custom-1 {\n    color: magenta;\n  }\n\n  .react-datepicker__day--highlighted-custom-2,\n  .react-datepicker__month-text--highlighted-custom-2,\n  .react-datepicker__quarter-text--highlighted-custom-2,\n  .react-datepicker__year-text--highlighted-custom-2 {\n    color: green;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    border-radius: 50%;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover,\n  .react-datepicker__year-text--selected:hover,\n  .react-datepicker__year-text--in-selecting-range:hover,\n  .react-datepicker__year-text--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected,\n  .react-datepicker__year-text--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: #2a87d0;\n    color: #fff;\n  }\n\n  .react-datepicker__day--keyboard-selected:hover,\n  .react-datepicker__month-text--keyboard-selected:hover,\n  .react-datepicker__quarter-text--keyboard-selected:hover,\n  .react-datepicker__year-text--keyboard-selected:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range {\n    background-color: rgba(33, 107, 165, 0.5);\n  }\n\n  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__month-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__quarter-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__year-text--in-range {\n    background-color: #f0f0f0;\n    color: #000;\n  }\n\n  .react-datepicker__day--disabled,\n  .react-datepicker__month-text--disabled,\n  .react-datepicker__quarter-text--disabled,\n  .react-datepicker__year-text--disabled {\n    cursor: default;\n    color: #ccc;\n  }\n\n  .react-datepicker__day--disabled:hover,\n  .react-datepicker__month-text--disabled:hover,\n  .react-datepicker__quarter-text--disabled:hover,\n  .react-datepicker__year-text--disabled:hover {\n    background-color: transparent;\n  }\n\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .react-datepicker__year-read-view,\n  .react-datepicker__month-read-view,\n  .react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n    position: relative;\n  }\n\n  .react-datepicker__year-read-view:hover,\n  .react-datepicker__month-read-view:hover,\n  .react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    transform: rotate(135deg);\n    right: -16px;\n    top: 0;\n  }\n\n  .react-datepicker__year-dropdown,\n  .react-datepicker__month-dropdown,\n  .react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid #aeaeae;\n  }\n\n  .react-datepicker__year-dropdown:hover,\n  .react-datepicker__month-dropdown:hover,\n  .react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-dropdown--scrollable,\n  .react-datepicker__month-dropdown--scrollable,\n  .react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n\n  .react-datepicker__year-option,\n  .react-datepicker__month-option,\n  .react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__year-option:first-of-type,\n  .react-datepicker__month-option:first-of-type,\n  .react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:last-of-type,\n  .react-datepicker__month-option:last-of-type,\n  .react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:hover,\n  .react-datepicker__month-option:hover,\n  .react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-previous {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option--selected,\n  .react-datepicker__month-option--selected,\n  .react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n  }\n\n  .react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0 6px 0 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: #216ba5;\n    color: #fff;\n    border-radius: 50%;\n    height: 16px;\n    width: 16px;\n    padding: 2px;\n    font-size: 12px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__today-button {\n    background: #f0f0f0;\n    border-top: 1px solid #aeaeae;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n  }\n\n  .react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n  }\n\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__portal .react-datepicker__current-month,\n  .react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n  }\n"], ["\n  .react-datepicker__navigation-icon::before,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    border-color: #ccc;\n    border-style: solid;\n    border-width: 3px 3px 0 0;\n    content: '';\n    display: block;\n    height: 9px;\n    position: absolute;\n    top: 6px;\n    width: 9px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    margin-left: -4px;\n    position: absolute;\n    width: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n    content: '';\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    border-top: none;\n    border-bottom-color: #f0f0f0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    top: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    bottom: 0;\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    border-bottom: none;\n    border-top-color: #fff;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    bottom: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    bottom: -1px;\n    border-top-color: #aeaeae;\n  }\n\n  .react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n  }\n\n  .react-datepicker {\n    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;\n    font-size: 0.8rem;\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n  }\n\n  .react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time,\n  .react-datepicker--time-only .react-datepicker__time-box {\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n  }\n\n  .react-datepicker-popper {\n    z-index: 1;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] {\n    padding-top: 10px;\n  }\n\n  .react-datepicker-popper[data-placement='bottom-end']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement='top-end']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] {\n    padding-bottom: 10px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] {\n    padding-left: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='right']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] {\n    padding-right: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    background-color: #f0f0f0;\n    border-bottom: 1px solid #aeaeae;\n    border-top-left-radius: 0.3rem;\n    padding: 8px 0;\n    position: relative;\n  }\n\n  .react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n    border-top-left-radius: 0;\n  }\n\n  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-dropdown-container--select,\n  .react-datepicker__month-dropdown-container--select,\n  .react-datepicker__month-year-dropdown-container--select,\n  .react-datepicker__year-dropdown-container--scroll,\n  .react-datepicker__month-dropdown-container--scroll,\n  .react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    margin-top: 0;\n    color: #000;\n    font-weight: bold;\n    font-size: 0.944rem;\n  }\n\n  .react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation {\n    align-items: center;\n    background: none;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 2px;\n    padding: 0;\n    border: none;\n    z-index: 1;\n    height: 32px;\n    width: 32px;\n    text-indent: -999em;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 2px;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 2px;\n  }\n\n  .react-datepicker__navigation--next--with-time:not(\n      .react-datepicker__navigation--next--with-today-button\n    ) {\n    right: 85px;\n  }\n\n  .react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    top: 4px;\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    top: -4px;\n  }\n\n  .react-datepicker__navigation:hover *::before {\n    border-color: #a6a6a6;\n  }\n\n  .react-datepicker__navigation-icon {\n    position: relative;\n    top: -1px;\n    font-size: 20px;\n  }\n\n  .react-datepicker__navigation-icon--next {\n    left: -2px;\n  }\n\n  .react-datepicker__navigation-icon--next::before {\n    transform: rotate(45deg);\n    left: -7px;\n  }\n\n  .react-datepicker__navigation-icon--previous {\n    right: -2px;\n  }\n\n  .react-datepicker__navigation-icon--previous::before {\n    transform: rotate(225deg);\n    right: -7px;\n  }\n\n  .react-datepicker__month-container {\n    float: left;\n  }\n\n  .react-datepicker__year {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__year-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 180px;\n  }\n\n  .react-datepicker__year .react-datepicker__year-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__month .react-datepicker__month-text,\n  .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input {\n    width: auto;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-inner-spin-button,\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time'] {\n    -moz-appearance: textfield;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n  }\n\n  .react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid #aeaeae;\n    width: 85px;\n  }\n\n  .react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0;\n    padding-left: 0;\n    width: 100%;\n    box-sizing: content-box;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__week-number {\n    color: #ccc;\n\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__week {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 2px;\n    width: 100%;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day-names,\n  .react-datepicker__week {\n  }\n\n  .react-datepicker__day-names {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 2px;\n  }\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    color: #000;\n\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__month--disabled,\n  .react-datepicker__quarter--disabled {\n    color: #ccc;\n    pointer-events: none;\n  }\n\n  .react-datepicker__month--disabled:hover,\n  .react-datepicker__quarter--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text,\n  .react-datepicker__year-text {\n    cursor: pointer;\n  }\n\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover,\n  .react-datepicker__year-text:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today,\n  .react-datepicker__year-text--today {\n    font-weight: bold;\n  }\n\n  .react-datepicker__day--highlighted,\n  .react-datepicker__month-text--highlighted,\n  .react-datepicker__quarter-text--highlighted,\n  .react-datepicker__year-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: #3dcc4a;\n    color: #fff;\n  }\n\n  .react-datepicker__day--highlighted:hover,\n  .react-datepicker__month-text--highlighted:hover,\n  .react-datepicker__quarter-text--highlighted:hover,\n  .react-datepicker__year-text--highlighted:hover {\n    background-color: #32be3f;\n  }\n\n  .react-datepicker__day--highlighted-custom-1,\n  .react-datepicker__month-text--highlighted-custom-1,\n  .react-datepicker__quarter-text--highlighted-custom-1,\n  .react-datepicker__year-text--highlighted-custom-1 {\n    color: magenta;\n  }\n\n  .react-datepicker__day--highlighted-custom-2,\n  .react-datepicker__month-text--highlighted-custom-2,\n  .react-datepicker__quarter-text--highlighted-custom-2,\n  .react-datepicker__year-text--highlighted-custom-2 {\n    color: green;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    border-radius: 50%;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover,\n  .react-datepicker__year-text--selected:hover,\n  .react-datepicker__year-text--in-selecting-range:hover,\n  .react-datepicker__year-text--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected,\n  .react-datepicker__year-text--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: #2a87d0;\n    color: #fff;\n  }\n\n  .react-datepicker__day--keyboard-selected:hover,\n  .react-datepicker__month-text--keyboard-selected:hover,\n  .react-datepicker__quarter-text--keyboard-selected:hover,\n  .react-datepicker__year-text--keyboard-selected:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range {\n    background-color: rgba(33, 107, 165, 0.5);\n  }\n\n  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__month-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__quarter-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__year-text--in-range {\n    background-color: #f0f0f0;\n    color: #000;\n  }\n\n  .react-datepicker__day--disabled,\n  .react-datepicker__month-text--disabled,\n  .react-datepicker__quarter-text--disabled,\n  .react-datepicker__year-text--disabled {\n    cursor: default;\n    color: #ccc;\n  }\n\n  .react-datepicker__day--disabled:hover,\n  .react-datepicker__month-text--disabled:hover,\n  .react-datepicker__quarter-text--disabled:hover,\n  .react-datepicker__year-text--disabled:hover {\n    background-color: transparent;\n  }\n\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .react-datepicker__year-read-view,\n  .react-datepicker__month-read-view,\n  .react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n    position: relative;\n  }\n\n  .react-datepicker__year-read-view:hover,\n  .react-datepicker__month-read-view:hover,\n  .react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    transform: rotate(135deg);\n    right: -16px;\n    top: 0;\n  }\n\n  .react-datepicker__year-dropdown,\n  .react-datepicker__month-dropdown,\n  .react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid #aeaeae;\n  }\n\n  .react-datepicker__year-dropdown:hover,\n  .react-datepicker__month-dropdown:hover,\n  .react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-dropdown--scrollable,\n  .react-datepicker__month-dropdown--scrollable,\n  .react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n\n  .react-datepicker__year-option,\n  .react-datepicker__month-option,\n  .react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__year-option:first-of-type,\n  .react-datepicker__month-option:first-of-type,\n  .react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:last-of-type,\n  .react-datepicker__month-option:last-of-type,\n  .react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:hover,\n  .react-datepicker__month-option:hover,\n  .react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-previous {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option--selected,\n  .react-datepicker__month-option--selected,\n  .react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n  }\n\n  .react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0 6px 0 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: #216ba5;\n    color: #fff;\n    border-radius: 50%;\n    height: 16px;\n    width: 16px;\n    padding: 2px;\n    font-size: 12px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__today-button {\n    background: #f0f0f0;\n    border-top: 1px solid #aeaeae;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n  }\n\n  .react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n  }\n\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__portal .react-datepicker__current-month,\n  .react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n  }\n"])));
var templateObject_1$t;

var white = BaSeTheme.colors.defaultColors.white;
var DatePickerWrapper = styled(DatePickerOriginal)(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  &,\n  & * {\n    box-sizing: border-box;\n  }\n\n  ", "\n\n  /** Componente do base de wrapper */\n  display: flex;\n  flex-flow: column;\n  position: relative;\n  /** Componente do base de wrapper */\n"], ["\n  &,\n  & * {\n    box-sizing: border-box;\n  }\n\n  ", "\n\n  /** Componente do base de wrapper */\n  display: flex;\n  flex-flow: column;\n  position: relative;\n  /** Componente do base de wrapper */\n"])), function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29;
    var colorProps = _a.colorProps, isStartDaySameEndDay = _a.isStartDaySameEndDay, maskInputProp = _a.maskInputProp, monthPickNotRange = _a.monthPickNotRange, alwaysIsOpen = _a.alwaysIsOpen;
    return css(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n    .react-datepicker {\n      font-family: ", ";\n      border-radius: 4px;\n      border: 1px solid ", ";\n      box-shadow: 0px 0px 4px ", ";\n      background-color: ", ";\n    }\n\n    .react-datepicker-popper {\n      z-index: ", ";\n    }\n\n    /** Display do m\u00EAs atual */\n    .react-datepicker__current-month {\n      font-family: ", ";\n      font-weight: bold;\n      font-size: 19px;\n      line-height: 23px;\n      text-align: center;\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n      }\n    }\n    /** Display do m\u00EAs atual */\n\n    /**Cabe\u00E7alho */\n    .react-datepicker__header {\n      padding: 16px 12px 0 12px;\n      background-color: ", ";\n      border-bottom: none;\n    }\n    .react-datepicker__day-name {\n      margin-bottom: 0;\n    }\n    /**Cabe\u00E7alho */\n\n    /** Icones de navega\u00E7\u00E3o */\n\n    button.react-datepicker__navigation--previous,\n    button.react-datepicker__navigation--next {\n      top: 10px;\n      display: grid;\n      place-items: center;\n      border-radius: 32px;\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    button.react-datepicker__navigation--previous {\n      left: 20px;\n      span {\n        top: -4px;\n        left: -4px;\n      }\n    }\n    button.react-datepicker__navigation--next {\n      right: 20px;\n      span {\n        top: -4px;\n        left: 4px;\n      }\n    }\n\n    button.react-datepicker__navigation:focus-visible {\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    .react-datepicker__navigation-icon::before {\n      border-color: ", ";\n      border-style: solid;\n      border-width: 0;\n      content: '';\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n    }\n\n    .react-datepicker__navigation-icon--previous::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-right: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation-icon--next::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-left: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation:hover *::before {\n      border-color: ", ";\n    }\n\n    .react-datepicker__navigation:hover {\n      .react-datepicker__navigation-icon--next::before {\n        border-left-color: ", ";\n      }\n      .react-datepicker__navigation-icon--previous::before {\n        border-right-color: ", ";\n      }\n    }\n    /** Icones de navega\u00E7\u00E3o */\n\n    /* Dias do m\u00EAs e da semana*/\n\n    .react-datepicker__month {\n      margin: 0.4rem 0.75rem;\n    }\n\n    .react-datepicker__week {\n      grid-template-columns: repeat(7, 2rem);\n      grid-gap: 0px;\n    }\n\n    .react-datepicker__day-names {\n      padding-top: 16px;\n      padding-left: 3px;\n      margin-bottom: 0;\n      grid-template-columns: repeat(7, 2rem);\n      grid-gap: 0px;\n    }\n\n    .react-datepicker__day-name {\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: ", ";\n      line-height: 1.2em;\n\n      margin: 0px;\n\n      width: 32px;\n      /* height: 32px; */\n      padding: 8px 0;\n\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n        color: #333333; // TODO cor n\u00E3o mapeada no base\n      }\n    }\n\n    .react-datepicker__day-name--outside-month,\n    .react-datepicker__day,\n    .react-datepicker__day-name,\n    .react-datepicker__time-name,\n    .react-datepicker__month-text,\n    .react-datepicker__year-text {\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n\n      margin: 0;\n      padding: 0;\n\n      width: 32px;\n      /* height: 32px; */\n      padding: 8px 0;\n\n      color: ", ";\n      user-select: none;\n      text-align: center;\n    }\n\n    .react-datepicker__day-name--outside-month:hover,\n    .react-datepicker__day:hover,\n    .react-datepicker__time-name:hover,\n    .react-datepicker__month-text:hover {\n      border-radius: 0;\n      background-color: ", ";\n    }\n\n    .react-datepicker__day--keyboard-selected,\n    .react-datepicker__month-text--keyboard-selected,\n    .react-datepicker__quarter-text--keyboard-selected,\n    .react-datepicker__year-text--keyboard-selected,\n    .react-datepicker__month-text--keyboard-selected {\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day:focus-visible {\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    .react-datepicker__month-text--keyboard-selected {\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    .react-datepicker__month-text--keyboard-selected {\n      &:hover {\n        background-color: ", "!important;\n      }\n    }\n\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-selecting-range,\n    .react-datepicker__year-text--in-range,\n    .react-datepicker__month--in-range {\n      background-color: ", ";\n      border-radius: 0;\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__year-text--selected,\n    .react-datepicker__month--selected {\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n\n      margin: 0;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 0;\n        background-color: ", ";\n      }\n\n      ", "\n    }\n    .unique-date {\n      color: ", ";\n      background-color: ", ";\n      border-radius: 100%;\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day--highlighted,\n    .react-datepicker__month-text--highlighted,\n    .react-datepicker__quarter-text--highlighted,\n    .react-datepicker__year-text--highlighted {\n      position: relative;\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .startDate,\n    .react-datepicker__month--range-start {\n      position: relative;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px;\n        border-top-right-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n        background-color: ", "!important;\n      }\n      ", "\n    }\n\n    .endDate,\n    .react-datepicker__month--range-end {\n      position: relative;\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: ", "px;\n        border-bottom-left-radius: ", "px;\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n        background-color: ", "!important;\n      }\n      ", "\n    }\n\n    .react-datepicker__month-in-range,\n    .react-datepicker__month-text {\n      &:hover {\n        background-color: ", "!important;\n      }\n    }\n\n    .react-datepicker__month--range-end,\n    .react-datepicker__month--range-start {\n      &:hover {\n        background-color: ", "!important;\n      }\n    }\n\n    .react-datepicker__day--outside-month {\n      color: ", ";\n      &.endDate,\n      &.startDate {\n        color: ", ";\n      }\n      &:empty {\n        height: 0;\n        overflow: hidden;\n        opacity: 0;\n        cursor: auto;\n        padding: 0 8px;\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n\n    .react-datepicker__day--disabled,\n    .react-datepicker__month-text--disabled,\n    .react-datepicker__quarter-text--disabled,\n    .react-datepicker__year-text--disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      color: ", ";\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n      }\n    }\n\n    /* Dias do m\u00EAs e da semana*/\n\n    /* M\u00EAses do ano*/\n\n    .react-datepicker__month-text {\n      margin: 0 !important;\n    }\n\n    /* M\u00EAses do ano*/\n\n    /* Anos */\n    /* Anos */\n\n    /*Cores do arrow */\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::before {\n      border-bottom-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::after {\n      border-bottom-color: ", ";\n    }\n\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::before {\n      border-top-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::after {\n      border-top-color: ", ";\n    }\n\n    .react-datepicker__navigation--previous,\n    .react-datepicker__navigation--next {\n      top: 0.625em;\n    }\n\n    /*Cores do arrow */\n\n    /** Wrapper do date picker */\n    .react-datepicker-wrapper {\n      display: flex;\n    }\n    /** Wrapper do date picker */\n\n    /**Deixar com width com 100% de espa\u00E7o */\n    .BaSe--date-picker {\n      width: 100%;\n    }\n\n    .react-datepicker__input-container {\n      input {\n        width: 100%;\n      }\n\n      > input {\n        font-family: ", ";\n        font-size: ", ";\n        line-height: ", ";\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        padding-left: 12px;\n        padding-right: 12px;\n        width: calc(100%);\n        color: ", ";\n        background: ", ";\n        border: 1px solid ", ";\n        border-radius: 4px;\n        height: ", ";\n        &:focus {\n          outline: none !important;\n          box-shadow: 0 0 4px ", ";\n          border: 1px solid ", ";\n          color: ", ";\n        }\n      }\n    }\n\n    .react-datepicker__year-wrapper {\n      max-width: 204px;\n    }\n\n    .react-datepicker__aria-live {\n      position: absolute;\n      clip-path: circle(0);\n      border: 0;\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      width: 1px;\n      white-space: nowrap;\n      display: none;\n    }\n\n    ", "\n  "], ["\n    .react-datepicker {\n      font-family: ", ";\n      border-radius: 4px;\n      border: 1px solid ", ";\n      box-shadow: 0px 0px 4px ", ";\n      background-color: ", ";\n    }\n\n    .react-datepicker-popper {\n      z-index: ", ";\n    }\n\n    /** Display do m\u00EAs atual */\n    .react-datepicker__current-month {\n      font-family: ", ";\n      font-weight: bold;\n      font-size: 19px;\n      line-height: 23px;\n      text-align: center;\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n      }\n    }\n    /** Display do m\u00EAs atual */\n\n    /**Cabe\u00E7alho */\n    .react-datepicker__header {\n      padding: 16px 12px 0 12px;\n      background-color: ", ";\n      border-bottom: none;\n    }\n    .react-datepicker__day-name {\n      margin-bottom: 0;\n    }\n    /**Cabe\u00E7alho */\n\n    /** Icones de navega\u00E7\u00E3o */\n\n    button.react-datepicker__navigation--previous,\n    button.react-datepicker__navigation--next {\n      top: 10px;\n      display: grid;\n      place-items: center;\n      border-radius: 32px;\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    button.react-datepicker__navigation--previous {\n      left: 20px;\n      span {\n        top: -4px;\n        left: -4px;\n      }\n    }\n    button.react-datepicker__navigation--next {\n      right: 20px;\n      span {\n        top: -4px;\n        left: 4px;\n      }\n    }\n\n    button.react-datepicker__navigation:focus-visible {\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    .react-datepicker__navigation-icon::before {\n      border-color: ", ";\n      border-style: solid;\n      border-width: 0;\n      content: '';\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n    }\n\n    .react-datepicker__navigation-icon--previous::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-right: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation-icon--next::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-left: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation:hover *::before {\n      border-color: ", ";\n    }\n\n    .react-datepicker__navigation:hover {\n      .react-datepicker__navigation-icon--next::before {\n        border-left-color: ", ";\n      }\n      .react-datepicker__navigation-icon--previous::before {\n        border-right-color: ", ";\n      }\n    }\n    /** Icones de navega\u00E7\u00E3o */\n\n    /* Dias do m\u00EAs e da semana*/\n\n    .react-datepicker__month {\n      margin: 0.4rem 0.75rem;\n    }\n\n    .react-datepicker__week {\n      grid-template-columns: repeat(7, 2rem);\n      grid-gap: 0px;\n    }\n\n    .react-datepicker__day-names {\n      padding-top: 16px;\n      padding-left: 3px;\n      margin-bottom: 0;\n      grid-template-columns: repeat(7, 2rem);\n      grid-gap: 0px;\n    }\n\n    .react-datepicker__day-name {\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: ", ";\n      line-height: 1.2em;\n\n      margin: 0px;\n\n      width: 32px;\n      /* height: 32px; */\n      padding: 8px 0;\n\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n        color: #333333; // TODO cor n\u00E3o mapeada no base\n      }\n    }\n\n    .react-datepicker__day-name--outside-month,\n    .react-datepicker__day,\n    .react-datepicker__day-name,\n    .react-datepicker__time-name,\n    .react-datepicker__month-text,\n    .react-datepicker__year-text {\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n\n      margin: 0;\n      padding: 0;\n\n      width: 32px;\n      /* height: 32px; */\n      padding: 8px 0;\n\n      color: ", ";\n      user-select: none;\n      text-align: center;\n    }\n\n    .react-datepicker__day-name--outside-month:hover,\n    .react-datepicker__day:hover,\n    .react-datepicker__time-name:hover,\n    .react-datepicker__month-text:hover {\n      border-radius: 0;\n      background-color: ", ";\n    }\n\n    .react-datepicker__day--keyboard-selected,\n    .react-datepicker__month-text--keyboard-selected,\n    .react-datepicker__quarter-text--keyboard-selected,\n    .react-datepicker__year-text--keyboard-selected,\n    .react-datepicker__month-text--keyboard-selected {\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day:focus-visible {\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    .react-datepicker__month-text--keyboard-selected {\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    }\n\n    .react-datepicker__month-text--keyboard-selected {\n      &:hover {\n        background-color: ", "!important;\n      }\n    }\n\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-selecting-range,\n    .react-datepicker__year-text--in-range,\n    .react-datepicker__month--in-range {\n      background-color: ", ";\n      border-radius: 0;\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__year-text--selected,\n    .react-datepicker__month--selected {\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n\n      margin: 0;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 0;\n        background-color: ", ";\n      }\n\n      ", "\n    }\n    .unique-date {\n      color: ", ";\n      background-color: ", ";\n      border-radius: 100%;\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day--highlighted,\n    .react-datepicker__month-text--highlighted,\n    .react-datepicker__quarter-text--highlighted,\n    .react-datepicker__year-text--highlighted {\n      position: relative;\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .startDate,\n    .react-datepicker__month--range-start {\n      position: relative;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px;\n        border-top-right-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n        background-color: ", "!important;\n      }\n      ", "\n    }\n\n    .endDate,\n    .react-datepicker__month--range-end {\n      position: relative;\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: ", "px;\n        border-bottom-left-radius: ", "px;\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n        background-color: ", "!important;\n      }\n      ", "\n    }\n\n    .react-datepicker__month-in-range,\n    .react-datepicker__month-text {\n      &:hover {\n        background-color: ", "!important;\n      }\n    }\n\n    .react-datepicker__month--range-end,\n    .react-datepicker__month--range-start {\n      &:hover {\n        background-color: ", "!important;\n      }\n    }\n\n    .react-datepicker__day--outside-month {\n      color: ", ";\n      &.endDate,\n      &.startDate {\n        color: ", ";\n      }\n      &:empty {\n        height: 0;\n        overflow: hidden;\n        opacity: 0;\n        cursor: auto;\n        padding: 0 8px;\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n\n    .react-datepicker__day--disabled,\n    .react-datepicker__month-text--disabled,\n    .react-datepicker__quarter-text--disabled,\n    .react-datepicker__year-text--disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      color: ", ";\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n      }\n    }\n\n    /* Dias do m\u00EAs e da semana*/\n\n    /* M\u00EAses do ano*/\n\n    .react-datepicker__month-text {\n      margin: 0 !important;\n    }\n\n    /* M\u00EAses do ano*/\n\n    /* Anos */\n    /* Anos */\n\n    /*Cores do arrow */\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::before {\n      border-bottom-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::after {\n      border-bottom-color: ", ";\n    }\n\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::before {\n      border-top-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::after {\n      border-top-color: ", ";\n    }\n\n    .react-datepicker__navigation--previous,\n    .react-datepicker__navigation--next {\n      top: 0.625em;\n    }\n\n    /*Cores do arrow */\n\n    /** Wrapper do date picker */\n    .react-datepicker-wrapper {\n      display: flex;\n    }\n    /** Wrapper do date picker */\n\n    /**Deixar com width com 100% de espa\u00E7o */\n    .BaSe--date-picker {\n      width: 100%;\n    }\n\n    .react-datepicker__input-container {\n      input {\n        width: 100%;\n      }\n\n      > input {\n        font-family: ", ";\n        font-size: ", ";\n        line-height: ", ";\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        padding-left: 12px;\n        padding-right: 12px;\n        width: calc(100%);\n        color: ", ";\n        background: ", ";\n        border: 1px solid ", ";\n        border-radius: 4px;\n        height: ", ";\n        &:focus {\n          outline: none !important;\n          box-shadow: 0 0 4px ", ";\n          border: 1px solid ", ";\n          color: ", ";\n        }\n      }\n    }\n\n    .react-datepicker__year-wrapper {\n      max-width: 204px;\n    }\n\n    .react-datepicker__aria-live {\n      position: absolute;\n      clip-path: circle(0);\n      border: 0;\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      width: 1px;\n      white-space: nowrap;\n      display: none;\n    }\n\n    ", "\n  "])), BaSeTheme.typography.fontFamily, (_b = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _b === void 0 ? void 0 : _b.borderColor, (_c = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _c === void 0 ? void 0 : _c.borderColor, (_d = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _d === void 0 ? void 0 : _d.color, BaSeTheme.stackOrder.overlay, BaSeTheme.typography.fontFamily, (_e = colorProps === null || colorProps === void 0 ? void 0 : colorProps.titleProps) === null || _e === void 0 ? void 0 : _e.color, (_f = colorProps === null || colorProps === void 0 ? void 0 : colorProps.headerProps) === null || _f === void 0 ? void 0 : _f.color, (_g = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _g === void 0 ? void 0 : _g.hoverColor, (_h = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _h === void 0 ? void 0 : _h.shadowColor, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, (_j = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _j === void 0 ? void 0 : _j.color, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, (_k = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _k === void 0 ? void 0 : _k.color, BaSeTheme.colors.defaultColors.transparent, (_l = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _l === void 0 ? void 0 : _l.hoverColor, (_m = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _m === void 0 ? void 0 : _m.hoverColor, BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, (_o = colorProps === null || colorProps === void 0 ? void 0 : colorProps.headerProps) === null || _o === void 0 ? void 0 : _o.color, BaSeTheme.typography.fontFamily, (_p = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _p === void 0 ? void 0 : _p.color, (_q = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _q === void 0 ? void 0 : _q.hoverColor, (_r = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _r === void 0 ? void 0 : _r.color, (_s = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _s === void 0 ? void 0 : _s.color, (_t = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _t === void 0 ? void 0 : _t.hoverColor, (_u = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _u === void 0 ? void 0 : _u.shadowColor, (_v = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _v === void 0 ? void 0 : _v.shadowColor, (_w = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _w === void 0 ? void 0 : _w.hoverColor, (_x = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _x === void 0 ? void 0 : _x.hoverColor, BaSeTheme.typography.fontFamily, (_y = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _y === void 0 ? void 0 : _y.color, (_z = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _z === void 0 ? void 0 : _z.color, (_0 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _0 === void 0 ? void 0 : _0.hoverColor, monthPickNotRange && css(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n        position: relative;\n        border-radius: 5px;\n        color: ", ";\n        background-color: ", ";\n        &:hover {\n          border-radius: 5px;\n          background-color: ", "!important;\n        }\n      "], ["\n        position: relative;\n        border-radius: 5px;\n        color: ", ";\n        background-color: ", ";\n        &:hover {\n          border-radius: 5px;\n          background-color: ", "!important;\n        }\n      "])), (_1 = BaSeTheme.colors.defaultColors) === null || _1 === void 0 ? void 0 : _1.white, (_2 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _2 === void 0 ? void 0 : _2.focusColor, (_3 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _3 === void 0 ? void 0 : _3.focusColor), (_4 = BaSeTheme.colors.defaultColors) === null || _4 === void 0 ? void 0 : _4.white, (_5 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _5 === void 0 ? void 0 : _5.focusColor, (_6 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _6 === void 0 ? void 0 : _6.focusColor, (_7 = BaSeTheme.colors.defaultColors) === null || _7 === void 0 ? void 0 : _7.white, (_8 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _8 === void 0 ? void 0 : _8.focusColor, (_9 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _9 === void 0 ? void 0 : _9.focusColor, isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_10 = BaSeTheme.colors.defaultColors) === null || _10 === void 0 ? void 0 : _10.white, (_11 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _11 === void 0 ? void 0 : _11.focusColor, isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_12 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _12 === void 0 ? void 0 : _12.focusColor, !isStartDaySameEndDay && css(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n        &::after {\n          content: '';\n          position: absolute;\n          border-left: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          left: 100%;\n          top: 0;\n          border-radius: 6px;\n        }\n      "], ["\n        &::after {\n          content: '';\n          position: absolute;\n          border-left: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          left: 100%;\n          top: 0;\n          border-radius: 6px;\n        }\n      "])), (_13 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _13 === void 0 ? void 0 : _13.focusColor, (_14 = BaSeTheme.colors.defaultColors) === null || _14 === void 0 ? void 0 : _14.transparent, (_15 = BaSeTheme.colors.defaultColors) === null || _15 === void 0 ? void 0 : _15.transparent), isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_16 = BaSeTheme.colors.defaultColors) === null || _16 === void 0 ? void 0 : _16.white, (_17 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _17 === void 0 ? void 0 : _17.focusColor, isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_18 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _18 === void 0 ? void 0 : _18.focusColor, !isStartDaySameEndDay && css(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n        &::before {\n          content: '';\n          position: absolute;\n          border-right: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          top: 0;\n          right: 100%;\n          border-radius: 6px;\n        }\n      "], ["\n        &::before {\n          content: '';\n          position: absolute;\n          border-right: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          top: 0;\n          right: 100%;\n          border-radius: 6px;\n        }\n      "])), (_19 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _19 === void 0 ? void 0 : _19.focusColor, (_20 = BaSeTheme.colors.defaultColors) === null || _20 === void 0 ? void 0 : _20.transparent, (_21 = BaSeTheme.colors.defaultColors) === null || _21 === void 0 ? void 0 : _21.transparent), (_22 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _22 === void 0 ? void 0 : _22.hoverColor, (_23 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _23 === void 0 ? void 0 : _23.focusColor, (_24 = ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.grayScale) === null || _24 === void 0 ? void 0 : _24.focus.defaultLight, BaSeTheme.colors.defaultColors.white, (_25 = BaSeTheme.colors.defaultColors) === null || _25 === void 0 ? void 0 : _25.transparent, ColorMapper.grayScale.hover.defaultLight, ColorMapper.grayScale.foreground, ColorMapper.grayScale.hover.defaultLight, ColorMapper.grayScale.foreground, (_26 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _26 === void 0 ? void 0 : _26.borderColor, (_27 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _27 === void 0 ? void 0 : _27.color, (_28 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _28 === void 0 ? void 0 : _28.borderColor, (_29 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _29 === void 0 ? void 0 : _29.color, BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.color, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.backgroundColor, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.borderColor, numberWithUnit(maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.size), maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.boxShadowFocus, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.focusBorderColor, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.focusTextColor, alwaysIsOpen && css(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n      .react-datepicker {\n        border: 1px solid ", ";\n        box-shadow: unset;\n        border-radius: 0.5em;\n        width: auto;\n\n        .react-datepicker__month-container {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          width: inherit;\n        }\n\n        .react-datepicker__week,\n        .react-datepicker__day-names {\n          grid-template-columns: repeat(7, 2.7em);\n        }\n      }\n    "], ["\n      .react-datepicker {\n        border: 1px solid ", ";\n        box-shadow: unset;\n        border-radius: 0.5em;\n        width: auto;\n\n        .react-datepicker__month-container {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          width: inherit;\n        }\n\n        .react-datepicker__week,\n        .react-datepicker__day-names {\n          grid-template-columns: repeat(7, 2.7em);\n        }\n      }\n    "])), BaSeTheme.colors.institucionais.azulSebrae97));
});
var DatePickerCalendarContainer = styled.div(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  cursor: pointer;\n  background-color: ", ";\n  ", "\n"], ["\n  cursor: pointer;\n  background-color: ", ";\n  ", "\n"])), white, function (_a) {
    var width = _a.width, top = _a.top;
    return css(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n    position: absolute;\n    right: 1em;\n    top: ", ";\n    bottom: 0;\n    width: ", ";\n    z-index: ", ";\n    display: flex;\n    align-items: center;\n    height: 1em;\n  "], ["\n    position: absolute;\n    right: 1em;\n    top: ", ";\n    bottom: 0;\n    width: ", ";\n    z-index: ", ";\n    display: flex;\n    align-items: center;\n    height: 1em;\n  "])), numberWithUnit(top), numberWithUnit(width), BaSeTheme.stackOrder.aboveNormal);
});
var templateObject_1$s, templateObject_2$p, templateObject_3$k, templateObject_4$g, templateObject_5$c, templateObject_6$b, templateObject_7$8, templateObject_8$8;

/** Checks if value is string */
function isString(str) {
  return typeof str === 'string' || str instanceof String;
}

/** Checks if value is object */
function isObject(obj) {
  var _obj$constructor;
  return typeof obj === 'object' && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === 'Object';
}
function pick(obj, keys) {
  if (Array.isArray(keys)) return pick(obj, (_, k) => keys.includes(k));
  return Object.entries(obj).reduce((acc, _ref) => {
    let [k, v] = _ref;
    if (keys(v, k)) acc[k] = v;
    return acc;
  }, {});
}

/** Direction */
const DIRECTION = {
  NONE: 'NONE',
  LEFT: 'LEFT',
  FORCE_LEFT: 'FORCE_LEFT',
  RIGHT: 'RIGHT',
  FORCE_RIGHT: 'FORCE_RIGHT'
};

/** Direction */

function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return direction;
  }
}

/** Escapes regular expression control chars */
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}

// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function objectIncludes(b, a) {
  if (a === b) return true;
  const arrA = Array.isArray(a),
    arrB = Array.isArray(b);
  let i;
  if (arrA && arrB) {
    if (a.length != b.length) return false;
    for (i = 0; i < a.length; i++) if (!objectIncludes(a[i], b[i])) return false;
    return true;
  }
  if (arrA != arrB) return false;
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    const dateA = a instanceof Date,
      dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;
    const regexpA = a instanceof RegExp,
      regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;
    const keys = Object.keys(a);
    // if (keys.length !== Object.keys(b).length) return false;

    for (i = 0; i < keys.length; i++) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = 0; i < keys.length; i++) if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
    return true;
  } else if (a && b && typeof a === 'function' && typeof b === 'function') {
    return a.toString() === b.toString();
  }
  return false;
}

/** Provides details of changing input */
class ActionDetails {
  /** Current input value */

  /** Current cursor position */

  /** Old input value */

  /** Old selection */

  constructor(opts) {
    Object.assign(this, opts);

    // double check if left part was changed (autofilling, other non-standard input triggers)
    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
    if (this.insertedCount) {
      // double check right part
      while (this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end)) {
        if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;else ++this.cursorPos;
      }
    }
  }

  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }

  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }

  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }

  /** Removed symbols count */
  get removedCount() {
    // Math.max for opposite operation
    return Math.max(this.oldSelection.end - this.startChangePos ||
    // for Delete
    this.oldValue.length - this.value.length, 0);
  }

  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }

  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }

  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }

  /** Remove direction */
  get removeDirection() {
    if (!this.removedCount || this.insertedCount) return DIRECTION.NONE;

    // align right if delete at right
    return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) &&
    // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
  }
}

/** Applies mask on element */
function IMask(el, opts) {
  // currently available only for input-like elements
  return new IMask.InputMask(el, opts);
}

// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;

/** Get Masked class by mask type */
function maskedClass(mask) /* TODO */{
  if (mask == null) throw new Error('mask property should be defined');
  if (mask instanceof RegExp) return IMask.MaskedRegExp;
  if (isString(mask)) return IMask.MaskedPattern;
  if (mask === Date) return IMask.MaskedDate;
  if (mask === Number) return IMask.MaskedNumber;
  if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic;
  if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask;
  if (IMask.Masked && mask instanceof IMask.Masked) return mask.constructor;
  if (mask instanceof Function) return IMask.MaskedFunction;
  console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
  return IMask.Masked;
}
function normalizeOpts(opts) {
  if (!opts) throw new Error('Options in not defined');
  if (IMask.Masked) {
    if (opts.prototype instanceof IMask.Masked) return {
      mask: opts
    };

    /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */
    const {
      mask = undefined,
      ...instanceOpts
    } = opts instanceof IMask.Masked ? {
      mask: opts
    } : isObject(opts) && opts.mask instanceof IMask.Masked ? opts : {};
    if (mask) {
      const _mask = mask.mask;
      return {
        ...pick(mask, (_, k) => !k.startsWith('_')),
        mask: mask.constructor,
        _mask,
        ...instanceOpts
      };
    }
  }
  if (!isObject(opts)) return {
    mask: opts
  };
  return {
    ...opts
  };
}

// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754

// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;

/** Creates new {@link Masked} depending on mask type */
function createMask(opts) {
  if (IMask.Masked && opts instanceof IMask.Masked) return opts;
  const nOpts = normalizeOpts(opts);
  const MaskedClass = maskedClass(nOpts.mask);
  if (!MaskedClass) throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
  if (nOpts.mask === MaskedClass) delete nOpts.mask;
  if (nOpts._mask) {
    nOpts.mask = nOpts._mask;
    delete nOpts._mask;
  }
  return new MaskedClass(nOpts);
}
IMask.createMask = createMask;

/**  Generic element API to use with mask */
class MaskElement {
  /** */

  /** */

  /** */

  /** Safely returns selection start */
  get selectionStart() {
    let start;
    try {
      start = this._unsafeSelectionStart;
    } catch {}
    return start != null ? start : this.value.length;
  }

  /** Safely returns selection end */
  get selectionEnd() {
    let end;
    try {
      end = this._unsafeSelectionEnd;
    } catch {}
    return end != null ? end : this.value.length;
  }

  /** Safely sets element selection */
  select(start, end) {
    if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
    try {
      this._unsafeSelect(start, end);
    } catch {}
  }

  /** */
  get isActive() {
    return false;
  }
  /** */

  /** */

  /** */
}
IMask.MaskElement = MaskElement;

const KEY_Z = 90;
const KEY_Y = 89;

/** Bridge between HTMLElement and {@link Masked} */
class HTMLMaskElement extends MaskElement {
  /** HTMLElement to use mask on */

  constructor(input) {
    super();
    this.input = input;
    this._onKeydown = this._onKeydown.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onBeforeinput = this._onBeforeinput.bind(this);
    this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
    return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
  }

  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }

  /** Binds HTMLElement events to mask internal events */
  bindEvents(handlers) {
    this.input.addEventListener('keydown', this._onKeydown);
    this.input.addEventListener('input', this._onInput);
    this.input.addEventListener('beforeinput', this._onBeforeinput);
    this.input.addEventListener('compositionend', this._onCompositionEnd);
    this.input.addEventListener('drop', handlers.drop);
    this.input.addEventListener('click', handlers.click);
    this.input.addEventListener('focus', handlers.focus);
    this.input.addEventListener('blur', handlers.commit);
    this._handlers = handlers;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === KEY_Y && e.ctrlKey)) {
      e.preventDefault();
      return this._handlers.redo(e);
    }
    if (this._handlers.undo && e.keyCode === KEY_Z && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      return this._handlers.undo(e);
    }
    if (!e.isComposing) this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === 'historyUndo' && this._handlers.undo) {
      e.preventDefault();
      return this._handlers.undo(e);
    }
    if (e.inputType === 'historyRedo' && this._handlers.redo) {
      e.preventDefault();
      return this._handlers.redo(e);
    }
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    if (!e.isComposing) this._handlers.input(e);
  }

  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener('keydown', this._onKeydown);
    this.input.removeEventListener('input', this._onInput);
    this.input.removeEventListener('beforeinput', this._onBeforeinput);
    this.input.removeEventListener('compositionend', this._onCompositionEnd);
    this.input.removeEventListener('drop', this._handlers.drop);
    this.input.removeEventListener('click', this._handlers.click);
    this.input.removeEventListener('focus', this._handlers.focus);
    this.input.removeEventListener('blur', this._handlers.commit);
    this._handlers = {};
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;

/** Bridge between InputElement and {@link Masked} */
class HTMLInputMaskElement extends HTMLMaskElement {
  /** InputElement to use mask on */

  constructor(input) {
    super(input);
    this.input = input;
  }

  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }

  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }

  /** Sets InputElement selection */
  _unsafeSelect(start, end) {
    this.input.setSelectionRange(start, end);
  }
  get value() {
    return this.input.value;
  }
  set value(value) {
    this.input.value = value;
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;

class HTMLContenteditableMaskElement extends HTMLMaskElement {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }

  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }

  /** Sets HTMLElement selection */
  _unsafeSelect(start, end) {
    if (!this.rootElement.createRange) return;
    const range = this.rootElement.createRange();
    range.setStart(this.input.firstChild || this.input, start);
    range.setEnd(this.input.lastChild || this.input, end);
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  /** HTMLElement value */
  get value() {
    return this.input.textContent || '';
  }
  set value(value) {
    this.input.textContent = value;
  }
}
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;

class InputHistory {
  constructor() {
    this.states = [];
    this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(state) {
    // if current index points before the last element then remove the future
    if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
    this.states.push(state);
    if (this.states.length > InputHistory.MAX_LENGTH) this.states.shift();
    this.currentIndex = this.states.length - 1;
  }
  go(steps) {
    this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
    return this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(+1);
  }
  clear() {
    this.states.length = 0;
    this.currentIndex = 0;
  }
}
InputHistory.MAX_LENGTH = 100;

/** Listens to element events and controls changes between element and {@link Masked} */
class InputMask {
  /**
    View element
  */

  /** Internal {@link Masked} model */

  constructor(el, opts) {
    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new HTMLContenteditableMaskElement(el) : new HTMLInputMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = '';
    this._unmaskedValue = '';
    this._rawInputValue = '';
    this.history = new InputHistory();
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onUndo = this._onUndo.bind(this);
    this._onRedo = this._onRedo.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
    this._bindEvents();

    // refresh
    this.updateValue();
    this._onChange();
  }
  maskEquals(mask) {
    var _this$masked;
    return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
  }

  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(mask) {
    if (this.maskEquals(mask)) return;
    if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
      // TODO "any" no idea
      this.masked.updateOptions({
        mask
      });
      return;
    }
    const masked = mask instanceof IMask.Masked ? mask : createMask({
      mask
    });
    masked.unmaskedValue = this.masked.unmaskedValue;
    this.masked = masked;
  }

  /** Raw value */
  get value() {
    return this._value;
  }
  set value(str) {
    if (this.value === str) return;
    this.masked.value = str;
    this.updateControl('auto');
  }

  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(str) {
    if (this.unmaskedValue === str) return;
    this.masked.unmaskedValue = str;
    this.updateControl('auto');
  }

  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(str) {
    if (this.rawInputValue === str) return;
    this.masked.rawInputValue = str;
    this.updateControl();
    this.alignCursor();
  }

  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(val) {
    if (this.masked.typedValueEquals(val)) return;
    this.masked.typedValue = val;
    this.updateControl('auto');
  }

  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }

  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }

  /** Stops listening to element events */
  _unbindEvents() {
    if (this.el) this.el.unbindEvents();
  }

  /** Fires custom event */
  _fireEvent(ev, e) {
    const listeners = this._listeners[ev];
    if (!listeners) return;
    listeners.forEach(l => l(e));
  }

  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }

  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(pos) {
    if (!this.el || !this.el.isActive) return;
    this.el.select(pos, pos);
    this._saveSelection();
  }

  /** Stores current selection */
  _saveSelection( /* ev */
  ) {
    if (this.displayValue !== this.el.value) {
      console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
    }
    this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }

  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value;
    this._value = this.masked.value;
    this._unmaskedValue = this.masked.unmaskedValue;
    this._rawInputValue = this.masked.rawInputValue;
  }

  /** Syncronizes view from model value, fires change events */
  updateControl(cursorPos) {
    const newUnmaskedValue = this.masked.unmaskedValue;
    const newValue = this.masked.value;
    const newRawInputValue = this.masked.rawInputValue;
    const newDisplayValue = this.displayValue;
    const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
    this._unmaskedValue = newUnmaskedValue;
    this._value = newValue;
    this._rawInputValue = newRawInputValue;
    if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
    if (cursorPos === 'auto') this.alignCursor();else if (cursorPos != null) this.cursorPos = cursorPos;
    if (isChanged) this._fireChangeEvents();
    if (!this._historyChanging && (isChanged || this.history.isEmpty)) this.history.push({
      unmaskedValue: newUnmaskedValue,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }

  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(opts) {
    const {
      mask,
      ...restOpts
    } = opts; // TODO types, yes, mask is optional

    const updateMask = !this.maskEquals(mask);
    const updateOpts = this.masked.optionsIsChanged(restOpts);
    if (updateMask) this.mask = mask;
    if (updateOpts) this.masked.updateOptions(restOpts); // TODO

    if (updateMask || updateOpts) this.updateControl();
  }

  /** Updates cursor */
  updateCursor(cursorPos) {
    if (cursorPos == null) return;
    this.cursorPos = cursorPos;

    // also queue change cursor for mobile browsers
    this._delayUpdateCursor(cursorPos);
  }

  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(cursorPos) {
    this._abortUpdateCursor();
    this._changingCursorPos = cursorPos;
    this._cursorChanging = setTimeout(() => {
      if (!this.el) return; // if was destroyed
      this.cursorPos = this._changingCursorPos;
      this._abortUpdateCursor();
    }, 10);
  }

  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent('accept', this._inputEvent);
    if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
  }

  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    if (this._cursorChanging) {
      clearTimeout(this._cursorChanging);
      delete this._cursorChanging;
    }
  }

  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
  }

  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
    this.alignCursor();
  }

  /** Adds listener on custom event */
  on(ev, handler) {
    if (!this._listeners[ev]) this._listeners[ev] = [];
    this._listeners[ev].push(handler);
    return this;
  }

  /** Removes custom event listener */
  off(ev, handler) {
    if (!this._listeners[ev]) return this;
    if (!handler) {
      delete this._listeners[ev];
      return this;
    }
    const hIndex = this._listeners[ev].indexOf(handler);
    if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
    return this;
  }

  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e;
    this._abortUpdateCursor();
    const details = new ActionDetails({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    });
    const oldRawValue = this.masked.rawInputValue;
    const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
      input: true,
      raw: true
    }).offset;

    // force align in remove direction only if no input chars were removed
    // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
    const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
    let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
    if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
    this.updateControl(cursorPos);
    delete this._inputEvent;
  }

  /** Handles view change event and commits model value */
  _onChange() {
    if (this.displayValue !== this.el.value) this.updateValue();
    this.masked.doCommit();
    this.updateControl();
    this._saveSelection();
  }

  /** Handles view drop event, prevents by default */
  _onDrop(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  /** Restore last selection on focus */
  _onFocus(ev) {
    this.alignCursorFriendly();
  }

  /** Restore last selection on focus */
  _onClick(ev) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(state) {
    if (!state) return;
    this._historyChanging = true;
    this.unmaskedValue = state.unmaskedValue;
    this.el.select(state.selection.start, state.selection.end);
    this._saveSelection();
    this._historyChanging = false;
  }

  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents();
    this._listeners.length = 0;
    delete this.el;
  }
}
IMask.InputMask = InputMask;

/** Provides details of changing model value */
class ChangeDetails {
  /** Inserted symbols */

  /** Additional offset if any changes occurred before tail */

  /** Raw inserted is used by dynamic mask */

  /** Can skip chars */

  static normalize(prep) {
    return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
  }
  constructor(details) {
    Object.assign(this, {
      inserted: '',
      rawInserted: '',
      tailShift: 0,
      skip: false
    }, details);
  }

  /** Aggregate changes */
  aggregate(details) {
    this.inserted += details.inserted;
    this.rawInserted += details.rawInserted;
    this.tailShift += details.tailShift;
    this.skip = this.skip || details.skip;
    return this;
  }

  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return Boolean(this.rawInserted) || this.skip;
  }
  equals(details) {
    return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
  }
}
IMask.ChangeDetails = ChangeDetails;

/** Provides details of continuous extracted tail */
class ContinuousTailDetails {
  /** Tail value as string */

  /** Tail start position */

  /** Start position */

  constructor(value, from, stop) {
    if (value === void 0) {
      value = '';
    }
    if (from === void 0) {
      from = 0;
    }
    this.value = value;
    this.from = from;
    this.stop = stop;
  }
  toString() {
    return this.value;
  }
  extend(tail) {
    this.value += String(tail);
  }
  appendTo(masked) {
    return masked.append(this.toString(), {
      tail: true
    }).aggregate(masked._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
  unshift(beforePos) {
    if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
    const shiftChar = this.value[0];
    this.value = this.value.slice(1);
    return shiftChar;
  }
  shift() {
    if (!this.value.length) return '';
    const shiftChar = this.value[this.value.length - 1];
    this.value = this.value.slice(0, -1);
    return shiftChar;
  }
}

/** Append flags */

/** Extract flags */

// see https://github.com/microsoft/TypeScript/issues/6223

/** Provides common masking stuff */
class Masked {
  /** */

  /** */

  /** Transforms value before mask processing */

  /** Transforms each char before mask processing */

  /** Validates if value is acceptable */

  /** Does additional processing at the end of editing */

  /** Format typed value to string */

  /** Parse string to get typed value */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    this._value = '';
    this._update({
      ...Masked.DEFAULTS,
      ...opts
    });
    this._initialized = true;
  }

  /** Sets and applies new options */
  updateOptions(opts) {
    if (!this.optionsIsChanged(opts)) return;
    this.withValueRefresh(this._update.bind(this, opts));
  }

  /** Sets new options */
  _update(opts) {
    Object.assign(this, opts);
  }

  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(state) {
    this._value = state._value;
  }

  /** Resets value */
  reset() {
    this._value = '';
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this.resolve(value, {
      input: true
    });
  }

  /** Resolve new value */
  resolve(value, flags) {
    if (flags === void 0) {
      flags = {
        input: true
      };
    }
    this.reset();
    this.append(value, flags, '');
    this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(value) {
    this.resolve(value, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(value) {
    if (this.format) {
      this.value = this.format(value, this);
    } else {
      this.unmaskedValue = String(value);
    }
  }

  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: true
    });
  }
  set rawInputValue(value) {
    this.resolve(value, {
      raw: true
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return this.isComplete;
  }

  /** Finds nearest input position in direction */
  nearestInputPos(cursorPos, direction) {
    return cursorPos;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return Math.min(this.displayValue.length, toPos - fromPos);
  }

  /** Extracts value in range considering flags */
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return this.displayValue.slice(fromPos, toPos);
  }

  /** Extracts tail in range */
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
  }

  /** Appends tail */
  appendTail(tail) {
    if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }

  /** Appends char */
  _appendCharRaw(ch, flags) {
    if (!ch) return new ChangeDetails();
    this._value += ch;
    return new ChangeDetails({
      inserted: ch,
      rawInserted: ch
    });
  }

  /** Appends char */
  _appendChar(ch, flags, checkTail) {
    if (flags === void 0) {
      flags = {};
    }
    const consistentState = this.state;
    let details;
    [ch, details] = this.doPrepareChar(ch, flags);
    if (ch) {
      details = details.aggregate(this._appendCharRaw(ch, flags));

      // TODO handle `skip`?

      // try `autofix` lookahead
      if (!details.rawInserted && this.autofix === 'pad') {
        const noFixState = this.state;
        this.state = consistentState;
        let fixDetails = this.pad(flags);
        const chDetails = this._appendCharRaw(ch, flags);
        fixDetails = fixDetails.aggregate(chDetails);

        // if fix was applied or
        // if details are equal use skip restoring state optimization
        if (chDetails.rawInserted || fixDetails.equals(details)) {
          details = fixDetails;
        } else {
          this.state = noFixState;
        }
      }
    }
    if (details.inserted) {
      let consistentTail;
      let appended = this.doValidate(flags) !== false;
      if (appended && checkTail != null) {
        // validation ok, check tail
        const beforeTailState = this.state;
        if (this.overwrite === true) {
          consistentTail = checkTail.state;
          for (let i = 0; i < details.rawInserted.length; ++i) {
            checkTail.unshift(this.displayValue.length - details.tailShift);
          }
        }
        let tailDetails = this.appendTail(checkTail);
        appended = tailDetails.rawInserted.length === checkTail.toString().length;

        // not ok, try shift
        if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
          this.state = beforeTailState;
          consistentTail = checkTail.state;
          for (let i = 0; i < details.rawInserted.length; ++i) {
            checkTail.shift();
          }
          tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted.length === checkTail.toString().length;
        }

        // if ok, rollback state after tail
        if (appended && tailDetails.inserted) this.state = beforeTailState;
      }

      // revert all if something went wrong
      if (!appended) {
        details = new ChangeDetails();
        this.state = consistentState;
        if (checkTail && consistentTail) checkTail.state = consistentTail;
      }
    }
    return details;
  }

  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new ChangeDetails();
  }

  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new ChangeDetails();
  }

  /** Appends symbols considering flags */
  append(str, flags, tail) {
    if (!isString(str)) throw new Error('value should be string');
    const checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
    if (flags != null && flags.tail) flags._beforeTailState = this.state;
    let details;
    [str, details] = this.doPrepare(str, flags);
    for (let ci = 0; ci < str.length; ++ci) {
      const d = this._appendChar(str[ci], flags, checkTail);
      if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
      details.aggregate(d);
    }
    if ((this.eager === true || this.eager === 'append') && flags != null && flags.input && str) {
      details.aggregate(this._appendEager());
    }

    // append tail but aggregate only tailShift
    if (checkTail != null) {
      details.tailShift += this.appendTail(checkTail).tailShift;
      // TODO it's a good idea to clear state after appending ends
      // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
      // this._resetBeforeTailState();
    }
    return details;
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
    return new ChangeDetails();
  }

  /** Calls function and reapplies current value */
  withValueRefresh(fn) {
    if (this._refreshing || !this._initialized) return fn();
    this._refreshing = true;
    const rawInput = this.rawInputValue;
    const value = this.value;
    const ret = fn();
    this.rawInputValue = rawInput;
    // append lost trailing chars at the end
    if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
      this.append(value.slice(this.displayValue.length), {}, '');
      this.doCommit();
    }
    delete this._refreshing;
    return ret;
  }
  runIsolated(fn) {
    if (this._isolated || !this._initialized) return fn(this);
    this._isolated = true;
    const state = this.state;
    const ret = fn(this);
    this.state = state;
    delete this._isolated;
    return ret;
  }
  doSkipInvalid(ch, flags, checkTail) {
    return Boolean(this.skipInvalid);
  }

  /** Prepares string before mask processing */
  doPrepare(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    return ChangeDetails.normalize(this.prepare ? this.prepare(str, this, flags) : str);
  }

  /** Prepares each char before mask processing */
  doPrepareChar(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    return ChangeDetails.normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
  }

  /** Validates if value is acceptable */
  doValidate(flags) {
    return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
  }

  /** Does additional processing at the end of editing */
  doCommit() {
    if (this.commit) this.commit(this.value, this);
  }
  splice(start, deleteCount, inserted, removeDirection, flags) {
    if (inserted === void 0) {
      inserted = '';
    }
    if (removeDirection === void 0) {
      removeDirection = DIRECTION.NONE;
    }
    if (flags === void 0) {
      flags = {
        input: true
      };
    }
    const tailPos = start + deleteCount;
    const tail = this.extractTail(tailPos);
    const eagerRemove = this.eager === true || this.eager === 'remove';
    let oldRawValue;
    if (eagerRemove) {
      removeDirection = forceDirection(removeDirection);
      oldRawValue = this.extractInput(0, tailPos, {
        raw: true
      });
    }
    let startChangePos = start;
    const details = new ChangeDetails();

    // if it is just deletion without insertion
    if (removeDirection !== DIRECTION.NONE) {
      startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection);

      // adjust tailShift if start was aligned
      details.tailShift = startChangePos - start;
    }
    details.aggregate(this.remove(startChangePos));
    if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
      if (removeDirection === DIRECTION.FORCE_LEFT) {
        let valLength;
        while (oldRawValue === this.rawInputValue && (valLength = this.displayValue.length)) {
          details.aggregate(new ChangeDetails({
            tailShift: -1
          })).aggregate(this.remove(valLength - 1));
        }
      } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
        tail.unshift();
      }
    }
    return details.aggregate(this.append(inserted, flags, tail));
  }
  maskEquals(mask) {
    return this.mask === mask;
  }
  optionsIsChanged(opts) {
    return !objectIncludes(this, opts);
  }
  typedValueEquals(value) {
    const tval = this.typedValue;
    return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
  }
  pad(flags) {
    return new ChangeDetails();
  }
}
Masked.DEFAULTS = {
  skipInvalid: true
};
Masked.EMPTY_VALUES = [undefined, null, ''];
IMask.Masked = Masked;

class ChunksTailDetails {
  /** */

  constructor(chunks, from) {
    if (chunks === void 0) {
      chunks = [];
    }
    if (from === void 0) {
      from = 0;
    }
    this.chunks = chunks;
    this.from = from;
  }
  toString() {
    return this.chunks.map(String).join('');
  }
  extend(tailChunk) {
    if (!String(tailChunk)) return;
    tailChunk = isString(tailChunk) ? new ContinuousTailDetails(String(tailChunk)) : tailChunk;
    const lastChunk = this.chunks[this.chunks.length - 1];
    const extendLast = lastChunk && (
    // if stops are same or tail has no stop
    lastChunk.stop === tailChunk.stop || tailChunk.stop == null) &&
    // if tail chunk goes just after last chunk
    tailChunk.from === lastChunk.from + lastChunk.toString().length;
    if (tailChunk instanceof ContinuousTailDetails) {
      // check the ability to extend previous chunk
      if (extendLast) {
        // extend previous chunk
        lastChunk.extend(tailChunk.toString());
      } else {
        // append new chunk
        this.chunks.push(tailChunk);
      }
    } else if (tailChunk instanceof ChunksTailDetails) {
      if (tailChunk.stop == null) {
        // unwrap floating chunks to parent, keeping `from` pos
        let firstTailChunk;
        while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
          firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
          firstTailChunk.from += tailChunk.from;
          this.extend(firstTailChunk);
        }
      }

      // if tail chunk still has value
      if (tailChunk.toString()) {
        // if chunks contains stops, then popup stop to container
        tailChunk.stop = tailChunk.blockIndex;
        this.chunks.push(tailChunk);
      }
    }
  }
  appendTo(masked) {
    if (!(masked instanceof IMask.MaskedPattern)) {
      const tail = new ContinuousTailDetails(this.toString());
      return tail.appendTo(masked);
    }
    const details = new ChangeDetails();
    for (let ci = 0; ci < this.chunks.length; ++ci) {
      const chunk = this.chunks[ci];
      const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
      const stop = chunk.stop;
      let chunkBlock;
      if (stop != null && (
      // if block not found or stop is behind lastBlock
      !lastBlockIter || lastBlockIter.index <= stop)) {
        if (chunk instanceof ChunksTailDetails ||
        // for continuous block also check if stop is exist
        masked._stops.indexOf(stop) >= 0) {
          details.aggregate(masked._appendPlaceholder(stop));
        }
        chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
      }
      if (chunkBlock) {
        const tailDetails = chunkBlock.appendTail(chunk);
        details.aggregate(tailDetails);

        // get not inserted chars
        const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
        if (remainChars) details.aggregate(masked.append(remainChars, {
          tail: true
        }));
      } else {
        details.aggregate(masked.append(chunk.toString(), {
          tail: true
        }));
      }
    }
    return details;
  }
  get state() {
    return {
      chunks: this.chunks.map(c => c.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(state) {
    const {
      chunks,
      ...props
    } = state;
    Object.assign(this, props);
    this.chunks = chunks.map(cstate => {
      const chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
      chunk.state = cstate;
      return chunk;
    });
  }
  unshift(beforePos) {
    if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
    const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
    let ci = 0;
    while (ci < this.chunks.length) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.unshift(chunkShiftPos);
      if (chunk.toString()) {
        // chunk still contains value
        // but not shifted - means no more available chars to shift
        if (!shiftChar) break;
        ++ci;
      } else {
        // clean if chunk has no value
        this.chunks.splice(ci, 1);
      }
      if (shiftChar) return shiftChar;
    }
    return '';
  }
  shift() {
    if (!this.chunks.length) return '';
    let ci = this.chunks.length - 1;
    while (0 <= ci) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.shift();
      if (chunk.toString()) {
        // chunk still contains value
        // but not shifted - means no more available chars to shift
        if (!shiftChar) break;
        --ci;
      } else {
        // clean if chunk has no value
        this.chunks.splice(ci, 1);
      }
      if (shiftChar) return shiftChar;
    }
    return '';
  }
}

class PatternCursor {
  constructor(masked, pos) {
    this.masked = masked;
    this._log = [];
    const {
      offset,
      index
    } = masked._mapPosToBlock(pos) || (pos < 0 ?
    // first
    {
      index: 0,
      offset: 0
    } :
    // last
    {
      index: this.masked._blocks.length,
      offset: 0
    });
    this.offset = offset;
    this.index = index;
    this.ok = false;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(s) {
    Object.assign(this, s);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const s = this._log.pop();
    if (s) this.state = s;
    return s;
  }
  bindBlock() {
    if (this.block) return;
    if (this.index < 0) {
      this.index = 0;
      this.offset = 0;
    }
    if (this.index >= this.masked._blocks.length) {
      this.index = this.masked._blocks.length - 1;
      this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
    }
  }
  _pushLeft(fn) {
    this.pushState();
    for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0) {
      var _this$block;
      if (fn()) return this.ok = true;
    }
    return this.ok = false;
  }
  _pushRight(fn) {
    this.pushState();
    for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
      if (fn()) return this.ok = true;
    }
    return this.ok = false;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (this.block.isFixed || !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
      if (this.offset !== 0) return true;
    });
  }
  pushLeftBeforeInput() {
    // cases:
    // filled input: 00|
    // optional empty input: 00[]|
    // nested block: XX<[]>|
    return this._pushLeft(() => {
      if (this.block.isFixed) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (this.block.isFixed || !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
      if (this.offset !== this.block.value.length) return true;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (this.block.isFixed) return;

      // const o = this.offset;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      // HACK cases like (STILL DOES NOT WORK FOR NESTED)
      // aa|X
      // aa<X|[]>X_    - this will not work
      // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
      return true;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value) return;

      // TODO check |[*]XX_
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
}

class PatternFixedDefinition {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    Object.assign(this, opts);
    this._value = '';
    this.isFixed = true;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : '';
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : '';
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = false;
    this._value = '';
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
    if (!this._value) this._isRawInput = false;
    return new ChangeDetails();
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    const minPos = 0;
    const maxPos = this._value.length;
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return minPos;
      case DIRECTION.NONE:
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
      default:
        return maxPos;
    }
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    return this._isRawInput ? toPos - fromPos : 0;
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    if (flags === void 0) {
      flags = {};
    }
    return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return Boolean(this._value);
  }
  _appendChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    if (this.isFilled) return new ChangeDetails();
    const appendEager = this.eager === true || this.eager === 'append';
    const appended = this.char === ch;
    const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
    const details = new ChangeDetails({
      inserted: this.char,
      rawInserted: isResolved ? this.char : ''
    });
    this._value = this.char;
    this._isRawInput = isResolved && (flags.raw || flags.input);
    return details;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: true
    });
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled) return details;
    this._value = details.inserted = this.char;
    return details;
  }
  extractTail() {
    return new ContinuousTailDetails('');
  }
  appendTail(tail) {
    if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  append(str, flags, tail) {
    const details = this._appendChar(str[0], flags);
    if (tail != null) {
      details.tailShift += this.appendTail(tail).tailShift;
    }
    return details;
  }
  doCommit() {}
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(state) {
    this._value = state._value;
    this._isRawInput = Boolean(state._rawInputValue);
  }
  pad(flags) {
    return this._appendPlaceholder();
  }
}

class PatternInputDefinition {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    const {
      parent,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager,
      ...maskOpts
    } = opts;
    this.masked = createMask(maskOpts);
    Object.assign(this, {
      parent,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager
    });
  }
  reset() {
    this.isFilled = false;
    this.masked.reset();
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    if (fromPos === 0 && toPos >= 1) {
      this.isFilled = false;
      return this.masked.remove(fromPos, toPos);
    }
    return new ChangeDetails();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return Boolean(this.masked.value) || this.isOptional;
  }
  _appendChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    if (this.isFilled) return new ChangeDetails();
    const state = this.masked.state;
    // simulate input
    let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
    if (details.inserted && this.doValidate(flags) === false) {
      details = new ChangeDetails();
      this.masked.state = state;
    }
    if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
      details.inserted = this.placeholderChar;
    }
    details.skip = !details.inserted && !this.isOptional;
    this.isFilled = Boolean(details.inserted);
    return details;
  }
  append(str, flags, tail) {
    // TODO probably should be done via _appendChar
    return this.masked.append(str, this.currentMaskFlags(flags), tail);
  }
  _appendPlaceholder() {
    if (this.isFilled || this.isOptional) return new ChangeDetails();
    this.isFilled = true;
    return new ChangeDetails({
      inserted: this.placeholderChar
    });
  }
  _appendEager() {
    return new ChangeDetails();
  }
  extractTail(fromPos, toPos) {
    return this.masked.extractTail(fromPos, toPos);
  }
  appendTail(tail) {
    return this.masked.appendTail(tail);
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    return this.masked.extractInput(fromPos, toPos, flags);
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    const minPos = 0;
    const maxPos = this.value.length;
    const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return this.isComplete ? boundPos : minPos;
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        return this.isComplete ? boundPos : maxPos;
      case DIRECTION.NONE:
      default:
        return boundPos;
    }
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    return this.value.slice(fromPos, toPos).length;
  }
  doValidate(flags) {
    return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(state) {
    this.masked.state = state.masked;
    this.isFilled = state.isFilled;
  }
  currentMaskFlags(flags) {
    var _flags$_beforeTailSta;
    return {
      ...flags,
      _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
    };
  }
  pad(flags) {
    return new ChangeDetails();
  }
}
PatternInputDefinition.DEFAULT_DEFINITIONS = {
  '0': /\d/,
  'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  '*': /./
};

/** Masking by RegExp */
class MaskedRegExp extends Masked {
  /** */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const mask = opts.mask;
    if (mask) opts.validate = value => value.search(mask) >= 0;
    super._update(opts);
  }
}
IMask.MaskedRegExp = MaskedRegExp;

/** Pattern mask */
class MaskedPattern extends Masked {
  /** */

  /** */

  /** Single char for empty input */

  /** Single char for filled input */

  /** Show placeholder only when needed */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  constructor(opts) {
    super({
      ...MaskedPattern.DEFAULTS,
      ...opts,
      definitions: Object.assign({}, PatternInputDefinition.DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    opts.definitions = Object.assign({}, this.definitions, opts.definitions);
    super._update(opts);
    this._rebuildMask();
  }
  _rebuildMask() {
    const defs = this.definitions;
    this._blocks = [];
    this.exposeBlock = undefined;
    this._stops = [];
    this._maskedBlocks = {};
    const pattern = this.mask;
    if (!pattern || !defs) return;
    let unmaskingBlock = false;
    let optionalBlock = false;
    for (let i = 0; i < pattern.length; ++i) {
      if (this.blocks) {
        const p = pattern.slice(i);
        const bNames = Object.keys(this.blocks).filter(bName => p.indexOf(bName) === 0);
        // order by key length
        bNames.sort((a, b) => b.length - a.length);
        // use block name with max length
        const bName = bNames[0];
        if (bName) {
          const {
            expose,
            repeat,
            ...bOpts
          } = normalizeOpts(this.blocks[bName]); // TODO type Opts<Arg & Extra>
          const blockOpts = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...bOpts,
            repeat,
            parent: this
          };
          const maskedBlock = repeat != null ? new IMask.RepeatBlock(blockOpts /* TODO */) : createMask(blockOpts);
          if (maskedBlock) {
            this._blocks.push(maskedBlock);
            if (expose) this.exposeBlock = maskedBlock;

            // store block index
            if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
            this._maskedBlocks[bName].push(this._blocks.length - 1);
          }
          i += bName.length - 1;
          continue;
        }
      }
      let char = pattern[i];
      let isInput = (char in defs);
      if (char === MaskedPattern.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (char === '{' || char === '}') {
        unmaskingBlock = !unmaskingBlock;
        continue;
      }
      if (char === '[' || char === ']') {
        optionalBlock = !optionalBlock;
        continue;
      }
      if (char === MaskedPattern.ESCAPE_CHAR) {
        ++i;
        char = pattern[i];
        if (!char) break;
        isInput = false;
      }
      const def = isInput ? new PatternInputDefinition({
        isOptional: optionalBlock,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...normalizeOpts(defs[char]),
        parent: this
      }) : new PatternFixedDefinition({
        char,
        eager: this.eager,
        isUnmasking: unmaskingBlock
      });
      this._blocks.push(def);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map(b => b.state)
    };
  }
  set state(state) {
    if (!state) {
      this.reset();
      return;
    }
    const {
      _blocks,
      ...maskedState
    } = state;
    this._blocks.forEach((b, bi) => b.state = _blocks[bi]);
    super.state = maskedState;
  }
  reset() {
    super.reset();
    this._blocks.forEach(b => b.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every(b => b.isComplete);
  }
  get isFilled() {
    return this._blocks.every(b => b.isFilled);
  }
  get isFixed() {
    return this._blocks.every(b => b.isFixed);
  }
  get isOptional() {
    return this._blocks.every(b => b.isOptional);
  }
  doCommit() {
    this._blocks.forEach(b => b.doCommit());
    super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b) => str += b.unmaskedValue, '');
  }
  set unmaskedValue(unmaskedValue) {
    if (this.exposeBlock) {
      const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = unmaskedValue;
      this.appendTail(tail);
      this.doCommit();
    } else super.unmaskedValue = unmaskedValue;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value :
    // TODO return _value when not in change?
    this._blocks.reduce((str, b) => str += b.value, '');
  }
  set value(value) {
    if (this.exposeBlock) {
      const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = value;
      this.appendTail(tail);
      this.doCommit();
    } else super.value = value;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(value) {
    if (this.exposeBlock) {
      const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = value;
      this.appendTail(tail);
      this.doCommit();
    } else super.typedValue = value;
  }
  get displayValue() {
    return this._blocks.reduce((str, b) => str += b.displayValue, '');
  }
  appendTail(tail) {
    return super.appendTail(tail).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var _this$_mapPosToBlock;
    const details = new ChangeDetails();
    let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
    if (startBlockIndex == null) return details;

    // TODO test if it works for nested pattern masks
    if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
    for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
      const d = this._blocks[bi]._appendEager();
      if (!d.inserted) break;
      details.aggregate(d);
    }
    return details;
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const blockIter = this._mapPosToBlock(this.displayValue.length);
    const details = new ChangeDetails();
    if (!blockIter) return details;
    for (let bi = blockIter.index, block; block = this._blocks[bi]; ++bi) {
      var _flags$_beforeTailSta;
      const blockDetails = block._appendChar(ch, {
        ...flags,
        _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
      });
      details.aggregate(blockDetails);
      if (blockDetails.consumed) break; // go next char
    }
    return details;
  }
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const chunkTail = new ChunksTailDetails();
    if (fromPos === toPos) return chunkTail;
    this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos) => {
      const blockChunk = b.extractTail(bFromPos, bToPos);
      blockChunk.stop = this._findStopBefore(bi);
      blockChunk.from = this._blockStartPos(bi);
      if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
      chunkTail.extend(blockChunk);
    });
    return chunkTail;
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    if (flags === void 0) {
      flags = {};
    }
    if (fromPos === toPos) return '';
    let input = '';
    this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos) => {
      input += b.extractInput(fromPos, toPos, flags);
    });
    return input;
  }
  _findStopBefore(blockIndex) {
    let stopBefore;
    for (let si = 0; si < this._stops.length; ++si) {
      const stop = this._stops[si];
      if (stop <= blockIndex) stopBefore = stop;else break;
    }
    return stopBefore;
  }

  /** Appends placeholder depending on laziness */
  _appendPlaceholder(toBlockIndex) {
    const details = new ChangeDetails();
    if (this.lazy && toBlockIndex == null) return details;
    const startBlockIter = this._mapPosToBlock(this.displayValue.length);
    if (!startBlockIter) return details;
    const startBlockIndex = startBlockIter.index;
    const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
    this._blocks.slice(startBlockIndex, endBlockIndex).forEach(b => {
      if (!b.lazy || toBlockIndex != null) {
        var _blocks2;
        details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
      }
    });
    return details;
  }

  /** Finds block in pos */
  _mapPosToBlock(pos) {
    let accVal = '';
    for (let bi = 0; bi < this._blocks.length; ++bi) {
      const block = this._blocks[bi];
      const blockStartPos = accVal.length;
      accVal += block.displayValue;
      if (pos <= accVal.length) {
        return {
          index: bi,
          offset: pos - blockStartPos
        };
      }
    }
  }
  _blockStartPos(blockIndex) {
    return this._blocks.slice(0, blockIndex).reduce((pos, b) => pos += b.displayValue.length, 0);
  }
  _forEachBlocksInRange(fromPos, toPos, fn) {
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const fromBlockIter = this._mapPosToBlock(fromPos);
    if (fromBlockIter) {
      const toBlockIter = this._mapPosToBlock(toPos);
      // process first block
      const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
      const fromBlockStartPos = fromBlockIter.offset;
      const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
      fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
      if (toBlockIter && !isSameBlock) {
        // process intermediate blocks
        for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
          fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
        }

        // process last block
        fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
      }
    }
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const removeDetails = super.remove(fromPos, toPos);
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      removeDetails.aggregate(b.remove(bFromPos, bToPos));
    });
    return removeDetails;
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    if (!this._blocks.length) return 0;
    const cursor = new PatternCursor(this, cursorPos);
    if (direction === DIRECTION.NONE) {
      // -------------------------------------------------
      // NONE should only go out from fixed to the right!
      // -------------------------------------------------
      if (cursor.pushRightBeforeInput()) return cursor.pos;
      cursor.popState();
      if (cursor.pushLeftBeforeInput()) return cursor.pos;
      return this.displayValue.length;
    }

    // FORCE is only about a|* otherwise is 0
    if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
      // try to break fast when *|a
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeFilled();
        if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
        cursor.popState();
      }

      // forward flow
      cursor.pushLeftBeforeInput();
      cursor.pushLeftBeforeRequired();
      cursor.pushLeftBeforeFilled();

      // backward flow
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
        cursor.popState();
        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
        cursor.popState();
      }
      if (cursor.ok) return cursor.pos;
      if (direction === DIRECTION.FORCE_LEFT) return 0;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      return 0;
    }
    if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
      // forward flow
      cursor.pushRightBeforeInput();
      cursor.pushRightBeforeRequired();
      if (cursor.pushRightBeforeFilled()) return cursor.pos;
      if (direction === DIRECTION.FORCE_RIGHT) return this.displayValue.length;

      // backward flow
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
    }
    return cursorPos;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    let total = 0;
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      total += b.totalInputPositions(bFromPos, bToPos);
    });
    return total;
  }

  /** Get block by name */
  maskedBlock(name) {
    return this.maskedBlocks(name)[0];
  }

  /** Get all blocks by name */
  maskedBlocks(name) {
    const indices = this._maskedBlocks[name];
    if (!indices) return [];
    return indices.map(gi => this._blocks[gi]);
  }
  pad(flags) {
    const details = new ChangeDetails();
    this._forEachBlocksInRange(0, this.displayValue.length, b => details.aggregate(b.pad(flags)));
    return details;
  }
}
MaskedPattern.DEFAULTS = {
  ...Masked.DEFAULTS,
  lazy: true,
  placeholderChar: '_'
};
MaskedPattern.STOP_CHAR = '`';
MaskedPattern.ESCAPE_CHAR = '\\';
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;

/** Pattern which accepts ranges */
class MaskedRange extends MaskedPattern {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */

  /** Min bound */

  /** Max bound */

  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(opts) {
    super(opts); // mask will be created in _update
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      to = this.to || 0,
      from = this.from || 0,
      maxLength = this.maxLength || 0,
      autofix = this.autofix,
      ...patternOpts
    } = opts;
    this.to = to;
    this.from = from;
    this.maxLength = Math.max(String(to).length, maxLength);
    this.autofix = autofix;
    const fromStr = String(this.from).padStart(this.maxLength, '0');
    const toStr = String(this.to).padStart(this.maxLength, '0');
    let sameCharsCount = 0;
    while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
    patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
    super._update(patternOpts);
  }
  get isComplete() {
    return super.isComplete && Boolean(this.value);
  }
  boundaries(str) {
    let minstr = '';
    let maxstr = '';
    const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
    if (num) {
      minstr = '0'.repeat(placeholder.length) + num;
      maxstr = '9'.repeat(placeholder.length) + num;
    }
    minstr = minstr.padEnd(this.maxLength, '0');
    maxstr = maxstr.padEnd(this.maxLength, '9');
    return [minstr, maxstr];
  }
  doPrepareChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    let details;
    [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ''), flags);
    if (!ch) details.skip = !this.isComplete;
    return [ch, details];
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
    const fromStr = String(this.from).padStart(this.maxLength, '0');
    const toStr = String(this.to).padStart(this.maxLength, '0');
    const [minstr, maxstr] = this.boundaries(this.value + ch);
    if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
    if (Number(minstr) > this.to) {
      if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) {
        return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
      }
      return super._appendCharRaw(toStr[this.value.length], flags);
    }
    return super._appendCharRaw(ch, flags);
  }
  doValidate(flags) {
    const str = this.value;
    const firstNonZero = str.search(/[^0]/);
    if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
    const [minstr, maxstr] = this.boundaries(str);
    return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
  }
  pad(flags) {
    const details = new ChangeDetails();
    if (this.value.length === this.maxLength) return details;
    const value = this.value;
    const padLength = this.maxLength - this.value.length;
    if (padLength) {
      this.reset();
      for (let i = 0; i < padLength; ++i) {
        details.aggregate(super._appendCharRaw('0', flags));
      }

      // append tail
      value.split('').forEach(ch => this._appendCharRaw(ch));
    }
    return details;
  }
}
IMask.MaskedRange = MaskedRange;

const DefaultPattern = 'd{.}`m{.}`Y';

// Make format and parse required when pattern is provided

/** Date mask */
class MaskedDate extends MaskedPattern {
  static extractPatternOptions(opts) {
    const {
      mask,
      pattern,
      ...patternOpts
    } = opts;
    return {
      ...patternOpts,
      mask: isString(mask) ? mask : pattern
    };
  }

  /** Pattern mask for date according to {@link MaskedDate#format} */

  /** Start date */

  /** End date */

  /** Format typed value to string */

  /** Parse string to get typed value */

  constructor(opts) {
    super(MaskedDate.extractPatternOptions({
      ...MaskedDate.DEFAULTS,
      ...opts
    }));
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      mask,
      pattern,
      blocks,
      ...patternOpts
    } = {
      ...MaskedDate.DEFAULTS,
      ...opts
    };
    const patternBlocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
    // adjust year block
    if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
    if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
    if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
      patternBlocks.m.from = opts.min.getMonth() + 1;
      patternBlocks.m.to = opts.max.getMonth() + 1;
      if (patternBlocks.m.from === patternBlocks.m.to) {
        patternBlocks.d.from = opts.min.getDate();
        patternBlocks.d.to = opts.max.getDate();
      }
    }
    Object.assign(patternBlocks, this.blocks, blocks);
    super._update({
      ...patternOpts,
      mask: isString(mask) ? mask : pattern,
      blocks: patternBlocks
    });
  }
  doValidate(flags) {
    const date = this.date;
    return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
  }

  /** Checks if date is exists */
  isDateExist(str) {
    return this.format(this.parse(str, this), this).indexOf(str) >= 0;
  }

  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(date) {
    this.typedValue = date;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(value) {
    super.typedValue = value;
  }
  maskEquals(mask) {
    return mask === Date || super.maskEquals(mask);
  }
  optionsIsChanged(opts) {
    return super.optionsIsChanged(MaskedDate.extractPatternOptions(opts));
  }
}
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: MaskedRange,
    from: 1900,
    to: 9999
  }
});
MaskedDate.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  mask: Date,
  pattern: DefaultPattern,
  format: (date, masked) => {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return [day, month, year].join('.');
  },
  parse: (str, masked) => {
    const [day, month, year] = str.split('.').map(Number);
    return new Date(year, month - 1, day);
  }
};
IMask.MaskedDate = MaskedDate;

/** Dynamic mask for choosing appropriate mask in run-time */
class MaskedDynamic extends Masked {
  constructor(opts) {
    super({
      ...MaskedDynamic.DEFAULTS,
      ...opts
    });
    this.currentMask = undefined;
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update(opts);
    if ('mask' in opts) {
      this.exposeMask = undefined;
      // mask could be totally dynamic with only `dispatch` option
      this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(m => {
        const {
          expose,
          ...maskOpts
        } = normalizeOpts(m);
        const masked = createMask({
          overwrite: this._overwrite,
          eager: this._eager,
          skipInvalid: this._skipInvalid,
          ...maskOpts
        });
        if (expose) this.exposeMask = masked;
        return masked;
      }) : [];

      // this.currentMask = this.doDispatch(''); // probably not needed but lets see
    }
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const details = this._applyDispatch(ch, flags);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
    }
    return details;
  }
  _applyDispatch(appended, flags, tail) {
    if (appended === void 0) {
      appended = '';
    }
    if (flags === void 0) {
      flags = {};
    }
    if (tail === void 0) {
      tail = '';
    }
    const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
    const inputValue = this.rawInputValue;
    const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
    const tailValue = inputValue.slice(insertValue.length);
    const prevMask = this.currentMask;
    const details = new ChangeDetails();
    const prevMaskState = prevMask == null ? void 0 : prevMask.state;

    // clone flags to prevent overwriting `_beforeTailState`
    this.currentMask = this.doDispatch(appended, {
      ...flags
    }, tail);

    // restore state after dispatch
    if (this.currentMask) {
      if (this.currentMask !== prevMask) {
        // if mask changed reapply input
        this.currentMask.reset();
        if (insertValue) {
          this.currentMask.append(insertValue, {
            raw: true
          });
          details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
        }
        if (tailValue) {
          details.tailShift += this.currentMask.append(tailValue, {
            raw: true,
            tail: true
          }).tailShift;
        }
      } else if (prevMaskState) {
        // Dispatch can do something bad with state, so
        // restore prev mask state
        this.currentMask.state = prevMaskState;
      }
    }
    return details;
  }
  _appendPlaceholder() {
    const details = this._applyDispatch();
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendPlaceholder());
    }
    return details;
  }
  _appendEager() {
    const details = this._applyDispatch();
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendEager());
    }
    return details;
  }
  appendTail(tail) {
    const details = new ChangeDetails();
    if (tail) details.aggregate(this._applyDispatch('', {}, tail));
    return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
  }
  currentMaskFlags(flags) {
    var _flags$_beforeTailSta, _flags$_beforeTailSta2;
    return {
      ...flags,
      _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
    };
  }
  doDispatch(appended, flags, tail) {
    if (flags === void 0) {
      flags = {};
    }
    if (tail === void 0) {
      tail = '';
    }
    return this.dispatch(appended, this, flags, tail);
  }
  doValidate(flags) {
    return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
  }
  doPrepare(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    let [s, details] = super.doPrepare(str, flags);
    if (this.currentMask) {
      let currentDetails;
      [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
      details = details.aggregate(currentDetails);
    }
    return [s, details];
  }
  doPrepareChar(str, flags) {
    if (flags === void 0) {
      flags = {};
    }
    let [s, details] = super.doPrepareChar(str, flags);
    if (this.currentMask) {
      let currentDetails;
      [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
      details = details.aggregate(currentDetails);
    }
    return [s, details];
  }
  reset() {
    var _this$currentMask;
    (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
    this.compiledMasks.forEach(m => m.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : '';
  }
  set value(value) {
    if (this.exposeMask) {
      this.exposeMask.value = value;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
    } else super.value = value;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : '';
  }
  set unmaskedValue(unmaskedValue) {
    if (this.exposeMask) {
      this.exposeMask.unmaskedValue = unmaskedValue;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
    } else super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : '';
  }
  set typedValue(typedValue) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = typedValue;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
      return;
    }
    let unmaskedValue = String(typedValue);

    // double check it
    if (this.currentMask) {
      this.currentMask.typedValue = typedValue;
      unmaskedValue = this.currentMask.unmaskedValue;
    }
    this.unmaskedValue = unmaskedValue;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : '';
  }
  get isComplete() {
    var _this$currentMask2;
    return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
  }
  get isFilled() {
    var _this$currentMask3;
    return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
  }
  remove(fromPos, toPos) {
    const details = new ChangeDetails();
    if (this.currentMask) {
      details.aggregate(this.currentMask.remove(fromPos, toPos))
      // update with dispatch
      .aggregate(this._applyDispatch());
    }
    return details;
  }
  get state() {
    var _this$currentMask4;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map(m => m.state),
      currentMaskRef: this.currentMask,
      currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
    };
  }
  set state(state) {
    const {
      compiledMasks,
      currentMaskRef,
      currentMask,
      ...maskedState
    } = state;
    if (compiledMasks) this.compiledMasks.forEach((m, mi) => m.state = compiledMasks[mi]);
    if (currentMaskRef != null) {
      this.currentMask = currentMaskRef;
      this.currentMask.state = currentMask;
    }
    super.state = maskedState;
  }
  extractInput(fromPos, toPos, flags) {
    return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
  }
  extractTail(fromPos, toPos) {
    return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
  }
  doCommit() {
    if (this.currentMask) this.currentMask.doCommit();
    super.doCommit();
  }
  nearestInputPos(cursorPos, direction) {
    return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(overwrite) {
    this._overwrite = overwrite;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(eager) {
    this._eager = eager;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(skipInvalid) {
    this._skipInvalid = skipInvalid;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(autofix) {
    this._autofix = autofix;
  }
  maskEquals(mask) {
    return Array.isArray(mask) ? this.compiledMasks.every((m, mi) => {
      if (!mask[mi]) return;
      const {
        mask: oldMask,
        ...restOpts
      } = mask[mi];
      return objectIncludes(m, restOpts) && m.maskEquals(oldMask);
    }) : super.maskEquals(mask);
  }
  typedValueEquals(value) {
    var _this$currentMask5;
    return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
  }
}
/** Currently chosen mask */
/** Currently chosen mask */
/** Compliled {@link Masked} options */
/** Chooses {@link Masked} depending on input value */
MaskedDynamic.DEFAULTS = {
  ...Masked.DEFAULTS,
  dispatch: (appended, masked, flags, tail) => {
    if (!masked.compiledMasks.length) return;
    const inputValue = masked.rawInputValue;

    // simulate input
    const inputs = masked.compiledMasks.map((m, index) => {
      const isCurrent = masked.currentMask === m;
      const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, DIRECTION.FORCE_LEFT);
      if (m.rawInputValue !== inputValue) {
        m.reset();
        m.append(inputValue, {
          raw: true
        });
      } else if (!isCurrent) {
        m.remove(startInputPos);
      }
      m.append(appended, masked.currentMaskFlags(flags));
      m.appendTail(tail);
      return {
        index,
        weight: m.rawInputValue.length,
        totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, DIRECTION.FORCE_LEFT)))
      };
    });

    // pop masks with longer values first
    inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;

/** Pattern which validates enum values */
class MaskedEnum extends MaskedPattern {
  constructor(opts) {
    super({
      ...MaskedEnum.DEFAULTS,
      ...opts
    }); // mask will be created in _update
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      enum: enum_,
      ...eopts
    } = opts;
    if (enum_) {
      const lengths = enum_.map(e => e.length);
      const requiredLength = Math.min(...lengths);
      const optionalLength = Math.max(...lengths) - requiredLength;
      eopts.mask = '*'.repeat(requiredLength);
      if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
      this.enum = enum_;
    }
    super._update(eopts);
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const matchFrom = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    const matches = this.enum.filter(e => this.matchValue(e, this.unmaskedValue + ch, matchFrom));
    if (matches.length) {
      if (matches.length === 1) {
        this._forEachBlocksInRange(0, this.value.length, (b, bi) => {
          const mch = matches[0][bi];
          if (bi >= this.value.length || mch === b.value) return;
          b.reset();
          b._appendChar(mch, flags);
        });
      }
      const d = super._appendCharRaw(matches[0][this.value.length], flags);
      if (matches.length === 1) {
        matches[0].slice(this.unmaskedValue.length).split('').forEach(mch => d.aggregate(super._appendCharRaw(mch)));
      }
      return d;
    }
    return new ChangeDetails({
      skip: !this.isComplete
    });
  }
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    // just drop tail
    return new ContinuousTailDetails('', fromPos);
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    if (fromPos === toPos) return new ChangeDetails();
    const matchFrom = Math.min(super.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    let pos;
    for (pos = fromPos; pos >= 0; --pos) {
      const matches = this.enum.filter(e => this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
      if (matches.length > 1) break;
    }
    const details = super.remove(pos, toPos);
    details.tailShift += pos - fromPos;
    return details;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
/** Match enum value */
MaskedEnum.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  matchValue: (estr, istr, matchFrom) => estr.indexOf(istr, matchFrom) === matchFrom
};
IMask.MaskedEnum = MaskedEnum;

/** Masking by custom Function */
class MaskedFunction extends Masked {
  /** */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update({
      ...opts,
      validate: opts.mask
    });
  }
}
IMask.MaskedFunction = MaskedFunction;

var _MaskedNumber;
/** Number mask */
class MaskedNumber extends Masked {
  /** Single char */

  /** Single char */

  /** Array of single chars */

  /** */

  /** */

  /** Digits after point */

  /** Flag to remove leading and trailing zeros in the end of editing */

  /** Flag to pad trailing zeros after point in the end of editing */

  /** Enable characters overwriting */

  /** */

  /** */

  /** */

  /** Format typed value to string */

  /** Parse string to get typed value */

  constructor(opts) {
    super({
      ...MaskedNumber.DEFAULTS,
      ...opts
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update(opts);
    this._updateRegExps();
  }
  _updateRegExps() {
    const start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
    const mid = '\\d*';
    const end = (this.scale ? "(" + escapeRegExp(this.radix) + "\\d{0," + this.scale + "})?" : '') + '$';
    this._numberRegExp = new RegExp(start + mid + end);
    this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(escapeRegExp).join('') + "]", 'g');
    this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
  }
  _removeThousandsSeparators(value) {
    return value.replace(this._thousandsSeparatorRegExp, '');
  }
  _insertThousandsSeparators(value) {
    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    const parts = value.split(this.radix);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    return parts.join(this.radix);
  }
  doPrepareChar(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (
    /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
    if (ch && !prepCh) details.skip = true;
    if (prepCh && !this.allowPositive && !this.value && prepCh !== '-') details.aggregate(this._appendChar('-'));
    return [prepCh, details];
  }
  _separatorsCount(to, extendOnSeparators) {
    if (extendOnSeparators === void 0) {
      extendOnSeparators = false;
    }
    let count = 0;
    for (let pos = 0; pos < to; ++pos) {
      if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
        ++count;
        if (extendOnSeparators) to += this.thousandsSeparator.length;
      }
    }
    return count;
  }
  _separatorsCountFromSlice(slice) {
    if (slice === void 0) {
      slice = this._value;
    }
    return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
  }
  extractInput(fromPos, toPos, flags) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
    this._value = this._removeThousandsSeparators(this.value);
    const oldValue = this._value;
    this._value += ch;
    const num = this.number;
    let accepted = !isNaN(num);
    let skip = false;
    if (accepted) {
      let fixedNum;
      if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
      if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
      if (fixedNum != null) {
        if (this.autofix) {
          this._value = this.format(fixedNum, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
          skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
        } else {
          accepted = false;
        }
      }
      accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
    }
    let appendDetails;
    if (!accepted) {
      this._value = oldValue;
      appendDetails = new ChangeDetails();
    } else {
      appendDetails = new ChangeDetails({
        inserted: this._value.slice(oldValue.length),
        rawInserted: skip ? '' : ch,
        skip
      });
    }
    this._value = this._insertThousandsSeparators(this._value);
    const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
    appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
    return appendDetails;
  }
  _findSeparatorAround(pos) {
    if (this.thousandsSeparator) {
      const searchFrom = pos - this.thousandsSeparator.length + 1;
      const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
      if (separatorPos <= pos) return separatorPos;
    }
    return -1;
  }
  _adjustRangeWithSeparators(from, to) {
    const separatorAroundFromPos = this._findSeparatorAround(from);
    if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
    const separatorAroundToPos = this._findSeparatorAround(to);
    if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
    return [from, to];
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    const valueBeforePos = this.value.slice(0, fromPos);
    const valueAfterPos = this.value.slice(toPos);
    const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
    return new ChangeDetails({
      tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(cursorPos, direction) {
    if (!this.thousandsSeparator) return cursorPos;
    switch (direction) {
      case DIRECTION.NONE:
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        {
          const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
          if (separatorAtLeftPos >= 0) {
            const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
            if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
              return separatorAtLeftPos;
            }
          }
          break;
        }
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        {
          const separatorAtRightPos = this._findSeparatorAround(cursorPos);
          if (separatorAtRightPos >= 0) {
            return separatorAtRightPos + this.thousandsSeparator.length;
          }
        }
    }
    return cursorPos;
  }
  doCommit() {
    if (this.value) {
      const number = this.number;
      let validnum = number;

      // check bounds
      if (this.min != null) validnum = Math.max(validnum, this.min);
      if (this.max != null) validnum = Math.min(validnum, this.max);
      if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
      let formatted = this.value;
      if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
      if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
      this._value = formatted;
    }
    super.doCommit();
  }
  _normalizeZeros(value) {
    const parts = this._removeThousandsSeparators(value).split(this.radix);

    // remove leading zeros
    parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num) => sign + num);
    // add leading zero
    if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
    if (parts.length > 1) {
      parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
      if (!parts[1].length) parts.length = 1; // remove fractional
    }
    return this._insertThousandsSeparators(parts.join(this.radix));
  }
  _padFractionalZeros(value) {
    if (!value) return value;
    const parts = value.split(this.radix);
    if (parts.length < 2) parts.push('');
    parts[1] = parts[1].padEnd(this.scale, '0');
    return parts.join(this.radix);
  }
  doSkipInvalid(ch, flags, checkTail) {
    if (flags === void 0) {
      flags = {};
    }
    const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
    return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(n) {
    this.rawInputValue = this.format(n, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
  }

  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(number) {
    this.typedValue = number;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(value) {
    // handle  0 -> '' case (typed = 0 even if value = '')
    // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
    return (super.typedValueEquals(value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
  }
}
_MaskedNumber = MaskedNumber;
MaskedNumber.UNMASKED_RADIX = '.';
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
MaskedNumber.DEFAULTS = {
  ...Masked.DEFAULTS,
  mask: Number,
  radix: ',',
  thousandsSeparator: '',
  mapToRadix: [_MaskedNumber.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: true,
  padFractionalZeros: false,
  parse: Number,
  format: n => n.toLocaleString('en-US', {
    useGrouping: false,
    maximumFractionDigits: 20
  })
};
IMask.MaskedNumber = MaskedNumber;

/** Mask pipe source and destination types */
const PIPE_TYPE = {
  MASKED: 'value',
  UNMASKED: 'unmaskedValue',
  TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */
function createPipe(arg, from, to) {
  if (from === void 0) {
    from = PIPE_TYPE.MASKED;
  }
  if (to === void 0) {
    to = PIPE_TYPE.MASKED;
  }
  const masked = createMask(arg);
  return value => masked.runIsolated(m => {
    m[from] = value;
    return m[to];
  });
}

/** Pipes value through mask depending on mask type, source and destination options */
function pipe(value, mask, from, to) {
  return createPipe(mask, from, to)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;

/** Pattern mask */
class RepeatBlock extends MaskedPattern {
  get repeatFrom() {
    var _ref;
    return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
  }
  get repeatTo() {
    var _ref2;
    return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
  }
  constructor(opts) {
    super(opts);
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    var _ref3, _ref4, _this$_blocks;
    const {
      repeat,
      ...blockOpts
    } = normalizeOpts(opts); // TODO type
    this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
    const block = createMask(this._blockOpts);
    this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type

    super._update({
      mask: 'm'.repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
      blocks: {
        m: block
      },
      eager: block.eager,
      overwrite: block.overwrite,
      skipInvalid: block.skipInvalid,
      lazy: block.lazy,
      placeholderChar: block.placeholderChar,
      displayChar: block.displayChar
    });
  }
  _allocateBlock(bi) {
    if (bi < this._blocks.length) return this._blocks[bi];
    if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
      this._blocks.push(createMask(this._blockOpts));
      this.mask += 'm';
      return this._blocks[this._blocks.length - 1];
    }
  }
  _appendCharRaw(ch, flags) {
    if (flags === void 0) {
      flags = {};
    }
    const details = new ChangeDetails();
    for (let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated;
    // try to get a block or
    // try to allocate a new block if not allocated already
    block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi) {
      var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
      const blockDetails = block._appendChar(ch, {
        ...flags,
        _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
      });
      if (blockDetails.skip && allocated) {
        // remove the last allocated block and break
        this._blocks.pop();
        this.mask = this.mask.slice(1);
        break;
      }
      details.aggregate(blockDetails);
      if (blockDetails.consumed) break; // go next char
    }
    return details;
  }
  _trimEmptyTail(fromPos, toPos) {
    var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
    if (fromPos === void 0) {
      fromPos = 0;
    }
    const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
    let lastBlockIndex;
    if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
    if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
    let removeCount = 0;
    for (let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount) {
      if (this._blocks[blockIndex].unmaskedValue) break;
    }
    if (removeCount) {
      this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
      this.mask = this.mask.slice(removeCount);
    }
  }
  reset() {
    super.reset();
    this._trimEmptyTail();
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const removeDetails = super.remove(fromPos, toPos);
    this._trimEmptyTail(fromPos, toPos);
    return removeDetails;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos == null && this.repeatTo === Infinity) return Infinity;
    return super.totalInputPositions(fromPos, toPos);
  }
  get state() {
    return super.state;
  }
  set state(state) {
    this._blocks.length = state._blocks.length;
    this.mask = this.mask.slice(0, this._blocks.length);
    super.state = state;
  }
}
IMask.RepeatBlock = RepeatBlock;

try {
  globalThis.IMask = IMask;
} catch {}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

const MASK_PROPS = {
  // common
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.string, PropTypes.instanceOf(RegExp), PropTypes.oneOf([Date, Number, IMask.Masked]), PropTypes.instanceOf(IMask.Masked)]),
  value: PropTypes.any,
  unmask: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['typed'])]),
  prepare: PropTypes.func,
  prepareChar: PropTypes.func,
  validate: PropTypes.func,
  commit: PropTypes.func,
  overwrite: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['shift'])]),
  eager: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['append', 'remove'])]),
  skipInvalid: PropTypes.bool,
  // events
  onAccept: PropTypes.func,
  onComplete: PropTypes.func,
  // pattern
  placeholderChar: PropTypes.string,
  displayChar: PropTypes.string,
  lazy: PropTypes.bool,
  definitions: PropTypes.object,
  blocks: PropTypes.object,
  // enum
  enum: PropTypes.arrayOf(PropTypes.string),
  // range
  maxLength: PropTypes.number,
  from: PropTypes.number,
  to: PropTypes.number,
  // date
  pattern: PropTypes.string,
  format: PropTypes.func,
  parse: PropTypes.func,
  autofix: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['pad'])]),
  // number
  radix: PropTypes.string,
  thousandsSeparator: PropTypes.string,
  mapToRadix: PropTypes.arrayOf(PropTypes.string),
  scale: PropTypes.number,
  normalizeZeros: PropTypes.bool,
  padFractionalZeros: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  // dynamic
  dispatch: PropTypes.func,
  // ref
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })])
};
const MASK_PROPS_NAMES = Object.keys(MASK_PROPS).filter(p => p !== 'value');
const NON_MASK_OPTIONS_NAMES = ['value', 'unmask', 'onAccept', 'onComplete', 'inputRef'];
const MASK_OPTIONS_NAMES = MASK_PROPS_NAMES.filter(pName => NON_MASK_OPTIONS_NAMES.indexOf(pName) < 0);
function IMaskMixin(ComposedComponent) {
  var _Class;
  const MaskedComponent = (_Class = class MaskedComponent extends React__default.Component {
    constructor(props) {
      super(props);
      this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      if (!this.props.mask) return;
      this.initMask();
    }
    componentDidUpdate() {
      const props = this.props;
      const maskOptions = this._extractMaskOptionsFromProps(props);
      if (maskOptions.mask) {
        if (this.maskRef) {
          this.maskRef.updateOptions(maskOptions); // TODO fix
          if ('value' in props && props.value !== undefined) this.maskValue = props.value;
        } else {
          this.initMask(maskOptions);
        }
      } else {
        this.destroyMask();
        if ('value' in props && props.value !== undefined) {
          var _this$element;
          if ((_this$element = this.element) != null && _this$element.isContentEditable && this.element.tagName !== 'INPUT' && this.element.tagName !== 'TEXTAREA') this.element.textContent = props.value;else this.element.value = props.value;
        }
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(el) {
      this.element = el;
      if (this.props.inputRef) {
        if (Object.prototype.hasOwnProperty.call(this.props.inputRef, 'current')) this.props.inputRef.current = el;else this.props.inputRef(el);
      }
    }
    initMask(maskOptions) {
      if (maskOptions === void 0) {
        maskOptions = this._extractMaskOptionsFromProps(this.props);
      }
      this.maskRef = IMask(this.element, maskOptions).on('accept', this._onAccept.bind(this)).on('complete', this._onComplete.bind(this));
      if ('value' in this.props && this.props.value !== undefined) this.maskValue = this.props.value;
    }
    destroyMask() {
      if (this.maskRef) {
        this.maskRef.destroy();
        delete this.maskRef;
      }
    }
    _extractMaskOptionsFromProps(props) {
      const {
        ...cloneProps
      } = props;

      // keep only mask options
      Object.keys(cloneProps).filter(prop => MASK_OPTIONS_NAMES.indexOf(prop) < 0).forEach(nonMaskProp => {
        delete cloneProps[nonMaskProp];
      });
      return cloneProps;
    }
    _extractNonMaskProps(props) {
      const {
        ...cloneProps
      } = props;
      MASK_PROPS_NAMES.forEach(maskProp => {
        if (maskProp !== 'maxLength') delete cloneProps[maskProp];
      });
      if (!('defaultValue' in cloneProps)) cloneProps.defaultValue = props.mask ? '' : cloneProps.value;
      delete cloneProps.value;
      return cloneProps;
    }
    get maskValue() {
      if (!this.maskRef) return '';
      if (this.props.unmask === 'typed') return this.maskRef.typedValue;
      if (this.props.unmask) return this.maskRef.unmaskedValue;
      return this.maskRef.value;
    }
    set maskValue(value) {
      if (!this.maskRef) return;
      value = value == null && this.props.unmask !== 'typed' ? '' : value;
      if (this.props.unmask === 'typed') this.maskRef.typedValue = value;else if (this.props.unmask) this.maskRef.unmaskedValue = value;else this.maskRef.value = value;
    }
    _onAccept(e) {
      if (this.props.onAccept && this.maskRef) this.props.onAccept(this.maskValue, this.maskRef, e);
    }
    _onComplete(e) {
      if (this.props.onComplete && this.maskRef) this.props.onComplete(this.maskValue, this.maskRef, e);
    }
    render() {
      return React__default.createElement(ComposedComponent, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, _Class.displayName = void 0, _Class.propTypes = void 0, _Class);
  const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
  MaskedComponent.displayName = "IMask(" + nestedComponentName + ")";
  MaskedComponent.propTypes = MASK_PROPS;
  return React__default.forwardRef((props, ref) => React__default.createElement(MaskedComponent, {
    ...props,
    ref
  }));
}

const IMaskInputClass = IMaskMixin(_ref => {
  let {
    inputRef,
    ...props
  } = _ref;
  return React__default.createElement('input', {
    ...props,
    ref: inputRef
  });
});
const IMaskInputFn = (props, ref) => React__default.createElement(IMaskInputClass, {
  ...props,
  ref
}) // TODO fix no idea
;
const IMaskInput = React__default.forwardRef(IMaskInputFn);

var idSequence$6 = idGenerator();
var BaSeDatePicker = function (_a) {
    var externalId = _a.id, name = _a.name, dataset = _a.dataset, startDate = _a.startDate, endDate = _a.endDate, closeOnScroll = _a.closeOnScroll, multipleMonths = _a.multipleMonths, selectRange = _a.selectRange, color = _a.color, inputStatus = _a.inputStatus, size = _a.size, isDisabled = _a.isDisabled, maxDate = _a.maxDate, minDate = _a.minDate, placeholder = _a.placeholder, label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, moreInfoLabel = _a.moreInfoLabel, moreInfoDetails = _a.moreInfoDetails, complement = _a.complement, _b = _a.calendarType, calendarType = _b === void 0 ? 'days' : _b, _c = _a.alwaysIsOpen, alwaysIsOpen = _c === void 0 ? false : _c, onFocus = _a.onFocus, onBlur = _a.onBlur, onSelect = _a.onSelect, onCalendarOpen = _a.onCalendarOpen, onCalendarClose = _a.onCalendarClose, onStartDateChange = _a.onStartDateChange, onEndDateChange = _a.onEndDateChange;
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence$6);
    var _d = React.useState(''), inputDate = _d[0], setInputDate = _d[1];
    var _e = React.useState(false), reg = _e[0], setReg = _e[1];
    var _f = React.useContext(BaSeI18nContext), locale = _f.locale, registerDateLocale = _f.registerDateLocale;
    var _g = React.useState(), labelHeight = _g[0], setLabelHeight = _g[1];
    var _h = React.useState(false), hasFocus = _h[0], setHasFocus = _h[1];
    var datePickerRef = React.useRef(null);
    var formattedDataset = getFormattedDataset(dataset);
    var hasComplement = React.useMemo(function () { return complement !== ''; }, [complement]);
    var getColors = React.useCallback(function () {
        return DatePickerColorManager(color, inputStatus);
    }, [color, inputStatus]);
    var handleCalendarClose = React.useCallback(function () {
        onCalendarClose === null || onCalendarClose === void 0 ? void 0 : onCalendarClose();
        setHasFocus(false);
    }, [onCalendarClose]);
    var handleSelection = React.useCallback(function (e) {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(e);
        setHasFocus(false);
    }, [onSelect]);
    var handleFocus = React.useCallback(function (e) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setHasFocus(true);
    }, [onFocus]);
    var handleBlur = React.useCallback(function (e) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        setHasFocus(false);
    }, [onBlur]);
    var handleChange = React.useCallback(function (dates) {
        if (Array.isArray(dates)) {
            var _a = dates, start = _a[0], end = _a[1];
            onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(start);
            onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(end);
            return;
        }
        onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(dates);
    }, [onEndDateChange, onStartDateChange]);
    var showSelected = React.useCallback(function () { return (multipleMonths ? endDate !== null && endDate !== void 0 ? endDate : startDate : startDate); }, [multipleMonths, startDate, endDate]);
    var showHighlightedDates = React.useCallback(function () {
        if (!selectRange) {
            return [{ 'unique-date': [startDate !== null && startDate !== void 0 ? startDate : new Date()] }];
        }
        var datesToHighlight = [];
        if (endDate) {
            datesToHighlight.push({ endDate: [endDate] });
        }
        datesToHighlight.push({ startDate: [startDate !== null && startDate !== void 0 ? startDate : new Date()] });
        return datesToHighlight;
    }, [selectRange, startDate, endDate]);
    var compareStarEndDates = React.useCallback(function () {
        if (!(!!startDate && !!endDate)) {
            return false;
        }
        if (calendarType === 'months') {
            return isSameMonth(startDate, endDate);
        }
        return isEqual(startDate, endDate);
    }, [startDate, endDate]);
    var getMaskSize = React.useCallback(function () { return MaskDatePickerSize(size); }, [size]);
    var getValidStatus = React.useCallback(function () {
        var inputStatusTypes = {
            normal: 'normal',
            valid: 'valid',
            invalid: 'invalid',
        };
        return isDisabled
            ? 'disabled'
            : !inputStatus || !(inputStatus in inputStatusTypes)
                ? 'normal'
                : inputStatusTypes[inputStatus];
    }, [inputStatus, isDisabled]);
    var hasInfoLabel = React.useCallback(function () { return !!label || !!subLabel || !!showHelpButton; }, [label, subLabel, showHelpButton]);
    var getIconTopCoordinates = React.useCallback(function () {
        var _a;
        var parentHeight;
        if (labelHeight) {
            parentHeight = labelHeight;
        }
        var sizes = {
            small: 23,
            default: 24.4,
        };
        var aditionalSize = hasInfoLabel()
            ? (_a = sizes[size !== null && size !== void 0 ? size : 'default']) !== null && _a !== void 0 ? _a : sizes.default
            : 0;
        if (parentHeight) {
            return parentHeight + (size === 'small' ? 8 : 12);
        }
        return aditionalSize + (size === 'small' ? 8 : 12);
    }, [size, labelHeight]);
    var getSize = React.useCallback(function () { return (size === 'big' ? 24 : 16); }, [size]);
    var getIconColor = React.useCallback(function () {
        var _a;
        return (_a = inputColorManager(color)[getValidStatus()]) === null || _a === void 0 ? void 0 : _a[hasFocus ? 'focusTextColor' : 'color'];
    }, [hasFocus, color]);
    var getIconName = React.useCallback(function () {
        var _a;
        var toErase = selectRange && startDate && endDate;
        var iconsNameMap = {
            valid: 'check',
            invalid: 'exclamation-circle-solid',
            default: 'calendar-alt',
            erase: 'trash-alt',
        };
        return toErase
            ? 'trash-alt'
            : (_a = iconsNameMap[inputStatus !== null && inputStatus !== void 0 ? inputStatus : 'default']) !== null && _a !== void 0 ? _a : iconsNameMap.default;
    }, [inputStatus, selectRange, startDate, endDate]);
    var getCalendarType = React.useCallback(function () {
        var _a;
        var attrTypeCalendar = [
            {
                attr: 'showMonthYearPicker',
                value: calendarType === 'months',
            },
        ]
            .filter(function (ele) { return ele.value; })
            .map(function (ele) {
            var _a;
            return (_a = {}, _a[ele.attr] = true, _a);
        });
        return (_a = attrTypeCalendar[0]) !== null && _a !== void 0 ? _a : {};
    }, [calendarType]);
    var getCustomInputMask = React.useCallback(function () {
        if (calendarType === 'months') {
            return '00/0000';
        }
        return '00/00/0000';
    }, [calendarType]);
    var handleFocusIcon = React.useCallback(function () {
        var _a, _b, _c;
        if (selectRange && startDate && endDate) {
            onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(null);
            onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(null);
            return;
        }
        (_c = (_b = (_a = datePickerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
    }, [selectRange, startDate, endDate]);
    var handleIcon = React.useCallback(function () {
        return (React.createElement("div", { onClick: handleFocusIcon },
            React.createElement(BaSeIcon, { size: getSize(), name: getIconName(), description: "BaSe--date-picker-icon", color: getIconColor() })));
    }, [getSize, getIconName, getIconColor, handleFocusIcon]);
    var renderCustomInput = React.useCallback(function () {
        return selectRange ? (React.createElement(BaSeInput, { dataset: dataset, size: size, isReadOnly: true, value: inputDate })) : (React.createElement(IMaskInput, __assign({ mask: getCustomInputMask() }, formattedDataset)));
    }, [selectRange, size, getCustomInputMask, inputDate]);
    var handleRawChange = React.useCallback(function (rawEvent) {
        var _a;
        if (!selectRange && rawEvent.currentTarget.value) {
            var nullDate = ((_a = rawEvent.currentTarget.value.replace(/\D/g, '')) === null || _a === void 0 ? void 0 : _a.length) > 0;
            if (!nullDate) {
                onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(null);
                onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(null);
            }
        }
    }, [selectRange]);
    React.useEffect(function () {
        setInputDate(function () {
            var _a, _b;
            return ((_a = localDateFormate[locale]) === null || _a === void 0 ? void 0 : _a.call(localDateFormate, startDate)) +
                "".concat(endDate ? ' - ' + ((_b = localDateFormate[locale]) === null || _b === void 0 ? void 0 : _b.call(localDateFormate, endDate)) : '');
        });
        if (startDate && endDate && isAfter(startDate, endDate)) {
            onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(undefined);
        }
    }, [startDate, endDate]);
    React.useEffect(function () {
        registerDateLocale === null || registerDateLocale === void 0 ? void 0 : registerDateLocale(locale);
        var timeout = setTimeout(function () { return setReg(true); }, 0);
        return function () { return clearTimeout(timeout); };
    }, [registerDateLocale, locale]);
    return (React.createElement(DatePickerWrapper, { ref: datePickerRef, isStartDaySameEndDay: compareStarEndDates(), colorProps: getColors(), maskInputProp: __assign({ size: getMaskSize() }, inputColorManager(color)[getValidStatus()]), monthPickNotRange: calendarType === 'months' && !selectRange, alwaysIsOpen: alwaysIsOpen },
        !alwaysIsOpen && (React.createElement(DatePickerCalendarContainer, { top: getIconTopCoordinates(), width: getSize() }, handleIcon())),
        React.createElement(BaSeFormLabel, { id: id, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, getContainerHeight: function (value) { return setLabelHeight(value); } }),
        reg && (React.createElement(DatePicker, __assign({ id: id, name: name, onChangeRaw: handleRawChange, formatWeekDay: function (nameOfDay) { return nameOfDay[0]; }, onCalendarOpen: onCalendarOpen, onCalendarClose: handleCalendarClose, selected: showSelected(), onChange: handleChange, onSelect: handleSelection, locale: locale, customInput: renderCustomInput(), monthsShown: calendarType === 'days' ? +!!multipleMonths + 1 : 1, startDate: startDate, endDate: endDate, selectsRange: selectRange, highlightDates: showHighlightedDates(), dropdownMode: "select", dateFormat: localeMapFormat[locale][calendarType], wrapperClassName: "BaSe--date-picker", popperPlacement: "auto", disabled: isDisabled, maxDate: maxDate, minDate: minDate, placeholderText: placeholder, closeOnScroll: closeOnScroll, onFocus: handleFocus, onBlur: handleBlur, onInputError: function () {
                onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(null);
                onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(null);
            } }, getCalendarType(), { inline: alwaysIsOpen }))),
        hasComplement && (React.createElement(WrapperHelper$2, null,
            React.createElement(BaSeHelperText, { isItalic: true, color: BaSeTheme.colors.institucionais.cinzaSebrae60, label: complement !== null && complement !== void 0 ? complement : '' }))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$3, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
};

var LeftButton = styled.button(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-radius: 4px 0px 0px 4px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 1px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    &:before {\n      background-color: ", ";\n    }\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: ", "px 0px 0px\n      ", "px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n    &:before {\n      border-radius: ", "px 0px 0px\n        ", "px;\n      background-color: ", ";\n      box-shadow: ", ";\n      outline: none;\n    }\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-radius: 4px 0px 0px 4px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 1px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    &:before {\n      background-color: ", ";\n    }\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: ", "px 0px 0px\n      ", "px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n    &:before {\n      border-radius: ", "px 0px 0px\n        ", "px;\n      background-color: ", ";\n      box-shadow: ", ";\n      outline: none;\n    }\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (props) { return props.background; }, function (props) { return props.borderColor; }, BaSeTheme.transitions.allPropertiesContinuousFast, function (props) { return props.hoverColor; }, function (props) { return props.hoverColor; }, function (props) { return props.borderRadius; }, function (props) { return props.borderRadius; }, function (props) { return props.hoverColor; }, function (props) { return props.boxShadowFocus; }, BaSeTheme.stackOrder.belowOverlay, function (props) { return props.borderRadius; }, function (props) { return props.borderRadius; }, function (props) { return props.hoverColor; }, BaSeTheme.shadows.profundidade2);
var RightButton = styled.button(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-radius: 0px 4px 4px 0px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 0px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: 0px ", "px\n      ", "px 0px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-radius: 0px 4px 4px 0px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 0px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: 0px ", "px\n      ", "px 0px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (props) { return props.background; }, function (props) { return props.borderColor; }, BaSeTheme.transitions.allPropertiesContinuousFast, function (props) { return props.hoverColor; }, function (props) { return props.borderRadius; }, function (props) { return props.borderRadius; }, function (props) { return props.hoverColor; }, function (props) { return props.boxShadowFocus; }, BaSeTheme.stackOrder.belowOverlay);
var Container = styled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  display: flex;\n  flex-direction: 'row';\n"], ["\n  display: flex;\n  flex-direction: 'row';\n"])));
var Label$1 = styled.label(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.4em;\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  display: flex;\n  margin: 1px;\n"], ["\n  font-size: ", ";\n  line-height: 1.4em;\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  display: flex;\n  margin: 1px;\n"])), BaSeTheme.typography.fontSizeBase, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.typography.fontFamily);
var templateObject_1$r, templateObject_2$o, templateObject_3$j, templateObject_4$f;

var idSequence$5 = idGenerator();
var BaSeDualButton = function (_a) {
    var _b;
    var _c = _a.buttonType, buttonType = _c === void 0 ? 'button' : _c, _d = _a.type, type = _d === void 0 ? 'primary-default' : _d, _e = _a.hasError, hasError = _e === void 0 ? false : _e, label = _a.label, _f = _a.right, right = _f === void 0 ? {
        value: true,
        label: 'Valor da direita',
        width: 'auto',
    } : _f, _g = _a.left, left = _g === void 0 ? {
        value: false,
        label: 'Valor da esquerda',
        width: 'auto',
    } : _g, externalSelected = _a.selected, _h = _a.onChange, onChange = _h === void 0 ? function () { } : _h;
    var id = (_b = left === null || left === void 0 ? void 0 : left.id) !== null && _b !== void 0 ? _b : useNextHashId(idSequence$5);
    var _j = React.useState(), selected = _j[0], setSelected = _j[1];
    var formattedLeftDataset = getFormattedDataset(left === null || left === void 0 ? void 0 : left.dataset);
    var formattedRightDataset = getFormattedDataset(right === null || right === void 0 ? void 0 : right.dataset);
    var leftSelected = React.useMemo(function () { return selected === 'left'; }, [selected]);
    var rightSelected = React.useMemo(function () { return selected === 'right'; }, [selected]);
    var _k = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var typeSplit = type.split('-');
        var typeMapped = hasError
            ? (_b = (_a = dualButtonMapStyle[typeSplit[0]]) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : dualButtonMapStyle.primary.error
            : (_d = (_c = dualButtonMapStyle[typeSplit[0]]) === null || _c === void 0 ? void 0 : _c[typeSplit[1]]) !== null && _d !== void 0 ? _d : dualButtonMapStyle.primary.default;
        var typeMappedSelected = hasError
            ? (_f = (_e = dualButtonMapStyle[typeSplit[0]]) === null || _e === void 0 ? void 0 : _e.error) !== null && _f !== void 0 ? _f : dualButtonMapStyle.primary.error
            : (_h = (_g = dualButtonMapStyle.selected) === null || _g === void 0 ? void 0 : _g[typeSplit[1]]) !== null && _h !== void 0 ? _h : dualButtonMapStyle.selected.default;
        var colorMapped = typeMapped.color, typeStyle = __rest(typeMapped, ["color"]);
        var colorMappedSelected = typeMappedSelected.color, typeStyleSelected = __rest(typeMappedSelected, ["color"]);
        return {
            color: colorMapped,
            colorSelected: colorMappedSelected,
            leftButtonProps: leftSelected ? typeStyleSelected : typeStyle,
            rightButtonProps: rightSelected ? typeStyleSelected : typeStyle,
        };
    }, [hasError, type, leftSelected, rightSelected]), color = _k.color, colorSelected = _k.colorSelected, leftButtonProps = _k.leftButtonProps, rightButtonProps = _k.rightButtonProps;
    React.useEffect(function () { return setSelected(externalSelected); }, [externalSelected]);
    return (React.createElement("div", { className: "BaSe--dual-button" },
        label && React.createElement(Label$1, { htmlFor: id }, label),
        React.createElement(Container, null,
            React.createElement(LeftButton, __assign({ id: id, name: left === null || left === void 0 ? void 0 : left.name }, formattedLeftDataset, leftButtonProps, { type: buttonType, width: left.width, onClick: function () {
                    onChange(left.value);
                    setSelected('left');
                } }),
                React.createElement(BaSeTextButton, { color: leftSelected ? colorSelected : color, fontSize: 1, lineHeight: 1.4, hasLeftIcon: false, hasRightIcon: false, fontWeigh: "normal" }, left.label)),
            React.createElement(RightButton, __assign({ id: right === null || right === void 0 ? void 0 : right.id, name: right === null || right === void 0 ? void 0 : right.name }, formattedRightDataset, rightButtonProps, { type: buttonType, width: right.width, onClick: function () {
                    onChange(right.value);
                    setSelected('right');
                } }),
                React.createElement(BaSeTextButton, { color: rightSelected ? colorSelected : color, fontSize: 1, lineHeight: 1.4, hasLeftIcon: false, hasRightIcon: false, fontWeigh: "normal" }, right.label)))));
};
BaSeDualButton.displayName = 'BaSeDualButton';

var TAG_WIDTH_LIMIT = 300;
var institucionais = BaSeTheme.colors.institucionais;
var defaults = BaSeTheme.colors.defaultColors;
var FilePickerWrapper = styled.div.attrs({
    className: 'BaSe--file-picker-wrapper',
})(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  display: grid;\n  border: 0.125em dashed ", ";\n  background-color: ", ";\n  place-items: center;\n  border-radius: 0.25em;\n  padding: 1em;\n  gap: 0.5em;\n  width: calc(100% - 2em);\n  height: calc(100% - 2em);\n  transition: background-color ", ";\n  will-change: background-color;\n\n  & > p.BaSe--paragraph {\n    text-align: center;\n  }\n"], ["\n  display: grid;\n  border: 0.125em dashed ", ";\n  background-color: ", ";\n  place-items: center;\n  border-radius: 0.25em;\n  padding: 1em;\n  gap: 0.5em;\n  width: calc(100% - 2em);\n  height: calc(100% - 2em);\n  transition: background-color ", ";\n  will-change: background-color;\n\n  & > p.BaSe--paragraph {\n    text-align: center;\n  }\n"])), institucionais.cinzaSebrae90, function (_a) {
    var isDrag = _a.isDrag;
    return isDrag ? institucionais.azulSebrae90 : defaults.white;
}, BaSeTheme.transitions.durationSlow);
var TagWrapper = styled.div.attrs({
    className: 'BaSe--file-picker-selected-files',
})(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  display: grid;\n  grid-auto-flow: row;\n  grid-auto-columns: minmax(", "px, 1fr);\n  grid-auto-rows: 2em;\n  grid-template-columns: repeat(auto-fill, minmax(", "px, 1fr));\n  grid-template-rows: repeat(auto-fill, 2em);\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 1em;\n  gap: 0.5em;\n"], ["\n  display: grid;\n  grid-auto-flow: row;\n  grid-auto-columns: minmax(", "px, 1fr);\n  grid-auto-rows: 2em;\n  grid-template-columns: repeat(auto-fill, minmax(", "px, 1fr));\n  grid-template-rows: repeat(auto-fill, 2em);\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 1em;\n  gap: 0.5em;\n"])), TAG_WIDTH_LIMIT, TAG_WIDTH_LIMIT);
var OutsideWrapper = styled.div.attrs({
    className: 'BaSe--file-picker-outside-button',
})(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 0.125em;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 0.125em;\n  width: 100%;\n"])));
var HiddenInputFile = styled.input.attrs({
    className: 'BaSe--file-picker-hidden-input-file',
    type: 'file',
})(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  position: absolute;\n  appearance: none;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  color: transparent;\n  display: none;\n  height: 0;\n  margin: 0;\n  max-height: 0;\n  max-width: 0;\n  min-height: 0;\n  min-width: 0;\n  opacity: 0;\n  outline: none;\n  pointer-events: none;\n  visibility: hidden;\n  width: 0;\n"], ["\n  position: absolute;\n  appearance: none;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  color: transparent;\n  display: none;\n  height: 0;\n  margin: 0;\n  max-height: 0;\n  max-width: 0;\n  min-height: 0;\n  min-width: 0;\n  opacity: 0;\n  outline: none;\n  pointer-events: none;\n  visibility: hidden;\n  width: 0;\n"])));
var templateObject_1$q, templateObject_2$n, templateObject_3$i, templateObject_4$e;

var BaSeFileInputField = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, isLoading = _a.isLoading, files = _a.files, hasFiles = _a.hasFiles, pickButtonProps = _a.pickButtonProps, pickInputProps = _a.pickInputProps, pickMultipleFiles = _a.pickMultipleFiles, onClickToPick = _a.onClickToPick, onClickToRemove = _a.onClickToRemove;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var inputPlaceholder = React.useMemo(function () {
        var _a;
        return (_a = pickInputProps === null || pickInputProps === void 0 ? void 0 : pickInputProps.placeholder) !== null && _a !== void 0 ? _a : getMessage(pickMultipleFiles
            ? 'filePicker.inputPickManyLabel'
            : 'filePicker.inputPickLabel');
    }, [pickInputProps === null || pickInputProps === void 0 ? void 0 : pickInputProps.placeholder, pickMultipleFiles, getMessage]);
    var inputValue = React.useMemo(function () {
        return joinWithSeparators(files.map(function (file) { return file.name; }), getMessage('list.separator'), getMessage('list.finalSeparator'));
    }, [getMessage, files]);
    var iconButtonColor = React.useMemo(function () { var _a; return (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.color) !== null && _a !== void 0 ? _a : 'default'; }, [pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.color]);
    var iconButtonName = React.useMemo(function () { var _a; return (hasFiles ? 'close-big' : (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.name) !== null && _a !== void 0 ? _a : 'upload'); }, [pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.name, hasFiles]);
    var iconButtonTypeButton = React.useMemo(function () { var _a; return (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.typeButton) !== null && _a !== void 0 ? _a : 'base-button'; }, [pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.typeButton]);
    var iconButtonType = React.useMemo(function () { var _a; return (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.type) !== null && _a !== void 0 ? _a : 'primary'; }, [pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.type]);
    var iconButtonValue = React.useMemo(function () {
        var _a;
        return hasFiles
            ? getMessage('filePicker.buttonDeleteLabel')
            : (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.value) !== null && _a !== void 0 ? _a : getMessage('filePicker.buttonPickLabel');
    }, [hasFiles, pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.value, getMessage]);
    var iconButtonAction = React.useCallback(function () {
        var _a;
        (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.action) === null || _a === void 0 ? void 0 : _a.call(pickButtonProps);
        if (hasFiles) {
            return onClickToRemove();
        }
        onClickToPick();
    }, [hasFiles, pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.action, onClickToPick, onClickToRemove]);
    return (React.createElement(BaSeInput, __assign({}, pickInputProps, { isReadOnly: true, isLoading: isLoading, placeholder: inputPlaceholder, value: inputValue, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, iconButton: {
            color: iconButtonColor,
            name: iconButtonName,
            typeButton: iconButtonTypeButton,
            type: iconButtonType,
            value: iconButtonValue,
            action: iconButtonAction,
        } })));
};
BaSeFileInputField.displayName = 'BaSeFileInputField';

function fileId(file) {
    return "\u00D7".concat(fileName(file), "\u00D7").concat(fileSize(file), "\u00D7").concat(fileType(file), "\u00D7").toLowerCase();
}
function fileName(file) {
    return file.name;
}
function fileSize(file) {
    function bytesToSize(bytes) {
        var KB = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 1) {
            return '1 Byte';
        }
        if (bytes === 0) {
            return '0 Byte';
        }
        var value = Math.floor(Math.log(bytes) / Math.log(KB));
        var int = parseInt(value + '', 10);
        return "".concat(Math.round(bytes / Math.pow(KB, int)), " ").concat(sizes[int]);
    }
    return bytesToSize(file.size);
}
function fileType(file) {
    var _a;
    return (_a = file.type) !== null && _a !== void 0 ? _a : '';
}
function mergeFiles(currentList, newList) {
    return __spreadArray(__spreadArray([], currentList, true), newList.filter(function (newFile) {
        return currentList.every(function (currentFile) { return fileId(currentFile) !== fileId(newFile); });
    }), true);
}
function fileIsImage(file) {
    return fileType(file).startsWith('image');
}

var ANY_FILE = '*';
var BaSeFilePicker = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = _a.pickMultipleFiles, pickMultipleFiles = _o === void 0 ? true : _o, _p = _a.renderStyle, renderStyle = _p === void 0 ? 'box' : _p, _q = _a.acceptsFilesPattern, acceptsFilePatternExternal = _q === void 0 ? ANY_FILE : _q, dragInfoText = _a.dragInfoText, dragInfoProps = _a.dragInfoProps, label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, pickButtonProps = _a.pickButtonProps, pickInputProps = _a.pickInputProps, placeholderImageProps = _a.placeholderImageProps, selectedFileTagProps = _a.selectedFileTagProps, selectedFilesContainerRender = _a.selectedFilesContainerRender, onError = _a.onError, onChange = _a.onChange, _r = _a.validateFiles, validateFiles = _r === void 0 ? function (list) { return list; } : _r;
    var inputRef = React.useRef(null);
    var _s = React.useState([]), files = _s[0], setFiles = _s[1];
    var _t = React.useState(false), isDrag = _t[0], setIsDrag = _t[1];
    var _u = React.useState(false), isLoading = _u[0], setIsLoading = _u[1];
    var acceptsFilesPattern = React.useMemo(function () { return (acceptsFilePatternExternal + '').toLowerCase(); }, [acceptsFilePatternExternal]);
    var hasFiles = React.useMemo(function () { var _a; return ((_a = files === null || files === void 0 ? void 0 : files.length) !== null && _a !== void 0 ? _a : 0) > 0; }, [files]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleError = React.useCallback(function (event) {
        // eslint-disable-next-line no-console
        console.error('[BaSeFilePicker] Error event', event);
        onError === null || onError === void 0 ? void 0 : onError('Xii! :(');
    }, [onError]);
    var handleChange = React.useCallback(function (event) {
        var _a, _b, _c;
        var fileList = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) !== null && _b !== void 0 ? _b : (_c = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _c === void 0 ? void 0 : _c.files;
        setTimeout(function () {
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                inputRef.current.value = '';
            }
        }, 150);
        if (!(fileList === null || fileList === void 0 ? void 0 : fileList.length)) {
            return setFiles([]);
        }
        setIsLoading(true);
        var filteredList = Array.from(fileList).filter(function (file) {
            if (acceptsFilesPattern === ANY_FILE) {
                return true;
            }
            var patternsList = acceptsFilesPattern.split(',');
            var extFile = '.' + fileName(file).split('.').pop();
            var acceptsPatternList = patternsList.map(function (pattern) {
                var filePattern = pattern.slice(0, pattern.indexOf('/')).trim();
                var fileTypePattern = fileType(file).slice(0, fileType(file).indexOf('/'));
                return pattern.includes('/*') && filePattern === fileTypePattern
                    ? fileType(file)
                    : pattern.trim();
            });
            return (acceptsPatternList.includes(fileType(file)) ||
                acceptsPatternList.includes(extFile) ||
                fileId(file).includes(acceptsFilesPattern));
        });
        var validatedList = validateFiles(filteredList);
        if (Array.isArray(validatedList)) {
            return setFiles(function (list) { return mergeFiles(list, validatedList); });
        }
        validatedList
            .then(function (resolvedList) {
            return setFiles(function (list) { return mergeFiles(list, resolvedList); });
        })
            .catch(function (err) {
            // eslint-disable-next-line no-console
            return console.error('[BaSeFilePicker] validation error', err);
        });
    }, [acceptsFilesPattern, validateFiles]);
    var handleDrag = React.useCallback(function (bool) { return function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setIsDrag(bool);
    }; }, []);
    var handleDrop = React.useCallback(function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if ((pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.isDisabled) !== true) {
            handleChange(event);
        }
        setIsDrag(false);
    }, [handleChange, pickButtonProps]);
    var handleRemoveFile = React.useCallback(function (fileToRemove) {
        return setFiles(function (list) {
            return list.filter(function (file) { return fileId(file) !== fileId(fileToRemove); });
        });
    }, []);
    React.useEffect(function () {
        var urls = Array.from(files).map(function (file) { return URL.createObjectURL(file); });
        onChange(files, urls);
        setIsLoading(false);
        return function () { return urls === null || urls === void 0 ? void 0 : urls.forEach(function (url) { return URL.revokeObjectURL(url); }); };
    }, [onChange, files]);
    return (React.createElement("div", { className: "BaSe--file-picker" },
        React.createElement(HiddenInputFile, { accept: acceptsFilesPattern, multiple: pickMultipleFiles, ref: inputRef, onChange: handleChange, onError: handleError }),
        renderStyle === 'input-field' && (React.createElement(BaSeFileInputField, { files: files, hasFiles: hasFiles, isLoading: isLoading, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, pickMultipleFiles: pickMultipleFiles, pickButtonProps: pickButtonProps, pickInputProps: pickInputProps, onClickToPick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, onClickToRemove: function () { return setFiles([]); } })),
        renderStyle === 'box' && (React.createElement(React.Fragment, null,
            React.createElement(OutsideWrapper, null,
                React.createElement(BaSeFormLabel, { label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps }),
                hasFiles && (React.createElement(BaSeButton, __assign({}, pickButtonProps, { isLoading: isLoading, type: (_b = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.type) !== null && _b !== void 0 ? _b : 'primary', size: (_c = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.size) !== null && _c !== void 0 ? _c : 'small', color: (_d = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.color) !== null && _d !== void 0 ? _d : 'default', leftIcon: (_e = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.leftIcon) !== null && _e !== void 0 ? _e : 'upload', value: (_f = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.value) !== null && _f !== void 0 ? _f : getMessage('filePicker.buttonPickLabel'), onClick: function (clickEvent) {
                        var _a, _b;
                        (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(pickButtonProps, clickEvent);
                        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.click();
                    } })))),
            React.createElement(FilePickerWrapper, { onDragEnter: handleDrag(true), onDragLeave: handleDrag(false), onDragOver: handleDrag(true), onDrop: handleDrop, isDrag: isDrag }, hasFiles ? (selectedFilesContainerRender !== undefined ? (selectedFilesContainerRender(files.map(function (file) { return ({
                file: file,
                removeFile: function () { return handleRemoveFile(file); },
            }); }))) : (React.createElement(TagWrapper, null, files.map(function (file) {
                var _a, _b;
                return (React.createElement(React.Fragment, { key: fileId(file) },
                    React.createElement(BaSeTag, __assign({}, selectedFileTagProps, { label: (_a = selectedFileTagProps === null || selectedFileTagProps === void 0 ? void 0 : selectedFileTagProps.label) !== null && _a !== void 0 ? _a : fileName(file), onClose: function () { return handleRemoveFile(file); }, limitedWidth: (_b = selectedFileTagProps === null || selectedFileTagProps === void 0 ? void 0 : selectedFileTagProps.limitedWidth) !== null && _b !== void 0 ? _b : 300, tooltip: {
                            color: selectedFileTagProps === null || selectedFileTagProps === void 0 ? void 0 : selectedFileTagProps.color,
                            message: [
                                fileName(file),
                                fileSize(file),
                                fileType(file),
                            ],
                        } }))));
            })))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { pointerEvents: 'none' } },
                    React.createElement(BaSeIcon, __assign({ color: BaSeTheme.colors.institucionais.cinzaSebrae90, size: 75, name: "file-plus-alt", description: getMessage('imagePicker.imagePlaceholder') }, placeholderImageProps))),
                React.createElement(BaSeButton, __assign({}, pickButtonProps, { isLoading: isLoading, type: (_g = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.type) !== null && _g !== void 0 ? _g : 'primary', size: (_h = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.size) !== null && _h !== void 0 ? _h : 'small', color: (_j = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.color) !== null && _j !== void 0 ? _j : 'default', leftIcon: (_k = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.leftIcon) !== null && _k !== void 0 ? _k : 'upload', value: (_l = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.value) !== null && _l !== void 0 ? _l : getMessage('filePicker.buttonPickLabel'), onClick: function (clickEvent) {
                        var _a, _b;
                        (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(pickButtonProps, clickEvent);
                        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.click();
                    } })),
                React.createElement(BaSeParagraph, __assign({}, dragInfoProps, { color: (_m = dragInfoProps === null || dragInfoProps === void 0 ? void 0 : dragInfoProps.color) !== null && _m !== void 0 ? _m : BaSeTheme.colors.institucionais.cinzaSebrae45 }), dragInfoText !== null && dragInfoText !== void 0 ? dragInfoText : getMessage(pickMultipleFiles
                    ? 'filePicker.dragManyInfo'
                    : 'filePicker.dragInfo')))))))));
};
BaSeFilePicker.displayName = 'BaSeFilePicker';

/* keyframes marching-ants of react crop "react-image-crop/ReactCrop.css" */
var marchingAnts = keyframes(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  0% {\n    background-position: 0 0, 0 100%, 0 0, 100% 0;\n  }\n  to {\n    background-position: 20px 0, -20px 100%, 0 -20px, 100% 20px;\n  }\n"], ["\n  0% {\n    background-position: 0 0, 0 100%, 0 0, 100% 0;\n  }\n  to {\n    background-position: 20px 0, -20px 100%, 0 -20px, 100% 20px;\n  }\n"])));
/* root variables of react crop "react-image-crop/ReactCrop.css" */
var root = {
    'rc-drag-handle-size': '12px',
    'rc-drag-handle-mobile-size': '24px',
    'rc-drag-handle-bg-colour': 'rgba(0, 0, 0, 0.2)',
    'rc-drag-bar-size': '6px',
    'rc-border-color': 'rgba(255, 255, 255, 0.7)',
    'rc-focus-color': BaSeTheme.colors.institucionais.azulSebrae, //'#0088ff',
};
var CropperContainer = styled.div.attrs({
    className: 'BaSe--cropper',
})(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  /* begin style react crop \"react-image-crop/ReactCrop.css\" */\n  .ReactCrop {\n    position: relative;\n    display: inline-block;\n    cursor: crosshair;\n    max-width: 100%;\n  }\n  .ReactCrop *,\n  .ReactCrop *:before,\n  .ReactCrop *:after {\n    box-sizing: border-box;\n  }\n  .ReactCrop--disabled,\n  .ReactCrop--locked {\n    cursor: inherit;\n  }\n  .ReactCrop__child-wrapper {\n    overflow: hidden;\n    max-height: inherit;\n  }\n  .ReactCrop__child-wrapper > img,\n  .ReactCrop__child-wrapper > video {\n    display: block;\n    max-width: 100%;\n    max-height: inherit;\n  }\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > img,\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > video {\n    touch-action: none;\n  }\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection {\n    touch-action: none;\n  }\n  .ReactCrop__crop-mask {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n  }\n  .ReactCrop__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translateZ(0);\n    cursor: move;\n  }\n  .ReactCrop--disabled .ReactCrop__crop-selection {\n    cursor: inherit;\n  }\n  .ReactCrop--circular-crop .ReactCrop__crop-selection {\n    border-radius: 50%;\n  }\n  .ReactCrop--circular-crop .ReactCrop__crop-selection:after {\n    pointer-events: none;\n    content: '';\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    bottom: -1px;\n    left: -1px;\n    border: 1px solid ", ";\n    opacity: 0.3;\n  }\n  .ReactCrop--no-animate .ReactCrop__crop-selection {\n    outline: 1px dashed white;\n  }\n  .ReactCrop__crop-selection:not(\n      .ReactCrop--no-animate .ReactCrop__crop-selection\n    ) {\n    animation: ", " 1s;\n    background-image: linear-gradient(to right, #fff 50%, #444 50%),\n      linear-gradient(to right, #fff 50%, #444 50%),\n      linear-gradient(to bottom, #fff 50%, #444 50%),\n      linear-gradient(to bottom, #fff 50%, #444 50%);\n    background-size:\n      10px 1px,\n      10px 1px,\n      1px 10px,\n      1px 10px;\n    background-position:\n      0 0,\n      0 100%,\n      0 0,\n      100% 0;\n    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n    color: #fff;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n  .ReactCrop__crop-selection:focus {\n    outline: 2px solid\n      ", ";\n    outline-offset: -1px;\n  }\n  .ReactCrop--invisible-crop .ReactCrop__crop-mask,\n  .ReactCrop--invisible-crop .ReactCrop__crop-selection {\n    display: none;\n  }\n  .ReactCrop__rule-of-thirds-vt:before,\n  .ReactCrop__rule-of-thirds-vt:after,\n  .ReactCrop__rule-of-thirds-hz:before,\n  .ReactCrop__rule-of-thirds-hz:after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: #fff6;\n  }\n  .ReactCrop__rule-of-thirds-vt:before,\n  .ReactCrop__rule-of-thirds-vt:after {\n    width: 1px;\n    height: 100%;\n  }\n  .ReactCrop__rule-of-thirds-vt:before {\n    left: 33.3333333333%;\n  }\n  .ReactCrop__rule-of-thirds-vt:after {\n    left: 66.6666666667%;\n  }\n  .ReactCrop__rule-of-thirds-hz:before,\n  .ReactCrop__rule-of-thirds-hz:after {\n    width: 100%;\n    height: 1px;\n  }\n  .ReactCrop__rule-of-thirds-hz:before {\n    top: 33.3333333333%;\n  }\n  .ReactCrop__rule-of-thirds-hz:after {\n    top: 66.6666666667%;\n  }\n  .ReactCrop__drag-handle {\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n  .ReactCrop__drag-handle:focus {\n    background: ", ";\n  }\n  .ReactCrop .ord-nw {\n    top: 0;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: nw-resize;\n  }\n  .ReactCrop .ord-n {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    cursor: n-resize;\n  }\n  .ReactCrop .ord-ne {\n    top: 0;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: ne-resize;\n  }\n  .ReactCrop .ord-e {\n    top: 50%;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: e-resize;\n  }\n  .ReactCrop .ord-se {\n    bottom: 0;\n    right: 0;\n    transform: translate(50%, 50%);\n    cursor: se-resize;\n  }\n  .ReactCrop .ord-s {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%);\n    cursor: s-resize;\n  }\n  .ReactCrop .ord-sw {\n    bottom: 0;\n    left: 0;\n    transform: translate(-50%, 50%);\n    cursor: sw-resize;\n  }\n  .ReactCrop .ord-w {\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: w-resize;\n  }\n  .ReactCrop__disabled .ReactCrop__drag-handle {\n    cursor: inherit;\n  }\n  .ReactCrop__drag-bar {\n    position: absolute;\n  }\n  .ReactCrop__drag-bar.ord-n {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    transform: translateY(-50%);\n  }\n  .ReactCrop__drag-bar.ord-e {\n    right: 0;\n    top: 0;\n    width: ", ";\n    height: 100%;\n    transform: translate(50%);\n  }\n  .ReactCrop__drag-bar.ord-s {\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    transform: translateY(50%);\n  }\n  .ReactCrop__drag-bar.ord-w {\n    top: 0;\n    left: 0;\n    width: ", ";\n    height: 100%;\n    transform: translate(-50%);\n  }\n  .ReactCrop--new-crop .ReactCrop__drag-bar,\n  .ReactCrop--new-crop .ReactCrop__drag-handle,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-bar,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {\n    display: none;\n  }\n  @media (pointer: coarse) {\n    .ReactCrop .ord-n,\n    .ReactCrop .ord-e,\n    .ReactCrop .ord-s,\n    .ReactCrop .ord-w {\n      display: none;\n    }\n    .ReactCrop__drag-handle {\n      width: ", ";\n      height: ", ";\n    }\n  }\n  /* end style react crop \"react-image-crop/ReactCrop.css\" */\n\n  position: relative;\n  display: grid;\n  place-items: center;\n\n  .ReactCrop {\n    max-height: 50vh;\n    margin: 0 auto;\n  }\n\n  .BaSe--cropper-image {\n    max-width: 100%;\n  }\n\n  .BaSe--cropper-canvas {\n    display: none;\n    pointer-events: none;\n    visibility: hidden;\n    opacity: 0;\n  }\n"], ["\n  /* begin style react crop \"react-image-crop/ReactCrop.css\" */\n  .ReactCrop {\n    position: relative;\n    display: inline-block;\n    cursor: crosshair;\n    max-width: 100%;\n  }\n  .ReactCrop *,\n  .ReactCrop *:before,\n  .ReactCrop *:after {\n    box-sizing: border-box;\n  }\n  .ReactCrop--disabled,\n  .ReactCrop--locked {\n    cursor: inherit;\n  }\n  .ReactCrop__child-wrapper {\n    overflow: hidden;\n    max-height: inherit;\n  }\n  .ReactCrop__child-wrapper > img,\n  .ReactCrop__child-wrapper > video {\n    display: block;\n    max-width: 100%;\n    max-height: inherit;\n  }\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > img,\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > video {\n    touch-action: none;\n  }\n  .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection {\n    touch-action: none;\n  }\n  .ReactCrop__crop-mask {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n  }\n  .ReactCrop__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translateZ(0);\n    cursor: move;\n  }\n  .ReactCrop--disabled .ReactCrop__crop-selection {\n    cursor: inherit;\n  }\n  .ReactCrop--circular-crop .ReactCrop__crop-selection {\n    border-radius: 50%;\n  }\n  .ReactCrop--circular-crop .ReactCrop__crop-selection:after {\n    pointer-events: none;\n    content: '';\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    bottom: -1px;\n    left: -1px;\n    border: 1px solid ", ";\n    opacity: 0.3;\n  }\n  .ReactCrop--no-animate .ReactCrop__crop-selection {\n    outline: 1px dashed white;\n  }\n  .ReactCrop__crop-selection:not(\n      .ReactCrop--no-animate .ReactCrop__crop-selection\n    ) {\n    animation: ", " 1s;\n    background-image: linear-gradient(to right, #fff 50%, #444 50%),\n      linear-gradient(to right, #fff 50%, #444 50%),\n      linear-gradient(to bottom, #fff 50%, #444 50%),\n      linear-gradient(to bottom, #fff 50%, #444 50%);\n    background-size:\n      10px 1px,\n      10px 1px,\n      1px 10px,\n      1px 10px;\n    background-position:\n      0 0,\n      0 100%,\n      0 0,\n      100% 0;\n    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n    color: #fff;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n  .ReactCrop__crop-selection:focus {\n    outline: 2px solid\n      ", ";\n    outline-offset: -1px;\n  }\n  .ReactCrop--invisible-crop .ReactCrop__crop-mask,\n  .ReactCrop--invisible-crop .ReactCrop__crop-selection {\n    display: none;\n  }\n  .ReactCrop__rule-of-thirds-vt:before,\n  .ReactCrop__rule-of-thirds-vt:after,\n  .ReactCrop__rule-of-thirds-hz:before,\n  .ReactCrop__rule-of-thirds-hz:after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: #fff6;\n  }\n  .ReactCrop__rule-of-thirds-vt:before,\n  .ReactCrop__rule-of-thirds-vt:after {\n    width: 1px;\n    height: 100%;\n  }\n  .ReactCrop__rule-of-thirds-vt:before {\n    left: 33.3333333333%;\n  }\n  .ReactCrop__rule-of-thirds-vt:after {\n    left: 66.6666666667%;\n  }\n  .ReactCrop__rule-of-thirds-hz:before,\n  .ReactCrop__rule-of-thirds-hz:after {\n    width: 100%;\n    height: 1px;\n  }\n  .ReactCrop__rule-of-thirds-hz:before {\n    top: 33.3333333333%;\n  }\n  .ReactCrop__rule-of-thirds-hz:after {\n    top: 66.6666666667%;\n  }\n  .ReactCrop__drag-handle {\n    position: absolute;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n  .ReactCrop__drag-handle:focus {\n    background: ", ";\n  }\n  .ReactCrop .ord-nw {\n    top: 0;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: nw-resize;\n  }\n  .ReactCrop .ord-n {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    cursor: n-resize;\n  }\n  .ReactCrop .ord-ne {\n    top: 0;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: ne-resize;\n  }\n  .ReactCrop .ord-e {\n    top: 50%;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: e-resize;\n  }\n  .ReactCrop .ord-se {\n    bottom: 0;\n    right: 0;\n    transform: translate(50%, 50%);\n    cursor: se-resize;\n  }\n  .ReactCrop .ord-s {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%);\n    cursor: s-resize;\n  }\n  .ReactCrop .ord-sw {\n    bottom: 0;\n    left: 0;\n    transform: translate(-50%, 50%);\n    cursor: sw-resize;\n  }\n  .ReactCrop .ord-w {\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: w-resize;\n  }\n  .ReactCrop__disabled .ReactCrop__drag-handle {\n    cursor: inherit;\n  }\n  .ReactCrop__drag-bar {\n    position: absolute;\n  }\n  .ReactCrop__drag-bar.ord-n {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    transform: translateY(-50%);\n  }\n  .ReactCrop__drag-bar.ord-e {\n    right: 0;\n    top: 0;\n    width: ", ";\n    height: 100%;\n    transform: translate(50%);\n  }\n  .ReactCrop__drag-bar.ord-s {\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    transform: translateY(50%);\n  }\n  .ReactCrop__drag-bar.ord-w {\n    top: 0;\n    left: 0;\n    width: ", ";\n    height: 100%;\n    transform: translate(-50%);\n  }\n  .ReactCrop--new-crop .ReactCrop__drag-bar,\n  .ReactCrop--new-crop .ReactCrop__drag-handle,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-bar,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {\n    display: none;\n  }\n  @media (pointer: coarse) {\n    .ReactCrop .ord-n,\n    .ReactCrop .ord-e,\n    .ReactCrop .ord-s,\n    .ReactCrop .ord-w {\n      display: none;\n    }\n    .ReactCrop__drag-handle {\n      width: ", ";\n      height: ", ";\n    }\n  }\n  /* end style react crop \"react-image-crop/ReactCrop.css\" */\n\n  position: relative;\n  display: grid;\n  place-items: center;\n\n  .ReactCrop {\n    max-height: 50vh;\n    margin: 0 auto;\n  }\n\n  .BaSe--cropper-image {\n    max-width: 100%;\n  }\n\n  .BaSe--cropper-canvas {\n    display: none;\n    pointer-events: none;\n    visibility: hidden;\n    opacity: 0;\n  }\n"])), root['rc-border-color'], marchingAnts, function (_a) {
    var cropFocusColor = _a.cropFocusColor;
    return cropFocusColor !== null && cropFocusColor !== void 0 ? cropFocusColor : root['rc-focus-color'];
}, root['rc-drag-handle-size'], root['rc-drag-handle-size'], root['rc-drag-handle-bg-colour'], root['rc-border-color'], function (_a) {
    var cropFocusColor = _a.cropFocusColor;
    return cropFocusColor !== null && cropFocusColor !== void 0 ? cropFocusColor : root['rc-focus-color'];
}, root['rc-drag-bar-size'], root['rc-drag-bar-size'], root['rc-drag-bar-size'], root['rc-drag-bar-size'], root['rc-drag-handle-mobile-size'], root['rc-drag-handle-mobile-size']);
var CropperActionsButton = styled.div(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n"])));
var templateObject_1$p, templateObject_2$m, templateObject_3$h;

function cropInitialValues(_a) {
    var unit = _a.unit, size = _a.size;
    return {
        unit: unit,
        x: 0,
        y: 0,
        width: size,
        height: size,
    };
}
function cropInitialAfterLoadImage(_a) {
    var width = _a.width, height = _a.height, aspect = _a.aspect;
    if (aspect) {
        return centerCrop(makeAspectCrop({
            unit: '%',
            width: 100,
        }, aspect, width, height), width, height);
    }
    return centerCrop({ unit: 'px', width: width, height: height }, width, height);
}
function valueOrMax(value, max) {
    return max !== undefined ? (value > max ? max : value) : value;
}
var BaSeCropper = function (_a) {
    var _b, _c, _d, _e;
    var file = _a.file, circularCrop = _a.circularCrop, cropAspect = _a.cropAspect, cropSaveButtonProps = _a.cropSaveButtonProps, cropCancelButtonProps = _a.cropCancelButtonProps, cropFocusColor = _a.cropFocusColor, cropMinWidth = _a.cropMinWidth, cropMinHeight = _a.cropMinHeight, cropMaxWidth = _a.cropMaxWidth, cropMaxHeight = _a.cropMaxHeight, saveCallback = _a.saveCallback, cancelCallback = _a.cancelCallback, onCropError = _a.onCropError;
    var _f = React.useState(cropInitialValues({ unit: '%', size: 100 })), crop = _f[0], setCrop = _f[1];
    var _g = React.useState(cropInitialValues({ unit: 'px', size: 0 })), completedCrop = _g[0], setCompletedCrop = _g[1];
    var _h = React.useState(''), imageUrl = _h[0], setImageUrl = _h[1];
    var _j = React.useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var imageRef = React.useRef(null);
    var canvasRef = React.useRef(null);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleLoadImageUrl = React.useCallback(function (event) {
        var _a = event.currentTarget, imageWidth = _a.width, imageHeight = _a.height;
        var width = valueOrMax(imageWidth, cropMaxWidth);
        var height = valueOrMax(imageHeight, cropMaxHeight);
        var centralizedCrop = cropInitialAfterLoadImage({
            width: width,
            height: height,
            aspect: cropAspect,
        });
        setCrop(centralizedCrop);
        setCompletedCrop(centralizedCrop);
    }, [cropAspect, cropMaxWidth, cropMaxHeight]);
    var handleError = React.useCallback(function (message) {
        // eslint-disable-next-line no-console
        console.error('[BaSeCropper] %s', message);
        setIsLoading(false);
        return onCropError === null || onCropError === void 0 ? void 0 : onCropError(getMessage('cropper.error.crop'));
    }, [getMessage, onCropError]);
    var handleSaveBlob = React.useCallback(function (blob) {
        if (!blob) {
            return handleError('Canvas vazio!');
        }
        // const imageEncodeOptions = { type: "image/jpeg", quality: {0, 0.1, ..., 0.9, 1} };
        // const imageEncodeOptions: ImageEncodeOptions = { type: 'image/png' };
        // const image = new File(
        //   [blob],
        //   originalImgTag?.name ??
        //     getMessage('cropper.file.default.name', Date?.now()),
        //   imageEncodeOptions,
        // );
        saveCallback(blob);
        setIsLoading(false);
    }, [handleError, saveCallback]);
    var handleSaveImage = React.useCallback(function () {
        setIsLoading(true);
        var image = imageRef.current;
        if (!image) {
            return handleError('Não encontrou a imagem para recortar');
        }
        var pixelRatio = 1; // window.devicePixelRatio;
        var imageWidth = image.naturalWidth;
        var imageHeight = image.naturalHeight;
        var scaleX = imageWidth / image.width;
        var scaleY = imageHeight / image.height;
        var centerY = imageHeight / 2;
        var centerX = imageWidth / 2;
        var toPx = function (value, size) {
            return completedCrop.unit === 'px' ? value : (value / 100) * size;
        };
        var cropX = toPx(completedCrop.x, image.width) * scaleX;
        var cropY = toPx(completedCrop.y, image.height) * scaleY;
        var cropWidth = toPx(completedCrop.width, image.width) * scaleX;
        var cropHeight = toPx(completedCrop.height, image.height) * scaleY;
        var canvas = canvasRef.current;
        if (!canvas) {
            return handleError('Não encontrou o canvas para recortar');
        }
        canvas.width = Math.floor(cropWidth * pixelRatio);
        canvas.height = Math.floor(cropHeight * pixelRatio);
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return handleError('Não encontrou o contexto 2D do canvas para recortar');
        }
        ctx.imageSmoothingQuality = 'high';
        ctx.save();
        ctx.translate(-cropX, -cropY);
        ctx.translate(centerX, centerY);
        ctx.rotate(0);
        ctx.scale(1, 1);
        ctx.translate(-centerX, -centerY);
        ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, imageWidth, imageHeight);
        ctx.restore();
        canvas.toBlob(handleSaveBlob);
    }, [completedCrop, handleError, handleSaveBlob]);
    React.useEffect(function () {
        var url;
        if (file) {
            url = URL.createObjectURL(file);
            setImageUrl(url);
        }
        return function () {
            if (url) {
                URL.revokeObjectURL(url);
                setImageUrl('');
            }
        };
    }, [file]);
    return (React.createElement(CropperContainer, { cropFocusColor: cropFocusColor }, file && imageUrl && (React.createElement(React.Fragment, null,
        React.createElement(ReactCropper, { ruleOfThirds: true, minWidth: cropMinWidth, minHeight: cropMinHeight, maxWidth: cropMaxWidth, maxHeight: cropMaxHeight, crop: crop, aspect: cropAspect, circularCrop: circularCrop, onChange: function (_, percentageCrop) { return setCrop(percentageCrop); }, onComplete: function (pixelCrop) { return setCompletedCrop(pixelCrop); } },
            React.createElement("img", { className: "BaSe--cropper-image", ref: imageRef, src: imageUrl, alt: getMessage('cropper.image.alt'), onLoad: handleLoadImageUrl })),
        React.createElement("canvas", { className: "BaSe--cropper-canvas", ref: canvasRef }),
        React.createElement(CropperActionsButton, null,
            React.createElement(BaSeButton, __assign({}, cropSaveButtonProps, { type: (_b = cropSaveButtonProps === null || cropSaveButtonProps === void 0 ? void 0 : cropSaveButtonProps.type) !== null && _b !== void 0 ? _b : 'primary', value: (_c = cropSaveButtonProps === null || cropSaveButtonProps === void 0 ? void 0 : cropSaveButtonProps.value) !== null && _c !== void 0 ? _c : getMessage('cropper.button.save'), onClick: function (clickEvent) {
                    var _a;
                    (_a = cropSaveButtonProps === null || cropSaveButtonProps === void 0 ? void 0 : cropSaveButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(cropSaveButtonProps, clickEvent);
                    handleSaveImage();
                }, isLoading: isLoading })),
            React.createElement(BaSeButton, __assign({}, cropCancelButtonProps, { type: (_d = cropCancelButtonProps === null || cropCancelButtonProps === void 0 ? void 0 : cropCancelButtonProps.type) !== null && _d !== void 0 ? _d : 'secondary', value: (_e = cropCancelButtonProps === null || cropCancelButtonProps === void 0 ? void 0 : cropCancelButtonProps.value) !== null && _e !== void 0 ? _e : getMessage('cropper.button.cancel'), onClick: function (clickEvent) {
                    var _a;
                    (_a = cropCancelButtonProps === null || cropCancelButtonProps === void 0 ? void 0 : cropCancelButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(cropCancelButtonProps, clickEvent);
                    cancelCallback();
                } })))))));
};
BaSeCropper.displayName = 'BaSeCropper';

var SelectedImage = styled.img.attrs({
    className: 'BaSe--image-picker-selected-image',
    loading: 'lazy',
    decoding: 'async',
})(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  height: 75px;\n  width: 75px;\n  min-height: 75px;\n  min-width: 75px;\n  max-height: 75px;\n  max-width: 75px;\n  object-fit: ", ";\n  border-radius: ", ";\n"], ["\n  height: 75px;\n  width: 75px;\n  min-height: 75px;\n  min-width: 75px;\n  max-height: 75px;\n  max-width: 75px;\n  object-fit: ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var previewImageFit = _a.previewImageFit;
    return previewImageFit;
}, function (_a) {
    var imageShape = _a.imageShape;
    return (imageShape === 'circle' ? '50%' : '0');
});
var ActionButtonWrapper = styled.div(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n"])));
var templateObject_1$o, templateObject_2$l;

var BaSeImagePicker = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var _t = _a.renderStyle, renderStyle = _t === void 0 ? 'box' : _t, _u = _a.iconNotFoundPlaceholder, iconNotFoundPlaceholder = _u === void 0 ? 'times-circle-tonescale' : _u, _v = _a.cropEnable, cropEnable = _v === void 0 ? true : _v, _w = _a.imageShape, imageShape = _w === void 0 ? 'square' : _w, selectedImage = _a.selectedImage, dialogContext = _a.dialogContext, // TODO encontrar melhor maneira de abrir modal?
    cropModalProps = _a.cropModalProps, cropSaveButtonProps = _a.cropSaveButtonProps, cropCancelButtonProps = _a.cropCancelButtonProps, cropFocusColor = _a.cropFocusColor, cropAspect = _a.cropAspect, cropMinWidth = _a.cropMinWidth, cropMinHeight = _a.cropMinHeight, cropMaxWidth = _a.cropMaxWidth, cropMaxHeight = _a.cropMaxHeight, label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, pickInputProps = _a.pickInputProps, pickButtonProps = _a.pickButtonProps, updateButtonProps = _a.updateButtonProps, deleteButtonProps = _a.deleteButtonProps, placeholderImageProps = _a.placeholderImageProps, dragInfoText = _a.dragInfoText, dragInfoProps = _a.dragInfoProps, _x = _a.previewImageFit, previewImageFit = _x === void 0 ? 'cover' : _x, onError = _a.onError, onFilePick = _a.onFilePick, onUrlPick = _a.onUrlPick, onDelete = _a.onDelete;
    var inputRef = React.useRef(null);
    var _y = React.useState(false), notFound = _y[0], setNotFound = _y[1];
    var _z = React.useState([]), files = _z[0], setFiles = _z[1];
    var _0 = React.useState([]), urls = _0[0], setUrls = _0[1];
    var _1 = React.useState(false), isDrag = _1[0], setIsDrag = _1[1];
    var _2 = React.useState(''), selectedImageSource = _2[0], setSelectedImageSource = _2[1];
    var showModal = React.useContext(dialogContext !== null && dialogContext !== void 0 ? dialogContext : BaSeDialogContext).showModal;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleChange = React.useCallback(function (event) {
        var _a, _b, _c, _d, _e;
        var fileList = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) !== null && _b !== void 0 ? _b : (_c = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _c === void 0 ? void 0 : _c.files;
        setTimeout(function () {
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
                inputRef.current.value = '';
            }
        }, 150);
        var filteredList = Array.from(fileList).filter(function (f) { return fileIsImage(f); });
        if (!(filteredList === null || filteredList === void 0 ? void 0 : filteredList.length)) {
            return setFiles([]);
        }
        var file = filteredList[0];
        if (!cropEnable) {
            return setFiles([file]);
        }
        showModal(__assign(__assign({}, cropModalProps), { content: function (modalProps) {
                var closeModalWithDelay = function (message) {
                    return setTimeout(function () { var _a; return (_a = modalProps === null || modalProps === void 0 ? void 0 : modalProps.closeModal) === null || _a === void 0 ? void 0 : _a.call(modalProps, message); }, 50);
                };
                return (React.createElement(BaSeCropper, { file: file, circularCrop: imageShape === 'circle', cropAspect: cropAspect, cropSaveButtonProps: cropSaveButtonProps, cropCancelButtonProps: cropCancelButtonProps, cropFocusColor: cropFocusColor, cropMinWidth: cropMinWidth, cropMinHeight: cropMinHeight, cropMaxWidth: cropMaxWidth, cropMaxHeight: cropMaxHeight, cancelCallback: function () { return closeModalWithDelay(''); }, onCropError: function (message) {
                        onError === null || onError === void 0 ? void 0 : onError(message);
                        closeModalWithDelay(message);
                    }, saveCallback: function (croppedImage) {
                        setFiles([croppedImage]);
                        closeModalWithDelay('');
                    } }));
            }, title: (_d = cropModalProps === null || cropModalProps === void 0 ? void 0 : cropModalProps.title) !== null && _d !== void 0 ? _d : getMessage('ImagePicker.modalTitle'), actions: [], size: (_e = cropModalProps === null || cropModalProps === void 0 ? void 0 : cropModalProps.size) !== null && _e !== void 0 ? _e : 'large' }));
    }, [
        cropEnable,
        cropModalProps,
        imageShape,
        cropAspect,
        cropSaveButtonProps,
        cropCancelButtonProps,
        cropFocusColor,
        cropMinWidth,
        cropMinHeight,
        cropMaxWidth,
        cropMaxHeight,
        showModal,
        getMessage,
        onError,
    ]);
    var handleDrag = React.useCallback(function (bool) { return function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setIsDrag(bool);
    }; }, []);
    var handleDrop = React.useCallback(function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        handleChange(event);
        setIsDrag(false);
    }, [handleChange]);
    React.useEffect(function () {
        onFilePick === null || onFilePick === void 0 ? void 0 : onFilePick(files);
        if (files) {
            setUrls(files.map(function (file) { return URL.createObjectURL(file); }));
        }
    }, [onFilePick, files]);
    React.useEffect(function () {
        onUrlPick === null || onUrlPick === void 0 ? void 0 : onUrlPick(urls);
        return function () { return urls === null || urls === void 0 ? void 0 : urls.forEach(function (url) { return URL.revokeObjectURL(url); }); };
    }, [onUrlPick, urls]);
    React.useEffect(function () {
        if (selectedImage instanceof File || selectedImage instanceof Blob) {
            if (!fileIsImage(selectedImage)) {
                return onError === null || onError === void 0 ? void 0 : onError(getMessage('filePicker.fileInvalidMessage'));
            }
            var url_1 = URL.createObjectURL(selectedImage);
            setSelectedImageSource(url_1);
            return function () { return URL.revokeObjectURL(url_1); };
        }
        setSelectedImageSource(selectedImage !== null && selectedImage !== void 0 ? selectedImage : '');
    }, [selectedImage, getMessage, onError]);
    React.useEffect(function () {
        if (selectedImage) {
            setNotFound(false);
        }
        if (selectedImage instanceof File) {
            return function () {
                URL.revokeObjectURL(selectedImageSource);
            };
        }
        return;
    }, [selectedImage, selectedImageSource]);
    return (React.createElement("div", { className: "BaSe--image-picker" },
        React.createElement(HiddenInputFile, { accept: "image/*", multiple: false, ref: inputRef, onChange: handleChange }),
        renderStyle === 'input-field' && (React.createElement(React.Fragment, null,
            React.createElement(BaSeFileInputField, { files: files, hasFiles: !!selectedImageSource, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, pickMultipleFiles: false, pickButtonProps: pickButtonProps, pickInputProps: pickInputProps, onClickToPick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, onClickToRemove: function () {
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete(selectedImage);
                    setSelectedImageSource('');
                    setFiles([]);
                } }),
            selectedImageSource && (React.createElement(BaSeSmall1, { link: {
                    href: selectedImageSource,
                    target: '_blank',
                } }, getMessage('imagePicker.selectedImage'))))),
        renderStyle === 'box' && (React.createElement(React.Fragment, null,
            React.createElement(BaSeFormLabel, { label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps }),
            React.createElement(FilePickerWrapper, { onDragEnter: handleDrag(true), onDragLeave: handleDrag(false), onDragOver: handleDrag(true), onDrop: handleDrop, isDrag: isDrag }, selectedImage ? (React.createElement(React.Fragment, null,
                notFound ? (React.createElement(BaSeIcon, { color: BaSeTheme.colors.institucionais.azulSebrae75, size: 75, name: iconNotFoundPlaceholder, description: getMessage('imagePicker.imageNotFound') })) : (React.createElement(SelectedImage, { imageShape: imageShape, previewImageFit: previewImageFit, src: selectedImageSource, alt: getMessage('imagePicker.selectedImage'), onError: function () { return setNotFound(true); } })),
                React.createElement(ActionButtonWrapper, null,
                    React.createElement(BaSeButton, __assign({}, updateButtonProps, { type: (_b = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.type) !== null && _b !== void 0 ? _b : 'primary', size: (_c = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.size) !== null && _c !== void 0 ? _c : 'small', color: (_d = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.color) !== null && _d !== void 0 ? _d : 'default', leftIcon: (_e = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.leftIcon) !== null && _e !== void 0 ? _e : 'refresh-alt', value: (_f = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.value) !== null && _f !== void 0 ? _f : getMessage('filePicker.buttonUpdateLabel'), onClick: function (clickEvent) {
                            var _a, _b;
                            (_a = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(updateButtonProps, clickEvent);
                            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.click();
                        } })),
                    React.createElement(BaSeButton, __assign({}, deleteButtonProps, { type: (_g = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.type) !== null && _g !== void 0 ? _g : 'primary', size: (_h = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.size) !== null && _h !== void 0 ? _h : 'small', color: (_j = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.color) !== null && _j !== void 0 ? _j : 'default', leftIcon: (_k = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.leftIcon) !== null && _k !== void 0 ? _k : 'trash-alt', value: (_l = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.value) !== null && _l !== void 0 ? _l : getMessage('filePicker.buttonDeleteLabel'), onClick: function (clickEvent) {
                            var _a;
                            (_a = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(deleteButtonProps, clickEvent);
                            onDelete === null || onDelete === void 0 ? void 0 : onDelete(selectedImage);
                            setSelectedImageSource('');
                            setFiles([]);
                        } }))))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { pointerEvents: 'none' } },
                    React.createElement(BaSeIcon, __assign({ color: BaSeTheme.colors.institucionais.cinzaSebrae90, size: 75, name: "image-plus", description: getMessage('imagePicker.imagePlaceholder') }, placeholderImageProps))),
                React.createElement(BaSeButton, __assign({}, pickButtonProps, { type: (_m = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.type) !== null && _m !== void 0 ? _m : 'primary', size: (_o = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.size) !== null && _o !== void 0 ? _o : 'small', color: (_p = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.color) !== null && _p !== void 0 ? _p : 'default', leftIcon: (_q = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.leftIcon) !== null && _q !== void 0 ? _q : 'upload', value: (_r = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.value) !== null && _r !== void 0 ? _r : getMessage('filePicker.buttonPickLabel'), onClick: function (clickEvent) {
                        var _a, _b;
                        (_a = pickButtonProps === null || pickButtonProps === void 0 ? void 0 : pickButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(pickButtonProps, clickEvent);
                        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.click();
                    } })),
                React.createElement(BaSeParagraph, __assign({}, dragInfoProps, { color: (_s = dragInfoProps === null || dragInfoProps === void 0 ? void 0 : dragInfoProps.color) !== null && _s !== void 0 ? _s : BaSeTheme.colors.institucionais.cinzaSebrae45 }), dragInfoText !== null && dragInfoText !== void 0 ? dragInfoText : getMessage('filePicker.image.dragInfo')))))))));
};
BaSeImagePicker.displayName = 'BaSeImagePicker';

var WrapperList = styled.ul.attrs({
    className: 'BaSe--list',
})(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n  max-height: ", ";\n  overflow: auto;\n  padding: 16px 4px;\n  margin: 0;\n\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n  max-height: ", ";\n  overflow: auto;\n  padding: 16px 4px;\n  margin: 0;\n\n  ", "\n"])), function (_a) {
    var columnNum = _a.columnNum;
    return "repeat(".concat(columnNum, ", 1fr)");
}, function (_a) {
    var gap = _a.gap;
    return numberWithUnit(gap);
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return numberWithUnit(maxHeight);
}, BaSeScrollbarCss);
var Wrapperbtn = styled.div(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var WrapperItem = styled.li.attrs({
    className: 'BaSe--list-item',
})(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: ", ";\n"])), function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var direction = _a.direction;
    return direction === 'row-reverse' ? 'space-between' : 'none';
});
var templateObject_1$n, templateObject_2$k, templateObject_3$g;

// import { string } from 'prop-types';
var BaSeList = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'column' : _b, _c = _a.maxHeight, maxHeight = _c === void 0 ? '' : _c, _d = _a.gap, gap = _d === void 0 ? '10px' : _d, _e = _a.valuesList, valuesList = _e === void 0 ? [] : _e, _f = _a.columnNum, columnNum = _f === void 0 ? 1 : _f, _g = _a.listActions, listActions = _g === void 0 ? [
        {
            size: 'medium',
            sizeIcon: 'medium',
            ActionisDisabled: false,
            nameIcon: 'trash-alt',
            color: BaSeTheme.colors.institucionais.azulSebrae36,
            listAction: function () { },
        },
    ] : _g;
    return (React.createElement(WrapperList, { columnNum: columnNum, gap: gap, maxHeight: maxHeight }, valuesList.map(function (item) {
        return (React.createElement(WrapperItem, { key: item.id, direction: direction },
            React.createElement(Wrapperbtn, null, listActions.map(function (action, index) { return (React.createElement(React.Fragment, { key: index },
                React.createElement(BaSeShapeButton, { onClick: function () { return action.listAction(item); }, type: "tertiary", nameIcon: action.nameIcon, size: action.size, sizeIcon: action.sizeIcon, buttonType: "button", isDisabled: action.ActionisDisabled, color: action.color }))); })),
            React.createElement(BaSeParagraph, null, item.label)));
    })));
};
BaSeList.displayName = 'BaSeList';

var ContainerInputList = styled.div.attrs({
    className: 'BaSe--input-list-container',
})(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
});
var WrapperInputList = styled.div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isFlex = _a.isFlex;
    return css(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n    display: ", ";\n    flex-direction: row;\n    position: relative;\n    align-items: stretch;\n  "], ["\n    display: ", ";\n    flex-direction: row;\n    position: relative;\n    align-items: stretch;\n  "])), isFlex ? 'flex' : 'block');
});
var templateObject_1$m, templateObject_2$j, templateObject_3$f;

var BaSeInputList = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.listItems, listItems = _c === void 0 ? {
        valuesList: [],
        direction: 'column',
        listActions: [
            {
                size: 'medium',
                sizeIcon: 'medium',
                ActionisDisabled: false,
                nameIcon: 'trash-alt',
                color: BaSeTheme.colors.institucionais.azulSebrae36,
                listAction: function () { },
            },
        ],
    } : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.nameButton, nameButton = _e === void 0 ? 'plus' : _e, _f = _a.valueButton, valueButton = _f === void 0 ? 'Adicionar' : _f, _g = _a.sizeInput, sizeInput = _g === void 0 ? 'medium' : _g, _h = _a.inputMode, inputMode = _h === void 0 ? 'text' : _h, _j = _a.typeInput, typeInput = _j === void 0 ? 'text' : _j, _k = _a.typeButton, typeButton = _k === void 0 ? 'base-button' : _k, _l = _a.placeholder, placeholder = _l === void 0 ? '' : _l, _m = _a.complement, complement = _m === void 0 ? '' : _m, _o = _a.value, value = _o === void 0 ? '' : _o, _p = _a.label, label = _p === void 0 ? '' : _p, _q = _a.subLabel, subLabel = _q === void 0 ? '' : _q, _r = _a.expandToMaxWidth, expandToMaxWidth = _r === void 0 ? false : _r, maxLength = _a.maxLength, _s = _a.buttonAction, buttonAction = _s === void 0 ? function () { } : _s, 
    // tslint:disable-next-line: trailing-comma
    rest = __rest(_a, ["width", "listItems", "isDisabled", "nameButton", "valueButton", "sizeInput", "inputMode", "typeInput", "typeButton", "placeholder", "complement", "value", "label", "subLabel", "expandToMaxWidth", "maxLength", "buttonAction"]);
    var _t = React.useState(value), newValue = _t[0], setNewValue = _t[1];
    var inputAction = function () {
        buttonAction(newValue);
        setNewValue('');
    };
    return (React.createElement(ContainerInputList, { width: width },
        React.createElement(WrapperInputList, { isFlex: !expandToMaxWidth },
            React.createElement(BaSeInput, __assign({}, rest, { value: newValue, onChange: function (changeValue) { return setNewValue(changeValue); }, label: label, size: sizeInput, subLabel: subLabel, typeInput: typeInput, inputMode: inputMode, complement: complement, width: width, isDisabled: isDisabled, maxLength: maxLength, placeholder: placeholder, iconButton: {
                    typeButton: typeButton,
                    name: nameButton,
                    action: inputAction,
                    type: 'primary',
                    value: valueButton,
                    color: BaSeTheme.colors.institucionais.azulSebrae36,
                } }))),
        React.createElement(BaSeList, __assign({}, listItems))));
};
BaSeInputList.displayName = 'BaSeInputList';

var mapSelectValues = function (color) {
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.attention ||
        color === BaSeTheme.components.button.colors.confirmation;
    if (colorIsMapped) {
        return {
            style: {
                bgC: ColorMapper[color].foreground,
                bcCHover: ColorMapper[color].hover.defaultLight,
                boxShadowFocus: ColorMapper[color].focus.defaultLight,
                border: ColorMapper[color].foreground,
            },
        };
    }
    else {
        var customColorHsv = Color.generateFromHex(color);
        return {
            style: {
                bgC: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                bcCHover: ColorMapper.light.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                boxShadowFocus: ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                border: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        };
    }
};
var mapBaSeSelectColor = {
    default: {
        iconColor: ColorMapper.grayScale.foreground,
        color: BaSeTheme.colors.institucionais.cinzaSebrae60,
        item: BaSeTheme.colors.institucionais.cinzaSebrae30,
        selectedColor: ColorMapper.grayScale.hover.defaultDark,
        borderColor: ColorMapper.grayScale.focus.defaultLight,
        bgC: BaSeTheme.colors.defaultColors.white,
    },
    error: {
        iconColor: BaSeTheme.colors.feedbackInterface.erro35,
        color: BaSeTheme.colors.feedbackInterface.erro35,
        item: BaSeTheme.colors.feedbackInterface.erro35,
        selectedColor: BaSeTheme.colors.feedbackInterface.erro35,
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
        bgC: BaSeTheme.colors.defaultColors.white,
    },
    disabled: {
        iconColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        color: BaSeTheme.colors.institucionais.cinzaSebrae75,
        item: BaSeTheme.colors.institucionais.cinzaSebrae60,
        selectedColor: ColorMapper.grayScale.hover.defaultDark,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        bgC: BaSeTheme.colors.institucionais.cinzaSebrae97,
    },
};

var getPixelsFromSize = function (size, hasLabel) {
    if (hasLabel) {
        return size === 'small' ? 32 : size === 'medium' ? 38 : 43;
    }
    else {
        return size === 'small' ? 9 : size === 'medium' ? 15 : 16;
    }
};
var WrapperSelect = styled.div.attrs({
    className: 'BaSe--select',
})(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  position: relative;\n  width: ", ";\n\n  ", "\n"], ["\n  position: relative;\n  width: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.width, width = _b === void 0 ? 'auto' : _b;
    return numberWithUnit(width);
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n      * {\n        cursor: not-allowed;\n        user-select: none;\n      }\n    "], ["\n      * {\n        cursor: not-allowed;\n        user-select: none;\n      }\n    "])));
});
var WrapperInputLabel = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: transparent;\n  position: relative;\n  margin-bottom: 2px;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: transparent;\n  position: relative;\n  margin-bottom: 2px;\n"])), BaSeTheme.stackOrder.aboveNormal);
var HideTopOfWrapperOptions = styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"], ["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.stackOrder.overlay + 1);
var WrapperOptions = styled.ul.attrs({
    className: 'BaSe--select-options',
})(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-top: none;\n  border-radius: 0px 0px 4px 4px;\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-top: none;\n  border-radius: 0px 0px 4px 4px;\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, BaSeTheme.stackOrder.overlay, BaSeTheme.colors.defaultColors.white, function (_a) {
    var hasError = _a.hasError, border = _a.border;
    return hasError ? mapBaSeSelectColor.error.borderColor : border;
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'auto' : '0px');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1' : '0');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '-3px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError, boxShadowFocus = _a.boxShadowFocus;
    return isOpen
        ? hasError
            ? BaSeTheme.shadows.focusError
            : "0 0 4px ".concat(boxShadowFocus)
        : 'none';
}, BaSeScrollbarCss);
var OptionDetail = styled.div.attrs({
    className: 'BaSe--select-option-detail',
})(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  will-change: opacity, transform, height;\n  position: absolute;\n  left: 25%;\n  width: calc(70% - 2em);\n  padding: 0.5em;\n  border-radius: 0.25em;\n  transform: translateX(125%);\n  cursor: default;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  transition: ", ";\n  height: 0;\n  pointer-events: none;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 1em;\n    left: -0.5em;\n    transform: rotate(270deg) translateX(50%);\n    border-top-right-radius: 0.125em;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0.25em 0.43em 0.25em;\n    border-color: transparent transparent\n      ", " transparent;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  will-change: opacity, transform, height;\n  position: absolute;\n  left: 25%;\n  width: calc(70% - 2em);\n  padding: 0.5em;\n  border-radius: 0.25em;\n  transform: translateX(125%);\n  cursor: default;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  transition: ", ";\n  height: 0;\n  pointer-events: none;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 1em;\n    left: -0.5em;\n    transform: rotate(270deg) translateX(50%);\n    border-top-right-radius: 0.125em;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 0.25em 0.43em 0.25em;\n    border-color: transparent transparent\n      ", " transparent;\n  }\n\n  ", "\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.colors.institucionais.azulSebrae97, BaSeTheme.shadows.profundidade4, BaSeTheme.transitions.allPropertiesContinuousFast, BaSeTheme.colors.defaultColors.white, function (_a) {
    var isOptionPicker = _a.isOptionPicker;
    return isOptionPicker && css(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n      top: 3px;\n      left: auto;\n      right: 1px;\n      max-width: calc(70% - 2em);\n      width: auto;\n    "], ["\n      top: 3px;\n      left: auto;\n      right: 1px;\n      max-width: calc(70% - 2em);\n      width: auto;\n    "])));
});
var OptionDetailHeader = styled.div(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.25em;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.25em;\n"])));
var OptionDetailButton = styled.div(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  position: relative;\n  right: -0.25em;\n  top: -0.25em;\n"], ["\n  position: relative;\n  right: -0.25em;\n  top: -0.25em;\n"])));
var DetailButtonWrapper = styled.span(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject(["\n  z-index: 0;\n  position: absolute;\n  right: 0.5em;\n  top: 0.5em;\n"], ["\n  z-index: 0;\n  position: absolute;\n  right: 0.5em;\n  top: 0.5em;\n"])));
var WrapperOption = styled.li.attrs({
    className: 'BaSe--select-option',
})(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject(["\n  display: flex;\n  transition: ", ";\n  will-change: background-color;\n  padding: 5px;\n  background-color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  & > * {\n    will-change: font-weight;\n  }\n\n  ", "\n\n  ", "\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n\n  &.detail {\n    ", " {\n      opacity: 1;\n      transform: translateX(0);\n      height: auto;\n      z-index: 1;\n      pointer-events: all;\n    }\n\n    ", " {\n      .BaSe--icon:first-of-type {\n        transform: translateX(100%);\n      }\n      .BaSe--icon:last-of-type {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  > img {\n    width: 16px;\n    height: 16px;\n    margin-top: 4px;\n    margin-right: 4px;\n  }\n"], ["\n  display: flex;\n  transition: ", ";\n  will-change: background-color;\n  padding: 5px;\n  background-color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  & > * {\n    will-change: font-weight;\n  }\n\n  ", "\n\n  ", "\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n\n  &.detail {\n    ", " {\n      opacity: 1;\n      transform: translateX(0);\n      height: auto;\n      z-index: 1;\n      pointer-events: all;\n    }\n\n    ", " {\n      .BaSe--icon:first-of-type {\n        transform: translateX(100%);\n      }\n      .BaSe--icon:last-of-type {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  > img {\n    width: 16px;\n    height: 16px;\n    margin-top: 4px;\n    margin-right: 4px;\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var isActive = _a.isActive, multiple = _a.multiple, bcCHover = _a.bcCHover, bgC = _a.bgC;
    return isActive
        ? multiple
            ? bcCHover
            : bgC
        : BaSeTheme.colors.defaultColors.white;
}, function (_a) {
    var hasItemIcon = _a.hasItemIcon, withIcon = _a.withIcon;
    return withIcon &&
        !hasItemIcon && css(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject(["\n      padding-left: 24px;\n    "], ["\n      padding-left: 24px;\n    "])));
}, function (_a) {
    var isOptionPickerItem = _a.isOptionPickerItem;
    return isOptionPickerItem && css(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject(["\n      padding-left: 12px;\n      padding-right: 32px;\n      justify-content: space-between;\n      align-items: flex-start;\n      flex-wrap: nowrap;\n      position: relative;\n    "], ["\n      padding-left: 12px;\n      padding-right: 32px;\n      justify-content: space-between;\n      align-items: flex-start;\n      flex-wrap: nowrap;\n      position: relative;\n    "])));
}, function (_a) {
    var ignoreFocus = _a.ignoreFocus, isActive = _a.isActive, multiple = _a.multiple, bgC = _a.bgC, bcCHover = _a.bcCHover;
    return !ignoreFocus && css(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n      &:focus,\n      &:hover {\n        outline: none;\n        background-color: ", ";\n      }\n    "], ["\n      &:focus,\n      &:hover {\n        outline: none;\n        background-color: ", ";\n      }\n    "])), isActive && !multiple ? bgC : bcCHover);
}, OptionDetail, DetailButtonWrapper);
var WrapperIcon = styled.div(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject(["\n  position: absolute;\n  transition: ", ";\n  will-change: transform;\n  transform: ", ";\n  right: 9px;\n  top: ", "px;\n  width: 16px;\n  height: 16px;\n  & > * {\n    transition: opacity ", ";\n    will-change: transform, opacity;\n    transform: scale(0);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    &:last-child {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n"], ["\n  position: absolute;\n  transition: ", ";\n  will-change: transform;\n  transform: ", ";\n  right: 9px;\n  top: ", "px;\n  width: 16px;\n  height: 16px;\n  & > * {\n    transition: opacity ", ";\n    will-change: transform, opacity;\n    transform: scale(0);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    &:last-child {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var isOpen = _a.isOpen;
    return (!isOpen ? 'rotateX(0)' : 'rotateX(180deg)');
}, function (_a) {
    var vSize = _a.vSize, hasLabel = _a.hasLabel;
    return getPixelsFromSize(vSize, hasLabel);
}, BaSeTheme.transitions.durationNormal);
var SelectInput = styled.input.attrs({
    className: 'BaSe--select-input',
})(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  font-family: ", ";\n  line-height: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  ", ";\n  height: ", "px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  font-size: ", "px;\n  padding: 0px 32px 0px 12px;\n\n  ", "\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:read-only {\n    cursor: default;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    user-select: none;\n  }\n"], ["\n  font-family: ", ";\n  line-height: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  ", ";\n  height: ", "px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  font-size: ", "px;\n  padding: 0px 32px 0px 12px;\n\n  ", "\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:read-only {\n    cursor: default;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    user-select: none;\n  }\n"])), BaSeTheme.typography.fontFamily, function (_a) {
    var hasIcon = _a.hasIcon;
    return hasIcon
        ? css(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject(["\n          width: calc(100% - 62px);\n        "], ["\n          width: calc(100% - 62px);\n        "]))) : css(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n          width: calc(100% - 46px);\n        "], ["\n          width: calc(100% - 46px);\n        "])));
}, function (_a) {
    var vSize = _a.vSize;
    return vSize === 'small' ? 30 : vSize === 'medium' ? 38 : 46;
}, function (_a) {
    var colorType = _a.colorType;
    return mapBaSeSelectColor[colorType].bgC;
}, function (_a) {
    var isOpen = _a.isOpen, border = _a.border, colorType = _a.colorType, menuAlwaysIsOpen = _a.menuAlwaysIsOpen;
    return colorType !== 'default'
        ? mapBaSeSelectColor[colorType].borderColor
        : isOpen && !menuAlwaysIsOpen
            ? border
            : mapBaSeSelectColor[colorType].borderColor;
}, function (_a) {
    var vSize = _a.vSize;
    return (vSize === 'small' ? 13 : 16);
}, function (_a) {
    var hasIcon = _a.hasIcon;
    return hasIcon && css(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n      padding-left: 28px;\n    "], ["\n      padding-left: 28px;\n    "])));
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError, boxShadowFocus = _a.boxShadowFocus, colorType = _a.colorType, bgC = _a.bgC, menuAlwaysIsOpen = _a.menuAlwaysIsOpen;
    return isOpen &&
        !menuAlwaysIsOpen && css(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n      box-shadow: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n    "], ["\n      box-shadow: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n    "])), hasError
        ? BaSeTheme.shadows.focusError
        : "0 0 4px ".concat(boxShadowFocus), mapBaSeSelectColor[colorType].iconColor, bgC);
}, function (_a) {
    var colorType = _a.colorType, hasSelectedOption = _a.hasSelectedOption;
    return css(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), hasSelectedOption
        ? mapBaSeSelectColor[colorType].selectedColor
        : mapBaSeSelectColor[colorType].color);
});
styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"], ["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"])), BaSeTheme.colors.feedbackInterface.erro35, BaSeTheme.typography.fontFamily);
var StyledLabel = styled.label(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n"])), function (props) { return props.fontSize; }, function (props) { return props.lineHeight; }, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.typography.fontFamily);
styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var StyledSubLabel = styled.label(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 1.46em;\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  margin-left: 4px;\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 1.46em;\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  margin-left: 4px;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.colors.institucionais.cinzaSebrae60);
var ButtonInfoContainerHelper = styled.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var MoreInfoContainer$1 = styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var WrapperHelper$1 = styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  padding-top: 2px;\n"], ["\n  padding-top: 2px;\n"])));
var WrapperMultipleInformation = styled.li(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  color: ", ";\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: ", ";\n\n  ", "\n\n  &:focus,\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  color: ", ";\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: ", ";\n\n  ", "\n\n  &:focus,\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.colors.defaultColors.white, BaSeTheme.stackOrder.overlay, function (_a) {
    var isOptionPickerItem = _a.isOptionPickerItem;
    return isOptionPickerItem && css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n      padding-left: 12px;\n    "], ["\n      padding-left: 12px;\n    "])));
}, function (_a) {
    var bcCHover = _a.bcCHover;
    return bcCHover;
});
styled.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var OptionWithIconSelected = styled.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  position: absolute;\n  left: 9px;\n  width: 16px;\n  height: 16px;\n  top: ", "px;\n"], ["\n  position: absolute;\n  left: 9px;\n  width: 16px;\n  height: 16px;\n  top: ", "px;\n"])), function (_a) {
    var vSize = _a.vSize, hasLabel = _a.hasLabel;
    return getPixelsFromSize(vSize, hasLabel);
});
styled.span(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  img.BaSe--icon {\n    float: left;\n    width: 1.46em;\n    height: 1.46em;\n  }\n"], ["\n  img.BaSe--icon {\n    float: left;\n    width: 1.46em;\n    height: 1.46em;\n  }\n"])));
var templateObject_1$l, templateObject_2$i, templateObject_3$e, templateObject_4$d, templateObject_5$b, templateObject_6$a, templateObject_7$7, templateObject_8$7, templateObject_9$7, templateObject_10$7, templateObject_11$5, templateObject_12$5, templateObject_13$4, templateObject_14$4, templateObject_15$3, templateObject_16$2, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33;

var idSequence$4 = idGenerator();
/**
 * @deprecated use BaSeOptionPicker
 */
var BaSeMultipleSelect = function (_a) {
    var _b, _c;
    var externalId = _a.id, name = _a.name, dataset = _a.dataset, _d = _a.initialSelectedValuesId, initialSelectedValuesId = _d === void 0 ? [0] : _d, _e = _a.values, values = _e === void 0 ? [] : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.subLabel, subLabel = _g === void 0 ? '' : _g, _h = _a.complement, complement = _h === void 0 ? '' : _h, _j = _a.moreInfoLabel, moreInfoLabel = _j === void 0 ? '' : _j, _k = _a.moreInfoDetails, moreInfoDetails = _k === void 0 ? '' : _k, _l = _a.showHelpButton, showHelpButton = _l === void 0 ? false : _l, _m = _a.helpButtonProps, helpButtonProps = _m === void 0 ? {} : _m, _o = _a.size, size = _o === void 0 ? 'medium' : _o, _p = _a.width, width = _p === void 0 ? null : _p, _q = _a.isDisabled, isDisabled = _q === void 0 ? false : _q, _r = _a.hasError, hasError = _r === void 0 ? false : _r, _s = _a.color, color = _s === void 0 ? 'default' : _s, _t = _a.overrideColor, overrideColor = _t === void 0 ? {} : _t, _u = _a.onChange, onChange = _u === void 0 ? function () { } : _u, _v = _a.emptyValueLabel, emptyValueLabel = _v === void 0 ? '' : _v;
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence$4);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var getColorsAtributes = function () {
        if (color) {
            return mapSelectValues(color);
        }
        return mapSelectValues('default');
    };
    var _w = getColorsAtributes().style, bcCHover = _w.bcCHover, bgC = _w.bgC, boxShadowFocus = _w.boxShadowFocus, border = _w.border;
    emptyValueLabel =
        emptyValueLabel === '' ? getMessage('select.emptyValue') : emptyValueLabel;
    var _x = React.useState('default'), colorType = _x[0], setColorType = _x[1];
    var _y = React.useState(false), isOpen = _y[0], setIsOpen = _y[1];
    var _z = React.useState(initialSelectedValuesId), selectedValuesId = _z[0], setSelectedValuesId = _z[1];
    var _0 = React.useState([]), refValues = _0[0], setRefValues = _0[1];
    var formattedDataset = getFormattedDataset(dataset);
    React.useEffect(function () {
        setRefValues(values.map(function (item) { return (__assign(__assign({}, item), { ref: React.createRef() })); }));
    }, [values]);
    React.useEffect(function () {
        setSelectedValuesId(initialSelectedValuesId);
    }, [initialSelectedValuesId.toString()]);
    var selectInputRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, setIsOpen);
    React.useEffect(function () {
        setColorType(isDisabled ? 'disabled' : hasError ? 'error' : 'default');
    }, [hasError, isDisabled]);
    function emitChange() {
        var emitValues = values.filter(function (val) { return selectedValuesId.indexOf(val.id) > -1; });
        onChange(emitValues);
    }
    React.useEffect(function () {
        emitChange();
    }, [selectedValuesId.toString()]);
    var updateValue = React.useCallback(function (selected) {
        if (selectedValuesId.indexOf(selected.id) > -1) {
            return setSelectedValuesId(function (input) {
                return input.filter(function (val) { return val !== selected.id; });
            });
        }
        setSelectedValuesId(function (input) { return input.concat([selected.id]); });
    }, [selectedValuesId]);
    var selectAll = React.useCallback(function () {
        if (refValues.length > selectedValuesId.length) {
            setSelectedValuesId(refValues.map(function (option) { return option.id; }));
        }
        else {
            setSelectedValuesId([]);
        }
    }, [refValues, selectedValuesId]);
    var onFocusInput = React.useCallback(function () { return setIsOpen(!isDisabled && true); }, [isDisabled]);
    var onClose = React.useCallback(function () { }, []);
    React.useEffect(function () {
        var _a;
        if (isDisabled) {
            return;
        }
        if (isOpen) {
            (_a = selectInputRef === null || selectInputRef === void 0 ? void 0 : selectInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            onClose();
        }
    }, [isOpen]);
    return (React.createElement(WrapperSelect, { ref: wrapperRef, isDisabled: isDisabled, width: width },
        React.createElement(WrapperInputLabel, null,
            React.createElement(StyledLabel, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, label),
            React.createElement(StyledSubLabel, { htmlFor: id }, subLabel),
            showHelpButton && (React.createElement(ButtonInfoContainerHelper, null,
                React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
        React.createElement(WrapperIcon, { hasLabel: !!label, vSize: size, isOpen: isOpen, searchable: false },
            React.createElement(BaSeIcon, { description: isOpen
                    ? getMessage('select.closeOptions')
                    : getMessage('select.openOptions'), name: "arrow-head-down", size: 16, onClick: isDisabled
                    ? undefined
                    : function () { return setIsOpen(function (actualState) { return !actualState; }); }, color: isDisabled
                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                    : (_b = overrideColor.iconColor) !== null && _b !== void 0 ? _b : bgC })),
        React.createElement(SelectInput, __assign({ id: id, name: name }, formattedDataset, { ref: selectInputRef, hasSelectedOption: false, disabled: isDisabled, vSize: size, boxShadowFocus: boxShadowFocus, readOnly: true, border: border, bgC: mapBaSeSelectColor[colorType].iconColor, colorType: colorType, value: selectedValuesId.length < 1
                ? emptyValueLabel
                : selectedValuesId.length > 3
                    ? getMessage('select.selectedCounter', selectedValuesId.length)
                    : joinWithSeparators(refValues
                        .filter(function (val) { return selectedValuesId.indexOf(val.id) > -1; })
                        .map(function (val) { return val.label; }), getMessage('list.separator'), getMessage('list.finalSeparator')), isOpen: isOpen, hasError: hasError, onChange: function (newValue) { return updateValue(newValue); }, onFocus: onFocusInput })),
        refValues.length > 0 && (React.createElement(React.Fragment, null,
            isOpen && React.createElement(HideTopOfWrapperOptions, null),
            React.createElement(WrapperOptions, { border: border, boxShadowFocus: boxShadowFocus, isOpen: isOpen, role: "menu", hasError: hasError },
                React.createElement(WrapperMultipleInformation, { tabIndex: 0, bcCHover: (_c = overrideColor.selectHoverColor) !== null && _c !== void 0 ? _c : bcCHover, onKeyDown: function (event) { return event.key === 'Enter' && selectAll(); }, onClick: function (e) {
                        e.preventDefault();
                        selectAll();
                    } },
                    React.createElement(BaSeCheckbox, { align: "top-left", isInteractive: false, color: color, label: getMessage('select.selectAll'), size: "medium", indeterminate: selectedValuesId.length !== refValues.length, checked: selectedValuesId.length > 0 })),
                refValues.map(function (option) {
                    var _a;
                    return (React.createElement(WrapperOption, { ref: option.ref, key: option.id.toString(), multiple: true, bcCHover: (_a = overrideColor.selectHoverColor) !== null && _a !== void 0 ? _a : bcCHover, bgC: bgC, isActive: false, role: "menuitem", tabIndex: 0, onKeyDown: function (event) {
                            return event.key === 'Enter' && updateValue(option);
                        }, onClick: function (e) {
                            e.preventDefault();
                            updateValue(option);
                        }, onFocus: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('focus'); }, onBlur: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('focus'); } },
                        React.createElement(BaSeCheckbox, { align: "top-left", isInteractive: false, label: option.label, color: color, size: "medium", checked: selectedValuesId.indexOf(option.id) > -1 })));
                })))),
        !!complement && (React.createElement(WrapperHelper$1, null,
            React.createElement(BaSeHelperText, { isItalic: true, size: "medium", color: mapBaSeSelectColor[colorType].color, label: complement }))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$1, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails, color: bgC })))));
};
BaSeMultipleSelect.displayName = 'BaSeMultipleSelect';

var mapSizeRadio = {
    small: 13,
    medium: 16,
};
var mapRadioValues = function (color) {
    var isDisabled = color === 'disabled';
    return {
        primary: {
            generalColors: {
                iconColor: BaSeTheme.colors.defaultColors.white,
                style: {
                    bgC: ColorMapper[color].foreground,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : ColorMapper[color].hover.defaultDark,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : ColorMapper[color].focus.defaultLight,
                    border: isDisabled
                        ? ColorMapper.disabled.foreground
                        : ColorMapper[color].foreground,
                },
            },
            negative: {
                iconColor: ColorMapper[color].foreground,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.white,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : BaSeTheme.colors.institucionais.cinzaSebrae97,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : BaSeTheme.colors.institucionais.azulSebrae90,
                    border: isDisabled ? ColorMapper.disabled.foreground : 'none',
                },
            },
        },
    };
};
var mapCustomColorsRadioValues = function (customColor) {
    var customColorHsv = Color.generateFromHex(customColor);
    return {
        primary: {
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                bcCHover: ColorMapper.dark.hover.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                boxShadowFocus: ColorMapper.light.focus.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        },
    };
};

var RadioWrapper = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var RadioMarker = styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  border-radius: ", ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: ", ";\n  transition: ", ";\n  background: ", ";\n  ", "\n"], ["\n  border-radius: ", ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: ", ";\n  transition: ", ";\n  background: ", ";\n  ", "\n"])), function (_a) {
    var shape = _a.shape;
    return (shape === 'circle' ? '50%' : '25%');
}, BaSeTheme.stackOrder.normal, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var checked = _a.checked;
    return checked
        ? css(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n          width: calc(100% - 10px);\n          height: calc(100% - 10px);\n        "], ["\n          width: calc(100% - 10px);\n          height: calc(100% - 10px);\n        "]))) : css(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n          width: 0;\n          height: 0;\n        "], ["\n          width: 0;\n          height: 0;\n        "])));
});
var ContainerRadio = styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  margin: 5px;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n  min-height: 18px;\n  min-width: 18px;\n  position: relative;\n  display: flex;\n\n  &::before {\n    content: '';\n    border-radius: ", ";\n    border: 2px solid\n      ", ";\n    background: ", ";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    box-sizing: border-box;\n    pointer-events: none;\n    z-index: ", ";\n  }\n  ", ";\n"], ["\n  margin: 5px;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n  min-height: 18px;\n  min-width: 18px;\n  position: relative;\n  display: flex;\n\n  &::before {\n    content: '';\n    border-radius: ", ";\n    border: 2px solid\n      ", ";\n    background: ", ";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    box-sizing: border-box;\n    pointer-events: none;\n    z-index: ", ";\n  }\n  ", ";\n"])), function (_a) {
    var shape = _a.shape;
    return (shape === 'circle' ? '50%' : '0.25em');
}, function (_a) {
    var disabled = _a.disabled, checked = _a.checked, border = _a.border;
    return checked
        ? border
        : disabled
            ? BaSeTheme.colors.institucionais.cinzaSebrae90
            : BaSeTheme.colors.institucionais.cinzaSebrae75;
}, function (_a) {
    var disabled = _a.disabled, checked = _a.checked, iconColor = _a.iconColor;
    return checked
        ? iconColor
        : disabled
            ? BaSeTheme.colors.institucionais.cinzaSebrae97
            : BaSeTheme.colors.defaultColors.white;
}, BaSeTheme.stackOrder.default, function (_a) {
    var disabled = _a.disabled, checked = _a.checked, backgroundOnHover = _a.backgroundOnHover;
    return !disabled && css(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n      &:hover,\n      &.hover {\n        &::before {\n          border: 2px solid\n            ", ";\n        }\n        & ", " {\n          background: ", ";\n        }\n      }\n    "], ["\n      &:hover,\n      &.hover {\n        &::before {\n          border: 2px solid\n            ", ";\n        }\n        & ", " {\n          background: ", ";\n        }\n      }\n    "])), function () {
        return checked
            ? backgroundOnHover
            : BaSeTheme.colors.institucionais.azulSebrae30;
    }, RadioMarker, backgroundOnHover);
});
var InputRadio = styled.input.attrs({ type: 'radio' })(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  opacity: 0;\n  z-index: ", ";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  opacity: 0;\n  z-index: ", ";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), BaSeTheme.stackOrder.normal + 1);
var LabelRadio = styled.label(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject(["\n  display: block;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: ", ";\n  line-height: 1.46em;\n  font-size: ", "px;\n  width: ", ";\n  ", ";\n"], ["\n  display: block;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: ", ";\n  line-height: 1.46em;\n  font-size: ", "px;\n  width: ", ";\n  ", ";\n"])), BaSeTheme.typography.fontFamily, function (_a) {
    var _b;
    var size = _a.size;
    return (_b = mapSizeRadio[size]) !== null && _b !== void 0 ? _b : mapSizeRadio.medium;
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? css(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n          color: ", ";\n          cursor: not-allowed;\n        "], ["\n          color: ", ";\n          cursor: not-allowed;\n        "])), BaSeTheme.colors.institucionais.cinzaSebrae75) : css(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n          color: ", ";\n          cursor: pointer;\n        "], ["\n          color: ", ";\n          cursor: pointer;\n        "])), BaSeTheme.colors.institucionais.cinzaSebrae30);
});
var templateObject_1$k, templateObject_2$h, templateObject_3$d, templateObject_4$c, templateObject_5$a, templateObject_6$9, templateObject_7$6, templateObject_8$6, templateObject_9$6, templateObject_10$6;

var BaSeRadio = function (_a) {
    var id = _a.id, name = _a.name, dataset = _a.dataset, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.labelWidth, labelWidth = _c === void 0 ? 'auto' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.checked, checked = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.color, color = _g === void 0 ? 'default' : _g, _h = _a.shape, shape = _h === void 0 ? 'circle' : _h, _j = _a.onChange, onChange = _j === void 0 ? function () { } : _j;
    if (!name) {
        throw Error('Atributo "name" é obrigatório no BaSeRadio');
    }
    if (!id) {
        throw Error('Atributo "id" é obrigatório no BaSeRadio');
    }
    var _k = React.useState(false), hover = _k[0], setHover = _k[1];
    var formattedDataset = getFormattedDataset(dataset);
    var changeValue = function () { return onChange(id); };
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation ||
        color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b;
        if (color) {
            if (!colorIsMapped) {
                return mapCustomColorsRadioValues(color).primary;
            }
            else {
                if (color === BaSeTheme.components.button.colors.negative) {
                    return (_a = mapRadioValues('default').primary) === null || _a === void 0 ? void 0 : _a.negative;
                }
                return (_b = mapRadioValues(color).primary) === null || _b === void 0 ? void 0 : _b.generalColors;
            }
        }
        else {
            return mapRadioValues('default').primary.generalColors;
        }
    };
    var buttonValues = disabled
        ? color === 'negative'
            ? mapRadioValues('disabled').primary.negative
            : mapRadioValues('disabled').primary.generalColors
        : getColorsAtributes();
    var _l = buttonValues.style, bgC = _l.bgC, border = _l.border, bcCHover = _l.bcCHover, iconColor = buttonValues.iconColor;
    return (React.createElement(RadioWrapper, { className: "BaSe--radio" },
        React.createElement(ContainerRadio, { className: "BaSe--radio-marker-container ".concat(hover ? 'hover' : ''), shape: shape, checked: checked, disabled: disabled, backgroundColor: bgC, border: border, iconColor: iconColor, backgroundOnHover: bcCHover },
            React.createElement(InputRadio, __assign({ className: "BaSe--radio-input", onChange: changeValue, id: id, name: name }, formattedDataset, { value: id, checked: checked, "aria-checked": checked, disabled: disabled })),
            React.createElement(RadioMarker, { className: "BaSe--radio-marker", shape: shape, checked: checked, disabled: disabled, backgroundColor: bgC, border: border, backgroundOnHover: bcCHover, iconColor: iconColor })),
        React.createElement(LabelRadio, { className: "BaSe--radio-label", disabled: disabled, size: size, width: labelWidth, onClick: function () { return !disabled && onChange(id); }, onPointerEnter: function () { return setHover(true); }, onPointerLeave: function () { return setHover(false); } }, label)));
};
BaSeRadio.displayName = 'BaSeRadio';

var idSequence$3 = idGenerator();
function filteredEmptyValue(list, removeEmptyValue, emptyValueLabel) {
    if (removeEmptyValue) {
        return list.filter(function (item) { return item.label !== emptyValueLabel; });
    }
    return list;
}
var ExtraAction = function (_a) {
    var _b = _a.extraAction, label = _b.label, onClick = _b.onClick, iconName = _b.iconName, _c = _a.search, search = _c === void 0 ? '' : _c, bcCHover = _a.bcCHover, bgC = _a.bgC, color = _a.color, afterClick = _a.afterClick;
    var ref = React.useRef(null);
    var onClickExtraAction = function () {
        onClick(search);
        afterClick();
    };
    return (React.createElement(WrapperOption, { ref: ref, isActive: false, multiple: false, role: "menuitem", onKeyDown: function (event) { return event.key === 'Enter' && onClickExtraAction(); }, onClick: function (e) {
            e.preventDefault();
            onClickExtraAction();
        }, bgC: bgC, bcCHover: bcCHover, onFocus: function () { var _a; return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.classList.add('focus'); }, onBlur: function () { var _a; return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.classList.remove('focus'); } },
        iconName && (React.createElement(BaSeIcon, { name: iconName !== null && iconName !== void 0 ? iconName : '', color: color, size: 16, description: "\u00CDcone da a\u00E7\u00E3o: ".concat(label) })),
        React.createElement(BaSeText, { color: color }, label)));
};
/**
 * @deprecated use BaSeOptionPicker
 */
var BaSeSelect = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var externalId = _a.id, name = _a.name, dataset = _a.dataset, _j = _a.complement, complement = _j === void 0 ? '' : _j, _k = _a.hasError, hasError = _k === void 0 ? false : _k, _l = _a.label, label = _l === void 0 ? '' : _l, _m = _a.searchable, searchable = _m === void 0 ? false : _m, _o = _a.selectedValueId, selectedValueId = _o === void 0 ? 0 : _o, _p = _a.subLabel, subLabel = _p === void 0 ? '' : _p, _q = _a.showHelpButton, showHelpButton = _q === void 0 ? false : _q, _r = _a.values, values = _r === void 0 ? [] : _r, _s = _a.width, width = _s === void 0 ? null : _s, _t = _a.size, size = _t === void 0 ? 'medium' : _t, _u = _a.emptyValueLabel, emptyValueLabel = _u === void 0 ? '' : _u, _v = _a.isDisabled, isDisabled = _v === void 0 ? false : _v, _w = _a.helpButtonProps, helpButtonProps = _w === void 0 ? {} : _w, _x = _a.moreInfoLabel, moreInfoLabel = _x === void 0 ? '' : _x, _y = _a.moreInfoDetails, moreInfoDetails = _y === void 0 ? '' : _y, _z = _a.removeEmptyValue, removeEmptyValue = _z === void 0 ? false : _z, _0 = _a.color, color = _0 === void 0 ? 'default' : _0, _1 = _a.overrideColor, overrideColor = _1 === void 0 ? {} : _1, _2 = _a.extraActions, extraActions = _2 === void 0 ? [] : _2, _3 = _a.onChange, onChange = _3 === void 0 ? function () { } : _3;
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence$3);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var getColorsAtributes = function () {
        if (color) {
            return mapSelectValues(color);
        }
        return mapSelectValues('default');
    };
    var _4 = getColorsAtributes().style, bcCHover = _4.bcCHover, bgC = _4.bgC, boxShadowFocus = _4.boxShadowFocus, border = _4.border;
    emptyValueLabel =
        emptyValueLabel === '' ? getMessage('select.emptyValue') : emptyValueLabel;
    var formattedDataset = getFormattedDataset(dataset);
    var memoValues = React.useMemo(function () {
        if (!Array.isArray(values)) {
            return [];
        }
        return values;
    }, [values.toString()]); // Nem repara nisso… Vai entender? ¯\_(ツ)_/¯
    var emptyValue = React.useMemo(function () { return ({ label: emptyValueLabel, id: 0 }); }, []);
    var originalValues = React.useMemo(function () {
        return __spreadArray([
            emptyValue
        ], filteredEmptyValue(memoValues, removeEmptyValue, emptyValueLabel), true).map(function (item) { return (__assign(__assign({}, item), { ref: React.createRef() })); });
    }, [memoValues]);
    var externalSelectedValues = React.useMemo(function () {
        return Array.isArray(selectedValueId) ? selectedValueId : [selectedValueId];
    }, [selectedValueId]);
    var initialSelectedValues = React.useMemo(function () {
        return originalValues.filter(function (s) {
            return externalSelectedValues.some(function (valueId) { return s.id === valueId; });
        });
    }, [
        originalValues.map(function (val) { return val.id; }).toString(),
        externalSelectedValues.toString(),
    ]);
    var withIcon = React.useMemo(function () { return memoValues.some(function (item) { var _a; return (_a = item.icon) !== null && _a !== void 0 ? _a : false; }); }, [memoValues]);
    var _5 = React.useState('default'), colorType = _5[0], setColorType = _5[1];
    var _6 = React.useState(true), firstTimeEmited = _6[0], setFirstTimeEmited = _6[1];
    var _7 = React.useState(''), searchableText = _7[0], setSearchableText = _7[1];
    var _8 = React.useState(false), isOpen = _8[0], setIsOpen = _8[1];
    var _9 = React.useState([]), allValues = _9[0], setAllValues = _9[1];
    var _10 = React.useState([originalValues[0]]), selectedValues = _10[0], setSelectedValues = _10[1];
    var selectInputRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, setIsOpen);
    React.useEffect(function () {
        setColorType(isDisabled ? 'disabled' : hasError ? 'error' : 'default');
    }, [hasError, isDisabled]);
    var emitChange = React.useCallback(function () {
        if (firstTimeEmited) {
            setFirstTimeEmited(false);
            return;
        }
        function valueToEmit(val) {
            var finalValue = __assign({}, val);
            delete finalValue.ref;
            return finalValue;
        }
        onChange(valueToEmit(selectedValues[0]));
        return;
    }, [selectedValues]);
    var setSingleValue = React.useCallback(function (selected, noClose) {
        if (!noClose) {
            setIsOpen(false);
        }
        if (selected.id === 0) {
            setSearchableText('');
        }
        setSelectedValues([selected]);
    }, []);
    var updateValue = React.useCallback(function (selected, isNotInputEvent, noClose) {
        if (isNotInputEvent === void 0) { isNotInputEvent = false; }
        if (noClose === void 0) { noClose = false; }
        if (isNotInputEvent) {
            setAllValues(originalValues);
            setSingleValue(selected, noClose);
        }
        else {
            var valueFromTarget_1 = selected.target.value;
            var filteredValues = filteredEmptyValue(originalValues, removeEmptyValue, emptyValueLabel).filter(function (item) {
                return normalize(item.label).includes(normalize(valueFromTarget_1));
            });
            setSearchableText(valueFromTarget_1);
            setAllValues(filteredValues);
        }
    }, [originalValues]);
    var onFocusInput = React.useCallback(function () { return setIsOpen(!isDisabled && true); }, [isDisabled]);
    var onKeyDownWrapper = React.useCallback(function (key) {
        if (['ArrowUp', 'ArrowDown'].includes(key)) {
            var focusedIndex_1 = allValues.findIndex(function (option) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = option === null || option === void 0 ? void 0 : option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.contains) === null || _d === void 0 ? void 0 : _d.call(_c, 'focus'); });
            selectedValues.map(function (value) {
                var _a, _b;
                var activeIndex = allValues.findIndex(function (option) { return option.id === value.id; });
                var actualIndex = focusedIndex_1 > -1 ? focusedIndex_1 : activeIndex;
                var nextIndex = actualIndex + (key === 'ArrowDown' ? 1 : -1);
                var nextItem = allValues === null || allValues === void 0 ? void 0 : allValues[nextIndex];
                (_b = (_a = nextItem === null || nextItem === void 0 ? void 0 : nextItem.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            });
        }
    }, [selectedValues, allValues]);
    var allValuesFiltered = React.useMemo(function () { return filteredEmptyValue(allValues, removeEmptyValue, emptyValueLabel); }, [allValues, removeEmptyValue, emptyValueLabel]);
    var onClose = React.useCallback(function () {
        allValues.forEach(function (_a) {
            var _b, _c, _d;
            var ref = _a.ref;
            return (_d = (_c = (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c, 'focus');
        });
        setSearchableText('');
    }, [allValues]);
    React.useEffect(function () {
        emitChange();
    }, [selectedValues]);
    React.useEffect(function () {
        initialSelectedValues.forEach(function (value) { return updateValue(value, true, true); });
    }, [initialSelectedValues]);
    React.useEffect(function () {
        setAllValues(originalValues);
    }, [originalValues]);
    React.useEffect(function () {
        var _a;
        if (isDisabled) {
            return;
        }
        if (isOpen) {
            (_a = selectInputRef === null || selectInputRef === void 0 ? void 0 : selectInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            onClose();
        }
    }, [isOpen]);
    var hasAllFiltered = allValuesFiltered.length > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(WrapperSelect, { ref: wrapperRef, isDisabled: isDisabled, width: width, onKeyDown: function (event) { return onKeyDownWrapper(event.key); } },
            React.createElement(BaSeFormLabel, { id: id, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps }),
            React.createElement(WrapperIcon, { hasLabel: !!label, vSize: size, isOpen: isOpen, searchable: searchable },
                React.createElement(BaSeIcon, { description: isOpen
                        ? getMessage('select.closeOptions')
                        : getMessage('select.openOptions'), name: "arrow-head-down", size: 16, onClick: isDisabled
                        ? undefined
                        : function () { return setIsOpen(function (actualState) { return !actualState; }); }, color: isDisabled
                        ? BaSeTheme.colors.institucionais.cinzaSebrae75
                        : (_b = overrideColor.iconColor) !== null && _b !== void 0 ? _b : bgC }),
                searchable && selectedValues && isOpen && (React.createElement(BaSeIcon, { description: getMessage('select.cleanSearch'), name: "close", size: 16, onClick: isDisabled
                        ? undefined
                        : function () { return updateValue(emptyValue, true, true); }, color: isDisabled
                        ? BaSeTheme.colors.institucionais.cinzaSebrae75
                        : (_c = overrideColor.iconColor) !== null && _c !== void 0 ? _c : bgC }))),
            React.createElement(OptionWithIconSelected, { hasLabel: !!label, vSize: size }, selectedValues[0].icon && !isOpen && (React.createElement(BaSeIcon, { name: (_d = selectedValues[0].icon) !== null && _d !== void 0 ? _d : '', color: mapBaSeSelectColor[colorType].item, description: (_f = (_e = selectedValues[0]) === null || _e === void 0 ? void 0 : _e.iconDescription) !== null && _f !== void 0 ? _f : getMessage('icon.label', selectedValues[0].label), size: 16 }))),
            React.createElement(SelectInput, __assign({ id: id, name: name }, formattedDataset, { ref: selectInputRef, hasSelectedOption: selectedValues[0].label !== emptyValueLabel, disabled: isDisabled, readOnly: !searchable, vSize: size, boxShadowFocus: boxShadowFocus, border: border, bgC: searchable ? bgC : mapBaSeSelectColor[colorType].iconColor, colorType: colorType, value: searchable && isOpen
                    ? searchableText
                    : selectedValues.length > 3
                        ? getMessage('select.selectedCounter', selectedValues.filter(function (val) { return val.id !== 0; }).length)
                        : joinWithSeparators(selectedValues.map(function (val) { return val.label; }), getMessage('list.separator'), getMessage('list.finalSeparator')), isOpen: isOpen, hasIcon: selectedValues[0].icon !== undefined, hasError: hasError, onChange: function (newValue) { return updateValue(newValue); }, onFocus: onFocusInput })),
            (hasAllFiltered || extraActions.length > 0) && (React.createElement(React.Fragment, null,
                isOpen && React.createElement(HideTopOfWrapperOptions, null),
                React.createElement(WrapperOptions, { border: border, boxShadowFocus: boxShadowFocus, isOpen: isOpen, role: "menu", hasError: hasError },
                    hasAllFiltered ? (allValuesFiltered.map(function (option) {
                        var _a, _b, _c, _d, _e;
                        return (React.createElement(WrapperOption, { ref: option.ref, key: option.id.toString(), multiple: false, withIcon: withIcon, hasItemIcon: option.icon !== undefined, bcCHover: (_a = overrideColor.selectHoverColor) !== null && _a !== void 0 ? _a : bcCHover, bgC: (_b = overrideColor.selectedBackgroundColor) !== null && _b !== void 0 ? _b : bgC, isActive: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1, role: "menuitem", tabIndex: -1, onKeyDown: function (event) {
                                return event.key === 'Enter' && updateValue(option, true);
                            }, onClick: function (e) {
                                e.preventDefault();
                                updateValue(option, true);
                            }, onFocus: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('detail'); }, onBlur: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('detail'); }, onPointerEnter: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('detail'); }, onPointerLeave: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('detail'); } },
                            option.icon && (React.createElement(BaSeIcon, { name: (_c = option.icon) !== null && _c !== void 0 ? _c : '', color: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1
                                    ? BaSeTheme.colors.defaultColors.white
                                    : mapBaSeSelectColor[colorType].item, size: "1em", description: (_d = option.iconDescription) !== null && _d !== void 0 ? _d : getMessage('icon.label', option.label) })),
                            React.createElement(BaSeText, { color: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1
                                    ? BaSeTheme.colors.defaultColors.white
                                    : mapBaSeSelectColor[colorType].item }, option.label),
                            option.detail && (React.createElement(React.Fragment, null,
                                React.createElement(BaSeBreakpointConsumer, null, function (_a) {
                                    var inTablet = _a.inTablet;
                                    return !inTablet && (React.createElement(DetailButtonWrapper, null,
                                        React.createElement(BaSeIcon, { color: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1
                                                ? BaSeTheme.colors.defaultColors.white
                                                : mapBaSeSelectColor[colorType].item, name: "question-circle", size: "1em", description: getMessage('select.showDetail'), onClick: function (e) {
                                                var _a, _b;
                                                e.stopPropagation();
                                                (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                                            } })));
                                }),
                                React.createElement(OptionDetail, { onClick: function (e) { return e.stopPropagation(); } },
                                    React.createElement(BaSeSmall1, { color: (_e = overrideColor.selectedBackgroundColor) !== null && _e !== void 0 ? _e : bgC, isBold: true }, option.detail.title),
                                    React.createElement(BaSeSmall1, { color: mapBaSeSelectColor[colorType].item, isThin: true }, option.detail.description))))));
                    })) : (React.createElement(WrapperOption, { multiple: false, withIcon: false, bcCHover: (_g = overrideColor.selectHoverColor) !== null && _g !== void 0 ? _g : bcCHover, bgC: (_h = overrideColor.selectedBackgroundColor) !== null && _h !== void 0 ? _h : bgC, isActive: false, role: "menuitem", tabIndex: -1 },
                        React.createElement(BaSeText, { color: mapBaSeSelectColor[colorType].item }, "Nenhum item encontrado."))),
                    extraActions.map(function (action, index) {
                        var _a, _b;
                        return (React.createElement(ExtraAction, { extraAction: action, search: searchableText, key: index, color: mapBaSeSelectColor[colorType].item, bcCHover: (_a = overrideColor.selectedBackgroundColor) !== null && _a !== void 0 ? _a : bcCHover, bgC: (_b = overrideColor.selectedBackgroundColor) !== null && _b !== void 0 ? _b : bgC, afterClick: function () {
                                setIsOpen(false);
                            } }));
                    })))),
            !!complement && (React.createElement(WrapperHelper$1, null,
                React.createElement(BaSeHelperText, { isItalic: true, size: "medium", color: mapBaSeSelectColor[colorType].color, label: complement }))),
            !!moreInfoLabel && (React.createElement(MoreInfoContainer$1, null,
                React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails, color: bgC }))))));
};
BaSeSelect.displayName = 'BaSeSelect';

var ContainerSelectList = styled.div.attrs({
    className: 'BaSe--select-list-container',
})(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
});
var WrapperSelectList = styled.div.attrs({
    className: 'BaSe--select-list',
})(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: flex-end;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: flex-end;\n  gap: ", ";\n"])), function (_a) {
    var gap = _a.gap;
    return numberWithUnit(gap);
});
var templateObject_1$j, templateObject_2$g;

var BaSeSelectList = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.gapButton, gapButton = _c === void 0 ? '8px' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.listItems, listItems = _e === void 0 ? {
        valuesList: [],
        direction: 'column',
        listActions: [
            {
                size: 'medium',
                sizeIcon: 'medium',
                ActionisDisabled: false,
                nameIcon: 'trash-alt',
                color: BaSeTheme.colors.institucionais.azulSebrae36,
                listAction: function () { },
            },
        ],
    } : _e, valueButton = _a.valueButton, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.subLabel, subLabel = _g === void 0 ? '' : _g, _h = _a.values, values = _h === void 0 ? [] : _h, _j = _a.sizeInput, sizeInput = _j === void 0 ? 'medium' : _j, _k = _a.nameButton, nameButton = _k === void 0 ? 'plus' : _k, _l = _a.selectIdValue, selectIdValue = _l === void 0 ? 0 : _l, _m = _a.buttonAction, buttonAction = _m === void 0 ? function () { } : _m;
    var _o = React.useState(selectIdValue), newValue = _o[0], setNewValue = _o[1];
    var inputAction = function () {
        buttonAction(newValue.label);
    };
    return (React.createElement(ContainerSelectList, { width: width },
        React.createElement(WrapperSelectList, { gap: gapButton },
            React.createElement(BaSeSelect, { isDisabled: isDisabled, label: label, subLabel: subLabel, values: values, size: sizeInput, width: "100%", selectedValueId: selectIdValue, onChange: function (value) { return setNewValue(value); } }),
            valueButton ? (React.createElement(BaSeButton, { color: BaSeTheme.colors.institucionais.azulSebrae36, onClick: inputAction, isDisabled: isDisabled, size: sizeInput, value: valueButton, leftIcon: nameButton })) : (React.createElement(BaSeShapeButton, { color: BaSeTheme.colors.institucionais.azulSebrae36, nameIcon: nameButton, isDisabled: isDisabled, shape: "square", size: sizeInput, onClick: inputAction }))),
        React.createElement(BaSeList, __assign({}, listItems))));
};
BaSeSelectList.displayName = 'BaSeSelectList';

var mapBaseTextAreaFontSize = {
    medium: {
        size: 16,
        lineHeight: 23,
    },
    small: {
        size: 13,
        lineHeight: 16,
    },
    default: {
        size: 16,
        lineHeight: 23,
    },
};
var mapBaseTextAreaColor = {
    default: {
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        color: BaSeTheme.colors.institucionais.cinzaSebrae30,
        boxShadow: 'none',
        backgroundColor: BaSeTheme.colors.defaultColors.white,
    },
    error: {
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
        color: BaSeTheme.colors.feedbackInterface.erro35,
        boxShadow: 'none',
        backgroundColor: BaSeTheme.colors.defaultColors.white,
    },
    focus: {
        borderColor: BaSeTheme.colors.institucionais.azulSebrae36,
        color: BaSeTheme.colors.institucionais.azulSebrae36,
        boxShadow: BaSeTheme.colors.institucionais.azulSebrae75,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
    },
    disabled: {
        color: BaSeTheme.colors.institucionais.cinzaSebrae75,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        backgroundColor: BaSeTheme.colors.institucionais.cinzaSebrae97,
        boxShadow: 'none',
    },
};

var StyledTextArea = styled.textarea.attrs({
    className: 'BaSe--text-area',
})(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  padding-right: 8px;\n  resize: none;\n  width: 100%;\n  height: 100%;\n\n  font-family: ", ";\n  font-weight: 400;\n  box-sizing: border-box;\n  border: none;\n  font-size: ", "px;\n  line-height: ", "px;\n\n  &:not(:disabled) {\n    color: ", ";\n  }\n\n  &:focus {\n    color: ", ";\n    outline: none !important;\n  }\n\n  ", "\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  padding-right: 8px;\n  resize: none;\n  width: 100%;\n  height: 100%;\n\n  font-family: ", ";\n  font-weight: 400;\n  box-sizing: border-box;\n  border: none;\n  font-size: ", "px;\n  line-height: ", "px;\n\n  &:not(:disabled) {\n    color: ", ";\n  }\n\n  &:focus {\n    color: ", ";\n    outline: none !important;\n  }\n\n  ", "\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"])), BaSeTheme.typography.fontFamily, function (props) {
    var _a, _b;
    return (_b = (_a = mapBaseTextAreaFontSize[props.size]) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : mapBaseTextAreaFontSize.default.size;
}, function (props) {
    var _a, _b;
    return (_b = (_a = mapBaseTextAreaFontSize[props.size]) === null || _a === void 0 ? void 0 : _a.lineHeight) !== null && _b !== void 0 ? _b : mapBaseTextAreaFontSize.default.lineHeight;
}, function (props) {
    return props.hasError
        ? mapBaseTextAreaColor.error.color
        : mapBaseTextAreaColor.default.color;
}, function (props) {
    return props.hasError
        ? mapBaseTextAreaColor.error.color
        : BaSeTheme.colors.institucionais.azulSebrae36;
}, BaSeScrollbarCss, mapBaseTextAreaColor.disabled.backgroundColor, mapBaseTextAreaColor.disabled.color);
var StyledOuterTextAreaBox = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  background: ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  padding: 8px;\n  ", "\n  ", "\n  box-shadow: ", "\n"], ["\n  background: ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  padding: 8px;\n  ", "\n  ", "\n  box-shadow: ", "\n"])), BaSeTheme.colors.defaultColors.white, function (props) {
    return props.hasError && !props.disabled
        ? mapBaseTextAreaColor.error.borderColor
        : props.hasFocus
            ? mapBaseTextAreaColor.focus.borderColor
            : mapBaseTextAreaColor.default.borderColor;
}, function (props) {
    return props.disabled && css(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), mapBaseTextAreaColor.disabled.backgroundColor);
}, function (props) { return props.disabled && 'pointer-events:none'; }, function (props) {
    return props.hasFocus &&
        (props.hasError
            ? BaSeTheme.shadows.focusError
            : BaSeTheme.shadows.focusPrimary);
});
var StyledTextAreaContainer = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledTextAreaLabel = styled.label.attrs({
    className: 'BaSe--text-area-label',
})(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 23px;\n  color: ", ";\n  margin-bottom: 2px;\n  font-size: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 23px;\n  color: ", ";\n  margin-bottom: 2px;\n  font-size: ", ";\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae45, function (props) { return (props.size === 'medium' ? '16px' : '13px'); });
var StyledTextAreaLabelContainer = styled.div.attrs({
    className: 'BaSe--text-area-label-container',
})(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledTextAreaSubLabel = styled.label.attrs({
    className: 'BaSe--text-area-sub-label',
})(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n  line-height: 23px;\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n  margin-bottom: 2px;\n"], ["\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n  line-height: 23px;\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n  margin-bottom: 2px;\n"])), function (props) { return (props.size === 'medium' ? '16px' : '13px'); }, BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae60);
var StyledTextAreaErrorText = styled.span(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  grid-column: 1/2;\n"], ["\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  grid-column: 1/2;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.colors.feedbackInterface.erro35);
var StyledTextAreaFooter = styled.div(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var showMultiple = _a.showMultiple;
    return css(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: 1fr ", ";\n  "], ["\n    display: grid;\n    grid-template-columns: 1fr ", ";\n  "])), showMultiple && '1fr');
});
var StyledTextAreaFooterLimit = styled.div(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n  grid-column: 2/3;\n  display: flex;\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  margin-top: 2px;\n  color: ", ";\n"], ["\n  grid-column: 2/3;\n  display: flex;\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  margin-top: 2px;\n  color: ", ";\n"])), BaSeTheme.typography.fontFamily, function (_a) {
    var color = _a.color;
    return color;
});
styled.div(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-left: 4px;\n  color: #45586a;\n"], ["\n  display: flex;\n  align-items: center;\n  padding-left: 4px;\n  color: #45586a;\n"])));
var ButtonInfoContainer = styled.div(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var MoreInfoContainer = styled.div(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var WrapperHelper = styled.div(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject(["\n  padding-top: 2px;\n"], ["\n  padding-top: 2px;\n"])));
var templateObject_1$i, templateObject_2$f, templateObject_3$c, templateObject_4$b, templateObject_5$9, templateObject_6$8, templateObject_7$5, templateObject_8$5, templateObject_9$5, templateObject_10$5, templateObject_11$4, templateObject_12$4, templateObject_13$3, templateObject_14$3, templateObject_15$2;

var idSequence$2 = idGenerator();
var BaSeTextArea = React.forwardRef(function (_a, forwardedRef) {
    var externalId = _a.id, dataset = _a.dataset, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.textSize, textSize = _e === void 0 ? 'medium' : _e, _f = _a.value, value = _f === void 0 ? '' : _f, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g, _h = _a.textError, textError = _h === void 0 ? '' : _h, _j = _a.name, name = _j === void 0 ? '' : _j, _k = _a.rows, rows = _k === void 0 ? 0 : _k, _l = _a.subLabel, subLabel = _l === void 0 ? '' : _l, _m = _a.helpButtonProps, helpButtonProps = _m === void 0 ? {} : _m, _o = _a.showHelpButton, showHelpButton = _o === void 0 ? false : _o, _p = _a.complement, complement = _p === void 0 ? '' : _p, _q = _a.moreInfoLabel, moreInfoLabel = _q === void 0 ? '' : _q, _r = _a.moreInfoDetails, moreInfoDetails = _r === void 0 ? '' : _r, _s = _a.inputStatus, inputStatus = _s === void 0 ? 'normal' : _s, _t = _a.hasCounter, hasCounter = _t === void 0 ? 'chars' : _t, maxLength = _a.maxLength, _u = _a.counterMinLength, counterMinLength = _u === void 0 ? 0 : _u, _v = _a.counterMaxLength, counterMaxLength = _v === void 0 ? 0 : _v;
    if (hasCounter === 'chars' && counterMaxLength > 0) {
        if (counterMaxLength > (maxLength !== null && maxLength !== void 0 ? maxLength : 0)) {
            throw Error('[BaSeTextArea] "maxLength" informado é menor do que o "counterMaxLength"');
        }
        maxLength !== null && maxLength !== void 0 ? maxLength : (maxLength = counterMaxLength);
    }
    var _w = useCounter({
        value: value,
        hasCounter: hasCounter,
        counterMinLength: counterMinLength,
        counterMaxLength: counterMaxLength,
        onChange: onChange,
    }), counterDescription = _w.counterDescription, cropText = _w.cropText;
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence$2);
    var textAreaRef = React.useRef(null);
    var _x = React.useState(false), hasFocus = _x[0], setHasFocus = _x[1];
    var formattedDataset = getFormattedDataset(dataset);
    var updateTextAreaValue = React.useCallback(function (event) {
        var val = event.target.value;
        if (hasCounter !== 'chars') {
            onChange(val);
            return;
        }
        if (!!counterMaxLength) {
            val = val.substring(0, counterMaxLength);
        }
        if (maxLength) {
            val = val.substring(0, maxLength);
        }
        onChange(val);
    }, [counterMaxLength, hasCounter, maxLength, onChange]);
    var handleErrorStatus = React.useCallback(function () { return inputStatus === 'invalid'; }, [inputStatus]);
    var giveFocus = React.useCallback(function () {
        var _a;
        (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    React.useImperativeHandle(forwardedRef, function () { return ({ focus: function () { var _a, _b; return (_b = (_a = textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a); } }); }, [textAreaRef]);
    return (React.createElement(StyledTextAreaContainer, null,
        React.createElement(StyledTextAreaLabelContainer, null,
            React.createElement(StyledTextAreaLabel, { size: textSize, htmlFor: id }, label),
            React.createElement(StyledTextAreaSubLabel, { size: textSize, htmlFor: id }, subLabel),
            showHelpButton && (React.createElement(ButtonInfoContainer, null,
                React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
        React.createElement(StyledOuterTextAreaBox, { disabled: isDisabled, hasFocus: hasFocus, onClick: function () { return giveFocus(); }, hasError: handleErrorStatus() },
            React.createElement(StyledTextArea, __assign({ id: id }, formattedDataset, { maxLength: maxLength, disabled: isDisabled, hasError: handleErrorStatus(), rows: rows, name: name, ref: textAreaRef, value: value, onChange: updateTextAreaValue, onInput: function (event) {
                    return counterMaxLength
                        ? cropText(event.currentTarget.value)
                        : onChange(event.currentTarget.value);
                }, placeholder: placeholder, size: textSize, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setHasFocus(false); } }))),
        React.createElement(StyledTextAreaFooter, { showMultiple: !!complement && !!counterMaxLength },
            inputStatus === 'invalid' ? (React.createElement(StyledTextAreaErrorText, null, textError)) : (!!complement && (React.createElement(WrapperHelper, null,
                React.createElement(BaSeHelperText, { color: BaSeTheme.colors.institucionais.cinzaSebrae45, isItalic: true, size: "medium", label: complement })))),
            hasCounter && (React.createElement(StyledTextAreaFooterLimit, { color: BaSeTheme.colors.institucionais.cinzaSebrae45 }, counterDescription))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
});
BaSeTextArea.displayName = 'BaSeTextArea';

var mapTogglerTypeSpan = {
    outlined: {
        position: {
            top: '4.5%',
            left: '2px',
        },
        size: '22px',
        transform: 'translateX(32px);',
    },
    contained: {
        position: {
            top: '-7px',
            left: '-3px',
        },
        size: '26px',
        transform: ' translateX(35px);',
    },
};
var TogglerMapper = {
    outlined: {
        default: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.default.unchecked),
                foreground: ColorMapper.default.unchecked,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                iconColor: ColorMapper.default.hover.defaultDark,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.default.foreground),
                foreground: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                iconColor: ColorMapper.default.hover.defaultDark,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        confirmation: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.confirmation.unchecked),
                foreground: ColorMapper.confirmation.unchecked,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                iconColor: ColorMapper.confirmation.hover.defaultDark,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.confirmation.foreground),
                foreground: ColorMapper.confirmation.foreground,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                iconColor: ColorMapper.confirmation.hover.defaultDark,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        destructive: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.destructive.unchecked),
                foreground: ColorMapper.destructive.unchecked,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                iconColor: ColorMapper.destructive.hover.defaultDark,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.destructive.foreground),
                foreground: ColorMapper.destructive.foreground,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                iconColor: ColorMapper.destructive.hover.defaultDark,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        negative: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.transparent,
                border: "2px solid ".concat(BaSeTheme.colors.defaultColors.white),
                foreground: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.default.focus.defaultLight,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.transparent,
                border: "2px solid ".concat(ColorMapper.default.hover.defaultLight),
                foreground: ColorMapper.default.hover.defaultLight,
                shadowFocus: ColorMapper.default.focus.defaultLight,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
    },
    contained: {
        default: {
            unchecked: {
                backgroundColor: ColorMapper.default.unchecked,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultDark,
            },
            checked: {
                backgroundColor: ColorMapper.default.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultDark,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
        confirmation: {
            unchecked: {
                backgroundColor: ColorMapper.confirmation.unchecked,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                hoverColor: ColorMapper.confirmation.hover.defaultDark,
            },
            checked: {
                backgroundColor: ColorMapper.confirmation.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                hoverColor: ColorMapper.confirmation.hover.defaultDark,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
        destructive: {
            unchecked: {
                backgroundColor: ColorMapper.destructive.unchecked,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                hoverColor: ColorMapper.destructive.hover.defaultDark,
            },
            checked: {
                backgroundColor: ColorMapper.destructive.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                hoverColor: ColorMapper.destructive.hover.defaultDark,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
        negative: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: 'none',
                foreground: ColorMapper.default.foreground,
                spanBorder: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultLight,
            },
            checked: {
                backgroundColor: ColorMapper.default.hover.defaultLight,
                border: 'none',
                foreground: ColorMapper.default.foreground,
                spanBorder: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultLight,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
            },
        },
    },
};
/*
light
main (checked) : {l: .36, s: 1 } => l, s
unchecked : {l: .6, s: .6} // s => s * .6, l => (1 - l) / (64 / 24)
hover: use createHoverColorDark
focus: use createFocusColorLight
*/
var makeUnchecked = function (color) {
    var _a = getHSLValues(color), s = _a.s, l = _a.l;
    s /= 100;
    l /= 100;
    return createColor(color, { s: s * 0.6, l: l + (1 - l) / (64 / 24) });
};
var createTogglerColor = function (color) {
    if (!Color.validateColor(color)) {
        return undefined;
    }
    return {
        outlined: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(makeUnchecked(color)),
                foreground: makeUnchecked(color),
                shadowFocus: ColorMapper.light.focus.create(color),
                iconColor: ColorMapper.dark.hover.create(color),
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(color),
                foreground: color,
                shadowFocus: ColorMapper.light.focus.create(color),
                iconColor: ColorMapper.dark.hover.create(color),
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        contained: {
            unchecked: {
                backgroundColor: makeUnchecked(color),
                border: "none",
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.light.focus.create(color),
                hoverColor: ColorMapper.dark.hover.create(color),
            },
            checked: {
                backgroundColor: color,
                border: "none",
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.light.focus.create(color),
                hoverColor: ColorMapper.dark.hover.create(color),
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
    };
};

// const memo = {};
// const handleColorTransform = (color: string) => {
//   if (color in memo) {
//     return memo[color];
//   }
//   memo[color] = ColorMapper.dark.hover.create(color);
//   return memo[color];
// };
var StyledTogglerLabel = styled.label.attrs({
    className: 'BaSe--toggler',
})(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b, _c, _d, _e;
    var type = _a.type, isDisabled = _a.isDisabled, colors = _a.colors, hasFocus = _a.hasFocus;
    return css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    display: flex;\n    width: 58px;\n    min-width: 58px;\n    height: ", ";\n    position: relative;\n    border-radius: 26px;\n    cursor: ", ";\n    background-color: ", ";\n    border: ", ";\n    ", "\n    &:hover {\n      ", "\n    }\n  "], ["\n    display: flex;\n    width: 58px;\n    min-width: 58px;\n    height: ", ";\n    position: relative;\n    border-radius: 26px;\n    cursor: ", ";\n    background-color: ", ";\n    border: ", ";\n    ", "\n    &:hover {\n      ", "\n    }\n  "])), type === 'contained' ? '16px' : '24px', isDisabled ? 'not-allowed' : 'pointer', colors.backgroundColor, colors.border, hasFocus &&
        "\n      box-shadow: 0px 0px 0px 3px ".concat(colors === null || colors === void 0 ? void 0 : colors.shadowFocus, ";\n    "), !isDisabled &&
        "\n        ".concat(colors.border === 'none'
            ? "\n          background-color: ".concat((_b = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _b !== void 0 ? _b : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          > span {\n            background-color: ").concat((_c = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _c !== void 0 ? _c : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          }\n        ")
            : "\n          border: 2px solid  ".concat((_d = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _d !== void 0 ? _d : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          > span {\n            background-color: ").concat((_e = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _e !== void 0 ? _e : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          }\n        "), "\n      "));
});
var StyledTogglerInput = styled.input(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  opacity: 0;\n  width: 0;\n  height: 0;\n"], ["\n  opacity: 0;\n  width: 0;\n  height: 0;\n"])));
var StyledTogglerSpan = styled.span(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var type = _a.type, value = _a.value, colors = _a.colors;
    return css(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n    position: absolute;\n    border-radius: 40px;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    left: ", ";\n    ", ";\n    background-color: ", ";\n    border ", "\n    transition: transform ", ";\n  "], ["\n    position: absolute;\n    border-radius: 40px;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    left: ", ";\n    ", ";\n    background-color: ", ";\n    border ", "\n    transition: transform ", ";\n  "])), mapTogglerTypeSpan[type].size, mapTogglerTypeSpan[type].size, mapTogglerTypeSpan[type].position.top, mapTogglerTypeSpan[type].position.left, value && 'transform:' + mapTogglerTypeSpan[type].transform, type === 'contained' ? colors.backgroundColor : colors.foreground, type === 'contained' ? "2px solid ".concat(colors.spanBorder, ";") : 'none;', BaSeTheme.transitions.durationNormal);
});
var StyledTogglerIconContainer = styled.div(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  visibility: ", ";\n  position: absolute;\n  top: ", ";\n  left: 2px;\n  transition: ", ";\n"], ["\n  visibility: ", ";\n  position: absolute;\n  top: ", ";\n  left: 2px;\n  transition: ", ";\n"])), function (props) { return (props.value ? 'visible' : 'hidden'); }, function (props) { return (props.type === 'contained' ? '-2.2px' : '2px'); }, BaSeTheme.transitions.allPropertiesContinuousFast);
var templateObject_1$h, templateObject_2$e, templateObject_3$b, templateObject_4$a, templateObject_5$8, templateObject_6$7;

var TogglerColorOptions = [
    'default',
    'negative',
    'confirmation',
    'destructive',
];
var handleMappedType = function (type) {
    return type === 'outlined' || type === 'contained' ? type : 'outlined';
};
var handleMappedColor = function (color) {
    return !!TogglerColorOptions.find(function (c) { return c === color; })
        ? color
        : Color.validateColor(color)
            ? 'unmapped'
            : 'default';
};
var BaSeToggler = function (_a) {
    var _b, _c, _d;
    var id = _a.id, name = _a.name, dataset = _a.dataset, _e = _a.type, type = _e === void 0 ? 'outlined' : _e, _f = _a.isDisabled, isDisabled = _f === void 0 ? false : _f, _g = _a.value, value = _g === void 0 ? false : _g, _h = _a.onChange, onChange = _h === void 0 ? function () { } : _h, color = _a.color;
    var _j = React.useState(false), hasFocus = _j[0], setHasFocus = _j[1];
    var styledMappedValues = React.useCallback(function () {
        var _a, _b;
        if (!color) {
            return TogglerMapper[handleMappedType(type)].default;
        }
        if (handleMappedColor(color) === 'unmapped') {
            return (_a = createTogglerColor(color)) === null || _a === void 0 ? void 0 : _a[handleMappedType(type)];
        }
        return (_b = TogglerMapper[handleMappedType(type)]) === null || _b === void 0 ? void 0 : _b[color];
    }, [color, type]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _k = (_b = styledMappedValues()) !== null && _b !== void 0 ? _b : TogglerMapper[handleMappedType(type)].default, unchecked = _k.unchecked, checked = _k.checked, disabledState = _k.disabled;
    var getStyles = React.useCallback(function () {
        if (isDisabled) {
            return disabledState;
        }
        return value ? checked : unchecked;
    }, [isDisabled, value, unchecked, checked, disabledState]);
    // const getStyles() = getStyles();
    var _l = React.useState(false), hasHover = _l[0], setHasHover = _l[1];
    var formattedDataset = getFormattedDataset(dataset);
    return (React.createElement(StyledTogglerLabel, { value: value, isDisabled: isDisabled, type: handleMappedType(type), colors: getStyles(), hasFocus: hasFocus, onMouseEnter: function () { return setHasHover(true); }, onMouseLeave: function () { return setHasHover(false); } },
        React.createElement(StyledTogglerInput, __assign({ id: id, name: name }, formattedDataset, { "aria-checked": value, role: "checkbox", checked: value, onChange: onChange, type: "checkbox", disabled: isDisabled, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setHasFocus(false); } })),
        React.createElement(StyledTogglerSpan, { type: handleMappedType(type), isDisabled: isDisabled, value: value, colors: getStyles() }),
        React.createElement(StyledTogglerIconContainer, { value: value, type: handleMappedType(type) },
            React.createElement(BaSeIcon, { color: type === 'contained'
                    ? color === 'negative'
                        ? BaSeTheme.colors.institucionais.azulSebrae36
                        : BaSeTheme.colors.defaultColors.white
                    : hasHover
                        ? (_c = getStyles()) === null || _c === void 0 ? void 0 : _c.iconColor
                        : (_d = getStyles()) === null || _d === void 0 ? void 0 : _d.foreground, description: getMessage('toggler.iconDescription'), name: "check", size: 20 }))));
};
BaSeToggler.displayName = 'BaSeToggler';

var OptionPickerBoxWrapper = styled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  transition: ", ";\n  position: ", ";\n  width: 100%;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-top: none;\n  border-radius: 0px 0px 0.25em 0.25em;\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  transition: ", ";\n  position: ", ";\n  width: 100%;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-top: none;\n  border-radius: 0px 0px 0.25em 0.25em;\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n\n  ", "\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var menuAlwaysIsOpen = _a.menuAlwaysIsOpen;
    return menuAlwaysIsOpen ? 'static' : 'absolute';
}, BaSeTheme.stackOrder.overlay, BaSeTheme.colors.defaultColors.white, function (_a) {
    var hasError = _a.hasError, border = _a.border, menuAlwaysIsOpen = _a.menuAlwaysIsOpen;
    return hasError
        ? mapBaSeSelectColor.error.borderColor
        : menuAlwaysIsOpen
            ? mapBaSeSelectColor['default'].borderColor
            : border;
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'auto' : '0px');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1' : '0');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '-3px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError, boxShadowFocus = _a.boxShadowFocus, menuAlwaysIsOpen = _a.menuAlwaysIsOpen;
    return isOpen
        ? hasError
            ? BaSeTheme.shadows.focusError
            : menuAlwaysIsOpen
                ? 'none'
                : "0 0 0.25em ".concat(boxShadowFocus)
        : 'none';
}, function (_a) {
    var hasBorderTop = _a.hasBorderTop, hasError = _a.hasError, border = _a.border;
    return hasBorderTop && css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n      border-top: 1px solid\n        ", ";\n      border-top-left-radius: 0.25em;\n      border-top-right-radius: 0.25em;\n      top: calc(100% + 0.5em);\n    "], ["\n      border-top: 1px solid\n        ", ";\n      border-top-left-radius: 0.25em;\n      border-top-right-radius: 0.25em;\n      top: calc(100% + 0.5em);\n    "])), hasError ? mapBaSeSelectColor.error.borderColor : border);
}, BaSeScrollbarCss);
var OptionPickerFilterContainer = styled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  padding: 0.75em 0.5em 0.5em 0.5em;\n  border-bottom: 1px solid ", ";\n  transition: ", ";\n"], ["\n  padding: 0.75em 0.5em 0.5em 0.5em;\n  border-bottom: 1px solid ", ";\n  transition: ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae75, BaSeTheme.transitions.allPropertiesContinuousNormal);
var OptionPickerHeaderLabelContainer = styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  padding: 0.5em 0.75em;\n  border-bottom: 1px solid ", ";\n  transition: ", ";\n"], ["\n  padding: 0.5em 0.75em;\n  border-bottom: 1px solid ", ";\n  transition: ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae75, BaSeTheme.transitions.allPropertiesContinuousNormal);
var OptionPickerOuterList = styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return css(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n    overflow: hidden;\n    height: ", ";\n    opacity: ", ";\n    transition: ", ";\n    box-sizing: border-box;\n    position: relative;\n  "], ["\n    overflow: hidden;\n    height: ", ";\n    opacity: ", ";\n    transition: ", ";\n    box-sizing: border-box;\n    position: relative;\n  "])), isOpen ? 'auto' : '0', isOpen ? '1' : '0', BaSeTheme.transitions.allPropertiesContinuousNormal);
});
var OptionPickerListUl = styled.ul(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var maxHeight = _a.maxHeight, withFilterText = _a.withFilterText;
    return css(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n    padding: 0;\n    margin: ", ";\n    width: 100%;\n    max-height: ", ";\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n  "], ["\n    padding: 0;\n    margin: ", ";\n    width: 100%;\n    max-height: ", ";\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n  "])), withFilterText ? '1em 0' : '0.5em 0 1em', maxHeight);
});
var OptionPickerExtraActionsHeaderWrapper = styled.div(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  padding: 0.5em 0.75em;\n"], ["\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  padding: 0.5em 0.75em;\n"])), BaSeTheme.colors.institucionais.cinzaSebrae75, BaSeTheme.colors.institucionais.cinzaSebrae75);
var OptionPickerExtraActionButton = styled.button(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 0.5em 0.75em;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  display: flex;\n  justify-content: flex-start;\n  text-align: left;\n  ", "\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus {\n    font-weight: bold;\n  }\n"], ["\n  background-color: ", ";\n  padding: 0.5em 0.75em;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  display: flex;\n  justify-content: flex-start;\n  text-align: left;\n  ", "\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus {\n    font-weight: bold;\n  }\n"])), BaSeTheme.colors.defaultColors.white, function (_a) {
    var isLast = _a.isLast;
    return isLast && css(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n      border-bottom-left-radius: 0.25em;\n      border-bottom-right-radius: 0.25em;\n    "], ["\n      border-bottom-left-radius: 0.25em;\n      border-bottom-right-radius: 0.25em;\n    "])));
}, BaSeTheme.colors.institucionais.azulSebrae97);
var OptionPickerInfoWrapper = styled.div(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  width: 90%;\n"], ["\n  width: 90%;\n"])));
var OptionPickerComplementWrapper = styled.div(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n  word-wrap: unset;\n  white-space: nowrap;\n"], ["\n  word-wrap: unset;\n  white-space: nowrap;\n"])));
styled.div(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["\n  position: absolute;\n  right: 4px;\n  top: 4px;\n"], ["\n  position: absolute;\n  right: 4px;\n  top: 4px;\n"])));
var templateObject_1$g, templateObject_2$d, templateObject_3$a, templateObject_4$9, templateObject_5$7, templateObject_6$6, templateObject_7$4, templateObject_8$4, templateObject_9$4, templateObject_10$4, templateObject_11$3, templateObject_12$3, templateObject_13$2, templateObject_14$2;

var idSequence$1 = idGenerator();
var BaSeOptionPicker = function (_a) {
    var externalId = _a.id, name = _a.name, dataset = _a.dataset, isDisabled = _a.isDisabled, _b = _a.width, width = _b === void 0 ? null : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, label = _a.label, helpButtonProps = _a.helpButtonProps, showHelpButton = _a.showHelpButton, subLabel = _a.subLabel, color = _a.color, _d = _a.overrideColor, overrideColor = _d === void 0 ? {} : _d, _e = _a.initialSelectedValuesId, initialSelectedValuesId = _e === void 0 ? [0] : _e, _f = _a.hasError, hasError = _f === void 0 ? false : _f, _g = _a.emptyValueLabel, emptyValueLabel = _g === void 0 ? '' : _g, _h = _a.complement, complement = _h === void 0 ? '' : _h, _j = _a.moreInfoLabel, moreInfoLabel = _j === void 0 ? '' : _j, _k = _a.moreInfoDetails, moreInfoDetails = _k === void 0 ? '' : _k, _l = _a.values, values = _l === void 0 ? [] : _l, _m = _a.headerLabel, headerLabel = _m === void 0 ? '' : _m, _o = _a.extraActions, extraActions = _o === void 0 ? [] : _o, _p = _a.enableSelectAll, enableSelectAll = _p === void 0 ? true : _p, _q = _a.maxMenuHeight, maxMenuHeight = _q === void 0 ? '200px' : _q, maxOptionsSelected = _a.maxOptionsSelected, _r = _a.showItemDetailButton, showItemDetailButton = _r === void 0 ? false : _r, _s = _a.searchPlaceholder, searchPlaceholder = _s === void 0 ? '' : _s, _t = _a.optionNotFoundLabel, optionNotFoundLabel = _t === void 0 ? '' : _t, _u = _a.menuAlwaysIsOpen, menuAlwaysIsOpen = _u === void 0 ? false : _u, _v = _a.withFilterText, withFilterText = _v === void 0 ? true : _v, onBlur = _a.onBlur, _w = _a.onChange, onChange = _w === void 0 ? function () { } : _w;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _x = React.useState(menuAlwaysIsOpen), isOpen = _x[0], setIsOpen = _x[1];
    var _y = React.useState('default'), colorType = _y[0], setColorType = _y[1];
    var _z = React.useState([]), currentExtraFocus = _z[0], setCurrentExtraFocus = _z[1];
    var _0 = React.useState(''), inputFilter = _0[0], setInputFilter = _0[1];
    var _1 = React.useState(initialSelectedValuesId), selectedValuesId = _1[0], setSelectedValuesId = _1[1];
    var _2 = React.useState([]), refValues = _2[0], setRefValues = _2[1];
    var handleIsOpen = React.useCallback(function (openOrClose) {
        if (!menuAlwaysIsOpen) {
            setIsOpen(openOrClose);
        }
    }, [menuAlwaysIsOpen]);
    var inputFilterRef = React.useRef(null);
    var selectInputRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, handleIsOpen);
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence$1);
    var formattedDataset = getFormattedDataset(dataset);
    var getColorsAtributes = function () {
        if (color) {
            return mapSelectValues(color);
        }
        return mapSelectValues('default');
    };
    var updateValue = React.useCallback(function (selected) {
        if (maxOptionsSelected === 1) {
            setSelectedValuesId([selected.id]);
            handleIsOpen(false);
            return;
        }
        if (selectedValuesId.indexOf(selected.id) > -1) {
            return setSelectedValuesId(function (input) {
                return input.filter(function (val) { return val !== selected.id; });
            });
        }
        if (!maxOptionsSelected ||
            (selectedValuesId.length < maxOptionsSelected && maxOptionsSelected > 0)) {
            setSelectedValuesId(function (input) { return input.concat([selected.id]); });
        }
    }, [selectedValuesId, maxOptionsSelected]);
    var onFocusInput = React.useCallback(function () { return handleIsOpen(!isDisabled && true); }, [isDisabled]);
    var _3 = getColorsAtributes().style, bcCHover = _3.bcCHover, bgC = _3.bgC, boxShadowFocus = _3.boxShadowFocus, border = _3.border;
    var handleFilter = React.useCallback(function (item) {
        var _a, _b, _c, _d, _e;
        return (!inputFilter ||
            normalize(item.label +
                ((_a = item === null || item === void 0 ? void 0 : item.complement) !== null && _a !== void 0 ? _a : '') +
                ((_c = (_b = item === null || item === void 0 ? void 0 : item.detail) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : '') +
                ((_e = (_d = item === null || item === void 0 ? void 0 : item.detail) === null || _d === void 0 ? void 0 : _d.title) !== null && _e !== void 0 ? _e : '')).includes(normalize(inputFilter)));
    }, [inputFilter]);
    var selectAll = React.useCallback(function () {
        var filteredValues = refValues.filter(handleFilter);
        if (filteredValues.length > selectedValuesId.length) {
            setSelectedValuesId(filteredValues.map(function (option) { return option.id; }));
        }
        else {
            setSelectedValuesId([]);
        }
    }, [refValues, selectedValuesId, handleFilter]);
    function emitChange() {
        var emitValues = values.filter(function (val) { return selectedValuesId.indexOf(val.id) > -1; });
        onChange(emitValues);
    }
    var addIndexExtra = React.useCallback(function (index) {
        if (currentExtraFocus.findIndex(function (i) { return i === index; }) === -1) {
            setCurrentExtraFocus(function (prev) { return __spreadArray(__spreadArray([], prev, true), [index], false); });
        }
    }, []);
    var removeIndexExtra = React.useCallback(function (index) {
        var auxCurrentExtraFocus = __spreadArray([], currentExtraFocus, true);
        var ind = auxCurrentExtraFocus.findIndex(function (i) { return i === index; });
        if (ind > -1) {
            auxCurrentExtraFocus.splice(ind, 1);
        }
        setCurrentExtraFocus(__spreadArray([], auxCurrentExtraFocus, true));
    }, [currentExtraFocus]);
    var indexInExtra = React.useCallback(function (index) {
        return currentExtraFocus.findIndex(function (i) { return i === index; }) !== -1;
    }, [currentExtraFocus]);
    var extraActionCall = React.useCallback(function (action) {
        action();
        handleIsOpen(false);
    }, []);
    var checkboxIsDisabled = React.useCallback(function (opt) {
        return (!!maxOptionsSelected &&
            selectedValuesId.length === maxOptionsSelected &&
            selectedValuesId.indexOf(opt.id) === -1);
    }, [maxOptionsSelected, selectedValuesId]);
    var removeDetailClassFromList = React.useCallback(function () {
        refValues.forEach(function (refVal) {
            var _a, _b;
            (_b = (_a = refVal.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('detail');
        });
    }, [refValues]);
    var handleKeyDown = React.useCallback(function (event, option) {
        var spaceBarKey = event.key === ' ';
        var enterKey = event.key === 'Enter';
        if (enterKey || spaceBarKey) {
            return option ? updateValue(option) : selectAll();
        }
    }, [updateValue, selectAll]);
    React.useEffect(function () {
        setRefValues(values.map(function (item) { return (__assign(__assign({}, item), { ref: React.createRef() })); }));
    }, [values]);
    React.useEffect(function () {
        setSelectedValuesId(initialSelectedValuesId);
    }, [initialSelectedValuesId.toString()]);
    React.useEffect(function () {
        setColorType(isDisabled ? 'disabled' : hasError ? 'error' : 'default');
    }, [hasError, isDisabled]);
    React.useEffect(function () {
        emitChange();
    }, [selectedValuesId.toString()]);
    React.useEffect(function () {
        var _a;
        if (!isOpen) {
            setCurrentExtraFocus([]);
        }
        else {
            (_a = inputFilterRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen, inputFilterRef]);
    return (React.createElement(BaSeBreakpointConsumer, null, function (_a) {
        var _b, _c;
        var inTablet = _a.inTablet;
        return (React.createElement(WrapperSelect, { ref: wrapperRef, isDisabled: !!isDisabled, width: width, onBlur: function (e) {
                if (e.relatedTarget === null) {
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur();
                }
            } },
            React.createElement(WrapperInputLabel, null,
                React.createElement(StyledLabel, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, label),
                React.createElement(StyledSubLabel, { htmlFor: id }, subLabel),
                showHelpButton && (React.createElement(ButtonInfoContainerHelper, null,
                    React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
            !menuAlwaysIsOpen && (React.createElement(WrapperIcon, { hasLabel: !!label, vSize: size, isOpen: isOpen, searchable: false },
                React.createElement(BaSeIcon, { description: isOpen
                        ? getMessage('select.closeOptions')
                        : getMessage('select.openOptions'), name: "arrow-head-down", size: 16, onClick: isDisabled ? undefined : function () { return handleIsOpen(!isOpen); }, color: isDisabled
                        ? BaSeTheme.colors.institucionais.cinzaSebrae75
                        : (_b = overrideColor.iconColor) !== null && _b !== void 0 ? _b : bgC }))),
            React.createElement(SelectInput, __assign({ id: id, name: name }, formattedDataset, { ref: selectInputRef, hasSelectedOption: false, disabled: isDisabled, vSize: size, boxShadowFocus: boxShadowFocus, readOnly: true, border: border, bgC: mapBaSeSelectColor[colorType].iconColor, colorType: colorType, value: selectedValuesId.length < 1
                    ? emptyValueLabel || getMessage('select.emptyValue')
                    : selectedValuesId.length > 3
                        ? getMessage('select.selectedCounter', selectedValuesId.length)
                        : joinWithSeparators(refValues
                            .filter(function (val) { return selectedValuesId.indexOf(val.id) > -1; })
                            .map(function (val) { return val.label; }), getMessage('list.separator'), getMessage('list.finalSeparator')), isOpen: isOpen, hasError: hasError, onChange: function (newValue) { return updateValue(newValue); }, onFocus: onFocusInput, menuAlwaysIsOpen: menuAlwaysIsOpen })),
            refValues.length > 0 && (React.createElement(React.Fragment, null,
                !complement && !moreInfoLabel && isOpen && (React.createElement(HideTopOfWrapperOptions, null)),
                React.createElement(OptionPickerBoxWrapper, { hasBorderTop: !!complement || !!moreInfoLabel, border: border, boxShadowFocus: boxShadowFocus, isOpen: isOpen, role: "menu", hasError: hasError, colorType: colorType, menuAlwaysIsOpen: menuAlwaysIsOpen },
                    isOpen && withFilterText && (React.createElement(OptionPickerFilterContainer, null,
                        React.createElement(BaSeInput, { placeholder: searchPlaceholder, iconButton: {
                                typeButton: 'base-icon',
                                name: !!inputFilter ? 'close-big' : 'search',
                                action: function () { return setInputFilter(''); },
                            }, value: inputFilter, ref: inputFilterRef, onChange: setInputFilter }))),
                    !!headerLabel && isOpen && (React.createElement(OptionPickerHeaderLabelContainer, null,
                        React.createElement(BaSeSmall1, { color: BaSeTheme.colors.institucionais.cinzaSebrae60, isBold: true }, headerLabel))),
                    React.createElement(OptionPickerOuterList, { isOpen: isOpen },
                        React.createElement(OptionPickerListUl, { maxHeight: maxMenuHeight, withFilterText: withFilterText, role: "listbox" },
                            enableSelectAll && !maxOptionsSelected && (React.createElement(WrapperMultipleInformation, { "aria-selected": selectedValuesId.length > 0, isOptionPickerItem: true, tabIndex: 0, bcCHover: (_c = overrideColor.selectHoverColor) !== null && _c !== void 0 ? _c : bcCHover, onKeyDown: handleKeyDown, onClick: function (e) {
                                    e.preventDefault();
                                    selectAll();
                                } },
                                React.createElement(BaSeCheckbox, { align: "top-left", isInteractive: false, color: color, label: inputFilter === ''
                                        ? getMessage('select.selectAll')
                                        : getMessage('select.selectResults'), size: "medium", indeterminate: selectedValuesId.length !== refValues.length, checked: selectedValuesId.length > 0 }))),
                            refValues.filter(handleFilter).map(function (option) {
                                var _a;
                                return (React.createElement(WrapperOption, { "aria-selected": selectedValuesId.indexOf(option.id) > -1, displayInfo: !(!inTablet || showItemDetailButton), ref: option.ref, key: option.id.toString(), multiple: true, bcCHover: (_a = overrideColor.selectHoverColor) !== null && _a !== void 0 ? _a : bcCHover, bgC: bgC, isActive: false, role: "option", tabIndex: 0, isOptionPickerItem: true, onKeyDown: function (event) { return handleKeyDown(event, option); }, onClick: function (e) {
                                        e.preventDefault();
                                        updateValue(option);
                                    }, onPointerEnter: !showItemDetailButton && inTablet
                                        ? function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('detail'); }
                                        : undefined, onPointerLeave: !showItemDetailButton && inTablet
                                        ? function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('detail'); }
                                        : undefined },
                                    React.createElement(OptionPickerInfoWrapper, null,
                                        (!maxOptionsSelected || maxOptionsSelected > 1) && (React.createElement(BaSeCheckbox, { align: "top-left", isInteractive: false, label: option.label, color: color, size: "medium", disabled: checkboxIsDisabled(option), checked: selectedValuesId.indexOf(option.id) > -1 })),
                                        !(!maxOptionsSelected || maxOptionsSelected > 1) && (React.createElement(BaSeParagraph, null, option.label))),
                                    option.detail && (React.createElement(React.Fragment, null,
                                        (showItemDetailButton || !inTablet) && (React.createElement(DetailButtonWrapper, null,
                                            React.createElement(BaSeIcon, { color: mapBaSeSelectColor[colorType].item, name: 'question-circle', size: "1em", description: getMessage('select.showDetail'), onClick: function (e) {
                                                    var _a, _b;
                                                    e.stopPropagation();
                                                    removeDetailClassFromList();
                                                    (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('detail');
                                                } }))),
                                        React.createElement(OptionDetail, { isOptionPicker: true, onClick: function (e) { return e.stopPropagation(); } },
                                            React.createElement(OptionDetailHeader, null,
                                                React.createElement(BaSeSmall1, { color: bgC, isBold: true }, option.detail.title),
                                                React.createElement(OptionDetailButton, null,
                                                    React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), size: "extra-small", type: "tertiary", onClick: function () {
                                                            var _a, _b;
                                                            (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('detail');
                                                        } }))),
                                            React.createElement(BaSeSmall1, { color: mapBaSeSelectColor[colorType].item, isThin: true }, option.detail.description)))),
                                    !!option.complement && (React.createElement(OptionPickerComplementWrapper, null,
                                        React.createElement(BaSeParagraph, { isThin: true, color: BaSeTheme.colors.institucionais.cinzaSebrae30 }, option.complement)))));
                            }),
                            !refValues.filter(handleFilter).length &&
                                !!optionNotFoundLabel && (React.createElement(WrapperOption, { onClick: function () { return setInputFilter(''); }, ignoreFocus: true, displayInfo: false, multiple: true, bcCHover: bcCHover, bgC: bgC, isActive: false, isOptionPickerItem: true },
                                React.createElement(BaSeParagraph, null, optionNotFoundLabel))))),
                    !!(extraActions === null || extraActions === void 0 ? void 0 : extraActions.length) && isOpen && (React.createElement(React.Fragment, null,
                        React.createElement(OptionPickerExtraActionsHeaderWrapper, null,
                            React.createElement(BaSeSmall1, { isBold: true, color: BaSeTheme.colors.institucionais.cinzaSebrae60 }, "A\u00C7\u00D5ES EXTRAS")),
                        extraActions.map(function (exact, index) { return (React.createElement(OptionPickerExtraActionButton, { isLast: index === extraActions.length - 1, onClick: function () { return extraActionCall(exact.action); }, key: exact.label, onFocus: function () { return addIndexExtra(index); }, onBlur: function () { return removeIndexExtra(index); } },
                            !!exact.icon && (React.createElement(BaSeIcon, { name: exact.icon, size: 20, description: exact.label, color: BaSeTheme.colors.institucionais.cinzaSebrae60 })),
                            React.createElement(BaSeParagraph, { color: BaSeTheme.colors.institucionais.cinzaSebrae30, isBold: indexInExtra(index) }, exact.label))); })))))),
            !!complement && (React.createElement(WrapperHelper$1, null,
                React.createElement(BaSeHelperText, { isItalic: true, size: "medium", color: mapBaSeSelectColor[colorType].color, label: complement }))),
            !!moreInfoLabel && (React.createElement(MoreInfoContainer$1, null,
                React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails, color: bgC })))));
    }));
};

var Wrapper = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  max-width: fit-content;\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n"], ["\n  max-width: fit-content;\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n"])));
var WrapperLabel = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: transparent;\n  position: relative;\n  margin-bottom: 2px;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: transparent;\n  position: relative;\n  margin-bottom: 2px;\n"])), BaSeTheme.stackOrder.aboveNormal);
var Label = styled.label(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n"])), function (props) { return props.fontSize; }, function (props) { return props.lineHeight; }, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.typography.fontFamily);
var SubLabel = styled.label(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 1.46em;\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  margin-left: 4px;\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 1.46em;\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  margin-left: 4px;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.colors.institucionais.cinzaSebrae60);
var Content = styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  max-width: fit-content;\n  display: flex;\n  gap: ", ";\n  flex-wrap: wrap;\n  justify-content: space-between;\n"], ["\n  max-width: fit-content;\n  display: flex;\n  gap: ", ";\n  flex-wrap: wrap;\n  justify-content: space-between;\n"])), function (_a) {
    var gap = _a.gap;
    return numberWithUnit(gap);
});
var LabelWrapper = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  display: flex;\n  gap: 16;\n  justify-content: space-between;\n  width: 100%;\n  padding: 8px 0;\n"], ["\n  display: flex;\n  gap: 16;\n  justify-content: space-between;\n  width: 100%;\n  padding: 8px 0;\n"])));
var templateObject_1$f, templateObject_2$c, templateObject_3$9, templateObject_4$8, templateObject_5$6, templateObject_6$5;

var idSequence = idGenerator();
var BaSeRating = function (_a) {
    var externalId = _a.id, _b = _a.values, values = _b === void 0 ? [] : _b, selected = _a.selected, _c = _a.size, size = _c === void 0 ? 'medium' : _c, label = _a.label, subLabel = _a.subLabel, rangeInformation = _a.rangeInformation, _d = _a.shape, shape = _d === void 0 ? 'square' : _d, _e = _a.sizeIcon, sizeIcon = _e === void 0 ? 'medium' : _e, isDisabled = _a.isDisabled, _f = _a.isFillUntilSelected, isFillUntilSelected = _f === void 0 ? true : _f, _g = _a.gap, gap = _g === void 0 ? '16px' : _g, onSelect = _a.onSelect;
    var id = externalId !== null && externalId !== void 0 ? externalId : useNextHashId(idSequence);
    if (values.length === 0) {
        throw Error('[BaSeRating] error: O campo values é obrigatório!');
    }
    if (values.length < 2) {
        throw Error('[BaSeRating] error: Para o campo values é necessário passar uma lista com pelo menos 2 valores');
    }
    var getTypeUnselected = React.useCallback(function (item) { return (!item.nameIcon ? 'secondary' : 'tertiary'); }, []);
    var isSelected = React.useCallback(function (index, exactly) {
        if (exactly === void 0) { exactly = false; }
        return selected !== undefined && !exactly && isFillUntilSelected
            ? selected >= index
            : selected === index;
    }, [isFillUntilSelected, selected]);
    var getTypeSelected = React.useCallback(function (item) {
        return item.colorSelected || item.nameIconSelected
            ? getTypeUnselected(item)
            : 'primary';
    }, [getTypeUnselected]);
    var type = React.useCallback(function (item, index) {
        return isSelected(index) ? getTypeSelected(item) : getTypeUnselected(item);
    }, [isFillUntilSelected, selected, getTypeSelected, getTypeUnselected]);
    var getId = React.useCallback(function (index) {
        return selected === undefined && index === 0
            ? id
            : isSelected(index, true)
                ? id
                : undefined;
    }, [selected]);
    var getNameIcon = React.useCallback(function (item, index) {
        return isSelected(index) && item.nameIconSelected
            ? item.nameIconSelected
            : item.nameIcon;
    }, [selected]);
    var getColor = React.useCallback(function (item, index) {
        return isSelected(index) && item.colorSelected ? item.colorSelected : item.color;
    }, [selected]);
    return (React.createElement(Wrapper, null,
        React.createElement(WrapperLabel, null,
            React.createElement(Label, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, label),
            React.createElement(SubLabel, { htmlFor: id }, subLabel)),
        React.createElement(Content, { gap: gap }, values.map(function (item, index) { return (React.createElement(BaSeShapeButton, __assign({}, item, { id: getId(index), isDisabled: isDisabled, key: index, shape: shape, size: size, type: type(item, index), nameIcon: getNameIcon(item, index), color: getColor(item, index), sizeIcon: sizeIcon, onClick: function () { return onSelect(index); } }))); })),
        React.createElement(LabelWrapper, null, rangeInformation &&
            rangeInformation.map(function (value, key) { return (React.createElement(BaSeSmall1, { key: key, color: BaSeTheme.colors.institucionais.cinzaSebrae30 }, value)); }))));
};
BaSeRating.displayName = 'BaSeRating';

var StyledAvatar = styled.img.attrs({
    className: 'BaSe--avatar BaSe--avatar-image',
})(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n"], ["\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n"])));
var StyledSpan = styled.span.attrs({
    className: 'BaSe--avatar BaSe--avatar-nameAbbreviation',
})(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"], ["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"])), BaSeTheme.typography.fontFamily, function (props) { return props.iconColor; }, function (props) { return props.iconSize; }, function (props) { return (props.isBoldIcon ? 'bold' : 'normal'); });
var templateObject_1$e, templateObject_2$b;

var BaSeAvatar = function (_a) {
    var keycloak = _a.keycloak, externalImageSrc = _a.imageSrc, externalUserId = _a.userId, externalUserName = _a.userName, externalAvatarUrl = _a.avatarUrl, _b = _a.iconColor, iconColor = _b === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _b, _c = _a.iconSize, iconSize = _c === void 0 ? 16 : _c, _d = _a.isBoldIcon, isBoldIcon = _d === void 0 ? false : _d, _e = _a.onErrorLoading, onErrorLoading = _e === void 0 ? function () { } : _e, _f = _a.onLoadSuccess, onLoadSuccess = _f === void 0 ? function () { } : _f;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _g = useConfigByAuthServerUrl(), getConfig = _g.getConfig, configIsInitialized = _g.configIsInitialized;
    var _h = React.useState(true), hasAvatar = _h[0], setHasAvatar = _h[1];
    var avatarUrl = React.useMemo(function () {
        var _a;
        var whenNotFoundConfig = externalAvatarUrl
            ? urlSanitizer(externalAvatarUrl)
            : undefined;
        if (configIsInitialized) {
            return ((_a = getConfig({
                authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
                key: 'avatarUrl',
            })) !== null && _a !== void 0 ? _a : whenNotFoundConfig);
        }
        return whenNotFoundConfig;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        externalAvatarUrl,
    ]);
    var userId = React.useMemo(function () {
        var _a, _b;
        if (configIsInitialized) {
            return ((_b = (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a[getConfig({
                authServerUrl: keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
                key: 'jwtAttrId',
            })]) !== null && _b !== void 0 ? _b : externalUserId);
        }
        return externalUserId;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        externalUserId,
    ]);
    var userName = React.useMemo(function () {
        var _a;
        if (configIsInitialized) {
            return (_a = extractFullName({ getConfig: getConfig, keycloak: keycloak })) !== null && _a !== void 0 ? _a : externalUserName;
        }
        return externalUserName;
    }, [
        configIsInitialized,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
        externalUserName,
    ]);
    var imageSrc = React.useMemo(function () {
        return externalImageSrc !== null && externalImageSrc !== void 0 ? externalImageSrc : getAvatarUrl({ getConfig: getConfig, avatarUrl: avatarUrl, userId: userId, keycloak: keycloak });
    }, [
        externalImageSrc,
        avatarUrl,
        userId,
        getConfig,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed,
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.authServerUrl,
    ]);
    if (!userName) {
        throw Error('[BaSeAvatar] Nome é obrigatório');
    }
    React.useEffect(function () { return setHasAvatar(!!imageSrc); }, [imageSrc]);
    if (!configIsInitialized) {
        return (React.createElement(BaSeLoadingSpinner, { diameter: iconSize, color: iconColor, description: getMessage('loading.description') }));
    }
    // TODO: Encapsular num container para ele ter o estilo e o shape adequado
    if (hasAvatar) {
        return (React.createElement(StyledAvatar, { loading: "lazy", alt: getMessage('avatarImage.description'), key: userId, src: imageSrc, onLoad: function () { return onLoadSuccess(); }, onError: function () {
                setHasAvatar(false);
                onErrorLoading();
            } }));
    }
    return (React.createElement(StyledSpan, { key: userId, isBoldIcon: isBoldIcon, "aria-hidden": true, iconColor: iconColor, iconSize: iconSize }, nameAbbreviation(userName)));
};
BaSeAvatar.displayName = 'BaSeAvatar';

var BaSeEmoticon = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--emoticon", description: description, path: "images/emoticons/".concat(name, ".svg") }));
};
BaSeEmoticon.displayName = 'BaSeEmoticon';

var BaSeIllustration = function (_a) {
    var name = _a.name, description = _a.description, width = _a.width, height = _a.height, color = _a.color, colorTransition = _a.colorTransition, _b = _a.colorSchema, colorSchema = _b === void 0 ? 'mono' : _b, onClick = _a.onClick;
    if (colorSchema === 'multi') {
        throw Error('[BaSeIllustration] "colowSchema = multi" ainda não implementado');
    }
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--illustration", width: width ? numberWithUnit(width) : undefined, height: height ? numberWithUnit(height) : undefined, description: description, path: "images/illustrations/static/".concat(colorSchema, "-color/").concat(name, ".svg"), color: color, colorTransition: colorTransition, onClick: onClick }));
};
BaSeIllustration.displayName = 'BaSeIllustration';

var BaSeImageFlag = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--image-flag", description: description, path: "images/flags/".concat(name, ".svg") }));
};
BaSeImageFlag.displayName = 'BaSeImageFlag';

var BaSeImageMap = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement(BaSeStaticAsset, { classIdentifier: "BaSe--image-map", description: description, path: "images/maps/".concat(name, ".svg") }));
};
BaSeImageMap.displayName = 'BaSeImageMap';

var MessageColors = {
    default: {
        headingTextColor: BaSeTheme.colors.institucionais.azulSebrae36,
        backgroundColor: BaSeTheme.colors.institucionais.azulSebrae97,
        borderColor: BaSeTheme.colors.institucionais.azulSebrae60,
    },
    attention: {
        headingTextColor: BaSeTheme.colors.feedbackInterface.atencao35,
        backgroundColor: BaSeTheme.colors.feedbackInterface.atencao95,
        borderColor: BaSeTheme.colors.feedbackInterface.atencao55,
    },
    confirmation: {
        headingTextColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        backgroundColor: BaSeTheme.colors.feedbackInterface.sucesso95,
        borderColor: BaSeTheme.colors.feedbackInterface.sucesso45,
    },
    destructive: {
        headingTextColor: BaSeTheme.colors.feedbackInterface.erro35,
        backgroundColor: BaSeTheme.colors.feedbackInterface.erro95,
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
    },
};
var StyledMessage = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  border-radius: 0.25em;\n  border-style: solid;\n  border-width: 1px;\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75em;\n  padding: 0.75em;\n  align-items: flex-start;\n  position: relative;\n  color: ", ";\n\n  > :first-child {\n    flex: 1 1 0%;\n  }\n\n  > .BaSe--heading6 {\n    margin-bottom: 0.5em;\n  }\n"], ["\n  border-radius: 0.25em;\n  border-style: solid;\n  border-width: 1px;\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75em;\n  padding: 0.75em;\n  align-items: flex-start;\n  position: relative;\n  color: ", ";\n\n  > :first-child {\n    flex: 1 1 0%;\n  }\n\n  > .BaSe--heading6 {\n    margin-bottom: 0.5em;\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae30);
var StyledMessageDefault = styled(StyledMessage)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"], ["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"])), MessageColors.default.borderColor, MessageColors.default.backgroundColor, MessageColors.default.headingTextColor);
var StyledMessageAttention = styled(StyledMessage)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"], ["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"])), MessageColors.attention.borderColor, MessageColors.attention.backgroundColor, MessageColors.attention.headingTextColor);
var StyledMessageConfirmation = styled(StyledMessage)(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"], ["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"])), MessageColors.confirmation.borderColor, MessageColors.confirmation.backgroundColor, MessageColors.confirmation.headingTextColor);
var StyledMessageDestructive = styled(StyledMessage)(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"], ["\n  border-color: ", ";\n  background-color: ", ";\n\n  .BaSe--heading6 {\n    color: ", ";\n  }\n"])), MessageColors.destructive.borderColor, MessageColors.destructive.backgroundColor, MessageColors.destructive.headingTextColor);
var templateObject_1$d, templateObject_2$a, templateObject_3$8, templateObject_4$7, templateObject_5$5;

var MessageTypes = {
    default: StyledMessageDefault,
    destructive: StyledMessageDestructive,
    confirmation: StyledMessageConfirmation,
    attention: StyledMessageAttention,
};
var getStyledMessageFromType = function (type) {
    var _a;
    return (_a = MessageTypes[type]) !== null && _a !== void 0 ? _a : StyledMessageDefault;
};
var BaSeMessage = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'default' : _b, title = _a.title, message = _a.message, _c = _a.showCloseButton, showCloseButton = _c === void 0 ? false : _c, _d = _a.withNewLineWrapInMessage, withNewLineWrapInMessage = _d === void 0 ? false : _d, _e = _a.secondsToClose, secondsToClose = _e === void 0 ? 0 : _e, progressAnimationTypeExternal = _a.progressAnimationType, action = _a.action, onAction = _a.onAction;
    var _f = React.useState(true), isOpen = _f[0], setIsOpen = _f[1];
    var progressRef = React.useRef(null);
    var messages = React.useMemo(function () { return (Array.isArray(message) ? message : [message]); }, [message]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var progressAnimationType = React.useMemo(function () { return progressAnimationTypeExternal !== null && progressAnimationTypeExternal !== void 0 ? progressAnimationTypeExternal : (showCloseButton ? 'circle' : 'bar'); }, [progressAnimationTypeExternal]);
    var StyledMessage = React.useMemo(function () { return getStyledMessageFromType(color); }, [color]);
    var titleEl = React.useMemo(function () { return title !== null && title !== void 0 ? title : getMessage("message.".concat(color)); }, [color, title, getMessage]);
    var buttonColor = React.useMemo(function () { return getMessageColorFromType(color).foreground; }, [color]);
    var progressIndicatorColor = React.useMemo(function () { return getMessageColorFromType(color).foreground; }, [color]);
    var progressTrackColor = React.useMemo(function () { return getMessageColorFromType(color).background; }, [color]);
    var progressLoadingDuration = React.useMemo(function () { return secondsToClose * 1000; }, [secondsToClose]);
    var closeButton = React.useMemo(function () {
        return (React.createElement("div", null,
            React.createElement(BaSeIconButton, { nameIcon: "close-big", descriptionIcon: getMessage('buttonIcon.iconDescription.close'), buttonType: "button", shape: "circle", size: "small", sizeIcon: "small", type: "tertiary", color: buttonColor, onClick: function () {
                    setIsOpen(false);
                } })));
    }, [buttonColor, getMessage]);
    var progressCircle = React.useMemo(function () {
        return (React.createElement(BaSeProgressCircle, { ref: progressRef, indicatorWidth: 3, loadingDuration: progressLoadingDuration, indicatorColor: progressIndicatorColor, trackColor: progressTrackColor, size: 32, trackWidth: 3, type: "emptying", closeOnTimeout: true, onFinish: function () {
                setIsOpen(false);
            } }, closeButton));
    }, [
        progressRef,
        progressLoadingDuration,
        progressIndicatorColor,
        progressTrackColor,
    ]);
    var progressBar = React.useMemo(function () {
        return (React.createElement(BaSeProgressBar, { backgroundColor: getAlertColorFromType(color).background, foregroundColor: getAlertColorFromType(color).foreground, loadingDuration: progressLoadingDuration, onFinish: function () { return setIsOpen(false); }, ref: progressRef }));
    }, [getAlertColorFromType, progressLoadingDuration, progressRef]);
    return (React.createElement(React.Fragment, null, isOpen && (React.createElement(StyledMessage, { onFocusCapture: function () { var _a; return (_a = progressRef.current) === null || _a === void 0 ? void 0 : _a.pause(); }, onBlurCapture: function () { var _a; return (_a = progressRef.current) === null || _a === void 0 ? void 0 : _a.resume(); }, onMouseEnter: function () { var _a; return (_a = progressRef.current) === null || _a === void 0 ? void 0 : _a.pause(); }, onMouseLeave: function () { var _a; return (_a = progressRef.current) === null || _a === void 0 ? void 0 : _a.resume(); } },
        React.createElement("div", null,
            React.createElement(BaSeHeading6, { isBold: true }, titleEl),
            messages.map(function (msg, index) { return (React.createElement(BaSeParagraph, { key: index, withNewLineWrap: withNewLineWrapInMessage }, msg)); })),
        action && (React.createElement(BaSeButton, { buttonType: "button", size: "small", type: "tertiary", color: buttonColor, value: action, onClick: function () { return onAction === null || onAction === void 0 ? void 0 : onAction(); } })),
        (secondsToClose === 0 ||
            (secondsToClose > 0 && progressAnimationType !== 'circle')) &&
            showCloseButton &&
            closeButton,
        secondsToClose > 0 &&
            progressAnimationType === 'circle' &&
            progressCircle,
        secondsToClose > 0 && progressAnimationType === 'bar' && progressBar))));
};
BaSeMessage.displayName = 'BaSeMessage';

var handleNumberString = function (val) { return numberWithUnit(val); };
var ActionItemWrapper = styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.relative
        ? css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n          position: relative;\n          display: inline-block;\n        "], ["\n          position: relative;\n          display: inline-block;\n        "]))) : css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n        "], ["\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n        "])));
});
var ActionItemContainer = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  ", "\n  ", ";\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  border-radius: 4px;\n  transition: ", ";\n  max-height: 0;\n  overflow-y: hidden;\n  visibility: hidden;\n  z-index: ", ";\n\n  &.BaSe--action-item-open {\n    max-height: 1000vh;\n    visibility: visible;\n  }\n"], ["\n  ", "\n  ", ";\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  border-radius: 4px;\n  transition: ", ";\n  max-height: 0;\n  overflow-y: hidden;\n  visibility: hidden;\n  z-index: ", ";\n\n  &.BaSe--action-item-open {\n    max-height: 1000vh;\n    visibility: visible;\n  }\n"])), function (props) { return css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n    min-width: ", ";\n  "], ["\n    min-width: ", ";\n  "])), handleNumberString(props.minWidth)); }, function (props) { return props.addStyles; }, BaSeTheme.colors.defaultColors.white, ColorMapper.disabled.foreground, BaSeTheme.shadows.profundidade2, BaSeTheme.transitions.allPropertiesContinuousNormal, BaSeTheme.stackOrder.belowOverlay);
var ActionItemAccordionContent = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  padding-left: 10px;\n"], ["\n  padding-left: 10px;\n"])));
var ActionItemListWrapper = styled.div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  padding: 8px 0;\n\n  > .BaSe--accordion-content,\n  .BaSe--accordion {\n    overflow: hidden;\n  }\n"], ["\n  display: flex;\n  flex-flow: column;\n  padding: 8px 0;\n\n  > .BaSe--accordion-content,\n  .BaSe--accordion {\n    overflow: hidden;\n  }\n"])));
var ActionItemTitleAccordionContainer = styled.div(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  cursor: pointer;\n  padding: 8px 16px;\n\n  display: flex;\n  align-items: center;\n  border: none;\n  outline: none;\n  margin: 0;\n  box-sizing: border-box;\n  gap: 14px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  img {\n    width: 20px;\n  }\n"], ["\n  cursor: pointer;\n  padding: 8px 16px;\n\n  display: flex;\n  align-items: center;\n  border: none;\n  outline: none;\n  margin: 0;\n  box-sizing: border-box;\n  gap: 14px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  img {\n    width: 20px;\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase);
var ActionItemSingleItem = styled.button(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var customColor = _a.customColor;
    return css(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding: 8px 16px;\n\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border: none;\n    outline: none;\n    cursor: ", ";\n    margin: 0;\n    box-sizing: border-box;\n    gap: 14px;\n    will-change: background-color;\n\n    &,\n    span {\n      transition: ", ";\n    }\n\n    img {\n      width: 20px;\n    }\n\n    ", "\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding: 8px 16px;\n\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border: none;\n    outline: none;\n    cursor: ", ";\n    margin: 0;\n    box-sizing: border-box;\n    gap: 14px;\n    will-change: background-color;\n\n    &,\n    span {\n      transition: ", ";\n    }\n\n    img {\n      width: 20px;\n    }\n\n    ", "\n  "])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, BaSeTheme.typography.lineHeightBase, customColor === null || customColor === void 0 ? void 0 : customColor.backgroundColor, (customColor === null || customColor === void 0 ? void 0 : customColor.disabled) ? 'not-allowed' : 'pointer', BaSeTheme.transitions.allPropertiesContinuousFast, (customColor === null || customColor === void 0 ? void 0 : customColor.hoverBackgroundColor) && css(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n\n      &:focus span {\n        font-weight: bold;\n      }\n    "], ["\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n\n      &:focus span {\n        font-weight: bold;\n      }\n    "])), customColor === null || customColor === void 0 ? void 0 : customColor.hoverBackgroundColor));
});
styled.div(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1$c, templateObject_2$9, templateObject_3$7, templateObject_4$6, templateObject_5$4, templateObject_6$4, templateObject_7$3, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$2, templateObject_12$2;

var NEGATIVE_INDEX = -99;
var DEFAULT_ITEM_COLORS = {
    unselected: {
        textColor: ColorMapper.default.foreground,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        hoverBackgroundColor: ColorMapper.default.hover.defaultLight,
    },
    selected: {
        textColor: BaSeTheme.colors.defaultColors.white,
        backgroundColor: ColorMapper.default.foreground,
        hoverBackgroundColor: ColorMapper.default.hover.defaultDark,
    },
    disabled: {
        textColor: ColorMapper.disabled.foreground,
        backgroundColor: ColorMapper.disabled.background,
        disabled: true,
    },
};
var SingleActionItemTitleContent = function (_a) {
    var createDisableIconColor = _a.createDisableIconColor, customColor = _a.customColor, item = _a.item;
    return (React.createElement(React.Fragment, null,
        (item === null || item === void 0 ? void 0 : item.icon) && (React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(BaSeIcon, { description: getMessage('icon.label', item.text), name: item.icon, color: createDisableIconColor() }));
        })),
        React.createElement(BaSeParagraph, { color: customColor === null || customColor === void 0 ? void 0 : customColor.textColor }, item.text)));
};
var SingleActionItemTitle = function (_a) {
    var customColor = _a.customColor, item = _a.item, selfRef = _a.selfRef, callback = _a.callback, updateCurrent = _a.updateCurrent, createDisableIconColor = _a.createDisableIconColor, index = _a.index;
    var handleClick = React.useCallback(function () {
        if (!(item === null || item === void 0 ? void 0 : item.isDisabled)) {
            item.callback();
            callback === null || callback === void 0 ? void 0 : callback();
        }
    }, [item, callback]);
    var handleFocus = React.useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        updateCurrent(index);
    }, [updateCurrent]);
    var disableTabIndex = React.useCallback(function () {
        return (item === null || item === void 0 ? void 0 : item.isDisabled) ? { tabIndex: -1 } : {};
    }, [item]);
    return (React.createElement(ActionItemSingleItem, __assign({ ref: selfRef, onFocus: handleFocus, onClick: handleClick, customColor: customColor, "aria-disabled": item === null || item === void 0 ? void 0 : item.isDisabled }, disableTabIndex()),
        React.createElement(SingleActionItemTitleContent, { createDisableIconColor: createDisableIconColor, customColor: customColor, item: item })));
};
var SingleActionItem = function (_a) {
    var item = _a.item, index = _a.index, opened = _a.opened, hasFocus = _a.hasFocus, callback = _a.callback, updateCurrent = _a.updateCurrent, subitems = _a.subitems, onClick = _a.onClick;
    var _b = React.useState(NEGATIVE_INDEX), currentIndex = _b[0], setCurrentIndex = _b[1];
    var _c = React.useState(false), menuOpen = _c[0], setMenuOpen = _c[1];
    var selfRef = React.useRef(null);
    var getIconColor = React.useCallback(function () {
        var _a, _b;
        if (!(item === null || item === void 0 ? void 0 : item.color)) {
            return ColorMapper.default.foreground;
        }
        if (ColorMapper.isValidType((_a = item === null || item === void 0 ? void 0 : item.color) !== null && _a !== void 0 ? _a : '')) {
            var colorMapper = ColorMapper[item.color];
            if ('foreground' in colorMapper) {
                return colorMapper.foreground;
            }
        }
        if (ColorMapper.isValidColor((_b = item === null || item === void 0 ? void 0 : item.color) !== null && _b !== void 0 ? _b : '')) {
            return item.color;
        }
        return ColorMapper.default.foreground;
    }, [item]);
    var createDisableIconColor = React.useCallback(function () {
        if (item === null || item === void 0 ? void 0 : item.isDisabled) {
            return BaSeTheme.colors.institucionais.cinzaSebrae75;
        }
        return item.isSelected
            ? BaSeTheme.colors.defaultColors.white
            : getIconColor();
    }, [item, getIconColor]);
    var getItemColor = React.useCallback(function () {
        var _a, _b;
        if (item === null || item === void 0 ? void 0 : item.isDisabled) {
            return DEFAULT_ITEM_COLORS.disabled;
        }
        var selected = (item === null || item === void 0 ? void 0 : item.isSelected) ? 'selected' : 'unselected';
        if (ColorMapper.isValidType((_a = item === null || item === void 0 ? void 0 : item.color) !== null && _a !== void 0 ? _a : '')) {
            return {
                unselected: {
                    textColor: ColorMapper[item.color].foreground,
                    backgroundColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper[item.color].hover
                        .defaultLight,
                },
                selected: {
                    backgroundColor: ColorMapper[item.color]
                        .foreground,
                    textColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper[item.color].hover
                        .defaultDark,
                },
            }[selected];
        }
        if (ColorMapper.isValidColor((_b = item === null || item === void 0 ? void 0 : item.color) !== null && _b !== void 0 ? _b : '')) {
            return {
                unselected: {
                    textColor: item === null || item === void 0 ? void 0 : item.color,
                    backgroundColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper.light.hover.create(item.color),
                },
                selected: {
                    backgroundColor: item === null || item === void 0 ? void 0 : item.color,
                    textColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper.dark.hover.create(item.color),
                },
            }[selected];
        }
        return DEFAULT_ITEM_COLORS[selected];
    }, [item]);
    React.useEffect(function () {
        var _a;
        if (hasFocus && opened && (selfRef === null || selfRef === void 0 ? void 0 : selfRef.current)) {
            (_a = selfRef === null || selfRef === void 0 ? void 0 : selfRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [hasFocus, opened, selfRef, index]);
    var customColor = getItemColor();
    var returnDefault = React.useCallback(function () {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        setCurrentIndex(NEGATIVE_INDEX);
        setMenuOpen(false);
    }, [onClick]);
    var options = React.useMemo(function () {
        var _a;
        return [
            {
                title: function (_a) {
                    var setOpen = _a.setOpen, open = _a.open;
                    return (React.createElement(ActionItemTitleAccordionContainer, { onClick: function () { return setOpen(!open); }, customColor: customColor },
                        React.createElement(SingleActionItemTitleContent, { createDisableIconColor: createDisableIconColor, customColor: customColor, item: item })));
                },
                content: (React.createElement(ActionItemListWrapper, null,
                    React.createElement(ActionItemAccordionContent, null, (_a = item.subitems) === null || _a === void 0 ? void 0 : _a.map(function (subitem, key) { return (React.createElement(SingleActionItem, { callback: returnDefault, item: subitem, key: key, index: key, opened: menuOpen, hasFocus: key === currentIndex, updateCurrent: setCurrentIndex, subitems: subitem.subitems, onClick: onClick })); })))),
                noPaddingContent: true,
                noPaddingTitle: true,
            },
        ];
    }, [customColor, item, menuOpen]);
    return subitems ? (React.createElement(BaSeAccordion, { backgroundContentColor: BaSeTheme.colors.defaultColors.white, titleButtonIconSize: "small", titleButtonSize: "small", hasContentBorder: false, hasTitleBorder: false, shadow: BaSeTheme.shadows.profundidade0, multipleOpen: true, options: options })) : (React.createElement(SingleActionItemTitle, { customColor: customColor, selfRef: selfRef, item: item, callback: callback, updateCurrent: updateCurrent, createDisableIconColor: createDisableIconColor, index: index }));
};
var BaSeActionItem = function (_a) {
    var _b;
    var _c = _a.icon, icon = _c === void 0 ? 'ellipsis-v' : _c, descriptionIcon = _a.descriptionIcon, _d = _a.type, type = _d === void 0 ? 'tertiary' : _d, _e = _a.size, size = _e === void 0 ? 'extra-small' : _e, _f = _a.sizeIcon, sizeIcon = _f === void 0 ? 'medium' : _f, _g = _a.color, color = _g === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _g, _h = _a.items, items = _h === void 0 ? [] : _h, _j = _a.isDisabled, isDisabled = _j === void 0 ? false : _j, _k = _a.closeOnAction, closeOnAction = _k === void 0 ? true : _k, _l = _a.minWidth, minWidth = _l === void 0 ? 164 : _l, _m = _a.open, open = _m === void 0 ? false : _m, _o = _a.noIcon, noIcon = _o === void 0 ? false : _o, _p = _a.trackPosition, trackPosition = _p === void 0 ? false : _p, _q = _a.position, position = _q === void 0 ? 'top-left' : _q, _r = _a.tooltip, tooltip = _r === void 0 ? {} : _r, _s = _a.buttonType, buttonType = _s === void 0 ? 'base-shape-button' : _s, _t = _a.customButtonProps, customButtonProps = _t === void 0 ? {} : _t, onClose = _a.onClose, onOpen = _a.onOpen;
    var _u = React.useState(false), menuOpen = _u[0], setMenuOpen = _u[1];
    var menuRef = React.useRef(null);
    var _v = React.useState(NEGATIVE_INDEX), currentIndex = _v[0], setCurrentIndex = _v[1];
    var _w = React.useState(''), styles = _w[0], setStyles = _w[1];
    var _x = React.useState(false), isTooltipOpen = _x[0], setIsTooltipOpen = _x[1];
    useOutsideEvent(menuRef, function () {
        setMenuOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    var handleButtonType = React.useCallback(function () {
        var _a;
        if (!buttonType) {
            return 'base-shape-button';
        }
        var option = [
            'base-button',
            'base-shape-button',
            'base-arrow-button',
        ];
        return (_a = option.find(function (i) { return i === buttonType; })) !== null && _a !== void 0 ? _a : 'base-shape-button';
    }, [buttonType]);
    var displayButton = React.useCallback(function () {
        return {
            'base-button': function (baseButtonProps) { return (React.createElement(BaSeButton, __assign({}, baseButtonProps, { tooltip: tooltip, onClick: function () { return setMenuOpen(function (prev) { return !prev; }); }, isDisabled: isDisabled, size: 'extra-small' === size || 'mega-small' === size ? 'small' : size, color: color, type: type, onFocus: undefined, onBlur: undefined }))); },
            'base-shape-button': function (baseShapeButtonProps) { return (React.createElement(BaSeI18nConsumer, null, function (_a) {
                var getMessage = _a.getMessage;
                return (React.createElement(BaSeShapeButton, __assign({}, baseShapeButtonProps, { tooltip: tooltip, isDisabled: isDisabled, size: size, sizeIcon: sizeIcon, color: color, type: type, nameIcon: icon, descriptionIcon: (descriptionIcon === null || descriptionIcon === void 0 ? void 0 : descriptionIcon.trim()) ||
                        getMessage('actionItem.iconDescription'), onClick: function () { return setMenuOpen(function (prev) { return !prev; }); }, onFocus: undefined, onBlur: undefined })));
            })); },
            'base-arrow-button': function (baseArrowButtonProps) { return (React.createElement(BaSeArrowButton, __assign({}, baseArrowButtonProps, { tooltip: tooltip, isDisabled: isDisabled, color: color, type: type, onClick: function () { return setMenuOpen(function (prev) { return !prev; }); }, onFocus: undefined, onBlur: undefined }))); },
        };
    }, [isDisabled, size, color, type, tooltip, sizeIcon, icon]);
    var returnDefault = React.useCallback(function () {
        setCurrentIndex(NEGATIVE_INDEX);
        setMenuOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    var handlePosition = React.useCallback(function (pos) {
        var styledPosition = '';
        styledPosition += pos.includes('top') ? 'top:100%;' : 'bottom: 100%;';
        styledPosition += pos.includes('left') ? 'left:0;' : 'right: 0;';
        return styledPosition;
    }, [position]);
    React.useEffect(function () {
        if (menuOpen) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
            setTimeout(function () {
                setCurrentIndex(0);
            }, 200);
        }
        else {
            setStyles('');
            setCurrentIndex(NEGATIVE_INDEX);
        }
    }, [menuOpen]);
    React.useEffect(function () {
        if (currentIndex < 0 && currentIndex !== NEGATIVE_INDEX) {
            setCurrentIndex(items.length - 1);
        }
        if (currentIndex > items.length - 1) {
            setCurrentIndex(0);
        }
    }, [currentIndex]);
    React.useEffect(function () {
        if (noIcon) {
            setMenuOpen(open);
        }
    }, [open, noIcon]);
    React.useEffect(function () {
        var _a;
        if (trackPosition) {
            try {
                var style = '';
                var _b = (_a = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), bottom = _b.bottom, right = _b.right, width = _b.width, height = _b.height;
                if (right && bottom && width && height && !styles) {
                    var _c = window, innerWidth_1 = _c.innerWidth, innerHeight_1 = _c.innerHeight;
                    if (height < innerHeight_1) {
                        if (bottom > innerHeight_1) {
                            style += 'bottom: 100%;';
                        }
                        else {
                            style += 'top:100%;';
                        }
                    }
                    if (width < innerWidth_1) {
                        if (right > innerWidth_1) {
                            style += 'right:0;';
                        }
                        else {
                            style += 'left:0;';
                        }
                    }
                    if (style === styles) {
                        return;
                    }
                    setStyles(style);
                }
            }
            catch (_d) {
                setStyles('');
            }
        }
        else {
            if (position) {
                setStyles(handlePosition(position));
            }
        }
    }, [menuRef, (_b = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()]);
    return (React.createElement(ActionItemWrapper, { onMouseEnter: function () {
            setIsTooltipOpen(true);
        }, onMouseLeave: function () {
            setIsTooltipOpen(false);
        }, relative: !noIcon, ref: menuRef },
        !noIcon &&
            displayButton()[handleButtonType()](customButtonProps),
        items.length > 0 && !isDisabled && (React.createElement(ActionItemContainer, { minWidth: minWidth, addStyles: styles, className: menuOpen ? 'BaSe--action-item-open' : '' },
            React.createElement(ActionItemListWrapper, null, items.map(function (item, key) { return (React.createElement(SingleActionItem, { callback: closeOnAction ? returnDefault : undefined, item: item, key: key, index: key, opened: menuOpen, hasFocus: key === currentIndex, updateCurrent: setCurrentIndex, subitems: item.subitems, onClick: closeOnAction ? returnDefault : undefined })); })))),
        objectNotEmpty(tooltip) && !!noIcon && (React.createElement(BaSeTooltip, __assign({ buddyRef: menuRef, open: isTooltipOpen }, tooltip)))));
};
BaSeActionItem.displayName = 'BaSeActionItem';

var BaSeDataSelectionContext = React.createContext({
    isAllSelected: false,
    isAllFromPageSelected: false,
    selectedItems: [],
    setIsAllSelected: function () { },
    setIsAllFromPageSelected: function () { },
    setSelectedItems: function () { },
});
function BaSeDataSelectionProvider(_a) {
    var hasSelection = _a.hasSelection, isAllSelected = _a.isAllSelected, isAllFromPageSelected = _a.isAllFromPageSelected, selectedItems = _a.selectedItems, setIsAllSelected = _a.setIsAllSelected, setIsAllFromPageSelected = _a.setIsAllFromPageSelected, setSelectedItems = _a.setSelectedItems, children = _a.children;
    if (hasSelection) {
        return (React.createElement(BaSeDataSelectionContext.Provider, { value: {
                isAllSelected: isAllSelected,
                isAllFromPageSelected: isAllFromPageSelected,
                selectedItems: selectedItems,
                setIsAllSelected: setIsAllSelected,
                setIsAllFromPageSelected: setIsAllFromPageSelected,
                setSelectedItems: setSelectedItems,
            } }, children));
    }
    return React.createElement(React.Fragment, null, children);
}
var BaSeDataSelectionConsumer = BaSeDataSelectionContext.Consumer;

var spacePixels = '24px';
var densityPixels = function (densityLevel, factor) {
    if (factor === void 0) { factor = 1; }
    return "".concat(factor * (densityLevel === 'high' ? 4 : densityLevel === 'low' ? 16 : 8) // normal
    , "px");
};
var DataContainer = styled.div.attrs({
    className: 'BaSe--data',
})(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  box-sizing: border-box;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), numberWithUnit(width));
});
var DataWrapper = styled.section.attrs({
    className: 'BaSe--data-wrapper',
})(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  &.BaSe--data-wrapper {\n    display: grid;\n    grid-template-areas:\n      'header'\n      'selection-helper'\n      'filter-or-tags'\n      'content'\n      'footer';\n    border-radius: 8px;\n    box-shadow: ", ";\n  }\n"], ["\n  &.BaSe--data-wrapper {\n    display: grid;\n    grid-template-areas:\n      'header'\n      'selection-helper'\n      'filter-or-tags'\n      'content'\n      'footer';\n    border-radius: 8px;\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var shadow = _a.shadow;
    return shadow;
});
var DataLoading = styled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  will-change: min-height;\n  min-height: ", "px;\n"], ["\n  will-change: min-height;\n  min-height: ", "px;\n"])), function (_a) {
    var height = _a.height;
    return height;
});
var DataHeader = styled.header.attrs({
    className: 'BaSe--data-header',
})(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  &.BaSe--data-header {\n    grid-area: header;\n    border-radius: 8px 8px 0 0;\n    position: relative;\n    will-change: padding;\n    padding: ", " ", ";\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    border: none;\n    ", "\n\n    & > *:last-child {\n      flex: 1;\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      height: 48px;\n      gap: 4px;\n    }\n  }\n"], ["\n  &.BaSe--data-header {\n    grid-area: header;\n    border-radius: 8px 8px 0 0;\n    position: relative;\n    will-change: padding;\n    padding: ", " ", ";\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    border: none;\n    ", "\n\n    & > *:last-child {\n      flex: 1;\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      height: 48px;\n      gap: 4px;\n    }\n  }\n"])), spacePixels, function (_a) {
    var horizontalPadding = _a.horizontalPadding;
    return horizontalPadding;
}, function (_a) {
    var headerBackgroundColor = _a.headerBackgroundColor;
    return headerBackgroundColor && css(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), headerBackgroundColor);
});
var DataHeaderTitle = styled.span.attrs({
    className: 'BaSe--data-header-title',
})(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 4px;\n"])));
var DataFooter = styled.footer.attrs({
    className: 'BaSe--data-footer',
})(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  &.BaSe--data-footer {\n    grid-area: footer;\n    border-radius: 0 0 8px 8px;\n    border: none;\n    will-change: padding;\n\n    ", "\n\n    ", "\n  }\n"], ["\n  &.BaSe--data-footer {\n    grid-area: footer;\n    border-radius: 0 0 8px 8px;\n    border: none;\n    will-change: padding;\n\n    ", "\n\n    ", "\n  }\n"])), function (_a) {
    var _b = _a.verticalPadding, verticalPadding = _b === void 0 ? '8px' : _b, _c = _a.horizontalPadding, horizontalPadding = _c === void 0 ? spacePixels : _c;
    return css(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), verticalPadding, horizontalPadding);
}, function (_a) {
    var footerBackgroundColor = _a.footerBackgroundColor;
    return footerBackgroundColor && css(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), footerBackgroundColor);
});
var DataSelectionHelper = styled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  grid-area: selection-helper;\n"], ["\n  grid-area: selection-helper;\n"])));
var DataFilterOrTags = styled.div.attrs({
    className: 'BaSe--data-filter-or-tags',
})(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  grid-area: filter-or-tags;\n"], ["\n  grid-area: filter-or-tags;\n"])));
var DataContent = styled.div.attrs({
    className: 'BaSe--data-content',
})(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n  grid-area: content;\n\n  ", ";\n\n  ", "\n\n  ", "\n"], ["\n  grid-area: content;\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var footerBackgroundColor = _a.footerBackgroundColor;
    return footerBackgroundColor === BaSeTheme.colors.defaultColors.transparent && css(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n      border-radius: 8px;\n    "], ["\n      border-radius: 8px;\n    "])));
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor && css(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), backgroundColor);
}, function (_a) {
    var hasHeader = _a.hasHeader, headerBackgroundColor = _a.headerBackgroundColor;
    return (!hasHeader ||
        headerBackgroundColor === BaSeTheme.colors.defaultColors.transparent) && css(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n    "], ["\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n    "])));
});
var templateObject_1$b, templateObject_2$8, templateObject_3$6, templateObject_4$5, templateObject_5$3, templateObject_6$3, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16$1;

function configMapper(_a) {
    var _b, _c;
    var config = _a.config, groupConfig = _a.groupConfig, reloadData = _a.reloadData, resetSelection = _a.resetSelection, whenRenderTextCell = _a.whenRenderTextCell;
    return ((_c = (_b = groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.map) === null || _b === void 0 ? void 0 : _b.call(groupConfig, function (groupConfigItem) { return ({
        Header: groupConfigItem.header,
        columns: configMapper({
            whenRenderTextCell: whenRenderTextCell,
            reloadData: reloadData,
            resetSelection: resetSelection,
            config: groupConfigItem.config,
        }),
    }); })) !== null && _c !== void 0 ? _c : config.map(function (configItem) { return ({
        Header: configItem.header,
        accessor: configItem.accessorKey,
        id: configItem.id,
        Cell: function (data) {
            if (configItem.mapper) {
                var cellToRender = configItem.mapper({
                    values: data.data[data.row.index],
                    reloadData: reloadData,
                    resetSelection: resetSelection,
                });
                if (cellToRender === undefined || cellToRender === null) {
                    return whenRenderTextCell('');
                }
                if (['number', 'string'].includes(typeof cellToRender)) {
                    return whenRenderTextCell(String(cellToRender));
                }
                return cellToRender;
            }
            return whenRenderTextCell(String(data.value));
        },
    }); }));
}
function rowIsSelected(_a) {
    var isAllSelected = _a.isAllSelected, selectedItems = _a.selectedItems, item = _a.item, itemKey = _a.itemKey;
    return (isAllSelected ||
        selectedItems.some(function (selectedItem) {
            return selectedItem[itemKey] && selectedItem[itemKey] === item[itemKey];
        }));
}
function renderColumnFilter(id, columnConfig) {
    var _a;
    return (_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
        var columnId = _a.columnId;
        return columnId === id;
    })) === null || _a === void 0 ? void 0 : _a.renderColumnFilter;
}
function columnFilterIconProps(id, columnConfig) {
    var _a;
    return (_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
        var columnId = _a.columnId;
        return columnId === id;
    })) === null || _a === void 0 ? void 0 : _a.columnFilterIconProps;
}
var cachePageReducedRange = {};
function pageReducedRange(options, actual) {
    var cacheKey = "".concat(actual, ": [").concat(options.toString(), "]");
    if (cachePageReducedRange[cacheKey]) {
        return cachePageReducedRange[cacheKey];
    }
    function resultWithCache(result) {
        cachePageReducedRange[cacheKey] = result;
        return result;
    }
    var ellipsis = '…';
    var siblingCount = 1;
    var boundaryCount = 1;
    var page = actual + 1;
    var count = options.length;
    function range(start, end) {
        var length = end - start + 1;
        return Array.from({ length: length }, function (_, index) { return start + index; });
    }
    var startPages = range(1, Math.min(boundaryCount, count));
    var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    var startSiblingsPages = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    var startSiblingsPagesOrEllipsis = startSiblingsPages > boundaryCount + 2
        ? [ellipsis]
        : boundaryCount + 1 < count - boundaryCount
            ? [boundaryCount + 1]
            : [];
    var endSiblingsPages = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : count - 1);
    var endSiblingsPagesOrEllipsis = endSiblingsPages < count - boundaryCount - 1
        ? [ellipsis]
        : count - boundaryCount > boundaryCount
            ? [count - boundaryCount]
            : [];
    var middlePages = range(startSiblingsPages, endSiblingsPages);
    var pages = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], startPages, true), startSiblingsPagesOrEllipsis, true), middlePages, true), endSiblingsPagesOrEllipsis, true), endPages, true);
    return resultWithCache(pages.map(function (item) { return (typeof item === 'number' ? item - 1 : item); }));
    // const boundary = 6;
    // const halfBoundary = Math.ceil(boundary / 2);
    // const total = options.length;
    // const first = 0;
    // const last = options[total - 1] ?? first;
    // const almostFirst = first + 1;
    // const almostLast = last - 1;
    // const dontNeedToReduce = last <= first + boundary - halfBoundary;
    // function inTheStart(item: number): boolean {
    //   return item <= first;
    // }
    // function notInTheStart(item: number): boolean {
    //   return !inTheStart(item);
    // }
    // function inTheEnd(item: number): boolean {
    //   return item >= last;
    // }
    // function notInTheEnd(item: number): boolean {
    //   return !inTheEnd(item);
    // }
    // function isActualAndSibling(item: number): boolean {
    //   const start = Array(halfBoundary)
    //     .fill(actual)
    //     .map((x, index) => x - index)
    //     .reverse();
    //   const end = Array(halfBoundary)
    //     .fill(actual)
    //     .map((x, index) => x + index);
    //   const actualAndSiblings = [...start, ...end];
    //   return actualAndSiblings.some(
    //     (actualAndSibling) => actualAndSibling === item,
    //   );
    // }
    // if (dontNeedToReduce) {
    //   return resultWithCache(options);
    // }
    // if (inTheEnd(actual)) {
    //   const end = Array(boundary)
    //     .fill(last)
    //     .map((x, index) => x - index)
    //     .reverse();
    //   return resultWithCache([first, '…', ...end]);
    // }
    // if (inTheStart(actual)) {
    //   const start = Array(boundary)
    //     .fill(first)
    //     .map((x, index) => x + index);
    //   return resultWithCache([...start, '…', last]);
    // }
    // const middleWithFirstAndLast: DataPageReducedRangeItem[] =
    //   options.filter(isActualAndSibling);
    // const sizeOfMiddle = middleWithFirstAndLast.length;
    // const startOfMiddle = middleWithFirstAndLast[0];
    // const endOfMiddle = middleWithFirstAndLast[sizeOfMiddle - 1];
    // if (startOfMiddle > almostFirst) {
    //   middleWithFirstAndLast.splice(0, 0, '…');
    // }
    // if (endOfMiddle < almostLast) {
    //   middleWithFirstAndLast.splice(sizeOfMiddle, 0, '…');
    // }
    // const middle = middleWithFirstAndLast
    //   .filter(notInTheStart)
    //   .filter(notInTheEnd);
    // return resultWithCache([first, ...middle, last]);
}

var showUp = keyframes(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateY(-50%);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateY(-50%);\n  }\n"])));
var showUpAnimation = css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  transform-origin: center;\n  will-change: opacity, transform;\n  animation: ", " ", "\n    ", " 1;\n"], ["\n  transform-origin: center;\n  will-change: opacity, transform;\n  animation: ", " ", "\n    ", " 1;\n"])), showUp, BaSeTheme.transitions.durationFast, BaSeTheme.transitions.continuousTimingFunction);
var FilterArea = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  flex: 1 100%;\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & > * {\n    ", "\n  }\n"], ["\n  flex: 1 100%;\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & > * {\n    ", "\n  }\n"])), function (_a) {
    var hasHeader = _a.hasHeader;
    return (hasHeader ? "16px ".concat(spacePixels) : 0);
}, showUpAnimation);
var ActivatedFilters = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var CustomFilterItem = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  gap: 8px;\n"])));
var DataFilterAreaWrapper = styled.div.attrs({
    className: 'BaSe--data-filter-area',
})(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  transition: max-height ", ";\n  position: relative;\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  border: none;\n  will-change: max-height, margin-bottom, overflow;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  transition: max-height ", ";\n  position: relative;\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  border: none;\n  will-change: max-height, margin-bottom, overflow;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n"])), "\n    ".concat(BaSeTheme.transitions.durationFast, "\n    ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n  "), function (_a) {
    var filterAreaBackgroundColor = _a.filterAreaBackgroundColor;
    return filterAreaBackgroundColor;
}, function (_a) {
    var separatorColor = _a.separatorColor, hasHeader = _a.hasHeader, filterAreaVisible = _a.filterAreaVisible, headerBackgroundColor = _a.headerBackgroundColor;
    return separatorColor &&
        hasHeader &&
        filterAreaVisible &&
        headerBackgroundColor !== BaSeTheme.colors.defaultColors.transparent && css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n      border-top: 1px solid ", ";\n    "], ["\n      border-top: 1px solid ", ";\n    "])), separatorColor);
}, function (_a) {
    var filterAreaVisible = _a.filterAreaVisible;
    return filterAreaVisible
        ? css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n          max-height: 100%;\n          margin-bottom: 0;\n        "], ["\n          max-height: 100%;\n          margin-bottom: 0;\n        "]))) : css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n          max-height: 0;\n          margin-bottom: -100%;\n        "], ["\n          max-height: 0;\n          margin-bottom: -100%;\n        "])));
}, function (_a) {
    var hasHeader = _a.hasHeader, headerBackgroundColor = _a.headerBackgroundColor;
    return (!hasHeader ||
        headerBackgroundColor === BaSeTheme.colors.defaultColors.transparent) && css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n      border-radius: 8px 8px 0 0;\n    "], ["\n      border-radius: 8px 8px 0 0;\n    "])));
});
var templateObject_1$a, templateObject_2$7, templateObject_3$5, templateObject_4$4, templateObject_5$2, templateObject_6$2, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1;

function BaSeDataFilterArea(_a) {
    var customFilterClearButtonProps = _a.customFilterClearButtonProps, textColor = _a.textColor, headerBackgroundColor = _a.headerBackgroundColor, filterAreaBackgroundColor = _a.filterAreaBackgroundColor, tags = _a.tags, separatorColor = _a.separatorColor, _b = _a.customFilterVisible, initialCustomFilterVisible = _b === void 0 ? false : _b, _c = _a.customFilterVisibleWhenHasTags, customFilterVisibleWhenHasTags = _c === void 0 ? false : _c, hasHeader = _a.hasHeader, customFilterTitle = _a.customFilterTitle, customFilterActivatedTitle = _a.customFilterActivatedTitle, setClearFilterButtonClicked = _a.setClearFilterButtonClicked, onClearFilter = _a.onClearFilter, renderCustomFilter = _a.renderCustomFilter, setFilter = _a.setFilter, setTags = _a.setTags, resetSelection = _a.resetSelection;
    if (renderCustomFilter === undefined) {
        throw Error('BaSeDataCustomFilter: "renderCustomFilter" é obrigatório');
    }
    var tagsVisible = React.useMemo(function () { return (tags === null || tags === void 0 ? void 0 : tags.length) > 0; }, [tags === null || tags === void 0 ? void 0 : tags.length]);
    var customFilterVisible = React.useMemo(function () {
        return (customFilterVisibleWhenHasTags && tags.length > 0) ||
            initialCustomFilterVisible;
    }, [initialCustomFilterVisible, customFilterVisibleWhenHasTags, tags === null || tags === void 0 ? void 0 : tags.length]);
    return (React.createElement(DataFilterAreaWrapper, { hasHeader: hasHeader, separatorColor: separatorColor, filterAreaVisible: tagsVisible || customFilterVisible, headerBackgroundColor: headerBackgroundColor, filterAreaBackgroundColor: filterAreaBackgroundColor }, (customFilterVisible || tagsVisible) && (React.createElement(FilterArea, { hasHeader: hasHeader },
        React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(React.Fragment, null,
                customFilterVisible && (React.createElement(CustomFilterItem, null,
                    React.createElement(BaSeSmall1, { color: textColor }, customFilterTitle !== null && customFilterTitle !== void 0 ? customFilterTitle : getMessage('dataFilter.customFilterTitle')),
                    React.createElement("div", null, renderCustomFilter({
                        setFilter: setFilter,
                        setTags: setTags,
                        resetSelection: resetSelection,
                    })))),
                tagsVisible && (React.createElement(ActivatedFilters, null,
                    React.createElement(BaSeSmall1, { isItalic: true, color: textColor }, customFilterActivatedTitle !== null && customFilterActivatedTitle !== void 0 ? customFilterActivatedTitle : getMessage('dataFilter.customFilterActivatedTitle')),
                    tags.map(function (tag) { return (React.createElement(BaSeTag, __assign({ key: "".concat(tag.label, "-").concat(tag.icon), color: textColor }, tag))); }),
                    React.createElement(BaSeButton, __assign({ size: "small", type: "tertiary", color: "destructive", value: getMessage('dataFilter.customFilterClear'), onClick: function () {
                            setFilter(undefined);
                            setTags === null || setTags === void 0 ? void 0 : setTags([]);
                            onClearFilter === null || onClearFilter === void 0 ? void 0 : onClearFilter({ resetSelection: resetSelection });
                            setClearFilterButtonClicked(function (clicked) { return ++clicked; });
                        } }, customFilterClearButtonProps))))));
        })))));
}

var DataPaginationWrapper = styled.div.attrs({
    className: 'BaSe--data-pagination',
})(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  height: 3em;\n  display: flex;\n  align-items: center;\n"], ["\n  height: 3em;\n  display: flex;\n  align-items: center;\n"])));
var DataPaginationController = styled.div.attrs({
    className: 'BaSe--data-pagination-controller',
})(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 3em;\n  gap: 0.25em;\n"], ["\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 3em;\n  gap: 0.25em;\n"])));
var DataPaginationFixedItem = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  width: 2em;\n"], ["\n  width: 2em;\n"])));
var templateObject_1$9, templateObject_2$6, templateObject_3$4;

function BaSeDataPagination(_a) {
    var canNextPage = _a.canNextPage, canPreviousPage = _a.canPreviousPage, page = _a.page, pageCount = _a.pageCount, pageIndex = _a.pageIndex, pageReducedRange = _a.pageReducedRange, pageSize = _a.pageSize, total = _a.total, notFoundMessage = _a.notFoundMessage, singularItemDescription = _a.singularItemDescription, pluralItemDescription = _a.pluralItemDescription, _b = _a.genderOfItemDescription, genderOfItemDescription = _b === void 0 ? 'male' : _b, _c = _a.highlightedColor, highlightedColor = _c === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _d, _e = _a.itemsPerPage, itemsPerPage = _e === void 0 ? [5, 10, 15] : _e, _f = _a.compactMode, compactMode = _f === void 0 ? false : _f, gotoPage = _a.gotoPage, nextPage = _a.nextPage, previousPage = _a.previousPage, setDataPageSize = _a.setDataPageSize, setPageSize = _a.setPageSize;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(DataPaginationWrapper, null, page ? (React.createElement(React.Fragment, null,
        React.createElement(BaSeSmall1, { color: foregroundColor }, total === 0
            ? notFoundMessage !== null && notFoundMessage !== void 0 ? notFoundMessage : getMessage('dataPagination.noItemsToDisplay', pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
            : total === 1
                ? getMessage('dataPagination.showingOneItems', singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
                : total === page.length
                    ? getMessage("dataPagination.showingAllItems.".concat(genderOfItemDescription), total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
                    : getMessage('dataPagination.showingItems', page.length, total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))),
        total > 0 && (React.createElement(DataPaginationController, null, compactMode ? (React.createElement(React.Fragment, null,
            React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, onClick: function () { return previousPage(); }, isDisabled: !canPreviousPage, sizeIcon: "big", nameIcon: "angle-left" }),
            React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, onClick: function () { return nextPage(); }, isDisabled: !canNextPage, sizeIcon: "big", nameIcon: "angle-right" }))) : (React.createElement(React.Fragment, null,
            (pageReducedRange === null || pageReducedRange === void 0 ? void 0 : pageReducedRange.length) > 1 && (React.createElement(React.Fragment, null,
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return gotoPage(0); }, isDisabled: !canPreviousPage, nameIcon: "angle-double-left" })),
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return previousPage(); }, isDisabled: !canPreviousPage, nameIcon: "angle-left" })),
                React.createElement("span", { style: { display: 'flex', gap: '4px' } }, pageReducedRange.map(function (pageOption, index) { return (React.createElement(DataPaginationFixedItem, { key: "".concat(pageOption, "-").concat(index) }, typeof pageOption === 'number' ? (React.createElement(BaSeShapeButton, { type: pageOption === pageIndex
                        ? 'primary'
                        : 'tertiary', color: pageOption === pageIndex
                        ? highlightedColor
                        : foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return gotoPage(pageOption); }, value: pageOption + 1 + '' })) : (React.createElement(BaSeText, { color: foregroundColor }, pageOption)))); })),
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return nextPage(); }, isDisabled: !canNextPage, nameIcon: "angle-right" })),
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return gotoPage(pageCount - 1); }, isDisabled: !canNextPage, nameIcon: "angle-double-right" })))),
            React.createElement(BaSeSmall1, { color: foregroundColor }, getMessage('dataPagination.perPage')),
            React.createElement(BaSeSelect, { size: "small", width: "70px", color: foregroundColor, removeEmptyValue: true, selectedValueId: pageSize, values: itemsPerPage.map(function (itemPageSize) { return ({
                    id: +itemPageSize,
                    label: itemPageSize + '',
                }); }), onChange: function (_a) {
                    var itemPageSize = _a.id;
                    if (itemPageSize) {
                        setPageSize(+itemPageSize);
                        setDataPageSize(+itemPageSize);
                    }
                } }))))))) : (React.createElement(BaSeSmall1, { color: foregroundColor }, total === 0
        ? notFoundMessage !== null && notFoundMessage !== void 0 ? notFoundMessage : getMessage('dataPagination.noItemsToDisplay', pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
        : total === 1
            ? getMessage('dataPagination.showingOneItems', singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
            : getMessage('dataPagination.showingMoreThanOneItem', total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))))));
}

var DataHeaderTitleSelection = styled(DataHeaderTitle)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var DataSelectOrUnselectAllItem = styled(DataHeaderTitleSelection)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 4px;\n"])));
var DataSelectionCounter = styled.span(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  flex: 1 100%;\n  opacity: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  flex: 1 100%;\n  opacity: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])), function (_a) {
    var fadeIn = _a.fadeIn;
    return (fadeIn ? 1 : 0);
});
var DataSelectOrUnselectAllArea = styled.span(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  height: 50px;\n  margin-bottom: 0;\n  will-change: height, margin-bottom;\n  transition: height ", ";\n  background-color: ", ";\n\n  &:empty {\n    height: 0;\n    margin-bottom: -100%;\n  }\n"], ["\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  height: 50px;\n  margin-bottom: 0;\n  will-change: height, margin-bottom;\n  transition: height ", ";\n  background-color: ", ";\n\n  &:empty {\n    height: 0;\n    margin-bottom: -100%;\n  }\n"])), "\n    ".concat(BaSeTheme.transitions.durationFast, "\n    ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n  "), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
});
var templateObject_1$8, templateObject_2$5, templateObject_3$3, templateObject_4$3;

function DataHeaderSelection(_a) {
    var _b, _c;
    var isAllSelected = _a.isAllSelected, pluralItemDescription = _a.pluralItemDescription, singularItemDescription = _a.singularItemDescription, selectedItems = _a.selectedItems, foregroundColor = _a.foregroundColor, highlightedColor = _a.highlightedColor, _d = _a.genderOfItemDescription, genderOfItemDescription = _d === void 0 ? 'male' : _d, _e = _a.total, total = _e === void 0 ? 0 : _e, reloadData = _a.reloadData, selectionIconActions = _a.selectionIconActions, selectionButtonActions = _a.selectionButtonActions, setSelectedItems = _a.setSelectedItems;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var showCounter = React.useMemo(function () { return isAllSelected || selectedItems.length > 0; }, [isAllSelected, selectedItems.length]);
    return (React.createElement(DataHeaderTitleSelection, null, (_b = selectionIconActions === null || selectionIconActions === void 0 ? void 0 : selectionIconActions({
        selectedItems: selectedItems,
        isAllSelected: isAllSelected,
        reloadData: reloadData,
    })) === null || _b === void 0 ? void 0 :
        _b.map(function (selectionIconAction) { return (React.createElement(BaSeShapeButton, __assign({ key: "".concat(selectionIconAction.nameIcon, "-").concat(selectionIconAction.value), size: "small", sizeIcon: "small", type: "tertiary", color: foregroundColor }, selectionIconAction))); }), (_c = selectionButtonActions === null || selectionButtonActions === void 0 ? void 0 : selectionButtonActions({
        selectedItems: selectedItems,
        isAllSelected: isAllSelected,
        reloadData: reloadData,
    })) === null || _c === void 0 ? void 0 :
        _c.map(function (selectionButtonAction) { return (React.createElement(BaSeButton, __assign({ key: "".concat(selectionButtonAction.rightIcon, "-").concat(selectionButtonAction.value, "-").concat(selectionButtonAction.leftIcon), size: "small", type: "tertiary", color: foregroundColor }, selectionButtonAction))); }),
        React.createElement(DataSelectionCounter, { fadeIn: showCounter },
            React.createElement(BaSeSmall1, { color: foregroundColor },
                isAllSelected || selectedItems.length === total
                    ? getMessage("dataSelection.allItemsSelected.".concat(genderOfItemDescription), total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
                    : selectedItems.length === 1
                        ? getMessage("dataSelection.oneItemSelected.".concat(genderOfItemDescription), singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
                        : getMessage("dataSelection.manyItemSelected.".concat(genderOfItemDescription), selectedItems.length, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription')),
                "."),
            selectedItems.length > 1 && (React.createElement(BaSeButton, { type: "tertiary", value: getMessage('dataSelection.cancelSelection'), size: "small", leftIcon: "close", color: highlightedColor, onClick: function () { return setSelectedItems([]); } })))));
}

var colors$1 = BaSeTheme.colors;
function DataSelectOrUnselectAll(_a) {
    var hasPagination = _a.hasPagination, singularItemDescription = _a.singularItemDescription, pluralItemDescription = _a.pluralItemDescription, compactMode = _a.compactMode, isAllFromPageSelected = _a.isAllFromPageSelected, selectedItems = _a.selectedItems, isAllSelected = _a.isAllSelected, hasSelectOrUnselectAll = _a.hasSelectOrUnselectAll, _b = _a.genderOfItemDescription, genderOfItemDescription = _b === void 0 ? 'male' : _b, _c = _a.total, total = _c === void 0 ? 0 : _c, _d = _a.highlightedColor, highlightedColor = _d === void 0 ? colors$1.institucionais.azulSebrae : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? colors$1.defaultColors.white : _e, _f = _a.textColor, textColor = _f === void 0 ? colors$1.institucionais.cinzaSebrae30 : _f, _g = _a.selectOrUnselectAllBackgroundColor, selectOrUnselectAllBackgroundColor = _g === void 0 ? colors$1.institucionais.cinzaSebrae97 : _g, selectOrUnselectAllHandler = _a.selectOrUnselectAllHandler, setIsAllSelected = _a.setIsAllSelected, setSelectedItems = _a.setSelectedItems;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _h = React.useState(false), loading = _h[0], setLoading = _h[1];
    var remainItemsCount = React.useMemo(function () { return total - selectedItems.length; }, [total, selectedItems]);
    var onClick = React.useCallback(function (selectOrUnselectAll) {
        if (typeof selectOrUnselectAllHandler === 'function') {
            return selectOrUnselectAllHandler({
                isAllSelected: selectOrUnselectAll,
                setLoading: setLoading,
                setIsAllSelected: setIsAllSelected,
                setSelectedItems: setSelectedItems,
            });
        }
        setIsAllSelected(selectOrUnselectAll);
    }, [selectOrUnselectAllHandler, setSelectedItems, setIsAllSelected]);
    if (!hasSelectOrUnselectAll || remainItemsCount < 1) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DataSelectOrUnselectAllArea, { backgroundColor: compactMode ? backgroundColor : selectOrUnselectAllBackgroundColor }, hasPagination &&
        isAllFromPageSelected &&
        selectedItems.length !== total &&
        (isAllSelected ? (React.createElement(DataSelectOrUnselectAllItem, null,
            React.createElement(BaSeParagraph, { color: textColor }, "".concat(getMessage("dataSelection.allItemsSelected.".concat(genderOfItemDescription), total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription')), ".")),
            React.createElement(BaSeButton, { isLoading: loading, size: "medium", type: "tertiary", color: highlightedColor, leftIcon: "close", onClick: function () { return onClick(false); }, value: getMessage("dataSelection.unselectAllItems.".concat(genderOfItemDescription)) }))) : (React.createElement(DataSelectOrUnselectAllItem, null,
            React.createElement(BaSeParagraph, { color: textColor }, "".concat(selectedItems.length === 1
                ? getMessage("dataSelection.almostAllSelected.".concat(genderOfItemDescription))
                : getMessage("dataSelection.allPageSelected"), ".")),
            React.createElement(BaSeButton, { isLoading: loading, size: "medium", type: "tertiary", color: highlightedColor, leftIcon: "check-double-tonescale", onClick: function () { return onClick(true); }, value: remainItemsCount === 1
                    ? getMessage("dataSelection.selectTheLastOne.".concat(genderOfItemDescription), singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
                    : getMessage("dataSelection.selectTheOtherRemaining.".concat(genderOfItemDescription), remainItemsCount, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription')) }))))));
}

function DataToggleAllCheckbox(_a) {
    var highlightedColor = _a.highlightedColor, actualItems = _a.actualItems, rowIdKey = _a.rowIdKey, hasToggleAllSelection = _a.hasToggleAllSelection, toggleAllSelectionHandler = _a.toggleAllSelectionHandler;
    var _b = React.useState(actualItems), itemsToSelect = _b[0], setItems = _b[1];
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useContext(BaSeDataSelectionContext), isAllSelected = _d.isAllSelected, isAllFromPageSelected = _d.isAllFromPageSelected, selectedItems = _d.selectedItems, setIsAllFromPageSelected = _d.setIsAllFromPageSelected, setSelectedItems = _d.setSelectedItems;
    var checked = React.useMemo(function () { return isAllSelected || isAllFromPageSelected; }, [isAllSelected, isAllFromPageSelected]);
    var indeterminate = React.useMemo(function () {
        return actualItems.some(function (actualItem) {
            return selectedItems.some(function (selectedItem) {
                return selectedItem[rowIdKey] === actualItem[rowIdKey];
            });
        });
    }, [itemsToSelect, selectedItems]);
    React.useEffect(function () {
        return setIsAllFromPageSelected(isAllSelected ||
            (selectedItems.length > 0 &&
                actualItems.every(function (actualItem) {
                    return selectedItems.some(function (selectedItem) {
                        return selectedItem[rowIdKey] === actualItem[rowIdKey];
                    });
                })));
    }, [isAllSelected, itemsToSelect, selectedItems, rowIdKey]);
    React.useEffect(function () {
        return toggleAllSelectionHandler === null || toggleAllSelectionHandler === void 0 ? void 0 : toggleAllSelectionHandler({
            setLoading: setLoading,
            setItems: setItems,
        });
    }, [toggleAllSelectionHandler]);
    if (!hasToggleAllSelection || isAllSelected || itemsToSelect.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    if (loading) {
        return (React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(BaSeLoadingSpinner, { diameter: 20, description: getMessage('loading.description') }));
        }));
    }
    return (React.createElement(BaSeCheckbox, { color: highlightedColor, checked: checked || indeterminate, indeterminate: !checked && indeterminate, onChange: function (changedChecked) {
            setSelectedItems(function (actualSelectedItems) {
                return actualSelectedItems.filter(function (actualSelectedItem) {
                    return actualItems.every(function (actualItem) {
                        return actualItem[rowIdKey] !== actualSelectedItem[rowIdKey];
                    });
                });
            });
            if (changedChecked) {
                setSelectedItems(function (actual) { return __spreadArray(__spreadArray([], actual, true), itemsToSelect, true); });
            }
        } }));
}

function DataToggleRowCheckbox(_a) {
    var highlightedColor = _a.highlightedColor, rowIdKey = _a.rowIdKey, rowItem = _a.rowItem, itemSelectionHandler = _a.itemSelectionHandler;
    var _b = React.useState(false), disabled = _b[0], setDisabled = _b[1];
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useContext(BaSeDataSelectionContext), isAllSelected = _d.isAllSelected, selectedItems = _d.selectedItems, setSelectedItems = _d.setSelectedItems;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var rowSelected = React.useMemo(function () {
        return isAllSelected ||
            selectedItems.some(function (item) { return rowItem[rowIdKey] === item[rowIdKey]; });
    }, [isAllSelected, selectedItems]);
    var setSelected = React.useCallback(function (checked) {
        setSelectedItems(function (actual) {
            return actual.filter(function (item) { return rowItem[rowIdKey] !== item[rowIdKey]; });
        });
        if (checked) {
            setSelectedItems(function (actual) { return __spreadArray(__spreadArray([], actual, true), [rowItem], false); });
        }
    }, [setSelectedItems]);
    React.useEffect(function () {
        return itemSelectionHandler === null || itemSelectionHandler === void 0 ? void 0 : itemSelectionHandler({
            values: rowItem,
            setDisabled: setDisabled,
            setLoading: setLoading,
            setSelected: setSelected,
        });
    }, [itemSelectionHandler, rowItem, setSelected]);
    React.useEffect(function () {
        if (disabled) {
            setSelectedItems(function (actual) {
                return actual.filter(function (item) { return rowItem[rowIdKey] !== item[rowIdKey]; });
            });
        }
    }, [disabled]);
    if (loading) {
        return (React.createElement(BaSeLoadingSpinner, { diameter: 20, description: getMessage('loading.description') }));
    }
    return isAllSelected ? (React.createElement(BaSeIcon, { name: "check", description: getMessage('dataSelection.selectedItem'), color: highlightedColor, size: 28 })) : (React.createElement(BaSeCheckbox, { color: highlightedColor, checked: rowSelected, disabled: disabled, onChange: setSelected }));
}

var IconButton = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  overflow: visible;\n"], ["\n  overflow: visible;\n"])));
var TextFilterContainer = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var textFilterAlwaysVisible = _a.textFilterAlwaysVisible;
    return !textFilterAlwaysVisible && css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n      overflow: hidden;\n      transition: width ", ";\n    "], ["\n      overflow: hidden;\n      transition: width ", ";\n    "])), BaSeTheme.transitions.durationSlow);
});
var DataTextFilterWrapper = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var textFilterVisible = _a.textFilterVisible, textFilterWidth = _a.textFilterWidth, compactMode = _a.compactMode;
    return textFilterVisible
        ? css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n          ", " {\n            width: ", ";\n            height: auto;\n          }\n          ", " {\n            display: none;\n          }\n        "], ["\n          ", " {\n            width: ", ";\n            height: auto;\n          }\n          ", " {\n            display: none;\n          }\n        "])), TextFilterContainer, compactMode ? 'auto' : "".concat(textFilterWidth, "px"), IconButton) : css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n          ", " {\n            width: 0;\n            height: 0;\n          }\n          ", " {\n            display: block;\n          }\n        "], ["\n          ", " {\n            width: 0;\n            height: 0;\n          }\n          ", " {\n            display: block;\n          }\n        "])), TextFilterContainer, IconButton);
});
var templateObject_1$7, templateObject_2$4, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1;

function BaSeDataTextFilter(_a) {
    var textFilterPlaceholder = _a.textFilterPlaceholder, textFilterIconProps = _a.textFilterIconProps, clearFilterButtonClicked = _a.clearFilterButtonClicked, _b = _a.textFilterInitialValue, textFilterInitialValue = _b === void 0 ? '' : _b, _c = _a.textFilterAlwaysVisible, textFilterAlwaysVisible = _c === void 0 ? false : _c, _d = _a.textFilterOnTyping, textFilterOnTyping = _d === void 0 ? true : _d, _e = _a.textFilterWidth, textFilterWidth = _e === void 0 ? 250 : _e, _f = _a.highlightedColor, highlightedColor = _f === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _f, _g = _a.foregroundColor, foregroundColor = _g === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _g, _h = _a.textColor, textColor = _h === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _h, compactMode = _a.compactMode, setFilter = _a.setFilter, setTags = _a.setTags, resetSelection = _a.resetSelection, onClearFilter = _a.onClearFilter, onTextFilter = _a.onTextFilter, setHasFilterFocus = _a.setHasFilterFocus;
    var _j = React.useState(textFilterAlwaysVisible), textFilterVisible = _j[0], setTextFilterVisible = _j[1];
    var _k = React.useState(textFilterInitialValue), textFilterInputValue = _k[0], setTextFilterInputValue = _k[1];
    var _l = React.useState(foregroundColor), color = _l[0], setColor = _l[1];
    var delay = React.useMemo(function () { return (textFilterOnTyping ? 350 : 0); }, [textFilterOnTyping]);
    var textFilterValue = useDebounce(textFilterInputValue, delay);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var textFilterInputRef = React.createRef();
    var cleanAndClose = React.useCallback(function () {
        if (textFilterValue) {
            setTextFilterInputValue('');
        }
        setTextFilterVisible(textFilterAlwaysVisible);
    }, [textFilterValue, textFilterAlwaysVisible]);
    var sendFilter = React.useCallback(function (text) {
        var _a;
        var term = (_a = text === null || text === void 0 ? void 0 : text.trim) === null || _a === void 0 ? void 0 : _a.call(text);
        if (typeof onTextFilter === 'function') {
            onTextFilter({ setFilter: setFilter, setTags: setTags, resetSelection: resetSelection, term: term });
        }
        else {
            setFilter((term || undefined));
        }
        if (clearFilterButtonClicked &&
            !term &&
            typeof onClearFilter === 'function') {
            onClearFilter({ resetSelection: resetSelection });
        }
    }, [onTextFilter, onClearFilter, setFilter, setTags, clearFilterButtonClicked]);
    React.useEffect(function () {
        var _a;
        if (!textFilterAlwaysVisible && textFilterVisible) {
            (_a = textFilterInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [textFilterVisible]);
    React.useEffect(function () {
        if (clearFilterButtonClicked) {
            cleanAndClose();
        }
    }, [clearFilterButtonClicked]);
    React.useEffect(function () {
        if (textFilterOnTyping) {
            sendFilter(textFilterValue);
        }
    }, [textFilterValue, textFilterOnTyping]);
    return (React.createElement(DataTextFilterWrapper, { textFilterVisible: textFilterVisible, textFilterWidth: textFilterWidth, compactMode: compactMode },
        React.createElement(TextFilterContainer, { textFilterAlwaysVisible: textFilterAlwaysVisible },
            React.createElement(BaSeInput, { ref: textFilterInputRef, size: "small", placeholder: textFilterPlaceholder !== null && textFilterPlaceholder !== void 0 ? textFilterPlaceholder : getMessage('dataFilter.textFilterPlaceholder'), iconButton: {
                    color: color,
                    name: textFilterInputValue ? 'close' : 'search',
                    typeButton: 'base-icon',
                    action: function () { return cleanAndClose(); },
                }, onSpecificKeyDown: [
                    { listenerKey: 'Esc', callback: function () { return cleanAndClose(); } },
                    {
                        listenerKey: 'Enter',
                        callback: function () { return sendFilter(textFilterValue); },
                    },
                ], color: color, value: textFilterInputValue, onFocus: function () {
                    setHasFilterFocus(true);
                    setColor(highlightedColor);
                }, onBlur: function () {
                    setHasFilterFocus(false);
                    setColor(foregroundColor);
                    if (!textFilterInputValue) {
                        setTextFilterVisible(textFilterAlwaysVisible);
                    }
                }, onChange: function (value) {
                    setColor(textFilterInputValue ? highlightedColor : foregroundColor);
                    setTextFilterInputValue(value);
                } })),
        !textFilterAlwaysVisible && (React.createElement(IconButton, null,
            React.createElement(BaSeShapeButton, __assign({ size: "small", sizeIcon: "small", nameIcon: "search", type: "tertiary", color: foregroundColor, tooltip: {
                    size: 'small',
                    direction: 'top',
                    messageNoBreakLine: true,
                    color: textColor,
                    message: textFilterPlaceholder !== null && textFilterPlaceholder !== void 0 ? textFilterPlaceholder : getMessage('dataFilter.textFilterPlaceholder'),
                }, onClick: function () { return setTextFilterVisible(true); } }, textFilterIconProps))))));
}

var DATA_SELECTION_ID = 'BaSe-data-selection';
var colors = BaSeTheme.colors;
function BaSeDataForwardedRef(_a, forwardedRef) {
    var _b;
    var 
    // data
    total = _a.total, _c = _a.items, items = _c === void 0 ? [] : _c, _d = _a.initialPageSize, initialPageSize = _d === void 0 ? 10 : _d, _e = _a.initialPageIndex, initialPageIndex = _e === void 0 ? 0 : _e, _f = _a.initialSortType, initialSortType = _f === void 0 ? 'ASC' : _f, initialSortField = _a.initialSortField, _g = _a.idAccessorKey, idAccessorKey = _g === void 0 ? 'id' : _g, itemsPerPage = _a.itemsPerPage, 
    // config
    config = _a.config, configActionItems = _a.configActionItems, groupConfig = _a.groupConfig, loadingText = _a.loadingText, textFilterPlaceholder = _a.textFilterPlaceholder, textFilterInitialValue = _a.textFilterInitialValue, textFilterAlwaysVisible = _a.textFilterAlwaysVisible, textFilterWidth = _a.textFilterWidth, _h = _a.customFilterIconVisible, customFilterIconVisible = _h === void 0 ? true : _h, _j = _a.customFilterVisibleWhenHasTags, customFilterVisibleWhenHasTags = _j === void 0 ? false : _j, _k = _a.customFilterVisible, initialCustomFilterVisible = _k === void 0 ? false : _k, _l = _a.isLoading, isLoading = _l === void 0 ? false : _l, _m = _a.hasCustomFilter, hasCustomFilter = _m === void 0 ? false : _m, _o = _a.hasPagination, hasPagination = _o === void 0 ? false : _o, _p = _a.hasSelection, hasSelection = _p === void 0 ? false : _p, _q = _a.hasSorting, hasSorting = _q === void 0 ? false : _q, _r = _a.hasTextFilter, hasTextFilter = _r === void 0 ? false : _r, 
    // layout
    title = _a.title, subTitle = _a.subTitle, customFilterTitle = _a.customFilterTitle, customFilterActivatedTitle = _a.customFilterActivatedTitle, width = _a.width, notFoundMessage = _a.notFoundMessage, pluralItemDescription = _a.pluralItemDescription, configActionItemsProps = _a.configActionItemsProps, textFilterIconProps = _a.textFilterIconProps, textFilterOnTyping = _a.textFilterOnTyping, customFilterIconProps = _a.customFilterIconProps, customFilterClearButtonProps = _a.customFilterClearButtonProps, singularItemDescription = _a.singularItemDescription, _s = _a.hasToggleAllSelection, hasToggleAllSelection = _s === void 0 ? true : _s, _t = _a.genderOfItemDescription, genderOfItemDescription = _t === void 0 ? 'male' : _t, _u = _a.compactMode, compactMode = _u === void 0 ? false : _u, _v = _a.hasHeader, hasHeader = _v === void 0 ? true : _v, _w = _a.hasSelectOrUnselectAll, hasSelectOrUnselectAll = _w === void 0 ? true : _w, _x = _a.shadow, shadow = _x === void 0 ? BaSeTheme.shadows.profundidade4 : _x, 
    // colors
    _y = _a.highlightedColor, 
    // colors
    highlightedColor = _y === void 0 ? colors.institucionais.azulSebrae : _y, _z = _a.foregroundColor, foregroundColor = _z === void 0 ? colors.institucionais.cinzaSebrae60 : _z, _0 = _a.backgroundColor, backgroundColor = _0 === void 0 ? colors.defaultColors.white : _0, _1 = _a.headerBackgroundColor, externalHeaderBackgroundColor = _1 === void 0 ? colors.defaultColors
        .white : _1, _2 = _a.footerBackgroundColor, footerBackgroundColor = _2 === void 0 ? colors.defaultColors.white : _2, _3 = _a.titleColor, titleColor = _3 === void 0 ? colors.institucionais.cinzaSebrae45 : _3, _4 = _a.textColor, textColor = _4 === void 0 ? colors.institucionais.cinzaSebrae30 : _4, _5 = _a.separatorColor, separatorColor = _5 === void 0 ? colors.institucionais.cinzaSebrae90 : _5, _6 = _a.filterAreaBackgroundColor, filterAreaBackgroundColor = _6 === void 0 ? colors.institucionais.cinzaSebrae97 : _6, _7 = _a.selectOrUnselectAllBackgroundColor, selectOrUnselectAllBackgroundColor = _7 === void 0 ? colors.institucionais.cinzaSebrae97 : _7, 
    // methods
    fetchData = _a.fetchData, render = _a.render, whenRenderTextCell = _a.whenRenderTextCell, renderCustomFilter = _a.renderCustomFilter, onClearFilter = _a.onClearFilter, onTextFilter = _a.onTextFilter, renderNotFoundContent = _a.renderNotFoundContent, itemSelectionHandler = _a.itemSelectionHandler, toggleAllSelectionHandler = _a.toggleAllSelectionHandler, selectOrUnselectAllHandler = _a.selectOrUnselectAllHandler, _8 = _a.extraIconActions, extraIconActions = _8 === void 0 ? function () { return []; } : _8, _9 = _a.extraButtonActions, extraButtonActions = _9 === void 0 ? function () { return []; } : _9, _10 = _a.selectionIconActions, selectionIconActions = _10 === void 0 ? function () { return []; } : _10, _11 = _a.selectionButtonActions, selectionButtonActions = _11 === void 0 ? function () { return []; } : _11, rowConfig = _a.rowConfig;
    total !== null && total !== void 0 ? total : (total = (_b = items === null || items === void 0 ? void 0 : items.length) !== null && _b !== void 0 ? _b : 0);
    if (total === undefined) {
        throw Error('[BaSeData] "total" inválido');
    }
    if (groupConfig && config) {
        throw Error('[BaSeData] Use somente o "config" ou o "groupConfig"');
    }
    if (hasSorting && initialSortField === undefined) {
        throw Error('[BaSeData] Informe o campo inicial que veio ordenado com o "initialSortField"');
    }
    if (hasPagination && fetchData === undefined) {
        throw Error('[BaSeData] Informe o callback "fetchData" para utilizar a paginação');
    }
    if (customFilterVisibleWhenHasTags && customFilterIconVisible) {
        throw Error('[BaSeData] Caso configure que o custom filter só fique visível ' +
            'quando tiver tag, não pode exibir o ícone do custom filter');
    }
    var _12 = React.useState(foregroundColor), configActionItemsColor = _12[0], setConfigActionItemsColor = _12[1];
    var _13 = React.useState(initialPageSize), dataPageSize = _13[0], setDataPageSize = _13[1];
    var _14 = React.useState(0), fetchAgain = _14[0], setFetchAgain = _14[1];
    var _15 = React.useState(0), containerHeight = _15[0], setContainerHeight = _15[1];
    var _16 = React.useState(false), isAllSelected = _16[0], setIsAllSelected = _16[1];
    var _17 = React.useState(false), isAllFromPageSelected = _17[0], setIsAllFromPageSelected = _17[1];
    var _18 = React.useState(items.filter(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item['isSelected']) !== null && _a !== void 0 ? _a : false; })), selectedItems = _18[0], setSelectedItems = _18[1];
    var _19 = React.useState(), filter = _19[0], setFilter = _19[1];
    var _20 = React.useState([]), tags = _20[0], setTags = _20[1];
    var _21 = React.useState(0), clearFilterButtonClicked = _21[0], setClearFilterButtonClicked = _21[1];
    var _22 = React.useState(initialCustomFilterVisible), customFilterVisible = _22[0], setCustomFilterVisible = _22[1];
    var _23 = React.useState(false), hasFilterFocus = _23[0], setHasFilterFocus = _23[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var renderedContainerRef = React.useRef(null);
    var headerBackgroundColor = React.useMemo(function () {
        return hasHeader
            ? externalHeaderBackgroundColor
            : colors.defaultColors.transparent;
    }, [externalHeaderBackgroundColor, hasHeader]);
    var dataWrapperShadow = React.useMemo(function () {
        return compactMode ||
            (backgroundColor === colors.defaultColors.transparent &&
                (headerBackgroundColor === colors.defaultColors.transparent ||
                    footerBackgroundColor === colors.defaultColors.transparent))
            ? 'none'
            : shadow;
    }, [
        compactMode,
        backgroundColor,
        headerBackgroundColor,
        footerBackgroundColor,
        shadow,
    ]);
    var _24 = React.useMemo(function () {
        var tableState = {};
        var pluginHook = [];
        if (hasSorting) {
            tableState.sortBy = [
                {
                    id: initialSortField,
                    desc: initialSortType === 'DESC',
                },
            ];
            pluginHook.push(useSortBy);
        }
        if (hasPagination) {
            tableState.pageIndex = initialPageIndex;
            tableState.pageSize = initialPageSize;
            pluginHook.push(usePagination);
        }
        if (hasSelection) {
            pluginHook.push(function (hooks) {
                hooks.visibleColumns.push(function (cols) { return __spreadArray([
                    {
                        id: DATA_SELECTION_ID,
                        Header: function (_a) {
                            var rows = _a.rows;
                            return (React.createElement(DataToggleAllCheckbox, { highlightedColor: highlightedColor, rowIdKey: idAccessorKey, actualItems: rows.map(function (row) { return row.original; }), hasToggleAllSelection: hasToggleAllSelection, toggleAllSelectionHandler: toggleAllSelectionHandler }));
                        },
                        Cell: function (_a) {
                            var _b;
                            var row = _a.row;
                            return (React.createElement(DataToggleRowCheckbox, { highlightedColor: (_b = rowConfig === null || rowConfig === void 0 ? void 0 : rowConfig({ values: row.original }).highlightedColor) !== null && _b !== void 0 ? _b : highlightedColor, rowIdKey: idAccessorKey, rowItem: row.original, itemSelectionHandler: itemSelectionHandler }));
                        },
                    }
                ], cols, true); });
            });
        }
        return [pluginHook, tableState];
    }, [
        hasPagination,
        hasSelection,
        hasSorting,
        highlightedColor,
        idAccessorKey,
        initialPageIndex,
        initialPageSize,
        initialSortField,
        initialSortType,
    ]), plugins = _24[0], initialState = _24[1];
    var resetSelection = React.useCallback(function () {
        setIsAllSelected(false);
        setIsAllFromPageSelected(false);
        setSelectedItems([]);
    }, []);
    var reloadData = React.useCallback(function (reloadDataConfig) {
        if (reloadDataConfig === void 0) { reloadDataConfig = {}; }
        if (reloadDataConfig === null || reloadDataConfig === void 0 ? void 0 : reloadDataConfig.resetSelection) {
            resetSelection();
        }
        setFetchAgain(function (counter) { return counter + 1; });
    }, [resetSelection]);
    var data = React.useMemo(function () { return items; }, [items]);
    var columns = React.useMemo(function () {
        return configMapper({
            config: config !== null && config !== void 0 ? config : [],
            groupConfig: groupConfig,
            reloadData: reloadData,
            resetSelection: resetSelection,
            whenRenderTextCell: whenRenderTextCell,
        });
    }, [config, groupConfig, reloadData, resetSelection, whenRenderTextCell]);
    var pageCount = React.useMemo(function () { return Math.ceil(total / dataPageSize); }, [total, dataPageSize]);
    var tableInstance = useTable.apply(void 0, __spreadArray([{
            data: data,
            columns: columns,
            initialState: initialState,
            manualPagination: true,
            pageCount: pageCount,
            manualSortBy: true,
            disableMultiSort: true,
        }], plugins, false));
    var renderData = React.useCallback(function () {
        if (isLoading) {
            return (React.createElement(DataLoading, { height: containerHeight },
                React.createElement(BaSeLoading, { spinnerSize: 64, text: loadingText, textColor: foregroundColor, backgroundColor: backgroundColor, spinnerColor: highlightedColor })));
        }
        if (!total && typeof renderNotFoundContent === 'function') {
            return renderNotFoundContent({ reloadData: reloadData });
        }
        return (React.createElement(BaSeDataSelectionProvider, { hasSelection: hasSelection, isAllSelected: isAllSelected, setIsAllSelected: setIsAllSelected, isAllFromPageSelected: isAllFromPageSelected, setIsAllFromPageSelected: setIsAllFromPageSelected, selectedItems: selectedItems, setSelectedItems: setSelectedItems },
            React.createElement("div", { ref: renderedContainerRef }, render({ table: tableInstance, setFilter: setFilter, setTags: setTags, resetSelection: resetSelection }))));
    }, [
        total,
        isLoading,
        hasSelection,
        renderNotFoundContent,
        render,
        reloadData,
        resetSelection,
        tableInstance,
        isAllSelected,
        isAllFromPageSelected,
        selectedItems,
    ]);
    React.useImperativeHandle(forwardedRef, function () { return ({ setFilter: setFilter, setTags: setTags, resetSelection: resetSelection }); }, [resetSelection]);
    React.useEffect(function () {
        var _a, _b;
        setContainerHeight((_b = (_a = renderedContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) !== null && _b !== void 0 ? _b : 300);
    }, [dataPageSize, renderedContainerRef.current]);
    React.useEffect(function () {
        if (hasSelection && isAllSelected) {
            setSelectedItems([]);
        }
    }, [hasSelection, isAllSelected]);
    React.useEffect(function () {
        var _a;
        if (!fetchData) {
            return;
        }
        var pageIndex = tableInstance.state.pageIndex;
        var pageSize = tableInstance.state.pageSize;
        var sortBy = ((_a = tableInstance.state.sortBy) !== null && _a !== void 0 ? _a : [])[0];
        var sortType = ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.desc) ? 'DESC' : 'ASC');
        var sortField = sortBy === null || sortBy === void 0 ? void 0 : sortBy.id;
        var timeout = setTimeout(function () {
            return fetchData({
                page: {
                    index: pageIndex,
                    size: pageSize,
                },
                sort: {
                    type: sortType,
                    field: sortField,
                },
                filter: filter,
            });
        }, 15);
        return function () { return clearTimeout(timeout); };
    }, [
        fetchData,
        fetchAgain,
        tableInstance.state.pageIndex,
        tableInstance.state.pageSize,
        tableInstance.state.sortBy,
        filter,
    ]);
    React.useEffect(function () { var _a; return (_a = tableInstance === null || tableInstance === void 0 ? void 0 : tableInstance.gotoPage) === null || _a === void 0 ? void 0 : _a.call(tableInstance, 0); }, [filter]);
    var TitleWithoutSelection = React.useMemo(function () {
        return function TitleWithoutSelection() {
            return (React.createElement(DataHeaderTitle, null,
                title && React.createElement(BaSeHeading5, { color: titleColor }, title),
                subTitle && (React.createElement(BaSeHeading6, { color: foregroundColor }, subTitle))));
        };
    }, [foregroundColor, subTitle, title, titleColor]);
    var TitleWithSelectionAndIconActions = React.useMemo(function () {
        return function TitleWithSelectionAndIconActions() {
            return isAllSelected ||
                selectedItems.length ||
                (!title && !subTitle) ? (React.createElement(DataHeaderSelection, { total: total, foregroundColor: foregroundColor, highlightedColor: highlightedColor, genderOfItemDescription: genderOfItemDescription, pluralItemDescription: pluralItemDescription, singularItemDescription: singularItemDescription, isAllSelected: isAllSelected, selectedItems: selectedItems, setSelectedItems: setSelectedItems, reloadData: reloadData, selectionIconActions: selectionIconActions, selectionButtonActions: selectionButtonActions })) : (React.createElement(TitleWithoutSelection, null));
        };
    }, [
        isAllSelected,
        selectedItems,
        foregroundColor,
        genderOfItemDescription,
        pluralItemDescription,
        singularItemDescription,
        subTitle,
        title,
        total,
        reloadData,
        selectionButtonActions,
        selectionIconActions,
    ]);
    var Title = React.useMemo(function () {
        return function Title() {
            return hasSelection ? (React.createElement(TitleWithSelectionAndIconActions, null)) : (React.createElement(TitleWithoutSelection, null));
        };
    }, [hasSelection, TitleWithSelectionAndIconActions, TitleWithoutSelection]);
    var Footer = React.useMemo(function () {
        return function Footer() {
            var _a, _b;
            return !total && typeof renderNotFoundContent === 'function' ? (React.createElement(DataFooter, { verticalPadding: spacePixels, separatorColor: colors.defaultColors.transparent, footerBackgroundColor: backgroundColor })) : (React.createElement(DataFooter, { horizontalPadding: compactMode ? '0' : spacePixels, separatorColor: compactMode ? colors.defaultColors.transparent : separatorColor, footerBackgroundColor: compactMode
                    ? colors.defaultColors.transparent
                    : footerBackgroundColor }, tableInstance && (React.createElement(BaSeDataPagination, { notFoundMessage: notFoundMessage, singularItemDescription: singularItemDescription, pluralItemDescription: pluralItemDescription, genderOfItemDescription: genderOfItemDescription, compactMode: compactMode, highlightedColor: highlightedColor, foregroundColor: foregroundColor, itemsPerPage: itemsPerPage, total: total, canNextPage: tableInstance.canNextPage, canPreviousPage: tableInstance.canPreviousPage, page: tableInstance.page, pageCount: tableInstance.pageCount, pageIndex: tableInstance.state.pageIndex, pageSize: tableInstance.state.pageSize, pageReducedRange: pageReducedRange((_a = tableInstance.pageOptions) !== null && _a !== void 0 ? _a : [], (_b = tableInstance.state.pageIndex) !== null && _b !== void 0 ? _b : 0), gotoPage: tableInstance.gotoPage, nextPage: tableInstance.nextPage, previousPage: tableInstance.previousPage, setDataPageSize: setDataPageSize, setPageSize: tableInstance.setPageSize }))));
        };
    }, [
        total,
        notFoundMessage,
        itemsPerPage,
        foregroundColor,
        highlightedColor,
        singularItemDescription,
        pluralItemDescription,
        genderOfItemDescription,
        backgroundColor,
        compactMode,
        footerBackgroundColor,
        spacePixels,
        tableInstance,
        renderNotFoundContent,
    ]);
    var header = React.useCallback(function () {
        var _a, _b;
        return hasHeader ? (React.createElement(DataHeader, { horizontalPadding: compactMode ? '0' : spacePixels, headerBackgroundColor: compactMode
                ? colors.defaultColors.transparent
                : headerBackgroundColor },
            compactMode ? !hasFilterFocus && React.createElement(Title, null) : React.createElement(Title, null),
            React.createElement("div", { className: "BaSe--data-header-actions" },
                hasTextFilter && (React.createElement(BaSeDataTextFilter, { compactMode: compactMode, highlightedColor: highlightedColor, foregroundColor: foregroundColor, textFilterPlaceholder: textFilterPlaceholder, textFilterInitialValue: textFilterInitialValue, textFilterAlwaysVisible: textFilterAlwaysVisible, textFilterWidth: textFilterWidth, textFilterIconProps: textFilterIconProps, textFilterOnTyping: textFilterOnTyping, setFilter: setFilter, setTags: setTags, resetSelection: resetSelection, onTextFilter: onTextFilter, onClearFilter: onClearFilter, clearFilterButtonClicked: clearFilterButtonClicked, setHasFilterFocus: setHasFilterFocus })),
                hasCustomFilter && customFilterIconVisible && (React.createElement(BaSeShapeButton, __assign({ size: "small", sizeIcon: "small", type: "tertiary", color: customFilterVisible ? highlightedColor : foregroundColor, nameIcon: "filter", tooltip: {
                        size: 'small',
                        direction: 'top',
                        messageNoBreakLine: true,
                        color: textColor,
                        message: getMessage(customFilterVisible
                            ? 'dataFilter.closeFilter'
                            : 'dataFilter.openFilter'),
                    }, onClick: function () { return setCustomFilterVisible(function (shown) { return !shown; }); } }, customFilterIconProps))), (_a = extraIconActions === null || extraIconActions === void 0 ? void 0 : extraIconActions({ reloadData: reloadData })) === null || _a === void 0 ? void 0 :
                _a.map(function (extraIconAction) { return (React.createElement(BaSeShapeButton, __assign({ key: "".concat(extraIconAction.nameIcon, "-").concat(extraIconAction.value), size: "small", sizeIcon: "small", type: "tertiary", color: foregroundColor }, extraIconAction))); }),
                configActionItems && (React.createElement(BaSeActionItem, __assign({ size: "small", sizeIcon: "small", icon: "sliders-v-alt", position: "top-right", color: configActionItemsColor, onOpen: function () { return setConfigActionItemsColor(highlightedColor); }, onClose: function () { return setConfigActionItemsColor(foregroundColor); }, items: configActionItems.map(function (configActionItem) {
                        return 'color' in configActionItem
                            ? configActionItem
                            : __assign(__assign({}, configActionItem), { color: foregroundColor });
                    }), tooltip: {
                        size: 'small',
                        direction: 'top',
                        messageNoBreakLine: true,
                        color: textColor,
                        message: getMessage('dataConfigAction.hint'),
                    } }, configActionItemsProps))), (_b = extraButtonActions === null || extraButtonActions === void 0 ? void 0 : extraButtonActions({ reloadData: reloadData })) === null || _b === void 0 ? void 0 :
                _b.map(function (extraButtonAction) { return (React.createElement(BaSeButton, __assign({ key: "".concat(extraButtonAction.rightIcon, "-").concat(extraButtonAction.value, "-").concat(extraButtonAction.leftIcon), size: "small", type: "tertiary", color: foregroundColor }, extraButtonAction))); })))) : (React.createElement(React.Fragment, null));
    }, [
        hasHeader,
        textColor,
        compactMode,
        hasTextFilter,
        hasCustomFilter,
        foregroundColor,
        textFilterWidth,
        highlightedColor,
        configActionItems,
        textFilterIconProps,
        textFilterOnTyping,
        customFilterIconProps,
        textFilterPlaceholder,
        configActionItemsProps,
        textFilterInitialValue,
        textFilterAlwaysVisible,
        customFilterIconVisible,
        spacePixels,
        customFilterVisible,
        headerBackgroundColor,
        configActionItemsColor,
        clearFilterButtonClicked,
        setTags,
        setFilter,
        getMessage,
        reloadData,
        onTextFilter,
        onClearFilter,
        extraIconActions,
        extraButtonActions,
    ]);
    return (React.createElement(DataContainer, { width: width },
        headerBackgroundColor === colors.defaultColors.transparent && header(),
        React.createElement(DataWrapper, { shadow: dataWrapperShadow },
            headerBackgroundColor !== colors.defaultColors.transparent && header(),
            React.createElement(BaSeDataInfoProvider, null,
                React.createElement(DataContent, { hasHeader: hasHeader, footerBackgroundColor: footerBackgroundColor, headerBackgroundColor: headerBackgroundColor, backgroundColor: compactMode ? colors.defaultColors.transparent : backgroundColor }, renderData())),
            hasSelection && (React.createElement(DataSelectionHelper, null,
                React.createElement(DataSelectOrUnselectAll, { total: total, hasPagination: hasPagination, isAllFromPageSelected: isAllFromPageSelected, isAllSelected: isAllSelected, selectedItems: selectedItems, setSelectedItems: setSelectedItems, setIsAllSelected: setIsAllSelected, hasSelectOrUnselectAll: hasSelectOrUnselectAll, selectOrUnselectAllHandler: selectOrUnselectAllHandler, singularItemDescription: singularItemDescription, pluralItemDescription: pluralItemDescription, compactMode: compactMode, genderOfItemDescription: genderOfItemDescription, highlightedColor: highlightedColor, backgroundColor: backgroundColor, textColor: textColor, selectOrUnselectAllBackgroundColor: selectOrUnselectAllBackgroundColor }))),
            (hasCustomFilter || tags.length > 0) && (React.createElement(DataFilterOrTags, null,
                React.createElement(BaSeDataFilterArea, { customFilterTitle: customFilterTitle, customFilterActivatedTitle: customFilterActivatedTitle, hasHeader: hasHeader, separatorColor: separatorColor, textColor: textColor, headerBackgroundColor: headerBackgroundColor, filterAreaBackgroundColor: filterAreaBackgroundColor, customFilterClearButtonProps: customFilterClearButtonProps, customFilterVisible: customFilterVisible, customFilterVisibleWhenHasTags: customFilterVisibleWhenHasTags, tags: tags, setTags: setTags, setFilter: setFilter, resetSelection: resetSelection, renderCustomFilter: renderCustomFilter, setClearFilterButtonClicked: setClearFilterButtonClicked, onClearFilter: onClearFilter }))),
            footerBackgroundColor !== colors.defaultColors.transparent && (React.createElement(Footer, null))),
        footerBackgroundColor === colors.defaultColors.transparent && React.createElement(Footer, null)));
}
var BaSeData = React.forwardRef(BaSeDataForwardedRef);
BaSeData['displayName'] = 'BaSeData';

var DataBodyGrid = styled.div.attrs({
    className: 'BaSe--data-body-grid',
})(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-grid {\n    display: grid;\n    grid-template-columns: repeat(\n      ", ",\n      1fr\n    );\n    gap: ", ";\n    padding: 0;\n  }\n"], ["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-grid {\n    display: grid;\n    grid-template-columns: repeat(\n      ", ",\n      1fr\n    );\n    gap: ", ";\n    padding: 0;\n  }\n"])), function (_a) {
    var compactMode = _a.compactMode;
    return (compactMode ? 0 : spacePixels);
}, function (_a) {
    var _b = _a.gridColumns, gridColumns = _b === void 0 ? 3 : _b;
    return (gridColumns < 1 ? 1 : gridColumns);
}, function (_a) {
    var densityLevel = _a.densityLevel;
    return densityPixels(densityLevel);
});
var templateObject_1$6;

function BaSeDataGridForwardedRef(props, ref) {
    var _a = props.gridColumns, gridColumns = _a === void 0 ? 3 : _a, _b = props.itemsPerPage, itemsPerPage = _b === void 0 ? Array(4)
        .fill(gridColumns)
        .map(function (column, index) { return column * (index + 1); }) : _b, _c = props.densityLevel, densityLevel = _c === void 0 ? 'normal' : _c, hasSelection = props.hasSelection, compactMode = props.compactMode, renderCard = props.renderCard, 
    // eslint-disable-next-line comma-dangle
    dataProps = __rest(props, ["gridColumns", "itemsPerPage", "densityLevel", "hasSelection", "compactMode", "renderCard"]);
    if (typeof renderCard !== 'function') {
        throw Error('BaSeDataGrid: "renderCard" inválido');
    }
    if (gridColumns <= 1) {
        throw Error('[BaSeDataGrid] Se vai mostrar um item, melhor usar o BaSeDataList, não?');
    }
    return (React.createElement(BaSeData, __assign({}, dataProps, { ref: ref, config: [
            {
                header: '',
                accessorKey: 'BaSe--data-grid-item',
                mapper: renderCard,
            },
        ], groupConfig: undefined, itemsPerPage: itemsPerPage, densityLevel: densityLevel, hasSelection: hasSelection, compactMode: compactMode, whenRenderTextCell: function () { return React.createElement(React.Fragment, null); }, render: function (_a) {
            var _b = _a.table, rows = _b.rows, page = _b.page, prepareRow = _b.prepareRow;
            return (React.createElement(DataBodyGrid, { gridColumns: gridColumns, densityLevel: densityLevel, compactMode: compactMode },
                React.createElement("ul", { className: "BaSe--data-grid" }, (page !== null && page !== void 0 ? page : rows).map(function (row) {
                    prepareRow(row);
                    return (React.createElement("li", { key: row.id, className: "BaSe--data-grid-item" },
                        row.cells[0].render('Cell'),
                        hasSelection && row.cells[1].render('Cell')));
                }))));
        } })));
}
var BaSeDataGrid = React.forwardRef(BaSeDataGridForwardedRef);
BaSeDataGrid['displayName'] = 'BaSeDataGrid';

var DataBodyList = styled.div.attrs({
    className: 'BaSe--data-body-list',
})(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-list {\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding: 0;\n  }\n"], ["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-list {\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding: 0;\n  }\n"])), function (_a) {
    var compactMode = _a.compactMode;
    return (compactMode ? 0 : spacePixels);
}, function (_a) {
    var densityLevel = _a.densityLevel;
    return densityPixels(densityLevel);
});
var templateObject_1$5;

function BaSeDataListForwardedRef(props, ref) {
    var _a = props.itemsPerPage, itemsPerPage = _a === void 0 ? [3, 5, 10, 15] : _a, _b = props.densityLevel, densityLevel = _b === void 0 ? 'normal' : _b, _c = props.hasHeader, hasHeader = _c === void 0 ? true : _c, renderCard = props.renderCard, hasSelection = props.hasSelection, compactMode = props.compactMode, 
    // eslint-disable-next-line comma-dangle
    dataProps = __rest(props, ["itemsPerPage", "densityLevel", "hasHeader", "renderCard", "hasSelection", "compactMode"]);
    if (typeof renderCard !== 'function') {
        throw Error('[BaSeDataList] "renderCard" inválido');
    }
    return (React.createElement(BaSeData, __assign({}, dataProps, { ref: ref, config: [
            {
                header: '',
                accessorKey: 'BaSe--data-list-item',
                mapper: renderCard,
            },
        ], groupConfig: undefined, itemsPerPage: itemsPerPage, densityLevel: densityLevel, hasSelection: hasSelection, hasHeader: hasHeader, compactMode: compactMode, whenRenderTextCell: function () { return React.createElement(React.Fragment, null); }, render: function (_a) {
            var _b = _a.table, rows = _b.rows, page = _b.page, prepareRow = _b.prepareRow;
            return (React.createElement(DataBodyList, { densityLevel: densityLevel, compactMode: compactMode },
                React.createElement("ul", { className: "BaSe--data-list" }, (page !== null && page !== void 0 ? page : rows).map(function (row) {
                    prepareRow(row);
                    return (React.createElement("li", { key: row.id, className: "BaSe--data-list-item" },
                        row.cells[0].render('Cell'),
                        hasSelection && row.cells[1].render('Cell')));
                }))));
        } })));
}
var BaSeDataList = React.forwardRef(BaSeDataListForwardedRef);
BaSeDataList['displayName'] = 'BaSeDataList';

var tableRow = function (_a) {
    var densityLevel = _a.densityLevel;
    return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  tr {\n    ", ",\n    ", " {\n      display: flex;\n      align-items: center;\n      padding: 0;\n      margin: 0;\n    }\n\n    ", " {\n      gap: 4px;\n      justify-content: flex-start;\n    }\n\n    th,\n    td {\n      will-change: background-color;\n      transition: ", ";\n      vertical-align: middle;\n      will-change: min-height, padding;\n      min-height: ", ";\n      padding: ", ";\n\n      &:first-of-type {\n        padding-left: ", ";\n      }\n      &:last-of-type {\n        padding-right: ", ";\n      }\n    }\n  }\n"], ["\n  tr {\n    ", ",\n    ", " {\n      display: flex;\n      align-items: center;\n      padding: 0;\n      margin: 0;\n    }\n\n    ", " {\n      gap: 4px;\n      justify-content: flex-start;\n    }\n\n    th,\n    td {\n      will-change: background-color;\n      transition: ", ";\n      vertical-align: middle;\n      will-change: min-height, padding;\n      min-height: ", ";\n      padding: ", ";\n\n      &:first-of-type {\n        padding-left: ", ";\n      }\n      &:last-of-type {\n        padding-right: ", ";\n      }\n    }\n  }\n"])), DataTableHeader, DataTableCell, DataTableHeader, BaSeTheme.transitions.allPropertiesContinuousNormal, densityPixels(densityLevel, 4), "".concat(densityPixels(densityLevel), " 8px"), spacePixels, spacePixels);
};
var lightness = 0.96;
var DataTableHeader = styled.span(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DataTableCell = styled.span(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  justify-content: ", ";\n"], ["\n  position: relative;\n  flex: 1;\n  justify-content: ", ";\n"])), function (_a) {
    var align = _a.align;
    return align;
});
var DataBodyTable = styled.div.attrs({
    className: 'BaSe--data-body-table',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n\n  & > table.BaSe--data-table {\n    width: 100%;\n    border: none;\n\n    ", "\n\n    ", "\n\n    ", "\n  }\n"], ["\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n\n  & > table.BaSe--data-table {\n    width: 100%;\n    border: none;\n\n    ", "\n\n    ", "\n\n    ", "\n  }\n"])), function (props) { return tableRow(props); }, function (_a) {
    var tableHeaderBackgroundColor = _a.tableHeaderBackgroundColor;
    return css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n      thead > tr {\n        background-color: ", ";\n      }\n    "], ["\n      thead > tr {\n        background-color: ", ";\n      }\n    "])), tableHeaderBackgroundColor);
}, function (_a) {
    var backgroundColor = _a.backgroundColor, textColor = _a.textColor, separatorColor = _a.separatorColor;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      tbody > tr {\n        border-top: 1px solid ", ";\n        will-change: background-color;\n        transition: ", ";\n        background-color: ", ";\n\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    "], ["\n      tbody > tr {\n        border-top: 1px solid ", ";\n        will-change: background-color;\n        transition: ", ";\n        background-color: ", ";\n\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    "])), separatorColor, BaSeTheme.transitions.allPropertiesContinuousNormal, transformLightness(backgroundColor, lightness), transformLightness(textColor, lightness));
});
var ColumnFilterWrapper = styled.div.attrs({
    className: 'BaSe--data-table-column-filter',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  z-index: ", ";\n  border-radius: 4px;\n  padding: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n"], ["\n  position: absolute;\n  top: 100%;\n  z-index: ", ";\n  border-radius: 4px;\n  padding: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n"])), BaSeTheme.stackOrder.aboveNormal, spacePixels, function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, BaSeTheme.shadows.profundidade2, showUpAnimation);
var DataCompactTables = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  gap: ", ";\n  justify-content: stretch;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  gap: ", ";\n  justify-content: stretch;\n  align-items: stretch;\n"])), spacePixels);
var DataCompactTable = styled.div.attrs({
    className: 'BaSe--data-compact-mode-table',
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  box-sizing: border-box;\n  border-radius: 8px;\n  will-change: background-color;\n  transition: ", ";\n\n  ", "\n\n  ", "\n\n  & > table.BaSe--data-table {\n    width: 100%;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    tbody > tr:last-of-type {\n      border-bottom: none;\n    }\n\n    tr:first-of-type td {\n      border-top: none;\n    }\n\n    tr:last-of-type td {\n      border-bottom: none;\n    }\n  }\n"], ["\n  box-sizing: border-box;\n  border-radius: 8px;\n  will-change: background-color;\n  transition: ", ";\n\n  ", "\n\n  ", "\n\n  & > table.BaSe--data-table {\n    width: 100%;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    tbody > tr:last-of-type {\n      border-bottom: none;\n    }\n\n    tr:first-of-type td {\n      border-top: none;\n    }\n\n    tr:last-of-type td {\n      border-bottom: none;\n    }\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var shadow = _a.shadow;
    return shadow && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), shadow);
}, function (_a) {
    var backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
    return backgroundColor && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      background: ", ";\n    "], ["\n      border: 1px solid ", ";\n      background: ", ";\n    "])), borderColor, backgroundColor);
}, function (props) { return tableRow(props); }, function (_a) {
    var tableHeaderBackgroundColor = _a.tableHeaderBackgroundColor;
    return tableHeaderBackgroundColor && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        thead > tr > td {\n          border-radius: 8px 8px 0 0;\n          background-color: ", ";\n          border-top: none;\n        }\n      "], ["\n        thead > tr > td {\n          border-radius: 8px 8px 0 0;\n          background-color: ", ";\n          border-top: none;\n        }\n      "])), tableHeaderBackgroundColor);
}, function (_a) {
    var textColor = _a.textColor, separatorColor = _a.separatorColor;
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\n      p {\n        color: ", ";\n      }\n\n      tr {\n        border-bottom: 1px solid ", ";\n      }\n\n      tbody > tr:hover > td {\n          background-color: ", ";\n        }\n      }\n    "], ["\n\n      p {\n        color: ", ";\n      }\n\n      tr {\n        border-bottom: 1px solid ", ";\n      }\n\n      tbody > tr:hover > td {\n          background-color: ", ";\n        }\n      }\n    "])), textColor, separatorColor, transformLightness(textColor, lightness));
});
var DataStickyCellContainer = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  align-items: center;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  align-items: center;\n  gap: 4px;\n"])));
var DataStickyCell = styled(DataTableHeader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  &:last-of-type {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end !important;\n    align-items: center;\n  }\n"], ["\n  &:last-of-type {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end !important;\n    align-items: center;\n  }\n"])));
var DataTableRow = styled.tr(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  ", ";\n\n  ", "\n"], ["\n  ", ";\n\n  ", "\n"])), function (_a) {
    var borderTopColor = _a.borderTopColor, separatorColor = _a.separatorColor, textColor = _a.textColor;
    return css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n    border-bottom: 1px solid ", " !important;\n\n    p {\n      color: ", ";\n    }\n  "], ["\n    ", "\n    border-bottom: 1px solid ", " !important;\n\n    p {\n      color: ", ";\n    }\n  "])), borderTopColor && css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      border-top: 1px solid ", " !important;\n    "], ["\n      border-top: 1px solid ", " !important;\n    "])), borderTopColor), separatorColor, textColor);
}, function (_a) {
    var isSelected = _a.isSelected, highlightedColor = _a.highlightedColor, backgroundColor = _a.backgroundColor, textColor = _a.textColor;
    return isSelected
        ? css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n          background-color: ", ";\n\n          &:hover {\n            background-color: ", " !important;\n          }\n        "], ["\n          background-color: ", ";\n\n          &:hover {\n            background-color: ", " !important;\n          }\n        "])), transformLightness(highlightedColor, 0.96), transformLightness(highlightedColor, 0.96)) : css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n          background-color: ", ";\n\n          &:hover {\n            background-color: ", " !important;\n          }\n        "], ["\n          background-color: ", ";\n\n          &:hover {\n            background-color: ", " !important;\n          }\n        "])), backgroundColor, transformLightness(textColor, lightness));
});
var templateObject_1$4, templateObject_2$3, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;

// eslint-disable-next-line @typescript-eslint/ban-types
function CompactTable(_a) {
    var shadow = _a.shadow, densityLevel = _a.densityLevel, textColor = _a.textColor, separatorColor = _a.separatorColor, tableHeaderBackgroundColor = _a.tableHeaderBackgroundColor, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, tableProps = _a.tableProps, row = _a.row, foregroundColor = _a.foregroundColor, compactModeExpandable = _a.compactModeExpandable, stickyColumn = _a.stickyColumn, columnAlignment = _a.columnAlignment;
    var _b = React.useState(true), isOpen = _b[0], setIsOpen = _b[1];
    return (React.createElement(DataCompactTable, { shadow: shadow, densityLevel: densityLevel, textColor: textColor, separatorColor: separatorColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor, backgroundColor: backgroundColor, borderColor: borderColor },
        React.createElement("table", __assign({}, tableProps, { "aria-expanded": compactModeExpandable ? (isOpen ? 'true' : 'false') : undefined }),
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 2 },
                        React.createElement(DataStickyCellContainer, null, row.cells
                            .filter(function (cell) { return stickyColumn(cell.column.id); })
                            .map(function (cell, index) { return (React.createElement(DataStickyCell, { key: cell.column.id },
                            compactModeExpandable && index === 0 ? (React.createElement(BaSeShapeButton, { nameIcon: isOpen ? 'angle-down' : 'angle-right', onClick: function () { return setIsOpen(function (value) { return !value; }); }, type: "tertiary" })) : null,
                            React.createElement(DataTableCell, null, cell.render('Cell')))); }))))),
            isOpen && (React.createElement("tbody", null, row.cells
                .filter(function (cell) { return !stickyColumn(cell.column.id); })
                .map(function (cell) { return (React.createElement("tr", { key: cell.column.id },
                React.createElement("td", __assign({}, cell.column.getHeaderProps()),
                    React.createElement(DataTableHeader, null,
                        React.createElement(BaSeSmall1, { color: foregroundColor }, cell.column.render('Header')))),
                React.createElement("td", __assign({}, cell.getCellProps({ style: { width: '50%' } })),
                    React.createElement(DataTableCell, { align: columnAlignment(cell.column.id) }, cell.render('Cell'))))); }))))));
}
// eslint-disable-next-line @typescript-eslint/ban-types
function DataTableCompactMode(_a) {
    var page = _a.page, rows = _a.rows, idAccessorKey = _a.idAccessorKey, shadow = _a.shadow, 
    // columnFilterVisible,
    densityLevel = _a.densityLevel, _b = _a.columnConfig, columnConfig = _b === void 0 ? [] : _b, _c = _a.highlightedColor, highlightedColor = _c === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _d, _e = _a.textColor, textColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _e, _f = _a.separatorColor, separatorColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _f, _g = _a.backgroundColor, backgroundColor = _g === void 0 ? BaSeTheme.colors.defaultColors.white : _g, _h = _a.tableHeaderBackgroundColor, tableHeaderBackgroundColor = _h === void 0 ? BaSeTheme.colors.defaultColors.white : _h, prepareRow = _a.prepareRow, 
    // setColumnFilterVisible,
    // setFilter,
    // setTags,
    getTableProps = _a.getTableProps, rowConfig = _a.rowConfig, compactModeExpandable = _a.compactModeExpandable;
    var columnConfigItem = React.useCallback(function (id) {
        return columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
            var columnId = _a.columnId;
            return columnId === id;
        });
    }, [columnConfig]);
    var columnAlignment = React.useCallback(function (id) { var _a; return (_a = columnConfigItem(id)) === null || _a === void 0 ? void 0 : _a.align; }, [columnConfigItem]);
    var stickyColumn = React.useCallback(function (id) { var _a; return id === DATA_SELECTION_ID || ((_a = columnConfigItem(id)) === null || _a === void 0 ? void 0 : _a.stickyOnCompactMode); }, [columnConfigItem]);
    var selected = React.useCallback(function (row, isAllSelected, selectedItems) {
        return rowIsSelected({
            itemKey: idAccessorKey,
            item: row.original,
            isAllSelected: isAllSelected,
            selectedItems: selectedItems,
        });
    }, [idAccessorKey]);
    return (React.createElement(DataCompactTables, null, (page !== null && page !== void 0 ? page : rows).map(function (row) {
        prepareRow(row);
        var rowConfigItem = rowConfig === null || rowConfig === void 0 ? void 0 : rowConfig({ values: row.original });
        return (React.createElement(BaSeDataRowInfoProvider, { key: row.id },
            React.createElement(BaSeDataSelectionConsumer, null, function (_a) {
                var _b, _c, _d, _e, _f, _g, _h, _j;
                var isAllSelected = _a.isAllSelected, selectedItems = _a.selectedItems;
                return (React.createElement(CompactTable, { compactModeExpandable: compactModeExpandable, shadow: shadow, densityLevel: densityLevel, textColor: (_b = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.textColor) !== null && _b !== void 0 ? _b : textColor, separatorColor: (_c = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.separatorColor) !== null && _c !== void 0 ? _c : separatorColor, tableHeaderBackgroundColor: selected(row, isAllSelected, selectedItems)
                        ? transformLightness((_d = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.highlightedColor) !== null && _d !== void 0 ? _d : highlightedColor, lightness)
                        : tableHeaderBackgroundColor, backgroundColor: selected(row, isAllSelected, selectedItems)
                        ? transformLightness((_e = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.highlightedColor) !== null && _e !== void 0 ? _e : highlightedColor, lightness)
                        : (_f = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.backgroundColor) !== null && _f !== void 0 ? _f : backgroundColor, borderColor: selected(row, isAllSelected, selectedItems)
                        ? (_g = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.highlightedColor) !== null && _g !== void 0 ? _g : highlightedColor
                        : (_h = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.backgroundColor) !== null && _h !== void 0 ? _h : backgroundColor, tableProps: getTableProps({
                        className: 'BaSe--data-table',
                    }), row: row, foregroundColor: (_j = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.textColor) !== null && _j !== void 0 ? _j : foregroundColor, stickyColumn: stickyColumn, columnAlignment: columnAlignment }));
            })));
    })));
}

function DataTableColumnFilter(_a) {
    var _b;
    var separatorColor = _a.separatorColor, backgroundColor = _a.backgroundColor, renderColumnFilter = _a.renderColumnFilter, column = _a.column, columnConfig = _a.columnConfig, setFilter = _a.setFilter, setTags = _a.setTags, resetSelection = _a.resetSelection, setColumnFilterVisible = _a.setColumnFilterVisible;
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, function () {
        return setTimeout(function () {
            return setColumnFilterVisible(function (actual) {
                var _a;
                return (__assign(__assign({}, actual), (_a = {}, _a[column.id] = false, _a)));
            });
        }, 100);
    });
    return (React.createElement(ColumnFilterWrapper, { ref: wrapperRef, separatorColor: separatorColor, backgroundColor: backgroundColor, onClick: function (event) { return event.stopPropagation(); } }, (_b = renderColumnFilter(column.id, columnConfig)) === null || _b === void 0 ? void 0 : _b({
        setFilter: setFilter,
        setTags: setTags,
        resetSelection: resetSelection,
        closeFilter: function () {
            return setColumnFilterVisible(function (actual) {
                var _a;
                return (__assign(__assign({}, actual), (_a = {}, _a[column.id] = false, _a)));
            });
        },
    })));
}

// eslint-disable-next-line @typescript-eslint/ban-types
function DataTableNormalMode(_a) {
    var headerGroups = _a.headerGroups, page = _a.page, rows = _a.rows, idAccessorKey = _a.idAccessorKey, columnFilterVisible = _a.columnFilterVisible, densityLevel = _a.densityLevel, _b = _a.columnConfig, columnConfig = _b === void 0 ? [] : _b, _c = _a.highlightedColor, highlightedColor = _c === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _d, _e = _a.textColor, textColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _e, _f = _a.separatorColor, separatorColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _f, _g = _a.backgroundColor, backgroundColor = _g === void 0 ? BaSeTheme.colors.defaultColors.white : _g, _h = _a.tableHeaderBackgroundColor, tableHeaderBackgroundColor = _h === void 0 ? BaSeTheme.colors.defaultColors.white : _h, _j = _a.sortIcon, sortIcon = _j === void 0 ? 'arrow-head-down' : _j, _k = _a.sortingAscIcon, sortingAscIcon = _k === void 0 ? 'arrow-head-down' : _k, _l = _a.sortingDescIcon, sortingDescIcon = _l === void 0 ? 'arrow-head-up' : _l, getTableBodyProps = _a.getTableBodyProps, getTableProps = _a.getTableProps, prepareRow = _a.prepareRow, setColumnFilterVisible = _a.setColumnFilterVisible, setFilter = _a.setFilter, setTags = _a.setTags, resetSelection = _a.resetSelection, rowConfig = _a.rowConfig;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var existingRowsConfig = React.useMemo(function () {
        return rows.map(function (row) { return ({
            index: row.index,
            rowConfigItem: rowConfig === null || rowConfig === void 0 ? void 0 : rowConfig({ values: row.original }),
        }); });
    }, [rowConfig, rows]);
    var columnConfigItem = React.useCallback(function (id) {
        return columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
            var columnId = _a.columnId;
            return columnId === id;
        });
    }, [columnConfig]);
    return (React.createElement(DataBodyTable, { densityLevel: densityLevel, separatorColor: separatorColor, textColor: textColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor },
        React.createElement("table", __assign({}, getTableProps({ className: 'BaSe--data-table' })),
            React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (
            // eslint-disable-next-line react/jsx-key
            React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
                var _a, _b, _c, _d, _e, _f;
                var sortClick = (_b = (_a = column === null || column === void 0 ? void 0 : column.getSortByToggleProps) === null || _a === void 0 ? void 0 : _a.call(column)) === null || _b === void 0 ? void 0 : _b.onClick;
                return (column.isVisible && (React.createElement("th", __assign({}, column.getHeaderProps((_c = column === null || column === void 0 ? void 0 : column.getSortByToggleProps) === null || _c === void 0 ? void 0 : _c.call(column, {
                    title: undefined,
                    onClick: undefined,
                    style: {
                        cursor: 'default',
                        width: (_d = columnConfigItem(column.id)) === null || _d === void 0 ? void 0 : _d.width,
                    },
                }))),
                    React.createElement(DataTableHeader, { style: {
                            display: 'flex',
                            justifyContent: (_f = (_e = columnConfigItem(column.id)) === null || _e === void 0 ? void 0 : _e.align) !== null && _f !== void 0 ? _f : 'start',
                        } },
                        React.createElement(BaSeSmall1, { color: foregroundColor }, column.render('Header')),
                        column.canSort &&
                            (column.isSorted ? (column.isSortedDesc ? (React.createElement(BaSeShapeButton, { size: "small", sizeIcon: "small", type: "tertiary", nameIcon: sortingDescIcon, color: highlightedColor, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage('dataTable.sortHint.desc'),
                                }, onClick: sortClick })) : (React.createElement(BaSeShapeButton, { size: "small", sizeIcon: "small", color: highlightedColor, type: "tertiary", nameIcon: sortingAscIcon, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage('dataTable.sortHint.asc'),
                                }, onClick: sortClick }))) : (React.createElement(BaSeShapeButton, { size: "small", sizeIcon: "small", type: "tertiary", nameIcon: sortIcon, color: foregroundColor, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage('dataTable.sortHint'),
                                }, onClick: sortClick }))),
                        !!renderColumnFilter(column.id, columnConfig) && (React.createElement(React.Fragment, null,
                            React.createElement(BaSeShapeButton, __assign({ key: column.id, size: "small", sizeIcon: "small", nameIcon: "filter", type: "tertiary", color: !!(columnFilterVisible === null || columnFilterVisible === void 0 ? void 0 : columnFilterVisible[column.id])
                                    ? highlightedColor
                                    : foregroundColor, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage(!!(columnFilterVisible === null || columnFilterVisible === void 0 ? void 0 : columnFilterVisible[column.id])
                                        ? 'dataFilter.closeFilter'
                                        : 'dataFilter.openFilter'),
                                }, onClick: function (event) {
                                    event.stopPropagation();
                                    setColumnFilterVisible(function (actual) {
                                        var _a;
                                        return (__assign(__assign({}, actual), (_a = {}, _a[column.id] = !(actual === null || actual === void 0 ? void 0 : actual[column.id]), _a)));
                                    });
                                } }, columnFilterIconProps(column.id, columnConfig))),
                            !!(columnFilterVisible === null || columnFilterVisible === void 0 ? void 0 : columnFilterVisible[column.id]) && (React.createElement(DataTableColumnFilter, { separatorColor: separatorColor, backgroundColor: backgroundColor, renderColumnFilter: renderColumnFilter, column: column, columnConfig: columnConfig, setFilter: setFilter, setTags: setTags, resetSelection: resetSelection, setColumnFilterVisible: setColumnFilterVisible }))))))));
            }))); })),
            React.createElement("tbody", __assign({}, getTableBodyProps()), (page !== null && page !== void 0 ? page : rows).map(function (row) {
                prepareRow(row);
                var rowConfigItem = rowConfig === null || rowConfig === void 0 ? void 0 : rowConfig({ values: row.original });
                var nextRowConfig = existingRowsConfig.find(function (item) { return item.index === row.index + 1; });
                return (React.createElement(BaSeDataRowInfoProvider, { key: row.id },
                    React.createElement(BaSeDataSelectionConsumer, null, function (_a) {
                        var _b, _c, _d, _e, _f;
                        var isAllSelected = _a.isAllSelected, selectedItems = _a.selectedItems;
                        return (React.createElement(DataTableRow, { borderTopColor: (row === null || row === void 0 ? void 0 : row.index) === 0
                                ? rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.separatorColor
                                : undefined, textColor: (_b = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.textColor) !== null && _b !== void 0 ? _b : textColor, backgroundColor: rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.backgroundColor, separatorColor: (_e = (_d = (_c = nextRowConfig === null || nextRowConfig === void 0 ? void 0 : nextRowConfig.rowConfigItem) === null || _c === void 0 ? void 0 : _c.separatorColor) !== null && _d !== void 0 ? _d : rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.separatorColor) !== null && _e !== void 0 ? _e : separatorColor, highlightedColor: (_f = rowConfigItem === null || rowConfigItem === void 0 ? void 0 : rowConfigItem.highlightedColor) !== null && _f !== void 0 ? _f : highlightedColor, isSelected: rowIsSelected({
                                itemKey: idAccessorKey,
                                item: row.original,
                                isAllSelected: isAllSelected,
                                selectedItems: selectedItems,
                            }) }, row.cells.map(function (cell) {
                            var _a, _b, _c, _d;
                            return (
                            // eslint-disable-next-line react/jsx-key
                            React.createElement("td", __assign({}, cell.getCellProps(((_a = columnConfigItem(cell.column.id)) === null || _a === void 0 ? void 0 : _a.align) && {
                                style: {
                                    width: (_b = columnConfigItem(cell.column.id)) === null || _b === void 0 ? void 0 : _b.width,
                                },
                            })),
                                React.createElement(DataTableCell, { align: (_d = (_c = columnConfigItem(cell.column.id)) === null || _c === void 0 ? void 0 : _c.align) !== null && _d !== void 0 ? _d : 'start' }, cell.render('Cell'))));
                        })));
                    })));
            })))));
}

function BaSeDataTableForwardedRef(props, ref) {
    var _a = props.itemsPerPage, itemsPerPage = _a === void 0 ? [5, 10, 15, 50, 100] : _a, _b = props.densityLevel, initialDensityLevel = _b === void 0 ? 'normal' : _b, _c = props.configActionItems, configActionItems = _c === void 0 ? [] : _c, _d = props.highlightedColor, highlightedColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _d, _e = props.foregroundColor, foregroundColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _e, _f = props.textColor, textColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _f, _g = props.separatorColor, separatorColor = _g === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _g, _h = props.backgroundColor, backgroundColor = _h === void 0 ? BaSeTheme.colors.defaultColors.white : _h, _j = props.tableHeaderBackgroundColor, externalTableHeaderBackgroundColor = _j === void 0 ? BaSeTheme
        .colors.defaultColors.transparent : _j, _k = props.sortIcon, sortIcon = _k === void 0 ? 'arrow-head-down' : _k, _l = props.sortingAscIcon, sortingAscIcon = _l === void 0 ? 'arrow-head-down' : _l, _m = props.sortingDescIcon, sortingDescIcon = _m === void 0 ? 'arrow-head-up' : _m, _o = props.columnConfig, columnConfig = _o === void 0 ? [] : _o, compactMode = props.compactMode, _p = props.hasHeader, hasHeader = _p === void 0 ? true : _p, shadow = props.shadow, _q = props.idAccessorKey, idAccessorKey = _q === void 0 ? 'id' : _q, compactModeExpandable = props.compactModeExpandable, rowConfig = props.rowConfig, 
    // eslint-disable-next-line comma-dangle
    dataProps = __rest(props, ["itemsPerPage", "densityLevel", "configActionItems", "highlightedColor", "foregroundColor", "textColor", "separatorColor", "backgroundColor", "tableHeaderBackgroundColor", "sortIcon", "sortingAscIcon", "sortingDescIcon", "columnConfig", "compactMode", "hasHeader", "shadow", "idAccessorKey", "compactModeExpandable", "rowConfig"]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _r = React.useState(initialDensityLevel), densityLevel = _r[0], setDensityLevel = _r[1];
    var _s = React.useState({}), columnFilterVisible = _s[0], setColumnFilterVisible = _s[1];
    var tableHeaderBackgroundColor = React.useMemo(function () {
        return hasHeader
            ? externalTableHeaderBackgroundColor
            : BaSeTheme.colors.defaultColors.transparent;
    }, [hasHeader, externalTableHeaderBackgroundColor]);
    return (React.createElement(BaSeData, __assign({}, dataProps, { ref: ref, hasHeader: hasHeader, itemsPerPage: itemsPerPage, densityLevel: densityLevel, highlightedColor: highlightedColor, foregroundColor: foregroundColor, textColor: textColor, separatorColor: separatorColor, backgroundColor: backgroundColor, compactMode: compactMode, shadow: shadow, idAccessorKey: idAccessorKey, rowConfig: rowConfig, configActionItems: __spreadArray([
            {
                icon: 'bars-high-density',
                text: getMessage('dataDensity.high'),
                color: foregroundColor,
                isSelected: densityLevel === 'high',
                callback: function () { return setDensityLevel('high'); },
            },
            {
                icon: 'bars',
                text: getMessage('dataDensity.normal'),
                color: foregroundColor,
                isSelected: densityLevel === 'normal',
                callback: function () { return setDensityLevel('normal'); },
            },
            {
                icon: 'bars-low-density',
                text: getMessage('dataDensity.low'),
                color: foregroundColor,
                isSelected: densityLevel === 'low',
                callback: function () { return setDensityLevel('low'); },
            }
        ], configActionItems, true), whenRenderTextCell: function (value) { return (React.createElement(BaSeParagraph, { color: textColor }, value)); }, render: function (_a) {
            var setTags = _a.setTags, setFilter = _a.setFilter, resetSelection = _a.resetSelection, _b = _a.table, getTableBodyProps = _b.getTableBodyProps, getTableProps = _b.getTableProps, headerGroups = _b.headerGroups, rows = _b.rows, page = _b.page, prepareRow = _b.prepareRow;
            return compactMode ? (React.createElement(DataTableCompactMode, { page: page, rows: rows, shadow: shadow, idAccessorKey: idAccessorKey, densityLevel: densityLevel, columnFilterVisible: columnFilterVisible, rowConfig: rowConfig, columnConfig: columnConfig, compactModeExpandable: compactModeExpandable, backgroundColor: backgroundColor, foregroundColor: foregroundColor, highlightedColor: highlightedColor, separatorColor: separatorColor, textColor: textColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor, getTableProps: getTableProps, prepareRow: prepareRow, setColumnFilterVisible: setColumnFilterVisible, setFilter: setFilter, setTags: setTags, resetSelection: resetSelection })) : (React.createElement(DataTableNormalMode, { headerGroups: headerGroups, page: page, rows: rows, idAccessorKey: idAccessorKey, columnFilterVisible: columnFilterVisible, rowConfig: rowConfig, columnConfig: columnConfig, densityLevel: densityLevel, sortIcon: sortIcon, sortingAscIcon: sortingAscIcon, sortingDescIcon: sortingDescIcon, backgroundColor: backgroundColor, foregroundColor: foregroundColor, highlightedColor: highlightedColor, separatorColor: separatorColor, textColor: textColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor, getTableBodyProps: getTableBodyProps, getTableProps: getTableProps, prepareRow: prepareRow, setColumnFilterVisible: setColumnFilterVisible, setFilter: setFilter, setTags: setTags, resetSelection: resetSelection }));
        } })));
}
var BaSeDataTable = React.forwardRef(BaSeDataTableForwardedRef);
BaSeDataTable['displayName'] = 'BaSeDataTable';

var handlePosition = function (position) {
    if (position === 'center') {
        return 'place-items: center';
    }
    else {
        var css = {
            'align-self': 'center;',
            'justify-self': 'center;',
        };
        if (position.includes('top')) {
            css['align-self'] = 'flex-start;';
        }
        if (position.includes('bottom')) {
            css['align-self'] = 'flex-end;';
        }
        if (position.includes('left')) {
            css['justify-self'] = 'flex-start;';
        }
        if (position.includes('right')) {
            css['justify-self'] = 'flex-end;';
        }
        return "align-self: ".concat(css['align-self'], " ;justify-self: ").concat(css['justify-self']);
    }
};
var CenterStyled = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n"], ["\n  display: grid;\n  place-items: center;\n"])));
styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  display: grid;\n  ", "\n"], ["\n  display: grid;\n  ", "\n"])), function (props) { return handlePosition(props.position); });
var templateObject_1$3, templateObject_2$2;

var PageWrapperStyled = styled.section.attrs({
    className: 'BaSe--page',
})(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  &.BaSe--page {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: grid;\n    place-items: center;\n    padding: 50px;\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n  }\n"], ["\n  &.BaSe--page {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: grid;\n    place-items: center;\n    padding: 50px;\n    background-color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n  }\n"])), function (_a) {
    var color = _a.color;
    return color !== null && color !== void 0 ? color : BaSeTheme.colors.defaultColors.white;
}, BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase);
var templateObject_1$2;

var rotate = function (_a) {
    var rotation = _a.rotation;
    return keyframes(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  40% {\n    transform: scale(.8);\n  }\n  100% {\n    transform: rotate(", "deg) scale(1);\n  }\n"], ["\n  40% {\n    transform: scale(.8);\n  }\n  100% {\n    transform: rotate(", "deg) scale(1);\n  }\n"])), rotation);
};
var slideDown = function (_a) {
    var initialOpacity = _a.initialOpacity;
    return keyframes(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  0% {\n    opacity: ", ";\n    transform: translateY(-100%);\n  }\n  80% {\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  0% {\n    opacity: ", ";\n    transform: translateY(-100%);\n  }\n  80% {\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])), initialOpacity);
};
var RotateTransitionStyled = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  animation: ", " ", "\n    ", " ", "\n    forwards;\n"], ["\n  display: inline-block;\n  animation: ", " ", "\n    ", " ", "\n    forwards;\n"])), function (props) { return rotate(props); }, BaSeTheme.transitions.durationSlow, function (_a) {
    var delay = _a.delay;
    return delay;
}, BaSeTheme.transitions.elasticTimingFunction);
var SlideDownTransitionStyled = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  opacity: ", ";\n  transform-origin: center;\n  animation: ", "\n    ", " ", "\n    ", " forwards;\n"], ["\n  display: inline-block;\n  opacity: ", ";\n  transform-origin: center;\n  animation: ", "\n    ", " ", "\n    ", " forwards;\n"])), function (_a) {
    var initialOpacity = _a.initialOpacity;
    return initialOpacity;
}, function (props) { return slideDown(props); }, BaSeTheme.transitions.durationSlow, function (_a) {
    var delay = _a.delay;
    return delay;
}, BaSeTheme.transitions.elasticTimingFunction);
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4;

var cssMobile = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  gap: 21px;\n  flex-direction: column;\n  & > *:first-child {\n    align-self: center;\n  }\n"], ["\n  gap: 21px;\n  flex-direction: column;\n  & > *:first-child {\n    align-self: center;\n  }\n"])));
var SideBySideStyled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 70px;\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 70px;\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"])), BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(cssMobile.toString()), BaSeTheme.breakpoints.mobile.mediaQueryCss(cssMobile.toString()), BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(cssMobile.toString()));
var templateObject_1, templateObject_2;

var transitionDelay = '2s';
var BaSeErrorPage = function (_a) {
    var title = _a.title, error = _a.error, button = _a.button, _b = _a.showButton, showButton = _b === void 0 ? true : _b;
    var hasButton = React.useMemo(function () { return showButton && (window.history.length > 1 || button); }, [button, showButton]);
    return (React.createElement(BaSeI18nConsumer, null, function (_a) {
        var getMessage = _a.getMessage;
        return (React.createElement(PageWrapperStyled, { color: BaSeTheme.colors.institucionais.cinzaSebrae97 },
            React.createElement(CenterStyled, null,
                React.createElement(SideBySideStyled, null,
                    React.createElement("div", { style: {
                            margin: '10px 0',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '24px',
                        } },
                        React.createElement(BaSeLogoSebrae, { width: 143, easterEgg: true }),
                        hasButton && (React.createElement(SlideDownTransitionStyled, { initialOpacity: 0, delay: transitionDelay },
                            React.createElement(BaSeButton, __assign({ onClick: function () { return window.history.back(); }, type: "tertiary", leftIcon: button ? button.leftIcon : 'history-alt', color: BaSeTheme.colors.institucionais.cinzaSebrae20, value: getMessage('errorPage.backButton') }, button))))),
                    React.createElement("div", null,
                        React.createElement(BaSeHeading1, { isBold: true, color: BaSeTheme.colors.institucionais.azulSebrae },
                            React.createElement(RotateTransitionStyled, { rotation: 90, delay: transitionDelay }, ": ("),
                            React.createElement("br", null),
                            "Ops!"),
                        React.createElement("div", { style: { margin: '21px 0' } },
                            React.createElement(BaSeHeading4, { isBold: true, color: BaSeTheme.colors.institucionais.cinzaSebrae20 }, title || getMessage('errorPage.defaultTitle')),
                            React.createElement(BaSeParagraph, { color: BaSeTheme.colors.institucionais.cinzaSebrae45 }, error || getMessage('errorPage.defaultDescription'))))))));
    }));
};

var BaSeBackendNoSignalPage = function () {
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeErrorPage, { title: getMessage('backendNoSignalPage.title'), error: getMessage('backendNoSignalPage.errorMessage') }));
};

var BaSeForbiddenPage = function () {
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeErrorPage, { title: getMessage('forbiddenPage.title'), error: getMessage('forbiddenPage.errorMessage') }));
};

var BaSeLoadingPage = function () { return (React.createElement(PageWrapperStyled, null,
    React.createElement(BaSeLoading, null))); };

var BaSeNotFoundPage = function () {
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeErrorPage, { title: getMessage('notFoundPage.title'), error: getMessage('notFoundPage.errorMessage') }));
};

var BaSeHomePage = BaSeConfig.docsUrl;

export { BaSeA11yBar, BaSeAccordion, BaSeAccountProfile, BaSeActionItem, BaSeArrowButton, BaSeAutocomplete, BaSeAvatar, BaSeBackendNoSignalPage, BaSeBadge, BaSeBoard, BaSeBox, BaSeBreakpointConsumer, BaSeBreakpointContext, BaSeButton, BaSeCard, BaSeCheckbox, BaSeConfig, BaSeContainer, BaSeCounter, BaSeDataGrid, BaSeDataInfoConsumer, BaSeDataInfoContext, BaSeDataList, BaSeDataRowInfoConsumer, BaSeDataRowInfoContext, BaSeDataTable, BaSeDatePicker, BaSeDialogConsumer, BaSeDialogContainer, BaSeDialogContext, BaSeDrawer, BaSeDualButton, BaSeEmoticon, BaSeErrorPage, BaSeFilePicker, BaSeFooter, BaSeForbiddenPage, BaSeGrid, BaSeGridItem, BaSeHeader, BaSeHeading1, BaSeHeading2, BaSeHeading3, BaSeHeading4, BaSeHeading5, BaSeHeading6, BaSeHelperText, BaSeHomePage, BaSeIcon, BaSeIllustration, BaSeImageFlag, BaSeImageMap, BaSeImagePicker, BaSeInput, BaSeInputList, BaSeLoading, BaSeLoadingPage, BaSeLoadingSpinner, BaSeLogoSebrae, BaSeLogoSebraeInverse, BaSeLogoSebraeRestrict, BaSeLogoSebraeRestrictInverse, BaSeMessage, BaSeMultipleSelect, BaSeNotFoundPage, BaSeOptionPicker, BaSePanel, BaSeParagraph, BaSePopover, BaSePopupButton, BaSeProgressBar, BaSeProgressCircle, BaSeRadio, BaSeRating, BaSeRoot, BaSeSelect, BaSeSelectList, BaSeSelectableContainer, BaSeShapeButton, BaSeSideMenu, BaSeSmall1, BaSeSmall2, BaSeStepper, BaSeTabs, BaSeTag, BaSeTextArea, BaSeTheme, BaSeToggler, BaSeTooltip, BaSeUserApps, version as BaSeVersion, Color, base64Decode, base64DecodeToBlob, base64DecodeToTypedArray, base64Encode, camelCase, createButtonDarkTextColor, createButtonFocusColor, createButtonHoverColor, createColor, createColorSmartLightingControl, firstLetterUpperCase, getHSLValues, getLValue, hueMapperFocus, hueMapperHover, isNumeric, joinWithSeparators, nameAbbreviation, normalize, numberWithUnit, removeAccents, reverse, stringToBlob, stringToTypedArray, stripHtmlTags, toKebabCase, urlDecode, urlEncode, urlSanitizer, useDebounce, useOutsideEvent, useQRCode };
//# sourceMappingURL=index.es.js.map
